webpackJsonp([0],Array(500).concat([
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_booking_vue__ = __webpack_require__(708);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54b33f9b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_booking_vue__ = __webpack_require__(773);
function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_booking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54b33f9b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_booking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_api__ = __webpack_require__(246);
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VisibleFor',

  props: __WEBPACK_IMPORTED_MODULE_0_config_api__["a" /* default */].roles,

  data: function data() {
    return {
      visible: false,
      userRol: null
    };
  },

  created: function created() {
    this.userRol = this.$store.getters['api/getUserRol'];
    this.checkUserPrivileges();
  },


  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    checkUserPrivileges: function checkUserPrivileges() {
      this.visible = typeof this.$props[this.userRol] !== 'undefined';
    }
  }
});

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(557);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isTrue: function isTrue(message) {
        return function (v) {
          return v === true || message || 'Campo requerido';
        };
      },
      isRequired: function isRequired(message) {
        return function (v) {
          if (v && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(v).length > 0) {
            return true;
          }
          return !!v && v.length > 0 || message || 'Campo requerido';
        };
      },
      isEmail: function isEmail(v) {
        if (!v.length > 0) return true;
        var regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        return regex.test(v) || 'Correo electrónico no válido';
      },
      isComposedBy: function isComposedBy(option, value) {
        var regex = {
          'letters|numbers': /^[A-zÀ-ÖØ-öø-ÿ0-9]*[A-zÀ-ÖØ-öø-ÿ0-9][A-zÀ-ÖØ-öø-ÿ0-9]*$/,
          'letters|numbers|spaces': /^[A-zÀ-ÖØ-öø-ÿ0-9 ]*[A-zÀ-ÖØ-öø-ÿ0-9][A-zÀ-ÖØ-öø-ÿ0-9 ]*$/,
          'numbers': /^[0-9]*[0-9][0-9]*$/
        };
        var msg = {
          'letters|numbers': 'Solo números y letras están permitidos',
          'letters|numbers|spaces': 'Solo números, letras y espacios están permitidos',
          'numbers': 'Solo números están permitidos'
        };
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return regex[option].test(v[value]) || msg[option];
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return regex[option].test(value);
            }) || msg[option];
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return regex[option].test(v) || msg[option];
          };
        }
        return true;
      },
      hasLength: function hasLength(chars, value) {
        var msg = 'Debe contener ' + chars + ' caracteres';
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return v[value].length === chars || msg;
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return value.length === chars;
            }) || msg;
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return !!v && v.length === chars || msg;
          };
        }
        return true;
      },
      hasMaxLength: function hasMaxLength(chars, value) {
        var msg = 'No debe exceder de ' + chars + ' caracteres';
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return v[value].length <= chars || msg;
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return value.length <= chars;
            }) || msg;
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return v.length <= chars || msg;
          };
        }
        return true;
      },
      hasMinLength: function hasMinLength(chars, value) {
        var msg = 'Debe contener un mínimo de ' + chars + ' caracteres';
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return v[value].length >= chars || msg;
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return value.length >= chars;
            }) || msg;
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return v.length >= chars || msg;
          };
        }
        return true;
      }
    };
  },


  methods: {

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setRules: function setRules(rules, value) {
      var items = [];
      for (var rule in rules) {
        rule = rules[rule].split(':');
        switch (rule[0]) {
          case 'required':
            items.push(this.isRequired(rule[1] || null));
            break;
          case 'is_true':
            items.push(this.isTrue(rule[1] || null));
            break;
          case 'has_length':
            items.push(this.hasLength(parseInt(rule[1]), value));
            break;
          case 'has_min_length':
            items.push(this.hasMinLength(parseInt(rule[1]), value));
            break;
          case 'has_max_length':
            items.push(this.hasMaxLength(parseInt(rule[1]), value));
            break;
          case 'is_composed_by':
            items.push(this.isComposedBy(rule[1]));
            break;
          case 'is_email':
            items.push(this.isEmail);
            break;
        }
      }
      return items;
    }
  }
});

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(523), __esModule: true };

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(524);
module.exports = __webpack_require__(12).Object.assign;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(20);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(525) });


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(63);
var gOPS = __webpack_require__(526);
var pIE = __webpack_require__(527);
var toObject = __webpack_require__(62);
var IObject = __webpack_require__(245);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(41)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 526 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 527 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_form_creator_vue__ = __webpack_require__(537);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458ae02a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_form_creator_vue__ = __webpack_require__(604);
function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_form_creator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458ae02a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_form_creator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_select_vue__ = __webpack_require__(539);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4baeca00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_select_vue__ = __webpack_require__(576);
function injectStyle (ssrContext) {
  __webpack_require__(574)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4baeca00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(531);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(532), __esModule: true };

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(533);
var $Object = __webpack_require__(12).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(20);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(21), 'Object', { defineProperty: __webpack_require__(28).f });


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyDatePicker',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: '',
      menu: false,
      dateFormatted: null
    };
  },

  created: function created() {
    this.itemValue = this.item.value;
  },


  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.itemValue);
    }
  },

  watch: {
    itemValue: {
      handler: function handler(val, oldVal) {
        console.log(val);
        this.dateFormatted = this.formatDate(this.itemValue);
        this.$emit('on-change', this.itemValue, oldVal, this.item, true);
      },
      deep: true
    },
    value: {
      handler: function handler(val, oldVal) {
        this.itemValue = val;
        this.$emit('on-change', val, oldVal, this.item, true);
      },
      deep: true
    }
  },

  methods: {
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '-' + month + '-' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      // const [month, day, year] = date.split('-')
      // return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

      var _date$split3 = date.split('-'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return day + '-' + month + '-' + year;
    }
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visible_for_vue__ = __webpack_require__(519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320c9e8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visible_for_vue__ = __webpack_require__(536);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visible_for_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320c9e8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visible_for_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',[_vm._t("content")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_vuetify_text_field__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_vuetify_select__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_vuetify_date_picker__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_vuetify_time_picker__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_vuetify_radio_card_vuetify_radio_card__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_vuetify_select_file__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fields_vuetify_places_autocomplete__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fields_vuetify_switch__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fields_vuetify_radio_group__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fields_vuetify_checkbox__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fields_vuetify_link__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fields_vuetify_slider__ = __webpack_require__(600);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyFormCreator',

  components: {
    VuetifyTextField: __WEBPACK_IMPORTED_MODULE_1__fields_vuetify_text_field__["a" /* default */],
    VuetifySelect: __WEBPACK_IMPORTED_MODULE_2__fields_vuetify_select__["a" /* default */],
    VuetifyDatePicker: __WEBPACK_IMPORTED_MODULE_3__fields_vuetify_date_picker__["a" /* default */],
    VuetifyTimePicker: __WEBPACK_IMPORTED_MODULE_4__fields_vuetify_time_picker__["a" /* default */],
    VuetifyRadioCard: __WEBPACK_IMPORTED_MODULE_5__fields_vuetify_radio_card_vuetify_radio_card__["a" /* default */],
    VuetifySelectFile: __WEBPACK_IMPORTED_MODULE_6__fields_vuetify_select_file__["a" /* default */],
    VuetifyPlacesAutocomplete: __WEBPACK_IMPORTED_MODULE_7__fields_vuetify_places_autocomplete__["default"],
    VuetifySwitch: __WEBPACK_IMPORTED_MODULE_8__fields_vuetify_switch__["a" /* default */],
    VuetifyRadioGroup: __WEBPACK_IMPORTED_MODULE_9__fields_vuetify_radio_group__["a" /* default */],
    VuetifyCheckbox: __WEBPACK_IMPORTED_MODULE_10__fields_vuetify_checkbox__["a" /* default */],
    VuetifyLink: __WEBPACK_IMPORTED_MODULE_11__fields_vuetify_link__["a" /* default */],
    VuetifySlider: __WEBPACK_IMPORTED_MODULE_12__fields_vuetify_slider__["a" /* default */]
  },

  data: function data() {
    return {
      fields: [],
      isValid: false,
      loader: null,
      newWindowContent: null
    };
  },

  props: {
    columns: {
      type: String,
      default: 'xs12 sm10 md8 lg6'
    },
    items: {
      type: Array,
      default: null,
      required: true
    },
    validate: {
      type: Boolean,
      default: false,
      required: false
    },
    fluid: {
      type: Boolean,
      default: true,
      required: false
    },
    validateOnChanged: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  created: function created() {
    this.normalizeParams(this.items);
  },


  methods: {
    /**
     * Normalize parameters by adding optional parameters.
     *
     * @param {Object} self
     */
    normalizeParams: function normalizeParams(items) {
      this.fields = [];
      var self = this;
      items.map(function (obj, index) {
        obj.index = obj.index || index;
        obj.valid = obj.valid || false;
        self.fields.push(obj);
        return obj;
      });
      if (this.validateOnChanged) {
        this.validateForm();
      }
    },
    validateForm: function validateForm() {
      if (this.$refs.form_creator) {
        this.isValid = this.$refs.form_creator.validate();
        return this.isValid;
      }
      return false;
    },
    reset: function reset() {
      this.$refs.form_creator.reset();
    },
    openNewWindow: function openNewWindow(item) {
      if (item.open_new_window) {
        if (this.newWindowContent === null || this.newWindowContent && this.newWindowContent.closed) {
          this.newWindowContent = window.open('', '_blank');
        }
      }
    },
    onAddItem: function onAddItem() {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['on-add-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params)));
    },

    /*
    onKeyup (...params) {
      this.$emit('update:validate', this.isValid)
    },
    */
    onClickButton: function onClickButton(item) {
      // console.log('-------------', item)
      item.newWindowContent = this.newWindowContent;
      if (item.loading === false) {
        item.loading = true;
      }
      if (item.validate_on_click) {
        this.validateForm();
      }
      this.$emit('on-click-button', item, this.isValid);
    },
    onChange: function onChange() {
      for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['on-change'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params)));
    },
    onBlur: function onBlur() {
      for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }

      this.$emit.apply(this, ['on-blur'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params)));
    },
    setClassButton: function setClassButton(item) {
      var align = '';
      switch (item.align || '') {
        case 'left':
          align = 'align-btn-left';
          break;
        case 'right':
          align = 'align-btn-right';
          break;
        case 'center':
          align = 'align-btn-center';
          break;
      }
      return align;
    }
  },

  watch: {
    items: {
      handler: function handler(newVal, oldVal) {
        this.normalizeParams(newVal);
      },
      deep: true
    },
    isValid: {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:validate', newVal);
      },
      deep: true
    }
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyTextField',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: '',
      visibility: false,
      editable: false,
      oldVal: ''
    };
  },

  created: function created() {
    this.itemValue = this.value || this.itemValue;
    this.oldVal = this.itemValue;
    this.isEditable();
  },


  watch: {
    itemValue: {
      handler: function handler(val, oldVal) {
        this.oldVal = this.oldVal !== this.itemValue ? this.itemValue : this.oldVal;
        this.$emit('on-keyup', val, this.oldVal, this.item, this.isValid());
      },
      deep: true
    },
    value: {
      handler: function handler(val, oldVal) {
        this.itemValue = val;
        this.$emit('on-change', val, oldVal, this.item, this.isValid());
        this.oldVal = this.oldVal !== this.itemValue ? this.itemValue : this.oldVal;
        this.isEditable();
      },
      deep: true
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      this.isEditable();
      if (this.editable && this.item.focusNextOnEnter) {
        if (event.target.form && event.target.form[this.item.index + 1]) {
          event.target.form[this.item.index + 1].focus();
        }
      }
    },
    isValid: function isValid() {
      var _this = this;

      var isValid = true;
      if (this.item.rules) {
        this.item.rules.forEach(function (rule) {
          if (rule(_this.itemValue) !== true) {
            isValid = false;
          }
        });
      }
      this.item.valid = isValid;
      return isValid;
    },
    isEditable: function isEditable() {
      this.editable = (this.item.editable || false) && this.isValid() && this.itemValue !== '';
    },
    onBlur: function onBlur(event) {
      this.$emit('on-blur', this.itemValue, this.val, this.item, this.isValid());
      this.isEditable();
    }
  }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifySelect',

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: '',
      editable: false,
      oldVal: '',
      search: null,
      currentValue: '',
      filteredItems: false
    };
  },

  created: function created() {
    this.itemValue = this.value || this.itemValue;
    this.oldVal = this.itemValue;
    this.isEditable();
  },


  watch: {
    itemValue: {
      handler: function handler(val, oldVal) {
        if (val) {
          this.$emit('on-change', val, oldVal, this.item, this.isValid());
          this.oldVal = this.itemValue;
          if (this.$refs.dialog) {
            this.$refs.dialog.isActive = false;
          }
        }
      },
      deep: true
    },
    value: {
      handler: function handler(newVal, oldVal) {
        this.itemValue = newVal;
        this.oldVal = oldVal;
        this.isEditable();
      },
      deep: true
    },
    search: function search(newVal) {
      if (this.$refs.select) {
        this.filteredItems = this.$refs.select.filteredItems.length > 0;
      }
      if (newVal) {
        this.currentValue = newVal;
      }
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      this.isEditable();
      if (this.editable && this.item.focusNextOnEnter) {
        if (event.target.form && event.target.form[this.item.index + 1]) {
          event.target.form[this.item.index + 1].focus();
        }
      }
    },
    isValid: function isValid() {
      var _this = this;

      var isValid = true;
      if (this.item.rules) {
        this.item.rules.forEach(function (rule) {
          var key = _this.item.item_value || 'item_value';
          var value = _this.itemValue[key] || _this.itemValue;
          if (rule(value) !== true) {
            isValid = 22222;
          }
        });
      }
      this.item.valid = isValid;
      return isValid;
    },
    isEditable: function isEditable() {
      this.editable = (this.item.editable || false) && this.isValid() && this.itemValue !== '';
    },
    getItemText: function getItemText(item) {
      if (item.return_object) {
        var prependText = item.prepend_text || '';
        var key = item.item_text || 'item_text';
        var value = typeof this.itemValue[key] !== 'undefined' ? this.itemValue[key] : this.itemValue;
        return prependText + value;
      }
      this.itemValue = item.value;
      return this.itemValue;
    },
    onAddItem: function onAddItem(event) {
      if (this.item.add_on_enter) {
        this.itemValue = this.currentValue;
        this.$emit('on-add-item', this.currentValue, this.oldVal, this.item, this.isValid());
      }
    }
  }
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyTimePicker',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: '',
      menu: false,
      dateFormatted: null
    };
  },

  created: function created() {
    this.itemValue = this.item.value;
  },


  watch: {
    itemValue: {
      handler: function handler(val, oldVal) {
        this.$emit('on-change', val, '', this.item, true);
      },
      deep: true
    },
    value: {
      handler: function handler(val, oldVal) {
        this.itemValue = val;
        this.$emit('on-change', val, '', this.item, true);
      },
      deep: true
    }
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuetify_select_file__ = __webpack_require__(542);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyRadioCard',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    options: {
      type: Array,
      default: null,
      required: true
    },
    rules: {
      type: Array,
      default: null
    },
    avatars: {
      type: Object,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    selected: {
      type: Object,
      default: null
    },
    valid: {
      type: Boolean,
      default: false
    },
    aggregator: {
      type: Object,
      default: null
    }
  },
  components: {
    VuetifySelectFile: __WEBPACK_IMPORTED_MODULE_0__vuetify_select_file__["a" /* default */]
  },
  data: function data() {
    return {
      items: null,
      itemSelected: null,
      itemValue: '',
      itemRules: [function (v) {
        return !!v || '';
      }],
      isValid: false,
      dialog: false,
      avatar: 0,
      gender: null,
      name: '',
      defaultAvatars: [{
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/1.png'
      }, {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/2.png'
      }, {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/3.jpg'
      }, {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/4.png'
      }, {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/5.jpg'
      }]
    };
  },

  mounted: function mounted() {
    this.defaultAvatars = this.avatars || this.defaultAvatars;
    this.items = this.options || this.items;
    this.itemSelected = this.selected || this.itemSelected;
    this.itemValue = this.value || this.itemValue;
    this.itemRules = this.rules || this.itemRules;
  },


  watch: {
    gender: function gender() {
      this.validateForm();
    },
    name: function name() {
      this.validateForm();
    }
  },
  methods: {
    getFirstWord: function getFirstWord(text) {
      return text.split(' ')[0];
    },
    selectItem: function selectItem(item) {
      this.$refs.radio_group.reset();
      this.itemValue = item.value;
      this.itemSelected = item;
      this.$emit('change', item);
    },
    reset: function reset() {
      this.name = '';
      this.avatar = 0;
      this.gender = null;
      this.$refs.name.reset();
    },
    addItem: function addItem(item) {
      var _this = this;

      this.dialog = false;
      var newItem = {
        text: this.name,
        value: '0',
        gender: this.gender,
        avatar: this.defaultAvatars[this.avatar].src
      };
      var index = this.items.push(newItem) - 1;
      this.items[index].value = (index + 1).toString();
      this.$emit('on-add-item', this.items[index]);
      this.selectItem(this.items[index]);
      setTimeout(function () {
        _this.reset();
      }, 1000);
    },
    validateForm: function validateForm() {
      if (this.$refs.name.validate() && this.gender) {
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    }
  }
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_select_file_vue__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5baf16e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_select_file_vue__ = __webpack_require__(584);
function injectStyle (ssrContext) {
  __webpack_require__(582)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5baf16e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_select_file_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5baf16e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_select_file_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuetify_select__ = __webpack_require__(529);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// https://gist.githubusercontent.com/ecmel/3d3d918f403140ff563d274c773508bf/raw/00ee8a3db7751e1fc2e4676e3d666246a10bf554/select-file.vue


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VuetifySelectFile',
  components: {
    VuetifySelect: __WEBPACK_IMPORTED_MODULE_0__vuetify_select__["a" /* default */]
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: null
    },
    accept: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    item: {
      type: 'select',
      label: '¿Quién eres?',
      columns: 'xs12 sm12 md12 lg12',
      value: '',
      itemText: 'name',
      itemValue: 'name',
      avatars: false,
      options: [{
        seller_id: '1',
        name: 'Diego',
        icon: 'account_box',
        label: true,
        chipColor: 'primary',
        iconColor: 'white',
        textColor: 'white'
      }, {
        seller_id: '1',
        name: 'Ana',
        icon: 'account_box',
        label: true,
        chipColor: 'primary',
        iconColor: 'white',
        textColor: 'white'
      }],
      default: {
        parent: 'sellerName',
        seller_id: '',
        seller_name: '',
        icon: 'account_box',
        label: true,
        chipColor: 'primary',
        iconColor: 'white',
        textColor: 'white'
      },
      rules: [],
      required: true,
      autocomplete: true,
      disabled: false,
      chips: true,
      addOnEnter: true,
      hideSelected: true,
      noDataText: 'Pulsa enter para agregar vendedor'
    },
    fetch: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      items: this.value ? this.value.slice() : [],
      dialog: false,
      data: null,
      type: null,
      selected_: null
    };
  },

  computed: {
    selected: {
      get: function get() {
        return this.selected_;
      },
      set: function set(value) {
        if (this.data) {
          URL.revokeObjectURL(this.data);
        }

        if (value) {
          this.data = URL.createObjectURL(value.file || value.blob);
          this.type = value.type;
          this.dialog = true;
        } else {
          this.dialog = false;
          this.type = null;
          this.data = null;
        }

        this.selected_ = value;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.selected = null;
  },

  methods: {
    clicked: function clicked() {
      this.$refs.input.click();
    },
    changed: function changed(files) {
      if (files.length === 0) {
        return;
      }

      var types = this.accept ? this.accept.split(',') : [];

      var update = false;

      for (var i = 0, file, push; i < files.length; i++) {
        file = files[i];

        push = this.accept === null;

        for (var j = 0, type; j < types.length; j++) {
          type = types[j].trim();

          if (type === file.type || type.endsWith('*') && file.type.startsWith(type.substring(0, type.length - 1))) {
            push = true;
            break;
          }
        }

        for (var _j = 0, item; _j < this.item.value.length; _j++) {
          item = this.item.value[_j];

          if (item.name === file.name) {
            push = false;
            break;
          }
        }

        if (push) {
          this.item.value.push({
            name: file.name,
            type: file.type,
            size: file.size,
            file: file
          });
          update = true;
        }
      }

      this.$refs.input.value = '';

      if (update) {
        this.update();
      }
    },
    remove: function remove(index) {
      this.item.value.splice(index, 1);
      this.update();
    },
    update: function update() {
      this.$emit('change', this.item.value.slice());
    },
    preview: function preview(item) {
      var _this = this;

      if (item.file || item.blob) {
        this.selected = item;
      } else if (this.fetch) {
        this.fetch(item).then(function () {
          _this.selected = item;
        });
      }
    }
  }
});

/***/ }),
/* 544 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
'use strict'

export default {

  name: 'VuetifyPlacesAutocomplete',

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    mapConfig: {
      type: Object,
      default: v => {
        return {
          center: {lat: 41.390205, lng: 2.170190},
          zoom: 14,
          mapTypeId: 'roadmap',
          disableDefaultUI: true,
          fullscreenControl: true,
          zoomControl: false,
          streetViewControl: false
        }
      }
    },
    value: {
      default: null
    },
    rules: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    searchBox: null,
    searchValue: '',
    fullAddress: '',
    map: null,
    markers: [],
    itemValue: null,
    isSearch: false,
    address: null,
    errorMessages: [],
    isValid: false,
    all: [],
    showInput: false
  }),

  mounted () {
    this.normalizeParams()
    this.createMap()
    this.searchBoxRegister(this)
  },

  created () {
    setTimeout(() => {
      this.showInput = true
    }, 1500)
  },

  watch: {
    itemValue: function (newVal, oldVal) {
      this.$emit('change', newVal)
      this.$emit('on-change', newVal, oldVal, this.item)
    }
  },

  methods: {
    normalizeParams () {
      this.address = this.item.options
      this.itemValue = this.value || this.itemValue
    },
    getTypeByName (name) {
      let type = false
      this.address.forEach((section, sectionIndex) => {
        let itemIndex = section.fields.findIndex(item => item.name === name)
        if (itemIndex > -1) {
          type = this.address[sectionIndex].fields[itemIndex].type
        }
      })
      return type
    },
    setValueByName (name, value) {
      this.address.forEach((section, sectionIndex) => {
        let itemIndex = section.fields.findIndex(item => item.name === name)
        if (itemIndex > -1) {
          this.address[sectionIndex].fields[itemIndex].value = value
        }
      })
    },
    resetValues () {
      this.address.forEach((section, sectionIndex) => {
        section.fields.forEach((item, itemIndex) => {
          if (item.required && item.value.length > 0) {
            item.value = ''
          }
        })
      })
    },
    getFullAddress (self) {
      this.fullAddress = ''
      this.address.forEach((section, sectionIndex) => {
        section.fields.forEach((item, itemIndex) => {
          if (item.required && item.value.length > 0) {
            self.fullAddress += item.value + ' '
          }
        })
      })
    },
    validateForm () {
      let value = {}
      let state = true
      this.errorMessages = []
      this.address.forEach((section, sectionIndex) => {
        section.fields.forEach((item, itemIndex) => {
          value[item.name] = item.value
          if (item.rules) {
            item.rules.forEach((rule) => {
              let valid = rule(item.value)
              if (valid !== true) {
                this.errorMessages.push(valid)
                item.isValid = false
                state = false
              } else {
                item.isValid = true
              }
            })
          }
        })
      })
      this.itemValue = state ? value : false
      this.isValid = state
      return state
    },
    createMap () {
      this.map = new google.maps.Map(
        document.getElementById(this.mapConfig.id),
        this.mapConfig
      )
    },
    aaa (item) {
      if (item && item.required && item.value.length > 0) {
        this.getFullAddress(this)
        let input = document.getElementById(this.mapConfig.id + '-input')
        input.value = this.fullAddress
        input.focus()
        google.maps.event.trigger(input, 'keydown', {keyCode: 32})
        setTimeout(() => {
          google.maps.event.trigger(input, 'keydown', {keyCode: 40})
          google.maps.event.trigger(input, 'keydown', {keyCode: 13})
        }, 500)
      }
      this.validateForm()
    },
    searchBoxRegister (self) {
      let input = document.getElementById(this.mapConfig.id + '-input')
      this.searchBox = new google.maps.places.SearchBox(input)
      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)
      this.map.addListener('bounds_changed', () => {
        self.searchBox.setBounds(self.map.getBounds())
      })
      this.searchBox.addListener('places_changed', () => {
        self.initAutocomplete(self.searchBox.getPlaces(), self)
        input.blur()
      })
    },
    getPlaceValues (places, bounds, self) {
      places.forEach(function (place) {
        console.log(place)
        if (place.address_components) {
          for (let i = 0; i < place.address_components.length; i++) {
            let addressName = place.address_components[i].types[0]
            let addressType = self.getTypeByName(addressName)
            if (place.address_components[i][addressType]) {
              let value = place.address_components[i][addressType]
              self.setValueByName(addressName, value)
            }
          }
        }
        if (place.name) {
          self.setValueByName('name', place.name)
        }
        if (place.geometry.viewport) {
          self.setValueByName('viewport', place.geometry.viewport)
        }
        if (place.geometry.location) {
          self.setValueByName('location', place.geometry.location)
        }
        self.validateForm()

        self.addMarker(place)

        self.setBounds(bounds, place)
      })
    },
    addMarker (place) {
      let icon = {
        url: place.icon,
        size: new google.maps.Size(71, 71),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(17, 34),
        scaledSize: new google.maps.Size(25, 25)
      }

      this.markers.push(new google.maps.Marker({
        map: this.map,
        icon: icon,
        title: place.name,
        position: place.geometry.location
      }))
    },

    setBounds (bounds, place) {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport)
      } else {
        bounds.extend(place.geometry.location)
      }
    },
    initAutocomplete (places) {
      this.resetValues()
      this.isSearch = true
      this.isValid = null
      if (!places) return

      this.markers.forEach(function (marker) {
        marker.setMap(null)
      })

      let bounds = new google.maps.LatLngBounds()

      this.getPlaceValues(places, bounds, this)

      this.map.fitBounds(bounds)
    }
  }
}
*/

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifySwitch',

  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }
  },

  watch: {
    'item.value': function itemValue(newVal, oldVal) {
      this.$emit('on-change', newVal, oldVal, this.item);
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus();
      }
    }
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyRadioGroup',

  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }
  },

  watch: {
    'item.value': function itemValue(newVal, oldVal) {
      this.$emit('on-change', newVal, oldVal, this.item, true);
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus();
      }
    }
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyCheckbox',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: false
    };
  },

  mounted: function mounted() {
    this.itemValue = this.item.value || this.itemValue;
  },


  watch: {
    itemValue: function itemValue(newVal, oldVal) {
      this.$emit('change', newVal);
      this.$emit('on-change', this.itemValue, oldVal, this.item, true);
    },
    value: function value(newVal, oldVal) {
      this.itemValue = newVal;
    },
    'item.value': {
      handler: function handler(newVal, oldVal) {
        this.itemValue = newVal;
      },
      deep: true
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus();
      }
    }
  }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyLink',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: ''
    };
  },

  mounted: function mounted() {
    this.itemValue = this.value || this.itemValue;
  },


  watch: {
    itemValue: function itemValue(newVal, oldVal) {
      this.$emit('change', newVal);
      this.$emit('on-change', newVal, oldVal, this.item);
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus();
      }
    }
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifySlider',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },

  watch: {
    'item.value': function itemValue(newVal, oldVal) {
      this.$emit('on-change', newVal, oldVal, this.item);
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {}
  }
});

/***/ }),
/* 550 */,
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(566), __esModule: true };

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_aggregator_card_vue__ = __webpack_require__(620);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_275a59b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_aggregator_card_vue__ = __webpack_require__(658);
function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_aggregator_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_275a59b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_aggregator_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_dialog_confirm_vue__ = __webpack_require__(621);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffc0f02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_dialog_confirm_vue__ = __webpack_require__(661);
function injectStyle (ssrContext) {
  __webpack_require__(659)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ffc0f02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_dialog_confirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffc0f02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_dialog_confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_text_field_vue__ = __webpack_require__(538);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_429959a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_text_field_vue__ = __webpack_require__(573);
function injectStyle (ssrContext) {
  __webpack_require__(571)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_text_field_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_429959a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_text_field_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 555 */,
/* 556 */,
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(558), __esModule: true };

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(242);
__webpack_require__(559);
module.exports = __webpack_require__(12).Array.from;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(29);
var $export = __webpack_require__(20);
var toObject = __webpack_require__(62);
var call = __webpack_require__(248);
var isArrayIter = __webpack_require__(249);
var toLength = __webpack_require__(65);
var createProperty = __webpack_require__(560);
var getIterFn = __webpack_require__(243);

$export($export.S + $export.F * !__webpack_require__(250)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(28);
var createDesc = __webpack_require__(64);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_date_picker_vue__ = __webpack_require__(534);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5430b32f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_date_picker_vue__ = __webpack_require__(568);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_date_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5430b32f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_date_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(563);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(551);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(564), __esModule: true };

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(244);
__webpack_require__(242);
module.exports = __webpack_require__(565);


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(66);
var ITERATOR = __webpack_require__(9)('iterator');
var Iterators = __webpack_require__(22);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(244);
__webpack_require__(242);
module.exports = __webpack_require__(567);


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var get = __webpack_require__(243);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{ref:"menu",attrs:{"nudge-right":40,"return-value":_vm.itemValue,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.itemValue=$event}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.item.label,"disabled":_vm.item.disabled || false,"rules":_vm.item.rules || [],"required":_vm.item.required || false,"placeholder":_vm.item.placeholder || undefined,"prepend-icon":"","readonly":""},on:{"blur":function($event){_vm.dateFormatted = _vm.parseDate(_vm.dateFormatted)}},slot:"activator",model:{value:(_vm.dateFormatted),callback:function ($$v) {_vm.dateFormatted=$$v},expression:"dateFormatted"}}),_vm._v(" "),_c('v-date-picker',{directives:[{name:"show",rawName:"v-show",value:(!_vm.item.disabled),expression:"!item.disabled"}],attrs:{"color":_vm.item.color || 'primary',"locale":"es"},on:{"input":function($event){_vm.$refs.menu.save(_vm.itemValue)}},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(570);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("2b454212", content, true, {});

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".align-btn-left{float:left}.align-btn-right{float:right}.align-btn-center{margin:auto;display:block}.hidden{display:none}.section-icon{margin-top:-4px}.input-group__error{color:#f44336!important}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/vuetify-form-creator.vue"],"names":[],"mappings":"AACA,gBACE,UAAY,CACb,AACD,iBACE,WAAa,CACd,AACD,kBACE,YAAa,AACb,aAAe,CAChB,AACD,QACE,YAAc,CACf,AACD,cACE,eAAiB,CAClB,AACD,oBACE,uBAA0B,CAC3B","file":"vuetify-form-creator.vue","sourcesContent":["\n.align-btn-left {\n  float: left;\n}\n.align-btn-right {\n  float: right;\n}\n.align-btn-center {\n  margin: auto;\n  display: block;\n}\n.hidden {\n  display: none;\n}\n.section-icon {\n  margin-top: -4px;\n}\n.input-group__error {\n  color: #f44336 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(572);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("4b7e5938", content, true, {});

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".edit-dialog{display:block!important;text-align:left;height:31px;margin:0;font-size:16px;padding-bottom:8px;margin-top:3px;color:rgba(0,0,0,.87)}.text-field{margin-bottom:-22px}.editable:after{content:\"\"!important}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-text-field.vue"],"names":[],"mappings":"AACA,aACE,wBAA0B,AAC1B,gBAAiB,AACjB,YAAa,AACb,SAAU,AACV,eAAgB,AAChB,mBAAoB,AACpB,eAAgB,AAChB,qBAA2B,CAC5B,AACD,YACE,mBAAqB,CACtB,AACD,gBACE,oBAAuB,CACxB","file":"vuetify-text-field.vue","sourcesContent":["\n.edit-dialog {\n  display: block !important;\n  text-align: left;\n  height: 31px;\n  margin: 0;\n  font-size: 16px;\n  padding-bottom: 8px;\n  margin-top: 3px;\n  color: rgba(0, 0, 0, 0.87);\n}\n.text-field {\n  margin-bottom: -22px;\n}\n.editable:after {\n  content: '' !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.editable)?_c('v-text-field',{class:_vm.item.editable ? 'text-field' : '',attrs:{"label":_vm.item.label || undefined,"placeholder":_vm.item.placeholder || undefined,"mask":_vm.item.mask || undefined,"rules":_vm.item.rules || [],"counter":_vm.item.counter || undefined,"required":_vm.item.required || false,"dark":_vm.item.dark || false,"hint":_vm.item.hint || undefined,"autofocus":_vm.item.autofocus || false,"multi-line":_vm.item.multi_line || false,"disabled":_vm.item.disabled || false,"autocomplete":_vm.item.autocomplete || 'name',"prepend-icon":_vm.item.prepend_icon || undefined,"append-icon-cb":function () {_vm.visibility = !_vm.visibility},"append-icon":_vm.item.hidden_append_icon === true ? undefined : (_vm.item.append_icon || _vm.item.type === 'password' ? (_vm.visibility ? 'visibility' : 'visibility_off') : undefined),"color":_vm.item.color || undefined,"type":_vm.item.type === 'password' ? (_vm.visibility ? 'text' : 'password') : 'text'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.focusNextField($event)},"blur":function($event){_vm.onBlur($event)}},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}}):_vm._e(),_vm._v(" "),(_vm.editable)?_c('div',{staticClass:"input-group input-group--dirty input-group--text-field primary--text",class:(_vm.item.required && !_vm.itemValue) ? 'input-group--required' : ''},[(_vm.item.hidden_label === true ? false : true)?_c('label',{staticClass:"editable"},[_vm._v(_vm._s(_vm.item.label))]):_vm._e(),_vm._v(" "),(!_vm.item.disabled)?_c('v-edit-dialog',{staticClass:"edit-dialog",attrs:{"lazy":""}},[(_vm.item.tooltip || false)?_c('v-tooltip',{attrs:{"open-delay":"500","right":""}},[_c('span',{class:_vm.item.value_class || '',attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s((_vm.item.prepend_text || '') + _vm.itemValue + (_vm.item.append_text || '')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.tooltip))])]):_c('span',[_vm._v("\n        "+_vm._s((_vm.item.prepend_text || '') + _vm.itemValue + (_vm.item.append_text || ''))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.item.label))]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"input","label":_vm.item.label || undefined,"placeholder":_vm.item.placeholder || undefined,"mask":_vm.item.mask || undefined,"rules":_vm.item.rules || [],"single-line":"","counter":_vm.item.counter || undefined,"required":_vm.item.required || false,"dark":_vm.item.dark || false,"autofocus":true,"multi-line":_vm.item.multi_line || false,"hint":_vm.item.hint || undefined,"disabled":_vm.item.disabled || false,"autocomplete":_vm.item.autocomplete || 'name',"prepend-icon":_vm.item.prepend_icon || undefined,"append-icon-cb":function () {_vm.visibility = !_vm.visibility},"append-icon":_vm.item.hidden_append_icon === true ? undefined : (_vm.item.append_icon || _vm.item.type === 'password' ? (_vm.visibility ? 'visibility' : 'visibility_off') : undefined),"color":_vm.item.color || undefined,"type":_vm.item.type === 'password' ? (_vm.visibility ? 'text' : 'password') : 'text'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.focusNextField($event)},"blur":function($event){_vm.onBlur($event)}},slot:"input",model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1):_c('span',{staticClass:"edit-dialog",class:_vm.item.value_class || ''},[_vm._v("\n      "+_vm._s((_vm.item.prepend_text || '') + _vm.itemValue + (_vm.item.append_text || ''))+"\n    ")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(575);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("5216a125", content, true, {});

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".edit-dialog{display:block!important;text-align:left;height:31px;margin:0;font-size:16px;padding-bottom:8px;margin-top:3px;color:rgba(0,0,0,.87)}.select-field{margin-bottom:-22px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-select.vue"],"names":[],"mappings":"AACA,aACE,wBAA0B,AAC1B,gBAAiB,AACjB,YAAa,AACb,SAAU,AACV,eAAgB,AAChB,mBAAoB,AACpB,eAAgB,AAChB,qBAA2B,CAC5B,AACD,cACE,mBAAqB,CACtB","file":"vuetify-select.vue","sourcesContent":["\n.edit-dialog {\n  display: block !important;\n  text-align: left;\n  height: 31px;\n  margin: 0;\n  font-size: 16px;\n  padding-bottom: 8px;\n  margin-top: 3px;\n  color: rgba(0, 0, 0, 0.87);\n}\n.select-field {\n  margin-bottom: -22px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.editable)?_c('v-select',{ref:"select",class:_vm.item.editable ? 'select-field' : '',attrs:{"label":_vm.item.label || undefined,"placeholder":_vm.item.placeholder || undefined,"rules":_vm.item.rules || [],"items":_vm.item.items || [],"required":_vm.item.required || false,"disabled":_vm.item.disabled || false,"autocomplete":_vm.item.autocomplete || false,"combobox":_vm.item.combobox || false,"search-input":_vm.search,"item-text":_vm.item.item_text || 'text',"item-value":_vm.item.item_value || 'value',"prepend-icon":_vm.item.prepend_icon || undefined,"append-icon":_vm.item.append_icon || 'arrow_drop_down',"append-icon-cb":_vm.item.append_icon_cb,"color":_vm.item.color || undefined,"cache-items":_vm.item.cache_items || false,"hide-selected":_vm.item.hide_selected || false,"no-data-text":(_vm.item.add_on_enter && _vm.item.no_data_text) ? _vm.item.no_data_text : 'No data available',"readonly":_vm.item.readonly || false,"multiple":_vm.item.multiple || false,"tags":_vm.item.tags || false,"mask":_vm.item.mask || undefined,"dark":_vm.item.dark || false,"hint":_vm.item.hint || undefined,"chips":_vm.item.chips || false,"return-object":_vm.item.return_object || false},on:{"update:searchInput":function($event){_vm.search=$event},"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }_vm.focusNextField($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onAddItem($event)},function($event){_vm.$emit('on-keyup')}]},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}}):_vm._e(),_vm._v(" "),(_vm.editable)?_c('div',{staticClass:"input-group input-group--dirty input-group--text-field primary--text",class:_vm.item.required ? 'input-group--required' : ''},[(_vm.item.hidden_label === true ? false : true)?_c('label',{staticClass:"editable"},[_vm._v(_vm._s(_vm.item.label))]):_vm._e(),_vm._v(" "),(!_vm.item.disabled)?_c('v-edit-dialog',{ref:"dialog",staticClass:"edit-dialog",attrs:{"lazy":""}},[(_vm.item.tooltip || false)?_c('v-tooltip',{attrs:{"open-delay":"500","right":""}},[_c('span',{class:_vm.item.value_class || '',attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.getItemText(_vm.item)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.tooltip))])]):_c('span',[_vm._v("\n        "+_vm._s(_vm.getItemText(_vm.item))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.item.label))]),_vm._v(" "),_c('v-select',{ref:"select",attrs:{"slot":"input","label":_vm.item.label || undefined,"placeholder":_vm.item.placeholder || undefined,"rules":_vm.item.rules || [],"items":_vm.item.items || [],"required":_vm.item.required || false,"disabled":_vm.item.disabled || false,"autocomplete":_vm.item.autocomplete || false,"combobox":_vm.item.combobox || false,"search-input":_vm.search,"item-text":_vm.item.item_text || 'text',"item-value":_vm.item.item_value || 'value',"prepend-icon":_vm.item.prepend_icon || undefined,"append-icon":_vm.item.append_icon || 'arrow_drop_down',"append-icon-cb":_vm.item.append_icon_cb,"single-line":"","color":_vm.item.color || undefined,"cache-items":_vm.item.cache_items || false,"hide-selected":_vm.item.hide_selected || false,"no-data-text":(_vm.item.add_on_enter && _vm.item.no_data_text) ? _vm.item.no_data_text : 'No data available',"readonly":_vm.item.readonly || false,"multiple":_vm.item.multiple || false,"tags":_vm.item.tags || false,"mask":_vm.item.mask || undefined,"dark":_vm.item.dark || false,"hint":_vm.item.hint || undefined,"chips":_vm.item.chips || false,"return-object":_vm.item.return_object || false},on:{"update:searchInput":function($event){_vm.search=$event},"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }_vm.focusNextField($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onAddItem($event)},function($event){_vm.$emit('on-keyup')}]},slot:"input",model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1):_c('span',{staticClass:"edit-dialog"},[_vm._v("\n      "+_vm._s(_vm.getItemText(_vm.item))+"\n    ")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_time_picker_vue__ = __webpack_require__(540);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028e726a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_time_picker_vue__ = __webpack_require__(578);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_time_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028e726a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_time_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.itemValue,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){_vm.itemValue=$event}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.item.label,"placeholder":_vm.item.placeholder || undefined,"disabled":_vm.item.disabled || false,"rules":_vm.item.rules || [],"required":_vm.item.required || false,"prepend-icon":"","readonly":""},slot:"activator",model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}}),_vm._v(" "),_c('v-time-picker',{directives:[{name:"show",rawName:"v-show",value:(!_vm.item.disabled),expression:"!item.disabled"}],attrs:{"format":"24hr","color":_vm.item.color || 'primary',"locale":"es"},on:{"change":function($event){_vm.$refs.menu.save(_vm.itemValue)}},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_radio_card_vue__ = __webpack_require__(541);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26bcb034_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_radio_card_vue__ = __webpack_require__(585);
function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26bcb034"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_radio_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26bcb034_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_radio_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(581);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("7cea7bd2", content, true, {});

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vuetify-radio-card .vrc-card[data-v-26bcb034]{margin-bottom:30px}.vuetify-radio-card .vrc-card .title[data-v-26bcb034]{width:-webkit-fill-available;margin-top:-8px}.vuetify-radio-card .vrc-card .media[data-v-26bcb034]{background:#f6f7f9}.vuetify-radio-card .vrc-card .title-container[data-v-26bcb034]{height:46px}.vuetify-radio-card .vrc-card .icon[data-v-26bcb034]{font-size:46px;border-radius:32px;color:#fff;padding:4px;background:#3f51b5}.vuetify-radio-card .vrc-card .icon-container[data-v-26bcb034]{margin:auto}.vuetify-radio-card .radio[data-v-26bcb034]{visibility:hidden;position:absolute}.vuetify-radio-card .avatar-card[data-v-26bcb034]{-webkit-box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px #212121;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px #212121}.vrc-dialog[data-v-26bcb034]{margin-top:-75px;margin-bottom:-45px}.vrc-gender[data-v-26bcb034]{margin:auto;display:table}.vrc-gender-icon[data-v-26bcb034]{margin-left:5px}.vrc-gender-title[data-v-26bcb034]{margin-top:3px}.vrc-carousel .fade-enter-active[data-v-26bcb034],.vrc-carousel .fade-leave-active[data-v-26bcb034],.vrc-carousel .fade-leave-to[data-v-26bcb034]{-webkit-transition:.3s ease-out;transition:.3s ease-out;position:absolute;top:0;left:0}.vrc-carousel .fade-enter[data-v-26bcb034],.vrc-carousel .fade-leave-to[data-v-26bcb034],.vrc-carousel .fade-leave[data-v-26bcb034]{opacity:0}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-radio-card/vuetify-radio-card.vue"],"names":[],"mappings":"AACA,+CACE,kBAAoB,CACrB,AACD,sDACI,6BAA8B,AAC9B,eAAiB,CACpB,AACD,sDACI,kBAAoB,CACvB,AACD,gEACI,WAAa,CAChB,AACD,qDACI,eAAgB,AAChB,mBAAoB,AACpB,WAAa,AACb,YAAa,AACb,kBAAoB,CACvB,AACD,+DACI,WAAa,CAChB,AACD,4CACE,kBAAmB,AACnB,iBAAmB,CACpB,AACD,kDACE,uGAAwH,AAChH,8FAAgH,CACzH,AACD,6BACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,6BACE,YAAa,AACb,aAAe,CAChB,AACD,kCACE,eAAiB,CAClB,AACD,mCACE,cAAgB,CACjB,AACD,kJACE,gCAAiC,AACjC,wBAAyB,AACzB,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACT,AACD,oIACE,SAAW,CACZ","file":"vuetify-radio-card.vue","sourcesContent":["\n.vuetify-radio-card .vrc-card[data-v-26bcb034] {\n  margin-bottom: 30px;\n}\n.vuetify-radio-card .vrc-card .title[data-v-26bcb034] {\n    width: -webkit-fill-available;\n    margin-top: -8px;\n}\n.vuetify-radio-card .vrc-card .media[data-v-26bcb034] {\n    background: #f6f7f9;\n}\n.vuetify-radio-card .vrc-card .title-container[data-v-26bcb034] {\n    height: 46px;\n}\n.vuetify-radio-card .vrc-card .icon[data-v-26bcb034] {\n    font-size: 46px;\n    border-radius: 32px;\n    color: white;\n    padding: 4px;\n    background: #3F51B5;\n}\n.vuetify-radio-card .vrc-card .icon-container[data-v-26bcb034] {\n    margin: auto;\n}\n.vuetify-radio-card .radio[data-v-26bcb034] {\n  visibility: hidden;\n  position: absolute;\n}\n.vuetify-radio-card .avatar-card[data-v-26bcb034] {\n  -webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px #212121;\n          box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px #212121;\n}\n.vrc-dialog[data-v-26bcb034] {\n  margin-top: -75px;\n  margin-bottom: -45px;\n}\n.vrc-gender[data-v-26bcb034] {\n  margin: auto;\n  display: table;\n}\n.vrc-gender-icon[data-v-26bcb034] {\n  margin-left: 5px;\n}\n.vrc-gender-title[data-v-26bcb034] {\n  margin-top: 3px;\n}\n.vrc-carousel .fade-enter-active[data-v-26bcb034], .vrc-carousel .fade-leave-active[data-v-26bcb034], .vrc-carousel .fade-leave-to[data-v-26bcb034] {\n  -webkit-transition: .3s ease-out;\n  transition: .3s ease-out;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.vrc-carousel .fade-enter[data-v-26bcb034], .vrc-carousel .fade-leave[data-v-26bcb034], .vrc-carousel .fade-leave-to[data-v-26bcb034] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(583);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("64f3bbf5", content, true, {});

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".view-pdf[data-v-b5baf16e]{width:100%;height:100%}.vuetify-select-file input[type=file][data-v-b5baf16e]{position:absolute;filter:alpha(opacity=0);opacity:0}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-select-file.vue"],"names":[],"mappings":"AACA,2BACE,WAAY,AACZ,WAAa,CACd,AACD,uDACE,kBAAmB,AACnB,wBAAyB,AACzB,SAAW,CACZ","file":"vuetify-select-file.vue","sourcesContent":["\n.view-pdf[data-v-b5baf16e] {\n  width: 100%;\n  height: 100%;\n}\n.vuetify-select-file input[type=file][data-v-b5baf16e] {\n  position: absolute;\n  filter: alpha(opacity=0);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuetify-select-file"},[_c('input',{ref:"input",attrs:{"type":"file","multiple":"","accept":_vm.accept,"disabled":_vm.disabled},on:{"change":function($event){_vm.changed($event.target.files)}}}),_vm._v(" "),_c('button',{on:{"click":_vm.clicked}},[_vm._v("dddddd")]),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","fullscreen":"","scrollable":"","hide-overlay":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.selected = null}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.label))])],1),_vm._v(" "),(_vm.data !== null && _vm.type !== null)?[(_vm.type === 'application/pdf')?_c('embed',{key:_vm.data,staticClass:"view-pdf",attrs:{"type":_vm.type,"src":_vm.data}}):(_vm.type.substring(0, 6) === 'image/')?_c('v-card-text',[_c('img',{key:_vm.data,attrs:{"src":_vm.data}})]):_c('v-card-text',[_c('v-alert',{attrs:{"type":"error","value":true}},[_vm._v(_vm._s(_vm.type)+" not supported.")])],1)]:_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',{ref:"radio_group",staticClass:"vuetify-radio-card",attrs:{"rules":_vm.itemRules},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_vm._l((_vm.items),function(item,i){return _c('v-flex',{key:i,attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-radio',{attrs:{"value":item.value}}),_vm._v(" "),_c('v-card',{class:[
            'vrc-card',
            (_vm.itemSelected && _vm.itemSelected.value === item.value) ? 'avatar-card' : '',
            'theme--light'
          ],attrs:{"title":item.text,"hover":"","ripple":"","width":"160px"},nativeOn:{"click":function($event){_vm.selectItem(item)}}},[_c('v-card-media',{staticClass:"media",attrs:{"src":item.avatar,"height":"160px"}}),_vm._v(" "),_c('v-card-title',{staticClass:"title-container text-xs-center",attrs:{"primary-title":""}},[_c('h3',{staticClass:"title headline mb-0"},[_vm._v("\n              "+_vm._s(_vm.getFirstWord(item.text))+"\n            ")])])],1)],1)}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-card',{staticClass:"vrc-card theme--light",attrs:{"title":_vm.aggregator.text,"ripple":"","width":"160px"},nativeOn:{"click":function($event){_vm.dialog = true}}},[_c('v-card-media',{attrs:{"height":"160px"}},[_c('div',{staticClass:"icon-container"},[_c('v-icon',{staticClass:"icon"},[_vm._v("add")])],1)]),_vm._v(" "),_c('v-card-title',{staticClass:"title-container text-xs-center",attrs:{"primary-title":""}},[_c('h3',{staticClass:"title headline mb-0"},[_vm._v("\n              "+_vm._s(_vm.aggregator.text)+"\n            ")])])],1)],1)],2),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.aggregator),expression:"aggregator"}],attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"vrc-dialog",attrs:{"xs12":""}},[_c('v-card-media',{staticClass:"vrc-carousel"},[_c('v-carousel',{attrs:{"cycle":false,"hide-delimiters":"","value":_vm.avatar},model:{value:(_vm.avatar),callback:function ($$v) {_vm.avatar=$$v},expression:"avatar"}},_vm._l((_vm.defaultAvatars),function(avatar,i){return _c('v-carousel-item',{key:i,attrs:{"src":avatar.src,"transition":"fade","reverse-transition":"fade"}})}))],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"vrc-gender",attrs:{"xs12":""}},[_c('v-btn-toggle',{model:{value:(_vm.gender),callback:function ($$v) {_vm.gender=$$v},expression:"gender"}},[_c('v-btn',{attrs:{"flat":"","value":"male"}},[_c('span',{staticClass:"vrc-gender-title"},[_vm._v("\n                        "+_vm._s(_vm.aggregator.gender.man || 'man')+"\n                      ")]),_vm._v(" "),_c('svg',{staticClass:"vrc-gender-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M16 2v2h3.586l-3.972 3.972c-1.54-1.231-3.489-1.972-5.614-1.972-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-2.125-.741-4.074-1.972-5.614l3.972-3.972v3.586h2v-7h-7zm-6 20c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"}})])]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","value":"female"}},[_c('span',{staticClass:"vrc-gender-title"},[_vm._v("\n                        "+_vm._s(_vm.aggregator.gender.woman || 'woman')+"\n                      ")]),_vm._v(" "),_c('svg',{staticClass:"vrc-gender-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21 9c0-4.97-4.03-9-9-9s-9 4.03-9 9c0 4.632 3.501 8.443 8 8.941v2.059h-3v2h3v2h2v-2h3v-2h-3v-2.059c4.499-.498 8-4.309 8-8.941zm-16 0c0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7-7-3.14-7-7z"}})])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{ref:"name",attrs:{"label":_vm.aggregator.label || 'Name',"rules":_vm.aggregator.rules || [],"autocomplete":_vm.aggregator.autocomplete || 'name',"single-line":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.aggregator.color,"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n            close\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.aggregator.color,"flat":"","disabled":!_vm.isValid},nativeOn:{"click":function($event){_vm.addItem(_vm.aggregator)}}},[_vm._v("\n            "+_vm._s(_vm.aggregator.buttons.save || 'save')+"\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_places_autocomplete_vue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_places_autocomplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_places_autocomplete_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e90d1022_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_places_autocomplete_vue__ = __webpack_require__(589);
function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_places_autocomplete_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e90d1022_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_places_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(588);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("8e5d3204", content, true, {});

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".map{height:100%;position:static!important}.controls{margin-top:10px;border:1px solid transparent;border-radius:2px 0 0 2px;-webkit-box-sizing:border-box;box-sizing:border-box;-moz-box-sizing:border-box;height:32px;outline:none;-webkit-box-shadow:0 2px 6px rgba(0,0,0,.3);box-shadow:0 2px 6px rgba(0,0,0,.3);background-color:#fff;font-family:Roboto;font-size:15px;font-weight:300;margin-left:12px;padding:0 11px 0 13px;text-overflow:ellipsis;width:300px}.controls:focus{border-color:#4d90fe}.pac-container{font-family:Roboto}#type-selector{color:#fff;background-color:#4d90fe;padding:5px 11px 0}#type-selector label{font-family:Roboto;font-size:13px;font-weight:300}#target{width:345px}.vpa-is-invalid{color:#ff5252!important}#validation>div>div.input-group__details:before,#validation>div>div.input-group__input{display:none}#validation>.input-group{padding:0}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-places-autocomplete.vue"],"names":[],"mappings":"AACA,KACE,YAAa,AACb,yBAA6B,CAC9B,AACD,UACE,gBAAiB,AACjB,6BAA8B,AAC9B,0BAA2B,AAC3B,8BAA+B,AACvB,sBAAuB,AAC/B,2BAA4B,AAC5B,YAAa,AACb,aAAc,AACd,4CAAiD,AACzC,oCAAyC,AAGjD,sBAAuB,AACvB,mBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,sBAAuB,AACvB,uBAAwB,AACxB,WAAa,CATd,AAWD,gBACE,oBAAsB,CACvB,AACD,eACE,kBAAoB,CACrB,AACD,eACE,WAAY,AACZ,yBAA0B,AAC1B,kBAA2B,CAC5B,AACD,qBACE,mBAAoB,AACpB,eAAgB,AAChB,eAAiB,CAClB,AACD,QACE,WAAa,CACd,AACD,gBACE,uBAA0B,CAC3B,AACD,uFAEE,YAAc,CACf,AACD,yBACE,SAAW,CACZ","file":"vuetify-places-autocomplete.vue","sourcesContent":["\n.map {\n  height: 100%;\n  position: initial !important;\n}\n.controls {\n  margin-top: 10px;\n  border: 1px solid transparent;\n  border-radius: 2px 0 0 2px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  height: 32px;\n  outline: none;\n  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n.controls {\n  background-color: #fff;\n  font-family: Roboto;\n  font-size: 15px;\n  font-weight: 300;\n  margin-left: 12px;\n  padding: 0 11px 0 13px;\n  text-overflow: ellipsis;\n  width: 300px;\n}\n.controls:focus {\n  border-color: #4d90fe;\n}\n.pac-container {\n  font-family: Roboto;\n}\n#type-selector {\n  color: #fff;\n  background-color: #4d90fe;\n  padding: 5px 11px 0px 11px;\n}\n#type-selector label {\n  font-family: Roboto;\n  font-size: 13px;\n  font-weight: 300;\n}\n#target {\n  width: 345px;\n}\n.vpa-is-invalid {\n  color: #ff5252 !important;\n}\n#validation > div > div.input-group__input,\n#validation > div > div.input-group__details::before {\n  display: none;\n}\n#validation > .input-group {\n  padding: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInput),expression:"showInput"}],staticClass:"controls",attrs:{"id":_vm.mapConfig.id + '-input',"placeholder":"Buscar dirección"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-card',[_c('v-card-media',{attrs:{"height":"240px"}},[_c('div',{staticClass:"map",attrs:{"id":_vm.mapConfig.id}})]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.isValid ? 'primary' : 'red'}},[_vm._v("location_on")])],1),_vm._v(" "),_c('v-list-tile-content',_vm._l((_vm.address),function(section,i){return (section.title !== 'hidden')?_c('div',{key:i,class:!section.title ? 'list__tile__sub-title' : 'list__tile__title'},_vm._l((section.fields),function(item,i){return _c('v-edit-dialog',{key:i,ref:item.name,refInFor:true,attrs:{"return-value":item.value,"lazy":""},on:{"update:returnValue":function($event){_vm.$set(item, "value", $event)}}},[_c('span',{class:item.required && _vm.isSearch && !item.value ? 'vpa-is-invalid' : ''},[_vm._v(_vm._s(item.value || item.text))]),_vm._v(_vm._s(item.sufix)+"\n              "),_c('v-text-field',{attrs:{"slot":"input","label":item.label,"required":item.required || false,"hint":item.hint || undefined,"rules":item.rules || []},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.aaa(item)}},slot:"input",model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}}),_vm._v(" "),_c('div',{attrs:{"slot":"input"},slot:"input"},[_vm._v("\n                dddddd\n              ")])],1)})):_vm._e()}))],1)],1)],1),_vm._v(" "),_vm._l((_vm.errorMessages),function(error,i){return _c('div',{key:i,staticClass:"input-group__details"},[_c('div',{staticClass:"vpa-is-invalid input-group__messages input-group__error"},[_vm._v(_vm._s(error))])])}),_vm._v(" "),_c('div',{attrs:{"id":"validation"}},[_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(!_vm.itemValue),expression:"!itemValue"}],ref:"form",attrs:{"rules":_vm.rules || []},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1)],2),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.aaa()}}},[_vm._v("ssss")]),_vm._v(" "),_c('pre',[_vm._v("  "+_vm._s(_vm.fullAddress)+"\n")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_switch_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b06fd30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_switch_vue__ = __webpack_require__(591);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b06fd30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-switch',{attrs:{"label":("Switch 1: " + (_vm.item.hint.toString())),"hint":_vm.item.hint || undefined},model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_radio_group_vue__ = __webpack_require__(546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d83475d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_radio_group_vue__ = __webpack_require__(595);
function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_radio_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d83475d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_radio_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(594);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("034659b8", content, true, {});

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vrg-title{color:rgba(0,0,0,.54);display:inline-block;font-size:16px;line-height:30px;height:30px;text-align:left;text-overflow:ellipsis;z-index:0}.radio-group{margin-top:-47px}.input-group__messages{text-align:left}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-radio-group.vue"],"names":[],"mappings":"AACA,WACE,sBAA2B,AAC3B,qBAAsB,AACtB,eAAgB,AAChB,iBAAkB,AAClB,YAAa,AACb,gBAAiB,AACjB,uBAAwB,AACxB,SAAW,CACZ,AACD,aACE,gBAAkB,CACnB,AACD,uBACE,eAAiB,CAClB","file":"vuetify-radio-group.vue","sourcesContent":["\n.vrg-title {\n  color: rgba(0, 0, 0, 0.54);\n  display: inline-block;\n  font-size: 16px;\n  line-height: 30px;\n  height: 30px;\n  text-align: left;\n  text-overflow: ellipsis;\n  z-index: 0;\n}\n.radio-group {\n  margin-top: -47px;\n}\n.input-group__messages {\n  text-align: left;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',{class:_vm.item.class || '',attrs:{"rules":_vm.item.rules || [],"hint":_vm.item.hint,"column":""},model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}},[_c('p',{staticClass:"vrg-title"},[_vm._v(_vm._s(_vm.item.label))]),_vm._v(" "),_vm._l((_vm.item.options),function(option,i){return _c('v-radio',{directives:[{name:"show",rawName:"v-show",value:(option.visible !== undefined ? option.visible : true),expression:"option.visible !== undefined ? option.visible : true"}],key:option.value + i,attrs:{"mandatory":"","label":option.label,"input-value":option.value,"value":option.value,"disabled":option.disabled || false,"title":option.value}})}),_vm._v(" "),_vm._l((_vm.item.options),function(option,i){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(option.hint && _vm.item.value === option.value),expression:"option.hint && item.value === option.value"}],key:i,staticClass:"input-group__details"},[_c('div',{staticClass:"input-group__messages input-group__error"},[_vm._v("\n         "+_vm._s(option.hint)+"\n       ")])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_checkbox_vue__ = __webpack_require__(547);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687fe2c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_checkbox_vue__ = __webpack_require__(597);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687fe2c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"color":_vm.item.color || undefined,"value":_vm.itemValue,"label":_vm.item.label || undefined,"disabled":_vm.item.disabled || false,"rules":_vm.item.rules || [],"data-vv-name":"checkbox","type":"checkbox","required":_vm.item.required || false},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}},[(_vm.item.text)?_c('span',{attrs:{"slot":"label"},slot:"label"},_vm._l((_vm.item.text || []),function(item,i){return _c('span',{key:i},[(i === 'link')?_c('router-link',{attrs:{"to":item.to}},[_vm._v(_vm._s(item.value))]):_c('span',[_vm._v(_vm._s(item))])],1)})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_link_vue__ = __webpack_require__(548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4cf9b4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_link_vue__ = __webpack_require__(599);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_link_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4cf9b4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:_vm.item.class || ''},[_c('router-link',{attrs:{"to":_vm.item.to || undefined}},[_vm._v("\n    "+_vm._s(_vm.item.value)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_slider_vue__ = __webpack_require__(549);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d16297_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_slider_vue__ = __webpack_require__(603);
function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d16297_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(602);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("3c4b2a72", content, true, {});

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"vuetify-slider.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slider',{attrs:{"color":_vm.item.color || undefined,"label":_vm.item.label || undefined,"min":_vm.item.min || 0,"max":_vm.item.max || 100,"thumb-label":_vm.item.thumbLabel || false,"append-icon":_vm.item.appendIcon || undefined,"prepend-icon":_vm.item.prependIcon || undefined,"step":_vm.item.step || 1},model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{class:_vm.columns},[_c('v-form',{ref:"form_creator",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.onClickButton($event)}},model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-container',[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.fields),function(item,i){return _c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(item.visible !== undefined ? item.visible : true),expression:"item.visible !== undefined ? item.visible : true"}],key:i,class:[item.columns, (item.type === 'hidden' ? 'hidden' : '')]},[(item.type === 'text-field' || item.type === 'password' || item.type === 'hidden')?_c('vuetify-text-field',{attrs:{"item":item},on:{"on-change":_vm.onChange,"on-blur":_vm.onBlur},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}}):_vm._e(),_vm._v(" "),(item.type === 'select')?_c('vuetify-select',{attrs:{"item":item},on:{"on-add-item":_vm.onAddItem,"on-change":_vm.onChange},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}}):_vm._e(),_vm._v(" "),(item.type === 'date-picker')?_c('vuetify-date-picker',{attrs:{"item":item},on:{"on-change":_vm.onChange}}):_vm._e(),_vm._v(" "),(item.type === 'time-picker')?_c('vuetify-time-picker',{attrs:{"item":item},on:{"on-change":_vm.onChange}}):_vm._e(),_vm._v(" "),(item.type === 'radio-card')?_c('vuetify-radio-card',{ref:"form",refInFor:true,attrs:{"options":item.options,"avatars":item.avatars,"aggregator":item.aggregator,"rules":item.rules},on:{"on-add-item":_vm.onAddItem},model:{value:(item.selected),callback:function ($$v) {_vm.$set(item, "selected", $$v)},expression:"item.selected"}}):_vm._e(),_vm._v(" "),(item.type === 'places-autocomplete')?_c('vuetify-places-autocomplete',{attrs:{"item":item,"map-config":item.mapConfig,"rules":item.rules},on:{"on-add-item":_vm.onAddItem},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}}):_vm._e(),_vm._v(" "),(item.type === 'switch')?_c('vuetify-switch',{attrs:{"item":item},on:{"on-add-item":_vm.onAddItem}}):_vm._e(),_vm._v(" "),(item.type === 'checkbox')?_c('vuetify-checkbox',{attrs:{"item":item},on:{"on-change":_vm.onChange}}):_vm._e(),_vm._v(" "),(item.type === 'link')?_c('vuetify-link',{attrs:{"item":item}}):_vm._e(),_vm._v(" "),(item.type === 'radio-group')?_c('vuetify-radio-group',{attrs:{"item":item},on:{"on-change":_vm.onChange}}):_vm._e(),_vm._v(" "),(item.type === 'slider')?_c('vuetify-slider',{attrs:{"item":item},on:{"on-change":_vm.onChange}}):_vm._e(),_vm._v(" "),(item.type === 'button' && !item.items)?_c('v-btn',{class:_vm.setClassButton(item),attrs:{"disabled":item.loading || item.disabled || false,"color":item.color || 'primary',"outline":item.outline || false,"small":item.small || false,"round":item.round || false,"loading":item.loading || false},on:{"click":function($event){_vm.openNewWindow(item); _vm.onClickButton(item);}}},[_vm._v(_vm._s(item.text_button || 'Submit')+"\n            ")]):_vm._e(),_vm._v(" "),_vm._l((item.items || []),function(button,i){return (item.type === 'button' && item.items)?_c('v-btn',{key:i,class:_vm.setClassButton(button),attrs:{"disabled":button.loading || button.disabled || false,"color":button.color || 'primary',"outline":button.outline || false,"small":button.small || false,"round":button.round || false,"loading":button.loading || false},on:{"click":function($event){_vm.openNewWindow(button); _vm.onClickButton(button);}}},[_vm._v(_vm._s(button.text_button || 'Submit')+"\n            ")]):_vm._e()}),_vm._v(" "),(item.type === 'section-text')?_c('span',{staticClass:"section"},[(item.append_icon)?_c('v-icon',{staticClass:"section-icon",attrs:{"color":item.icon_color || 'primary'}},[_vm._v(_vm._s(item.append_icon))]):_vm._e(),_vm._v(" "),_c('span',{class:[item.class]},[_vm._v(_vm._s(item.value))])],1):_vm._e(),_vm._v(" "),(item.type === 'plain-text')?_c('div',[_c('div',{staticClass:"input-group input-group--dirty input-group--text-field primary--text"},[_c('label',[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('div',{staticClass:"menu edit-dialog",staticStyle:{"display":"inline-block"}},[_vm._v("\n                  "+_vm._s((item.value || {}).item_text ||
                    (item.value || {}).commerce_name ||
                    (item.value || {}).installer_alias ||
                    (item.value || {}).seller_name ||
                    item.value ||
                    '')+"\n                ")])])]):_vm._e()],2)}))],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue__ = __webpack_require__(606);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a1682036_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueGoogleAutocomplete_vue__ = __webpack_require__(622);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a1682036_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueGoogleAutocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ADDRESS_COMPONENTS = {
    street_number: 'long_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};

var CITIES_TYPE = ['locality', 'administrative_area_level_3'];
var REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country', 'administrative_area_level_1', 'administrative_area_level_2'];

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'VueGoogleAutocomplete',

    props: {
        id: {
            type: String,
            required: true
        },

        classname: String,

        placeholder: {
            type: String,
            default: 'Start typing'
        },

        types: {
            type: String,
            default: 'address'
        },

        country: {
            type: [String, Array],
            default: null
        },

        enableGeolocation: {
            type: Boolean,
            default: false
        },

        geolocationOptions: {
            type: Object,
            default: null
        }
    },

    data: function data() {
        return {
            /**
             * The Autocomplete object.
             *
             * @type {Autocomplete}
             * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
             */
            autocomplete: null,

            /**
             * Autocomplete input text
             * @type {String}
             */
            autocompleteText: '',

            geolocation: {
                /**
                 * Google Geocoder Objet
                 * @type {Geocoder}
                 * @link https://developers.google.com/maps/documentation/javascript/reference#Geocoder
                 */
                geocoder: null,

                /**
                 * Filled after geolocate result
                 * @type {Coordinates}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Coordinates
                 */
                loc: null,

                /**
                 * Filled after geolocate result
                 * @type {Position}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Position
                 */
                position: null
            }
        };
    },


    watch: {
        autocompleteText: function autocompleteText(newVal, oldVal) {
            this.$emit('inputChange', { newVal: newVal, oldVal: oldVal }, this.id);
        },
        country: function country(newVal, oldVal) {
            this.autocomplete.setComponentRestrictions({
                country: this.country === null ? [] : this.country
            });
        }
    },

    mounted: function mounted() {
        var options = {};

        if (this.types) {
            options.types = [this.types];
        }

        if (this.country) {
            options.componentRestrictions = {
                country: this.country
            };
        }

        this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);

        this.autocomplete.addListener('place_changed', this.onPlaceChanged);
    },

    methods: {
        /**
         * When a place changed
         */
        onPlaceChanged: function onPlaceChanged() {
            var place = this.autocomplete.getPlace();

            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                this.$emit('no-results-found', place, this.id);
                return;
            }

            if (place.address_components !== undefined) {
                // return returnData object and PlaceResult object
                this.$emit('placechanged', this.formatResult(place), place, this.id);

                // update autocompleteText then emit change event
                this.autocompleteText = document.getElementById(this.id).value;
                this.onChange();
            }
        },


        /**
         * When the input gets focus
         */
        onFocus: function onFocus() {
            this.biasAutocompleteLocation();
            this.$emit('focus');
        },


        /**
         * When the input loses focus
         */
        onBlur: function onBlur() {
            this.$emit('blur');
        },


        /**
         * When the input got changed
         */
        onChange: function onChange() {
            this.$emit('change', this.autocompleteText);
        },


        /**
         * When a key gets pressed
         * @param  {Event} event A keypress event
         */
        onKeyPress: function onKeyPress(event) {
            this.$emit('keypress', event);
        },


        /**
         * When a keyup occurs
         * @param  {Event} event A keyup event
         */
        onKeyUp: function onKeyUp(event) {
            this.$emit('keyup', event);
        },


        /**
         * Clear the input
         */
        clear: function clear() {
            this.autocompleteText = '';
        },


        /**
         * Focus the input
         */
        focus: function focus() {
            this.$refs.autocomplete.focus();
        },


        /**
         * Blur the input
         */
        blur: function blur() {
            this.$refs.autocomplete.blur();
        },


        /**
         * Update the value of the input
         * @param  {String} value
         */
        update: function update(value) {
            this.autocompleteText = value;
        },


        /**
         * Update the coordinates of the input
         * @param  {Coordinates} value
         */
        updateCoordinates: function updateCoordinates(value) {
            var _this = this;

            if (!value && !(value.lat || value.lng)) return;
            if (!this.geolocation.geocoder) this.geolocation.geocoder = new google.maps.Geocoder();
            this.geolocation.geocoder.geocode({ 'location': value }, function (results, status) {
                if (status === 'OK') {
                    results = _this.filterGeocodeResultTypes(results);
                    if (results[0]) {
                        _this.$emit('placechanged', _this.formatResult(results[0]), results[0], _this.id);
                        _this.update(results[0].formatted_address);
                    } else {
                        _this.$emit('error', 'no result for provided coordinates');
                    }
                } else {
                    _this.$emit('error', 'error getting address from coords');
                }
            });
        },


        /**
         * Update location based on navigator geolocation
         */
        geolocate: function geolocate() {
            var _this2 = this;

            this.updateGeolocation(function (geolocation, position) {
                _this2.updateCoordinates(geolocation);
            });
        },


        /**
         * Update internal location from navigator geolocation
         * @param  {Function} (geolocation, position)
         */
        updateGeolocation: function updateGeolocation() {
            var _this3 = this;

            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (navigator.geolocation) {
                var options = {};
                if (this.geolocationOptions) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(options, this.geolocationOptions);
                navigator.geolocation.getCurrentPosition(function (position) {
                    var geolocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    _this3.geolocation.loc = geolocation;
                    _this3.geolocation.position = position;

                    if (callback) callback(geolocation, position);
                }, function (err) {
                    _this3.$emit('error', 'Cannot get Coordinates from navigator', err);
                }, options);
            }
        },


        // Bias the autocomplete object to the user's geographical location,
        // as supplied by the browser's 'navigator.geolocation' object.
        biasAutocompleteLocation: function biasAutocompleteLocation() {
            var _this4 = this;

            if (this.enableGeolocation) {
                this.updateGeolocation(function (geolocation, position) {
                    var circle = new google.maps.Circle({
                        center: geolocation,
                        radius: position.coords.accuracy
                    });
                    _this4.autocomplete.setBounds(circle.getBounds());
                });
            }
        },


        /**
         * Format result from Geo google APIs
         * @param place
         * @returns {{formatted output}}
         */
        formatResult: function formatResult(place) {
            var returnData = {};
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];

                if (ADDRESS_COMPONENTS[addressType]) {
                    var val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                    returnData[addressType] = val;
                }
            }

            returnData['latitude'] = place.geometry.location.lat();
            returnData['longitude'] = place.geometry.location.lng();
            return returnData;
        },


        /**
         * Extract configured types out of raw result as
         * Geocode API does not allow to do it
         * @param results
         * @returns {GeocoderResult}
         * @link https://developers.google.com/maps/documentation/javascript/reference#GeocoderResult
         */
        filterGeocodeResultTypes: function filterGeocodeResultTypes(results) {
            if (!results || !this.types) return results;
            var output = [];
            var types = [this.types];
            if (types.includes('(cities)')) types = types.concat(CITIES_TYPE);
            if (types.includes('(regions)')) types = types.concat(REGIONS_TYPE);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var r = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(r.types), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var t = _step2.value;

                            if (types.includes(t)) {
                                output.push(r);
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return output;
        }
    }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyAvatarSelector',

  props: {
    avatar: {
      type: Object,
      default: null,
      required: true
    },
    avatars: {
      type: Array,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    controls: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data: function data() {
    return {
      item: {},
      items: [],
      dialog: false,
      value: 0
    };
  },

  mounted: function mounted() {
    this.item = this.avatar;
    this.items = this.avatars;
  },


  watch: {
    avatars: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal;
      },
      deep: true
    },
    avatar: {
      handler: function handler(newVal, oldVal) {
        this.item = newVal;
        if (this.$refs.carousel && this.$refs.carousel[this.value]) {
          this.$refs.carousel[this.value].$data.active = true;
        }
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    selectAvatarFile: function selectAvatarFile() {
      this.$refs.input.value = '';
      this.$refs.input.click();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    changeAvatar: function changeAvatar() {
      console.log('ssss');
      this.item.dialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    checkFile: function checkFile(format, maxFileSize, width, height) {
      var file = this.$refs.input.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);

      var self = this;
      reader.addEventListener('load', function () {
        var img = new Image();

        img.onload = function () {
          if (file.type !== format) {
            self.$emit('on-upload-error', 'format', format);
          } else if (file.size > maxFileSize) {
            self.$emit('on-upload-error', 'max-file-size', maxFileSize);
          } else if (img.width !== width) {
            self.$emit('on-upload-error', 'width', width);
          } else if (img.height !== height) {
            self.$emit('on-upload-error', 'height', height);
          } else {
            self.saveAvatar(reader.result);
          }
        };
        img.src = reader.result;
      }, false);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    saveAvatar: function saveAvatar(data) {
      if (!data) {
        data = this.items[this.value].src;
      }
      this.item.src = data;
      this.item.dialog = false;
      this.$emit('on-change-avatar', this.item);
      this.$forceUpdate();
    }
  }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_form_creator_vuetify_form_creator__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete__ = __webpack_require__(605);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyEditableAddressCard',

  components: {
    VuetifyFormCreator: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_form_creator_vuetify_form_creator__["a" /* default */],
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete__["a" /* default */]
  },

  props: {
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    items: {
      type: Array,
      default: null,
      required: true
    },
    validateOnChanged: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data: function data() {
    return {
      fields: [],
      dialog: false
    };
  },

  mounted: function mounted() {
    this.fields = this.items;
  },


  watch: {
    items: {
      handler: function handler(newVal, oldVal) {
        this.fields = newVal;
      }
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange: function onChange() {
      for (var _len = arguments.length, data = Array(_len), _key = 0; _key < _len; _key++) {
        data[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['on-change'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data)));
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddItem: function onAddItem() {
      for (var _len2 = arguments.length, data = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        data[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['on-add-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data)));
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onClickButton: function onClickButton() {
      for (var _len3 = arguments.length, data = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        data[_key3] = arguments[_key3];
      }

      this.$emit.apply(this, ['on-click-button'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data)));
    }
  }
});

/***/ }),
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_calendar__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fullcalendar_dist_fullcalendar_min_css__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fullcalendar_dist_fullcalendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fullcalendar_dist_fullcalendar_min_css__);
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VueCalendar',

  components: {
    FullCalendar: __WEBPACK_IMPORTED_MODULE_0_vue_full_calendar__["a" /* FullCalendar */]
  },

  props: {
    events: {
      type: Array,
      default: null,
      required: false
    },
    config: {
      type: Object,
      default: null,
      required: false
    }
  },

  data: function data() {
    return {
      calendarEvents: [],
      calendarConfig: [],
      selectedTool: [],
      lastClickTime: 0,
      clickTimer: null
    };
  },

  created: function created() {
    var _this = this;

    this.calendarEvents = this.events || this.calendarEvents;
    this.calendarConfig = {
      eventRender: function eventRender(event, element) {
        // console.log('eventRender', event)
      },
      drop: function drop(event) {
        // console.log('drop', event)
      },
      dayClick: function dayClick(date, jsEvent, view) {
        // console.log('dayClick', date, jsEvent, view)
      },
      eventClick: function eventClick(event) {
        // console.log('eventClick', event)
        var thisClickTime = new Date().getTime();

        var timeSinceLastClick = thisClickTime - _this.lastClickTime;

        _this.lastClickTime = thisClickTime;

        if (timeSinceLastClick < 300) {
          clearInterval(_this.clickTimer);
          _this.$emit('event-double-click', event);
        } else {
          _this.clickTimer = setInterval(function () {
            _this.$emit('event-click', event);
            clearInterval(_this.clickTimer);
          }, 300);
        }
      },
      select: function select(startDate, endDate) {
        _this.$emit('select', startDate, endDate);
      },
      validRange: function validRange(nowDate) {
        // let range = {
        //   start: nowDate,
        //   end: nowDate.clone().add(2, 'months')
        // }
        // console.log('validRange', range)
        // return range
      },
      selectOverlap: function selectOverlap(event) {
        return event.rendering === 'background';
      },
      eventOverlap: function eventOverlap(stillEvent, movingEvent) {
        // console.log('eventOverlap', stillEvent, movingEvent)
        return stillEvent.allDay && movingEvent.allDay;
      }
    };
    this.normalizeConfig();
  },


  watch: {
    events: {
      handler: function handler(val, oldVal) {
        this.calendarEvents = val;
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeConfig: function normalizeConfig() {
      for (var index in this.config) {
        this.calendarConfig[index] = this.config[index];
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    removeEvents: function removeEvents() {
      this.$refs.calendar.calendar.removeEvents();
      this.$emit('remove-events');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    renderEvent: function renderEvent(event, stick) {
      this.$refs.calendar.$emit('render-event', event, stick || false);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    fireMethod: function fireMethod() {
      var _$refs$calendar;

      (_$refs$calendar = this.$refs.calendar).$emit.apply(_$refs$calendar, arguments);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    refreshEvents: function refreshEvents() {
      this.$refs.calendar.$emit('refetch-events');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    removeEvent: function removeEvent(event) {
      this.$refs.calendar.$emit('remove-event', event);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    eventSelected: function eventSelected(event) {
      // console.log('eventSelected', event)
      this.selected = event;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    eventCreated: function eventCreated() {
      // console.log('eventCreated', test)
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAdd: function onAdd() {}
  },
  computed: {

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    eventSources: function eventSources() {
      var self = this;
      // console.log('ssssssss')
      return [{
        events: function events(start, end, timezone, callback) {
          // console.log(start, end, timezone, callback)
          setTimeout(function () {
            callback(self.events.filter(function () {
              return Math.random() > 0.5;
            }));
          }, 1000);
        }
      }];
    }
  }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__);




var FullCalendar = __webpack_require__(639);

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        events: {
            default: function _default() {
                return [];
            }
        },

        eventSources: {
            default: function _default() {
                return [];
            }
        },

        editable: {
            default: function _default() {
                return true;
            }
        },

        selectable: {
            default: function _default() {
                return true;
            }
        },

        selectHelper: {
            default: function _default() {
                return true;
            }
        },

        header: {
            default: function _default() {
                return {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                };
            }
        },

        defaultView: {
            default: function _default() {
                return 'agendaWeek';
            }
        },

        sync: {
            default: function _default() {
                return false;
            }
        },

        config: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    data: function data() {
        return {
            calendar: null
        };
    },


    computed: {
        defaultConfig: function defaultConfig() {
            var self = this;
            return {
                header: this.header,
                defaultView: this.defaultView,
                editable: this.editable,
                selectable: this.selectable,
                selectHelper: this.selectHelper,
                aspectRatio: 2,
                timeFormat: 'HH:mm',
                events: this.events,
                eventSources: this.eventSources,

                eventRender: function eventRender() {
                    if (this.sync) {
                        self.events = self.calendar.clientEvents();
                    }

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    self.$emit.apply(self, ['event-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDestroy: function eventDestroy(event) {
                    if (this.sync) {
                        self.events = self.calendar.clientEvents();
                    }
                },
                eventClick: function eventClick() {
                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    self.$emit.apply(self, ['event-selected'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDrop: function eventDrop() {
                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        args[_key3] = arguments[_key3];
                    }

                    self.$emit.apply(self, ['event-drop'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventReceive: function eventReceive() {
                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        args[_key4] = arguments[_key4];
                    }

                    self.$emit.apply(self, ['event-receive'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventResize: function eventResize() {
                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                        args[_key5] = arguments[_key5];
                    }

                    self.$emit.apply(self, ['event-resize'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                dayClick: function dayClick() {
                    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                        args[_key6] = arguments[_key6];
                    }

                    self.$emit.apply(self, ['day-click'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                select: function select(start, end, jsEvent, view, resource) {
                    self.$emit('event-created', {
                        start: start,
                        end: end,
                        allDay: !start.hasTime() && !end.hasTime(),
                        view: view,
                        resource: resource
                    });
                }
            };
        }
    },

    mounted: function mounted() {
        var _this = this;

        var cal = this.$el,
            self = this;

        this.$on('remove-event', function (event) {
            if (event && event.hasOwnProperty('id')) {
                _this.calendar.removeEvents(event.id);
            } else {
                _this.calendar.removeEvents(event);
            }
        });

        this.$on('rerender-events', function () {
            _this.calendar.rerenderEvents();
        });

        this.$on('refetch-events', function () {
            _this.calendar.refetchEvents();
        });

        this.$on('render-event', function (event, stick) {
            _this.calendar.renderEvent(event, stick);
        });

        this.$on('reload-events', function () {
            _this.calendar.removeEvents();
            _this.calendar.addEventSource(_this.events);
        });

        this.$on('rebuild-sources', function () {
            _this.calendar.removeEventSources();
            _this.eventSources.map(function (event) {
                _this.calendar.addEventSource(event);
            });
        });

        this.calendar = new FullCalendar.Calendar(cal, __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default()(this.config, this.defaultConfig));
        this.calendar.render();
    },


    methods: {
        fireMethod: function fireMethod() {
            var _calendar;

            for (var _len7 = arguments.length, options = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                options[_key7] = arguments[_key7];
            }

            return (_calendar = this.calendar)[options.shift()].apply(_calendar, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(options));
        }
    },

    watch: {
        events: {
            deep: true,
            handler: function handler(val) {
                this.calendar.removeEvents();
                this.calendar.addEventSource(this.events);
            }
        },
        eventSources: {
            deep: true,
            handler: function handler(val) {
                this.$emit('rebuild-sources');
            }
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.$off('remove-event');
        this.$off('rerender-events');
        this.$off('refetch-events');
        this.$off('render-event');
        this.$off('reload-events');
        this.$off('rebuild-sources');
    }
});

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__ = __webpack_require__(553);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyPhoneAggregator',

  components: {
    VuetifyAggregatorCard: __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__["a" /* default */],
    VuetifyDialogConfirm: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__["a" /* default */]
  },

  props: {
    phones: {
      type: Array,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    textFieldLabel: {
      type: String,
      default: 'Phone',
      required: false
    },
    textFieldRules: {
      type: Array,
      default: null,
      required: false
    },
    selectLabel: {
      type: String,
      default: 'Type',
      required: false
    },
    phoneTypes: {
      type: Array,
      default: null,
      required: false
    },
    dialogConfirmHeadline: {
      type: String,
      default: 'Delete area',
      required: false
    },
    dialogConfirmText: {
      type: String,
      default: 'Estás a punto de eliminar un área de trabajo',
      required: false
    },
    cancelButton: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmButton: {
      type: String,
      default: 'Confirm',
      required: false
    },
    deleteIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    value: {
      type: Array,
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      dialog: false,
      valid: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: [{
        text: 'Phone'
      }, {
        text: 'Mobile'
      }, {
        text: 'Fax'
      }],
      phoneType: null,
      phoneNumber: null
    };
  },

  watch: {
    phoneTypes: {
      handler: function handler(newVal, oldVal) {
        this.types = newVal;
        this.phoneType = this.types[0];
      },
      deep: true
    },

    phones: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal;
      },
      deep: true
    },

    items: {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:value', newVal);
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    askForConfirmation: function askForConfirmation(index) {
      this.currentIndex = index;
      this.showConfirmDialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    validate: function validate() {
      return this.$refs.form.validate();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.deletePhone();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deletePhone: function deletePhone() {
      this.items.splice(this.currentIndex, 1);
      this.$emit('on-delete-phone');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openDialog: function openDialog() {
      this.$refs.aggregator.dialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    closeDialog: function closeDialog() {
      this.$refs.aggregator.dialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addPhone: function addPhone() {
      if (this.validate()) {
        this.closeDialog();
        var item = {
          type: this.phoneType.text,
          value: this.phoneNumber
        };
        this.items.push(item);
        this.$refs.form.reset();
        this.$emit('on-add-phone');
      }
    }
  }
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyAggregatorCard',

  props: {
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    persistent: {
      type: Boolean,
      default: false,
      required: false
    },
    canEdit: {
      type: Boolean,
      default: true,
      required: false
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    addButton: {
      type: Boolean,
      default: true,
      required: false
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data: function data() {
    return {
      dialog: false
    };
  }
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyDialogConfirm',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    reference: {
      type: String,
      default: 'dialog_confirm',
      required: false
    },
    value: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: 290,
      required: false
    },
    headline: {
      type: String,
      default: 'Delete element?',
      required: false
    },
    text: {
      type: String,
      default: 'Delete element?',
      required: false
    },
    cancel: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirm: {
      type: String,
      default: 'Confirm',
      required: false
    },
    dark: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data: function data() {
    return {
      visible: false
    };
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onClick: function onClick(button) {
      this.$emit('on-' + button + '-dialog', this.reference);
      this.visible = false;
    }
  },

  watch: {
    value: {
      handler: function handler(newVal, oldVal) {
        this.visible = newVal;
      },
      deep: true
    },
    visible: {
      handler: function handler(newVal) {
        if (newVal === false) {
          this.$emit('on-cancel-dialog', this.reference);
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autocompleteText),expression:"autocompleteText"}],ref:"autocomplete",class:_vm.classname,attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder},domProps:{"value":(_vm.autocompleteText)},on:{"focus":function($event){_vm.onFocus()},"blur":function($event){_vm.onBlur()},"change":_vm.onChange,"keypress":_vm.onKeyPress,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.autocompleteText=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vue_signature_pad___ = __webpack_require__(666);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifySignatureAggregator',

  components: {
    VuetifyAggregatorCard: __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__["a" /* default */],
    VuetifyDialogConfirm: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__["a" /* default */],
    VueSignaturePad: __WEBPACK_IMPORTED_MODULE_2__components_vue_signature_pad___["a" /* default */]
  },

  props: {
    options: {
      type: Object,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    textFieldLabel: {
      type: String,
      default: 'Phone',
      required: false
    },
    textFieldRules: {
      type: Array,
      default: null,
      required: false
    },
    selectLabel: {
      type: String,
      default: 'Type',
      required: false
    },
    phoneTypes: {
      type: Array,
      default: null,
      required: false
    },
    dialogConfirmHeadline: {
      type: String,
      default: 'Delete area',
      required: false
    },
    dialogConfirmText: {
      type: String,
      default: 'Estás a punto de eliminar un área de trabajo',
      required: false
    },
    cancelButton: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmButton: {
      type: String,
      default: 'Confirm',
      required: false
    },
    deleteIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    uploadIconHoverText: {
      type: String,
      default: 'Upload image of 400 x 200 pixels in PNG format',
      required: false
    },
    clearIconHoverText: {
      type: String,
      default: 'Clean signature',
      required: false
    },
    saveIconHoverText: {
      type: String,
      default: 'Save signature',
      required: false
    },
    disableDeleteButton: {
      type: Boolean,
      default: false,
      required: false
    },
    disableCancelButton: {
      type: Boolean,
      default: false,
      required: false
    },
    disableSaveButton: {
      type: Boolean,
      default: false,
      required: false
    },
    disableClearButton: {
      type: Boolean,
      default: false,
      required: false
    },
    disableUploadButton: {
      type: Boolean,
      default: false,
      required: false
    },
    persistent: {
      type: Boolean,
      default: true,
      required: false
    },
    value: {
      type: String,
      default: null
    }
  },

  data: function data() {
    return {
      signature: null,
      showConfirmDialog: false,
      theToolbarTitle: ''
    };
  },

  created: function created() {
    this.signature = this.options;
    this.theToolbarTitle = this.toolbarTitle;
  },


  watch: {
    options: {
      handler: function handler(newVal, oldVal) {
        this.signature = newVal;
      },
      deep: true
    },
    toolbarTitle: {
      handler: function handler(newVal, oldVal) {
        this.theToolbarTitle = newVal;
      },
      deep: true
    },

    'signature.value': {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:value', newVal);
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    askForConfirmation: function askForConfirmation() {
      this.showConfirmDialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.delSignature();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    clearSignature: function clearSignature() {
      this.$refs.signature.clear();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openDialog: function openDialog() {
      this.$refs.aggregator.dialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    closeDialog: function closeDialog() {
      this.$refs.aggregator.dialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    delSignature: function delSignature() {
      this.onSaveSignature('');
      this.$emit('on-del-signature');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onSaveSignature: function onSaveSignature(signature) {
      this.signature.value = signature;
      if (signature !== '') {
        this.$emit('on-add-signature');
      }
      this.$forceUpdate();
      this.$refs.signature.clear();
      this.closeDialog();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    selectSignatureFile: function selectSignatureFile() {
      this.$refs.signature.selectSignatureFile();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setSignature: function setSignature() {
      this.$refs.signature.save();
      this.signature.dialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onUploadError: function onUploadError(type, requiredValue) {
      this.$emit('on-upload-error', type, requiredValue);
    }
  }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_signature_pad__ = __webpack_require__(669);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VueSignaturePad',

  props: {
    background: {
      type: String,
      default: 'rgba(255, 255, 255, 0)',
      required: false
    },
    color: {
      type: String,
      default: 'rgba(0,0,0,0.87)',
      required: false
    },
    width: {
      type: Number,
      default: 400,
      required: false
    },
    height: {
      type: Number,
      default: 200,
      required: false
    },
    format: {
      type: String,
      default: 'image/png',
      required: false
    },
    maxFileSize: {
      type: Number,
      default: 200000,
      required: false
    }
  },

  data: function data() {
    return {
      signature: null,
      stamp: ''
    };
  },

  mounted: function mounted() {
    this.signaturePad = new __WEBPACK_IMPORTED_MODULE_0_signature_pad__["a" /* default */](this.$refs.signaturePad, {
      backgroundColor: this.background,
      penColor: this.color
    });
  },


  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    save: function save() {
      var signatureImage = this.signaturePad.toDataURL(this.format);

      if (this.stamp === '') {
        return this.$emit('on-save-signature', signatureImage);
      }
      var canvas = document.getElementById('canvas');
      var context = canvas.getContext('2d');
      var signature = new Image();
      var stamp = new Image();

      var self = this;
      signature.onload = function () {
        canvas.width = self.width;
        canvas.height = self.height;
        stamp.src = self.stamp;
      };
      stamp.onload = function () {
        context.drawImage(signature, 0, 0);
        context.drawImage(stamp, 0, 0);
        self.$emit('on-save-signature', canvas.toDataURL('image/png'));
        context.clearRect(0, 0, self.width, self.height);
      };
      signature.src = signatureImage;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    clear: function clear() {
      this.signaturePad.clear();
      this.stamp = '';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    checkFile: function checkFile() {
      var file = this.$refs.input.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);

      var self = this;
      reader.addEventListener('load', function () {
        var img = new Image();

        img.onload = function () {
          if (file.type !== self.format) {
            self.$emit('on-upload-error', 'format', self.format);
          } else if (file.size > self.maxFileSize) {
            self.$emit('on-upload-error', 'max-file-size', self.maxFileSize);
          } else if (img.width !== self.width) {
            self.$emit('on-upload-error', 'width', self.width);
          } else if (img.height !== self.height) {
            self.$emit('on-upload-error', 'height', self.height);
          } else {
            self.stamp = reader.result;
          }
        };
        img.src = reader.result;
      }, false);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    selectSignatureFile: function selectSignatureFile() {
      this.$refs.input.value = '';
      this.$refs.input.click();
    }
  }
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_avatar_card_vue__ = __webpack_require__(607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7a2fcbe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_avatar_card_vue__ = __webpack_require__(628);
function injectStyle (ssrContext) {
  __webpack_require__(626)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_avatar_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7a2fcbe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_avatar_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(627);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("7f7c7cac", content, true, {});

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vuetify-avatar-selector{margin-bottom:20px}.avatar-image{margin-top:29px}.avatar-cursor{cursor:pointer}.avatar-content{margin-top:25px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-avatar-card.vue"],"names":[],"mappings":"AACA,yBACE,kBAAoB,CACrB,AACD,cACE,eAAiB,CAClB,AACD,eACE,cAAgB,CACjB,AACD,gBACE,eAAiB,CAClB","file":"vuetify-avatar-card.vue","sourcesContent":["\n.vuetify-avatar-selector {\n  margin-bottom: 20px;\n}\n.avatar-image {\n  margin-top: 29px;\n}\n.avatar-cursor {\n  cursor: pointer;\n}\n.avatar-content {\n  margin-top: 25px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"vuetify-avatar-selector",attrs:{"tile":""}},[_c('v-card-media',{attrs:{"height":"200px"}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","text-xs-center":"","layout":"","align-center":"","justify-center":""}},[(_vm.item.show_only || false)?_c('v-avatar',{staticClass:"avatar-image",attrs:{"size":"150px"}},[_c('img',{class:_vm.item.show_only ? '' : 'avatar-cursor',attrs:{"src":_vm.item.src ? _vm.item.src : '',"alt":""}})]):_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-avatar',{staticClass:"avatar-image",attrs:{"slot":"activator","size":"150px"},on:{"click":function($event){_vm.changeAvatar()}},slot:"activator"},[_c('img',{attrs:{"src":_vm.item.src ? _vm.item.src : '',"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("Pulsa para cambiar")])],1)],1)],1),_vm._v(" "),_c('input',{ref:"input",staticClass:"input-file",attrs:{"type":"file","id":"avatar","accept":"image/x-png, image/jpeg"},on:{"change":function($event){_vm.checkFile('image/png', 200000, 180, 180)}}})],1),_vm._v(" "),_c('v-card-title',[_vm._t("card-title")],2),_vm._v(" "),_c('v-card-text',[_vm._t("card-text")],2),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"350px"},model:{value:(_vm.item.dialog),callback:function ($$v) {_vm.$set(_vm.item, "dialog", $$v)},expression:"item.dialog"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Cambiar imagen")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-avatar',{staticClass:"avatar avatar-content",attrs:{"size":"250px"}},[_c('v-carousel',{attrs:{"cycle":false,"hide-delimiters":"","hide-controls":!_vm.controls,"lazy":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,ref:"carousel",refInFor:true,attrs:{"src":item.src,"transition":"fade","reverse-transition":"fade"}})}))],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{staticClass:"carousel-actions",attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.selectAvatarFile()}},slot:"activator"},[_c('v-icon',[_vm._v("file_upload")])],1),_vm._v(" "),_c('span',[_vm._v("Subir imagen de 180 x 180 píxeles en formato PNG")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.saveAvatar()}},slot:"activator"},[_c('v-icon',[_vm._v("check")])],1),_vm._v(" "),_c('span',[_vm._v("Utilizar el seleccionado")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.item.dialog = false}},slot:"activator"},[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('span',[_vm._v("Salir")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_form_creator_vuetify_form_creator__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete__ = __webpack_require__(605);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyEditableAddressCard',

  components: {
    VuetifyFormCreator: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_form_creator_vuetify_form_creator__["a" /* default */],
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete__["a" /* default */]
  },

  props: {
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    placeholder: {
      type: String,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    id: {
      type: String,
      default: 'google',
      required: false
    },
    route: {
      type: Object,
      default: null,
      required: true
    },
    routeExtras: {
      type: Object,
      default: null,
      required: true
    },
    postalCode: {
      type: Object,
      default: null,
      required: true
    },
    locality: {
      type: Object,
      default: null,
      required: true
    },
    province: {
      type: Object,
      default: null,
      required: true
    },
    placeId: {
      type: Object,
      default: null,
      required: false
    },
    checkbox: {
      type: Object,
      default: null,
      required: false
    },
    validateOnChanged: {
      type: Boolean,
      default: false,
      required: false
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data: function data() {
    return {
      items: [{}, {}, {}, {}, {}, {}],
      dialog: false
    };
  },

  watch: {
    route: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(0, 0, newVal);
      }
    },
    routeExtras: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(1, 0, newVal);
      }
    },
    postalCode: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(2, 0, newVal);
      }
    },
    locality: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(3, 0, newVal);
      }
    },
    province: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(4, 0, newVal);
      }
    },
    placeId: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(5, 0, newVal);
      }
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange: function onChange() {
      for (var _len = arguments.length, data = Array(_len), _key = 0; _key < _len; _key++) {
        data[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['on-change'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data)));
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openDialog: function openDialog() {
      this.dialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    closeDialog: function closeDialog() {
      this.dialog = false;
    },


    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.address = {
        route: addressData.route || '',
        postalCode: addressData.postal_code || '',
        locality: addressData.locality || '',
        province: addressData.administrative_area_level_2 || '',
        country: addressData.country || '',
        latitude: addressData.latitude || '',
        longitude: addressData.longitude || '',
        formattedAddress: placeResultData.formatted_address || '',
        url: placeResultData.url || '',
        placeId: placeResultData.place_id || ''
      };
      var number = addressData.street_number || '';
      number = number ? ', ' + number : '';
      this.address.route += number;

      this.items[0].value = this.address.route || '';
      this.items[1].value = '';
      this.items[2].value = this.address.postalCode || '';
      this.items[3].value = this.address.locality || '';
      this.items[4].value = this.address.province || '';
      this.items[5].value = this.address.placeId || '';

      this.closeDialog();
    }
  }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_editable_form_card_vue__ = __webpack_require__(608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2965ef8d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_editable_form_card_vue__ = __webpack_require__(633);
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_editable_form_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2965ef8d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_editable_form_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(632);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("6bd58e01", content, true, {});

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vuetify-editable-form-card{margin-bottom:20px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-editable-form-card.vue"],"names":[],"mappings":"AACA,4BACE,kBAAoB,CACrB","file":"vuetify-editable-form-card.vue","sourcesContent":["\n.vuetify-editable-form-card {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"vuetify-editable-form-card",attrs:{"tile":"","light":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.toolbarTitle))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('vuetify-form-creator',{ref:"form_creator",attrs:{"columns":'xs12 sm12 md12 lg12',"items":_vm.fields,"validate-on-changed":_vm.validateOnChanged},on:{"on-click-button":_vm.onClickButton,"on-blur":_vm.onChange,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem},model:{value:(_vm.fields),callback:function ($$v) {_vm.fields=$$v},expression:"fields"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vue_calendar__ = __webpack_require__(635);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'Calendar',

  components: {
    VueCalendar: __WEBPACK_IMPORTED_MODULE_2__components_vue_calendar__["a" /* default */]
  },

  data: function data() {
    return {
      events: [],
      config: {
        buttonText: {
          today: 'hoy',
          month: 'mes',
          week: 'semana',
          day: 'día',
          list: 'lista'
        },
        views: {
          month: {
            columnFormat: 'dddd'
          },
          week: {
            columnFormat: 'ddd D/M'
          },
          day: {
            columnFormat: 'dddd D/M'
          }
        },
        slotLabelFormat: 'HH:mm',
        allDayText: 'todo el día',
        allDaySlot: false,
        scrollTime: '08:00:00',
        defaultView: 'month',
        editable: false,
        selectable: true,
        droppable: false,
        locale: 'es',
        hiddenDays: [0]
      },
      sheet: false,
      on: false,
      selected: {},
      deactivatedShedules: [],
      installers: [],
      shedules: [],
      startDate: '',
      current: null,
      clickTimer: null,
      endDate: '',
      dialog: false,
      display: false,
      flatDialog: false,
      humanizeDate: '',
      selectedTool: 1
    };
  },

  created: function created() {
    if (!this.isNew()) {
      this.getCalendarShedules();
    } else {
      this.config.header = {
        right: ' '
      };
      this.config.selectable = false;
    }
  },


  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCalendarShedules: function getCalendarShedules() {
      var _this = this;

      if (this.display) {
        this.removeEvents();
      }
      var selectedInstallers = this.getSelectedInstallers();
      this.config.displayEventTime = false;
      if (this.isAdmin() || this.isSuperadmin() || this.isInstaller()) {
        this.config.defaultView = 'agendaWeek';
      }
      this.getDeactivatedShedules().then(function (response) {
        _this.getBookings(_this.$store.getters['api/getUserRol'], selectedInstallers).then(function (response) {
          console.log(_this.getUnique(response.data.items, 'commerce_id'));
          _this.installers.forEach(function (item) {
            var val = !_this.hasSelected() ? true : item.value;
            if (val) {
              _this.getDeactivatedShedulesForInstallers(item.user_id).then(function (response) {
                _this.display = true;
                // console.log(response)
              }).catch(function (error) {
                console.log(error);
                _this.$store.dispatch('snackbar/show', 'Error al obtener los días ocupados: ' + _this.$store.getters['api/getMessage']);
              });
            }
          });
        }).catch(function (error) {
          console.log(error);
          _this.$store.dispatch('snackbar/show', 'Error al obtener las reservas: ' + _this.$store.getters['api/getMessage']);
        });
      }).catch(function (error) {
        console.log(error);
        _this.$store.dispatch('snackbar/show', 'Error al obtener los días ocupados: ' + _this.$store.getters['api/getMessage']);
      });
    },
    getUnique: function getUnique(array, key) {
      var unique = array.map(function (e) {
        return e[key];
      }).map(function (e, i, final) {
        return final.indexOf(e) === i && i;
      }).filter(function (e) {
        return array[e];
      }).map(function (e) {
        return array[e];
      });

      return unique;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isNew: function isNew() {
      return this.$route.params.booking_id === 'new';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    copy: function copy() {
      var text = this.getPlainText();
      var dummy = document.createElement('textarea');
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getPlainText: function getPlainText() {
      return '' + this.current.title.replace(/(\r\n|\n|\r)/gm, '') + '\n' + this.current.subtitle.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' + this.current.anexo.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' + '-----------------------------------------------------------------------------------------------------------\n\n' + (this.current.phones + ' - ' + this.current.customer + ' - ' + this.current.dni).replace(/(\r\n|\n|\r)/gm, '') + '\n' + this.current.customer_email.replace(/(\r\n|\n|\r)/gm, '') + '\n' + this.current.address.replace(/(\r\n|\n|\r)/gm, '') + '\n' + this.current.invoiceInfo.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' + '-----------------------------------------------------------------------------------------------------------\n\n' + this.current.equipment.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' + '-----------------------------------------------------------------------------------------------------------\n\n' + 'OBSERVACIONES: \n\n' + this.current.observations.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' + this.current.booking_observations.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' + '-----------------------------------------------------------------------------------------------------------\n\n' + 'SE HA PAGADO: ' + this.current.wasPaid.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' + 'NO SE COBRA: ' + this.current.notPaid.replace(/(\r\n|\n|\r)/gm, '') + '\n\n' + 'A COBRAR: ' + this.current.toPaid.replace(/(\r\n|\n|\r)/gm, '');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isSuperadmin: function isSuperadmin() {
      return this.$store.getters['api/getUserRol'] === 'superadmin';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isAdmin: function isAdmin() {
      return this.$store.getters['api/getUserRol'] === 'administrator';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isInstaller: function isInstaller() {
      return this.$store.getters['api/getUserRol'] === 'installer';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangeInstallers: function onChangeInstallers() {
      var _this2 = this;

      clearTimeout(this.clickTimer);
      this.clickTimer = setTimeout(function () {
        _this2.getCalendarShedules();
      }, 1000);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    showPlainText: function showPlainText() {
      this.copy();
      this.flatDialog = true;
      this.$awn.success('Se ha copiado automáticamente este texto en tu portapapeles.');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    eventDoubleClick: function eventDoubleClick(event) {
      if (!this.isNew()) {
        if (event.status === 12) {
          this.deleteDeactivatedShedule(event);
        } else {
          this.current = event;
          this.openBooking(this.current.identificator);
        }
      } else {
        this.addBooking(event);
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    eventClick: function eventClick(event) {
      if (!this.isNew()) {
        if (event.status === 12) {
          this.deleteDeactivatedShedule(event);
        } else {
          // this.openBooking(event.identificator)
          // console.log(this.current)
          this.current = event;
          this.dialog = true;
        }
      } else {
        this.addBooking(event);
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addBooking: function addBooking(event) {
      this.$emit('on-assign-booking', event.identificator, __WEBPACK_IMPORTED_MODULE_1_moment___default()(event.start).format('YYYY-MM-DD HH:mm'), __WEBPACK_IMPORTED_MODULE_1_moment___default()(event.end).format('YYYY-MM-DD HH:mm'));
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    refreshEvents: function refreshEvents() {
      this.$refs.calendar.refreshEvents();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    removeEvents: function removeEvents() {
      this.$refs.calendar.removeEvents();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openBooking: function openBooking(saleID) {
      this.$router.push({
        name: 'booking-id',
        params: {
          booking_id: saleID
        }
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    newBooking: function newBooking() {
      this.$router.push({
        name: 'booking-new',
        params: {
          booking_id: 'new',
          booking_start: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.startDate).format('YYYY-MM-DD_HH:mm'),
          booking_end: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.endDate).format('YYYY-MM-DD_HH:mm')
        }
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    humanize: function humanize(startDate, endDate) {
      return 'Desde el ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.startDate).format('DD-MM-YYYY') + ' a las ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.startDate).format('HH:mm') + ' hasta el ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.endDate).format('DD-MM-YYYY') + ' a las ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.endDate).format('HH:mm') + '.';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    select: function select(startDate, endDate) {
      if (this.isNew()) {
        return true;
      }
      this.startDate = startDate;
      this.endDate = endDate;
      this.humanizeDate = this.humanize();
      if (this.isInstaller()) {
        this.addDeactivatedShedule();
      } else if (this.isSuperadmin() || this.isAdmin()) {
        if (this.selectedTool === 0) {
          this.newBooking();
        } else if (this.selectedTool === 1) {
          this.addDeactivatedShedule();
        }
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getColorByState: function getColorByState(status) {
      var color = '';
      switch (status) {
        case 6:
        case '6':
          color = '#3F51B5';
          break;
        case 7:
        case '7':
          color = '#673ab7';
          break;
        case 8:
        case '8':
          color = '#f44336';
          break;
        case 9:
        case '9':
          color = '#ff9800';
          break;
        case 10:
        case '10':
          color = '#009688';
          break;
        case 11:
        case '11':
          color = '#00897b';
          break;
        case 12:
        case '12':
          color = '#9e9e9e';
          break;
        case 13:
        case '13':
          color = '#2196f3';
          break;
        case 14:
        case '14':
          color = '#8bc34a';
          break;
        default:
          color = '#009688';
          break;
      }
      return color;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getStatusName: function getStatusName(status) {
      var text = '';
      switch (status) {
        case 6:
        case '6':
          text = 'Pendiente';
          break;
        case 7:
        case '7':
          text = 'En proceso';
          break;
        case 8:
        case '8':
          text = 'Cancelada';
          break;
        case 9:
        case '9':
          text = 'Anulada';
          break;
        case 10:
        case '10':
          text = 'Finalizada';
          break;
        case 11:
        case '11':
          text = 'Finalizada';
          break;
        case 12:
        case '12':
          text = 'OCUPADO';
          break;
        case 13:
        case '13':
          text = 'Cita programada';
          break;
        case 14:
        case '14':
          text = 'No instalada por iBEC';
          break;
        default:
          text = status;
          break;
      }
      return text;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    renderShedules: function renderShedules(element) {
      var _this3 = this;

      if (element.items) {
        element.items.forEach(function (item, index) {
          _this3.$refs.calendar.fireMethod('render-event', {
            id: Date.now(),
            identificator: item[element.item_value],
            status: item[element.item_text_3] || 12,
            title: _this3.getStatusName(item[element.item_text_3] || 12),
            start: item[element.item_text],
            end: item[element.item_text_2],
            overlap: true,
            color: _this3.getInstallerColorByUserId(item.user_id) || _this3.getColorByState(item[element.item_text_3] || 12)
          }, true);
        });
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    renderCustomShedules: function renderCustomShedules(element) {
      var _this4 = this;

      if (element.items) {
        element.items.forEach(function (item, index) {
          var i = _this4.installers.findIndex(function (installer) {
            return parseInt(installer.id) === parseInt(item.installer_id);
          });
          if (!_this4.display && i === -1) {
            _this4.installers.push({
              text: item.custom_installer_alias === '' ? 'Sin asignar' : item.custom_installer_alias,
              id: parseInt(item.installer_id),
              value: true,
              user_id: item.custom_installer_user_id,
              color: item.installer_color || _this4.getColorByState(6)
            });
          }
          _this4.$refs.calendar.fireMethod('render-event', {
            id: Date.now(),
            identificator: item.booking_id,
            status: item.status_id || 12,
            title: _this4.getTitle(item),
            subtitle: _this4.getSubTitle(item),
            anexo: _this4.getAnexo(item),
            start: item.booking_installation_start_date,
            end: item.booking_installation_end_date,
            overlap: true,
            color: _this4.isSuperadmin() || _this4.isAdmin() ? item.installer_color || _this4.getColorByState(item.status_id || 12) : _this4.getColorByState(item.status_id || 12),
            date: _this4.getDate(item),
            address: _this4.getAddress(item),
            installer: _this4.getInstallerAlias(item),
            customer: _this4.getCustomerName(item),
            customer_email: _this4.getCustomerEmail(item),
            commerce: _this4.getCommerceAlias(item),
            model: _this4.getBrandAndModel(item),
            phones: _this4.getCustomerPhones(item),
            dni: _this4.getCustomerDni(item),
            equipment: _this4.getEquipment(item),
            observations: _this4.getObservations(item),
            payment_method: _this4.getPaymentMethod(item),
            booking_observations: _this4.getBookingObservations(item),
            wasPaid: _this4.getWasPaid(item),
            notPaid: _this4.getNotPaid(item),
            toPaid: _this4.getToPaid(item),
            invoiceInfo: _this4.getInvoiceInfo(item)
          }, true);
        });
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getSaleId: function getSaleId(item) {
      return item.booking_id || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getPaymentMethod: function getPaymentMethod(item) {
      return item.custom_payment_method || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getNotPaid: function getNotPaid(item) {
      return item.custom_not_paid || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getToPaid: function getToPaid(item) {
      return item.custom_to_paid || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getInvoiceNumber: function getInvoiceNumber(item) {
      return item.custom_invoice_number || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getWasPaid: function getWasPaid(item) {
      return item.custom_was_paid || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getBrandAndModel: function getBrandAndModel(item) {
      return (item.custom_brand || '') + ' ' + (item.custom_model || '');
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getBookingObservations: function getBookingObservations(item) {
      return item.custom_booking_observations || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getObservations: function getObservations(item) {
      return item.custom_observations || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getEquipment: function getEquipment(item) {
      return item.custom_equipment || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCustomerPhones: function getCustomerPhones(item) {
      return item.custom_phones || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCommerceName: function getCommerceName(item) {
      return item.commerce_name || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCustomerDni: function getCustomerDni(item) {
      return item.customer_dni || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCustomerEmail: function getCustomerEmail(item) {
      return item.customer_email || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCustomerName: function getCustomerName(item) {
      return (item.customer_name || '') + ' ' + (item.customer_surname || '');
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getInstallerAlias: function getInstallerAlias(item) {
      return item.installer_alias || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCommerceAlias: function getCommerceAlias(item) {
      return item.commerce_alias || '';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getInvoiceInfo: function getInvoiceInfo(item) {
      var date = (item.custom_start_date || ' - - ').split('-');
      // return (item.custom_start_date || '') + ' - ' +
      return this.getSaleId(item) + ' - ' + this.getInvoiceNumber(item) + ' - ' + date[0] + '/' + date[1] + ' - ' + (item.customer_name || '') + ' ' + (item.customer_surname || '');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getAnexo: function getAnexo(item) {
      var date = (item.custom_start_date || ' - - ').split('-');
      // return (item.custom_start_date || '') + ' - ' +
      return date[2] + '-' + date[1] + '-' + date[0] + ' - ' + ' ANEXO VI - ' + (item.customer_name || '') + ' ' + (item.customer_surname || '') + ' - ' + this.getCommerceAlias(item);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getTitle: function getTitle(item) {
      return this.getSaleId(item) + ' - ' + (item.custom_today || '') + ' - ' + (item.custom_start_date || '') + ' - ' + (item.custom_start_hour || '') + 'h - ' + this.getInstallerAlias(item) + ' - ' + (item.customer_name || '') + ' ' + (item.customer_surname || '') + ' - ' + this.getCommerceAlias(item);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getSubTitle: function getSubTitle(item) {
      var hour = item.custom_start_hour.split(':');
      return (item.custom_start_date || '') + ' - ' + (hour[0] || '') + 'h - ' + this.getSaleId(item) + ' - ' + this.getInstallerAlias(item) + ' - ' + (item.customer_name || '') + ' ' + (item.customer_surname || '') + ' - ' + this.getCommerceAlias(item);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getDate: function getDate(item) {
      return (item.custom_today || '') + ' - ' + (item.custom_start_date || '') + ' - ' + (item.custom_start_hour || '') + 'h';
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getAddress: function getAddress(item) {
      return (item.customer_delivery_address || '') + ' ' + (item.customer_delivery_address_2 || '') + ', ' + (item.customer_delivery_postal_code || '') + ', ' + (item.customer_delivery_locality || '') + ', ' + (item.customer_delivery_province || '');
      // return this.getStatusName(item.status_id || 12) +
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getBookings: function getBookings(type, selectedInstallers) {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var userID = parseInt(_this5.$store.getters['api/getUserId']);
        _this5.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'get-all/bookings/' + userID + '/' + type + '/' + (selectedInstallers.join() || 'false') + '/'
        }).then(function (response) {
          _this5.shedules = response.data;
          _this5.isNew() ? _this5.renderShedules(_this5.shedules) : _this5.renderCustomShedules(_this5.shedules);
          console.log(response);
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this5.$store.dispatch('snackbar/show', 'Error al obtener calendario: ' + _this5.$store.getters['api/getMessage']);
          reject(error);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getDeactivatedShedulesForInstallers: function getDeactivatedShedulesForInstallers(userID) {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'deactivated-shedules/' + userID + '/'
        }).then(function (response) {
          var id = parseInt(_this6.$store.getters['api/getUserId']);
          if (_this6.isAdmin() || _this6.isSuperadmin() || _this6.isInstaller && userID === id) {
            _this6.renderShedules(response.data);
          }
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this6.$store.dispatch('snackbar/show', 'Error al obtener calendario: ' + _this6.$store.getters['api/getMessage']);
          reject(error);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    hasSelected: function hasSelected() {
      var active = false;
      this.installers.forEach(function (item) {
        if (item.value) {
          active = true;
        }
      });
      return active;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getInstallerColorByUserId: function getInstallerColorByUserId(userID) {
      var i = this.installers.findIndex(function (installer) {
        return parseInt(installer.user_id) === parseInt(userID);
      });
      if (i > -1) {
        return this.installers[i].color;
      }
      return null;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getDeactivatedShedules: function getDeactivatedShedules() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var userID = parseInt(_this7.$store.getters['api/getUserId']);
        // console.log(userID)
        _this7.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'deactivated-shedules/' + userID + '/'
        }).then(function (response) {
          _this7.renderShedules(response.data);
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this7.$store.dispatch('snackbar/show', 'Error al obtener calendario: ' + _this7.$store.getters['api/getMessage']);
          reject(error);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addDeactivatedShedule: function addDeactivatedShedule() {
      var _this8 = this;

      var assignTo = [];
      if (this.isSuperadmin() || this.isAdmin()) {
        var selectedInstallers = this.getSelectedInstallers();
        if (selectedInstallers.length) {
          this.installers.forEach(function (item) {
            if (item.value && parseInt(item.user_id) !== 2) {
              assignTo.push({
                id: item.user_id
              });
            }
          });
        }
      }

      if (!assignTo.length) {
        assignTo.push({
          id: parseInt(this.$store.getters['api/getUserId'])
        });
      }

      assignTo.forEach(function (item) {
        _this8.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'deactivated-shedules/' + item.id + '/',
          data: {
            start: __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this8.startDate).format('YYYY-MM-DD HH:mm:ss'),
            end: __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this8.endDate).format('YYYY-MM-DD HH:mm:ss')
          }
        }).then(function (response) {
          console.log(response.data);
          var event = {
            id: Date.now(),
            identificator: response.data.id,
            status: 12,
            title: _this8.getStatusName(12),
            start: _this8.startDate,
            end: _this8.endDate,
            overlap: true,
            color: _this8.getInstallerColorByUserId(response.data.user_id) || _this8.getColorByState(12)
          };
          _this8.$refs.calendar.renderEvent(event, true);
          _this8.$awn.success('Horario agregado');
        }).catch(function (error) {
          console.log(error);
          var message = _this8.$store.getters['api/getMessage'];
          _this8.$awn.alert('Error al agregar observación: ' + message);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getSelectedInstallers: function getSelectedInstallers(event) {
      var selected = [];
      this.installers.forEach(function (item) {
        if (item.value) {
          selected.push(item.id);
        }
      });

      return selected;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteDeactivatedShedule: function deleteDeactivatedShedule(event) {
      var _this9 = this;

      this.$store.dispatch('api/authRequest', {
        method: 'delete',
        url: 'deactivated-shedules/' + event.identificator + '/'
      }).then(function (response) {
        // console.log(response)
        _this9.$refs.calendar.removeEvent(event);
        _this9.$awn.success('Horario eliminado');
      }).catch(function () {
        var message = _this9.$store.getters['api/getMessage'];
        _this9.$awn.alert('Error al eliminar el horario: ' + message);
      });
    }
  },
  computed: {
    dddd: function dddd() {}
  }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_calendar_vue__ = __webpack_require__(616);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bedf678a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_calendar_vue__ = __webpack_require__(649);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bedf678a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FullCalendar_vue__ = __webpack_require__(637);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_FullCalendar_vue__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = ({
    install: function (Vue, options) {
        Vue.component('full-calendar', __WEBPACK_IMPORTED_MODULE_0__components_FullCalendar_vue__["a" /* default */]);
    },
});



/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__ = __webpack_require__(617);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4189f72a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__ = __webpack_require__(646);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4189f72a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (typeof key == 'number' && value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  if (!(isArray(source) || isTypedArray(source))) {
    var props = baseKeysIn(source);
  }
  arrayEach(props || source, function(srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  });
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    newValue = srcValue;
    if (isArray(srcValue) || isTypedArray(srcValue)) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
      else {
        newValue = objValue;
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function mergeDefaults(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, mergeDefaults);
  return apply(mergeWith, undefined, args);
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with seven arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = defaultsDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30), __webpack_require__(251)(module)))

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * FullCalendar v4.0.0-alpha
 * Docs & License: https://fullcalendar.io/
 * (c) 2018 Adam Shaw
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(640));
	else if(typeof define === 'function' && define.amd)
		define(["moment", "superagent"], factory);
	else if(typeof exports === 'object')
		exports["FullCalendar"] = factory(require("moment"), require("superagent"));
	else
		root["FullCalendar"] = factory(root["moment"], root["superagent"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_58__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 243);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

/*
derived from:
https://github.com/Microsoft/tslib/blob/v1.6.0/tslib.js

only include the helpers we need, to keep down filesize
*/
var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p]; };
exports.__extends = function (d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

// Creating
// ----------------------------------------------------------------------------------------------------------------
Object.defineProperty(exports, "__esModule", { value: true });
var elementPropHash = {
    className: true,
    colSpan: true,
    rowSpan: true
};
var containerTagHash = {
    '<tr': 'tbody',
    '<td': 'tr'
};
function createElement(tagName, attrs, content) {
    var el = document.createElement(tagName);
    if (attrs) {
        for (var attrName in attrs) {
            if (attrName === 'style') {
                applyStyle(el, attrs[attrName]);
            }
            else if (elementPropHash[attrName]) {
                el[attrName] = attrs[attrName];
            }
            else {
                el.setAttribute(attrName, attrs[attrName]);
            }
        }
    }
    if (typeof content === 'string') {
        el.innerHTML = content; // shortcut. no need to process HTML in any way
    }
    else if (content != null) {
        appendToElement(el, content);
    }
    return el;
}
exports.createElement = createElement;
function htmlToElement(html) {
    html = html.trim();
    var container = document.createElement(computeContainerTag(html));
    container.innerHTML = html;
    return container.firstChild;
}
exports.htmlToElement = htmlToElement;
function htmlToElements(html) {
    return Array.prototype.slice.call(htmlToNodeList(html));
}
exports.htmlToElements = htmlToElements;
function htmlToNodeList(html) {
    html = html.trim();
    var container = document.createElement(computeContainerTag(html));
    container.innerHTML = html;
    return container.childNodes;
}
// assumes html already trimmed and tag names are lowercase
function computeContainerTag(html) {
    return containerTagHash[html.substr(0, 3) // faster than using regex
    ] || 'div';
}
function appendToElement(el, content) {
    var childNodes = normalizeContent(content);
    for (var i = 0; i < childNodes.length; i++) {
        el.appendChild(childNodes[i]);
    }
}
exports.appendToElement = appendToElement;
function prependToElement(parent, content) {
    var newEls = normalizeContent(content);
    var afterEl = parent.firstChild || null; // if no firstChild, will append to end, but that's okay, b/c there were no children
    for (var i = 0; i < newEls.length; i++) {
        parent.insertBefore(newEls[i], afterEl);
    }
}
exports.prependToElement = prependToElement;
function insertAfterElement(refEl, content) {
    var newEls = normalizeContent(content);
    var afterEl = refEl.nextSibling || null;
    for (var i = 0; i < newEls.length; i++) {
        refEl.parentNode.insertBefore(newEls[i], afterEl);
    }
}
exports.insertAfterElement = insertAfterElement;
function normalizeContent(content) {
    var els;
    if (typeof content === 'string') {
        els = htmlToNodeList(content);
    }
    else if (content instanceof Node) {
        els = [content];
    }
    else { // assumed to be NodeList or Node[]
        els = content;
    }
    return els;
}
function removeElement(el) {
    if (el.parentNode) {
        el.parentNode.removeChild(el);
    }
}
exports.removeElement = removeElement;
// Querying
// ----------------------------------------------------------------------------------------------------------------
// from https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
var matchesMethod = Element.prototype.matches ||
    Element.prototype.matchesSelector ||
    Element.prototype.msMatchesSelector;
var closestMethod = Element.prototype.closest || function (selector) {
    // polyfill
    var el = this;
    if (!document.documentElement.contains(el)) {
        return null;
    }
    do {
        if (elementMatches(el, selector)) {
            return el;
        }
        el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
};
function elementClosest(el, selector) {
    return closestMethod.call(el, selector);
}
exports.elementClosest = elementClosest;
function elementMatches(el, selector) {
    return matchesMethod.call(el, selector);
}
exports.elementMatches = elementMatches;
// accepts multiple subject els
// returns a real array. good for methods like forEach
function findElements(container, selector) {
    var containers = container instanceof HTMLElement ? [container] : container;
    var allMatches = [];
    for (var i = 0; i < containers.length; i++) {
        var matches = containers[i].querySelectorAll(selector);
        for (var j = 0; j < matches.length; j++) {
            allMatches.push(matches[j]);
        }
    }
    return allMatches;
}
exports.findElements = findElements;
// accepts multiple subject els
// only queries direct child elements
function findChildren(parent, selector) {
    var parents = parent instanceof HTMLElement ? [parent] : parent;
    var allMatches = [];
    for (var i = 0; i < parents.length; i++) {
        var childNodes = parents[i].children; // only ever elements
        for (var j = 0; j < childNodes.length; j++) {
            var childNode = childNodes[j];
            if (!selector || elementMatches(childNode, selector)) {
                allMatches.push(childNode);
            }
        }
    }
    return allMatches;
}
exports.findChildren = findChildren;
// Attributes
// ----------------------------------------------------------------------------------------------------------------
function forceClassName(el, className, bool) {
    if (bool) {
        el.classList.add(className);
    }
    else {
        el.classList.remove(className);
    }
}
exports.forceClassName = forceClassName;
// Style
// ----------------------------------------------------------------------------------------------------------------
var PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function applyStyle(el, props, propVal) {
    for (var propName in props) {
        applyStyleProp(el, propName, props[propName]);
    }
}
exports.applyStyle = applyStyle;
function applyStyleProp(el, name, val) {
    if (val == null) {
        el.style[name] = '';
    }
    else if (typeof val === 'number' && PIXEL_PROP_RE.test(name)) {
        el.style[name] = val + 'px';
    }
    else {
        el.style[name] = val;
    }
}
exports.applyStyleProp = applyStyleProp;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var dom_manip_1 = __webpack_require__(3);
var dom_geom_1 = __webpack_require__(13);
var dom_event_1 = __webpack_require__(10);
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/
// Given the scrollbar widths of some other container, create borders/margins on rowEls in order to match the left
// and right space that was offset by the scrollbars. A 1-pixel border first, then margin beyond that.
function compensateScroll(rowEl, scrollbarWidths) {
    if (scrollbarWidths.left) {
        dom_manip_1.applyStyle(rowEl, {
            borderLeftWidth: 1,
            marginLeft: scrollbarWidths.left - 1
        });
    }
    if (scrollbarWidths.right) {
        dom_manip_1.applyStyle(rowEl, {
            borderRightWidth: 1,
            marginRight: scrollbarWidths.right - 1
        });
    }
}
exports.compensateScroll = compensateScroll;
// Undoes compensateScroll and restores all borders/margins
function uncompensateScroll(rowEl) {
    dom_manip_1.applyStyle(rowEl, {
        marginLeft: '',
        marginRight: '',
        borderLeftWidth: '',
        borderRightWidth: ''
    });
}
exports.uncompensateScroll = uncompensateScroll;
// Make the mouse cursor express that an event is not allowed in the current area
function disableCursor() {
    document.body.classList.add('fc-not-allowed');
}
exports.disableCursor = disableCursor;
// Returns the mouse cursor to its original look
function enableCursor() {
    document.body.classList.remove('fc-not-allowed');
}
exports.enableCursor = enableCursor;
// Given a total available height to fill, have `els` (essentially child rows) expand to accomodate.
// By default, all elements that are shorter than the recommended height are expanded uniformly, not considering
// any other els that are already too tall. if `shouldRedistribute` is on, it considers these tall rows and
// reduces the available height.
function distributeHeight(els, availableHeight, shouldRedistribute) {
    // *FLOORING NOTE*: we floor in certain places because zoom can give inaccurate floating-point dimensions,
    // and it is better to be shorter than taller, to avoid creating unnecessary scrollbars.
    var minOffset1 = Math.floor(availableHeight / els.length); // for non-last element
    var minOffset2 = Math.floor(availableHeight - minOffset1 * (els.length - 1)); // for last element *FLOORING NOTE*
    var flexEls = []; // elements that are allowed to expand. array of DOM nodes
    var flexOffsets = []; // amount of vertical space it takes up
    var flexHeights = []; // actual css height
    var usedHeight = 0;
    undistributeHeight(els); // give all elements their natural height
    // find elements that are below the recommended height (expandable).
    // important to query for heights in a single first pass (to avoid reflow oscillation).
    els.forEach(function (el, i) {
        var minOffset = i === els.length - 1 ? minOffset2 : minOffset1;
        var naturalOffset = dom_geom_1.computeHeightAndMargins(el);
        if (naturalOffset < minOffset) {
            flexEls.push(el);
            flexOffsets.push(naturalOffset);
            flexHeights.push(el.offsetHeight);
        }
        else {
            // this element stretches past recommended height (non-expandable). mark the space as occupied.
            usedHeight += naturalOffset;
        }
    });
    // readjust the recommended height to only consider the height available to non-maxed-out rows.
    if (shouldRedistribute) {
        availableHeight -= usedHeight;
        minOffset1 = Math.floor(availableHeight / flexEls.length);
        minOffset2 = Math.floor(availableHeight - minOffset1 * (flexEls.length - 1)); // *FLOORING NOTE*
    }
    // assign heights to all expandable elements
    flexEls.forEach(function (el, i) {
        var minOffset = i === flexEls.length - 1 ? minOffset2 : minOffset1;
        var naturalOffset = flexOffsets[i];
        var naturalHeight = flexHeights[i];
        var newHeight = minOffset - (naturalOffset - naturalHeight); // subtract the margin/padding
        if (naturalOffset < minOffset) { // we check this again because redistribution might have changed things
            el.style.height = newHeight + 'px';
        }
    });
}
exports.distributeHeight = distributeHeight;
// Undoes distrubuteHeight, restoring all els to their natural height
function undistributeHeight(els) {
    els.forEach(function (el) {
        el.style.height = '';
    });
}
exports.undistributeHeight = undistributeHeight;
// Given `els`, a set of <td> cells, find the cell with the largest natural width and set the widths of all the
// cells to be that width.
// PREREQUISITE: if you want a cell to take up width, it needs to have a single inner element w/ display:inline
function matchCellWidths(els) {
    var maxInnerWidth = 0;
    els.forEach(function (el) {
        var innerEl = el.firstChild; // hopefully an element
        if (innerEl instanceof HTMLElement) {
            var innerWidth_1 = innerEl.offsetWidth;
            if (innerWidth_1 > maxInnerWidth) {
                maxInnerWidth = innerWidth_1;
            }
        }
    });
    maxInnerWidth++; // sometimes not accurate of width the text needs to stay on one line. insurance
    els.forEach(function (el) {
        el.style.width = maxInnerWidth + 'px';
    });
    return maxInnerWidth;
}
exports.matchCellWidths = matchCellWidths;
// Given one element that resides inside another,
// Subtracts the height of the inner element from the outer element.
function subtractInnerElHeight(outerEl, innerEl) {
    // effin' IE8/9/10/11 sometimes returns 0 for dimensions. this weird hack was the only thing that worked
    var reflowStyleProps = {
        position: 'relative',
        left: -1 // ensure reflow in case the el was already relative. negative is less likely to cause new scroll
    };
    dom_manip_1.applyStyle(outerEl, reflowStyleProps);
    dom_manip_1.applyStyle(innerEl, reflowStyleProps);
    var diff = outerEl.offsetHeight - innerEl.offsetHeight; // grab the dimensions
    // undo hack
    var resetStyleProps = { position: '', left: '' };
    dom_manip_1.applyStyle(outerEl, resetStyleProps);
    dom_manip_1.applyStyle(innerEl, resetStyleProps);
    return diff;
}
exports.subtractInnerElHeight = subtractInnerElHeight;
/* Selection
----------------------------------------------------------------------------------------------------------------------*/
function preventSelection(el) {
    el.classList.add('fc-unselectable');
    el.addEventListener('selectstart', dom_event_1.preventDefault);
}
exports.preventSelection = preventSelection;
function allowSelection(el) {
    el.classList.remove('fc-unselectable');
    el.removeEventListener('selectstart', dom_event_1.preventDefault);
}
exports.allowSelection = allowSelection;
/* Object Ordering by Field
----------------------------------------------------------------------------------------------------------------------*/
function parseFieldSpecs(input) {
    var specs = [];
    var tokens = [];
    var i;
    var token;
    if (typeof input === 'string') {
        tokens = input.split(/\s*,\s*/);
    }
    else if (typeof input === 'function') {
        tokens = [input];
    }
    else if (Array.isArray(input)) {
        tokens = input;
    }
    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        if (typeof token === 'string') {
            specs.push(token.charAt(0) === '-' ?
                { field: token.substring(1), order: -1 } :
                { field: token, order: 1 });
        }
        else if (typeof token === 'function') {
            specs.push({ func: token });
        }
    }
    return specs;
}
exports.parseFieldSpecs = parseFieldSpecs;
function compareByFieldSpecs(obj1, obj2, fieldSpecs, obj1fallback, obj2fallback) {
    var i;
    var cmp;
    for (i = 0; i < fieldSpecs.length; i++) {
        cmp = compareByFieldSpec(obj1, obj2, fieldSpecs[i], obj1fallback, obj2fallback);
        if (cmp) {
            return cmp;
        }
    }
    return 0;
}
exports.compareByFieldSpecs = compareByFieldSpecs;
function compareByFieldSpec(obj1, obj2, fieldSpec, obj1fallback, obj2fallback) {
    if (fieldSpec.func) {
        return fieldSpec.func(obj1, obj2);
    }
    var val1 = obj1[fieldSpec.field];
    var val2 = obj2[fieldSpec.field];
    if (val1 == null && obj1fallback) {
        val1 = obj1fallback[fieldSpec.field];
    }
    if (val2 == null && obj2fallback) {
        val2 = obj2fallback[fieldSpec.field];
    }
    return flexibleCompare(val1, val2) * (fieldSpec.order || 1);
}
exports.compareByFieldSpec = compareByFieldSpec;
function flexibleCompare(a, b) {
    if (!a && !b) {
        return 0;
    }
    if (b == null) {
        return -1;
    }
    if (a == null) {
        return 1;
    }
    if (typeof a === 'string' || typeof b === 'string') {
        return String(a).localeCompare(String(b));
    }
    return a - b;
}
exports.flexibleCompare = flexibleCompare;
/* Logging and Debug
----------------------------------------------------------------------------------------------------------------------*/
function log() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var console = window.console;
    if (console && console.log) {
        return console.log.apply(console, args);
    }
}
exports.log = log;
function warn() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var console = window.console;
    if (console && console.warn) {
        return console.warn.apply(console, args);
    }
    else {
        return log.apply(null, args);
    }
}
exports.warn = warn;
/* General Utilities
----------------------------------------------------------------------------------------------------------------------*/
function applyAll(functions, thisObj, args) {
    if (typeof functions === 'function') { // supplied a single function
        functions = [functions];
    }
    if (functions) {
        var i = void 0;
        var ret = void 0;
        for (i = 0; i < functions.length; i++) {
            ret = functions[i].apply(thisObj, args) || ret;
        }
        return ret;
    }
}
exports.applyAll = applyAll;
function firstDefined() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    for (var i = 0; i < args.length; i++) {
        if (args[i] !== undefined) {
            return args[i];
        }
    }
}
exports.firstDefined = firstDefined;
function capitaliseFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
exports.capitaliseFirstLetter = capitaliseFirstLetter;
function compareNumbers(a, b) {
    return a - b;
}
exports.compareNumbers = compareNumbers;
function isInt(n) {
    return n % 1 === 0;
}
exports.isInt = isInt;
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
// https://github.com/jashkenas/underscore/blob/1.6.0/underscore.js#L714
function debounce(func, wait, immediate) {
    if (immediate === void 0) { immediate = false; }
    var timeout;
    var args;
    var context;
    var timestamp;
    var result;
    var later = function () {
        var last = +new Date() - timestamp;
        if (last < wait) {
            timeout = setTimeout(later, wait - last);
        }
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    };
    return function () {
        context = this;
        args = arguments;
        timestamp = +new Date();
        var callNow = immediate && !timeout;
        if (!timeout) {
            timeout = setTimeout(later, wait);
        }
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
}
exports.debounce = debounce;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var hasOwnPropMethod = {}.hasOwnProperty;
function assignTo(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    for (var i = 0; i < sources.length; i++) {
        var source = sources[i];
        if (source != null) { // skip over if undefined or null
            for (var key in source) {
                // avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
    }
    return target;
}
exports.assignTo = assignTo;
function isEmptyObject(obj) {
    for (var _key in obj) {
        return false;
    }
    return true;
}
exports.isEmptyObject = isEmptyObject;
function copyOwnProps(src, dest) {
    for (var name_1 in src) {
        if (hasOwnProp(src, name_1)) {
            dest[name_1] = src[name_1];
        }
    }
}
exports.copyOwnProps = copyOwnProps;
function hasOwnProp(obj, name) {
    return hasOwnPropMethod.call(obj, name);
}
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function mergeProps(propObjs, complexProps) {
    var dest = {};
    var i;
    var name;
    var complexObjs;
    var j;
    var val;
    var props;
    if (complexProps) {
        for (i = 0; i < complexProps.length; i++) {
            name = complexProps[i];
            complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for (j = propObjs.length - 1; j >= 0; j--) {
                val = propObjs[j][name];
                if (typeof val === 'object' && val) { // non-null object
                    complexObjs.unshift(val);
                }
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) {
                dest[name] = mergeProps(complexObjs);
            }
        }
    }
    // copy values into the destination, going from last to first
    for (i = propObjs.length - 1; i >= 0; i--) {
        props = propObjs[i];
        for (name in props) {
            if (!(name in dest)) { // if already assigned by previous props or complex props, don't reassign
                dest[name] = props[name];
            }
        }
    }
    return dest;
}
exports.mergeProps = mergeProps;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function htmlEscape(s) {
    return (s + '').replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&#039;')
        .replace(/"/g, '&quot;')
        .replace(/\n/g, '<br />');
}
exports.htmlEscape = htmlEscape;
function stripHtmlEntities(text) {
    return text.replace(/&.*?;/g, '');
}
exports.stripHtmlEntities = stripHtmlEntities;
// Given a hash of CSS properties, returns a string of CSS.
// Uses property names as-is (no camel-case conversion). Will not make statements for null/undefined values.
function cssToStr(cssProps) {
    var statements = [];
    for (var name_1 in cssProps) {
        var val = cssProps[name_1];
        if (val != null) {
            statements.push(name_1 + ':' + val);
        }
    }
    return statements.join(';');
}
exports.cssToStr = cssToStr;
// Given an object hash of HTML attribute names to values,
// generates a string that can be injected between < > in HTML
function attrsToStr(attrs) {
    var parts = [];
    for (var name_2 in attrs) {
        var val = attrs[name_2];
        if (val != null) {
            parts.push(name_2 + '="' + htmlEscape(val) + '"');
        }
    }
    return parts.join(' ');
}
exports.attrsToStr = attrsToStr;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var moment_ext_1 = __webpack_require__(14);
var UnzonedRange = /** @class */ (function () {
    function UnzonedRange(startInput, endInput) {
        // TODO: move these into footprint.
        // Especially, doesn't make sense for null startMs/endMs.
        this.isStart = true;
        this.isEnd = true;
        if (moment.isMoment(startInput)) {
            startInput = startInput.clone().stripZone();
        }
        if (moment.isMoment(endInput)) {
            endInput = endInput.clone().stripZone();
        }
        if (startInput) {
            this.startMs = startInput.valueOf();
        }
        if (endInput) {
            this.endMs = endInput.valueOf();
        }
    }
    /*
    SIDEEFFECT: will mutate eventRanges.
    Will return a new array result.
    Only works for non-open-ended ranges.
    */
    UnzonedRange.invertRanges = function (ranges, constraintRange) {
        var invertedRanges = [];
        var startMs = constraintRange.startMs; // the end of the previous range. the start of the new range
        var i;
        var dateRange;
        // ranges need to be in order. required for our date-walking algorithm
        ranges.sort(compareUnzonedRanges);
        for (i = 0; i < ranges.length; i++) {
            dateRange = ranges[i];
            // add the span of time before the event (if there is any)
            if (dateRange.startMs > startMs) { // compare millisecond time (skip any ambig logic)
                invertedRanges.push(new UnzonedRange(startMs, dateRange.startMs));
            }
            if (dateRange.endMs > startMs) {
                startMs = dateRange.endMs;
            }
        }
        // add the span of time after the last event (if there is any)
        if (startMs < constraintRange.endMs) { // compare millisecond time (skip any ambig logic)
            invertedRanges.push(new UnzonedRange(startMs, constraintRange.endMs));
        }
        return invertedRanges;
    };
    UnzonedRange.prototype.intersect = function (otherRange) {
        var startMs = this.startMs;
        var endMs = this.endMs;
        var newRange = null;
        if (otherRange.startMs != null) {
            if (startMs == null) {
                startMs = otherRange.startMs;
            }
            else {
                startMs = Math.max(startMs, otherRange.startMs);
            }
        }
        if (otherRange.endMs != null) {
            if (endMs == null) {
                endMs = otherRange.endMs;
            }
            else {
                endMs = Math.min(endMs, otherRange.endMs);
            }
        }
        if (startMs == null || endMs == null || startMs < endMs) {
            newRange = new UnzonedRange(startMs, endMs);
            newRange.isStart = this.isStart && startMs === this.startMs;
            newRange.isEnd = this.isEnd && endMs === this.endMs;
        }
        return newRange;
    };
    UnzonedRange.prototype.intersectsWith = function (otherRange) {
        return (this.endMs == null || otherRange.startMs == null || this.endMs > otherRange.startMs) &&
            (this.startMs == null || otherRange.endMs == null || this.startMs < otherRange.endMs);
    };
    UnzonedRange.prototype.containsRange = function (innerRange) {
        return (this.startMs == null || (innerRange.startMs != null && innerRange.startMs >= this.startMs)) &&
            (this.endMs == null || (innerRange.endMs != null && innerRange.endMs <= this.endMs));
    };
    // `date` can be a moment, a Date, or a millisecond time.
    UnzonedRange.prototype.containsDate = function (date) {
        var ms = date.valueOf();
        return (this.startMs == null || ms >= this.startMs) &&
            (this.endMs == null || ms < this.endMs);
    };
    // If the given date is not within the given range, move it inside.
    // (If it's past the end, make it one millisecond before the end).
    // `date` can be a moment, a Date, or a millisecond time.
    // Returns a MS-time.
    UnzonedRange.prototype.constrainDate = function (date) {
        var ms = date.valueOf();
        if (this.startMs != null && ms < this.startMs) {
            ms = this.startMs;
        }
        if (this.endMs != null && ms >= this.endMs) {
            ms = this.endMs - 1;
        }
        return ms;
    };
    UnzonedRange.prototype.equals = function (otherRange) {
        return this.startMs === otherRange.startMs && this.endMs === otherRange.endMs;
    };
    UnzonedRange.prototype.clone = function () {
        var range = new UnzonedRange(this.startMs, this.endMs);
        range.isStart = this.isStart;
        range.isEnd = this.isEnd;
        return range;
    };
    // Returns an ambig-zoned moment from startMs.
    // BEWARE: returned moment is not localized.
    // Formatting and start-of-week will be default.
    UnzonedRange.prototype.getStart = function () {
        if (this.startMs != null) {
            return moment_ext_1.default.utc(this.startMs).stripZone();
        }
        return null;
    };
    // Returns an ambig-zoned moment from startMs.
    // BEWARE: returned moment is not localized.
    // Formatting and start-of-week will be default.
    UnzonedRange.prototype.getEnd = function () {
        if (this.endMs != null) {
            return moment_ext_1.default.utc(this.endMs).stripZone();
        }
        return null;
    };
    UnzonedRange.prototype.as = function (unit) {
        return moment.utc(this.endMs).diff(moment.utc(this.startMs), unit, true);
    };
    return UnzonedRange;
}());
exports.default = UnzonedRange;
/*
Only works for non-open-ended ranges.
*/
function compareUnzonedRanges(range1, range2) {
    return range1.startMs - range2.startMs; // earlier ranges go first
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var misc_1 = __webpack_require__(4);
exports.dayIDs = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
exports.unitsDesc = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond']; // descending
// Diffs the two moments into a Duration where full-days are recorded first, then the remaining time.
// Moments will have their timezones normalized.
function diffDayTime(a, b) {
    return moment.duration({
        days: a.clone().stripTime().diff(b.clone().stripTime(), 'days'),
        ms: a.time() - b.time() // time-of-day from day start. disregards timezone
    });
}
exports.diffDayTime = diffDayTime;
// Diffs the two moments via their start-of-day (regardless of timezone). Produces whole-day durations.
function diffDay(a, b) {
    return moment.duration({
        days: a.clone().stripTime().diff(b.clone().stripTime(), 'days')
    });
}
exports.diffDay = diffDay;
// Diffs two moments, producing a duration, made of a whole-unit-increment of the given unit. Uses rounding.
function diffByUnit(a, b, unit) {
    return moment.duration(Math.round(a.diff(b, unit, true)), // returnFloat=true
    unit);
}
exports.diffByUnit = diffByUnit;
// Computes the unit name of the largest whole-unit period of time.
// For example, 48 hours will be "days" whereas 49 hours will be "hours".
// Accepts start/end, a range object, or an original duration object.
function computeGreatestUnit(start, end) {
    var i;
    var unit;
    var val;
    for (i = 0; i < exports.unitsDesc.length; i++) {
        unit = exports.unitsDesc[i];
        val = computeRangeAs(unit, start, end);
        if (val >= 1 && misc_1.isInt(val)) {
            break;
        }
    }
    return unit; // will be "milliseconds" if nothing else matches
}
exports.computeGreatestUnit = computeGreatestUnit;
// like computeGreatestUnit, but has special abilities to interpret the source input for clues
function computeDurationGreatestUnit(duration, durationInput) {
    var unit = computeGreatestUnit(duration);
    // prevent days:7 from being interpreted as a week
    if (unit === 'week' && typeof durationInput === 'object' && durationInput && durationInput.days) { // non-null object
        unit = 'day';
    }
    return unit;
}
exports.computeDurationGreatestUnit = computeDurationGreatestUnit;
// Computes the number of units (like "hours") in the given range.
// Range can be a {start,end} object, separate start/end args, or a Duration.
// Results are based on Moment's .as() and .diff() methods, so results can depend on internal handling
// of month-diffing logic (which tends to vary from version to version).
function computeRangeAs(unit, start, end) {
    if (end != null) { // given start, end
        return end.diff(start, unit, true);
    }
    else if (moment.isDuration(start)) { // given duration
        return start.as(unit);
    }
    else { // given { start, end } range object
        return start.end.diff(start.start, unit, true);
    }
}
// Intelligently divides a range (specified by a start/end params) by a duration
function divideRangeByDuration(start, end, dur) {
    var months;
    if (durationHasTime(dur)) {
        return (end - start) / dur;
    }
    months = dur.asMonths();
    if (Math.abs(months) >= 1 && misc_1.isInt(months)) {
        return end.diff(start, 'months', true) / months;
    }
    return end.diff(start, 'days', true) / dur.asDays();
}
exports.divideRangeByDuration = divideRangeByDuration;
// Intelligently divides one duration by another
function divideDurationByDuration(dur1, dur2) {
    var months1;
    var months2;
    if (durationHasTime(dur1) || durationHasTime(dur2)) {
        return dur1 / dur2;
    }
    months1 = dur1.asMonths();
    months2 = dur2.asMonths();
    if (Math.abs(months1) >= 1 && misc_1.isInt(months1) &&
        Math.abs(months2) >= 1 && misc_1.isInt(months2)) {
        return months1 / months2;
    }
    return dur1.asDays() / dur2.asDays();
}
exports.divideDurationByDuration = divideDurationByDuration;
// Intelligently multiplies a duration by a number
function multiplyDuration(dur, n) {
    var months;
    if (durationHasTime(dur)) {
        return moment.duration(dur * n);
    }
    months = dur.asMonths();
    if (Math.abs(months) >= 1 && misc_1.isInt(months)) {
        return moment.duration({ months: months * n });
    }
    return moment.duration({ days: dur.asDays() * n });
}
exports.multiplyDuration = multiplyDuration;
// Returns a boolean about whether the given duration has any time parts (hours/minutes/seconds/ms)
function durationHasTime(dur) {
    return Boolean(dur.hours() || dur.minutes() || dur.seconds() || dur.milliseconds());
}
exports.durationHasTime = durationHasTime;
function isNativeDate(input) {
    return Object.prototype.toString.call(input) === '[object Date]' || input instanceof Date;
}
exports.isNativeDate = isNativeDate;
// Returns a boolean about whether the given input is a time string, like "06:40:00" or "06:00"
function isTimeString(str) {
    return typeof str === 'string' &&
        /^\d+\:\d+(?:\:\d+\.?(?:\d{3})?)?$/.test(str);
}
exports.isTimeString = isTimeString;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var ParsableModelMixin_1 = __webpack_require__(216);
var Class_1 = __webpack_require__(38);
var EventDefParser_1 = __webpack_require__(54);
var EventSource = /** @class */ (function (_super) {
    tslib_1.__extends(EventSource, _super);
    // can we do away with calendar? at least for the abstract?
    // useful for buildEventDef
    function EventSource(calendar) {
        var _this = _super.call(this) || this;
        _this.calendar = calendar;
        _this.className = [];
        _this.uid = String(EventSource.uuid++);
        return _this;
    }
    /*
    rawInput can be any data type!
    */
    EventSource.parse = function (rawInput, calendar) {
        var source = new this(calendar);
        if (typeof rawInput === 'object' && rawInput) { // non-null object
            if (source.applyProps(rawInput)) {
                return source;
            }
        }
        return false;
    };
    EventSource.normalizeId = function (id) {
        if (id) {
            return String(id);
        }
        return null;
    };
    EventSource.prototype.fetch = function (start, end, timezone, onSuccess, onFailure) {
        // subclasses must implement. must call the `onSuccess` or `onFailure` func.
    };
    EventSource.prototype.removeEventDefsById = function (eventDefId) {
        // optional for subclasses to implement
    };
    EventSource.prototype.removeAllEventDefs = function () {
        // optional for subclasses to implement
    };
    /*
    For compairing/matching
    */
    EventSource.prototype.getPrimitive = function (otherSource) {
        // subclasses must implement
    };
    EventSource.prototype.parseEventDefs = function (rawEventDefs) {
        var i;
        var eventDef;
        var eventDefs = [];
        for (i = 0; i < rawEventDefs.length; i++) {
            eventDef = this.parseEventDef(rawEventDefs[i]);
            if (eventDef) {
                eventDefs.push(eventDef);
            }
        }
        return eventDefs;
    };
    EventSource.prototype.parseEventDef = function (rawInput) {
        var calendarTransform = this.calendar.opt('eventDataTransform');
        var sourceTransform = this.eventDataTransform;
        if (calendarTransform) {
            rawInput = calendarTransform(rawInput, this.calendar);
        }
        if (sourceTransform) {
            rawInput = sourceTransform(rawInput, this.calendar);
        }
        return EventDefParser_1.default.parse(rawInput, this);
    };
    EventSource.prototype.applyManualStandardProps = function (rawProps) {
        if (rawProps.id != null) {
            this.id = EventSource.normalizeId(rawProps.id);
        }
        // TODO: converge with EventDef
        if (Array.isArray(rawProps.className)) {
            this.className = rawProps.className;
        }
        else if (typeof rawProps.className === 'string') {
            this.className = rawProps.className.split(/\s+/);
        }
        return true;
    };
    EventSource.uuid = 0;
    EventSource.defineStandardProps = ParsableModelMixin_1.default.defineStandardProps;
    EventSource.copyVerbatimStandardProps = ParsableModelMixin_1.default.copyVerbatimStandardProps;
    return EventSource;
}(Class_1.default));
exports.default = EventSource;
ParsableModelMixin_1.default.mixInto(EventSource);
// Parsing
// ---------------------------------------------------------------------------------------------------------------------
EventSource.defineStandardProps({
    // manually process...
    id: false,
    className: false,
    // automatically transfer...
    color: true,
    backgroundColor: true,
    borderColor: true,
    textColor: true,
    editable: true,
    startEditable: true,
    durationEditable: true,
    rendering: true,
    overlap: true,
    constraint: true,
    allDayDefault: true,
    eventDataTransform: true
});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var dom_manip_1 = __webpack_require__(3);
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function isPrimaryMouseButton(ev) {
    return ev.button === 0 && !ev.ctrlKey;
}
exports.isPrimaryMouseButton = isPrimaryMouseButton;
function getEvX(ev) {
    var touches = ev.touches;
    // on mobile FF, pageX for touch events is present, but incorrect,
    // so, look at touch coordinates first.
    if (touches && touches.length) {
        return touches[0].pageX;
    }
    return ev.pageX;
}
exports.getEvX = getEvX;
function getEvY(ev) {
    var touches = ev.touches;
    // on mobile FF, pageX for touch events is present, but incorrect,
    // so, look at touch coordinates first.
    if (touches && touches.length) {
        return touches[0].pageY;
    }
    return ev.pageY;
}
exports.getEvY = getEvY;
function getEvIsTouch(ev) {
    return /^touch/.test(ev.type);
}
exports.getEvIsTouch = getEvIsTouch;
// Stops a mouse/touch event from doing it's native browser action
function preventDefault(ev) {
    ev.preventDefault();
}
exports.preventDefault = preventDefault;
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function listenBySelector(container, eventType, selector, handler) {
    function realHandler(ev) {
        var matchedChild = dom_manip_1.elementClosest(ev.target, selector);
        if (matchedChild) {
            handler.call(matchedChild, ev, matchedChild);
        }
    }
    container.addEventListener(eventType, realHandler, {passive: false}); // CUSTOM CHANGE
    return function () {
        container.removeEventListener(eventType, realHandler);
    };
}
exports.listenBySelector = listenBySelector;
function listenToHoverBySelector(container, selector, onMouseEnter, onMouseLeave) {
    var currentMatchedChild;
    return listenBySelector(container, 'mouseover', selector, function (ev, matchedChild) {
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(ev, matchedChild);
            var realOnMouseLeave_1 = function (ev) {
                currentMatchedChild = null;
                onMouseLeave(ev, matchedChild);
                matchedChild.removeEventListener('mouseleave', realOnMouseLeave_1);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener('mouseleave', realOnMouseLeave_1);
        }
    });
}
exports.listenToHoverBySelector = listenToHoverBySelector;
// Animation
// ----------------------------------------------------------------------------------------------------------------
var transitionEventNames = [
    'webkitTransitionEnd',
    'otransitionend',
    'oTransitionEnd',
    'msTransitionEnd',
    'transitionend'
];
// triggered only when the next single subsequent transition finishes
function whenTransitionDone(el, callback) {
    var realCallback = function (ev) {
        callback(ev);
        transitionEventNames.forEach(function (eventName) {
            el.removeEventListener(eventName, realCallback);
        });
    };
    transitionEventNames.forEach(function (eventName) {
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
exports.whenTransitionDone = whenTransitionDone;


/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/*
Utility methods for easily listening to events on another object,
and more importantly, easily unlistening from them.

USAGE:
  import { default as ListenerMixin, ListenerInterface } from './ListenerMixin'
in class:
  listenTo: ListenerInterface['listenTo']
  stopListeningTo: ListenerInterface['stopListeningTo']
after class:
  ListenerMixin.mixInto(TheClass)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Mixin_1 = __webpack_require__(18);
var ListenerMixin = /** @class */ (function (_super) {
    tslib_1.__extends(ListenerMixin, _super);
    function ListenerMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
    Given an `other` object that has on/off or addEventListener/removeEventListener methods, bind the given `callback` to an event by the given name.
    The `callback` will be called with the `this` context of the object that .listenTo is being called on.
    Can be called:
      .listenTo(other, eventName, callback)
    OR
      .listenTo(other, {
        eventName1: callback1,
        eventName2: callback2
      })
    */
    ListenerMixin.prototype.listenTo = function (other, arg, callback) {
        if (typeof arg === 'object' && arg) { // given dictionary of callbacks (non-null)
            for (var eventName in arg) {
                if (arg.hasOwnProperty(eventName)) {
                    this.listenTo(other, eventName, arg[eventName]);
                }
            }
        }
        else if (typeof arg === 'string' && callback) {
            callback = callback.bind(this); // always use `this` context)
            if (other.addEventListener) {
                other.addEventListener(arg, callback);
            }
            else {
                other.on(arg, callback);
            }
            (this._listeners || (this._listeners = []))
                .push([other, arg, callback]);
        }
    };
    /*
    Causes the current object to stop listening to events on the `other` object.
    `eventName` is optional. If omitted, will stop listening to ALL events on `other`.
    */
    ListenerMixin.prototype.stopListeningTo = function (other, eventName) {
        if (this._listeners) {
            this._listeners = this._listeners.filter(function (listener) {
                if (listener[0] === other &&
                    (!eventName || eventName === listener[1])) {
                    if (other.removeEventListener) {
                        other.removeEventListener(listener[1], listener[2]);
                    }
                    else {
                        other.off(listener[1], listener[2]);
                    }
                    return false; // remove from array
                }
                else {
                    return true; // keep in array
                }
            });
        }
    };
    return ListenerMixin;
}(Mixin_1.default));
exports.default = ListenerMixin;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var dom_manip_1 = __webpack_require__(3);
function computeEdges(el, getPadding) {
    if (getPadding === void 0) { getPadding = false; }
    var computedStyle = window.getComputedStyle(el);
    var borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    var borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    var borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    var borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    var scrollbarLeftRight = sanitizeScrollbarWidth(el.offsetWidth - el.clientWidth - borderLeft - borderRight);
    var scrollbarBottom = sanitizeScrollbarWidth(el.offsetHeight - el.clientHeight - borderTop - borderBottom);
    var res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if (getIsLeftRtlScrollbars() && computedStyle.direction === 'rtl') { // is the scrollbar on the left side?
        res.scrollbarLeft = scrollbarLeftRight;
    }
    else {
        res.scrollbarRight = scrollbarLeftRight;
    }
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
exports.computeEdges = computeEdges;
function computeInnerRect(el, goWithinPadding) {
    if (goWithinPadding === void 0) { goWithinPadding = false; }
    var outerRect = el.getBoundingClientRect();
    var edges = computeEdges(el, goWithinPadding);
    var res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
exports.computeInnerRect = computeInnerRect;
function computeHeightAndMargins(el) {
    var computed = window.getComputedStyle(el);
    return el.offsetHeight +
        parseInt(computed.marginTop, 10) +
        parseInt(computed.marginBottom, 10);
}
exports.computeHeightAndMargins = computeHeightAndMargins;
// will return null of no scroll parent. will NOT return window/body
function getScrollParent(el) {
    while (el instanceof HTMLElement) { // will stop when gets to document or null
        var computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === 'fixed') {
            break;
        }
        if ((/(auto|scroll)/).test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) {
            return el;
        }
        el = el.parentNode;
    }
    return null;
}
exports.getScrollParent = getScrollParent;
// The scrollbar width computations in computeEdges are sometimes flawed when it comes to
// retina displays, rounding, and IE11. Massage them into a usable value.
function sanitizeScrollbarWidth(width) {
    width = Math.max(0, width); // no negatives
    width = Math.round(width);
    return width;
}
// Logic for determining if, when the element is right-to-left, the scrollbar appears on the left side
var _isLeftRtlScrollbars = null;
function getIsLeftRtlScrollbars() {
    if (_isLeftRtlScrollbars === null) {
        _isLeftRtlScrollbars = computeIsLeftRtlScrollbars();
    }
    return _isLeftRtlScrollbars;
}
function computeIsLeftRtlScrollbars() {
    var outerEl = dom_manip_1.createElement('div', {
        style: {
            position: 'absolute',
            top: -1000,
            left: 0,
            border: 0,
            padding: 0,
            overflow: 'scroll',
            direction: 'rtl'
        }
    }, '<div></div>');
    document.body.appendChild(outerEl);
    var innerEl = outerEl.firstChild;
    var res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    dom_manip_1.removeElement(outerEl);
    return res;
}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var date_1 = __webpack_require__(8);
var object_1 = __webpack_require__(5);
var ambigDateOfMonthRegex = /^\s*\d{4}-\d\d$/;
var ambigTimeOrZoneRegex = /^\s*\d{4}-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?)?$/;
var newMomentProto = moment.fn; // where we will attach our new methods
exports.newMomentProto = newMomentProto;
var oldMomentProto = object_1.assignTo({}, newMomentProto); // copy of original moment methods
exports.oldMomentProto = oldMomentProto;
// tell momentjs to transfer these properties upon clone
var momentProperties = moment.momentProperties;
momentProperties.push('_fullCalendar');
momentProperties.push('_ambigTime');
momentProperties.push('_ambigZone');
/*
Call this if you want Moment's original format method to be used
*/
function oldMomentFormat(mom, formatStr) {
    return oldMomentProto.format.call(mom, formatStr); // oldMomentProto defined in moment-ext.js
}
exports.oldMomentFormat = oldMomentFormat;
// Creating
// -------------------------------------------------------------------------------------------------
// Creates a new moment, similar to the vanilla moment(...) constructor, but with
// extra features (ambiguous time, enhanced formatting). When given an existing moment,
// it will function as a clone (and retain the zone of the moment). Anything else will
// result in a moment in the local zone.
var momentExt = function () {
    return makeMoment(arguments);
};
exports.default = momentExt;
// Sames as momentExt, but forces the resulting moment to be in the UTC timezone.
momentExt.utc = function () {
    var mom = makeMoment(arguments, true);
    // Force it into UTC because makeMoment doesn't guarantee it
    // (if given a pre-existing moment for example)
    if (mom.hasTime()) { // don't give ambiguously-timed moments a UTC zone
        mom.utc();
    }
    return mom;
};
// Same as momentExt, but when given an ISO8601 string, the timezone offset is preserved.
// ISO8601 strings with no timezone offset will become ambiguously zoned.
momentExt.parseZone = function () {
    return makeMoment(arguments, true, true);
};
// Builds an enhanced moment from args. When given an existing moment, it clones. When given a
// native Date, or called with no arguments (the current time), the resulting moment will be local.
// Anything else needs to be "parsed" (a string or an array), and will be affected by:
//    parseAsUTC - if there is no zone information, should we parse the input in UTC?
//    parseZone - if there is zone information, should we force the zone of the moment?
function makeMoment(args, parseAsUTC, parseZone) {
    if (parseAsUTC === void 0) { parseAsUTC = false; }
    if (parseZone === void 0) { parseZone = false; }
    var input = args[0];
    var isSingleString = args.length === 1 && typeof input === 'string';
    var isAmbigTime;
    var isAmbigZone;
    var ambigMatch;
    var mom;
    if (moment.isMoment(input) || date_1.isNativeDate(input) || input === undefined) {
        mom = moment.apply(null, args);
    }
    else { // "parsing" is required
        isAmbigTime = false;
        isAmbigZone = false;
        if (isSingleString) {
            if (ambigDateOfMonthRegex.test(input)) {
                // accept strings like '2014-05', but convert to the first of the month
                input += '-01';
                args = [input]; // for when we pass it on to moment's constructor
                isAmbigTime = true;
                isAmbigZone = true;
            }
            else if ((ambigMatch = ambigTimeOrZoneRegex.exec(input))) {
                isAmbigTime = !ambigMatch[5]; // no time part?
                isAmbigZone = true;
            }
        }
        else if (Array.isArray(input)) {
            // arrays have no timezone information, so assume ambiguous zone
            isAmbigZone = true;
        }
        // otherwise, probably a string with a format
        if (parseAsUTC || isAmbigTime) {
            mom = moment.utc.apply(moment, args);
        }
        else {
            mom = moment.apply(null, args);
        }
        if (isAmbigTime) {
            mom._ambigTime = true;
            mom._ambigZone = true; // ambiguous time always means ambiguous zone
        }
        else if (parseZone) { // let's record the inputted zone somehow
            if (isAmbigZone) {
                mom._ambigZone = true;
            }
            else if (isSingleString) {
                mom.utcOffset(input); // if not a valid zone, will assign UTC
            }
        }
    }
    mom._fullCalendar = true; // flag for extended functionality
    return mom;
}
// Week Number
// -------------------------------------------------------------------------------------------------
// Returns the week number, considering the locale's custom week number calcuation
// `weeks` is an alias for `week`
newMomentProto.week = newMomentProto.weeks = function (input) {
    var weekCalc = this._locale._fullCalendar_weekCalc;
    if (input == null && typeof weekCalc === 'function') { // custom function only works for getter
        return weekCalc(this);
    }
    else if (weekCalc === 'ISO') {
        return oldMomentProto.isoWeek.apply(this, arguments); // ISO getter/setter
    }
    return oldMomentProto.week.apply(this, arguments); // local getter/setter
};
// Time-of-day
// -------------------------------------------------------------------------------------------------
// GETTER
// Returns a Duration with the hours/minutes/seconds/ms values of the moment.
// If the moment has an ambiguous time, a duration of 00:00 will be returned.
//
// SETTER
// You can supply a Duration, a Moment, or a Duration-like argument.
// When setting the time, and the moment has an ambiguous time, it then becomes unambiguous.
newMomentProto.time = function (time) {
    // Fallback to the original method (if there is one) if this moment wasn't created via FullCalendar.
    // `time` is a generic enough method name where this precaution is necessary to avoid collisions w/ other plugins.
    if (!this._fullCalendar) {
        return oldMomentProto.time.apply(this, arguments);
    }
    if (time == null) { // getter
        return moment.duration({
            hours: this.hours(),
            minutes: this.minutes(),
            seconds: this.seconds(),
            milliseconds: this.milliseconds()
        });
    }
    else { // setter
        this._ambigTime = false; // mark that the moment now has a time
        if (!moment.isDuration(time) && !moment.isMoment(time)) {
            time = moment.duration(time);
        }
        // The day value should cause overflow (so 24 hours becomes 00:00:00 of next day).
        // Only for Duration times, not Moment times.
        var dayHours = 0;
        if (moment.isDuration(time)) {
            dayHours = Math.floor(time.asDays()) * 24;
        }
        // We need to set the individual fields.
        // Can't use startOf('day') then add duration. In case of DST at start of day.
        return this.hours(dayHours + time.hours())
            .minutes(time.minutes())
            .seconds(time.seconds())
            .milliseconds(time.milliseconds());
    }
};
// Converts the moment to UTC, stripping out its time-of-day and timezone offset,
// but preserving its YMD. A moment with a stripped time will display no time
// nor timezone offset when .format() is called.
newMomentProto.stripTime = function () {
    if (!this._ambigTime) {
        this.utc(true); // keepLocalTime=true (for keeping *date* value)
        // set time to zero
        this.set({
            hours: 0,
            minutes: 0,
            seconds: 0,
            ms: 0
        });
        // Mark the time as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
        // which clears all ambig flags.
        this._ambigTime = true;
        this._ambigZone = true; // if ambiguous time, also ambiguous timezone offset
    }
    return this; // for chaining
};
// Returns if the moment has a non-ambiguous time (boolean)
newMomentProto.hasTime = function () {
    return !this._ambigTime;
};
// Timezone
// -------------------------------------------------------------------------------------------------
// Converts the moment to UTC, stripping out its timezone offset, but preserving its
// YMD and time-of-day. A moment with a stripped timezone offset will display no
// timezone offset when .format() is called.
newMomentProto.stripZone = function () {
    var wasAmbigTime;
    if (!this._ambigZone) {
        wasAmbigTime = this._ambigTime;
        this.utc(true); // keepLocalTime=true (for keeping date and time values)
        // the above call to .utc()/.utcOffset() unfortunately might clear the ambig flags, so restore
        this._ambigTime = wasAmbigTime || false;
        // Mark the zone as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
        // which clears the ambig flags.
        this._ambigZone = true;
    }
    return this; // for chaining
};
// Returns of the moment has a non-ambiguous timezone offset (boolean)
newMomentProto.hasZone = function () {
    return !this._ambigZone;
};
// implicitly marks a zone
newMomentProto.local = function (keepLocalTime) {
    // for when converting from ambiguously-zoned to local,
    // keep the time values when converting from UTC -> local
    oldMomentProto.local.call(this, this._ambigZone || keepLocalTime);
    // ensure non-ambiguous
    // this probably already happened via local() -> utcOffset(), but don't rely on Moment's internals
    this._ambigTime = false;
    this._ambigZone = false;
    return this; // for chaining
};
// implicitly marks a zone
newMomentProto.utc = function (keepLocalTime) {
    oldMomentProto.utc.call(this, keepLocalTime);
    // ensure non-ambiguous
    // this probably already happened via utc() -> utcOffset(), but don't rely on Moment's internals
    this._ambigTime = false;
    this._ambigZone = false;
    return this;
};
// implicitly marks a zone (will probably get called upon .utc() and .local())
newMomentProto.utcOffset = function (tzo) {
    if (tzo != null) { // setter
        // these assignments needs to happen before the original zone method is called.
        // I forget why, something to do with a browser crash.
        this._ambigTime = false;
        this._ambigZone = false;
    }
    return oldMomentProto.utcOffset.apply(this, arguments);
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/*
USAGE:
  import { default as EmitterMixin, EmitterInterface } from './EmitterMixin'
in class:
  on: EmitterInterface['on']
  one: EmitterInterface['one']
  off: EmitterInterface['off']
  trigger: EmitterInterface['trigger']
  triggerWith: EmitterInterface['triggerWith']
  hasHandlers: EmitterInterface['hasHandlers']
after class:
  EmitterMixin.mixInto(TheClass)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var misc_1 = __webpack_require__(4);
var Mixin_1 = __webpack_require__(18);
var EmitterMixin = /** @class */ (function (_super) {
    tslib_1.__extends(EmitterMixin, _super);
    function EmitterMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmitterMixin.prototype.on = function (type, handler) {
        addToHash(this._handlers || (this._handlers = {}), type, handler);
        return this; // for chaining
    };
    // todo: add comments
    EmitterMixin.prototype.one = function (type, handler) {
        addToHash(this._oneHandlers || (this._oneHandlers = {}), type, handler);
        return this; // for chaining
    };
    EmitterMixin.prototype.off = function (type, handler) {
        if (this._handlers) {
            removeFromHash(this._handlers, type, handler);
        }
        if (this._oneHandlers) {
            removeFromHash(this._oneHandlers, type, handler);
        }
        return this; // for chaining
    };
    EmitterMixin.prototype.trigger = function (type) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.triggerWith(type, this, args);
        return this; // for chaining
    };
    EmitterMixin.prototype.triggerWith = function (type, context, args) {
        if (this._handlers) {
            misc_1.applyAll(this._handlers[type], context, args);
        }
        if (this._oneHandlers) {
            misc_1.applyAll(this._oneHandlers[type], context, args);
            delete this._oneHandlers[type]; // will never fire again
        }
        return this; // for chaining
    };
    EmitterMixin.prototype.hasHandlers = function (type) {
        return (this._handlers && this._handlers[type] && this._handlers[type].length) ||
            (this._oneHandlers && this._oneHandlers[type] && this._oneHandlers[type].length);
    };
    return EmitterMixin;
}(Mixin_1.default));
exports.default = EmitterMixin;
function addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = []))
        .push(handler);
}
function removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) {
            hash[type] = hash[type].filter(function (func) {
                return func !== handler;
            });
        }
    }
    else {
        delete hash[type]; // remove all handler funcs for this type
    }
}


/***/ }),
/* 16 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
/*
Meant to be immutable
*/
var ComponentFootprint = /** @class */ (function () {
    function ComponentFootprint(unzonedRange, isAllDay) {
        this.isAllDay = false; // component can choose to ignore this
        this.unzonedRange = unzonedRange;
        this.isAllDay = isAllDay;
    }
    /*
    Only works for non-open-ended ranges.
    */
    ComponentFootprint.prototype.toLegacy = function (calendar) {
        return {
            start: calendar.msToMoment(this.unzonedRange.startMs, this.isAllDay),
            end: calendar.msToMoment(this.unzonedRange.endMs, this.isAllDay)
        };
    };
    return ComponentFootprint;
}());
exports.default = ComponentFootprint;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var EventDef_1 = __webpack_require__(39);
var EventInstance_1 = __webpack_require__(217);
var EventDateProfile_1 = __webpack_require__(22);
var SingleEventDef = /** @class */ (function (_super) {
    tslib_1.__extends(SingleEventDef, _super);
    function SingleEventDef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
    Will receive start/end params, but will be ignored.
    */
    SingleEventDef.prototype.buildInstances = function () {
        return [this.buildInstance()];
    };
    SingleEventDef.prototype.buildInstance = function () {
        return new EventInstance_1.default(this, // definition
        this.dateProfile);
    };
    SingleEventDef.prototype.isAllDay = function () {
        return this.dateProfile.isAllDay();
    };
    SingleEventDef.prototype.clone = function () {
        var def = _super.prototype.clone.call(this);
        def.dateProfile = this.dateProfile;
        return def;
    };
    SingleEventDef.prototype.rezone = function () {
        var calendar = this.source.calendar;
        var dateProfile = this.dateProfile;
        this.dateProfile = new EventDateProfile_1.default(calendar.moment(dateProfile.start), dateProfile.end ? calendar.moment(dateProfile.end) : null, calendar);
    };
    /*
    NOTE: if super-method fails, should still attempt to apply
    */
    SingleEventDef.prototype.applyManualStandardProps = function (rawProps) {
        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
        var dateProfile = EventDateProfile_1.default.parse(rawProps, this.source); // returns null on failure
        if (dateProfile) {
            this.dateProfile = dateProfile;
            // make sure `date` shows up in the legacy event objects as-is
            if (rawProps.date != null) {
                this.miscProps.date = rawProps.date;
            }
            return superSuccess;
        }
        else {
            return false;
        }
    };
    return SingleEventDef;
}(EventDef_1.default));
exports.default = SingleEventDef;
// Parsing
// ---------------------------------------------------------------------------------------------------------------------
SingleEventDef.defineStandardProps({
    start: false,
    date: false,
    end: false,
    allDay: false
});


/***/ }),
/* 18 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Mixin = /** @class */ (function () {
    function Mixin() {
    }
    // mix into a CLASS
    Mixin.mixInto = function (destClass) {
        this.mixIntoObj(destClass.prototype);
    };
    // mix into ANY object
    Mixin.mixIntoObj = function (destObj) {
        var _this = this;
        Object.getOwnPropertyNames(this.prototype).forEach(function (name) {
            if (!destObj[name]) { // if destination doesn't already define it
                destObj[name] = _this.prototype[name];
            }
        });
    };
    /*
    will override existing methods
    TODO: remove! not used anymore
    */
    Mixin.mixOver = function (destClass) {
        var _this = this;
        Object.getOwnPropertyNames(this.prototype).forEach(function (name) {
            destClass.prototype[name] = _this.prototype[name];
        });
    };
    return Mixin;
}());
exports.default = Mixin;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Interaction = /** @class */ (function () {
    function Interaction(component) {
        this.view = component._getView();
        this.component = component;
    }
    Interaction.prototype.opt = function (name) {
        return this.view.opt(name);
    };
    Interaction.prototype.end = function () {
        // subclasses can implement
    };
    return Interaction;
}());
exports.default = Interaction;


/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
function removeMatching(array, testFunc) {
    var removeCnt = 0;
    var i = 0;
    while (i < array.length) {
        if (testFunc(array[i])) { // truthy value means *remove*
            array.splice(i, 1);
            removeCnt++;
        }
        else {
            i++;
        }
    }
    return removeCnt;
}
exports.removeMatching = removeMatching;
function removeExact(array, exactVal) {
    var removeCnt = 0;
    var i = 0;
    while (i < array.length) {
        if (array[i] === exactVal) {
            array.splice(i, 1);
            removeCnt++;
        }
        else {
            i++;
        }
    }
    return removeCnt;
}
exports.removeExact = removeExact;
function isArraysEqual(a0, a1) {
    var len = a0.length;
    var i;
    if (len == null || len !== a1.length) { // not array? or not same length?
        return false;
    }
    for (i = 0; i < len; i++) {
        if (a0[i] !== a1[i]) {
            return false;
        }
    }
    return true;
}
exports.isArraysEqual = isArraysEqual;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var UnzonedRange_1 = __webpack_require__(7);
/*
Meant to be immutable
*/
var EventDateProfile = /** @class */ (function () {
    function EventDateProfile(start, end, calendar) {
        this.start = start;
        this.end = end || null;
        this.unzonedRange = this.buildUnzonedRange(calendar);
    }
    /*
    Needs an EventSource object
    */
    EventDateProfile.parse = function (rawProps, source) {
        var startInput = rawProps.start || rawProps.date;
        var endInput = rawProps.end;
        if (!startInput) {
            return false;
        }
        var calendar = source.calendar;
        var start = calendar.moment(startInput);
        var end = endInput ? calendar.moment(endInput) : null;
        var forcedAllDay = rawProps.allDay;
        var forceEventDuration = calendar.opt('forceEventDuration');
        if (!start.isValid()) {
            return false;
        }
        if (end && (!end.isValid() || !end.isAfter(start))) {
            end = null;
        }
        if (forcedAllDay == null) {
            forcedAllDay = source.allDayDefault;
            if (forcedAllDay == null) {
                forcedAllDay = calendar.opt('allDayDefault');
            }
        }
        if (forcedAllDay === true) {
            start.stripTime();
            if (end) {
                end.stripTime();
            }
        }
        else if (forcedAllDay === false) {
            if (!start.hasTime()) {
                start.time(0);
            }
            if (end && !end.hasTime()) {
                end.time(0);
            }
        }
        if (!end && forceEventDuration) {
            end = calendar.getDefaultEventEnd(!start.hasTime(), start);
        }
        return new EventDateProfile(start, end, calendar);
    };
    EventDateProfile.isStandardProp = function (propName) {
        return propName === 'start' || propName === 'date' || propName === 'end' || propName === 'allDay';
    };
    EventDateProfile.prototype.isAllDay = function () {
        return !(this.start.hasTime() || (this.end && this.end.hasTime()));
    };
    /*
    Needs a Calendar object
    */
    EventDateProfile.prototype.buildUnzonedRange = function (calendar) {
        var startMs = this.start.clone().stripZone().valueOf();
        var endMs = this.getEnd(calendar).stripZone().valueOf();
        return new UnzonedRange_1.default(startMs, endMs);
    };
    /*
    Needs a Calendar object
    */
    EventDateProfile.prototype.getEnd = function (calendar) {
        return this.end ?
            this.end.clone() :
            // derive the end from the start and allDay. compute allDay if necessary
            calendar.getDefaultEventEnd(this.isAllDay(), this.start);
    };
    return EventDateProfile;
}());
exports.default = EventDateProfile;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var UnzonedRange_1 = __webpack_require__(7);
var util_1 = __webpack_require__(40);
var EventRange_1 = __webpack_require__(219);
/*
It's expected that there will be at least one EventInstance,
OR that an explicitEventDef is assigned.
*/
var EventInstanceGroup = /** @class */ (function () {
    function EventInstanceGroup(eventInstances) {
        this.eventInstances = eventInstances || [];
    }
    EventInstanceGroup.prototype.getAllEventRanges = function (constraintRange) {
        if (constraintRange) {
            return this.sliceNormalRenderRanges(constraintRange);
        }
        else {
            return this.eventInstances.map(util_1.eventInstanceToEventRange);
        }
    };
    EventInstanceGroup.prototype.sliceRenderRanges = function (constraintRange) {
        if (this.isInverse()) {
            return this.sliceInverseRenderRanges(constraintRange);
        }
        else {
            return this.sliceNormalRenderRanges(constraintRange);
        }
    };
    EventInstanceGroup.prototype.sliceNormalRenderRanges = function (constraintRange) {
        var eventInstances = this.eventInstances;
        var i;
        var eventInstance;
        var slicedRange;
        var slicedEventRanges = [];
        for (i = 0; i < eventInstances.length; i++) {
            eventInstance = eventInstances[i];
            slicedRange = eventInstance.dateProfile.unzonedRange.intersect(constraintRange);
            if (slicedRange) {
                slicedEventRanges.push(new EventRange_1.default(slicedRange, eventInstance.def, eventInstance));
            }
        }
        return slicedEventRanges;
    };
    EventInstanceGroup.prototype.sliceInverseRenderRanges = function (constraintRange) {
        var unzonedRanges = this.eventInstances.map(util_1.eventInstanceToUnzonedRange);
        var ownerDef = this.getEventDef();
        unzonedRanges = UnzonedRange_1.default.invertRanges(unzonedRanges, constraintRange);
        return unzonedRanges.map(function (unzonedRange) {
            return new EventRange_1.default(unzonedRange, ownerDef); // don't give an EventInstance
        });
    };
    EventInstanceGroup.prototype.isInverse = function () {
        return this.getEventDef().hasInverseRendering();
    };
    EventInstanceGroup.prototype.getEventDef = function () {
        return this.explicitEventDef || this.eventInstances[0].def;
    };
    return EventInstanceGroup;
}());
exports.default = EventInstanceGroup;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = __webpack_require__(5);
var Theme = /** @class */ (function () {
    function Theme(optionsManager) {
        this.optionsManager = optionsManager;
        this.processIconOverride();
    }
    Theme.prototype.processIconOverride = function () {
        if (this.iconOverrideOption) {
            this.setIconOverride(this.optionsManager.get(this.iconOverrideOption));
        }
    };
    Theme.prototype.setIconOverride = function (iconOverrideHash) {
        var iconClassesCopy;
        var buttonName;
        if (typeof iconOverrideHash === 'object' && iconOverrideHash) { // non-null object
            iconClassesCopy = object_1.assignTo({}, this.iconClasses);
            for (buttonName in iconOverrideHash) {
                iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            }
            this.iconClasses = iconClassesCopy;
        }
        else if (iconOverrideHash === false) {
            this.iconClasses = {};
        }
    };
    Theme.prototype.applyIconOverridePrefix = function (className) {
        var prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) { // if not already present
            className = prefix + className;
        }
        return className;
    };
    Theme.prototype.getClass = function (key) {
        return this.classes[key] || '';
    };
    Theme.prototype.getIconClass = function (buttonName) {
        var className = this.iconClasses[buttonName];
        if (className) {
            return this.baseIconClass + ' ' + className;
        }
        return '';
    };
    Theme.prototype.getCustomButtonIconClass = function (customButtonProps) {
        var className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) {
                return this.baseIconClass + ' ' + this.applyIconOverridePrefix(className);
            }
        }
        return '';
    };
    return Theme;
}());
exports.default = Theme;
Theme.prototype.classes = {};
Theme.prototype.iconClasses = {};
Theme.prototype.baseIconClass = '';
Theme.prototype.iconOverridePrefix = '';


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var exportHooks = __webpack_require__(35);
var EmitterMixin_1 = __webpack_require__(15);
var ListenerMixin_1 = __webpack_require__(12);
exportHooks.touchMouseIgnoreWait = 500;
var globalEmitter = null;
var neededCount = 0;
/*
Listens to document and window-level user-interaction events, like touch events and mouse events,
and fires these events as-is to whoever is observing a GlobalEmitter.
Best when used as a singleton via GlobalEmitter.get()

Normalizes mouse/touch events. For examples:
- ignores the the simulated mouse events that happen after a quick tap: mousemove+mousedown+mouseup+click
- compensates for various buggy scenarios where a touchend does not fire
*/
var GlobalEmitter = /** @class */ (function () {
    function GlobalEmitter() {
        var _this = this;
        this.isTouching = false;
        this.mouseIgnoreDepth = 0;
        this.handleTouchMove = function (ev) {
            if (_this.isTouching) {
                _this.trigger('touchmove', ev);
            }
        };
        this.handleScroll = function (ev) {
            _this.trigger('scroll', ev);
        };
    }
    // gets the singleton
    GlobalEmitter.get = function () {
        if (!globalEmitter) {
            globalEmitter = new GlobalEmitter();
            globalEmitter.bind();
        }
        return globalEmitter;
    };
    // called when an object knows it will need a GlobalEmitter in the near future.
    GlobalEmitter.needed = function () {
        GlobalEmitter.get(); // ensures globalEmitter
        neededCount++;
    };
    // called when the object that originally called needed() doesn't need a GlobalEmitter anymore.
    GlobalEmitter.unneeded = function () {
        if (neededCount > 0) {
            neededCount--;
            if (!neededCount) { // nobody else needs it
                globalEmitter.unbind();
                globalEmitter = null;
            }
        }
    };
    GlobalEmitter.prototype.bind = function () {
        this.listenTo(document, {
            touchstart: this.handleTouchStart,
            touchcancel: this.handleTouchCancel,
            touchend: this.handleTouchEnd,
            mousedown: this.handleMouseDown,
            mousemove: this.handleMouseMove,
            mouseup: this.handleMouseUp,
            click: this.handleClick,
            selectstart: this.handleSelectStart,
            contextmenu: this.handleContextMenu
        });
        // because we need to call preventDefault
        // because https://www.chromestatus.com/features/5093566007214080
        // TODO: investigate performance because this is a global handler
        window.addEventListener('touchmove', this.handleTouchMove, // always bound to `this`
        { passive: false } // allows preventDefault()
        );
        // attach a handler to get called when ANY scroll action happens on the page.
        // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
        // http://stackoverflow.com/a/32954565/96342
        window.addEventListener('scroll', this.handleScroll, // always bound to `this`
        true // useCapture
        );
    };
    GlobalEmitter.prototype.unbind = function () {
        this.stopListeningTo(document);
        window.removeEventListener('touchmove', this.handleTouchMove);
        window.removeEventListener('scroll', this.handleScroll, true // useCapture
        );
    };
    // Touch Handlers
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.handleTouchStart = function (ev) {
        // if a previous touch interaction never ended with a touchend, then implicitly end it,
        // but since a new touch interaction is about to begin, don't start the mouse ignore period.
        this.stopTouch(ev, true); // skipMouseIgnore=true
        this.isTouching = true;
        this.trigger('touchstart', ev);
    };
    GlobalEmitter.prototype.handleTouchCancel = function (ev) {
        if (this.isTouching) {
            this.trigger('touchcancel', ev);
            // Have touchcancel fire an artificial touchend. That way, handlers won't need to listen to both.
            // If touchend fires later, it won't have any effect b/c isTouching will be false.
            this.stopTouch(ev);
        }
    };
    GlobalEmitter.prototype.handleTouchEnd = function (ev) {
        this.stopTouch(ev);
    };
    // Mouse Handlers
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.handleMouseDown = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('mousedown', ev);
        }
    };
    GlobalEmitter.prototype.handleMouseMove = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('mousemove', ev);
        }
    };
    GlobalEmitter.prototype.handleMouseUp = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('mouseup', ev);
        }
    };
    GlobalEmitter.prototype.handleClick = function (ev) {
        if (!this.shouldIgnoreMouse()) {
            this.trigger('click', ev);
        }
    };
    // Misc Handlers
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.handleSelectStart = function (ev) {
        this.trigger('selectstart', ev);
    };
    GlobalEmitter.prototype.handleContextMenu = function (ev) {
        this.trigger('contextmenu', ev);
    };
    // Utils
    // -----------------------------------------------------------------------------------------------------------------
    GlobalEmitter.prototype.stopTouch = function (ev, skipMouseIgnore) {
        if (skipMouseIgnore === void 0) { skipMouseIgnore = false; }
        if (this.isTouching) {
            this.isTouching = false;
            this.trigger('touchend', ev);
            if (!skipMouseIgnore) {
                this.startTouchMouseIgnore();
            }
        }
    };
    GlobalEmitter.prototype.startTouchMouseIgnore = function () {
        var _this = this;
        var wait = exportHooks.touchMouseIgnoreWait;
        if (wait) {
            this.mouseIgnoreDepth++;
            setTimeout(function () {
                _this.mouseIgnoreDepth--;
            }, wait);
        }
    };
    GlobalEmitter.prototype.shouldIgnoreMouse = function () {
        return this.isTouching || Boolean(this.mouseIgnoreDepth);
    };
    return GlobalEmitter;
}());
exports.default = GlobalEmitter;
ListenerMixin_1.default.mixInto(GlobalEmitter);
EmitterMixin_1.default.mixInto(GlobalEmitter);


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var exportHooks = __webpack_require__(35);
exports.viewHash = {};
exportHooks.views = exports.viewHash;
function defineView(viewName, viewConfig) {
    exports.viewHash[viewName] = viewConfig;
}
exports.defineView = defineView;
function getViewConfig(viewName) {
    return exports.viewHash[viewName];
}
exports.getViewConfig = getViewConfig;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var geom_1 = __webpack_require__(214);
var dom_event_1 = __webpack_require__(10);
var DragListener_1 = __webpack_require__(60);
/* Tracks mouse movements over a component and raises events about which hit the mouse is over.
------------------------------------------------------------------------------------------------------------------------
*/
var HitDragListener = /** @class */ (function (_super) {
    tslib_1.__extends(HitDragListener, _super);
    function HitDragListener(component, options) {
        var _this = _super.call(this, options) || this;
        _this.component = component;
        return _this;
    }
    // Called when drag listening starts (but a real drag has not necessarily began).
    // ev might be undefined if dragging was started manually.
    HitDragListener.prototype.handleInteractionStart = function (ev) {
        var subjectEl = this.subjectEl;
        var subjectRect;
        var origPoint;
        var point;
        this.component.hitsNeeded();
        this.computeScrollBounds(); // for autoscroll
        if (ev) {
            origPoint = { left: dom_event_1.getEvX(ev), top: dom_event_1.getEvY(ev) };
            point = origPoint;
            // constrain the point to bounds of the element being dragged
            if (subjectEl) {
                subjectRect = subjectEl.getBoundingClientRect(); // used for centering as well
                point = geom_1.constrainPoint(point, subjectRect);
            }
            this.origHit = this.queryHit(point.left, point.top);
            // treat the center of the subject as the collision point?
            if (subjectEl && this.options.subjectCenter) {
                // only consider the area the subject overlaps the hit. best for large subjects.
                // TODO: skip this if hit didn't supply left/right/top/bottom
                if (this.origHit) {
                    subjectRect = geom_1.intersectRects(this.origHit, subjectRect) ||
                        subjectRect; // in case there is no intersection
                }
                point = geom_1.getRectCenter(subjectRect);
            }
            this.coordAdjust = geom_1.diffPoints(point, origPoint); // point - origPoint
        }
        else {
            this.origHit = null;
            this.coordAdjust = null;
        }
        // call the super-method. do it after origHit has been computed
        _super.prototype.handleInteractionStart.call(this, ev);
    };
    // Called when the actual drag has started
    HitDragListener.prototype.handleDragStart = function (ev) {
        var hit;
        _super.prototype.handleDragStart.call(this, ev);
        // might be different from this.origHit if the min-distance is large
        hit = this.queryHit(dom_event_1.getEvX(ev), dom_event_1.getEvY(ev));
        // report the initial hit the mouse is over
        // especially important if no min-distance and drag starts immediately
        if (hit) {
            this.handleHitOver(hit);
        }
    };
    // Called when the drag moves
    HitDragListener.prototype.handleDrag = function (dx, dy, ev) {
        var hit;
        _super.prototype.handleDrag.call(this, dx, dy, ev);
        hit = this.queryHit(dom_event_1.getEvX(ev), dom_event_1.getEvY(ev));
        if (!isHitsEqual(hit, this.hit)) { // a different hit than before?
            if (this.hit) {
                this.handleHitOut();
            }
            if (hit) {
                this.handleHitOver(hit);
            }
        }
    };
    // Called when dragging has been stopped
    HitDragListener.prototype.handleDragEnd = function (ev) {
        this.handleHitDone();
        _super.prototype.handleDragEnd.call(this, ev);
    };
    // Called when a the mouse has just moved over a new hit
    HitDragListener.prototype.handleHitOver = function (hit) {
        var isOrig = isHitsEqual(hit, this.origHit);
        this.hit = hit;
        this.trigger('hitOver', this.hit, isOrig, this.origHit);
    };
    // Called when the mouse has just moved out of a hit
    HitDragListener.prototype.handleHitOut = function () {
        if (this.hit) {
            this.trigger('hitOut', this.hit);
            this.handleHitDone();
            this.hit = null;
        }
    };
    // Called after a hitOut. Also called before a dragStop
    HitDragListener.prototype.handleHitDone = function () {
        if (this.hit) {
            this.trigger('hitDone', this.hit);
        }
    };
    // Called when the interaction ends, whether there was a real drag or not
    HitDragListener.prototype.handleInteractionEnd = function (ev, isCancelled) {
        _super.prototype.handleInteractionEnd.call(this, ev, isCancelled);
        this.origHit = null;
        this.hit = null;
        this.component.hitsNotNeeded();
    };
    // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
    HitDragListener.prototype.handleScrollEnd = function () {
        _super.prototype.handleScrollEnd.call(this);
        // hits' absolute positions will be in new places after a user's scroll.
        // HACK for recomputing.
        if (this.isDragging) {
            this.component.releaseHits();
            this.component.prepareHits();
        }
    };
    // Gets the hit underneath the coordinates for the given mouse event
    HitDragListener.prototype.queryHit = function (left, top) {
        if (this.coordAdjust) {
            left += this.coordAdjust.left;
            top += this.coordAdjust.top;
        }
        return this.component.queryHit(left, top);
    };
    return HitDragListener;
}(DragListener_1.default));
exports.default = HitDragListener;
// Returns `true` if the hits are identically equal. `false` otherwise. Must be from the same component.
// Two null values will be considered equal, as two "out of the component" states are the same.
function isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) {
        return true;
    }
    if (hit0 && hit1) {
        return hit0.component === hit1.component &&
            isHitPropsWithin(hit0, hit1) &&
            isHitPropsWithin(hit1, hit0); // ensures all props are identical
    }
    return false;
}
// Returns true if all of subHit's non-standard properties are within superHit
function isHitPropsWithin(subHit, superHit) {
    for (var propName in subHit) {
        if (!/^(component|left|right|top|bottom)$/.test(propName)) {
            if (subHit[propName] !== superHit[propName]) {
                return false;
            }
        }
    }
    return true;
}


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
exports.version = '4.0.0-alpha';
// When introducing internal API incompatibilities (where fullcalendar plugins would break),
// the minor version of the calendar should be upped (ex: 2.7.2 -> 2.8.0)
// and the below integer should be incremented.
exports.internalApiVersion = 12;
var misc_1 = __webpack_require__(4);
exports.applyAll = misc_1.applyAll;
exports.debounce = misc_1.debounce;
exports.isInt = misc_1.isInt;
exports.capitaliseFirstLetter = misc_1.capitaliseFirstLetter;
exports.parseFieldSpecs = misc_1.parseFieldSpecs;
exports.compareByFieldSpecs = misc_1.compareByFieldSpecs;
exports.compareByFieldSpec = misc_1.compareByFieldSpec;
exports.flexibleCompare = misc_1.flexibleCompare;
exports.log = misc_1.log;
exports.warn = misc_1.warn;
var html_1 = __webpack_require__(6);
exports.htmlEscape = html_1.htmlEscape;
exports.cssToStr = html_1.cssToStr;
var array_1 = __webpack_require__(21);
exports.removeExact = array_1.removeExact;
var geom_1 = __webpack_require__(214);
exports.intersectRects = geom_1.intersectRects;
var object_1 = __webpack_require__(5);
exports.assignTo = object_1.assignTo;
var date_1 = __webpack_require__(8);
exports.computeGreatestUnit = date_1.computeGreatestUnit;
exports.divideRangeByDuration = date_1.divideRangeByDuration;
exports.divideDurationByDuration = date_1.divideDurationByDuration;
exports.multiplyDuration = date_1.multiplyDuration;
exports.durationHasTime = date_1.durationHasTime;
var dom_manip_1 = __webpack_require__(3);
exports.findElements = dom_manip_1.findElements;
exports.findChildren = dom_manip_1.findChildren;
exports.htmlToElement = dom_manip_1.htmlToElement;
exports.createElement = dom_manip_1.createElement;
exports.insertAfterElement = dom_manip_1.insertAfterElement;
exports.prependToElement = dom_manip_1.prependToElement;
exports.removeElement = dom_manip_1.removeElement;
exports.appendToElement = dom_manip_1.appendToElement;
exports.applyStyle = dom_manip_1.applyStyle;
exports.applyStyleProp = dom_manip_1.applyStyleProp;
exports.elementMatches = dom_manip_1.elementMatches;
exports.forceClassName = dom_manip_1.forceClassName;
var dom_event_1 = __webpack_require__(10);
exports.preventDefault = dom_event_1.preventDefault;
exports.listenBySelector = dom_event_1.listenBySelector;
exports.whenTransitionDone = dom_event_1.whenTransitionDone;
var dom_geom_1 = __webpack_require__(13);
exports.computeInnerRect = dom_geom_1.computeInnerRect;
exports.computeEdges = dom_geom_1.computeEdges;
exports.computeHeightAndMargins = dom_geom_1.computeHeightAndMargins;
var date_formatting_1 = __webpack_require__(52);
exports.formatDate = date_formatting_1.formatDate;
exports.formatRange = date_formatting_1.formatRange;
exports.queryMostGranularFormatUnit = date_formatting_1.queryMostGranularFormatUnit;
var locale_1 = __webpack_require__(36);
exports.datepickerLocale = locale_1.datepickerLocale;
exports.locale = locale_1.locale;
var moment_ext_1 = __webpack_require__(14);
exports.moment = moment_ext_1.default;
var EmitterMixin_1 = __webpack_require__(15);
exports.EmitterMixin = EmitterMixin_1.default;
var ListenerMixin_1 = __webpack_require__(12);
exports.ListenerMixin = ListenerMixin_1.default;
var Model_1 = __webpack_require__(53);
exports.Model = Model_1.default;
var Constraints_1 = __webpack_require__(215);
exports.Constraints = Constraints_1.default;
var UnzonedRange_1 = __webpack_require__(7);
exports.UnzonedRange = UnzonedRange_1.default;
var ComponentFootprint_1 = __webpack_require__(16);
exports.ComponentFootprint = ComponentFootprint_1.default;
var BusinessHourGenerator_1 = __webpack_require__(220);
exports.BusinessHourGenerator = BusinessHourGenerator_1.default;
var EventDef_1 = __webpack_require__(39);
exports.EventDef = EventDef_1.default;
var EventDefMutation_1 = __webpack_require__(42);
exports.EventDefMutation = EventDefMutation_1.default;
var EventSourceParser_1 = __webpack_require__(43);
exports.EventSourceParser = EventSourceParser_1.default;
var EventSource_1 = __webpack_require__(9);
exports.EventSource = EventSource_1.default;
var ThemeRegistry_1 = __webpack_require__(56);
exports.defineThemeSystem = ThemeRegistry_1.defineThemeSystem;
var EventInstanceGroup_1 = __webpack_require__(23);
exports.EventInstanceGroup = EventInstanceGroup_1.default;
var ArrayEventSource_1 = __webpack_require__(57);
exports.ArrayEventSource = ArrayEventSource_1.default;
var FuncEventSource_1 = __webpack_require__(223);
exports.FuncEventSource = FuncEventSource_1.default;
var JsonFeedEventSource_1 = __webpack_require__(224);
exports.JsonFeedEventSource = JsonFeedEventSource_1.default;
var EventFootprint_1 = __webpack_require__(41);
exports.EventFootprint = EventFootprint_1.default;
var Class_1 = __webpack_require__(38);
exports.Class = Class_1.default;
var Mixin_1 = __webpack_require__(18);
exports.Mixin = Mixin_1.default;
var CoordCache_1 = __webpack_require__(59);
exports.CoordCache = CoordCache_1.default;
var DragListener_1 = __webpack_require__(60);
exports.DragListener = DragListener_1.default;
var TaskQueue_1 = __webpack_require__(225);
exports.TaskQueue = TaskQueue_1.default;
var RenderQueue_1 = __webpack_require__(226);
exports.RenderQueue = RenderQueue_1.default;
var Scroller_1 = __webpack_require__(44);
exports.Scroller = Scroller_1.default;
var Theme_1 = __webpack_require__(24);
exports.Theme = Theme_1.default;
var DateComponent_1 = __webpack_require__(227);
exports.DateComponent = DateComponent_1.default;
var InteractiveDateComponent_1 = __webpack_require__(45);
exports.InteractiveDateComponent = InteractiveDateComponent_1.default;
var Calendar_1 = __webpack_require__(246);
exports.Calendar = Calendar_1.default;
var View_1 = __webpack_require__(46);
exports.View = View_1.default;
var ViewRegistry_1 = __webpack_require__(26);
exports.defineView = ViewRegistry_1.defineView;
exports.getViewConfig = ViewRegistry_1.getViewConfig;
var DayTableMixin_1 = __webpack_require__(61);
exports.DayTableMixin = DayTableMixin_1.default;
var BusinessHourRenderer_1 = __webpack_require__(62);
exports.BusinessHourRenderer = BusinessHourRenderer_1.default;
var EventRenderer_1 = __webpack_require__(47);
exports.EventRenderer = EventRenderer_1.default;
var FillRenderer_1 = __webpack_require__(63);
exports.FillRenderer = FillRenderer_1.default;
var HelperRenderer_1 = __webpack_require__(64);
exports.HelperRenderer = HelperRenderer_1.default;
var ExternalDropping_1 = __webpack_require__(229);
exports.ExternalDropping = ExternalDropping_1.default;
var EventResizing_1 = __webpack_require__(230);
exports.EventResizing = EventResizing_1.default;
var EventPointing_1 = __webpack_require__(65);
exports.EventPointing = EventPointing_1.default;
var EventDragging_1 = __webpack_require__(231);
exports.EventDragging = EventDragging_1.default;
var DateSelecting_1 = __webpack_require__(232);
exports.DateSelecting = DateSelecting_1.default;
var StandardInteractionsMixin_1 = __webpack_require__(66);
exports.StandardInteractionsMixin = StandardInteractionsMixin_1.default;
var AgendaView_1 = __webpack_require__(233);
exports.AgendaView = AgendaView_1.default;
var TimeGrid_1 = __webpack_require__(234);
exports.TimeGrid = TimeGrid_1.default;
var DayGrid_1 = __webpack_require__(67);
exports.DayGrid = DayGrid_1.default;
var BasicView_1 = __webpack_require__(68);
exports.BasicView = BasicView_1.default;
var MonthView_1 = __webpack_require__(236);
exports.MonthView = MonthView_1.default;
var ListView_1 = __webpack_require__(237);
exports.ListView = ListView_1.default;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var exportHooks = __webpack_require__(35);
var options_1 = __webpack_require__(37);
var html_1 = __webpack_require__(6);
exports.localeOptionHash = {};
exportHooks.locales = exports.localeOptionHash;
// NOTE: can't guarantee any of these computations will run because not every locale has datepicker
// configs, so make sure there are English fallbacks for these in the defaults file.
var dpComputableOptions = {
    buttonText: function (dpOptions) {
        return {
            // the translations sometimes wrongly contain HTML entities
            prev: html_1.stripHtmlEntities(dpOptions.prevText),
            next: html_1.stripHtmlEntities(dpOptions.nextText),
            today: html_1.stripHtmlEntities(dpOptions.currentText)
        };
    },
    // Produces format strings like "MMMM YYYY" -> "September 2014"
    monthYearFormat: function (dpOptions) {
        return dpOptions.showMonthAfterYear ?
            'YYYY[' + dpOptions.yearSuffix + '] MMMM' :
            'MMMM YYYY[' + dpOptions.yearSuffix + ']';
    }
};
var momComputableOptions = {
    // Produces format strings like "ddd M/D" -> "Fri 9/15"
    dayOfMonthFormat: function (momOptions, fcOptions) {
        var format = momOptions.longDateFormat('l'); // for the format like "M/D/YYYY"
        // strip the year off the edge, as well as other misc non-whitespace chars
        format = format.replace(/^Y+[^\w\s]*|[^\w\s]*Y+$/g, '');
        if (fcOptions.isRTL) {
            format += ' ddd'; // for RTL, add day-of-week to end
        }
        else {
            format = 'ddd ' + format; // for LTR, add day-of-week to beginning
        }
        return format;
    },
    // Produces format strings like "h:mma" -> "6:00pm"
    mediumTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h(:mm)a" -> "6pm" / "6:30pm"
    smallTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(':mm', '(:mm)')
            .replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h(:mm)t" -> "6p" / "6:30p"
    extraSmallTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(':mm', '(:mm)')
            .replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
            .replace(/\s*a$/i, 't'); // convert to AM/PM/am/pm to lowercase one-letter. remove any spaces beforehand
    },
    // Produces format strings like "ha" / "H" -> "6pm" / "18"
    hourFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(':mm', '')
            .replace(/(\Wmm)$/, '') // like above, but for foreign locales
            .replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
    },
    // Produces format strings like "h:mm" -> "6:30" (with no AM/PM)
    noMeridiemTimeFormat: function (momOptions) {
        return momOptions.longDateFormat('LT')
            .replace(/\s*a$/i, ''); // remove trailing AM/PM
    }
};
// options that should be computed off live calendar options (considers override options)
// TODO: best place for this? related to locale?
// TODO: flipping text based on isRTL is a bad idea because the CSS `direction` might want to handle it
var instanceComputableOptions = {
    // Produces format strings for results like "Mo 16"
    smallDayDateFormat: function (options) {
        return options.isRTL ?
            'D dd' :
            'dd D';
    },
    // Produces format strings for results like "Wk 5"
    weekFormat: function (options) {
        return options.isRTL ?
            'w[ ' + options.weekNumberTitle + ']' :
            '[' + options.weekNumberTitle + ' ]w';
    },
    // Produces format strings for results like "Wk5"
    smallWeekFormat: function (options) {
        return options.isRTL ?
            'w[' + options.weekNumberTitle + ']' :
            '[' + options.weekNumberTitle + ']w';
    }
};
// TODO: make these computable properties in optionsManager
function populateInstanceComputableOptions(options) {
    for (var name_1 in instanceComputableOptions) {
        var func = instanceComputableOptions[name_1];
        if (options[name_1] == null) {
            options[name_1] = func(options);
        }
    }
}
exports.populateInstanceComputableOptions = populateInstanceComputableOptions;
// Initialize jQuery UI datepicker translations while using some of the translations
// Will set this as the default locales for datepicker.
function datepickerLocale(localeCode, dpLocaleCode, dpOptions) {
    // get the FullCalendar internal option hash for this locale. create if necessary
    var fcOptions = exports.localeOptionHash[localeCode] || (exports.localeOptionHash[localeCode] = {});
    // transfer some simple options from datepicker to fc
    fcOptions.isRTL = dpOptions.isRTL;
    fcOptions.weekNumberTitle = dpOptions.weekHeader;
    // compute some more complex options from datepicker
    for (var name_2 in dpComputableOptions) {
        var func = dpComputableOptions[name_2];
        fcOptions[name_2] = func(dpOptions);
    }
    var jqDatePicker = window['jQuery'] && window['jQuery'].datepicker;
    // is jQuery UI Datepicker is on the page?
    if (jqDatePicker) {
        // Register the locale data.
        // FullCalendar and MomentJS use locale codes like "pt-br" but Datepicker
        // does it like "pt-BR" or if it doesn't have the locale, maybe just "pt".
        // Make an alias so the locale can be referenced either way.
        jqDatePicker.regional[dpLocaleCode] =
            jqDatePicker.regional[localeCode] = // alias
                dpOptions;
        // Alias 'en' to the default locale data. Do this every time.
        jqDatePicker.regional.en = jqDatePicker.regional[''];
        // Set as Datepicker's global defaults.
        jqDatePicker.setDefaults(dpOptions);
    }
}
exports.datepickerLocale = datepickerLocale;
// Sets FullCalendar-specific translations. Will set the locales as the global default.
function locale(localeCode, newFcOptions) {
    var fcOptions;
    var momOptions;
    // get the FullCalendar internal option hash for this locale. create if necessary
    fcOptions = exports.localeOptionHash[localeCode] || (exports.localeOptionHash[localeCode] = {});
    // provided new options for this locales? merge them in
    if (newFcOptions) {
        fcOptions = exports.localeOptionHash[localeCode] = options_1.mergeOptions([fcOptions, newFcOptions]);
    }
    // compute locale options that weren't defined.
    // always do this. newFcOptions can be undefined when initializing from i18n file,
    // so no way to tell if this is an initialization or a default-setting.
    momOptions = getMomentLocaleData(localeCode); // will fall back to en
    for (var name_3 in momComputableOptions) {
        var func = momComputableOptions[name_3];
        if (fcOptions[name_3] == null) {
            fcOptions[name_3] = (func)(momOptions, fcOptions);
        }
    }
    // set it as the default locale for FullCalendar
    options_1.globalDefaults.locale = localeCode;
}
exports.locale = locale;
// Returns moment's internal locale data. If doesn't exist, returns English.
function getMomentLocaleData(localeCode) {
    return moment.localeData(localeCode) || moment.localeData('en');
}
exports.getMomentLocaleData = getMomentLocaleData;
// Initialize English by forcing computation of moment-derived options.
// Also, sets it as the default.
locale('en', options_1.englishDefaults);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = __webpack_require__(5);
exports.globalDefaults = {
    titleRangeSeparator: ' \u2013 ',
    monthYearFormat: 'MMMM YYYY',
    defaultTimedEventDuration: '02:00:00',
    defaultAllDayEventDuration: { days: 1 },
    forceEventDuration: false,
    nextDayThreshold: '09:00:00',
    // display
    columnHeader: true,
    defaultView: 'month',
    aspectRatio: 1.35,
    header: {
        left: 'title',
        center: '',
        right: 'today prev,next'
    },
    weekends: true,
    weekNumbers: false,
    weekNumberTitle: 'W',
    weekNumberCalculation: 'local',
    // editable: false,
    // nowIndicator: false,
    scrollTime: '06:00:00',
    minTime: '00:00:00',
    maxTime: '24:00:00',
    showNonCurrentDates: true,
    // event ajax
    lazyFetching: true,
    startParam: 'start',
    endParam: 'end',
    timezoneParam: 'timezone',
    timezone: false,
    // allDayDefault: undefined,
    // locale
    locale: null,
    isRTL: false,
    buttonText: {
        prev: 'prev',
        next: 'next',
        prevYear: 'prev year',
        nextYear: 'next year',
        year: 'year',
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day'
    },
    // buttonIcons: null,
    allDayText: 'all-day',
    // allows setting a min-height to the event segment to prevent short events overlapping each other
    agendaEventMinHeight: 0,
    // jquery-ui theming
    theme: false,
    // themeButtonIcons: null,
    // eventResizableFromStart: false,
    dragOpacity: .75,
    dragRevertDuration: 500,
    dragScroll: true,
    // selectable: false,
    unselectAuto: true,
    // selectMinDistance: 0,
    dropAccept: '*',
    eventOrder: 'title',
    // eventRenderWait: null,
    eventLimit: false,
    eventLimitText: 'more',
    eventLimitClick: 'popover',
    dayPopoverFormat: 'LL',
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000
};
exports.englishDefaults = {
    dayPopoverFormat: 'dddd, MMMM D'
};
exports.rtlDefaults = {
    header: {
        left: 'next,prev today',
        center: '',
        right: 'title'
    },
    buttonIcons: {
        prev: 'right-single-arrow',
        next: 'left-single-arrow',
        prevYear: 'right-double-arrow',
        nextYear: 'left-double-arrow'
    },
    themeButtonIcons: {
        prev: 'circle-triangle-e',
        next: 'circle-triangle-w',
        nextYear: 'seek-prev',
        prevYear: 'seek-next'
    }
};
var complexOptions = [
    'header',
    'footer',
    'buttonText',
    'buttonIcons',
    'themeButtonIcons'
];
// Merges an array of option objects into a single object
function mergeOptions(optionObjs) {
    return object_1.mergeProps(optionObjs, complexOptions);
}
exports.mergeOptions = mergeOptions;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var object_1 = __webpack_require__(5);
// Class that all other classes will inherit from
var Class = /** @class */ (function () {
    function Class() {
    }
    // Called on a class to create a subclass.
    // LIMITATION: cannot provide a constructor!
    Class.extend = function (members) {
        var SubClass = /** @class */ (function (_super) {
            tslib_1.__extends(SubClass, _super);
            function SubClass() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return SubClass;
        }(this));
        object_1.copyOwnProps(members, SubClass.prototype);
        return SubClass;
    };
    // Adds new member variables/methods to the class's prototype.
    // Can be called with another class, or a plain object hash containing new members.
    Class.mixin = function (members) {
        object_1.copyOwnProps(members, this.prototype);
    };
    return Class;
}());
exports.default = Class;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = __webpack_require__(5);
var ParsableModelMixin_1 = __webpack_require__(216);
var EventDef = /** @class */ (function () {
    function EventDef(source) {
        this.source = source;
        this.className = [];
        this.miscProps = {};
    }
    EventDef.parse = function (rawInput, source) {
        var def = new this(source);
        if (def.applyProps(rawInput)) {
            return def;
        }
        return false;
    };
    EventDef.normalizeId = function (id) {
        return String(id);
    };
    EventDef.generateId = function () {
        return '_fc' + (EventDef.uuid++);
    };
    EventDef.prototype.clone = function () {
        var copy = new this.constructor(this.source);
        copy.id = this.id;
        copy.rawId = this.rawId;
        copy.uid = this.uid; // not really unique anymore :(
        EventDef.copyVerbatimStandardProps(this, copy);
        copy.className = this.className.slice(); // copy
        copy.miscProps = object_1.assignTo({}, this.miscProps);
        return copy;
    };
    EventDef.prototype.hasInverseRendering = function () {
        return this.getRendering() === 'inverse-background';
    };
    EventDef.prototype.hasBgRendering = function () {
        var rendering = this.getRendering();
        return rendering === 'inverse-background' || rendering === 'background';
    };
    EventDef.prototype.getRendering = function () {
        if (this.rendering != null) {
            return this.rendering;
        }
        return this.source.rendering;
    };
    EventDef.prototype.getConstraint = function () {
        if (this.constraint != null) {
            return this.constraint;
        }
        if (this.source.constraint != null) {
            return this.source.constraint;
        }
        return this.source.calendar.opt('eventConstraint'); // what about View option?
    };
    EventDef.prototype.getOverlap = function () {
        if (this.overlap != null) {
            return this.overlap;
        }
        if (this.source.overlap != null) {
            return this.source.overlap;
        }
        return this.source.calendar.opt('eventOverlap'); // what about View option?
    };
    EventDef.prototype.isStartExplicitlyEditable = function () {
        if (this.startEditable != null) {
            return this.startEditable;
        }
        return this.source.startEditable;
    };
    EventDef.prototype.isDurationExplicitlyEditable = function () {
        if (this.durationEditable != null) {
            return this.durationEditable;
        }
        return this.source.durationEditable;
    };
    EventDef.prototype.isExplicitlyEditable = function () {
        if (this.editable != null) {
            return this.editable;
        }
        return this.source.editable;
    };
    EventDef.prototype.toLegacy = function () {
        var obj = object_1.assignTo({}, this.miscProps);
        obj._id = this.uid;
        obj.source = this.source;
        obj.className = this.className.slice(); // copy
        obj.allDay = this.isAllDay();
        if (this.rawId != null) {
            obj.id = this.rawId;
        }
        EventDef.copyVerbatimStandardProps(this, obj);
        return obj;
    };
    EventDef.prototype.applyManualStandardProps = function (rawProps) {
        if (rawProps.id != null) {
            this.id = EventDef.normalizeId((this.rawId = rawProps.id));
        }
        else {
            this.id = EventDef.generateId();
        }
        if (rawProps._id != null) { // accept this prop, even tho somewhat internal
            this.uid = String(rawProps._id);
        }
        else {
            this.uid = EventDef.generateId();
        }
        // TODO: converge with EventSource
        if (Array.isArray(rawProps.className)) {
            this.className = rawProps.className;
        }
        if (typeof rawProps.className === 'string') {
            this.className = rawProps.className.split(/\s+/);
        }
        return true;
    };
    EventDef.prototype.applyMiscProps = function (rawProps) {
        object_1.assignTo(this.miscProps, rawProps);
    };
    EventDef.uuid = 0;
    EventDef.defineStandardProps = ParsableModelMixin_1.default.defineStandardProps;
    EventDef.copyVerbatimStandardProps = ParsableModelMixin_1.default.copyVerbatimStandardProps;
    return EventDef;
}());
exports.default = EventDef;
ParsableModelMixin_1.default.mixInto(EventDef);
EventDef.defineStandardProps({
    // not automatically assigned (`false`)
    _id: false,
    id: false,
    className: false,
    source: false,
    // automatically assigned (`true`)
    title: true,
    url: true,
    rendering: true,
    constraint: true,
    overlap: true,
    editable: true,
    startEditable: true,
    durationEditable: true,
    color: true,
    backgroundColor: true,
    borderColor: true,
    textColor: true
});


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventRange_1 = __webpack_require__(219);
var EventFootprint_1 = __webpack_require__(41);
var ComponentFootprint_1 = __webpack_require__(16);
function eventDefsToEventInstances(eventDefs, unzonedRange) {
    var eventInstances = [];
    var i;
    for (i = 0; i < eventDefs.length; i++) {
        eventInstances.push.apply(eventInstances, // append
        eventDefs[i].buildInstances(unzonedRange));
    }
    return eventInstances;
}
exports.eventDefsToEventInstances = eventDefsToEventInstances;
function eventInstanceToEventRange(eventInstance) {
    return new EventRange_1.default(eventInstance.dateProfile.unzonedRange, eventInstance.def, eventInstance);
}
exports.eventInstanceToEventRange = eventInstanceToEventRange;
function eventRangeToEventFootprint(eventRange) {
    return new EventFootprint_1.default(new ComponentFootprint_1.default(eventRange.unzonedRange, eventRange.eventDef.isAllDay()), eventRange.eventDef, eventRange.eventInstance // might not exist
    );
}
exports.eventRangeToEventFootprint = eventRangeToEventFootprint;
function eventInstanceToUnzonedRange(eventInstance) {
    return eventInstance.dateProfile.unzonedRange;
}
exports.eventInstanceToUnzonedRange = eventInstanceToUnzonedRange;
function eventFootprintToComponentFootprint(eventFootprint) {
    return eventFootprint.componentFootprint;
}
exports.eventFootprintToComponentFootprint = eventFootprintToComponentFootprint;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventFootprint = /** @class */ (function () {
    function EventFootprint(componentFootprint, eventDef, eventInstance) {
        this.componentFootprint = componentFootprint;
        this.eventDef = eventDef;
        if (eventInstance) {
            this.eventInstance = eventInstance;
        }
    }
    EventFootprint.prototype.getEventLegacy = function () {
        return (this.eventInstance || this.eventDef).toLegacy();
    };
    return EventFootprint;
}());
exports.default = EventFootprint;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var array_1 = __webpack_require__(21);
var EventDateProfile_1 = __webpack_require__(22);
var EventDef_1 = __webpack_require__(39);
var EventDefDateMutation_1 = __webpack_require__(55);
var SingleEventDef_1 = __webpack_require__(17);
var EventDefMutation = /** @class */ (function () {
    function EventDefMutation() {
    }
    EventDefMutation.createFromRawProps = function (eventInstance, rawProps, largeUnit) {
        var eventDef = eventInstance.def;
        var dateProps = {};
        var standardProps = {};
        var miscProps = {};
        var verbatimStandardProps = {};
        var eventDefId = null;
        var className = null;
        var propName;
        var dateProfile;
        var dateMutation;
        var defMutation;
        for (propName in rawProps) {
            if (EventDateProfile_1.default.isStandardProp(propName)) {
                dateProps[propName] = rawProps[propName];
            }
            else if (eventDef.isStandardProp(propName)) {
                standardProps[propName] = rawProps[propName];
            }
            else if (eventDef.miscProps[propName] !== rawProps[propName]) { // only if changed
                miscProps[propName] = rawProps[propName];
            }
        }
        dateProfile = EventDateProfile_1.default.parse(dateProps, eventDef.source);
        if (dateProfile) { // no failure?
            dateMutation = EventDefDateMutation_1.default.createFromDiff(eventInstance.dateProfile, dateProfile, largeUnit);
        }
        if (standardProps.id !== eventDef.id) {
            eventDefId = standardProps.id; // only apply if there's a change
        }
        if (!array_1.isArraysEqual(standardProps.className, eventDef.className)) {
            className = standardProps.className; // only apply if there's a change
        }
        EventDef_1.default.copyVerbatimStandardProps(standardProps, // src
        verbatimStandardProps // dest
        );
        defMutation = new EventDefMutation();
        defMutation.eventDefId = eventDefId;
        defMutation.className = className;
        defMutation.verbatimStandardProps = verbatimStandardProps;
        defMutation.miscProps = miscProps;
        if (dateMutation) {
            defMutation.dateMutation = dateMutation;
        }
        return defMutation;
    };
    /*
    eventDef assumed to be a SingleEventDef.
    returns an undo function.
    */
    EventDefMutation.prototype.mutateSingle = function (eventDef) {
        var origDateProfile;
        if (this.dateMutation) {
            origDateProfile = eventDef.dateProfile;
            eventDef.dateProfile = this.dateMutation.buildNewDateProfile(origDateProfile, eventDef.source.calendar);
        }
        // can't undo
        // TODO: more DRY with EventDef::applyManualStandardProps
        if (this.eventDefId != null) {
            eventDef.id = EventDef_1.default.normalizeId((eventDef.rawId = this.eventDefId));
        }
        // can't undo
        // TODO: more DRY with EventDef::applyManualStandardProps
        if (this.className) {
            eventDef.className = this.className;
        }
        // can't undo
        if (this.verbatimStandardProps) {
            SingleEventDef_1.default.copyVerbatimStandardProps(this.verbatimStandardProps, // src
            eventDef // dest
            );
        }
        // can't undo
        if (this.miscProps) {
            eventDef.applyMiscProps(this.miscProps);
        }
        if (origDateProfile) {
            return function () {
                eventDef.dateProfile = origDateProfile;
            };
        }
        else {
            return function () { };
        }
    };
    EventDefMutation.prototype.setDateMutation = function (dateMutation) {
        if (dateMutation && !dateMutation.isEmpty()) {
            this.dateMutation = dateMutation;
        }
        else {
            this.dateMutation = null;
        }
    };
    EventDefMutation.prototype.isEmpty = function () {
        return !this.dateMutation;
    };
    return EventDefMutation;
}());
exports.default = EventDefMutation;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    sourceClasses: [],
    registerClass: function (EventSourceClass) {
        this.sourceClasses.unshift(EventSourceClass); // give highest priority
    },
    parse: function (rawInput, calendar) {
        var sourceClasses = this.sourceClasses;
        var i;
        var eventSource;
        for (i = 0; i < sourceClasses.length; i++) {
            eventSource = sourceClasses[i].parse(rawInput, calendar);
            if (eventSource) {
                return eventSource;
            }
        }
    }
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var dom_geom_1 = __webpack_require__(13);
var dom_manip_1 = __webpack_require__(3);
var Class_1 = __webpack_require__(38);
/*
Embodies a div that has potential scrollbars
*/
var Scroller = /** @class */ (function (_super) {
    tslib_1.__extends(Scroller, _super);
    function Scroller(options) {
        var _this = _super.call(this) || this;
        options = options || {};
        _this.overflowX = options.overflowX || options.overflow || 'auto';
        _this.overflowY = options.overflowY || options.overflow || 'auto';
        return _this;
    }
    Scroller.prototype.render = function () {
        this.el = this.renderEl();
        this.applyOverflow();
    };
    Scroller.prototype.renderEl = function () {
        return this.scrollEl = dom_manip_1.createElement('div', {
            className: 'fc-scroller'
        });
    };
    // sets to natural height, unlocks overflow
    Scroller.prototype.clear = function () {
        this.setHeight('auto');
        this.applyOverflow();
    };
    Scroller.prototype.destroy = function () {
        dom_manip_1.removeElement(this.el);
    };
    // Overflow
    // -----------------------------------------------------------------------------------------------------------------
    Scroller.prototype.applyOverflow = function () {
        dom_manip_1.applyStyle(this.scrollEl, {
            overflowX: this.overflowX,
            overflowY: this.overflowY
        });
    };
    // Causes any 'auto' overflow values to resolves to 'scroll' or 'hidden'.
    // Useful for preserving scrollbar widths regardless of future resizes.
    // Can pass in scrollbarWidths for optimization.
    Scroller.prototype.lockOverflow = function (scrollbarWidths) {
        var scrollEl = this.scrollEl;
        var overflowX = this.overflowX;
        var overflowY = this.overflowY;
        scrollbarWidths = scrollbarWidths || this.getScrollbarWidths();
        if (overflowX === 'auto') {
            overflowX = (scrollbarWidths.bottom || // horizontal scrollbars?
                // OR scrolling pane with massless scrollbars?
                scrollEl.scrollWidth - 1 > scrollEl.clientWidth
            // subtract 1 because of IE off-by-one issue
            ) ? 'scroll' : 'hidden';
        }
        if (overflowY === 'auto') {
            overflowY = (scrollbarWidths.left || scrollbarWidths.right || // vertical scrollbars?
                // OR scrolling pane with massless scrollbars?
                scrollEl.scrollHeight - 1 > scrollEl.clientHeight
            // subtract 1 because of IE off-by-one issue
            ) ? 'scroll' : 'hidden';
        }
        dom_manip_1.applyStyle(this.scrollEl, { overflowX: overflowX, overflowY: overflowY });
    };
    // Getters / Setters
    // -----------------------------------------------------------------------------------------------------------------
    Scroller.prototype.setHeight = function (height) {
        dom_manip_1.applyStyleProp(this.scrollEl, 'height', height);
    };
    Scroller.prototype.getScrollTop = function () {
        return this.scrollEl.scrollTop;
    };
    Scroller.prototype.setScrollTop = function (top) {
        this.scrollEl.scrollTop = top;
    };
    Scroller.prototype.getClientWidth = function () {
        return this.scrollEl.clientWidth;
    };
    Scroller.prototype.getClientHeight = function () {
        return this.scrollEl.clientHeight;
    };
    Scroller.prototype.getScrollbarWidths = function () {
        var edges = dom_geom_1.computeEdges(this.scrollEl);
        return {
            left: edges.scrollbarLeft,
            right: edges.scrollbarRight,
            bottom: edges.scrollbarBottom
        };
    };
    return Scroller;
}(Class_1.default));
exports.default = Scroller;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var date_1 = __webpack_require__(8);
var dom_manip_1 = __webpack_require__(3);
var dom_event_1 = __webpack_require__(10);
var DateComponent_1 = __webpack_require__(227);
var GlobalEmitter_1 = __webpack_require__(25);
var InteractiveDateComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InteractiveDateComponent, _super);
    function InteractiveDateComponent(_view, _options) {
        var _this = _super.call(this, _view, _options) || this;
        // self-config, overridable by subclasses
        _this.segSelector = '.fc-event-container > *'; // what constitutes an event element?
        if (_this.dateSelectingClass) {
            _this.dateClicking = new _this.dateClickingClass(_this);
        }
        if (_this.dateSelectingClass) {
            _this.dateSelecting = new _this.dateSelectingClass(_this);
        }
        if (_this.eventPointingClass) {
            _this.eventPointing = new _this.eventPointingClass(_this);
        }
        if (_this.eventDraggingClass && _this.eventPointing) {
            _this.eventDragging = new _this.eventDraggingClass(_this, _this.eventPointing);
        }
        if (_this.eventResizingClass && _this.eventPointing) {
            _this.eventResizing = new _this.eventResizingClass(_this, _this.eventPointing);
        }
        if (_this.externalDroppingClass) {
            _this.externalDropping = new _this.externalDroppingClass(_this);
        }
        return _this;
    }
    // Sets the container element that the view should render inside of, does global DOM-related initializations,
    // and renders all the non-date-related content inside.
    InteractiveDateComponent.prototype.setElement = function (el) {
        _super.prototype.setElement.call(this, el);
        if (this.dateClicking) {
            this.dateClicking.bindToEl(el);
        }
        if (this.dateSelecting) {
            this.dateSelecting.bindToEl(el);
        }
        this.bindAllSegHandlersToEl(el);
    };
    InteractiveDateComponent.prototype.removeElement = function () {
        this.endInteractions();
        _super.prototype.removeElement.call(this);
    };
    InteractiveDateComponent.prototype.executeEventUnrender = function () {
        this.endInteractions();
        _super.prototype.executeEventUnrender.call(this);
    };
    InteractiveDateComponent.prototype.bindDateHandlerToEl = function (el, name, handler) {
        var _this = this;
        el.addEventListener(name, function (ev) {
            if (!dom_manip_1.elementClosest(ev.target, _this.segSelector + ':not(.fc-helper),' + // on or within an event segment
                '.fc-more,' + // a "more.." link
                'a[data-goto]' // a clickable nav link
            )) {
                return handler.call(_this, ev);
            }
        }, {passive: false}); // CUSTOM CHANGE
    };
    InteractiveDateComponent.prototype.bindAllSegHandlersToEl = function (el) {
        [
            this.eventPointing,
            this.eventDragging,
            this.eventResizing
        ].forEach(function (eventInteraction) {
            if (eventInteraction) {
                eventInteraction.bindToEl(el);
            }
        });
    };
    InteractiveDateComponent.prototype.bindSegHandlerToEl = function (el, name, handler) {
        dom_event_1.listenBySelector(el, name, this.segSelector, this.makeSegMouseHandler(handler));
    };
    InteractiveDateComponent.prototype.bindSegHoverHandlersToEl = function (el, onMouseEnter, onMouseLeave) {
        dom_event_1.listenToHoverBySelector(el, this.segSelector, this.makeSegMouseHandler(onMouseEnter), this.makeSegMouseHandler(onMouseLeave));
    };
    InteractiveDateComponent.prototype.makeSegMouseHandler = function (handler) {
        var _this = this;
        return function (ev, segEl) {
            if (!segEl.classList.contains('fc-helper')) {
                var seg = segEl.fcSeg; // grab segment data. put there by View::renderEventsPayload
                if (seg && !_this.shouldIgnoreEventPointing()) {
                    return handler.call(_this, seg, ev); // context will be the Grid
                }
            }
        };
    };
    InteractiveDateComponent.prototype.shouldIgnoreMouse = function () {
        // HACK
        // This will still work even though bindDateHandlerToEl doesn't use GlobalEmitter.
        return GlobalEmitter_1.default.get().shouldIgnoreMouse();
    };
    InteractiveDateComponent.prototype.shouldIgnoreTouch = function () {
        var view = this._getView();
        // On iOS (and Android?) when a new selection is initiated overtop another selection,
        // the touchend never fires because the elements gets removed mid-touch-interaction (my theory).
        // HACK: simply don't allow this to happen.
        // ALSO: prevent selection when an *event* is already raised.
        return view.isSelected || view.selectedEvent;
    };
    InteractiveDateComponent.prototype.shouldIgnoreEventPointing = function () {
        // only call the handlers if there is not a drag/resize in progress
        return (this.eventDragging && this.eventDragging.isDragging) ||
            (this.eventResizing && this.eventResizing.isResizing);
    };
    InteractiveDateComponent.prototype.canStartSelection = function (seg, ev) {
        return dom_event_1.getEvIsTouch(ev) &&
            !this.canStartResize(seg, ev) &&
            (this.isEventDefDraggable(seg.footprint.eventDef) ||
                this.isEventDefResizable(seg.footprint.eventDef));
    };
    InteractiveDateComponent.prototype.canStartDrag = function (seg, ev) {
        return !this.canStartResize(seg, ev) &&
            this.isEventDefDraggable(seg.footprint.eventDef);
    };
    InteractiveDateComponent.prototype.canStartResize = function (seg, ev) {
        var view = this._getView();
        var eventDef = seg.footprint.eventDef;
        return (!dom_event_1.getEvIsTouch(ev) || view.isEventDefSelected(eventDef)) &&
            this.isEventDefResizable(eventDef) &&
            ev.target.classList.contains('fc-resizer');
    };
    // Kills all in-progress dragging.
    // Useful for when public API methods that result in re-rendering are invoked during a drag.
    // Also useful for when touch devices misbehave and don't fire their touchend.
    InteractiveDateComponent.prototype.endInteractions = function () {
        [
            this.dateClicking,
            this.dateSelecting,
            this.eventPointing,
            this.eventDragging,
            this.eventResizing
        ].forEach(function (interaction) {
            if (interaction) {
                interaction.end();
            }
        });
    };
    // Event Drag-n-Drop
    // ---------------------------------------------------------------------------------------------------------------
    // Computes if the given event is allowed to be dragged by the user
    InteractiveDateComponent.prototype.isEventDefDraggable = function (eventDef) {
        return this.isEventDefStartEditable(eventDef);
    };
    InteractiveDateComponent.prototype.isEventDefStartEditable = function (eventDef) {
        var isEditable = eventDef.isStartExplicitlyEditable();
        if (isEditable == null) {
            isEditable = this.opt('eventStartEditable');
            if (isEditable == null) {
                isEditable = this.isEventDefGenerallyEditable(eventDef);
            }
        }
        return isEditable;
    };
    InteractiveDateComponent.prototype.isEventDefGenerallyEditable = function (eventDef) {
        var isEditable = eventDef.isExplicitlyEditable();
        if (isEditable == null) {
            isEditable = this.opt('editable');
        }
        return isEditable;
    };
    // EXTERNAL Drag-n-Drop
    // ---------------------------------------------------------------------------------------------------------------
    InteractiveDateComponent.prototype.handlExternalDragStart = function (ev, el, skipBinding) {
        if (this.externalDropping) {
            this.externalDropping.handleDragStart(ev, el, skipBinding);
        }
        _super.prototype.handlExternalDragStart.call(this, ev, el, skipBinding);
    };
    InteractiveDateComponent.prototype.handleExternalDragMove = function (ev) {
        if (this.externalDropping) {
            this.externalDropping.handleDragMove(ev);
        }
        _super.prototype.handleExternalDragMove.call(this, ev);
    };
    InteractiveDateComponent.prototype.handleExternalDragStop = function (ev) {
        if (this.externalDropping) {
            this.externalDropping.handleDragStop(ev);
        }
        _super.prototype.handleExternalDragStop.call(this, ev);
    };
    // Event Resizing
    // ---------------------------------------------------------------------------------------------------------------
    // Computes if the given event is allowed to be resized from its starting edge
    InteractiveDateComponent.prototype.isEventDefResizableFromStart = function (eventDef) {
        return this.opt('eventResizableFromStart') && this.isEventDefResizable(eventDef);
    };
    // Computes if the given event is allowed to be resized from its ending edge
    InteractiveDateComponent.prototype.isEventDefResizableFromEnd = function (eventDef) {
        return this.isEventDefResizable(eventDef);
    };
    // Computes if the given event is allowed to be resized by the user at all
    InteractiveDateComponent.prototype.isEventDefResizable = function (eventDef) {
        var isResizable = eventDef.isDurationExplicitlyEditable();
        if (isResizable == null) {
            isResizable = this.opt('eventDurationEditable');
            if (isResizable == null) {
                isResizable = this.isEventDefGenerallyEditable(eventDef);
            }
        }
        return isResizable;
    };
    // Event Mutation / Constraints
    // ---------------------------------------------------------------------------------------------------------------
    // Diffs the two dates, returning a duration, based on granularity of the grid
    // TODO: port isTimeScale into this system?
    InteractiveDateComponent.prototype.diffDates = function (a, b) {
        if (this.largeUnit) {
            return date_1.diffByUnit(a, b, this.largeUnit);
        }
        else {
            return date_1.diffDayTime(a, b);
        }
    };
    // is it allowed, in relation to the view's validRange?
    // NOTE: very similar to isExternalInstanceGroupAllowed
    InteractiveDateComponent.prototype.isEventInstanceGroupAllowed = function (eventInstanceGroup) {
        var view = this._getView();
        var dateProfile = this.dateProfile;
        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            // TODO: just use getAllEventRanges directly
            if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
                return false;
            }
        }
        return view.calendar.constraints.isEventInstanceGroupAllowed(eventInstanceGroup);
    };
    // NOTE: very similar to isEventInstanceGroupAllowed
    // when it's a completely anonymous external drag, no event.
    InteractiveDateComponent.prototype.isExternalInstanceGroupAllowed = function (eventInstanceGroup) {
        var view = this._getView();
        var dateProfile = this.dateProfile;
        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            if (!dateProfile.validUnzonedRange.containsRange(eventFootprints[i].componentFootprint.unzonedRange)) {
                return false;
            }
        }
        for (i = 0; i < eventFootprints.length; i++) {
            // treat it as a selection
            // TODO: pass in eventInstanceGroup instead
            //  because we don't want calendar's constraint system to depend on a component's
            //  determination of footprints.
            if (!view.calendar.constraints.isSelectionFootprintAllowed(eventFootprints[i].componentFootprint)) {
                return false;
            }
        }
        return true;
    };
    return InteractiveDateComponent;
}(DateComponent_1.default));
exports.default = InteractiveDateComponent;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var moment = __webpack_require__(0);
var object_1 = __webpack_require__(5);
var dom_manip_1 = __webpack_require__(3);
var dom_event_1 = __webpack_require__(10);
var misc_1 = __webpack_require__(4);
var RenderQueue_1 = __webpack_require__(226);
var DateProfileGenerator_1 = __webpack_require__(228);
var InteractiveDateComponent_1 = __webpack_require__(45);
var GlobalEmitter_1 = __webpack_require__(25);
var UnzonedRange_1 = __webpack_require__(7);
/* An abstract class from which other views inherit from
----------------------------------------------------------------------------------------------------------------------*/
var View = /** @class */ (function (_super) {
    tslib_1.__extends(View, _super);
    function View(calendar, viewSpec) {
        var _this = _super.call(this, null, viewSpec.options) || this;
        _this.batchRenderDepth = 0;
        _this.isSelected = false; // boolean whether a range of time is user-selected or not
        _this.calendar = calendar;
        _this.viewSpec = viewSpec;
        // shortcuts
        _this.type = viewSpec.type;
        // .name is deprecated
        _this.name = _this.type;
        _this.initRenderQueue();
        _this.initHiddenDays();
        _this.dateProfileGenerator = new _this.dateProfileGeneratorClass(_this);
        _this.bindBaseRenderHandlers();
        _this.eventOrderSpecs = misc_1.parseFieldSpecs(_this.opt('eventOrder'));
        // legacy
        if (_this['initialize']) {
            _this['initialize']();
        }
        return _this;
    }
    View.prototype._getView = function () {
        return this;
    };
    // Retrieves an option with the given name
    View.prototype.opt = function (name) {
        return this.options[name];
    };
    /* Render Queue
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.initRenderQueue = function () {
        this.renderQueue = new RenderQueue_1.default({
            event: this.opt('eventRenderWait')
        });
        this.renderQueue.on('start', this.onRenderQueueStart.bind(this));
        this.renderQueue.on('stop', this.onRenderQueueStop.bind(this));
        this.on('before:change', this.startBatchRender);
        this.on('change', this.stopBatchRender);
    };
    View.prototype.onRenderQueueStart = function () {
        this.calendar.freezeContentHeight();
        this.addScroll(this.queryScroll());
    };
    View.prototype.onRenderQueueStop = function () {
        if (this.calendar.updateViewSize()) { // success?
            this.popScroll();
        }
        this.calendar.thawContentHeight();
    };
    View.prototype.startBatchRender = function () {
        if (!(this.batchRenderDepth++)) {
            this.renderQueue.pause();
        }
    };
    View.prototype.stopBatchRender = function () {
        if (!(--this.batchRenderDepth)) {
            this.renderQueue.resume();
        }
    };
    View.prototype.requestRender = function (func, namespace, actionType) {
        this.renderQueue.queue(func, namespace, actionType);
    };
    // given func will auto-bind to `this`
    View.prototype.whenSizeUpdated = function (func) {
        if (this.renderQueue.isRunning) {
            this.renderQueue.one('stop', func.bind(this));
        }
        else {
            func.call(this);
        }
    };
    /* Title and Date Formatting
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes what the title at the top of the calendar should be for this view
    View.prototype.computeTitle = function (dateProfile) {
        var unzonedRange;
        // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
        if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) {
            unzonedRange = dateProfile.currentUnzonedRange;
        }
        else { // for day units or smaller, use the actual day range
            unzonedRange = dateProfile.activeUnzonedRange;
        }
        return this.formatRange({
            start: this.calendar.msToMoment(unzonedRange.startMs, dateProfile.isRangeAllDay),
            end: this.calendar.msToMoment(unzonedRange.endMs, dateProfile.isRangeAllDay)
        }, dateProfile.isRangeAllDay, this.opt('titleFormat') || this.computeTitleFormat(dateProfile), this.opt('titleRangeSeparator'));
    };
    // Generates the format string that should be used to generate the title for the current date range.
    // Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
    View.prototype.computeTitleFormat = function (dateProfile) {
        var currentRangeUnit = dateProfile.currentRangeUnit;
        if (currentRangeUnit === 'year') {
            return 'YYYY';
        }
        else if (currentRangeUnit === 'month') {
            return this.opt('monthYearFormat'); // like "September 2014"
        }
        else if (dateProfile.currentUnzonedRange.as('days') > 1) {
            return 'll'; // multi-day range. shorter, like "Sep 9 - 10 2014"
        }
        else {
            return 'LL'; // one day. longer, like "September 9 2014"
        }
    };
    // Date Setting/Unsetting
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.setDate = function (date) {
        var currentDateProfile = this.get('dateProfile');
        var newDateProfile = this.dateProfileGenerator.build(date, undefined, true); // forceToValid=true
        if (!currentDateProfile ||
            !currentDateProfile.activeUnzonedRange.equals(newDateProfile.activeUnzonedRange)) {
            this.set('dateProfile', newDateProfile);
        }
    };
    View.prototype.unsetDate = function () {
        this.unset('dateProfile');
    };
    // Event Data
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.fetchInitialEvents = function (dateProfile, callback) {
        var calendar = this.calendar;
        var forceAllDay = dateProfile.isRangeAllDay && !this.usesMinMaxTime;
        calendar.requestEvents(calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, forceAllDay), calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, forceAllDay), callback);
    };
    View.prototype.bindEventChanges = function () {
        this.listenTo(this.calendar, 'eventsReset', this.resetEvents); // TODO: make this a real event
    };
    View.prototype.unbindEventChanges = function () {
        this.stopListeningTo(this.calendar, 'eventsReset');
    };
    View.prototype.setEvents = function (eventsPayload) {
        this.set('currentEvents', eventsPayload);
        this.set('hasEvents', true);
    };
    View.prototype.unsetEvents = function () {
        this.unset('currentEvents');
        this.unset('hasEvents');
    };
    View.prototype.resetEvents = function (eventsPayload) {
        this.startBatchRender();
        this.unsetEvents();
        this.setEvents(eventsPayload);
        this.stopBatchRender();
    };
    // Date High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.requestDateRender = function (dateProfile) {
        var _this = this;
        this.requestRender(function () {
            _this.executeDateRender(dateProfile);
        }, 'date', 'init');
    };
    View.prototype.requestDateUnrender = function () {
        var _this = this;
        this.requestRender(function () {
            _this.executeDateUnrender();
        }, 'date', 'destroy');
    };
    // if dateProfile not specified, uses current
    View.prototype.executeDateRender = function (dateProfile) {
        _super.prototype.executeDateRender.call(this, dateProfile);
        if (this['render']) {
            this['render'](); // TODO: deprecate
        }
        this.trigger('datesRendered');
        this.addScroll({ isDateInit: true });
        this.startNowIndicator(); // shouldn't render yet because updateSize will be called soon
    };
    View.prototype.executeDateUnrender = function () {
        this.unselect();
        this.stopNowIndicator();
        this.trigger('before:datesUnrendered');
        if (this['destroy']) {
            this['destroy'](); // TODO: deprecate
        }
        _super.prototype.executeDateUnrender.call(this);
    };
    // "Base" rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.bindBaseRenderHandlers = function () {
        var _this = this;
        this.on('datesRendered', function () {
            _this.whenSizeUpdated(_this.triggerViewRender);
        });
        this.on('before:datesUnrendered', function () {
            _this.triggerViewDestroy();
        });
    };
    View.prototype.triggerViewRender = function () {
        this.publiclyTrigger('viewRender', {
            context: this,
            args: [this, this.el]
        });
    };
    View.prototype.triggerViewDestroy = function () {
        this.publiclyTrigger('viewDestroy', {
            context: this,
            args: [this, this.el]
        });
    };
    // Event High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.requestEventsRender = function (eventsPayload) {
        var _this = this;
        this.requestRender(function () {
            _this.executeEventRender(eventsPayload);
            _this.whenSizeUpdated(_this.triggerAfterEventsRendered);
        }, 'event', 'init');
    };
    View.prototype.requestEventsUnrender = function () {
        var _this = this;
        this.requestRender(function () {
            _this.triggerBeforeEventsDestroyed();
            _this.executeEventUnrender();
        }, 'event', 'destroy');
    };
    // Business Hour High-level Rendering
    // -----------------------------------------------------------------------------------------------------------------
    View.prototype.requestBusinessHoursRender = function (businessHourGenerator) {
        var _this = this;
        this.requestRender(function () {
            _this.renderBusinessHours(businessHourGenerator);
        }, 'businessHours', 'init');
    };
    View.prototype.requestBusinessHoursUnrender = function () {
        var _this = this;
        this.requestRender(function () {
            _this.unrenderBusinessHours();
        }, 'businessHours', 'destroy');
    };
    // Misc view rendering utils
    // -----------------------------------------------------------------------------------------------------------------
    // Binds DOM handlers to elements that reside outside the view container, such as the document
    View.prototype.bindGlobalHandlers = function () {
        _super.prototype.bindGlobalHandlers.call(this);
        this.listenTo(GlobalEmitter_1.default.get(), {
            touchstart: this.processUnselect,
            mousedown: this.handleDocumentMousedown
        });
    };
    // Unbinds DOM handlers from elements that reside outside the view container
    View.prototype.unbindGlobalHandlers = function () {
        _super.prototype.unbindGlobalHandlers.call(this);
        this.stopListeningTo(GlobalEmitter_1.default.get());
    };
    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    // Immediately render the current time indicator and begins re-rendering it at an interval,
    // which is defined by this.getNowIndicatorUnit().
    // TODO: somehow do this for the current whole day's background too
    View.prototype.startNowIndicator = function () {
        var _this = this;
        var unit;
        var update;
        var delay; // ms wait value
        if (this.opt('nowIndicator')) {
            unit = this.getNowIndicatorUnit();
            if (unit) {
                update = this.updateNowIndicator.bind(this);
                this.initialNowDate = this.calendar.getNow();
                this.initialNowQueriedMs = new Date().valueOf();
                // wait until the beginning of the next interval
                delay = this.initialNowDate.clone().startOf(unit).add(1, unit).valueOf() - this.initialNowDate.valueOf();
                this.nowIndicatorTimeoutID = setTimeout(function () {
                    _this.nowIndicatorTimeoutID = null;
                    update();
                    delay = +moment.duration(1, unit);
                    delay = Math.max(100, delay); // prevent too frequent
                    _this.nowIndicatorIntervalID = setInterval(update, delay); // update every interval
                }, delay);
            }
            // rendering will be initiated in updateSize
        }
    };
    // rerenders the now indicator, computing the new current time from the amount of time that has passed
    // since the initial getNow call.
    View.prototype.updateNowIndicator = function () {
        if (this.isDatesRendered &&
            this.initialNowDate // activated before?
        ) {
            this.unrenderNowIndicator(); // won't unrender if unnecessary
            this.renderNowIndicator(this.initialNowDate.clone().add(new Date().valueOf() - this.initialNowQueriedMs) // add ms
            );
            this.isNowIndicatorRendered = true;
        }
    };
    // Immediately unrenders the view's current time indicator and stops any re-rendering timers.
    // Won't cause side effects if indicator isn't rendered.
    View.prototype.stopNowIndicator = function () {
        if (this.isNowIndicatorRendered) {
            if (this.nowIndicatorTimeoutID) {
                clearTimeout(this.nowIndicatorTimeoutID);
                this.nowIndicatorTimeoutID = null;
            }
            if (this.nowIndicatorIntervalID) {
                clearInterval(this.nowIndicatorIntervalID);
                this.nowIndicatorIntervalID = null;
            }
            this.unrenderNowIndicator();
            this.isNowIndicatorRendered = false;
        }
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        if (this['setHeight']) { // for legacy API
            this['setHeight'](totalHeight, isAuto);
        }
        else {
            _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        }
        this.updateNowIndicator();
    };
    /* Scroller
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.addScroll = function (scroll) {
        var queuedScroll = this.queuedScroll || (this.queuedScroll = {});
        object_1.assignTo(queuedScroll, scroll);
    };
    View.prototype.popScroll = function () {
        this.applyQueuedScroll();
        this.queuedScroll = null;
    };
    View.prototype.applyQueuedScroll = function () {
        if (this.queuedScroll) {
            this.applyScroll(this.queuedScroll);
        }
    };
    View.prototype.queryScroll = function () {
        var scroll = {};
        if (this.isDatesRendered) {
            object_1.assignTo(scroll, this.queryDateScroll());
        }
        return scroll;
    };
    View.prototype.applyScroll = function (scroll) {
        if (scroll.isDateInit && this.isDatesRendered) {
            object_1.assignTo(scroll, this.computeInitialDateScroll());
        }
        if (this.isDatesRendered) {
            this.applyDateScroll(scroll);
        }
    };
    View.prototype.computeInitialDateScroll = function () {
        return {}; // subclasses must implement
    };
    View.prototype.queryDateScroll = function () {
        return {}; // subclasses must implement
    };
    View.prototype.applyDateScroll = function (scroll) {
        // subclasses must implement
    };
    /* Event Drag-n-Drop
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.reportEventDrop = function (eventInstance, eventMutation, el, ev) {
        var eventManager = this.calendar.eventManager;
        var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation);
        var dateMutation = eventMutation.dateMutation;
        // update the EventInstance, for handlers
        if (dateMutation) {
            eventInstance.dateProfile = dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
        }
        this.triggerEventDrop(eventInstance, 
        // a drop doesn't necessarily mean a date mutation (ex: resource change)
        (dateMutation && dateMutation.dateDelta) || moment.duration(), undoFunc, el, ev);
    };
    // Triggers event-drop handlers that have subscribed via the API
    View.prototype.triggerEventDrop = function (eventInstance, dateDelta, undoFunc, el, ev) {
        this.publiclyTrigger('eventDrop', {
            context: el,
            args: [
                eventInstance.toLegacy(),
                dateDelta,
                undoFunc,
                ev,
                {},
                this
            ]
        });
    };
    /* External Element Drag-n-Drop
    ------------------------------------------------------------------------------------------------------------------*/
    // Must be called when an external element, via jQuery UI, has been dropped onto the calendar.
    // `meta` is the parsed data that has been embedded into the dragging event.
    // `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
    View.prototype.reportExternalDrop = function (singleEventDef, isEvent, isSticky, el, ev) {
        if (isEvent) {
            this.calendar.eventManager.addEventDef(singleEventDef, isSticky);
        }
        this.triggerExternalDrop(singleEventDef, isEvent, el, ev);
    };
    // Triggers external-drop handlers that have subscribed via the API
    View.prototype.triggerExternalDrop = function (singleEventDef, isEvent, el, ev) {
        // trigger 'drop' regardless of whether element represents an event
        this.publiclyTrigger('drop', {
            context: el,
            args: [
                singleEventDef.dateProfile.start.clone(),
                ev,
                this
            ]
        });
        if (isEvent) {
            // signal an external event landed
            this.publiclyTrigger('eventReceive', {
                context: this,
                args: [
                    singleEventDef.buildInstance().toLegacy(),
                    this
                ]
            });
        }
    };
    /* Event Resizing
    ------------------------------------------------------------------------------------------------------------------*/
    // Must be called when an event in the view has been resized to a new length
    View.prototype.reportEventResize = function (eventInstance, eventMutation, el, ev) {
        var eventManager = this.calendar.eventManager;
        var undoFunc = eventManager.mutateEventsWithId(eventInstance.def.id, eventMutation);
        // update the EventInstance, for handlers
        eventInstance.dateProfile = eventMutation.dateMutation.buildNewDateProfile(eventInstance.dateProfile, this.calendar);
        this.triggerEventResize(eventInstance, eventMutation.dateMutation.endDelta, undoFunc, el, ev);
    };
    // Triggers event-resize handlers that have subscribed via the API
    View.prototype.triggerEventResize = function (eventInstance, durationDelta, undoFunc, el, ev) {
        this.publiclyTrigger('eventResize', {
            context: el,
            args: [
                eventInstance.toLegacy(),
                durationDelta,
                undoFunc,
                ev,
                {},
                this
            ]
        });
    };
    /* Selection (time range)
    ------------------------------------------------------------------------------------------------------------------*/
    // Selects a date span on the view. `start` and `end` are both Moments.
    // `ev` is the native mouse event that begin the interaction.
    View.prototype.select = function (footprint, ev) {
        this.unselect(ev);
        this.renderSelectionFootprint(footprint);
        this.reportSelection(footprint, ev);
    };
    View.prototype.renderSelectionFootprint = function (footprint) {
        if (this['renderSelection']) { // legacy method in custom view classes
            this['renderSelection'](footprint.toLegacy(this.calendar));
        }
        else {
            _super.prototype.renderSelectionFootprint.call(this, footprint);
        }
    };
    // Called when a new selection is made. Updates internal state and triggers handlers.
    View.prototype.reportSelection = function (footprint, ev) {
        this.isSelected = true;
        this.triggerSelect(footprint, ev);
    };
    // Triggers handlers to 'select'
    View.prototype.triggerSelect = function (footprint, ev) {
        var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?
        this.publiclyTrigger('select', {
            context: this,
            args: [
                dateProfile.start,
                dateProfile.end,
                ev,
                this
            ]
        });
    };
    // Undoes a selection. updates in the internal state and triggers handlers.
    // `ev` is the native mouse event that began the interaction.
    View.prototype.unselect = function (ev) {
        if (this.isSelected) {
            this.isSelected = false;
            if (this['destroySelection']) {
                this['destroySelection'](); // TODO: deprecate
            }
            this.unrenderSelection();
            this.publiclyTrigger('unselect', {
                context: this,
                args: [ev, this]
            });
        }
    };
    /* Event Selection
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.selectEventInstance = function (eventInstance) {
        if (!this.selectedEventInstance ||
            this.selectedEventInstance !== eventInstance) {
            this.unselectEventInstance();
            this.getEventSegs().forEach(function (seg) {
                if (seg.footprint.eventInstance === eventInstance &&
                    seg.el // necessary?
                ) {
                    seg.el.classList.add('fc-selected');
                }
            });
            this.selectedEventInstance = eventInstance;
        }
    };
    View.prototype.unselectEventInstance = function () {
        if (this.selectedEventInstance) {
            this.getEventSegs().forEach(function (seg) {
                if (seg.el) { // necessary?
                    seg.el.classList.remove('fc-selected');
                }
            });
            this.selectedEventInstance = null;
        }
    };
    View.prototype.isEventDefSelected = function (eventDef) {
        // event references might change on refetchEvents(), while selectedEventInstance doesn't,
        // so compare IDs
        return this.selectedEventInstance && this.selectedEventInstance.def.id === eventDef.id;
    };
    /* Mouse / Touch Unselecting (time range & event unselection)
    ------------------------------------------------------------------------------------------------------------------*/
    // TODO: move consistently to down/start or up/end?
    // TODO: don't kill previous selection if touch scrolling
    View.prototype.handleDocumentMousedown = function (ev) {
        if (dom_event_1.isPrimaryMouseButton(ev)) {
            this.processUnselect(ev);
        }
    };
    View.prototype.processUnselect = function (ev) {
        this.processRangeUnselect(ev);
        this.processEventUnselect(ev);
    };
    View.prototype.processRangeUnselect = function (ev) {
        var ignore;
        // is there a time-range selection?
        if (this.isSelected && this.opt('unselectAuto')) {
            // only unselect if the clicked element is not identical to or inside of an 'unselectCancel' element
            ignore = this.opt('unselectCancel');
            if (!ignore || !dom_manip_1.elementClosest(ev.target, ignore)) {
                this.unselect(ev);
            }
        }
    };
    View.prototype.processEventUnselect = function (ev) {
        if (this.selectedEventInstance) {
            if (!dom_manip_1.elementClosest(ev.target, '.fc-selected')) {
                this.unselectEventInstance();
            }
        }
    };
    /* Triggers
    ------------------------------------------------------------------------------------------------------------------*/
    View.prototype.triggerBaseRendered = function () {
        this.publiclyTrigger('viewRender', {
            context: this,
            args: [this, this.el]
        });
    };
    View.prototype.triggerBaseUnrendered = function () {
        this.publiclyTrigger('viewDestroy', {
            context: this,
            args: [this, this.el]
        });
    };
    // Triggers handlers to 'dayClick'
    // Span has start/end of the clicked area. Only the start is useful.
    View.prototype.triggerDayClick = function (footprint, dayEl, ev) {
        var dateProfile = this.calendar.footprintToDateProfile(footprint); // abuse of "Event"DateProfile?
        this.publiclyTrigger('dayClick', {
            context: dayEl,
            args: [dateProfile.start, ev, this]
        });
    };
    /* Date Utils
    ------------------------------------------------------------------------------------------------------------------*/
    // For DateComponent::getDayClasses
    View.prototype.isDateInOtherMonth = function (date, dateProfile) {
        return false;
    };
    // Arguments after name will be forwarded to a hypothetical function value
    // WARNING: passed-in arguments will be given to generator functions as-is and can cause side-effects.
    // Always clone your objects if you fear mutation.
    View.prototype.getUnzonedRangeOption = function (name) {
        var val = this.opt(name);
        if (typeof val === 'function') {
            val = val.apply(null, Array.prototype.slice.call(arguments, 1));
        }
        if (val) {
            return this.calendar.parseUnzonedRange(val);
        }
    };
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/
    // Initializes internal variables related to calculating hidden days-of-week
    View.prototype.initHiddenDays = function () {
        var hiddenDays = this.opt('hiddenDays') || []; // array of day-of-week indices that are hidden
        var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        var dayCnt = 0;
        var i;
        if (this.opt('weekends') === false) {
            hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        }
        for (i = 0; i < 7; i++) {
            if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) {
                dayCnt++;
            }
        }
        if (!dayCnt) {
            throw new Error('invalid hiddenDays'); // all days were hidden? bad.
        }
        this.isHiddenDayHash = isHiddenDayHash;
    };
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    View.prototype.trimHiddenDays = function (inputUnzonedRange) {
        var start = inputUnzonedRange.getStart();
        var end = inputUnzonedRange.getEnd();
        if (start) {
            start = this.skipHiddenDays(start);
        }
        if (end) {
            end = this.skipHiddenDays(end, -1, true);
        }
        if (start === null || end === null || start < end) {
            return new UnzonedRange_1.default(start, end);
        }
        return null;
    };
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Moment
    View.prototype.isHiddenDay = function (day) {
        if (moment.isMoment(day)) {
            day = day.day();
        }
        return this.isHiddenDayHash[day];
    };
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validUnzonedRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    View.prototype.skipHiddenDays = function (date, inc, isExclusive) {
        if (inc === void 0) { inc = 1; }
        if (isExclusive === void 0) { isExclusive = false; }
        var out = date.clone();
        while (this.isHiddenDayHash[(out.day() + (isExclusive ? inc : 0) + 7) % 7]) {
            out.add(inc, 'days');
        }
        return out;
    };
    return View;
}(InteractiveDateComponent_1.default));
exports.default = View;
View.prototype.usesMinMaxTime = false;
View.prototype.dateProfileGeneratorClass = DateProfileGenerator_1.default;
View.watch('displayingDates', ['isInDom', 'dateProfile'], function (deps) {
    this.requestDateRender(deps.dateProfile);
}, function () {
    this.requestDateUnrender();
});
View.watch('displayingBusinessHours', ['displayingDates', 'businessHourGenerator'], function (deps) {
    this.requestBusinessHoursRender(deps.businessHourGenerator);
}, function () {
    this.requestBusinessHoursUnrender();
});
View.watch('initialEvents', ['dateProfile'], function (deps, callback) {
    this.fetchInitialEvents(deps.dateProfile, callback);
}, null, true); // async=true
View.watch('bindingEvents', ['initialEvents'], function (deps) {
    this.setEvents(deps.initialEvents);
    this.bindEventChanges();
}, function () {
    this.unbindEventChanges();
    this.unsetEvents();
});
View.watch('displayingEvents', ['displayingDates', 'hasEvents'], function () {
    this.requestEventsRender(this.get('currentEvents'));
}, function () {
    this.requestEventsUnrender();
});
View.watch('title', ['dateProfile'], function (deps) {
    return (this.title = this.computeTitle(deps.dateProfile)); // assign to View for legacy reasons
});
View.watch('legacyDateProps', ['dateProfile'], function (deps) {
    var calendar = this.calendar;
    var dateProfile = deps.dateProfile;
    // DEPRECATED, but we need to keep it updated...
    this.start = calendar.msToMoment(dateProfile.activeUnzonedRange.startMs, dateProfile.isRangeAllDay);
    this.end = calendar.msToMoment(dateProfile.activeUnzonedRange.endMs, dateProfile.isRangeAllDay);
    this.intervalStart = calendar.msToMoment(dateProfile.currentUnzonedRange.startMs, dateProfile.isRangeAllDay);
    this.intervalEnd = calendar.msToMoment(dateProfile.currentUnzonedRange.endMs, dateProfile.isRangeAllDay);
});


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var dom_manip_1 = __webpack_require__(3);
var misc_1 = __webpack_require__(4);
var EventRenderer = /** @class */ (function () {
    function EventRenderer(component, fillRenderer) {
        this.view = component._getView();
        this.component = component;
        this.fillRenderer = fillRenderer;
    }
    EventRenderer.prototype.opt = function (name) {
        return this.view.opt(name);
    };
    // Updates values that rely on options and also relate to range
    EventRenderer.prototype.rangeUpdated = function () {
        var displayEventTime;
        var displayEventEnd;
        this.eventTimeFormat =
            this.opt('eventTimeFormat') ||
                this.opt('timeFormat') || // deprecated
                this.computeEventTimeFormat();
        displayEventTime = this.opt('displayEventTime');
        if (displayEventTime == null) {
            displayEventTime = this.computeDisplayEventTime(); // might be based off of range
        }
        displayEventEnd = this.opt('displayEventEnd');
        if (displayEventEnd == null) {
            displayEventEnd = this.computeDisplayEventEnd(); // might be based off of range
        }
        this.displayEventTime = displayEventTime;
        this.displayEventEnd = displayEventEnd;
    };
    EventRenderer.prototype.render = function (eventsPayload) {
        var dateProfile = this.component._getDateProfile();
        var eventDefId;
        var instanceGroup;
        var eventRanges;
        var bgRanges = [];
        var fgRanges = [];
        for (eventDefId in eventsPayload) {
            instanceGroup = eventsPayload[eventDefId];
            eventRanges = instanceGroup.sliceRenderRanges(dateProfile.activeUnzonedRange);
            if (instanceGroup.getEventDef().hasBgRendering()) {
                bgRanges.push.apply(bgRanges, eventRanges);
            }
            else {
                fgRanges.push.apply(fgRanges, eventRanges);
            }
        }
        this.renderBgRanges(bgRanges);
        this.renderFgRanges(fgRanges);
    };
    EventRenderer.prototype.unrender = function () {
        this.unrenderBgRanges();
        this.unrenderFgRanges();
    };
    EventRenderer.prototype.renderFgRanges = function (eventRanges) {
        var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        // render an `.el` on each seg
        // returns a subset of the segs. segs that were actually rendered
        segs = this.renderFgSegEls(segs);
        if (this.renderFgSegs(segs) !== false) { // no failure?
            this.fgSegs = segs;
        }
    };
    EventRenderer.prototype.unrenderFgRanges = function () {
        this.unrenderFgSegs(this.fgSegs || []);
        this.fgSegs = null;
    };
    EventRenderer.prototype.renderBgRanges = function (eventRanges) {
        var eventFootprints = this.component.eventRangesToEventFootprints(eventRanges);
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        if (this.renderBgSegs(segs) !== false) { // no failure?
            this.bgSegs = segs;
        }
    };
    EventRenderer.prototype.unrenderBgRanges = function () {
        this.unrenderBgSegs();
        this.bgSegs = null;
    };
    EventRenderer.prototype.getSegs = function () {
        return (this.bgSegs || []).concat(this.fgSegs || []);
    };
    // Renders foreground event segments onto the grid
    EventRenderer.prototype.renderFgSegs = function (segs) {
        // subclasses must implement
        // segs already has rendered els, and has been filtered.
        return false; // signal failure if not implemented
    };
    // Unrenders all currently rendered foreground segments
    EventRenderer.prototype.unrenderFgSegs = function (segs) {
        // subclasses must implement
    };
    EventRenderer.prototype.renderBgSegs = function (segs) {
        var _this = this;
        if (this.fillRenderer) {
            this.fillRenderer.renderSegs('bgEvent', segs, {
                getClasses: function (seg) {
                    return _this.getBgClasses(seg.footprint.eventDef);
                },
                getCss: function (seg) {
                    return {
                        'background-color': _this.getBgColor(seg.footprint.eventDef)
                    };
                },
                filterEl: function (seg, el) {
                    return _this.filterEventRenderEl(seg.footprint, el);
                }
            });
        }
        else {
            return false; // signal failure if no fillRenderer
        }
    };
    EventRenderer.prototype.unrenderBgSegs = function () {
        if (this.fillRenderer) {
            this.fillRenderer.unrender('bgEvent');
        }
    };
    // Renders and assigns an `el` property for each foreground event segment.
    // Only returns segments that successfully rendered.
    EventRenderer.prototype.renderFgSegEls = function (segs, disableResizing) {
        var _this = this;
        if (disableResizing === void 0) { disableResizing = false; }
        var hasEventRenderHandlers = this.view.hasPublicHandlers('eventRender');
        var html = '';
        var renderedSegs = [];
        var i;
        if (segs.length) { // don't build an empty html string
            // build a large concatenation of event segment HTML
            for (i = 0; i < segs.length; i++) {
                this.beforeFgSegHtml(segs[i]);
                html += this.fgSegHtml(segs[i], disableResizing);
            }
            // Grab individual elements from the combined HTML string. Use each as the default rendering.
            // Then, compute the 'el' for each segment. An el might be null if the eventRender callback returned false.
            dom_manip_1.htmlToElements(html).forEach(function (el, i) {
                var seg = segs[i];
                if (hasEventRenderHandlers) { // optimization
                    el = _this.filterEventRenderEl(seg.footprint, el);
                }
                if (el) {
                    el.fcSeg = seg; // used by handlers
                    seg.el = el;
                    renderedSegs.push(seg);
                }
            });
        }
        return renderedSegs;
    };
    EventRenderer.prototype.beforeFgSegHtml = function (seg) {
    };
    // Generates the HTML for the default rendering of a foreground event segment. Used by renderFgSegEls()
    EventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
        // subclasses should implement
    };
    // Generic utility for generating the HTML classNames for an event segment's element
    EventRenderer.prototype.getSegClasses = function (seg, isDraggable, isResizable) {
        var classes = [
            'fc-event',
            seg.isStart ? 'fc-start' : 'fc-not-start',
            seg.isEnd ? 'fc-end' : 'fc-not-end'
        ].concat(this.getClasses(seg.footprint.eventDef));
        if (isDraggable) {
            classes.push('fc-draggable');
        }
        if (isResizable) {
            classes.push('fc-resizable');
        }
        // event is currently selected? attach a className.
        if (this.view.isEventDefSelected(seg.footprint.eventDef)) {
            classes.push('fc-selected');
        }
        return classes;
    };
    // Given an event and the default element used for rendering, returns the element that should actually be used.
    // Basically runs events and elements through the eventRender hook.
    EventRenderer.prototype.filterEventRenderEl = function (eventFootprint, el) {
        var legacy = eventFootprint.getEventLegacy();
        var custom = this.view.publiclyTrigger('eventRender', {
            context: legacy,
            args: [legacy, el, this.view]
        });
        if (custom === false) { // means don't render at all
            el = null;
        }
        else if (custom && custom !== true) {
            el = custom;
        }
        return el;
    };
    // Compute the text that should be displayed on an event's element.
    // `range` can be the Event object itself, or something range-like, with at least a `start`.
    // If event times are disabled, or the event has no time, will return a blank string.
    // If not specified, formatStr will default to the eventTimeFormat setting,
    // and displayEnd will default to the displayEventEnd setting.
    EventRenderer.prototype.getTimeText = function (eventFootprint, formatStr, displayEnd) {
        return this._getTimeText(eventFootprint.eventInstance.dateProfile.start, eventFootprint.eventInstance.dateProfile.end, eventFootprint.componentFootprint.isAllDay, formatStr, displayEnd);
    };
    EventRenderer.prototype._getTimeText = function (start, end, isAllDay, formatStr, displayEnd) {
        if (formatStr == null) {
            formatStr = this.eventTimeFormat;
        }
        if (displayEnd == null) {
            displayEnd = this.displayEventEnd;
        }
        if (this.displayEventTime && !isAllDay) {
            if (displayEnd && end) {
                return this.view.formatRange({ start: start, end: end }, false, // allDay
                formatStr);
            }
            else {
                return start.format(formatStr);
            }
        }
        return '';
    };
    EventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('smallTimeFormat');
    };
    EventRenderer.prototype.computeDisplayEventTime = function () {
        return true;
    };
    EventRenderer.prototype.computeDisplayEventEnd = function () {
        return true;
    };
    EventRenderer.prototype.getBgClasses = function (eventDef) {
        var classNames = this.getClasses(eventDef);
        classNames.push('fc-bgevent');
        return classNames;
    };
    EventRenderer.prototype.getClasses = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var classNames = [];
        for (i = 0; i < objs.length; i++) {
            classNames.push.apply(// append
            classNames, objs[i].eventClassName || objs[i].className || []);
        }
        return classNames;
    };
    // Utility for generating event skin-related CSS properties
    EventRenderer.prototype.getSkinCss = function (eventDef) {
        return {
            'background-color': this.getBgColor(eventDef),
            'border-color': this.getBorderColor(eventDef),
            color: this.getTextColor(eventDef)
        };
    };
    // Queries for caller-specified color, then falls back to default
    EventRenderer.prototype.getBgColor = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var val;
        for (i = 0; i < objs.length && !val; i++) {
            val = objs[i].eventBackgroundColor || objs[i].eventColor ||
                objs[i].backgroundColor || objs[i].color;
        }
        if (!val) {
            val = this.opt('eventBackgroundColor') || this.opt('eventColor');
        }
        return val;
    };
    // Queries for caller-specified color, then falls back to default
    EventRenderer.prototype.getBorderColor = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var val;
        for (i = 0; i < objs.length && !val; i++) {
            val = objs[i].eventBorderColor || objs[i].eventColor ||
                objs[i].borderColor || objs[i].color;
        }
        if (!val) {
            val = this.opt('eventBorderColor') || this.opt('eventColor');
        }
        return val;
    };
    // Queries for caller-specified color, then falls back to default
    EventRenderer.prototype.getTextColor = function (eventDef) {
        var objs = this.getStylingObjs(eventDef);
        var i;
        var val;
        for (i = 0; i < objs.length && !val; i++) {
            val = objs[i].eventTextColor ||
                objs[i].textColor;
        }
        if (!val) {
            val = this.opt('eventTextColor');
        }
        return val;
    };
    EventRenderer.prototype.getStylingObjs = function (eventDef) {
        var objs = this.getFallbackStylingObjs(eventDef);
        objs.unshift(eventDef);
        return objs;
    };
    EventRenderer.prototype.getFallbackStylingObjs = function (eventDef) {
        return [eventDef.source];
    };
    EventRenderer.prototype.sortEventSegs = function (segs) {
        segs.sort(this.compareEventSegs.bind(this));
    };
    // A cmp function for determining which segments should take visual priority
    EventRenderer.prototype.compareEventSegs = function (seg1, seg2) {
        var f1 = seg1.footprint;
        var f2 = seg2.footprint;
        var cf1 = f1.componentFootprint;
        var cf2 = f2.componentFootprint;
        var r1 = cf1.unzonedRange;
        var r2 = cf2.unzonedRange;
        return r1.startMs - r2.startMs || // earlier events go first
            (r2.endMs - r2.startMs) - (r1.endMs - r1.startMs) || // tie? longer events go first
            cf2.isAllDay - cf1.isAllDay || // tie? put all-day events first (booleans cast to 0/1)
            misc_1.compareByFieldSpecs(f1.eventDef, f2.eventDef, this.view.eventOrderSpecs, f1.eventDef.miscProps, f2.eventDef.miscProps);
    };
    return EventRenderer;
}());
exports.default = EventRenderer;


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment_ext_1 = __webpack_require__(14);
// Plugin
// -------------------------------------------------------------------------------------------------
moment_ext_1.newMomentProto.format = function () {
    if (this._fullCalendar && arguments[0]) { // an enhanced moment? and a format string provided?
        return formatDate(this, arguments[0]); // our extended formatting
    }
    if (this._ambigTime) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
    }
    if (this._ambigZone) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
    }
    if (this._fullCalendar) { // enhanced non-ambig moment?
        // moment.format() doesn't ensure english, but we want to.
        return moment_ext_1.oldMomentFormat(englishMoment(this));
    }
    return moment_ext_1.oldMomentProto.format.apply(this, arguments);
};
moment_ext_1.newMomentProto.toISOString = function () {
    if (this._ambigTime) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD');
    }
    if (this._ambigZone) {
        return moment_ext_1.oldMomentFormat(englishMoment(this), 'YYYY-MM-DD[T]HH:mm:ss');
    }
    if (this._fullCalendar) { // enhanced non-ambig moment?
        // depending on browser, moment might not output english. ensure english.
        // https://github.com/moment/moment/blob/2.18.1/src/lib/moment/format.js#L22
        return moment_ext_1.oldMomentProto.toISOString.apply(englishMoment(this), arguments);
    }
    return moment_ext_1.oldMomentProto.toISOString.apply(this, arguments);
};
function englishMoment(mom) {
    if (mom.locale() !== 'en') {
        return mom.clone().locale('en');
    }
    return mom;
}
// Config
// ---------------------------------------------------------------------------------------------------------------------
/*
Inserted between chunks in the fake ("intermediate") formatting string.
Important that it passes as whitespace (\s) because moment often identifies non-standalone months
via a regexp with an \s.
*/
var PART_SEPARATOR = '\u000b'; // vertical tab
/*
Inserted as the first character of a literal-text chunk to indicate that the literal text is not actually literal text,
but rather, a "special" token that has custom rendering (see specialTokens map).
*/
var SPECIAL_TOKEN_MARKER = '\u001f'; // information separator 1
/*
Inserted at the beginning and end of a span of text that must have non-zero numeric characters.
Handling of these markers is done in a post-processing step at the very end of text rendering.
*/
var MAYBE_MARKER = '\u001e'; // information separator 2
var MAYBE_REGEXP = new RegExp(MAYBE_MARKER + '([^' + MAYBE_MARKER + ']*)' + MAYBE_MARKER, 'g'); // must be global
/*
Addition formatting tokens we want recognized
*/
var specialTokens = {
    t: function (date) {
        return moment_ext_1.oldMomentFormat(date, 'a').charAt(0);
    },
    T: function (date) {
        return moment_ext_1.oldMomentFormat(date, 'A').charAt(0);
    }
};
/*
The first characters of formatting tokens for units that are 1 day or larger.
`value` is for ranking relative size (lower means bigger).
`unit` is a normalized unit, used for comparing moments.
*/
var largeTokenMap = {
    Y: { value: 1, unit: 'year' },
    M: { value: 2, unit: 'month' },
    W: { value: 3, unit: 'week' },
    w: { value: 3, unit: 'week' },
    D: { value: 4, unit: 'day' },
    d: { value: 4, unit: 'day' } // day of week
};
// Single Date Formatting
// ---------------------------------------------------------------------------------------------------------------------
/*
Formats `date` with a Moment formatting string, but allow our non-zero areas and special token
*/
function formatDate(date, formatStr) {
    return renderFakeFormatString(getParsedFormatString(formatStr).fakeFormatString, date);
}
exports.formatDate = formatDate;
// Date Range Formatting
// -------------------------------------------------------------------------------------------------
// TODO: make it work with timezone offset
/*
Using a formatting string meant for a single date, generate a range string, like
"Sep 2 - 9 2013", that intelligently inserts a separator where the dates differ.
If the dates are the same as far as the format string is concerned, just return a single
rendering of one date, without any separator.
*/
function formatRange(date1, date2, formatStr, separator, isRTL) {
    var localeData;
    date1 = moment_ext_1.default.parseZone(date1);
    date2 = moment_ext_1.default.parseZone(date2);
    localeData = date1.localeData();
    // Expand localized format strings, like "LL" -> "MMMM D YYYY".
    // BTW, this is not important for `formatDate` because it is impossible to put custom tokens
    // or non-zero areas in Moment's localized format strings.
    formatStr = localeData.longDateFormat(formatStr) || formatStr;
    return renderParsedFormat(getParsedFormatString(formatStr), date1, date2, separator || ' - ', isRTL);
}
exports.formatRange = formatRange;
/*
Renders a range with an already-parsed format string.
*/
function renderParsedFormat(parsedFormat, date1, date2, separator, isRTL) {
    var sameUnits = parsedFormat.sameUnits;
    var unzonedDate1 = date1.clone().stripZone(); // for same-unit comparisons
    var unzonedDate2 = date2.clone().stripZone(); // "
    var renderedParts1 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date1);
    var renderedParts2 = renderFakeFormatStringParts(parsedFormat.fakeFormatString, date2);
    var leftI;
    var leftStr = '';
    var rightI;
    var rightStr = '';
    var middleI;
    var middleStr1 = '';
    var middleStr2 = '';
    var middleStr = '';
    // Start at the leftmost side of the formatting string and continue until you hit a token
    // that is not the same between dates.
    for (leftI = 0; leftI < sameUnits.length && (!sameUnits[leftI] || unzonedDate1.isSame(unzonedDate2, sameUnits[leftI])); leftI++) {
        leftStr += renderedParts1[leftI];
    }
    // Similarly, start at the rightmost side of the formatting string and move left
    for (rightI = sameUnits.length - 1; rightI > leftI && (!sameUnits[rightI] || unzonedDate1.isSame(unzonedDate2, sameUnits[rightI])); rightI--) {
        // If current chunk is on the boundary of unique date-content, and is a special-case
        // date-formatting postfix character, then don't consume it. Consider it unique date-content.
        // TODO: make configurable
        if (rightI - 1 === leftI && renderedParts1[rightI] === '.') {
            break;
        }
        rightStr = renderedParts1[rightI] + rightStr;
    }
    // The area in the middle is different for both of the dates.
    // Collect them distinctly so we can jam them together later.
    for (middleI = leftI; middleI <= rightI; middleI++) {
        middleStr1 += renderedParts1[middleI];
        middleStr2 += renderedParts2[middleI];
    }
    if (middleStr1 || middleStr2) {
        if (isRTL) {
            middleStr = middleStr2 + separator + middleStr1;
        }
        else {
            middleStr = middleStr1 + separator + middleStr2;
        }
    }
    return processMaybeMarkers(leftStr + middleStr + rightStr);
}
// Format String Parsing
// ---------------------------------------------------------------------------------------------------------------------
var parsedFormatStrCache = {};
/*
Returns a parsed format string, leveraging a cache.
*/
function getParsedFormatString(formatStr) {
    return parsedFormatStrCache[formatStr] ||
        (parsedFormatStrCache[formatStr] = parseFormatString(formatStr));
}
/*
Parses a format string into the following:
- fakeFormatString: a momentJS formatting string, littered with special control characters that get post-processed.
- sameUnits: for every part in fakeFormatString, if the part is a token, the value will be a unit string (like "day"),
  that indicates how similar a range's start & end must be in order to share the same formatted text.
  If not a token, then the value is null.
  Always a flat array (not nested liked "chunks").
*/
function parseFormatString(formatStr) {
    var chunks = chunkFormatString(formatStr);
    return {
        fakeFormatString: buildFakeFormatString(chunks),
        sameUnits: buildSameUnits(chunks)
    };
}
/*
Break the formatting string into an array of chunks.
A 'maybe' chunk will have nested chunks.
*/
function chunkFormatString(formatStr) {
    var chunks = [];
    var match;
    // TODO: more descrimination
    // \4 is a backreference to the first character of a multi-character set.
    var chunker = /\[([^\]]*)\]|\(([^\)]*)\)|(LTS|LT|(\w)\4*o?)|([^\w\[\(]+)/g;
    while ((match = chunker.exec(formatStr))) {
        if (match[1]) { // a literal string inside [ ... ]
            chunks.push.apply(chunks, // append
            splitStringLiteral(match[1]));
        }
        else if (match[2]) { // non-zero formatting inside ( ... )
            chunks.push({ maybe: chunkFormatString(match[2]) });
        }
        else if (match[3]) { // a formatting token
            chunks.push({ token: match[3] });
        }
        else if (match[5]) { // an unenclosed literal string
            chunks.push.apply(chunks, // append
            splitStringLiteral(match[5]));
        }
    }
    return chunks;
}
/*
Potentially splits a literal-text string into multiple parts. For special cases.
*/
function splitStringLiteral(s) {
    if (s === '. ') {
        return ['.', ' ']; // for locales with periods bound to the end of each year/month/date
    }
    else {
        return [s];
    }
}
/*
Given chunks parsed from a real format string, generate a fake (aka "intermediate") format string with special control
characters that will eventually be given to moment for formatting, and then post-processed.
*/
function buildFakeFormatString(chunks) {
    var parts = [];
    var i;
    var chunk;
    for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];
        if (typeof chunk === 'string') {
            parts.push('[' + chunk + ']');
        }
        else if (chunk.token) {
            if (chunk.token in specialTokens) {
                parts.push(SPECIAL_TOKEN_MARKER + // useful during post-processing
                    '[' + chunk.token + ']' // preserve as literal text
                );
            }
            else {
                parts.push(chunk.token); // unprotected text implies a format string
            }
        }
        else if (chunk.maybe) {
            parts.push(MAYBE_MARKER + // useful during post-processing
                buildFakeFormatString(chunk.maybe) +
                MAYBE_MARKER);
        }
    }
    return parts.join(PART_SEPARATOR);
}
/*
Given parsed chunks from a real formatting string, generates an array of unit strings (like "day") that indicate
in which regard two dates must be similar in order to share range formatting text.
The `chunks` can be nested (because of "maybe" chunks), however, the returned array will be flat.
*/
function buildSameUnits(chunks) {
    var units = [];
    var i;
    var chunk;
    var tokenInfo;
    for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];
        if (chunk.token) {
            tokenInfo = largeTokenMap[chunk.token.charAt(0)];
            units.push(tokenInfo ? tokenInfo.unit : 'second'); // default to a very strict same-second
        }
        else if (chunk.maybe) {
            units.push.apply(units, // append
            buildSameUnits(chunk.maybe));
        }
        else {
            units.push(null);
        }
    }
    return units;
}
// Rendering to text
// ---------------------------------------------------------------------------------------------------------------------
/*
Formats a date with a fake format string, post-processes the control characters, then returns.
*/
function renderFakeFormatString(fakeFormatString, date) {
    return processMaybeMarkers(renderFakeFormatStringParts(fakeFormatString, date).join(''));
}
/*
Formats a date into parts that will have been post-processed, EXCEPT for the "maybe" markers.
*/
function renderFakeFormatStringParts(fakeFormatString, date) {
    var parts = [];
    var fakeRender = moment_ext_1.oldMomentFormat(date, fakeFormatString);
    var fakeParts = fakeRender.split(PART_SEPARATOR);
    var i;
    var fakePart;
    for (i = 0; i < fakeParts.length; i++) {
        fakePart = fakeParts[i];
        if (fakePart.charAt(0) === SPECIAL_TOKEN_MARKER) {
            parts.push(
            // the literal string IS the token's name.
            // call special token's registered function.
            specialTokens[fakePart.substring(1)](date));
        }
        else {
            parts.push(fakePart);
        }
    }
    return parts;
}
/*
Accepts an almost-finally-formatted string and processes the "maybe" control characters, returning a new string.
*/
function processMaybeMarkers(s) {
    return s.replace(MAYBE_REGEXP, function (m0, m1) {
        if (m1.match(/[1-9]/)) { // any non-zero numeric characters?
            return m1;
        }
        else {
            return '';
        }
    });
}
// Misc Utils
// -------------------------------------------------------------------------------------------------
/*
Returns a unit string, either 'year', 'month', 'day', or null for the most granular formatting token in the string.
*/
function queryMostGranularFormatUnit(formatStr) {
    var chunks = chunkFormatString(formatStr);
    var i;
    var chunk;
    var candidate;
    var best;
    for (i = 0; i < chunks.length; i++) {
        chunk = chunks[i];
        if (chunk.token) {
            candidate = largeTokenMap[chunk.token.charAt(0)];
            if (candidate) {
                if (!best || candidate.value > best.value) {
                    best = candidate;
                }
            }
        }
    }
    if (best) {
        return best.unit;
    }
    return null;
}
exports.queryMostGranularFormatUnit = queryMostGranularFormatUnit;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Class_1 = __webpack_require__(38);
var EmitterMixin_1 = __webpack_require__(15);
var ListenerMixin_1 = __webpack_require__(12);
var Model = /** @class */ (function (_super) {
    tslib_1.__extends(Model, _super);
    function Model() {
        var _this = _super.call(this) || this;
        _this._watchers = {};
        _this._props = {};
        _this.applyGlobalWatchers();
        _this.constructed();
        return _this;
    }
    Model.watch = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // subclasses should make a masked-copy of the superclass's map
        // TODO: write test
        if (!this.prototype.hasOwnProperty('_globalWatchArgs')) {
            this.prototype._globalWatchArgs = Object.create(this.prototype._globalWatchArgs);
        }
        this.prototype._globalWatchArgs[name] = args;
    };
    Model.prototype.constructed = function () {
        // useful for monkeypatching. TODO: BaseClass?
    };
    Model.prototype.applyGlobalWatchers = function () {
        var map = this._globalWatchArgs;
        var name;
        for (name in map) {
            this.watch.apply(this, [name].concat(map[name]));
        }
    };
    Model.prototype.has = function (name) {
        return name in this._props;
    };
    Model.prototype.get = function (name) {
        if (name === undefined) {
            return this._props;
        }
        return this._props[name];
    };
    Model.prototype.set = function (name, val) {
        var newProps;
        if (typeof name === 'string') {
            newProps = {};
            newProps[name] = val === undefined ? null : val;
        }
        else {
            newProps = name;
        }
        this.setProps(newProps);
    };
    Model.prototype.reset = function (newProps) {
        var oldProps = this._props;
        var changeset = {}; // will have undefined's to signal unsets
        var name;
        for (name in oldProps) {
            changeset[name] = undefined;
        }
        for (name in newProps) {
            changeset[name] = newProps[name];
        }
        this.setProps(changeset);
    };
    Model.prototype.unset = function (name) {
        var newProps = {};
        var names;
        var i;
        if (typeof name === 'string') {
            names = [name];
        }
        else {
            names = name;
        }
        for (i = 0; i < names.length; i++) {
            newProps[names[i]] = undefined;
        }
        this.setProps(newProps);
    };
    Model.prototype.setProps = function (newProps) {
        var changedProps = {};
        var changedCnt = 0;
        var name;
        var val;
        for (name in newProps) {
            val = newProps[name];
            // a change in value?
            // if an object, don't check equality, because might have been mutated internally.
            // TODO: eventually enforce immutability.
            if ((typeof val === 'object' && val) || // non-null object
                val !== this._props[name]) {
                changedProps[name] = val;
                changedCnt++;
            }
        }
        if (changedCnt) {
            this.trigger('before:batchChange', changedProps);
            for (name in changedProps) {
                val = changedProps[name];
                this.trigger('before:change', name, val);
                this.trigger('before:change:' + name, val);
            }
            for (name in changedProps) {
                val = changedProps[name];
                if (val === undefined) {
                    delete this._props[name];
                }
                else {
                    this._props[name] = val;
                }
                this.trigger('change:' + name, val);
                this.trigger('change', name, val);
            }
            this.trigger('batchChange', changedProps);
        }
    };
    Model.prototype.watch = function (name, depList, startFunc, stopFunc, isAsync) {
        var _this = this;
        if (isAsync === void 0) { isAsync = false; }
        this.unwatch(name);
        this._watchers[name] = this._watchDeps(depList, function (deps) {
            if (isAsync) { // means startFunc accepts a callback function that it will call
                _this.unset(name); // put in an unset state while resolving
                startFunc.call(_this, deps, function (val) {
                    _this.set(name, val);
                });
            }
            else {
                var res = startFunc.call(_this, deps);
                _this.set(name, res);
            }
        }, function (deps) {
            _this.unset(name);
            if (stopFunc) {
                stopFunc.call(_this, deps);
            }
        });
    };
    Model.prototype.unwatch = function (name) {
        var watcher = this._watchers[name];
        if (watcher) {
            delete this._watchers[name];
            watcher.teardown();
        }
    };
    Model.prototype._watchDeps = function (depList, startFunc, stopFunc) {
        var _this = this;
        var queuedChangeCnt = 0;
        var depCnt = depList.length;
        var satisfyCnt = 0;
        var values = {}; // what's passed as the `deps` arguments
        var bindTuples = []; // array of [ eventName, handlerFunc ] arrays
        var isCallingStop = false;
        var onBeforeDepChange = function (depName, val, isOptional) {
            queuedChangeCnt++;
            if (queuedChangeCnt === 1) { // first change to cause a "stop" ?
                if (satisfyCnt === depCnt) { // all deps previously satisfied?
                    isCallingStop = true;
                    stopFunc(values);
                    isCallingStop = false;
                }
            }
        };
        var onDepChange = function (depName, val, isOptional) {
            if (val === undefined) { // unsetting a value?
                // required dependency that was previously set?
                if (!isOptional && values[depName] !== undefined) {
                    satisfyCnt--;
                }
                delete values[depName];
            }
            else { // setting a value?
                // required dependency that was previously unset?
                if (!isOptional && values[depName] === undefined) {
                    satisfyCnt++;
                }
                values[depName] = val;
            }
            queuedChangeCnt--;
            if (!queuedChangeCnt) { // last change to cause a "start"?
                // now finally satisfied or satisfied all along?
                if (satisfyCnt === depCnt) {
                    // if the stopFunc initiated another value change, ignore it.
                    // it will be processed by another change event anyway.
                    if (!isCallingStop) {
                        startFunc(values);
                    }
                }
            }
        };
        // intercept for .on() that remembers handlers
        var bind = function (eventName, handler) {
            _this.on(eventName, handler);
            bindTuples.push([eventName, handler]);
        };
        // listen to dependency changes
        depList.forEach(function (depName) {
            var isOptional = false;
            if (depName.charAt(0) === '?') { // TODO: more DRY
                depName = depName.substring(1);
                isOptional = true;
            }
            bind('before:change:' + depName, function (val) {
                onBeforeDepChange(depName, val, isOptional);
            });
            bind('change:' + depName, function (val) {
                onDepChange(depName, val, isOptional);
            });
        });
        // process current dependency values
        depList.forEach(function (depName) {
            var isOptional = false;
            if (depName.charAt(0) === '?') { // TODO: more DRY
                depName = depName.substring(1);
                isOptional = true;
            }
            if (_this.has(depName)) {
                values[depName] = _this.get(depName);
                satisfyCnt++;
            }
            else if (isOptional) {
                satisfyCnt++;
            }
        });
        // initially satisfied
        if (satisfyCnt === depCnt) {
            startFunc(values);
        }
        return {
            teardown: function () {
                // remove all handlers
                for (var i = 0; i < bindTuples.length; i++) {
                    _this.off(bindTuples[i][0], bindTuples[i][1]);
                }
                bindTuples = null;
                // was satisfied, so call stopFunc
                if (satisfyCnt === depCnt) {
                    stopFunc();
                }
            },
            flash: function () {
                if (satisfyCnt === depCnt) {
                    stopFunc();
                    startFunc(values);
                }
            }
        };
    };
    Model.prototype.flash = function (name) {
        var watcher = this._watchers[name];
        if (watcher) {
            watcher.flash();
        }
    };
    return Model;
}(Class_1.default));
exports.default = Model;
Model.prototype._globalWatchArgs = {}; // mutation protection in Model.watch
EmitterMixin_1.default.mixInto(Model);
ListenerMixin_1.default.mixInto(Model);


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var date_1 = __webpack_require__(8);
var SingleEventDef_1 = __webpack_require__(17);
var RecurringEventDef_1 = __webpack_require__(218);
exports.default = {
    parse: function (eventInput, source) {
        if (date_1.isTimeString(eventInput.start) || moment.isDuration(eventInput.start) ||
            date_1.isTimeString(eventInput.end) || moment.isDuration(eventInput.end)) {
            return RecurringEventDef_1.default.parse(eventInput, source);
        }
        else {
            return SingleEventDef_1.default.parse(eventInput, source);
        }
    }
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var date_1 = __webpack_require__(8);
var EventDateProfile_1 = __webpack_require__(22);
var EventDefDateMutation = /** @class */ (function () {
    function EventDefDateMutation() {
        this.clearEnd = false;
        this.forceTimed = false;
        this.forceAllDay = false;
    }
    EventDefDateMutation.createFromDiff = function (dateProfile0, dateProfile1, largeUnit) {
        var clearEnd = dateProfile0.end && !dateProfile1.end;
        var forceTimed = dateProfile0.isAllDay() && !dateProfile1.isAllDay();
        var forceAllDay = !dateProfile0.isAllDay() && dateProfile1.isAllDay();
        var dateDelta;
        var endDiff;
        var endDelta;
        var mutation;
        // subtracts the dates in the appropriate way, returning a duration
        function subtractDates(date1, date0) {
            if (largeUnit) {
                return date_1.diffByUnit(date1, date0, largeUnit); // poorly named
            }
            else if (dateProfile1.isAllDay()) {
                return date_1.diffDay(date1, date0); // poorly named
            }
            else {
                return date_1.diffDayTime(date1, date0); // poorly named
            }
        }
        dateDelta = subtractDates(dateProfile1.start, dateProfile0.start);
        if (dateProfile1.end) {
            // use unzonedRanges because dateProfile0.end might be null
            endDiff = subtractDates(dateProfile1.unzonedRange.getEnd(), dateProfile0.unzonedRange.getEnd());
            endDelta = endDiff.subtract(dateDelta);
        }
        mutation = new EventDefDateMutation();
        mutation.clearEnd = clearEnd;
        mutation.forceTimed = forceTimed;
        mutation.forceAllDay = forceAllDay;
        mutation.setDateDelta(dateDelta);
        mutation.setEndDelta(endDelta);
        return mutation;
    };
    /*
    returns an undo function.
    */
    EventDefDateMutation.prototype.buildNewDateProfile = function (eventDateProfile, calendar) {
        var start = eventDateProfile.start.clone();
        var end = null;
        var shouldRezone = false;
        if (eventDateProfile.end && !this.clearEnd) {
            end = eventDateProfile.end.clone();
        }
        else if (this.endDelta && !end) {
            end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
        }
        if (this.forceTimed) {
            shouldRezone = true;
            if (!start.hasTime()) {
                start.time(0);
            }
            if (end && !end.hasTime()) {
                end.time(0);
            }
        }
        else if (this.forceAllDay) {
            if (start.hasTime()) {
                start.stripTime();
            }
            if (end && end.hasTime()) {
                end.stripTime();
            }
        }
        if (this.dateDelta) {
            shouldRezone = true;
            start.add(this.dateDelta);
            if (end) {
                end.add(this.dateDelta);
            }
        }
        // do this before adding startDelta to start, so we can work off of start
        if (this.endDelta) {
            shouldRezone = true;
            end.add(this.endDelta);
        }
        if (this.startDelta) {
            shouldRezone = true;
            start.add(this.startDelta);
        }
        if (shouldRezone) {
            start = calendar.applyTimezone(start);
            if (end) {
                end = calendar.applyTimezone(end);
            }
        }
        // TODO: okay to access calendar option?
        if (!end && calendar.opt('forceEventDuration')) {
            end = calendar.getDefaultEventEnd(eventDateProfile.isAllDay(), start);
        }
        return new EventDateProfile_1.default(start, end, calendar);
    };
    EventDefDateMutation.prototype.setDateDelta = function (dateDelta) {
        if (dateDelta && dateDelta.valueOf()) {
            this.dateDelta = dateDelta;
        }
        else {
            this.dateDelta = null;
        }
    };
    EventDefDateMutation.prototype.setStartDelta = function (startDelta) {
        if (startDelta && startDelta.valueOf()) {
            this.startDelta = startDelta;
        }
        else {
            this.startDelta = null;
        }
    };
    EventDefDateMutation.prototype.setEndDelta = function (endDelta) {
        if (endDelta && endDelta.valueOf()) {
            this.endDelta = endDelta;
        }
        else {
            this.endDelta = null;
        }
    };
    EventDefDateMutation.prototype.isEmpty = function () {
        return !this.clearEnd && !this.forceTimed && !this.forceAllDay &&
            !this.dateDelta && !this.startDelta && !this.endDelta;
    };
    return EventDefDateMutation;
}());
exports.default = EventDefDateMutation;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var StandardTheme_1 = __webpack_require__(221);
var JqueryUiTheme_1 = __webpack_require__(222);
var themeClassHash = {};
function defineThemeSystem(themeName, themeClass) {
    themeClassHash[themeName] = themeClass;
}
exports.defineThemeSystem = defineThemeSystem;
function getThemeSystemClass(themeSetting) {
    if (!themeSetting) {
        return StandardTheme_1.default;
    }
    else if (themeSetting === true) {
        return JqueryUiTheme_1.default;
    }
    else {
        return themeClassHash[themeSetting];
    }
}
exports.getThemeSystemClass = getThemeSystemClass;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var array_1 = __webpack_require__(21);
var EventSource_1 = __webpack_require__(9);
var SingleEventDef_1 = __webpack_require__(17);
var ArrayEventSource = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayEventSource, _super);
    function ArrayEventSource(calendar) {
        var _this = _super.call(this, calendar) || this;
        _this.eventDefs = []; // for if setRawEventDefs is never called
        return _this;
    }
    ArrayEventSource.parse = function (rawInput, calendar) {
        var rawProps;
        // normalize raw input
        if (Array.isArray(rawInput.events)) { // extended form
            rawProps = rawInput;
        }
        else if (Array.isArray(rawInput)) { // short form
            rawProps = { events: rawInput };
        }
        if (rawProps) {
            return EventSource_1.default.parse.call(this, rawProps, calendar);
        }
        return false;
    };
    ArrayEventSource.prototype.setRawEventDefs = function (rawEventDefs) {
        this.rawEventDefs = rawEventDefs;
        this.eventDefs = this.parseEventDefs(rawEventDefs);
    };
    ArrayEventSource.prototype.fetch = function (start, end, timezone, onSuccess, onFailure) {
        var eventDefs = this.eventDefs;
        var i;
        if (this.currentTimezone != null &&
            this.currentTimezone !== timezone) {
            for (i = 0; i < eventDefs.length; i++) {
                if (eventDefs[i] instanceof SingleEventDef_1.default) {
                    eventDefs[i].rezone();
                }
            }
        }
        this.currentTimezone = timezone;
        onSuccess(eventDefs);
    };
    ArrayEventSource.prototype.addEventDef = function (eventDef) {
        this.eventDefs.push(eventDef);
    };
    /*
    eventDefId already normalized to a string
    */
    ArrayEventSource.prototype.removeEventDefsById = function (eventDefId) {
        return array_1.removeMatching(this.eventDefs, function (eventDef) {
            return eventDef.id === eventDefId;
        });
    };
    ArrayEventSource.prototype.removeAllEventDefs = function () {
        this.eventDefs = [];
    };
    ArrayEventSource.prototype.getPrimitive = function () {
        return this.rawEventDefs;
    };
    ArrayEventSource.prototype.applyManualStandardProps = function (rawProps) {
        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
        this.setRawEventDefs(rawProps.events);
        return superSuccess;
    };
    return ArrayEventSource;
}(EventSource_1.default));
exports.default = ArrayEventSource;
ArrayEventSource.defineStandardProps({
    events: false // don't automatically transfer
});


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_58__;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var dom_geom_1 = __webpack_require__(13);
/*
A cache for the left/right/top/bottom/width/height values for one or more elements.
Works with both offset (from topleft document) and position (from offsetParent).

options:
- els
- isHorizontal
- isVertical
*/
var CoordCache = /** @class */ (function () {
    function CoordCache(options) {
        this.isHorizontal = false; // whether to query for left/right/width
        this.isVertical = false; // whether to query for top/bottom/height
        this.els = options.els;
        this.isHorizontal = options.isHorizontal;
        this.isVertical = options.isVertical;
        this.forcedOffsetParentEl = options.offsetParent;
    }
    // Queries the els for coordinates and stores them.
    // Call this method before using and of the get* methods below.
    CoordCache.prototype.build = function () {
        var offsetParentEl = this.forcedOffsetParentEl;
        if (!offsetParentEl && this.els.length > 0) {
            offsetParentEl = this.els[0].offsetParent;
        }
        if (offsetParentEl) {
            var offsetParentRect = offsetParentEl.getBoundingClientRect();
            this.origin = { top: offsetParentRect.top, left: offsetParentRect.left };
            this.boundingRect = this.queryBoundingRect();
            if (this.isHorizontal) {
                this.buildElHorizontals();
            }
            if (this.isVertical) {
                this.buildElVerticals();
            }
        }
        else {
            this.lefts = [];
            this.rights = [];
            this.tops = [];
            this.bottoms = [];
        }
    };
    // Destroys all internal data about coordinates, freeing memory
    CoordCache.prototype.clear = function () {
        this.origin = null;
        this.boundingRect = null;
        this.lefts = null;
        this.rights = null;
        this.tops = null;
        this.bottoms = null;
    };
    // When called, if coord caches aren't built, builds them
    CoordCache.prototype.ensureBuilt = function () {
        if (!this.origin) {
            this.build();
        }
    };
    // Populates the left/right internal coordinate arrays
    CoordCache.prototype.buildElHorizontals = function () {
        var lefts = [];
        var rights = [];
        this.els.forEach(function (node) {
            var rect = node.getBoundingClientRect();
            lefts.push(rect.left);
            rights.push(rect.right);
        });
        this.lefts = lefts;
        this.rights = rights;
    };
    // Populates the top/bottom internal coordinate arrays
    CoordCache.prototype.buildElVerticals = function () {
        var tops = [];
        var bottoms = [];
        this.els.forEach(function (node) {
            var rect = node.getBoundingClientRect();
            tops.push(rect.top);
            bottoms.push(rect.bottom);
        });
        this.tops = tops;
        this.bottoms = bottoms;
    };
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    CoordCache.prototype.getHorizontalIndex = function (leftOffset) {
        this.ensureBuilt();
        var lefts = this.lefts;
        var rights = this.rights;
        var len = lefts.length;
        var i;
        for (i = 0; i < len; i++) {
            if (leftOffset >= lefts[i] && leftOffset < rights[i]) {
                return i;
            }
        }
    };
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    CoordCache.prototype.getVerticalIndex = function (topOffset) {
        this.ensureBuilt();
        var tops = this.tops;
        var bottoms = this.bottoms;
        var len = tops.length;
        var i;
        for (i = 0; i < len; i++) {
            if (topOffset >= tops[i] && topOffset < bottoms[i]) {
                return i;
            }
        }
    };
    // Gets the left offset (from document left) of the element at the given index
    CoordCache.prototype.getLeftOffset = function (leftIndex) {
        this.ensureBuilt();
        return this.lefts[leftIndex];
    };
    // Gets the left position (from offsetParent left) of the element at the given index
    CoordCache.prototype.getLeftPosition = function (leftIndex) {
        this.ensureBuilt();
        return this.lefts[leftIndex] - this.origin.left;
    };
    // Gets the right offset (from document left) of the element at the given index.
    // This value is NOT relative to the document's right edge, like the CSS concept of "right" would be.
    CoordCache.prototype.getRightOffset = function (leftIndex) {
        this.ensureBuilt();
        return this.rights[leftIndex];
    };
    // Gets the right position (from offsetParent left) of the element at the given index.
    // This value is NOT relative to the offsetParent's right edge, like the CSS concept of "right" would be.
    CoordCache.prototype.getRightPosition = function (leftIndex) {
        this.ensureBuilt();
        return this.rights[leftIndex] - this.origin.left;
    };
    // Gets the width of the element at the given index
    CoordCache.prototype.getWidth = function (leftIndex) {
        this.ensureBuilt();
        return this.rights[leftIndex] - this.lefts[leftIndex];
    };
    // Gets the top offset (from document top) of the element at the given index
    CoordCache.prototype.getTopOffset = function (topIndex) {
        this.ensureBuilt();
        return this.tops[topIndex];
    };
    // Gets the top position (from offsetParent top) of the element at the given position
    CoordCache.prototype.getTopPosition = function (topIndex) {
        this.ensureBuilt();
        return this.tops[topIndex] - this.origin.top;
    };
    // Gets the bottom offset (from the document top) of the element at the given index.
    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
    CoordCache.prototype.getBottomOffset = function (topIndex) {
        this.ensureBuilt();
        return this.bottoms[topIndex];
    };
    // Gets the bottom position (from the offsetParent top) of the element at the given index.
    // This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
    CoordCache.prototype.getBottomPosition = function (topIndex) {
        this.ensureBuilt();
        return this.bottoms[topIndex] - this.origin.top;
    };
    // Gets the height of the element at the given index
    CoordCache.prototype.getHeight = function (topIndex) {
        this.ensureBuilt();
        return this.bottoms[topIndex] - this.tops[topIndex];
    };
    // Bounding Rect
    // TODO: decouple this from CoordCache
    // Compute and return what the elements' bounding rectangle is, from the user's perspective.
    // Right now, only returns a rectangle if constrained by an overflow:scroll element.
    // Returns null if there are no elements
    CoordCache.prototype.queryBoundingRect = function () {
        var scrollParentEl;
        if (this.els.length > 0) {
            scrollParentEl = dom_geom_1.getScrollParent(this.els[0]);
            if (scrollParentEl) {
                return dom_geom_1.computeInnerRect(scrollParentEl);
            }
        }
        return null;
    };
    CoordCache.prototype.isPointInBounds = function (leftOffset, topOffset) {
        return this.isLeftInBounds(leftOffset) && this.isTopInBounds(topOffset);
    };
    CoordCache.prototype.isLeftInBounds = function (leftOffset) {
        return !this.boundingRect || (leftOffset >= this.boundingRect.left && leftOffset < this.boundingRect.right);
    };
    CoordCache.prototype.isTopInBounds = function (topOffset) {
        return !this.boundingRect || (topOffset >= this.boundingRect.top && topOffset < this.boundingRect.bottom);
    };
    return CoordCache;
}());
exports.default = CoordCache;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var dom_geom_1 = __webpack_require__(13);
var dom_event_1 = __webpack_require__(10);
var misc_1 = __webpack_require__(4);
var ListenerMixin_1 = __webpack_require__(12);
var GlobalEmitter_1 = __webpack_require__(25);
/* Tracks a drag's mouse movement, firing various handlers
----------------------------------------------------------------------------------------------------------------------*/
// TODO: use Emitter
var DragListener = /** @class */ (function () {
    function DragListener(options) {
        this.isInteracting = false;
        this.isDistanceSurpassed = false;
        this.isDelayEnded = false;
        this.isDragging = false;
        this.isTouch = false;
        this.skipBinding = false; // if true, don't watch mouse/touch events
        this.shouldCancelTouchScroll = true;
        this.scrollAlwaysKills = false;
        this.isAutoScroll = false;
        // defaults
        this.scrollSensitivity = 30; // pixels from edge for scrolling to start
        this.scrollSpeed = 200; // pixels per second, at maximum speed
        this.scrollIntervalMs = 50; // millisecond wait between scroll increment
        this.options = options || {};
    }
    // Interaction (high-level)
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.startInteraction = function (ev, extraOptions) {
        if (extraOptions === void 0) { extraOptions = {}; }
        if (ev.type === 'mousedown') {
            if (GlobalEmitter_1.default.get().shouldIgnoreMouse()) {
                return;
            }
            else if (!dom_event_1.isPrimaryMouseButton(ev)) {
                return;
            }
            else {
                ev.preventDefault(); // prevents native selection in most browsers
            }
        }
        if (!this.isInteracting) {
            // process options
            this.delay = misc_1.firstDefined(extraOptions.delay, this.options.delay, 0);
            this.minDistance = misc_1.firstDefined(extraOptions.distance, this.options.distance, 0);
            this.subjectEl = this.options.subjectEl;
            misc_1.preventSelection(document.body);
            this.isInteracting = true;
            this.isTouch = dom_event_1.getEvIsTouch(ev);
            this.isDelayEnded = false;
            this.isDistanceSurpassed = false;
            this.originX = dom_event_1.getEvX(ev);
            this.originY = dom_event_1.getEvY(ev);
            this.scrollEl = dom_geom_1.getScrollParent(ev.target);
            this.bindHandlers();
            this.initAutoScroll();
            this.handleInteractionStart(ev);
            this.startDelay(ev);
            if (!this.minDistance) {
                this.handleDistanceSurpassed(ev);
            }
        }
    };
    DragListener.prototype.handleInteractionStart = function (ev) {
        this.trigger('interactionStart', ev);
    };
    DragListener.prototype.endInteraction = function (ev, isCancelled) {
        if (this.isInteracting) {
            this.endDrag(ev);
            if (this.delayTimeoutId) {
                clearTimeout(this.delayTimeoutId);
                this.delayTimeoutId = null;
            }
            this.destroyAutoScroll();
            this.unbindHandlers();
            this.isInteracting = false;
            this.handleInteractionEnd(ev, isCancelled);
            misc_1.allowSelection(document.body);
        }
    };
    DragListener.prototype.handleInteractionEnd = function (ev, isCancelled) {
        this.trigger('interactionEnd', ev, isCancelled || false);
    };
    // Binding To DOM
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.bindHandlers = function () {
        // some browsers (Safari in iOS 10) don't allow preventDefault on touch events that are bound after touchstart,
        // so listen to the GlobalEmitter singleton, which is always bound, instead of the document directly.
        var globalEmitter = GlobalEmitter_1.default.get();
        if (this.skipBinding) {
            //
        }
        else if (this.isTouch) {
            this.listenTo(globalEmitter, {
                touchmove: this.handleTouchMove,
                touchend: this.endInteraction,
                scroll: this.handleTouchScroll
            });
        }
        else {
            this.listenTo(globalEmitter, {
                mousemove: this.handleMouseMove,
                mouseup: this.endInteraction
            });
        }
        this.listenTo(globalEmitter, {
            selectstart: dom_event_1.preventDefault,
            contextmenu: dom_event_1.preventDefault // long taps would open menu on Chrome dev tools
        });
    };
    DragListener.prototype.unbindHandlers = function () {
        this.stopListeningTo(GlobalEmitter_1.default.get());
    };
    // Drag (high-level)
    // -----------------------------------------------------------------------------------------------------------------
    // extraOptions ignored if drag already started
    DragListener.prototype.startDrag = function (ev, extraOptions) {
        this.startInteraction(ev, extraOptions); // ensure interaction began
        if (!this.isDragging) {
            this.isDragging = true;
            this.handleDragStart(ev);
        }
    };
    DragListener.prototype.handleDragStart = function (ev) {
        this.trigger('dragStart', ev);
    };
    DragListener.prototype.handleMove = function (ev) {
        var dx = dom_event_1.getEvX(ev) - this.originX;
        var dy = dom_event_1.getEvY(ev) - this.originY;
        var minDistance = this.minDistance;
        var distanceSq; // current distance from the origin, squared
        if (!this.isDistanceSurpassed) {
            distanceSq = dx * dx + dy * dy;
            if (distanceSq >= minDistance * minDistance) { // use pythagorean theorem
                this.handleDistanceSurpassed(ev);
            }
        }
        if (this.isDragging) {
            this.handleDrag(dx, dy, ev);
        }
    };
    // Called while the mouse is being moved and when we know a legitimate drag is taking place
    DragListener.prototype.handleDrag = function (dx, dy, ev) {
        this.trigger('drag', dx, dy, ev);
        this.updateAutoScroll(ev); // will possibly cause scrolling
    };
    DragListener.prototype.endDrag = function (ev) {
        if (this.isDragging) {
            this.isDragging = false;
            this.handleDragEnd(ev);
        }
    };
    DragListener.prototype.handleDragEnd = function (ev) {
        this.trigger('dragEnd', ev);
    };
    // Delay
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.startDelay = function (initialEv) {
        var _this = this;
        if (this.delay) {
            this.delayTimeoutId = setTimeout(function () {
                _this.handleDelayEnd(initialEv);
            }, this.delay);
        }
        else {
            this.handleDelayEnd(initialEv);
        }
    };
    DragListener.prototype.handleDelayEnd = function (initialEv) {
        this.isDelayEnded = true;
        if (this.isDistanceSurpassed) {
            this.startDrag(initialEv);
        }
    };
    // Distance
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.handleDistanceSurpassed = function (ev) {
        this.isDistanceSurpassed = true;
        if (this.isDelayEnded) {
            this.startDrag(ev);
        }
    };
    // Mouse / Touch
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.handleTouchMove = function (ev) {
        // prevent inertia and touchmove-scrolling while dragging
        if (this.isDragging && this.shouldCancelTouchScroll) {
            ev.preventDefault();
        }
        this.handleMove(ev);
    };
    DragListener.prototype.handleMouseMove = function (ev) {
        this.handleMove(ev);
    };
    // Scrolling (unrelated to auto-scroll)
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.handleTouchScroll = function (ev) {
        // if the drag is being initiated by touch, but a scroll happens before
        // the drag-initiating delay is over, cancel the drag
        if (!this.isDragging || this.scrollAlwaysKills) {
            this.endInteraction(ev, true); // isCancelled=true
        }
    };
    // Utils
    // -----------------------------------------------------------------------------------------------------------------
    // Triggers a callback. Calls a function in the option hash of the same name.
    // Arguments beyond the first `name` are forwarded on.
    DragListener.prototype.trigger = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.options[name]) {
            this.options[name].apply(this, args);
        }
        // makes _methods callable by event name. TODO: kill this
        if (this['_' + name]) {
            this['_' + name].apply(this, args);
        }
    };
    // Auto-scroll
    // -----------------------------------------------------------------------------------------------------------------
    DragListener.prototype.initAutoScroll = function () {
        var scrollEl = this.scrollEl;
        this.isAutoScroll = Boolean(this.options.scroll && scrollEl);
        if (this.isAutoScroll) {
            // debounce makes sure rapid calls don't happen
            this.listenTo(scrollEl, 'scroll', misc_1.debounce(this.handleDebouncedScroll, 100));
        }
    };
    DragListener.prototype.destroyAutoScroll = function () {
        this.endAutoScroll(); // kill any animation loop
        // remove the scroll handler if there is a scrollEl
        if (this.isAutoScroll) {
            this.stopListeningTo(this.scrollEl, 'scroll'); // will probably get removed by unbindHandlers too :(
        }
    };
    // Computes and stores the bounding rectangle of scrollEl
    DragListener.prototype.computeScrollBounds = function () {
        if (this.isAutoScroll) {
            this.scrollBounds = this.scrollEl.getBoundingClientRect();
            // TODO: use computeInnerRect in future. but prevents auto scrolling when on top of scrollbars
        }
    };
    // Called when the dragging is in progress and scrolling should be updated
    DragListener.prototype.updateAutoScroll = function (ev) {
        var sensitivity = this.scrollSensitivity;
        var bounds = this.scrollBounds;
        var topCloseness;
        var bottomCloseness;
        var leftCloseness;
        var rightCloseness;
        var topVel = 0;
        var leftVel = 0;
        if (bounds) { // only scroll if scrollEl exists
            // compute closeness to edges. valid range is from 0.0 - 1.0
            topCloseness = (sensitivity - (dom_event_1.getEvY(ev) - bounds.top)) / sensitivity;
            bottomCloseness = (sensitivity - (bounds.bottom - dom_event_1.getEvY(ev))) / sensitivity;
            leftCloseness = (sensitivity - (dom_event_1.getEvX(ev) - bounds.left)) / sensitivity;
            rightCloseness = (sensitivity - (bounds.right - dom_event_1.getEvX(ev))) / sensitivity;
            // translate vertical closeness into velocity.
            // mouse must be completely in bounds for velocity to happen.
            if (topCloseness >= 0 && topCloseness <= 1) {
                topVel = topCloseness * this.scrollSpeed * -1; // negative. for scrolling up
            }
            else if (bottomCloseness >= 0 && bottomCloseness <= 1) {
                topVel = bottomCloseness * this.scrollSpeed;
            }
            // translate horizontal closeness into velocity
            if (leftCloseness >= 0 && leftCloseness <= 1) {
                leftVel = leftCloseness * this.scrollSpeed * -1; // negative. for scrolling left
            }
            else if (rightCloseness >= 0 && rightCloseness <= 1) {
                leftVel = rightCloseness * this.scrollSpeed;
            }
        }
        this.setScrollVel(topVel, leftVel);
    };
    // Sets the speed-of-scrolling for the scrollEl
    DragListener.prototype.setScrollVel = function (topVel, leftVel) {
        this.scrollTopVel = topVel;
        this.scrollLeftVel = leftVel;
        this.constrainScrollVel(); // massages into realistic values
        // if there is non-zero velocity, and an animation loop hasn't already started, then START
        if ((this.scrollTopVel || this.scrollLeftVel) && !this.scrollIntervalId) {
            this.scrollIntervalId = setInterval(this.scrollIntervalFunc.bind(this), this.scrollIntervalMs);
        }
    };
    // Forces scrollTopVel and scrollLeftVel to be zero if scrolling has already gone all the way
    DragListener.prototype.constrainScrollVel = function () {
        var el = this.scrollEl;
        if (this.scrollTopVel < 0) { // scrolling up?
            if (el.scrollTop <= 0) { // already scrolled all the way up?
                this.scrollTopVel = 0;
            }
        }
        else if (this.scrollTopVel > 0) { // scrolling down?
            if (el.scrollTop + el.clientHeight >= el.scrollHeight) { // already scrolled all the way down?
                this.scrollTopVel = 0;
            }
        }
        if (this.scrollLeftVel < 0) { // scrolling left?
            if (el.scrollLeft <= 0) { // already scrolled all the left?
                this.scrollLeftVel = 0;
            }
        }
        else if (this.scrollLeftVel > 0) { // scrolling right?
            if (el.scrollLeft + el.clientWidth >= el.scrollWidth) { // already scrolled all the way right?
                this.scrollLeftVel = 0;
            }
        }
    };
    // This function gets called during every iteration of the scrolling animation loop
    DragListener.prototype.scrollIntervalFunc = function () {
        var el = this.scrollEl;
        var frac = this.scrollIntervalMs / 1000; // considering animation frequency, what the vel should be mult'd by
        // change the value of scrollEl's scroll
        if (this.scrollTopVel) {
            el.scrollTop = el.scrollTop + this.scrollTopVel * frac;
        }
        if (this.scrollLeftVel) {
            el.scrollLeft = el.scrollLeft + this.scrollLeftVel * frac;
        }
        this.constrainScrollVel(); // since the scroll values changed, recompute the velocities
        // if scrolled all the way, which causes the vels to be zero, stop the animation loop
        if (!this.scrollTopVel && !this.scrollLeftVel) {
            this.endAutoScroll();
        }
    };
    // Kills any existing scrolling animation loop
    DragListener.prototype.endAutoScroll = function () {
        if (this.scrollIntervalId) {
            clearInterval(this.scrollIntervalId);
            this.scrollIntervalId = null;
            this.handleScrollEnd();
        }
    };
    // Get called when the scrollEl is scrolled (NOTE: this is delayed via debounce)
    DragListener.prototype.handleDebouncedScroll = function () {
        // recompute all coordinates, but *only* if this is *not* part of our scrolling animation
        if (!this.scrollIntervalId) {
            this.handleScrollEnd();
        }
    };
    DragListener.prototype.handleScrollEnd = function () {
        // Called when scrolling has stopped, whether through auto scroll, or the user scrolling
    };
    return DragListener;
}());
exports.default = DragListener;
ListenerMixin_1.default.mixInto(DragListener);


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var html_1 = __webpack_require__(6);
var date_1 = __webpack_require__(8);
var dom_manip_1 = __webpack_require__(3);
var Mixin_1 = __webpack_require__(18);
/*
A set of rendering and date-related methods for a visual component comprised of one or more rows of day columns.
Prerequisite: the object being mixed into needs to be a *Grid*
*/
var DayTableMixin = /** @class */ (function (_super) {
    tslib_1.__extends(DayTableMixin, _super);
    function DayTableMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Populates internal variables used for date calculation and rendering
    DayTableMixin.prototype.updateDayTable = function () {
        var t = this;
        var view = t.view;
        var calendar = view.calendar;
        var date = calendar.msToUtcMoment(t.dateProfile.renderUnzonedRange.startMs, true);
        var end = calendar.msToUtcMoment(t.dateProfile.renderUnzonedRange.endMs, true);
        var dayIndex = -1;
        var dayIndices = [];
        var dayDates = [];
        var daysPerRow;
        var firstDay;
        var rowCnt;
        while (date.isBefore(end)) { // loop each day from start to end
            if (view.isHiddenDay(date)) {
                dayIndices.push(dayIndex + 0.5); // mark that it's between indices
            }
            else {
                dayIndex++;
                dayIndices.push(dayIndex);
                dayDates.push(date.clone());
            }
            date.add(1, 'days');
        }
        if (this.breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dayDates[0].day();
            for (daysPerRow = 1; daysPerRow < dayDates.length; daysPerRow++) {
                if (dayDates[daysPerRow].day() === firstDay) {
                    break;
                }
            }
            rowCnt = Math.ceil(dayDates.length / daysPerRow);
        }
        else {
            rowCnt = 1;
            daysPerRow = dayDates.length;
        }
        this.dayDates = dayDates;
        this.dayIndices = dayIndices;
        this.daysPerRow = daysPerRow;
        this.rowCnt = rowCnt;
        this.updateDayTableCols();
    };
    // Computes and assigned the colCnt property and updates any options that may be computed from it
    DayTableMixin.prototype.updateDayTableCols = function () {
        this.colCnt = this.computeColCnt();
        this.colHeadFormat =
            this.opt('columnHeaderFormat') ||
                this.opt('columnFormat') || // deprecated
                this.computeColHeadFormat();
    };
    // Determines how many columns there should be in the table
    DayTableMixin.prototype.computeColCnt = function () {
        return this.daysPerRow;
    };
    // Computes the ambiguously-timed moment for the given cell
    DayTableMixin.prototype.getCellDate = function (row, col) {
        return this.dayDates[this.getCellDayIndex(row, col)].clone();
    };
    // Computes the ambiguously-timed date range for the given cell
    DayTableMixin.prototype.getCellRange = function (row, col) {
        var start = this.getCellDate(row, col);
        var end = start.clone().add(1, 'days');
        return { start: start, end: end };
    };
    // Returns the number of day cells, chronologically, from the first of the grid (0-based)
    DayTableMixin.prototype.getCellDayIndex = function (row, col) {
        return row * this.daysPerRow + this.getColDayIndex(col);
    };
    // Returns the numner of day cells, chronologically, from the first cell in *any given row*
    DayTableMixin.prototype.getColDayIndex = function (col) {
        if (this.isRTL) {
            return this.colCnt - 1 - col;
        }
        else {
            return col;
        }
    };
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    DayTableMixin.prototype.getDateDayIndex = function (date) {
        var dayIndices = this.dayIndices;
        var dayOffset = date.diff(this.dayDates[0], 'days');
        if (dayOffset < 0) {
            return dayIndices[0] - 1;
        }
        else if (dayOffset >= dayIndices.length) {
            return dayIndices[dayIndices.length - 1] + 1;
        }
        else {
            return dayIndices[dayOffset];
        }
    };
    /* Options
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes a default column header formatting string if `colFormat` is not explicitly defined
    DayTableMixin.prototype.computeColHeadFormat = function () {
        // if more than one week row, or if there are a lot of columns with not much space,
        // put just the day numbers will be in each cell
        if (this.rowCnt > 1 || this.colCnt > 10) {
            return 'ddd'; // "Sat"
        }
        else if (this.colCnt > 1) {
            return this.opt('dayOfMonthFormat'); // "Sat 12/10"
        }
        else {
            return 'dddd'; // "Saturday"
        }
    };
    /* Slicing
    ------------------------------------------------------------------------------------------------------------------*/
    // Slices up a date range into a segment for every week-row it intersects with
    DayTableMixin.prototype.sliceRangeByRow = function (unzonedRange) {
        var daysPerRow = this.daysPerRow;
        var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold
        var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
        var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
        var segs = [];
        var row;
        var rowFirst;
        var rowLast; // inclusive day-index range for current row
        var segFirst;
        var segLast; // inclusive day-index range for segment
        for (row = 0; row < this.rowCnt; row++) {
            rowFirst = row * daysPerRow;
            rowLast = rowFirst + daysPerRow - 1;
            // intersect segment's offset range with the row's
            segFirst = Math.max(rangeFirst, rowFirst);
            segLast = Math.min(rangeLast, rowLast);
            // deal with in-between indices
            segFirst = Math.ceil(segFirst); // in-between starts round to next cell
            segLast = Math.floor(segLast); // in-between ends round to prev cell
            if (segFirst <= segLast) { // was there any intersection with the current row?
                segs.push({
                    row: row,
                    // normalize to start of row
                    firstRowDayIndex: segFirst - rowFirst,
                    lastRowDayIndex: segLast - rowFirst,
                    // must be matching integers to be the segment's start/end
                    isStart: segFirst === rangeFirst,
                    isEnd: segLast === rangeLast
                });
            }
        }
        return segs;
    };
    // Slices up a date range into a segment for every day-cell it intersects with.
    // TODO: make more DRY with sliceRangeByRow somehow.
    DayTableMixin.prototype.sliceRangeByDay = function (unzonedRange) {
        var daysPerRow = this.daysPerRow;
        var normalRange = this.view.computeDayRange(unzonedRange); // make whole-day range, considering nextDayThreshold
        var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
        var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
        var segs = [];
        var row;
        var rowFirst;
        var rowLast; // inclusive day-index range for current row
        var i;
        var segFirst;
        var segLast; // inclusive day-index range for segment
        for (row = 0; row < this.rowCnt; row++) {
            rowFirst = row * daysPerRow;
            rowLast = rowFirst + daysPerRow - 1;
            for (i = rowFirst; i <= rowLast; i++) {
                // intersect segment's offset range with the row's
                segFirst = Math.max(rangeFirst, i);
                segLast = Math.min(rangeLast, i);
                // deal with in-between indices
                segFirst = Math.ceil(segFirst); // in-between starts round to next cell
                segLast = Math.floor(segLast); // in-between ends round to prev cell
                if (segFirst <= segLast) { // was there any intersection with the current row?
                    segs.push({
                        row: row,
                        // normalize to start of row
                        firstRowDayIndex: segFirst - rowFirst,
                        lastRowDayIndex: segLast - rowFirst,
                        // must be matching integers to be the segment's start/end
                        isStart: segFirst === rangeFirst,
                        isEnd: segLast === rangeLast
                    });
                }
            }
        }
        return segs;
    };
    /* Header Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayTableMixin.prototype.renderHeadHtml = function () {
        var theme = this.view.calendar.theme;
        return '' +
            '<div class="fc-row ' + theme.getClass('headerRow') + '">' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            '<thead>' +
            this.renderHeadTrHtml() +
            '</thead>' +
            '</table>' +
            '</div>';
    };
    DayTableMixin.prototype.renderHeadIntroHtml = function () {
        return this.renderIntroHtml(); // fall back to generic
    };
    DayTableMixin.prototype.renderHeadTrHtml = function () {
        return '' +
            '<tr>' +
            (this.isRTL ? '' : this.renderHeadIntroHtml()) +
            this.renderHeadDateCellsHtml() +
            (this.isRTL ? this.renderHeadIntroHtml() : '') +
            '</tr>';
    };
    DayTableMixin.prototype.renderHeadDateCellsHtml = function () {
        var htmls = [];
        var col;
        var date;
        for (col = 0; col < this.colCnt; col++) {
            date = this.getCellDate(0, col);
            htmls.push(this.renderHeadDateCellHtml(date));
        }
        return htmls.join('');
    };
    // TODO: when internalApiVersion, accept an object for HTML attributes
    // (colspan should be no different)
    DayTableMixin.prototype.renderHeadDateCellHtml = function (date, colspan, otherAttrs) {
        var t = this;
        var view = t.view;
        var isDateValid = t.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
        var classNames = [
            'fc-day-header',
            view.calendar.theme.getClass('widgetHeader')
        ];
        var innerHtml;
        if (typeof t.opt('columnHeaderHtml') === 'function') {
            innerHtml = t.opt('columnHeaderHtml')(date);
        }
        else if (typeof t.opt('columnHeaderText') === 'function') {
            innerHtml = html_1.htmlEscape(t.opt('columnHeaderText')(date));
        }
        else {
            innerHtml = html_1.htmlEscape(date.format(t.colHeadFormat));
        }
        // if only one row of days, the classNames on the header can represent the specific days beneath
        if (t.rowCnt === 1) {
            classNames = classNames.concat(
            // includes the day-of-week class
            // noThemeHighlight=true (don't highlight the header)
            t.getDayClasses(date, true));
        }
        else {
            classNames.push('fc-' + date_1.dayIDs[date.day()]); // only add the day-of-week class
        }
        return '' +
            '<th class="' + classNames.join(' ') + '"' +
            ((isDateValid && t.rowCnt) === 1 ?
                ' data-date="' + date.format('YYYY-MM-DD') + '"' :
                '') +
            (colspan > 1 ?
                ' colspan="' + colspan + '"' :
                '') +
            (otherAttrs ?
                ' ' + otherAttrs :
                '') +
            '>' +
            (isDateValid ?
                // don't make a link if the heading could represent multiple days, or if there's only one day (forceOff)
                view.buildGotoAnchorHtml({ date: date, forceOff: t.rowCnt > 1 || t.colCnt === 1 }, innerHtml) :
                // if not valid, display text, but no link
                innerHtml) +
            '</th>';
    };
    /* Background Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayTableMixin.prototype.renderBgTrHtml = function (row) {
        return '' +
            '<tr>' +
            (this.isRTL ? '' : this.renderBgIntroHtml(row)) +
            this.renderBgCellsHtml(row) +
            (this.isRTL ? this.renderBgIntroHtml(row) : '') +
            '</tr>';
    };
    DayTableMixin.prototype.renderBgIntroHtml = function (row) {
        return this.renderIntroHtml(); // fall back to generic
    };
    DayTableMixin.prototype.renderBgCellsHtml = function (row) {
        var htmls = [];
        var col;
        var date;
        for (col = 0; col < this.colCnt; col++) {
            date = this.getCellDate(row, col);
            htmls.push(this.renderBgCellHtml(date));
        }
        return htmls.join('');
    };
    DayTableMixin.prototype.renderBgCellHtml = function (date, otherAttrs) {
        var t = this;
        var view = t.view;
        var isDateValid = t.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
        var classes = t.getDayClasses(date);
        classes.unshift('fc-day', view.calendar.theme.getClass('widgetContent'));
        return '<td class="' + classes.join(' ') + '"' +
            (isDateValid ?
                ' data-date="' + date.format('YYYY-MM-DD') + '"' : // if date has a time, won't format it
                '') +
            (otherAttrs ?
                ' ' + otherAttrs :
                '') +
            '></td>';
    };
    /* Generic
    ------------------------------------------------------------------------------------------------------------------*/
    // Generates the default HTML intro for any row. User classes should override
    DayTableMixin.prototype.renderIntroHtml = function () {
        return '';
    };
    // TODO: a generic method for dealing with <tr>, RTL, intro
    // when increment internalApiVersion
    // wrapTr (scheduler)
    /* Utils
    ------------------------------------------------------------------------------------------------------------------*/
    // Applies the generic "intro" and "outro" HTML to the given cells.
    // Intro means the leftmost cell when the calendar is LTR and the rightmost cell when RTL. Vice-versa for outro.
    DayTableMixin.prototype.bookendCells = function (trEl) {
        var introHtml = this.renderIntroHtml();
        if (introHtml) {
            if (this.isRTL) {
                dom_manip_1.appendToElement(trEl, introHtml);
            }
            else {
                dom_manip_1.prependToElement(trEl, introHtml);
            }
        }
    };
    return DayTableMixin;
}(Mixin_1.default));
exports.default = DayTableMixin;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var BusinessHourRenderer = /** @class */ (function () {
    /*
    component implements:
      - eventRangesToEventFootprints
      - eventFootprintsToSegs
    */
    function BusinessHourRenderer(component, fillRenderer) {
        this.component = component;
        this.fillRenderer = fillRenderer;
    }
    BusinessHourRenderer.prototype.render = function (businessHourGenerator) {
        var component = this.component;
        var unzonedRange = component._getDateProfile().activeUnzonedRange;
        var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(component.hasAllDayBusinessHours, unzonedRange);
        var eventFootprints = eventInstanceGroup ?
            component.eventRangesToEventFootprints(eventInstanceGroup.sliceRenderRanges(unzonedRange)) :
            [];
        this.renderEventFootprints(eventFootprints);
    };
    BusinessHourRenderer.prototype.renderEventFootprints = function (eventFootprints) {
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        this.renderSegs(segs);
        this.segs = segs;
    };
    BusinessHourRenderer.prototype.renderSegs = function (segs) {
        if (this.fillRenderer) {
            this.fillRenderer.renderSegs('businessHours', segs, {
                getClasses: function (seg) {
                    return ['fc-nonbusiness', 'fc-bgevent'];
                }
            });
        }
    };
    BusinessHourRenderer.prototype.unrender = function () {
        if (this.fillRenderer) {
            this.fillRenderer.unrender('businessHours');
        }
        this.segs = null;
    };
    BusinessHourRenderer.prototype.getSegs = function () {
        return this.segs || [];
    };
    return BusinessHourRenderer;
}());
exports.default = BusinessHourRenderer;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(6);
var dom_manip_1 = __webpack_require__(3);
var FillRenderer = /** @class */ (function () {
    function FillRenderer(component) {
        this.fillSegTag = 'div';
        this.component = component;
        this.elsByFill = {};
    }
    FillRenderer.prototype.renderFootprint = function (type, componentFootprint, props) {
        this.renderSegs(type, this.component.componentFootprintToSegs(componentFootprint), props);
    };
    FillRenderer.prototype.renderSegs = function (type, segs, props) {
        var els;
        segs = this.buildSegEls(type, segs, props); // assignes `.el` to each seg. returns successfully rendered segs
        els = this.attachSegEls(type, segs);
        if (els) {
            this.reportEls(type, els);
        }
        return segs;
    };
    // Unrenders a specific type of fill that is currently rendered on the grid
    FillRenderer.prototype.unrender = function (type) {
        var els = this.elsByFill[type];
        if (els) {
            els.forEach(dom_manip_1.removeElement);
            delete this.elsByFill[type];
        }
    };
    // Renders and assigns an `el` property for each fill segment. Generic enough to work with different types.
    // Only returns segments that successfully rendered.
    FillRenderer.prototype.buildSegEls = function (type, segs, props) {
        var _this = this;
        var html = '';
        var renderedSegs = [];
        var i;
        if (segs.length) {
            // build a large concatenation of segment HTML
            for (i = 0; i < segs.length; i++) {
                html += this.buildSegHtml(type, segs[i], props);
            }
            // Grab individual elements from the combined HTML string. Use each as the default rendering.
            // Then, compute the 'el' for each segment.
            dom_manip_1.htmlToElements(html).forEach(function (el, i) {
                var seg = segs[i];
                // allow custom filter methods per-type
                if (props.filterEl) {
                    el = props.filterEl(seg, el); // might return null/undefined
                }
                // correct element type? (would be bad if a non-TD were inserted into a table for example)
                if (el && dom_manip_1.elementMatches(el, _this.fillSegTag)) {
                    seg.el = el;
                    renderedSegs.push(seg);
                }
            });
        }
        return renderedSegs;
    };
    // Builds the HTML needed for one fill segment. Generic enough to work with different types.
    FillRenderer.prototype.buildSegHtml = function (type, seg, props) {
        // custom hooks per-type
        var classes = props.getClasses ? props.getClasses(seg) : [];
        var css = html_1.cssToStr(props.getCss ? props.getCss(seg) : {});
        return '<' + this.fillSegTag +
            (classes.length ? ' class="' + classes.join(' ') + '"' : '') +
            (css ? ' style="' + css + '"' : '') +
            '></' + this.fillSegTag + '>';
    };
    // Should return wrapping DOM structure
    FillRenderer.prototype.attachSegEls = function (type, segs) {
        // subclasses must implement
    };
    FillRenderer.prototype.reportEls = function (type, els) {
        (_a = (this.elsByFill[type] || (this.elsByFill[type] = []))).push.apply(_a, els);
        var _a;
    };
    return FillRenderer;
}());
exports.default = FillRenderer;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var dom_manip_1 = __webpack_require__(3);
var SingleEventDef_1 = __webpack_require__(17);
var EventFootprint_1 = __webpack_require__(41);
var EventSource_1 = __webpack_require__(9);
var HelperRenderer = /** @class */ (function () {
    function HelperRenderer(component, eventRenderer) {
        this.view = component._getView();
        this.component = component;
        this.eventRenderer = eventRenderer;
    }
    HelperRenderer.prototype.renderComponentFootprint = function (componentFootprint) {
        this.renderEventFootprints([
            this.fabricateEventFootprint(componentFootprint)
        ]);
    };
    HelperRenderer.prototype.renderEventDraggingFootprints = function (eventFootprints, sourceSeg, isTouch) {
        this.renderEventFootprints(eventFootprints, sourceSeg, 'fc-dragging', isTouch ? null : this.view.opt('dragOpacity'));
    };
    HelperRenderer.prototype.renderEventResizingFootprints = function (eventFootprints, sourceSeg, isTouch) {
        this.renderEventFootprints(eventFootprints, sourceSeg, 'fc-resizing');
    };
    HelperRenderer.prototype.renderEventFootprints = function (eventFootprints, sourceSeg, extraClassName, opacity) {
        var segs = this.component.eventFootprintsToSegs(eventFootprints);
        var i;
        // assigns each seg's el and returns a subset of segs that were rendered
        segs = this.eventRenderer.renderFgSegEls(segs);
        for (i = 0; i < segs.length; i++) {
            var classList = segs[i].el.classList;
            classList.add('fc-helper');
            if (extraClassName) {
                classList.add(extraClassName);
            }
        }
        if (opacity != null) {
            for (i = 0; i < segs.length; i++) {
                segs[i].el.style.opacity = opacity;
            }
        }
        this.helperEls = this.renderSegs(segs, sourceSeg);
    };
    HelperRenderer.prototype.unrender = function () {
        if (this.helperEls) {
            this.helperEls.forEach(dom_manip_1.removeElement);
            this.helperEls = null;
        }
    };
    HelperRenderer.prototype.fabricateEventFootprint = function (componentFootprint) {
        var calendar = this.view.calendar;
        var eventDateProfile = calendar.footprintToDateProfile(componentFootprint);
        var dummyEvent = new SingleEventDef_1.default(new EventSource_1.default(calendar));
        var dummyInstance;
        dummyEvent.dateProfile = eventDateProfile;
        dummyInstance = dummyEvent.buildInstance();
        return new EventFootprint_1.default(componentFootprint, dummyEvent, dummyInstance);
    };
    return HelperRenderer;
}());
exports.default = HelperRenderer;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var GlobalEmitter_1 = __webpack_require__(25);
var Interaction_1 = __webpack_require__(19);
var EventPointing = /** @class */ (function (_super) {
    tslib_1.__extends(EventPointing, _super);
    function EventPointing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
    component must implement:
      - publiclyTrigger
    */
    EventPointing.prototype.bindToEl = function (el) {
        var component = this.component;
        component.bindSegHandlerToEl(el, 'click', this.handleClick.bind(this));
        component.bindSegHoverHandlersToEl(el, this.handleMouseover.bind(this), this.handleMouseout.bind(this));
    };
    EventPointing.prototype.handleClick = function (seg, ev) {
        var res = this.component.publiclyTrigger('eventClick', {
            context: seg.el,
            args: [seg.footprint.getEventLegacy(), ev, this.view]
        });
        if (res === false) {
            ev.preventDefault();
        }
    };
    // Updates internal state and triggers handlers for when an event element is moused over
    EventPointing.prototype.handleMouseover = function (seg, ev) {
        if (!GlobalEmitter_1.default.get().shouldIgnoreMouse() &&
            !this.mousedOverSeg) {
            this.mousedOverSeg = seg;
            // TODO: move to EventSelecting's responsibility
            if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
                seg.el.classList.add('fc-allow-mouse-resize');
            }
            this.component.publiclyTrigger('eventMouseover', {
                context: seg.el,
                args: [seg.footprint.getEventLegacy(), ev, this.view]
            });
        }
    };
    // Updates internal state and triggers handlers for when an event element is moused out.
    // Can be given no arguments, in which case it will mouseout the segment that was previously moused over.
    EventPointing.prototype.handleMouseout = function (seg, ev) {
        if (this.mousedOverSeg) {
            this.mousedOverSeg = null;
            // TODO: move to EventSelecting's responsibility
            if (this.view.isEventDefResizable(seg.footprint.eventDef)) {
                seg.el.classList.remove('fc-allow-mouse-resize');
            }
            this.component.publiclyTrigger('eventMouseout', {
                context: seg.el,
                args: [
                    seg.footprint.getEventLegacy(),
                    ev || {},
                    this.view
                ]
            });
        }
    };
    EventPointing.prototype.end = function () {
        if (this.mousedOverSeg) {
            this.handleMouseout(this.mousedOverSeg);
        }
    };
    return EventPointing;
}(Interaction_1.default));
exports.default = EventPointing;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Mixin_1 = __webpack_require__(18);
var DateClicking_1 = __webpack_require__(254);
var DateSelecting_1 = __webpack_require__(232);
var EventPointing_1 = __webpack_require__(65);
var EventDragging_1 = __webpack_require__(231);
var EventResizing_1 = __webpack_require__(230);
var ExternalDropping_1 = __webpack_require__(229);
var StandardInteractionsMixin = /** @class */ (function (_super) {
    tslib_1.__extends(StandardInteractionsMixin, _super);
    function StandardInteractionsMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StandardInteractionsMixin;
}(Mixin_1.default));
exports.default = StandardInteractionsMixin;
StandardInteractionsMixin.prototype.dateClickingClass = DateClicking_1.default;
StandardInteractionsMixin.prototype.dateSelectingClass = DateSelecting_1.default;
StandardInteractionsMixin.prototype.eventPointingClass = EventPointing_1.default;
StandardInteractionsMixin.prototype.eventDraggingClass = EventDragging_1.default;
StandardInteractionsMixin.prototype.eventResizingClass = EventResizing_1.default;
StandardInteractionsMixin.prototype.externalDroppingClass = ExternalDropping_1.default;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var object_1 = __webpack_require__(5);
var html_1 = __webpack_require__(6);
var dom_manip_1 = __webpack_require__(3);
var CoordCache_1 = __webpack_require__(59);
var Popover_1 = __webpack_require__(258);
var UnzonedRange_1 = __webpack_require__(7);
var ComponentFootprint_1 = __webpack_require__(16);
var EventFootprint_1 = __webpack_require__(41);
var BusinessHourRenderer_1 = __webpack_require__(62);
var StandardInteractionsMixin_1 = __webpack_require__(66);
var InteractiveDateComponent_1 = __webpack_require__(45);
var DayTableMixin_1 = __webpack_require__(61);
var DayGridEventRenderer_1 = __webpack_require__(259);
var DayGridHelperRenderer_1 = __webpack_require__(260);
var DayGridFillRenderer_1 = __webpack_require__(261);
/* A component that renders a grid of whole-days that runs horizontally. There can be multiple rows, one per week.
----------------------------------------------------------------------------------------------------------------------*/
var DayGrid = /** @class */ (function (_super) {
    tslib_1.__extends(DayGrid, _super);
    function DayGrid(view) {
        var _this = _super.call(this, view) || this;
        _this.cellWeekNumbersVisible = false; // display week numbers in day cell?
        _this.bottomCoordPadding = 0; // hack for extending the hit area for the last row of the coordinate grid
        // isRigid determines whether the individual rows should ignore the contents and be a constant height.
        // Relies on the view's colCnt and rowCnt. In the future, this component should probably be self-sufficient.
        _this.isRigid = false;
        _this.hasAllDayBusinessHours = true;
        return _this;
    }
    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
    DayGrid.prototype.componentFootprintToSegs = function (componentFootprint) {
        var segs = this.sliceRangeByRow(componentFootprint.unzonedRange);
        for (var i = 0; i < segs.length; i++) {
            var seg = segs[i];
            if (this.isRTL) {
                seg.leftCol = this.daysPerRow - 1 - seg.lastRowDayIndex;
                seg.rightCol = this.daysPerRow - 1 - seg.firstRowDayIndex;
            }
            else {
                seg.leftCol = seg.firstRowDayIndex;
                seg.rightCol = seg.lastRowDayIndex;
            }
        }
        return segs;
    };
    /* Date Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.renderDates = function (dateProfile) {
        this.dateProfile = dateProfile;
        this.updateDayTable();
        this.renderGrid();
    };
    DayGrid.prototype.unrenderDates = function () {
        this.removeSegPopover();
    };
    // Renders the rows and columns into the component's `this.el`, which should already be assigned.
    DayGrid.prototype.renderGrid = function () {
        var view = this.view;
        var rowCnt = this.rowCnt;
        var colCnt = this.colCnt;
        var html = '';
        var row;
        var col;
        if (this.headContainerEl) {
            this.headContainerEl.innerHTML = this.renderHeadHtml();
        }
        for (row = 0; row < rowCnt; row++) {
            html += this.renderDayRowHtml(row, this.isRigid);
        }
        this.el.innerHTML = html;
        this.rowEls = dom_manip_1.findElements(this.el, '.fc-row');
        this.cellEls = dom_manip_1.findElements(this.el, '.fc-day, .fc-disabled-day');
        this.rowCoordCache = new CoordCache_1.default({
            els: this.rowEls,
            isVertical: true
        });
        this.colCoordCache = new CoordCache_1.default({
            els: this.cellEls.slice(0, this.colCnt),
            isHorizontal: true
        });
        // trigger dayRender with each cell's element
        for (row = 0; row < rowCnt; row++) {
            for (col = 0; col < colCnt; col++) {
                this.publiclyTrigger('dayRender', {
                    context: view,
                    args: [
                        this.getCellDate(row, col),
                        this.getCellEl(row, col),
                        view
                    ]
                });
            }
        }
    };
    // Generates the HTML for a single row, which is a div that wraps a table.
    // `row` is the row number.
    DayGrid.prototype.renderDayRowHtml = function (row, isRigid) {
        var theme = this.view.calendar.theme;
        var classes = ['fc-row', 'fc-week', theme.getClass('dayRow')];
        if (isRigid) {
            classes.push('fc-rigid');
        }
        return '' +
            '<div class="' + classes.join(' ') + '">' +
            '<div class="fc-bg">' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            this.renderBgTrHtml(row) +
            '</table>' +
            '</div>' +
            '<div class="fc-content-skeleton">' +
            '<table>' +
            (this.getIsNumbersVisible() ?
                '<thead>' +
                    this.renderNumberTrHtml(row) +
                    '</thead>' :
                '') +
            '</table>' +
            '</div>' +
            '</div>';
    };
    DayGrid.prototype.getIsNumbersVisible = function () {
        return this.getIsDayNumbersVisible() || this.cellWeekNumbersVisible;
    };
    DayGrid.prototype.getIsDayNumbersVisible = function () {
        return this.rowCnt > 1;
    };
    /* Grid Number Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.renderNumberTrHtml = function (row) {
        return '' +
            '<tr>' +
            (this.isRTL ? '' : this.renderNumberIntroHtml(row)) +
            this.renderNumberCellsHtml(row) +
            (this.isRTL ? this.renderNumberIntroHtml(row) : '') +
            '</tr>';
    };
    DayGrid.prototype.renderNumberIntroHtml = function (row) {
        return this.renderIntroHtml();
    };
    DayGrid.prototype.renderNumberCellsHtml = function (row) {
        var htmls = [];
        var col;
        var date;
        for (col = 0; col < this.colCnt; col++) {
            date = this.getCellDate(row, col);
            htmls.push(this.renderNumberCellHtml(date));
        }
        return htmls.join('');
    };
    // Generates the HTML for the <td>s of the "number" row in the DayGrid's content skeleton.
    // The number row will only exist if either day numbers or week numbers are turned on.
    DayGrid.prototype.renderNumberCellHtml = function (date) {
        var view = this.view;
        var html = '';
        var isDateValid = this.dateProfile.activeUnzonedRange.containsDate(date); // TODO: called too frequently. cache somehow.
        var isDayNumberVisible = this.getIsDayNumbersVisible() && isDateValid;
        var classes;
        var weekCalcFirstDoW;
        if (!isDayNumberVisible && !this.cellWeekNumbersVisible) {
            // no numbers in day cell (week number must be along the side)
            return '<td></td>'; //  will create an empty space above events :(
        }
        classes = this.getDayClasses(date);
        classes.unshift('fc-day-top');
        if (this.cellWeekNumbersVisible) {
            // To determine the day of week number change under ISO, we cannot
            // rely on moment.js methods such as firstDayOfWeek() or weekday(),
            // because they rely on the locale's dow (possibly overridden by
            // our firstDay option), which may not be Monday. We cannot change
            // dow, because that would affect the calendar start day as well.
            if (date._locale._fullCalendar_weekCalc === 'ISO') {
                weekCalcFirstDoW = 1; // Monday by ISO 8601 definition
            }
            else {
                weekCalcFirstDoW = date._locale.firstDayOfWeek();
            }
        }
        html += '<td class="' + classes.join(' ') + '"' +
            (isDateValid ?
                ' data-date="' + date.format() + '"' :
                '') +
            '>';
        if (this.cellWeekNumbersVisible && (date.day() === weekCalcFirstDoW)) {
            html += view.buildGotoAnchorHtml({ date: date, type: 'week' }, { 'class': 'fc-week-number' }, date.format('w') // inner HTML
            );
        }
        if (isDayNumberVisible) {
            html += view.buildGotoAnchorHtml(date, { 'class': 'fc-day-number' }, date.format('D') // inner HTML
            );
        }
        html += '</td>';
        return html;
    };
    /* Hit System
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.prepareHits = function () {
        this.colCoordCache.build();
        this.rowCoordCache.build();
        this.rowCoordCache.bottoms[this.rowCnt - 1] += this.bottomCoordPadding; // hack
    };
    DayGrid.prototype.releaseHits = function () {
        this.colCoordCache.clear();
        this.rowCoordCache.clear();
    };
    DayGrid.prototype.queryHit = function (leftOffset, topOffset) {
        if (this.colCoordCache.isLeftInBounds(leftOffset) && this.rowCoordCache.isTopInBounds(topOffset)) {
            var col = this.colCoordCache.getHorizontalIndex(leftOffset);
            var row = this.rowCoordCache.getVerticalIndex(topOffset);
            if (row != null && col != null) {
                return this.getCellHit(row, col);
            }
        }
    };
    DayGrid.prototype.getHitFootprint = function (hit) {
        var range = this.getCellRange(hit.row, hit.col);
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(range.start, range.end), true // all-day?
        );
    };
    DayGrid.prototype.getHitEl = function (hit) {
        return this.getCellEl(hit.row, hit.col);
    };
    /* Cell System
    ------------------------------------------------------------------------------------------------------------------*/
    // FYI: the first column is the leftmost column, regardless of date
    DayGrid.prototype.getCellHit = function (row, col) {
        return {
            row: row,
            col: col,
            component: this,
            left: this.colCoordCache.getLeftOffset(col),
            right: this.colCoordCache.getRightOffset(col),
            top: this.rowCoordCache.getTopOffset(row),
            bottom: this.rowCoordCache.getBottomOffset(row)
        };
    };
    DayGrid.prototype.getCellEl = function (row, col) {
        return this.cellEls[row * this.colCnt + col];
    };
    /* Event Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    // Unrenders all events currently rendered on the grid
    DayGrid.prototype.executeEventUnrender = function () {
        this.removeSegPopover(); // removes the "more.." events popover
        _super.prototype.executeEventUnrender.call(this);
    };
    // Retrieves all rendered segment objects currently rendered on the grid
    DayGrid.prototype.getOwnEventSegs = function () {
        // append the segments from the "more..." popover
        return _super.prototype.getOwnEventSegs.call(this).concat(this.popoverSegs || []);
    };
    /* Event Drag Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event or external element being dragged.
    // `eventLocation` has zoned start and end (optional)
    DayGrid.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            this.renderHighlight(eventFootprints[i].componentFootprint);
        }
        // render drags from OTHER components as helpers
        if (eventFootprints.length && seg && seg.component !== this) {
            this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch);
            return true; // signal helpers rendered
        }
    };
    // Unrenders any visual indication of a hovering event
    DayGrid.prototype.unrenderDrag = function () {
        this.unrenderHighlight();
        this.helperRenderer.unrender();
    };
    /* Event Resize Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being resized
    DayGrid.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            this.renderHighlight(eventFootprints[i].componentFootprint);
        }
        this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
    };
    // Unrenders a visual indication of an event being resized
    DayGrid.prototype.unrenderEventResize = function () {
        this.unrenderHighlight();
        this.helperRenderer.unrender();
    };
    /* More+ Link Popover
    ------------------------------------------------------------------------------------------------------------------*/
    DayGrid.prototype.removeSegPopover = function () {
        if (this.segPopover) {
            this.segPopover.hide(); // in handler, will call segPopover's removeElement
        }
    };
    // Limits the number of "levels" (vertically stacking layers of events) for each row of the grid.
    // `levelLimit` can be false (don't limit), a number, or true (should be computed).
    DayGrid.prototype.limitRows = function (levelLimit) {
        var rowStructs = this.eventRenderer.rowStructs || [];
        var row; // row #
        var rowLevelLimit;
        for (row = 0; row < rowStructs.length; row++) {
            this.unlimitRow(row);
            if (!levelLimit) {
                rowLevelLimit = false;
            }
            else if (typeof levelLimit === 'number') {
                rowLevelLimit = levelLimit;
            }
            else {
                rowLevelLimit = this.computeRowLevelLimit(row);
            }
            if (rowLevelLimit !== false) {
                this.limitRow(row, rowLevelLimit);
            }
        }
    };
    // Computes the number of levels a row will accomodate without going outside its bounds.
    // Assumes the row is "rigid" (maintains a constant height regardless of what is inside).
    // `row` is the row number.
    DayGrid.prototype.computeRowLevelLimit = function (row) {
        var rowEl = this.rowEls[row]; // the containing "fake" row div
        var rowBottom = rowEl.getBoundingClientRect().bottom;
        var trEls = dom_manip_1.findChildren(this.eventRenderer.rowStructs[row].tbodyEl);
        var i;
        var trEl;
        // Reveal one level <tr> at a time and stop when we find one out of bounds
        for (i = 0; i < trEls.length; i++) {
            trEl = trEls[i];
            trEl.classList.remove('fc-limited'); // reset to original state (reveal)
            if (trEl.getBoundingClientRect().bottom > rowBottom) {
                return i;
            }
        }
        return false; // should not limit at all
    };
    // Limits the given grid row to the maximum number of levels and injects "more" links if necessary.
    // `row` is the row number.
    // `levelLimit` is a number for the maximum (inclusive) number of levels allowed.
    DayGrid.prototype.limitRow = function (row, levelLimit) {
        var _this = this;
        var rowStruct = this.eventRenderer.rowStructs[row];
        var moreNodes = []; // array of "more" <a> links and <td> DOM nodes
        var col = 0; // col #, left-to-right (not chronologically)
        var levelSegs; // array of segment objects in the last allowable level, ordered left-to-right
        var cellMatrix; // a matrix (by level, then column) of all <td> elements in the row
        var limitedNodes; // array of temporarily hidden level <tr> and segment <td> DOM nodes
        var i;
        var seg;
        var segsBelow; // array of segment objects below `seg` in the current `col`
        var totalSegsBelow; // total number of segments below `seg` in any of the columns `seg` occupies
        var colSegsBelow; // array of segment arrays, below seg, one for each column (offset from segs's first column)
        var td;
        var rowSpan;
        var segMoreNodes; // array of "more" <td> cells that will stand-in for the current seg's cell
        var j;
        var moreTd;
        var moreWrap;
        var moreLink;
        // Iterates through empty level cells and places "more" links inside if need be
        var emptyCellsUntil = function (endCol) {
            while (col < endCol) {
                segsBelow = _this.getCellSegs(row, col, levelLimit);
                if (segsBelow.length) {
                    td = cellMatrix[levelLimit - 1][col];
                    moreLink = _this.renderMoreLink(row, col, segsBelow);
                    moreWrap = dom_manip_1.createElement('div', null, moreLink);
                    td.appendChild(moreWrap);
                    moreNodes.push(moreWrap[0]);
                }
                col++;
            }
        };
        if (levelLimit && levelLimit < rowStruct.segLevels.length) { // is it actually over the limit?
            levelSegs = rowStruct.segLevels[levelLimit - 1];
            cellMatrix = rowStruct.cellMatrix;
            limitedNodes = dom_manip_1.findChildren(rowStruct.tbodyEl).slice(levelLimit); // get level <tr> elements past the limit
            limitedNodes.forEach(function (node) {
                node.classList.add('fc-limited'); // hide elements and get a simple DOM-nodes array
            });
            // iterate though segments in the last allowable level
            for (i = 0; i < levelSegs.length; i++) {
                seg = levelSegs[i];
                emptyCellsUntil(seg.leftCol); // process empty cells before the segment
                // determine *all* segments below `seg` that occupy the same columns
                colSegsBelow = [];
                totalSegsBelow = 0;
                while (col <= seg.rightCol) {
                    segsBelow = this.getCellSegs(row, col, levelLimit);
                    colSegsBelow.push(segsBelow);
                    totalSegsBelow += segsBelow.length;
                    col++;
                }
                if (totalSegsBelow) { // do we need to replace this segment with one or many "more" links?
                    td = cellMatrix[levelLimit - 1][seg.leftCol]; // the segment's parent cell
                    rowSpan = td.rowSpan || 1;
                    segMoreNodes = [];
                    // make a replacement <td> for each column the segment occupies. will be one for each colspan
                    for (j = 0; j < colSegsBelow.length; j++) {
                        moreTd = dom_manip_1.createElement('td', { className: 'fc-more-cell', rowSpan: rowSpan });
                        segsBelow = colSegsBelow[j];
                        moreLink = this.renderMoreLink(row, seg.leftCol + j, [seg].concat(segsBelow) // count seg as hidden too
                        );
                        moreWrap = dom_manip_1.createElement('div', null, moreLink);
                        moreTd.appendChild(moreWrap);
                        segMoreNodes.push(moreTd);
                        moreNodes.push(moreTd);
                    }
                    td.classList.add('fc-limited');
                    dom_manip_1.insertAfterElement(td, segMoreNodes);
                    limitedNodes.push(td);
                }
            }
            emptyCellsUntil(this.colCnt); // finish off the level
            rowStruct.moreEls = moreNodes; // for easy undoing later
            rowStruct.limitedEls = limitedNodes; // for easy undoing later
        }
    };
    // Reveals all levels and removes all "more"-related elements for a grid's row.
    // `row` is a row number.
    DayGrid.prototype.unlimitRow = function (row) {
        var rowStruct = this.eventRenderer.rowStructs[row];
        if (rowStruct.moreEls) {
            rowStruct.moreEls.forEach(dom_manip_1.removeElement);
            rowStruct.moreEls = null;
        }
        if (rowStruct.limitedEls) {
            rowStruct.limitedEls.forEach(function (limitedEl) {
                limitedEl.classList.remove('fc-limited');
            });
            rowStruct.limitedEls = null;
        }
    };
    // Renders an <a> element that represents hidden event element for a cell.
    // Responsible for attaching click handler as well.
    DayGrid.prototype.renderMoreLink = function (row, col, hiddenSegs) {
        var _this = this;
        var view = this.view;
        var a = dom_manip_1.createElement('a', { className: 'fc-more' });
        a.innerText = this.getMoreLinkText(hiddenSegs.length);
        a.addEventListener('click', function (ev) {
            var clickOption = _this.opt('eventLimitClick');
            var date = _this.getCellDate(row, col);
            var moreEl = ev.currentTarget;
            var dayEl = _this.getCellEl(row, col);
            var allSegs = _this.getCellSegs(row, col);
            // rescope the segments to be within the cell's date
            var reslicedAllSegs = _this.resliceDaySegs(allSegs, date);
            var reslicedHiddenSegs = _this.resliceDaySegs(hiddenSegs, date);
            if (typeof clickOption === 'function') {
                // the returned value can be an atomic option
                clickOption = _this.publiclyTrigger('eventLimitClick', {
                    context: view,
                    args: [
                        {
                            date: date.clone(),
                            dayEl: dayEl,
                            moreEl: moreEl,
                            segs: reslicedAllSegs,
                            hiddenSegs: reslicedHiddenSegs
                        },
                        ev,
                        view
                    ]
                });
            }
            if (clickOption === 'popover') {
                _this.showSegPopover(row, col, moreEl, reslicedAllSegs);
            }
            else if (typeof clickOption === 'string') { // a view name
                view.calendar.zoomTo(date, clickOption);
            }
        });
        return a;
    };
    // Reveals the popover that displays all events within a cell
    DayGrid.prototype.showSegPopover = function (row, col, moreLink, segs) {
        var _this = this;
        var view = this.view;
        var moreWrap = moreLink.parentNode; // the <div> wrapper around the <a>
        var topEl; // the element we want to match the top coordinate of
        var options;
        if (this.rowCnt === 1) {
            topEl = view.el; // will cause the popover to cover any sort of header
        }
        else {
            topEl = this.rowEls[row]; // will align with top of row
        }
        options = {
            className: 'fc-more-popover ' + view.calendar.theme.getClass('popover'),
            content: this.renderSegPopoverContent(row, col, segs),
            parentEl: view.el,
            top: topEl.getBoundingClientRect().top,
            autoHide: true,
            viewportConstrain: this.opt('popoverViewportConstrain'),
            hide: function () {
                // kill everything when the popover is hidden
                // notify events to be removed
                if (_this.popoverSegs) {
                    _this.triggerBeforeEventSegsDestroyed(_this.popoverSegs);
                }
                _this.segPopover.removeElement();
                _this.segPopover = null;
                _this.popoverSegs = null;
            }
        };
        // Determine horizontal coordinate.
        // We use the moreWrap instead of the <td> to avoid border confusion.
        if (this.isRTL) {
            options.right = moreWrap.getBoundingClientRect().right + 1; // +1 to be over cell border
        }
        else {
            options.left = moreWrap.getBoundingClientRect().left - 1; // -1 to be over cell border
        }
        this.segPopover = new Popover_1.default(options);
        this.segPopover.show();
        // the popover doesn't live within the grid's container element, and thus won't get the event
        // delegated-handlers for free. attach event-related handlers to the popover.
        this.bindAllSegHandlersToEl(this.segPopover.el);
        this.triggerAfterEventSegsRendered(segs);
    };
    // Builds the inner DOM contents of the segment popover
    DayGrid.prototype.renderSegPopoverContent = function (row, col, segs) {
        var view = this.view;
        var theme = view.calendar.theme;
        var title = this.getCellDate(row, col).format(this.opt('dayPopoverFormat'));
        var content = dom_manip_1.htmlToElements('<div class="fc-header ' + theme.getClass('popoverHeader') + '">' +
            '<span class="fc-close ' + theme.getIconClass('close') + '"></span>' +
            '<span class="fc-title">' +
            html_1.htmlEscape(title) +
            '</span>' +
            '<div class="fc-clear"></div>' +
            '</div>' +
            '<div class="fc-body ' + theme.getClass('popoverContent') + '">' +
            '<div class="fc-event-container"></div>' +
            '</div>');
        var segContainer = content[1].querySelector('.fc-event-container');
        var i;
        // render each seg's `el` and only return the visible segs
        segs = this.eventRenderer.renderFgSegEls(segs, true); // disableResizing=true
        this.popoverSegs = segs;
        for (i = 0; i < segs.length; i++) {
            // because segments in the popover are not part of a grid coordinate system, provide a hint to any
            // grids that want to do drag-n-drop about which cell it came from
            this.hitsNeeded();
            segs[i].hit = this.getCellHit(row, col);
            this.hitsNotNeeded();
            segContainer.appendChild(segs[i].el);
        }
        return content;
    };
    // Given the events within an array of segment objects, reslice them to be in a single day
    DayGrid.prototype.resliceDaySegs = function (segs, dayDate) {
        var dayStart = dayDate.clone();
        var dayEnd = dayStart.clone().add(1, 'days');
        var dayRange = new UnzonedRange_1.default(dayStart, dayEnd);
        var newSegs = [];
        var i;
        var seg;
        var slicedRange;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            slicedRange = seg.footprint.componentFootprint.unzonedRange.intersect(dayRange);
            if (slicedRange) {
                newSegs.push(object_1.assignTo({}, seg, {
                    footprint: new EventFootprint_1.default(new ComponentFootprint_1.default(slicedRange, seg.footprint.componentFootprint.isAllDay), seg.footprint.eventDef, seg.footprint.eventInstance),
                    isStart: seg.isStart && slicedRange.isStart,
                    isEnd: seg.isEnd && slicedRange.isEnd
                }));
            }
        }
        // force an order because eventsToSegs doesn't guarantee one
        // TODO: research if still needed
        this.eventRenderer.sortEventSegs(newSegs);
        return newSegs;
    };
    // Generates the text that should be inside a "more" link, given the number of events it represents
    DayGrid.prototype.getMoreLinkText = function (num) {
        var opt = this.opt('eventLimitText');
        if (typeof opt === 'function') {
            return opt(num);
        }
        else {
            return '+' + num + ' ' + opt;
        }
    };
    // Returns segments within a given cell.
    // If `startLevel` is specified, returns only events including and below that level. Otherwise returns all segs.
    DayGrid.prototype.getCellSegs = function (row, col, startLevel) {
        var segMatrix = this.eventRenderer.rowStructs[row].segMatrix;
        var level = startLevel || 0;
        var segs = [];
        var seg;
        while (level < segMatrix.length) {
            seg = segMatrix[level][col];
            if (seg) {
                segs.push(seg);
            }
            level++;
        }
        return segs;
    };
    return DayGrid;
}(InteractiveDateComponent_1.default));
exports.default = DayGrid;
DayGrid.prototype.eventRendererClass = DayGridEventRenderer_1.default;
DayGrid.prototype.businessHourRendererClass = BusinessHourRenderer_1.default;
DayGrid.prototype.helperRendererClass = DayGridHelperRenderer_1.default;
DayGrid.prototype.fillRendererClass = DayGridFillRenderer_1.default;
StandardInteractionsMixin_1.default.mixInto(DayGrid);
DayTableMixin_1.default.mixInto(DayGrid);


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var html_1 = __webpack_require__(6);
var dom_manip_1 = __webpack_require__(3);
var misc_1 = __webpack_require__(4);
var Scroller_1 = __webpack_require__(44);
var View_1 = __webpack_require__(46);
var BasicViewDateProfileGenerator_1 = __webpack_require__(235);
var DayGrid_1 = __webpack_require__(67);
/* An abstract class for the "basic" views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/
// It is a manager for a DayGrid subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
var BasicView = /** @class */ (function (_super) {
    tslib_1.__extends(BasicView, _super);
    function BasicView(calendar, viewSpec) {
        var _this = _super.call(this, calendar, viewSpec) || this;
        _this.colWeekNumbersVisible = false;
        _this.dayGrid = _this.instantiateDayGrid();
        _this.dayGrid.isRigid = _this.hasRigidRows();
        if (_this.opt('weekNumbers')) {
            if (_this.opt('weekNumbersWithinDays')) {
                _this.dayGrid.cellWeekNumbersVisible = true;
                _this.colWeekNumbersVisible = false;
            }
            else {
                _this.dayGrid.cellWeekNumbersVisible = false;
                _this.colWeekNumbersVisible = true;
            }
        }
        _this.addChild(_this.dayGrid);
        _this.scroller = new Scroller_1.default({
            overflowX: 'hidden',
            overflowY: 'auto'
        });
        return _this;
    }
    // Generates the DayGrid object this view needs. Draws from this.dayGridClass
    BasicView.prototype.instantiateDayGrid = function () {
        // generate a subclass on the fly with BasicView-specific behavior
        // TODO: cache this subclass
        var subclass = makeDayGridSubclass(this.dayGridClass);
        return new subclass(this);
    };
    BasicView.prototype.executeDateRender = function (dateProfile) {
        this.dayGrid.breakOnWeeks = /year|month|week/.test(dateProfile.currentRangeUnit);
        _super.prototype.executeDateRender.call(this, dateProfile);
    };
    BasicView.prototype.renderSkeleton = function () {
        var dayGridContainerEl;
        var dayGridEl;
        this.el.classList.add('fc-basic-view');
        this.el.innerHTML = this.renderSkeletonHtml();
        this.scroller.render();
        dayGridContainerEl = this.scroller.el;
        dayGridContainerEl.classList.add('fc-day-grid-container');
        dayGridEl = dom_manip_1.createElement('div', { className: 'fc-day-grid' });
        dayGridContainerEl.appendChild(dayGridEl);
        this.el.querySelector('.fc-body > tr > td').appendChild(dayGridContainerEl);
        this.dayGrid.headContainerEl = this.el.querySelector('.fc-head-container');
        this.dayGrid.setElement(dayGridEl);
    };
    BasicView.prototype.unrenderSkeleton = function () {
        this.dayGrid.removeElement();
        this.scroller.destroy();
    };
    // Builds the HTML skeleton for the view.
    // The day-grid component will render inside of a container defined by this HTML.
    BasicView.prototype.renderSkeletonHtml = function () {
        var theme = this.calendar.theme;
        return '' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            (this.opt('columnHeader') ?
                '<thead class="fc-head">' +
                    '<tr>' +
                    '<td class="fc-head-container ' + theme.getClass('widgetHeader') + '">&nbsp;</td>' +
                    '</tr>' +
                    '</thead>' :
                '') +
            '<tbody class="fc-body">' +
            '<tr>' +
            '<td class="' + theme.getClass('widgetContent') + '"></td>' +
            '</tr>' +
            '</tbody>' +
            '</table>';
    };
    // Generates an HTML attribute string for setting the width of the week number column, if it is known
    BasicView.prototype.weekNumberStyleAttr = function () {
        if (this.weekNumberWidth != null) {
            return 'style="width:' + this.weekNumberWidth + 'px"';
        }
        return '';
    };
    // Determines whether each row should have a constant height
    BasicView.prototype.hasRigidRows = function () {
        var eventLimit = this.opt('eventLimit');
        return eventLimit && typeof eventLimit !== 'number';
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    // Refreshes the horizontal dimensions of the view
    BasicView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        var dayGrid = this.dayGrid;
        var eventLimit = this.opt('eventLimit');
        var headRowEl = dayGrid.headContainerEl ?
            dayGrid.headContainerEl.querySelector('.fc-row') :
            null;
        var scrollerHeight;
        var scrollbarWidths;
        // hack to give the view some height prior to dayGrid's columns being rendered
        // TODO: separate setting height from scroller VS dayGrid.
        if (!dayGrid.rowEls) {
            if (!isAuto) {
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            return;
        }
        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        if (this.colWeekNumbersVisible) {
            // Make sure all week number cells running down the side have the same width.
            // Record the width for cells created later.
            this.weekNumberWidth = misc_1.matchCellWidths(dom_manip_1.findElements(this.el, '.fc-week-number'));
        }
        // reset all heights to be natural
        this.scroller.clear();
        if (headRowEl) {
            misc_1.uncompensateScroll(headRowEl);
        }
        dayGrid.removeSegPopover(); // kill the "more" popover if displayed
        // is the event limit a constant level number?
        if (eventLimit && typeof eventLimit === 'number') {
            dayGrid.limitRows(eventLimit); // limit the levels first so the height can redistribute after
        }
        // distribute the height to the rows
        // (totalHeight is a "recommended" value if isAuto)
        scrollerHeight = this.computeScrollerHeight(totalHeight);
        this.setGridHeight(scrollerHeight, isAuto);
        // is the event limit dynamically calculated?
        if (eventLimit && typeof eventLimit !== 'number') {
            dayGrid.limitRows(eventLimit); // limit the levels after the grid's row heights have been set
        }
        if (!isAuto) { // should we force dimensions of the scroll container?
            this.scroller.setHeight(scrollerHeight);
            scrollbarWidths = this.scroller.getScrollbarWidths();
            if (scrollbarWidths.left || scrollbarWidths.right) { // using scrollbars?
                if (headRowEl) {
                    misc_1.compensateScroll(headRowEl, scrollbarWidths);
                }
                // doing the scrollbar compensation might have created text overflow which created more height. redo
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            // guarantees the same scrollbar widths
            this.scroller.lockOverflow(scrollbarWidths);
        }
    };
    // given a desired total height of the view, returns what the height of the scroller should be
    BasicView.prototype.computeScrollerHeight = function (totalHeight) {
        return totalHeight -
            misc_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    };
    // Sets the height of just the DayGrid component in this view
    BasicView.prototype.setGridHeight = function (height, isAuto) {
        if (isAuto) {
            misc_1.undistributeHeight(this.dayGrid.rowEls); // let the rows be their natural height with no expanding
        }
        else {
            misc_1.distributeHeight(this.dayGrid.rowEls, height, true); // true = compensate for height-hogging rows
        }
    };
    /* Scroll
    ------------------------------------------------------------------------------------------------------------------*/
    BasicView.prototype.computeInitialDateScroll = function () {
        return { top: 0 };
    };
    BasicView.prototype.queryDateScroll = function () {
        return { top: this.scroller.getScrollTop() };
    };
    BasicView.prototype.applyDateScroll = function (scroll) {
        if (scroll.top !== undefined) {
            this.scroller.setScrollTop(scroll.top);
        }
    };
    return BasicView;
}(View_1.default));
exports.default = BasicView;
BasicView.prototype.dateProfileGeneratorClass = BasicViewDateProfileGenerator_1.default;
BasicView.prototype.dayGridClass = DayGrid_1.default;
// customize the rendering behavior of BasicView's dayGrid
function makeDayGridSubclass(SuperClass) {
    return /** @class */ (function (_super) {
        tslib_1.__extends(SubClass, _super);
        function SubClass() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        // Generates the HTML that will go before the day-of week header cells
        SubClass.prototype.renderHeadIntroHtml = function () {
            var view = this.view;
            if (view.colWeekNumbersVisible) {
                return '' +
                    '<th class="fc-week-number ' + view.calendar.theme.getClass('widgetHeader') + '" ' + view.weekNumberStyleAttr() + '>' +
                    '<span>' + // needed for matchCellWidths
                    html_1.htmlEscape(this.opt('weekNumberTitle')) +
                    '</span>' +
                    '</th>';
            }
            return '';
        };
        // Generates the HTML that will go before content-skeleton cells that display the day/week numbers
        SubClass.prototype.renderNumberIntroHtml = function (row) {
            var view = this.view;
            var weekStart = this.getCellDate(row, 0);
            if (view.colWeekNumbersVisible) {
                return '' +
                    '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '>' +
                    view.buildGotoAnchorHtml(// aside from link, important for matchCellWidths
                    { date: weekStart, type: 'week', forceOff: this.colCnt === 1 }, weekStart.format('w') // inner HTML
                    ) +
                    '</td>';
            }
            return '';
        };
        // Generates the HTML that goes before the day bg cells for each day-row
        SubClass.prototype.renderBgIntroHtml = function () {
            var view = this.view;
            if (view.colWeekNumbersVisible) {
                return '<td class="fc-week-number ' + view.calendar.theme.getClass('widgetContent') + '" ' +
                    view.weekNumberStyleAttr() + '></td>';
            }
            return '';
        };
        // Generates the HTML that goes before every other type of row generated by DayGrid.
        // Affects helper-skeleton and highlight-skeleton rows.
        SubClass.prototype.renderIntroHtml = function () {
            var view = this.view;
            if (view.colWeekNumbersVisible) {
                return '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '></td>';
            }
            return '';
        };
        SubClass.prototype.getIsNumbersVisible = function () {
            var view = this.view;
            return DayGrid_1.default.prototype.getIsNumbersVisible.apply(this, arguments) || view.colWeekNumbersVisible;
        };
        return SubClass;
    }(SuperClass));
}


/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function intersectRects(rect1, rect2) {
    var res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) {
        return res;
    }
    return false;
}
exports.intersectRects = intersectRects;
// Returns a new point that will have been moved to reside within the given rectangle
function constrainPoint(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
exports.constrainPoint = constrainPoint;
// Returns a point that is the center of the given rectangle
function getRectCenter(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
exports.getRectCenter = getRectCenter;
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function diffPoints(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
exports.diffPoints = diffPoints;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var UnzonedRange_1 = __webpack_require__(7);
var ComponentFootprint_1 = __webpack_require__(16);
var EventDefParser_1 = __webpack_require__(54);
var EventSource_1 = __webpack_require__(9);
var util_1 = __webpack_require__(40);
var Constraints = /** @class */ (function () {
    function Constraints(eventManager, _calendar) {
        this.eventManager = eventManager;
        this._calendar = _calendar;
    }
    Constraints.prototype.opt = function (name) {
        return this._calendar.opt(name);
    };
    /*
    determines if eventInstanceGroup is allowed,
    in relation to other EVENTS and business hours.
    */
    Constraints.prototype.isEventInstanceGroupAllowed = function (eventInstanceGroup) {
        var eventDef = eventInstanceGroup.getEventDef();
        var eventFootprints = this.eventRangesToEventFootprints(eventInstanceGroup.getAllEventRanges());
        var i;
        var peerEventInstances = this.getPeerEventInstances(eventDef);
        var peerEventRanges = peerEventInstances.map(util_1.eventInstanceToEventRange);
        var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
        var constraintVal = eventDef.getConstraint();
        var overlapVal = eventDef.getOverlap();
        var eventAllowFunc = this.opt('eventAllow');
        for (i = 0; i < eventFootprints.length; i++) {
            if (!this.isFootprintAllowed(eventFootprints[i].componentFootprint, peerEventFootprints, constraintVal, overlapVal, eventFootprints[i].eventInstance)) {
                return false;
            }
        }
        if (eventAllowFunc) {
            for (i = 0; i < eventFootprints.length; i++) {
                if (eventAllowFunc(eventFootprints[i].componentFootprint.toLegacy(this._calendar), eventFootprints[i].getEventLegacy()) === false) {
                    return false;
                }
            }
        }
        return true;
    };
    Constraints.prototype.getPeerEventInstances = function (eventDef) {
        return this.eventManager.getEventInstancesWithoutId(eventDef.id);
    };
    Constraints.prototype.isSelectionFootprintAllowed = function (componentFootprint) {
        var peerEventInstances = this.eventManager.getEventInstances();
        var peerEventRanges = peerEventInstances.map(util_1.eventInstanceToEventRange);
        var peerEventFootprints = this.eventRangesToEventFootprints(peerEventRanges);
        var selectAllowFunc;
        if (this.isFootprintAllowed(componentFootprint, peerEventFootprints, this.opt('selectConstraint'), this.opt('selectOverlap'))) {
            selectAllowFunc = this.opt('selectAllow');
            if (selectAllowFunc) {
                return selectAllowFunc(componentFootprint.toLegacy(this._calendar)) !== false;
            }
            else {
                return true;
            }
        }
        return false;
    };
    Constraints.prototype.isFootprintAllowed = function (componentFootprint, peerEventFootprints, constraintVal, overlapVal, subjectEventInstance // optional
    ) {
        var constraintFootprints; // ComponentFootprint[]
        var overlapEventFootprints; // EventFootprint[]
        if (constraintVal != null) {
            constraintFootprints = this.constraintValToFootprints(constraintVal, componentFootprint.isAllDay);
            if (!this.isFootprintWithinConstraints(componentFootprint, constraintFootprints)) {
                return false;
            }
        }
        overlapEventFootprints = this.collectOverlapEventFootprints(peerEventFootprints, componentFootprint);
        if (overlapVal === false) {
            if (overlapEventFootprints.length) {
                return false;
            }
        }
        else if (typeof overlapVal === 'function') {
            if (!isOverlapsAllowedByFunc(overlapEventFootprints, overlapVal, subjectEventInstance)) {
                return false;
            }
        }
        if (subjectEventInstance) {
            if (!isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance)) {
                return false;
            }
        }
        return true;
    };
    // Constraint
    // ------------------------------------------------------------------------------------------------
    Constraints.prototype.isFootprintWithinConstraints = function (componentFootprint, constraintFootprints) {
        var i;
        for (i = 0; i < constraintFootprints.length; i++) {
            if (this.footprintContainsFootprint(constraintFootprints[i], componentFootprint)) {
                return true;
            }
        }
        return false;
    };
    Constraints.prototype.constraintValToFootprints = function (constraintVal, isAllDay) {
        var eventInstances;
        if (constraintVal === 'businessHours') {
            return this.buildCurrentBusinessFootprints(isAllDay);
        }
        else if (typeof constraintVal === 'object' && constraintVal) { // non-null object
            eventInstances = this.parseEventDefToInstances(constraintVal); // handles recurring events
            if (!eventInstances) { // invalid input. fallback to parsing footprint directly
                return this.parseFootprints(constraintVal);
            }
            else {
                return this.eventInstancesToFootprints(eventInstances);
            }
        }
        else if (constraintVal != null) { // an ID
            eventInstances = this.eventManager.getEventInstancesWithId(constraintVal);
            return this.eventInstancesToFootprints(eventInstances);
        }
    };
    // returns ComponentFootprint[]
    // uses current view's range
    Constraints.prototype.buildCurrentBusinessFootprints = function (isAllDay) {
        var view = this._calendar.view;
        var businessHourGenerator = view.get('businessHourGenerator');
        var unzonedRange = view.dateProfile.activeUnzonedRange;
        var eventInstanceGroup = businessHourGenerator.buildEventInstanceGroup(isAllDay, unzonedRange);
        if (eventInstanceGroup) {
            return this.eventInstancesToFootprints(eventInstanceGroup.eventInstances);
        }
        else {
            return [];
        }
    };
    // conversion util
    Constraints.prototype.eventInstancesToFootprints = function (eventInstances) {
        var eventRanges = eventInstances.map(util_1.eventInstanceToEventRange);
        var eventFootprints = this.eventRangesToEventFootprints(eventRanges);
        return eventFootprints.map(util_1.eventFootprintToComponentFootprint);
    };
    // Overlap
    // ------------------------------------------------------------------------------------------------
    Constraints.prototype.collectOverlapEventFootprints = function (peerEventFootprints, targetFootprint) {
        var overlapEventFootprints = [];
        var i;
        for (i = 0; i < peerEventFootprints.length; i++) {
            if (this.footprintsIntersect(targetFootprint, peerEventFootprints[i].componentFootprint)) {
                overlapEventFootprints.push(peerEventFootprints[i]);
            }
        }
        return overlapEventFootprints;
    };
    // Conversion: eventDefs -> eventInstances -> eventRanges -> eventFootprints -> componentFootprints
    // ------------------------------------------------------------------------------------------------
    // NOTE: this might seem like repetitive code with the Grid class, however, this code is related to
    // constraints whereas the Grid code is related to rendering. Each approach might want to convert
    // eventRanges -> eventFootprints in a different way. Regardless, there are opportunities to make
    // this more DRY.
    /*
    Returns false on invalid input.
    */
    Constraints.prototype.parseEventDefToInstances = function (eventInput) {
        var eventManager = this.eventManager;
        var eventDef = EventDefParser_1.default.parse(eventInput, new EventSource_1.default(this._calendar));
        if (!eventDef) { // invalid
            return false;
        }
        return eventDef.buildInstances(eventManager.currentPeriod.unzonedRange);
    };
    Constraints.prototype.eventRangesToEventFootprints = function (eventRanges) {
        var i;
        var eventFootprints = [];
        for (i = 0; i < eventRanges.length; i++) {
            eventFootprints.push.apply(// footprints
            eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
        }
        return eventFootprints;
    };
    Constraints.prototype.eventRangeToEventFootprints = function (eventRange) {
        return [util_1.eventRangeToEventFootprint(eventRange)];
    };
    /*
    Parses footprints directly.
    Very similar to EventDateProfile::parse :(
    */
    Constraints.prototype.parseFootprints = function (rawInput) {
        var start;
        var end;
        if (rawInput.start) {
            start = this._calendar.moment(rawInput.start);
            if (!start.isValid()) {
                start = null;
            }
        }
        if (rawInput.end) {
            end = this._calendar.moment(rawInput.end);
            if (!end.isValid()) {
                end = null;
            }
        }
        return [
            new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), (start && !start.hasTime()) || (end && !end.hasTime()) // isAllDay
            )
        ];
    };
    // Footprint Utils
    // ----------------------------------------------------------------------------------------
    Constraints.prototype.footprintContainsFootprint = function (outerFootprint, innerFootprint) {
        return outerFootprint.unzonedRange.containsRange(innerFootprint.unzonedRange);
    };
    Constraints.prototype.footprintsIntersect = function (footprint0, footprint1) {
        return footprint0.unzonedRange.intersectsWith(footprint1.unzonedRange);
    };
    return Constraints;
}());
exports.default = Constraints;
// optional subjectEventInstance
function isOverlapsAllowedByFunc(overlapEventFootprints, overlapFunc, subjectEventInstance) {
    var i;
    for (i = 0; i < overlapEventFootprints.length; i++) {
        if (!overlapFunc(overlapEventFootprints[i].eventInstance.toLegacy(), subjectEventInstance ? subjectEventInstance.toLegacy() : null)) {
            return false;
        }
    }
    return true;
}
function isOverlapEventInstancesAllowed(overlapEventFootprints, subjectEventInstance) {
    var subjectLegacyInstance = subjectEventInstance.toLegacy();
    var i;
    var overlapEventInstance;
    var overlapEventDef;
    var overlapVal;
    for (i = 0; i < overlapEventFootprints.length; i++) {
        overlapEventInstance = overlapEventFootprints[i].eventInstance;
        overlapEventDef = overlapEventInstance.def;
        // don't need to pass in calendar, because don't want to consider global eventOverlap property,
        // because we already considered that earlier in the process.
        overlapVal = overlapEventDef.getOverlap();
        if (overlapVal === false) {
            return false;
        }
        else if (typeof overlapVal === 'function') {
            if (!overlapVal(overlapEventInstance.toLegacy(), subjectLegacyInstance)) {
                return false;
            }
        }
    }
    return true;
}


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

/*
USAGE:
  import { default as ParsableModelMixin, ParsableModelInterface } from './ParsableModelMixin'
in class:
  applyProps: ParsableModelInterface['applyProps']
  applyManualStandardProps: ParsableModelInterface['applyManualStandardProps']
  applyMiscProps: ParsableModelInterface['applyMiscProps']
  isStandardProp: ParsableModelInterface['isStandardProp']
  static defineStandardProps = ParsableModelMixin.defineStandardProps
  static copyVerbatimStandardProps = ParsableModelMixin.copyVerbatimStandardProps
after class:
  ParsableModelMixin.mixInto(TheClass)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var object_1 = __webpack_require__(5);
var Mixin_1 = __webpack_require__(18);
var ParsableModelMixin = /** @class */ (function (_super) {
    tslib_1.__extends(ParsableModelMixin, _super);
    function ParsableModelMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParsableModelMixin.defineStandardProps = function (propDefs) {
        var proto = this.prototype;
        if (!proto.hasOwnProperty('standardPropMap')) {
            proto.standardPropMap = Object.create(proto.standardPropMap);
        }
        object_1.copyOwnProps(propDefs, proto.standardPropMap);
    };
    ParsableModelMixin.copyVerbatimStandardProps = function (src, dest) {
        var map = this.prototype.standardPropMap;
        var propName;
        for (propName in map) {
            if (src[propName] != null && // in the src object?
                map[propName] === true // false means "copy verbatim"
            ) {
                dest[propName] = src[propName];
            }
        }
    };
    /*
    Returns true/false for success.
    Meant to be only called ONCE, at object creation.
    */
    ParsableModelMixin.prototype.applyProps = function (rawProps) {
        var standardPropMap = this.standardPropMap;
        var manualProps = {};
        var miscProps = {};
        var propName;
        for (propName in rawProps) {
            if (standardPropMap[propName] === true) { // copy verbatim
                this[propName] = rawProps[propName];
            }
            else if (standardPropMap[propName] === false) {
                manualProps[propName] = rawProps[propName];
            }
            else {
                miscProps[propName] = rawProps[propName];
            }
        }
        this.applyMiscProps(miscProps);
        return this.applyManualStandardProps(manualProps);
    };
    /*
    If subclasses override, they must call this supermethod and return the boolean response.
    Meant to be only called ONCE, at object creation.
    */
    ParsableModelMixin.prototype.applyManualStandardProps = function (rawProps) {
        return true;
    };
    /*
    Can be called even after initial object creation.
    */
    ParsableModelMixin.prototype.applyMiscProps = function (rawProps) {
        // subclasses can implement
    };
    /*
    TODO: why is this a method when defineStandardProps is static
    */
    ParsableModelMixin.prototype.isStandardProp = function (propName) {
        return propName in this.standardPropMap;
    };
    return ParsableModelMixin;
}(Mixin_1.default));
exports.default = ParsableModelMixin;
ParsableModelMixin.prototype.standardPropMap = {}; // will be cloned by defineStandardProps


/***/ }),
/* 217 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventInstance = /** @class */ (function () {
    function EventInstance(def, dateProfile) {
        this.def = def;
        this.dateProfile = dateProfile;
    }
    EventInstance.prototype.toLegacy = function () {
        var dateProfile = this.dateProfile;
        var obj = this.def.toLegacy();
        obj.start = dateProfile.start.clone();
        obj.end = dateProfile.end ? dateProfile.end.clone() : null;
        return obj;
    };
    return EventInstance;
}());
exports.default = EventInstance;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var moment = __webpack_require__(0);
var object_1 = __webpack_require__(5);
var EventDef_1 = __webpack_require__(39);
var EventInstance_1 = __webpack_require__(217);
var EventDateProfile_1 = __webpack_require__(22);
var RecurringEventDef = /** @class */ (function (_super) {
    tslib_1.__extends(RecurringEventDef, _super);
    function RecurringEventDef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecurringEventDef.prototype.isAllDay = function () {
        return !this.startTime && !this.endTime;
    };
    RecurringEventDef.prototype.buildInstances = function (unzonedRange) {
        var calendar = this.source.calendar;
        var unzonedDate = unzonedRange.getStart();
        var unzonedEnd = unzonedRange.getEnd();
        var zonedDayStart;
        var instanceStart;
        var instanceEnd;
        var instances = [];
        while (unzonedDate.isBefore(unzonedEnd)) {
            // if everyday, or this particular day-of-week
            if (!this.dowHash || this.dowHash[unzonedDate.day()]) {
                zonedDayStart = calendar.applyTimezone(unzonedDate);
                instanceStart = zonedDayStart.clone();
                instanceEnd = null;
                if (this.startTime) {
                    instanceStart.time(this.startTime);
                }
                else {
                    instanceStart.stripTime();
                }
                if (this.endTime) {
                    instanceEnd = zonedDayStart.clone().time(this.endTime);
                }
                instances.push(new EventInstance_1.default(this, // definition
                new EventDateProfile_1.default(instanceStart, instanceEnd, calendar)));
            }
            unzonedDate.add(1, 'days');
        }
        return instances;
    };
    RecurringEventDef.prototype.setDow = function (dowNumbers) {
        if (!this.dowHash) {
            this.dowHash = {};
        }
        for (var i = 0; i < dowNumbers.length; i++) {
            this.dowHash[dowNumbers[i]] = true;
        }
    };
    RecurringEventDef.prototype.clone = function () {
        var def = _super.prototype.clone.call(this);
        if (def.startTime) {
            def.startTime = moment.duration(this.startTime);
        }
        if (def.endTime) {
            def.endTime = moment.duration(this.endTime);
        }
        if (this.dowHash) {
            def.dowHash = object_1.assignTo({}, this.dowHash);
        }
        return def;
    };
    return RecurringEventDef;
}(EventDef_1.default));
exports.default = RecurringEventDef;
/*
HACK to work with TypeScript mixins
NOTE: if super-method fails, should still attempt to apply
*/
RecurringEventDef.prototype.applyProps = function (rawProps) {
    var superSuccess = EventDef_1.default.prototype.applyProps.call(this, rawProps);
    if (rawProps.start) {
        this.startTime = moment.duration(rawProps.start);
    }
    if (rawProps.end) {
        this.endTime = moment.duration(rawProps.end);
    }
    if (rawProps.dow) {
        this.setDow(rawProps.dow);
    }
    return superSuccess;
};
// Parsing
// ---------------------------------------------------------------------------------------------------------------------
RecurringEventDef.defineStandardProps({
    start: false,
    end: false,
    dow: false
});


/***/ }),
/* 219 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventRange = /** @class */ (function () {
    function EventRange(unzonedRange, eventDef, eventInstance) {
        this.unzonedRange = unzonedRange;
        this.eventDef = eventDef;
        if (eventInstance) {
            this.eventInstance = eventInstance;
        }
    }
    return EventRange;
}());
exports.default = EventRange;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = __webpack_require__(5);
var util_1 = __webpack_require__(40);
var EventInstanceGroup_1 = __webpack_require__(23);
var RecurringEventDef_1 = __webpack_require__(218);
var EventSource_1 = __webpack_require__(9);
var BUSINESS_HOUR_EVENT_DEFAULTS = {
    start: '09:00',
    end: '17:00',
    dow: [1, 2, 3, 4, 5],
    rendering: 'inverse-background'
    // classNames are defined in businessHoursSegClasses
};
var BusinessHourGenerator = /** @class */ (function () {
    function BusinessHourGenerator(rawComplexDef, calendar) {
        this.rawComplexDef = rawComplexDef;
        this.calendar = calendar;
    }
    BusinessHourGenerator.prototype.buildEventInstanceGroup = function (isAllDay, unzonedRange) {
        var eventDefs = this.buildEventDefs(isAllDay);
        var eventInstanceGroup;
        if (eventDefs.length) {
            eventInstanceGroup = new EventInstanceGroup_1.default(util_1.eventDefsToEventInstances(eventDefs, unzonedRange));
            // so that inverse-background rendering can happen even when no eventRanges in view
            eventInstanceGroup.explicitEventDef = eventDefs[0];
            return eventInstanceGroup;
        }
    };
    BusinessHourGenerator.prototype.buildEventDefs = function (isAllDay) {
        var rawComplexDef = this.rawComplexDef;
        var rawDefs = [];
        var requireDow = false;
        var i;
        var defs = [];
        if (rawComplexDef === true) {
            rawDefs = [{}]; // will get BUSINESS_HOUR_EVENT_DEFAULTS verbatim
        }
        else if (Array.isArray(rawComplexDef)) {
            rawDefs = rawComplexDef;
            requireDow = true; // every sub-definition NEEDS a day-of-week
        }
        else if (typeof rawComplexDef === 'object' && rawComplexDef) { // non-null object
            rawDefs = [rawComplexDef];
        }
        for (i = 0; i < rawDefs.length; i++) {
            if (!requireDow || rawDefs[i].dow) {
                defs.push(this.buildEventDef(isAllDay, rawDefs[i]));
            }
        }
        return defs;
    };
    BusinessHourGenerator.prototype.buildEventDef = function (isAllDay, rawDef) {
        var fullRawDef = object_1.assignTo({}, BUSINESS_HOUR_EVENT_DEFAULTS, rawDef);
        if (isAllDay) {
            fullRawDef.start = null;
            fullRawDef.end = null;
        }
        return RecurringEventDef_1.default.parse(fullRawDef, new EventSource_1.default(this.calendar) // dummy source
        );
    };
    return BusinessHourGenerator;
}());
exports.default = BusinessHourGenerator;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Theme_1 = __webpack_require__(24);
var StandardTheme = /** @class */ (function (_super) {
    tslib_1.__extends(StandardTheme, _super);
    function StandardTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StandardTheme;
}(Theme_1.default));
exports.default = StandardTheme;
StandardTheme.prototype.classes = {
    widget: 'fc-unthemed',
    widgetHeader: 'fc-widget-header',
    widgetContent: 'fc-widget-content',
    buttonGroup: 'fc-button-group',
    button: 'fc-button',
    cornerLeft: 'fc-corner-left',
    cornerRight: 'fc-corner-right',
    stateDefault: 'fc-state-default',
    stateActive: 'fc-state-active',
    stateDisabled: 'fc-state-disabled',
    stateHover: 'fc-state-hover',
    stateDown: 'fc-state-down',
    popoverHeader: 'fc-widget-header',
    popoverContent: 'fc-widget-content',
    // day grid
    headerRow: 'fc-widget-header',
    dayRow: 'fc-widget-content',
    // list view
    listView: 'fc-widget-content'
};
StandardTheme.prototype.baseIconClass = 'fc-icon';
StandardTheme.prototype.iconClasses = {
    close: 'fc-icon-x',
    prev: 'fc-icon-left-single-arrow',
    next: 'fc-icon-right-single-arrow',
    prevYear: 'fc-icon-left-double-arrow',
    nextYear: 'fc-icon-right-double-arrow'
};
StandardTheme.prototype.iconOverrideOption = 'buttonIcons';
StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Theme_1 = __webpack_require__(24);
var JqueryUiTheme = /** @class */ (function (_super) {
    tslib_1.__extends(JqueryUiTheme, _super);
    function JqueryUiTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return JqueryUiTheme;
}(Theme_1.default));
exports.default = JqueryUiTheme;
JqueryUiTheme.prototype.classes = {
    widget: 'ui-widget',
    widgetHeader: 'ui-widget-header',
    widgetContent: 'ui-widget-content',
    buttonGroup: 'fc-button-group',
    button: 'ui-button',
    cornerLeft: 'ui-corner-left',
    cornerRight: 'ui-corner-right',
    stateDefault: 'ui-state-default',
    stateActive: 'ui-state-active',
    stateDisabled: 'ui-state-disabled',
    stateHover: 'ui-state-hover',
    stateDown: 'ui-state-down',
    today: 'ui-state-highlight',
    popoverHeader: 'ui-widget-header',
    popoverContent: 'ui-widget-content',
    // day grid
    headerRow: 'ui-widget-header',
    dayRow: 'ui-widget-content',
    // list view
    listView: 'ui-widget-content'
};
JqueryUiTheme.prototype.baseIconClass = 'ui-icon';
JqueryUiTheme.prototype.iconClasses = {
    close: 'ui-icon-closethick',
    prev: 'ui-icon-circle-triangle-w',
    next: 'ui-icon-circle-triangle-e',
    prevYear: 'ui-icon-seek-prev',
    nextYear: 'ui-icon-seek-next'
};
JqueryUiTheme.prototype.iconOverrideOption = 'themeButtonIcons';
JqueryUiTheme.prototype.iconOverrideCustomButtonOption = 'themeIcon';
JqueryUiTheme.prototype.iconOverridePrefix = 'ui-icon-';


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var promise_1 = __webpack_require__(244);
var EventSource_1 = __webpack_require__(9);
var FuncEventSource = /** @class */ (function (_super) {
    tslib_1.__extends(FuncEventSource, _super);
    function FuncEventSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FuncEventSource.parse = function (rawInput, calendar) {
        var rawProps;
        // normalize raw input
        if (typeof rawInput.events === 'function') { // extended form
            rawProps = rawInput;
        }
        else if (typeof rawInput === 'function') { // short form
            rawProps = { events: rawInput };
        }
        if (rawProps) {
            return EventSource_1.default.parse.call(this, rawProps, calendar);
        }
        return false;
    };
    FuncEventSource.prototype.fetch = function (start, end, timezone, onSuccess, onFailure) {
        var _this = this;
        this.calendar.pushLoading();
        promise_1.unpromisify(// allow the func to return a promise
        this.func.bind(this.calendar, start.clone(), end.clone(), timezone), function (rawEventDefs) {
            _this.calendar.popLoading();
            onSuccess(_this.parseEventDefs(rawEventDefs));
        }, function () {
            _this.calendar.popLoading();
            onFailure();
        });
    };
    FuncEventSource.prototype.getPrimitive = function () {
        return this.func;
    };
    FuncEventSource.prototype.applyManualStandardProps = function (rawProps) {
        var superSuccess = _super.prototype.applyManualStandardProps.call(this, rawProps);
        this.func = rawProps.events;
        return superSuccess;
    };
    return FuncEventSource;
}(EventSource_1.default));
exports.default = FuncEventSource;
FuncEventSource.defineStandardProps({
    events: false // don't automatically transfer
});


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var request = __webpack_require__(58);
var object_1 = __webpack_require__(5);
var misc_1 = __webpack_require__(4);
var EventSource_1 = __webpack_require__(9);
var JsonFeedEventSource = /** @class */ (function (_super) {
    tslib_1.__extends(JsonFeedEventSource, _super);
    function JsonFeedEventSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JsonFeedEventSource.parse = function (rawInput, calendar) {
        var rawProps;
        // normalize raw input
        if (typeof rawInput.url === 'string') { // extended form
            rawProps = rawInput;
        }
        else if (typeof rawInput === 'string') { // short form
            rawProps = { url: rawInput };
        }
        if (rawProps) {
            return EventSource_1.default.parse.call(this, rawProps, calendar);
        }
        return false;
    };
    JsonFeedEventSource.prototype.fetch = function (start, end, timezone, onSuccess, onFailure) {
        var _this = this;
        var ajaxSettings = this.ajaxSettings;
        var requestParams = this.buildRequestParams(start, end, timezone);
        var theRequest;
        this.calendar.pushLoading();
        if (!ajaxSettings.method || ajaxSettings.method.toUpperCase() === 'GET') {
            theRequest = request.get(this.url).query(requestParams); // querystring params
        }
        else {
            theRequest = request(ajaxSettings.method, this.url).send(requestParams); // body data
        }
        theRequest.end(function (error, res) {
            var rawEventDefs;
            _this.calendar.popLoading();
            if (!error) {
                if (res.body) { // parsed JSON
                    rawEventDefs = res.body;
                }
                else if (res.text) {
                    // if the server doesn't set Content-Type, won't be parsed as JSON. parse anyway.
                    rawEventDefs = JSON.parse(res.text);
                }
            }
            if (rawEventDefs) {
                var callbackRes = misc_1.applyAll(ajaxSettings.success, null, [rawEventDefs, res]);
                if (Array.isArray(callbackRes)) {
                    rawEventDefs = callbackRes;
                }
                onSuccess(_this.parseEventDefs(rawEventDefs));
            }
            else {
                misc_1.applyAll(ajaxSettings.error, null, [error, res]);
                onFailure();
            }
        });
    };
    JsonFeedEventSource.prototype.buildRequestParams = function (start, end, timezone) {
        var calendar = this.calendar;
        var ajaxSettings = this.ajaxSettings;
        var startParam;
        var endParam;
        var timezoneParam;
        var customRequestParams;
        var params = {};
        startParam = this.startParam;
        if (startParam == null) {
            startParam = calendar.opt('startParam');
        }
        endParam = this.endParam;
        if (endParam == null) {
            endParam = calendar.opt('endParam');
        }
        timezoneParam = this.timezoneParam;
        if (timezoneParam == null) {
            timezoneParam = calendar.opt('timezoneParam');
        }
        // retrieve any outbound GET/POST data from the options
        if (typeof ajaxSettings.data === 'function') {
            // supplied as a function that returns a key/value object
            customRequestParams = ajaxSettings.data();
        }
        else {
            // probably supplied as a straight key/value object
            customRequestParams = ajaxSettings.data || {};
        }
        object_1.assignTo(params, customRequestParams);
        params[startParam] = start.format();
        params[endParam] = end.format();
        if (timezone && timezone !== 'local') {
            params[timezoneParam] = timezone;
        }
        return params;
    };
    JsonFeedEventSource.prototype.getPrimitive = function () {
        return this.url;
    };
    JsonFeedEventSource.prototype.applyMiscProps = function (rawProps) {
        this.ajaxSettings = rawProps;
    };
    return JsonFeedEventSource;
}(EventSource_1.default));
exports.default = JsonFeedEventSource;
JsonFeedEventSource.defineStandardProps({
    // automatically transfer (true)...
    url: true,
    startParam: true,
    endParam: true,
    timezoneParam: true
});


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var EmitterMixin_1 = __webpack_require__(15);
var TaskQueue = /** @class */ (function () {
    function TaskQueue() {
        this.q = [];
        this.isPaused = false;
        this.isRunning = false;
    }
    TaskQueue.prototype.queue = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.q.push.apply(this.q, args); // append
        this.tryStart();
    };
    TaskQueue.prototype.pause = function () {
        this.isPaused = true;
    };
    TaskQueue.prototype.resume = function () {
        this.isPaused = false;
        this.tryStart();
    };
    TaskQueue.prototype.getIsIdle = function () {
        return !this.isRunning && !this.isPaused;
    };
    TaskQueue.prototype.tryStart = function () {
        if (!this.isRunning && this.canRunNext()) {
            this.isRunning = true;
            this.trigger('start');
            this.runRemaining();
        }
    };
    TaskQueue.prototype.canRunNext = function () {
        return !this.isPaused && this.q.length;
    };
    TaskQueue.prototype.runRemaining = function () {
        var _this = this;
        var task;
        var res;
        do {
            task = this.q.shift(); // always freshly reference q. might have been reassigned.
            res = this.runTask(task);
            if (res && res.then) {
                res.then(function () {
                    if (_this.canRunNext()) {
                        _this.runRemaining();
                    }
                });
                return; // prevent marking as stopped
            }
        } while (this.canRunNext());
        this.trigger('stop'); // not really a 'stop' ... more of a 'drained'
        this.isRunning = false;
        // if 'stop' handler added more tasks.... TODO: write test for this
        this.tryStart();
    };
    TaskQueue.prototype.runTask = function (task) {
        return task(); // task *is* the function, but subclasses can change the format of a task
    };
    return TaskQueue;
}());
exports.default = TaskQueue;
EmitterMixin_1.default.mixInto(TaskQueue);


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var TaskQueue_1 = __webpack_require__(225);
var RenderQueue = /** @class */ (function (_super) {
    tslib_1.__extends(RenderQueue, _super);
    function RenderQueue(waitsByNamespace) {
        var _this = _super.call(this) || this;
        _this.waitsByNamespace = waitsByNamespace || {};
        return _this;
    }
    RenderQueue.prototype.queue = function (taskFunc, namespace, type) {
        var task = {
            func: taskFunc,
            namespace: namespace,
            type: type
        };
        var waitMs;
        if (namespace) {
            waitMs = this.waitsByNamespace[namespace];
        }
        if (this.waitNamespace) {
            if (namespace === this.waitNamespace && waitMs != null) {
                this.delayWait(waitMs);
            }
            else {
                this.clearWait();
                this.tryStart();
            }
        }
        if (this.compoundTask(task)) { // appended to queue?
            if (!this.waitNamespace && waitMs != null) {
                this.startWait(namespace, waitMs);
            }
            else {
                this.tryStart();
            }
        }
    };
    RenderQueue.prototype.startWait = function (namespace, waitMs) {
        this.waitNamespace = namespace;
        this.spawnWait(waitMs);
    };
    RenderQueue.prototype.delayWait = function (waitMs) {
        clearTimeout(this.waitId);
        this.spawnWait(waitMs);
    };
    RenderQueue.prototype.spawnWait = function (waitMs) {
        var _this = this;
        this.waitId = setTimeout(function () {
            _this.waitNamespace = null;
            _this.tryStart();
        }, waitMs);
    };
    RenderQueue.prototype.clearWait = function () {
        if (this.waitNamespace) {
            clearTimeout(this.waitId);
            this.waitId = null;
            this.waitNamespace = null;
        }
    };
    RenderQueue.prototype.canRunNext = function () {
        if (!_super.prototype.canRunNext.call(this)) {
            return false;
        }
        // waiting for a certain namespace to stop receiving tasks?
        if (this.waitNamespace) {
            var q = this.q;
            // if there was a different namespace task in the meantime,
            // that forces all previously-waiting tasks to suddenly execute.
            // TODO: find a way to do this in constant time.
            for (var i = 0; i < q.length; i++) {
                if (q[i].namespace !== this.waitNamespace) {
                    return true; // allow execution
                }
            }
            return false;
        }
        return true;
    };
    RenderQueue.prototype.runTask = function (task) {
        task.func();
    };
    RenderQueue.prototype.compoundTask = function (newTask) {
        var q = this.q;
        var shouldAppend = true;
        var i;
        var task;
        if (newTask.namespace && newTask.type === 'destroy') {
            // remove all init/add/remove ops with same namespace, regardless of order
            for (i = q.length - 1; i >= 0; i--) {
                task = q[i];
                switch (task.type) {
                    case 'init':
                        shouldAppend = false;
                    // the latest destroy is cancelled out by not doing the init
                    /* falls through */
                    case 'add':
                    /* falls through */
                    case 'remove':
                        q.splice(i, 1); // remove task
                }
            }
        }
        if (shouldAppend) {
            q.push(newTask);
        }
        return shouldAppend;
    };
    return RenderQueue;
}(TaskQueue_1.default));
exports.default = RenderQueue;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var moment = __webpack_require__(0);
var html_1 = __webpack_require__(6);
var date_1 = __webpack_require__(8);
var moment_ext_1 = __webpack_require__(14);
var date_formatting_1 = __webpack_require__(52);
var Component_1 = __webpack_require__(245);
var util_1 = __webpack_require__(40);
var DateComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DateComponent, _super);
    function DateComponent(_view, _options) {
        var _this = _super.call(this) || this;
        _this.isRTL = false; // frequently accessed options
        _this.hitsNeededDepth = 0; // necessary because multiple callers might need the same hits
        _this.hasAllDayBusinessHours = false; // TODO: unify with largeUnit and isTimeScale?
        _this.isDatesRendered = false;
        // hack to set options prior to the this.opt calls
        if (_view) {
            _this['view'] = _view;
        }
        if (_options) {
            _this['options'] = _options;
        }
        _this.uid = String(DateComponent.guid++);
        _this.childrenByUid = {};
        _this.nextDayThreshold = moment.duration(_this.opt('nextDayThreshold'));
        _this.isRTL = _this.opt('isRTL');
        if (_this.fillRendererClass) {
            _this.fillRenderer = new _this.fillRendererClass(_this);
        }
        if (_this.eventRendererClass) { // fillRenderer is optional -----v
            _this.eventRenderer = new _this.eventRendererClass(_this, _this.fillRenderer);
        }
        if (_this.helperRendererClass && _this.eventRenderer) {
            _this.helperRenderer = new _this.helperRendererClass(_this, _this.eventRenderer);
        }
        if (_this.businessHourRendererClass && _this.fillRenderer) {
            _this.businessHourRenderer = new _this.businessHourRendererClass(_this, _this.fillRenderer);
        }
        return _this;
    }
    DateComponent.prototype.addChild = function (child) {
        if (!this.childrenByUid[child.uid]) {
            this.childrenByUid[child.uid] = child;
            return true;
        }
        return false;
    };
    DateComponent.prototype.removeChild = function (child) {
        if (this.childrenByUid[child.uid]) {
            delete this.childrenByUid[child.uid];
            return true;
        }
        return false;
    };
    // TODO: only do if isInDom?
    // TODO: make part of Component, along with children/batch-render system?
    DateComponent.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        this.callChildren('updateSize', arguments);
    };
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.opt = function (name) {
        return this._getView().opt(name); // default implementation
    };
    DateComponent.prototype.publiclyTrigger = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var calendar = this._getCalendar();
        return calendar.publiclyTrigger.apply(calendar, args);
    };
    DateComponent.prototype.hasPublicHandlers = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var calendar = this._getCalendar();
        return calendar.hasPublicHandlers.apply(calendar, args);
    };
    // Date
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.executeDateRender = function (dateProfile) {
        this.dateProfile = dateProfile; // for rendering
        this.renderDates(dateProfile);
        this.isDatesRendered = true;
        this.callChildren('executeDateRender', arguments);
    };
    DateComponent.prototype.executeDateUnrender = function () {
        this.callChildren('executeDateUnrender', arguments);
        this.dateProfile = null;
        this.unrenderDates();
        this.isDatesRendered = false;
    };
    // date-cell content only
    DateComponent.prototype.renderDates = function (dateProfile) {
        // subclasses should implement
    };
    // date-cell content only
    DateComponent.prototype.unrenderDates = function () {
        // subclasses should override
    };
    // Now-Indicator
    // -----------------------------------------------------------------------------------------------------------------
    // Returns a string unit, like 'second' or 'minute' that defined how often the current time indicator
    // should be refreshed. If something falsy is returned, no time indicator is rendered at all.
    DateComponent.prototype.getNowIndicatorUnit = function () {
        // subclasses should implement
    };
    // Renders a current time indicator at the given datetime
    DateComponent.prototype.renderNowIndicator = function (date) {
        this.callChildren('renderNowIndicator', arguments);
    };
    // Undoes the rendering actions from renderNowIndicator
    DateComponent.prototype.unrenderNowIndicator = function () {
        this.callChildren('unrenderNowIndicator', arguments);
    };
    // Business Hours
    // ---------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.renderBusinessHours = function (businessHourGenerator) {
        if (this.businessHourRenderer) {
            this.businessHourRenderer.render(businessHourGenerator);
        }
        this.callChildren('renderBusinessHours', arguments);
    };
    // Unrenders previously-rendered business-hours
    DateComponent.prototype.unrenderBusinessHours = function () {
        this.callChildren('unrenderBusinessHours', arguments);
        if (this.businessHourRenderer) {
            this.businessHourRenderer.unrender();
        }
    };
    // Event Displaying
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.executeEventRender = function (eventsPayload) {
        if (this.eventRenderer) {
            this.eventRenderer.rangeUpdated(); // poorly named now
            this.eventRenderer.render(eventsPayload);
        }
        else if (this['renderEvents']) { // legacy
            this['renderEvents'](convertEventsPayloadToLegacyArray(eventsPayload));
        }
        this.callChildren('executeEventRender', arguments);
    };
    DateComponent.prototype.executeEventUnrender = function () {
        this.callChildren('executeEventUnrender', arguments);
        if (this.eventRenderer) {
            this.eventRenderer.unrender();
        }
        else if (this['destroyEvents']) { // legacy
            this['destroyEvents']();
        }
    };
    DateComponent.prototype.getBusinessHourSegs = function () {
        var segs = this.getOwnBusinessHourSegs();
        this.iterChildren(function (child) {
            segs.push.apply(segs, child.getBusinessHourSegs());
        });
        return segs;
    };
    DateComponent.prototype.getOwnBusinessHourSegs = function () {
        if (this.businessHourRenderer) {
            return this.businessHourRenderer.getSegs();
        }
        return [];
    };
    DateComponent.prototype.getEventSegs = function () {
        var segs = this.getOwnEventSegs();
        this.iterChildren(function (child) {
            segs.push.apply(segs, child.getEventSegs());
        });
        return segs;
    };
    DateComponent.prototype.getOwnEventSegs = function () {
        if (this.eventRenderer) {
            return this.eventRenderer.getSegs();
        }
        return [];
    };
    // Event Rendering Triggering
    // -----------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.triggerAfterEventsRendered = function () {
        this.triggerAfterEventSegsRendered(this.getEventSegs());
        this.publiclyTrigger('eventAfterAllRender', {
            context: this,
            args: [this]
        });
    };
    DateComponent.prototype.triggerAfterEventSegsRendered = function (segs) {
        var _this = this;
        // an optimization, because getEventLegacy is expensive
        if (this.hasPublicHandlers('eventAfterRender')) {
            segs.forEach(function (seg) {
                var legacy;
                if (seg.el) { // necessary?
                    legacy = seg.footprint.getEventLegacy();
                    _this.publiclyTrigger('eventAfterRender', {
                        context: legacy,
                        args: [legacy, seg.el, _this]
                    });
                }
            });
        }
    };
    DateComponent.prototype.triggerBeforeEventsDestroyed = function () {
        this.triggerBeforeEventSegsDestroyed(this.getEventSegs());
    };
    DateComponent.prototype.triggerBeforeEventSegsDestroyed = function (segs) {
        var _this = this;
        if (this.hasPublicHandlers('eventDestroy')) {
            segs.forEach(function (seg) {
                var legacy;
                if (seg.el) { // necessary?
                    legacy = seg.footprint.getEventLegacy();
                    _this.publiclyTrigger('eventDestroy', {
                        context: legacy,
                        args: [legacy, seg.el, _this]
                    });
                }
            });
        }
    };
    // Event Rendering Utils
    // -----------------------------------------------------------------------------------------------------------------
    // Hides all rendered event segments linked to the given event
    // RECURSIVE with subcomponents
    DateComponent.prototype.showEventsWithId = function (eventDefId) {
        this.getEventSegs().forEach(function (seg) {
            if (seg.footprint.eventDef.id === eventDefId &&
                seg.el // necessary?
            ) {
                seg.el.style.visibility = '';
            }
        });
        this.callChildren('showEventsWithId', arguments);
    };
    // Shows all rendered event segments linked to the given event
    // RECURSIVE with subcomponents
    DateComponent.prototype.hideEventsWithId = function (eventDefId) {
        this.getEventSegs().forEach(function (seg) {
            if (seg.footprint.eventDef.id === eventDefId &&
                seg.el // necessary?
            ) {
                seg.el.style.visibility = 'hidden';
            }
        });
        this.callChildren('hideEventsWithId', arguments);
    };
    // Drag-n-Drop Rendering (for both events and external elements)
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of a event or external-element drag over the given drop zone.
    // If an external-element, seg will be `null`.
    // Must return elements used for any mock events.
    DateComponent.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        if (isTouch === void 0) { isTouch = false; }
        var renderedHelper = false;
        this.iterChildren(function (child) {
            if (child.renderDrag(eventFootprints, seg, isTouch)) {
                renderedHelper = true;
            }
        });
        return renderedHelper;
    };
    // Unrenders a visual indication of an event or external-element being dragged.
    DateComponent.prototype.unrenderDrag = function () {
        this.callChildren('unrenderDrag', arguments);
    };
    // EXTERNAL Drag-n-Drop
    // ---------------------------------------------------------------------------------------------------------------
    // Doesn't need to implement a response, but must pass to children
    DateComponent.prototype.handlExternalDragStart = function (ev, el, skipBinding) {
        this.callChildren('handlExternalDragStart', arguments);
    };
    DateComponent.prototype.handleExternalDragMove = function (ev) {
        this.callChildren('handleExternalDragMove', arguments);
    };
    DateComponent.prototype.handleExternalDragStop = function (ev) {
        this.callChildren('handleExternalDragStop', arguments);
    };
    // Event Resizing
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of an event being resized.
    DateComponent.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        this.callChildren('renderEventResize', arguments);
    };
    // Unrenders a visual indication of an event being resized.
    DateComponent.prototype.unrenderEventResize = function () {
        this.callChildren('unrenderEventResize', arguments);
    };
    // Selection
    // ---------------------------------------------------------------------------------------------------------------
    // Renders a visual indication of the selection
    // TODO: rename to `renderSelection` after legacy is gone
    DateComponent.prototype.renderSelectionFootprint = function (componentFootprint) {
        this.renderHighlight(componentFootprint);
        this.callChildren('renderSelectionFootprint', arguments);
    };
    // Unrenders a visual indication of selection
    DateComponent.prototype.unrenderSelection = function () {
        this.unrenderHighlight();
        this.callChildren('unrenderSelection', arguments);
    };
    // Highlight
    // ---------------------------------------------------------------------------------------------------------------
    // Renders an emphasis on the given date range. Given a span (unzoned start/end and other misc data)
    DateComponent.prototype.renderHighlight = function (componentFootprint) {
        if (this.fillRenderer) {
            this.fillRenderer.renderFootprint('highlight', componentFootprint, {
                getClasses: function () {
                    return ['fc-highlight'];
                }
            });
        }
        this.callChildren('renderHighlight', arguments);
    };
    // Unrenders the emphasis on a date range
    DateComponent.prototype.unrenderHighlight = function () {
        if (this.fillRenderer) {
            this.fillRenderer.unrender('highlight');
        }
        this.callChildren('unrenderHighlight', arguments);
    };
    // Hit Areas
    // ---------------------------------------------------------------------------------------------------------------
    // just because all DateComponents support this interface
    // doesn't mean they need to have their own internal coord system. they can defer to sub-components.
    DateComponent.prototype.hitsNeeded = function () {
        if (!(this.hitsNeededDepth++)) {
            this.prepareHits();
        }
        this.callChildren('hitsNeeded', arguments);
    };
    DateComponent.prototype.hitsNotNeeded = function () {
        if (this.hitsNeededDepth && !(--this.hitsNeededDepth)) {
            this.releaseHits();
        }
        this.callChildren('hitsNotNeeded', arguments);
    };
    DateComponent.prototype.prepareHits = function () {
        // subclasses can implement
    };
    DateComponent.prototype.releaseHits = function () {
        // subclasses can implement
    };
    // Given coordinates from the topleft of the document, return data about the date-related area underneath.
    // Can return an object with arbitrary properties (although top/right/left/bottom are encouraged).
    // Must have a `grid` property, a reference to this current grid. TODO: avoid this
    // The returned object will be processed by getHitFootprint and getHitEl.
    DateComponent.prototype.queryHit = function (leftOffset, topOffset) {
        var childrenByUid = this.childrenByUid;
        var uid;
        var hit;
        for (uid in childrenByUid) {
            hit = childrenByUid[uid].queryHit(leftOffset, topOffset);
            if (hit) {
                break;
            }
        }
        return hit;
    };
    DateComponent.prototype.getSafeHitFootprint = function (hit) {
        var footprint = this.getHitFootprint(hit);
        if (!this.dateProfile.activeUnzonedRange.containsRange(footprint.unzonedRange)) {
            return null;
        }
        return footprint;
    };
    DateComponent.prototype.getHitFootprint = function (hit) {
        // what about being abstract!?
    };
    // Given position-level information about a date-related area within the grid,
    // should return an element that best represents it. passed to dayClick callback.
    DateComponent.prototype.getHitEl = function (hit) {
        return null;
    };
    /* Converting eventRange -> eventFootprint
    ------------------------------------------------------------------------------------------------------------------*/
    DateComponent.prototype.eventRangesToEventFootprints = function (eventRanges) {
        var eventFootprints = [];
        var i;
        for (i = 0; i < eventRanges.length; i++) {
            eventFootprints.push.apply(// append
            eventFootprints, this.eventRangeToEventFootprints(eventRanges[i]));
        }
        return eventFootprints;
    };
    DateComponent.prototype.eventRangeToEventFootprints = function (eventRange) {
        return [util_1.eventRangeToEventFootprint(eventRange)];
    };
    /* Converting componentFootprint/eventFootprint -> segs
    ------------------------------------------------------------------------------------------------------------------*/
    DateComponent.prototype.eventFootprintsToSegs = function (eventFootprints) {
        var segs = [];
        var i;
        for (i = 0; i < eventFootprints.length; i++) {
            segs.push.apply(segs, this.eventFootprintToSegs(eventFootprints[i]));
        }
        return segs;
    };
    // Given an event's span (unzoned start/end and other misc data), and the event itself,
    // slices into segments and attaches event-derived properties to them.
    // eventSpan - { start, end, isStart, isEnd, otherthings... }
    DateComponent.prototype.eventFootprintToSegs = function (eventFootprint) {
        var unzonedRange = eventFootprint.componentFootprint.unzonedRange;
        var segs;
        var i;
        var seg;
        segs = this.componentFootprintToSegs(eventFootprint.componentFootprint);
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            if (!unzonedRange.isStart) {
                seg.isStart = false;
            }
            if (!unzonedRange.isEnd) {
                seg.isEnd = false;
            }
            seg.footprint = eventFootprint;
            // TODO: rename to seg.eventFootprint
        }
        return segs;
    };
    DateComponent.prototype.componentFootprintToSegs = function (componentFootprint) {
        return [];
    };
    // Utils
    // ---------------------------------------------------------------------------------------------------------------
    DateComponent.prototype.callChildren = function (methodName, args) {
        this.iterChildren(function (child) {
            child[methodName].apply(child, args);
        });
    };
    DateComponent.prototype.iterChildren = function (func) {
        var childrenByUid = this.childrenByUid;
        var uid;
        for (uid in childrenByUid) {
            func(childrenByUid[uid]);
        }
    };
    DateComponent.prototype._getCalendar = function () {
        var t = this;
        return t.calendar || t.view.calendar;
    };
    DateComponent.prototype._getView = function () {
        return this.view;
    };
    DateComponent.prototype._getDateProfile = function () {
        return this._getView().get('dateProfile');
    };
    // Generates HTML for an anchor to another view into the calendar.
    // Will either generate an <a> tag or a non-clickable <span> tag, depending on enabled settings.
    // `gotoOptions` can either be a moment input, or an object with the form:
    // { date, type, forceOff }
    // `type` is a view-type like "day" or "week". default value is "day".
    // `attrs` and `innerHtml` are use to generate the rest of the HTML tag.
    DateComponent.prototype.buildGotoAnchorHtml = function (gotoOptions, attrs, innerHtml) {
        var date;
        var type;
        var forceOff;
        var finalOptions;
        if (moment.isMoment(gotoOptions) || typeof gotoOptions !== 'object') {
            date = gotoOptions; // a single moment input
        }
        else {
            date = gotoOptions.date;
            type = gotoOptions.type;
            forceOff = gotoOptions.forceOff;
        }
        date = moment_ext_1.default(date); // if a string, parse it
        finalOptions = {
            date: date.format('YYYY-MM-DD'),
            type: type || 'day'
        };
        if (typeof attrs === 'string') {
            innerHtml = attrs;
            attrs = null;
        }
        attrs = attrs ? ' ' + html_1.attrsToStr(attrs) : ''; // will have a leading space
        innerHtml = innerHtml || '';
        if (!forceOff && this.opt('navLinks')) {
            return '<a' + attrs +
                ' data-goto="' + html_1.htmlEscape(JSON.stringify(finalOptions)) + '">' +
                innerHtml +
                '</a>';
        }
        else {
            return '<span' + attrs + '>' +
                innerHtml +
                '</span>';
        }
    };
    DateComponent.prototype.getAllDayHtml = function () {
        return this.opt('allDayHtml') || html_1.htmlEscape(this.opt('allDayText'));
    };
    // Computes HTML classNames for a single-day element
    DateComponent.prototype.getDayClasses = function (date, noThemeHighlight) {
        var view = this._getView();
        var classes = [];
        var today;
        if (!this.dateProfile.activeUnzonedRange.containsDate(date)) {
            classes.push('fc-disabled-day'); // TODO: jQuery UI theme?
        }
        else {
            classes.push('fc-' + date_1.dayIDs[date.day()]);
            if (view.isDateInOtherMonth(date, this.dateProfile)) { // TODO: use DateComponent subclass somehow
                classes.push('fc-other-month');
            }
            today = view.calendar.getNow();
            if (date.isSame(today, 'day')) {
                classes.push('fc-today');
                if (noThemeHighlight !== true) {
                    classes.push(view.calendar.theme.getClass('today'));
                }
            }
            else if (date < today) {
                classes.push('fc-past');
            }
            else {
                classes.push('fc-future');
            }
        }
        return classes;
    };
    // Utility for formatting a range. Accepts a range object, formatting string, and optional separator.
    // Displays all-day ranges naturally, with an inclusive end. Takes the current isRTL into account.
    // The timezones of the dates within `range` will be respected.
    DateComponent.prototype.formatRange = function (range, isAllDay, formatStr, separator) {
        var end = range.end;
        if (isAllDay) {
            end = end.clone().subtract(1); // convert to inclusive. last ms of previous day
        }
        return date_formatting_1.formatRange(range.start, end, formatStr, separator, this.isRTL);
    };
    // Compute the number of the give units in the "current" range.
    // Will return a floating-point number. Won't round.
    DateComponent.prototype.currentRangeAs = function (unit) {
        return this._getDateProfile().currentUnzonedRange.as(unit);
    };
    // Returns the date range of the full days the given range visually appears to occupy.
    // Returns a plain object with start/end, NOT an UnzonedRange!
    DateComponent.prototype.computeDayRange = function (unzonedRange) {
        var calendar = this._getCalendar();
        var startDay = calendar.msToUtcMoment(unzonedRange.startMs, true); // the beginning of the day the range starts
        var end = calendar.msToUtcMoment(unzonedRange.endMs);
        var endTimeMS = +end.time(); // # of milliseconds into `endDay`
        var endDay = end.clone().stripTime(); // the beginning of the day the range exclusively ends
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= this.nextDayThreshold) {
            endDay.add(1, 'days');
        }
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay <= startDay) {
            endDay = startDay.clone().add(1, 'days');
        }
        return { start: startDay, end: endDay };
    };
    // Does the given range visually appear to occupy more than one day?
    DateComponent.prototype.isMultiDayRange = function (unzonedRange) {
        var dayRange = this.computeDayRange(unzonedRange);
        return dayRange.end.diff(dayRange.start, 'days') > 1;
    };
    DateComponent.guid = 0; // TODO: better system for this?
    return DateComponent;
}(Component_1.default));
exports.default = DateComponent;
// legacy
function convertEventsPayloadToLegacyArray(eventsPayload) {
    var eventDefId;
    var eventInstances;
    var legacyEvents = [];
    var i;
    for (eventDefId in eventsPayload) {
        eventInstances = eventsPayload[eventDefId].eventInstances;
        for (i = 0; i < eventInstances.length; i++) {
            legacyEvents.push(eventInstances[i].toLegacy());
        }
    }
    return legacyEvents;
}


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var date_1 = __webpack_require__(8);
var UnzonedRange_1 = __webpack_require__(7);
var DateProfileGenerator = /** @class */ (function () {
    function DateProfileGenerator(_view) {
        this._view = _view;
    }
    DateProfileGenerator.prototype.opt = function (name) {
        return this._view.opt(name);
    };
    DateProfileGenerator.prototype.trimHiddenDays = function (unzonedRange) {
        return this._view.trimHiddenDays(unzonedRange);
    };
    DateProfileGenerator.prototype.msToUtcMoment = function (ms, forceAllDay) {
        return this._view.calendar.msToUtcMoment(ms, forceAllDay);
    };
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/
    // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    DateProfileGenerator.prototype.buildPrev = function (currentDateProfile) {
        var prevDate = currentDateProfile.date.clone()
            .startOf(currentDateProfile.currentRangeUnit)
            .subtract(currentDateProfile.dateIncrement);
        return this.build(prevDate, -1);
    };
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    DateProfileGenerator.prototype.buildNext = function (currentDateProfile) {
        var nextDate = currentDateProfile.date.clone()
            .startOf(currentDateProfile.currentRangeUnit)
            .add(currentDateProfile.dateIncrement);
        return this.build(nextDate, 1);
    };
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    DateProfileGenerator.prototype.build = function (date, direction, forceToValid) {
        if (forceToValid === void 0) { forceToValid = false; }
        var isDateAllDay = !date.hasTime();
        var validUnzonedRange;
        var minTime = null;
        var maxTime = null;
        var currentInfo;
        var isRangeAllDay;
        var renderUnzonedRange;
        var activeUnzonedRange;
        var isValid;
        validUnzonedRange = this.buildValidRange();
        validUnzonedRange = this.trimHiddenDays(validUnzonedRange);
        if (forceToValid) {
            date = this.msToUtcMoment(validUnzonedRange.constrainDate(date), // returns MS
            isDateAllDay);
        }
        currentInfo = this.buildCurrentRangeInfo(date, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderUnzonedRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.unzonedRange), currentInfo.unit, isRangeAllDay);
        renderUnzonedRange = this.trimHiddenDays(renderUnzonedRange);
        activeUnzonedRange = renderUnzonedRange.clone();
        if (!this.opt('showNonCurrentDates')) {
            activeUnzonedRange = activeUnzonedRange.intersect(currentInfo.unzonedRange);
        }
        minTime = moment.duration(this.opt('minTime'));
        maxTime = moment.duration(this.opt('maxTime'));
        activeUnzonedRange = this.adjustActiveRange(activeUnzonedRange, minTime, maxTime);
        activeUnzonedRange = activeUnzonedRange.intersect(validUnzonedRange); // might return null
        if (activeUnzonedRange) {
            date = this.msToUtcMoment(activeUnzonedRange.constrainDate(date), // returns MS
            isDateAllDay);
        }
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = currentInfo.unzonedRange.intersectsWith(validUnzonedRange);
        return {
            // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validUnzonedRange: validUnzonedRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentUnzonedRange: currentInfo.unzonedRange,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeUnzonedRange: activeUnzonedRange,
            // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderUnzonedRange: renderUnzonedRange,
            // Duration object that denotes the first visible time of any given day
            minTime: minTime,
            // Duration object that denotes the exclusive visible end time of any given day
            maxTime: maxTime,
            isValid: isValid,
            date: date,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration)
            // pass a fallback (might be null) ^
        };
    };
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildValidRange = function () {
        return this._view.getUnzonedRangeOption('validRange', this._view.calendar.getNow()) ||
            new UnzonedRange_1.default(); // completely open-ended
    };
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildCurrentRangeInfo = function (date, direction) {
        var viewSpec = this._view.viewSpec;
        var duration = null;
        var unit = null;
        var unzonedRange = null;
        var dayCount;
        if (viewSpec.duration) {
            duration = viewSpec.duration;
            unit = viewSpec.durationUnit;
            unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        else if ((dayCount = this.opt('dayCount'))) {
            unit = 'day';
            unzonedRange = this.buildRangeFromDayCount(date, direction, dayCount);
        }
        else if ((unzonedRange = this.buildCustomVisibleRange(date))) {
            unit = date_1.computeGreatestUnit(unzonedRange.getStart(), unzonedRange.getEnd());
        }
        else {
            duration = this.getFallbackDuration();
            unit = date_1.computeGreatestUnit(duration);
            unzonedRange = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return { duration: duration, unit: unit, unzonedRange: unzonedRange };
    };
    DateProfileGenerator.prototype.getFallbackDuration = function () {
        return moment.duration({ days: 1 });
    };
    // Returns a new activeUnzonedRange to have time values (un-ambiguate)
    // minTime or maxTime causes the range to expand.
    DateProfileGenerator.prototype.adjustActiveRange = function (unzonedRange, minTime, maxTime) {
        var start = unzonedRange.getStart();
        var end = unzonedRange.getEnd();
        if (this._view.usesMinMaxTime) {
            if (minTime < 0) {
                start.time(0).add(minTime);
            }
            if (maxTime > 24 * 60 * 60 * 1000) { // beyond 24 hours?
                end.time(maxTime - (24 * 60 * 60 * 1000));
            }
        }
        return new UnzonedRange_1.default(start, end);
    };
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed computeGreatestUnit value of duration.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildRangeFromDuration = function (date, direction, duration, unit) {
        var alignment = this.opt('dateAlignment');
        var dateIncrementInput;
        var dateIncrementDuration;
        var start;
        var end;
        var res;
        // compute what the alignment should be
        if (!alignment) {
            dateIncrementInput = this.opt('dateIncrement');
            if (dateIncrementInput) {
                dateIncrementDuration = moment.duration(dateIncrementInput);
                // use the smaller of the two units
                if (dateIncrementDuration < duration) {
                    alignment = date_1.computeDurationGreatestUnit(dateIncrementDuration, dateIncrementInput);
                }
                else {
                    alignment = unit;
                }
            }
            else {
                alignment = unit;
            }
        }
        // if the view displays a single day or smaller
        if (duration.as('days') <= 1) {
            if (this._view.isHiddenDay(start)) {
                start = this._view.skipHiddenDays(start, direction);
                start.startOf('day');
            }
        }
        function computeRes() {
            start = date.clone().startOf(alignment);
            end = start.clone().add(duration);
            res = new UnzonedRange_1.default(start, end);
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this._view.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    };
    // Builds the "current" range when a dayCount is specified.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildRangeFromDayCount = function (date, direction, dayCount) {
        var customAlignment = this.opt('dateAlignment');
        var runningCount = 0;
        var start = date.clone();
        var end;
        if (customAlignment) {
            start.startOf(customAlignment);
        }
        start.startOf('day');
        start = this._view.skipHiddenDays(start, direction);
        end = start.clone();
        do {
            end.add(1, 'day');
            if (!this._view.isHiddenDay(end)) {
                runningCount++;
            }
        } while (runningCount < dayCount);
        return new UnzonedRange_1.default(start, end);
    };
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentUnzonedRange and activeUnzonedRange at the same time.
    // TODO: accept a MS-time instead of a moment `date`?
    DateProfileGenerator.prototype.buildCustomVisibleRange = function (date) {
        var visibleUnzonedRange = this._view.getUnzonedRangeOption('visibleRange', this._view.calendar.applyTimezone(date) // correct zone. also generates new obj that avoids mutations
        );
        if (visibleUnzonedRange && (visibleUnzonedRange.startMs == null || visibleUnzonedRange.endMs == null)) {
            return null;
        }
        return visibleUnzonedRange;
    };
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    DateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
        return currentUnzonedRange.clone();
    };
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    DateProfileGenerator.prototype.buildDateIncrement = function (fallback) {
        var dateIncrementInput = this.opt('dateIncrement');
        var customAlignment;
        if (dateIncrementInput) {
            return moment.duration(dateIncrementInput);
        }
        else if ((customAlignment = this.opt('dateAlignment'))) {
            return moment.duration(1, customAlignment);
        }
        else if (fallback) {
            return fallback;
        }
        else {
            return moment.duration({ days: 1 });
        }
    };
    return DateProfileGenerator;
}());
exports.default = DateProfileGenerator;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var moment = __webpack_require__(0);
var object_1 = __webpack_require__(5);
var dom_manip_1 = __webpack_require__(3);
var misc_1 = __webpack_require__(4);
var moment_ext_1 = __webpack_require__(14);
var HitDragListener_1 = __webpack_require__(27);
var SingleEventDef_1 = __webpack_require__(17);
var EventInstanceGroup_1 = __webpack_require__(23);
var EventSource_1 = __webpack_require__(9);
var Interaction_1 = __webpack_require__(19);
var ExternalDropping = /** @class */ (function (_super) {
    tslib_1.__extends(ExternalDropping, _super);
    function ExternalDropping() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDragging = false; // jqui-dragging an external element? boolean
        return _this;
    }
    // Given a jQuery element that might represent a dragged FullCalendar event, returns an intermediate data structure
    // to be used for Event Object creation.
    // A defined `.eventProps`, even when empty, indicates that an event should be created.
    ExternalDropping.getDraggedElMeta = function (el) {
        var eventProps; // properties for creating the event, not related to date/time
        var startTime; // a Duration
        var duration;
        var stick;
        eventProps = ExternalDropping.getEmbeddedElData(el, 'event', true);
        if (eventProps) {
            // something like 1 or true. still signal event creation
            if (typeof eventProps !== 'object') {
                eventProps = {};
            }
            // pluck special-cased date/time properties
            startTime = eventProps.start;
            if (startTime == null) {
                startTime = eventProps.time;
            } // accept 'time' as well
            duration = eventProps.duration;
            stick = eventProps.stick;
            delete eventProps.start;
            delete eventProps.time;
            delete eventProps.duration;
            delete eventProps.stick;
        }
        // fallback to standalone attribute values for each of the date/time properties
        if (startTime == null) {
            startTime = ExternalDropping.getEmbeddedElData(el, 'start');
        }
        if (startTime == null) {
            startTime = ExternalDropping.getEmbeddedElData(el, 'time');
        } // accept 'time' as well
        if (duration == null) {
            duration = ExternalDropping.getEmbeddedElData(el, 'duration');
        }
        if (stick == null) {
            stick = ExternalDropping.getEmbeddedElData(el, 'stick', true);
        }
        // massage into correct data types
        startTime = startTime != null ? moment.duration(startTime) : null;
        duration = duration != null ? moment.duration(duration) : null;
        stick = Boolean(stick);
        return { eventProps: eventProps, startTime: startTime, duration: duration, stick: stick };
    };
    ExternalDropping.getEmbeddedElData = function (el, name, shouldParseJson) {
        if (shouldParseJson === void 0) { shouldParseJson = false; }
        var prefix = ExternalDropping.dataAttrPrefix;
        var prefixedName = (prefix ? prefix + '-' : '') + name;
        var data = el.getAttribute('data-' + prefixedName) || null;
        if (data && shouldParseJson) {
            data = JSON.parse(data);
        }
        return data;
    };
    /*
    component impements:
      - eventRangesToEventFootprints
      - isEventInstanceGroupAllowed
      - isExternalInstanceGroupAllowed
      - renderDrag
      - unrenderDrag
    */
    ExternalDropping.prototype.end = function () {
        if (this.dragListener) {
            this.dragListener.endInteraction();
        }
    };
    // Called when a jQuery UI drag is initiated anywhere in the DOM
    ExternalDropping.prototype.handleDragStart = function (ev, el, skipBinding) {
        var accept;
        if (this.opt('droppable')) { // only listen if this setting is on
            // Test that the dragged element passes the dropAccept selector or filter function.
            // FYI, the default is "*" (matches all)
            accept = this.opt('dropAccept');
            if (typeof accept === 'function' ? accept.call(el, el) : dom_manip_1.elementMatches(el, accept)) {
                if (!this.isDragging) { // prevent double-listening if fired twice
                    this.listenToExternalDrag(ev, el, skipBinding);
                }
            }
        }
    };
    ExternalDropping.prototype.handleDragMove = function (ev) {
        if (this.dragListener) {
            this.dragListener.handleMove(ev);
        }
    };
    ExternalDropping.prototype.handleDragStop = function (ev) {
        if (this.dragListener) {
            this.dragListener.endInteraction(ev);
        }
    };
    // Called when a 3rd-party draggable starts and it needs to be monitored for dropping
    ExternalDropping.prototype.listenToExternalDrag = function (ev, el, skipBinding) {
        var _this = this;
        var component = this.component;
        var view = this.view;
        var meta = ExternalDropping.getDraggedElMeta(el); // extra data about event drop, including possible event to create
        var singleEventDef; // a null value signals an unsuccessful drag
        // listener that tracks mouse movement over date-associated pixel regions
        var dragListener = this.dragListener = new HitDragListener_1.default(component, {
            interactionStart: function () {
                _this.isDragging = true;
            },
            hitOver: function (hit) {
                var isAllowed = true;
                var hitFootprint = hit.component.getSafeHitFootprint(hit); // hit might not belong to this grid
                var mutatedEventInstanceGroup;
                if (hitFootprint) {
                    singleEventDef = _this.computeExternalDrop(hitFootprint, meta);
                    if (singleEventDef) {
                        mutatedEventInstanceGroup = new EventInstanceGroup_1.default(singleEventDef.buildInstances());
                        isAllowed = meta.eventProps ? // isEvent?
                            component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup) :
                            component.isExternalInstanceGroupAllowed(mutatedEventInstanceGroup);
                    }
                    else {
                        isAllowed = false;
                    }
                }
                else {
                    isAllowed = false;
                }
                if (!isAllowed) {
                    singleEventDef = null;
                    misc_1.disableCursor();
                }
                if (singleEventDef) {
                    component.renderDrag(// called without a seg parameter
                    component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, view.calendar)));
                }
            },
            hitOut: function () {
                singleEventDef = null; // signal unsuccessful
            },
            hitDone: function () {
                misc_1.enableCursor();
                component.unrenderDrag();
            },
            interactionEnd: function (ev) {
                if (singleEventDef) { // element was dropped on a valid hit
                    view.reportExternalDrop(singleEventDef, Boolean(meta.eventProps), // isEvent
                    Boolean(meta.stick), // isSticky
                    el, ev);
                }
                _this.isDragging = false;
                _this.dragListener = null;
            }
        });
        dragListener.skipBinding = skipBinding;
        dragListener.startDrag(ev); // start listening immediately
    };
    // Given a hit to be dropped upon, and misc data associated with the jqui drag (guaranteed to be a plain object),
    // returns the zoned start/end dates for the event that would result from the hypothetical drop. end might be null.
    // Returning a null value signals an invalid drop hit.
    // DOES NOT consider overlap/constraint.
    // Assumes both footprints are non-open-ended.
    ExternalDropping.prototype.computeExternalDrop = function (componentFootprint, meta) {
        var calendar = this.view.calendar;
        var start = moment_ext_1.default.utc(componentFootprint.unzonedRange.startMs).stripZone();
        var end;
        var eventDef;
        if (componentFootprint.isAllDay) {
            // if dropped on an all-day span, and element's metadata specified a time, set it
            if (meta.startTime) {
                start.time(meta.startTime);
            }
            else {
                start.stripTime();
            }
        }
        if (meta.duration) {
            end = start.clone().add(meta.duration);
        }
        start = calendar.applyTimezone(start);
        if (end) {
            end = calendar.applyTimezone(end);
        }
        eventDef = SingleEventDef_1.default.parse(object_1.assignTo({}, meta.eventProps, {
            start: start,
            end: end
        }), new EventSource_1.default(calendar));
        return eventDef;
    };
    ExternalDropping.dataAttrPrefix = '';
    return ExternalDropping;
}(Interaction_1.default));
exports.default = ExternalDropping;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var misc_1 = __webpack_require__(4);
var EventDefMutation_1 = __webpack_require__(42);
var EventDefDateMutation_1 = __webpack_require__(55);
var HitDragListener_1 = __webpack_require__(27);
var Interaction_1 = __webpack_require__(19);
var EventResizing = /** @class */ (function (_super) {
    tslib_1.__extends(EventResizing, _super);
    /*
    component impements:
      - bindSegHandlerToEl
      - publiclyTrigger
      - diffDates
      - eventRangesToEventFootprints
      - isEventInstanceGroupAllowed
      - getSafeHitFootprint
    */
    function EventResizing(component, eventPointing) {
        var _this = _super.call(this, component) || this;
        _this.isResizing = false;
        _this.eventPointing = eventPointing;
        return _this;
    }
    EventResizing.prototype.end = function () {
        if (this.dragListener) {
            this.dragListener.endInteraction();
        }
    };
    EventResizing.prototype.bindToEl = function (el) {
        var component = this.component;
        component.bindSegHandlerToEl(el, 'mousedown', this.handleMouseDown.bind(this));
        component.bindSegHandlerToEl(el, 'touchstart', this.handleTouchStart.bind(this));
    };
    EventResizing.prototype.handleMouseDown = function (seg, ev) {
        if (this.component.canStartResize(seg, ev)) {
            this.buildDragListener(seg, ev.target.classList.contains('fc-start-resizer'))
                .startInteraction(ev, { distance: 5 });
        }
    };
    EventResizing.prototype.handleTouchStart = function (seg, ev) {
        if (this.component.canStartResize(seg, ev)) {
            this.buildDragListener(seg, ev.target.classList.contains('fc-start-resizer'))
                .startInteraction(ev);
        }
    };
    // Creates a listener that tracks the user as they resize an event segment.
    // Generic enough to work with any type of Grid.
    EventResizing.prototype.buildDragListener = function (seg, isStart) {
        var _this = this;
        var component = this.component;
        var view = this.view;
        var calendar = view.calendar;
        var eventManager = calendar.eventManager;
        var el = seg.el;
        var eventDef = seg.footprint.eventDef;
        var eventInstance = seg.footprint.eventInstance;
        var isDragging;
        var resizeMutation; // zoned event date properties. falsy if invalid resize
        // Tracks mouse movement over the *grid's* coordinate map
        var dragListener = this.dragListener = new HitDragListener_1.default(component, {
            scroll: this.opt('dragScroll'),
            subjectEl: el,
            interactionStart: function () {
                isDragging = false;
            },
            dragStart: function (ev) {
                isDragging = true;
                // ensure a mouseout on the manipulated event has been reported
                _this.eventPointing.handleMouseout(seg, ev);
                _this.segResizeStart(seg, ev);
            },
            hitOver: function (hit, isOrig, origHit) {
                var isAllowed = true;
                var origHitFootprint = component.getSafeHitFootprint(origHit);
                var hitFootprint = component.getSafeHitFootprint(hit);
                var mutatedEventInstanceGroup;
                if (origHitFootprint && hitFootprint) {
                    resizeMutation = isStart ?
                        _this.computeEventStartResizeMutation(origHitFootprint, hitFootprint, seg.footprint) :
                        _this.computeEventEndResizeMutation(origHitFootprint, hitFootprint, seg.footprint);
                    if (resizeMutation) {
                        mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, resizeMutation);
                        isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
                    }
                    else {
                        isAllowed = false;
                    }
                }
                else {
                    isAllowed = false;
                }
                if (!isAllowed) {
                    resizeMutation = null;
                    misc_1.disableCursor();
                }
                else if (resizeMutation.isEmpty()) {
                    // no change. (FYI, event dates might have zones)
                    resizeMutation = null;
                }
                if (resizeMutation) {
                    view.hideEventsWithId(seg.footprint.eventDef.id);
                    view.renderEventResize(component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg);
                }
            },
            hitOut: function () {
                resizeMutation = null;
            },
            hitDone: function () {
                view.unrenderEventResize(seg);
                view.showEventsWithId(seg.footprint.eventDef.id);
                misc_1.enableCursor();
            },
            interactionEnd: function (ev) {
                if (isDragging) {
                    _this.segResizeStop(seg, ev);
                }
                if (resizeMutation) { // valid date to resize to?
                    // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
                    view.reportEventResize(eventInstance, resizeMutation, el, ev);
                }
                _this.dragListener = null;
            }
        });
        return dragListener;
    };
    // Called before event segment resizing starts
    EventResizing.prototype.segResizeStart = function (seg, ev) {
        this.isResizing = true;
        this.component.publiclyTrigger('eventResizeStart', {
            context: seg.el,
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // Called after event segment resizing stops
    EventResizing.prototype.segResizeStop = function (seg, ev) {
        this.isResizing = false;
        this.component.publiclyTrigger('eventResizeStop', {
            context: seg.el,
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // Returns new date-information for an event segment being resized from its start
    EventResizing.prototype.computeEventStartResizeMutation = function (startFootprint, endFootprint, origEventFootprint) {
        var origRange = origEventFootprint.componentFootprint.unzonedRange;
        var startDelta = this.component.diffDates(endFootprint.unzonedRange.getStart(), startFootprint.unzonedRange.getStart());
        var dateMutation;
        var eventDefMutation;
        if (origRange.getStart().add(startDelta) < origRange.getEnd()) {
            dateMutation = new EventDefDateMutation_1.default();
            dateMutation.setStartDelta(startDelta);
            eventDefMutation = new EventDefMutation_1.default();
            eventDefMutation.setDateMutation(dateMutation);
            return eventDefMutation;
        }
        return false;
    };
    // Returns new date-information for an event segment being resized from its end
    EventResizing.prototype.computeEventEndResizeMutation = function (startFootprint, endFootprint, origEventFootprint) {
        var origRange = origEventFootprint.componentFootprint.unzonedRange;
        var endDelta = this.component.diffDates(endFootprint.unzonedRange.getEnd(), startFootprint.unzonedRange.getEnd());
        var dateMutation;
        var eventDefMutation;
        if (origRange.getEnd().add(endDelta) > origRange.getStart()) {
            dateMutation = new EventDefDateMutation_1.default();
            dateMutation.setEndDelta(endDelta);
            eventDefMutation = new EventDefMutation_1.default();
            eventDefMutation.setDateMutation(dateMutation);
            return eventDefMutation;
        }
        return false;
    };
    return EventResizing;
}(Interaction_1.default));
exports.default = EventResizing;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var misc_1 = __webpack_require__(4);
var EventDefMutation_1 = __webpack_require__(42);
var EventDefDateMutation_1 = __webpack_require__(55);
var DragListener_1 = __webpack_require__(60);
var HitDragListener_1 = __webpack_require__(27);
var MouseFollower_1 = __webpack_require__(253);
var Interaction_1 = __webpack_require__(19);
var EventDragging = /** @class */ (function (_super) {
    tslib_1.__extends(EventDragging, _super);
    /*
    component implements:
      - bindSegHandlerToEl
      - publiclyTrigger
      - diffDates
      - eventRangesToEventFootprints
      - isEventInstanceGroupAllowed
    */
    function EventDragging(component, eventPointing) {
        var _this = _super.call(this, component) || this;
        _this.isDragging = false;
        _this.eventPointing = eventPointing;
        return _this;
    }
    EventDragging.prototype.end = function () {
        if (this.dragListener) {
            this.dragListener.endInteraction();
        }
    };
    EventDragging.prototype.getSelectionDelay = function () {
        var delay = this.opt('eventLongPressDelay');
        if (delay == null) {
            delay = this.opt('longPressDelay'); // fallback
        }
        return delay;
    };
    EventDragging.prototype.bindToEl = function (el) {
        var component = this.component;
        component.bindSegHandlerToEl(el, 'mousedown', this.handleMousedown.bind(this));
        component.bindSegHandlerToEl(el, 'touchstart', this.handleTouchStart.bind(this));
    };
    EventDragging.prototype.handleMousedown = function (seg, ev) {
        if (!this.component.shouldIgnoreMouse() &&
            this.component.canStartDrag(seg, ev)) {
            this.buildDragListener(seg).startInteraction(ev, { distance: 5 });
        }
    };
    EventDragging.prototype.handleTouchStart = function (seg, ev) {
        var component = this.component;
        var settings = {
            delay: this.view.isEventDefSelected(seg.footprint.eventDef) ? // already selected?
                0 : this.getSelectionDelay()
        };
        if (component.canStartDrag(seg, ev)) {
            this.buildDragListener(seg).startInteraction(ev, settings);
        }
        else if (component.canStartSelection(seg, ev)) {
            this.buildSelectListener(seg).startInteraction(ev, settings);
        }
    };
    // seg isn't draggable, but let's use a generic DragListener
    // simply for the delay, so it can be selected.
    // Has side effect of setting/unsetting `dragListener`
    EventDragging.prototype.buildSelectListener = function (seg) {
        var _this = this;
        var view = this.view;
        var eventDef = seg.footprint.eventDef;
        var eventInstance = seg.footprint.eventInstance; // null for inverse-background events
        if (this.dragListener) {
            return this.dragListener;
        }
        var dragListener = this.dragListener = new DragListener_1.default({
            dragStart: function (ev) {
                if (dragListener.isTouch &&
                    !view.isEventDefSelected(eventDef) &&
                    eventInstance) {
                    // if not previously selected, will fire after a delay. then, select the event
                    view.selectEventInstance(eventInstance);
                }
            },
            interactionEnd: function (ev) {
                _this.dragListener = null;
            }
        });
        return dragListener;
    };
    // Builds a listener that will track user-dragging on an event segment.
    // Generic enough to work with any type of Grid.
    // Has side effect of setting/unsetting `dragListener`
    EventDragging.prototype.buildDragListener = function (seg) {
        var _this = this;
        var component = this.component;
        var view = this.view;
        var calendar = view.calendar;
        var eventManager = calendar.eventManager;
        var el = seg.el;
        var eventDef = seg.footprint.eventDef;
        var eventInstance = seg.footprint.eventInstance; // null for inverse-background events
        var isDragging;
        var mouseFollower; // A clone of the original element that will move with the mouse
        var eventDefMutation;
        if (this.dragListener) {
            return this.dragListener;
        }
        // Tracks mouse movement over the *view's* coordinate map. Allows dragging and dropping between subcomponents
        // of the view.
        var dragListener = this.dragListener = new HitDragListener_1.default(view, {
            scroll: this.opt('dragScroll'),
            subjectEl: el,
            subjectCenter: true,
            interactionStart: function (ev) {
                seg.component = component; // for renderDrag
                isDragging = false;
                mouseFollower = new MouseFollower_1.default(seg.el, {
                    additionalClass: 'fc-dragging',
                    parentEl: view.el,
                    opacity: dragListener.isTouch ? null : _this.opt('dragOpacity'),
                    revertDuration: _this.opt('dragRevertDuration'),
                    zIndex: 2 // one above the .fc-view
                });
                mouseFollower.hide(); // don't show until we know this is a real drag
                mouseFollower.start(ev);
            },
            dragStart: function (ev) {
                if (dragListener.isTouch &&
                    !view.isEventDefSelected(eventDef) &&
                    eventInstance) {
                    // if not previously selected, will fire after a delay. then, select the event
                    view.selectEventInstance(eventInstance);
                }
                isDragging = true;
                // ensure a mouseout on the manipulated event has been reported
                _this.eventPointing.handleMouseout(seg, ev);
                _this.segDragStart(seg, ev);
                view.hideEventsWithId(seg.footprint.eventDef.id);
            },
            hitOver: function (hit, isOrig, origHit) {
                var isAllowed = true;
                var origFootprint;
                var footprint;
                var mutatedEventInstanceGroup;
                // starting hit could be forced (DayGrid.limit)
                if (seg.hit) {
                    origHit = seg.hit;
                }
                // hit might not belong to this grid, so query origin grid
                origFootprint = origHit.component.getSafeHitFootprint(origHit);
                footprint = hit.component.getSafeHitFootprint(hit);
                if (origFootprint && footprint) {
                    eventDefMutation = _this.computeEventDropMutation(origFootprint, footprint, eventDef);
                    if (eventDefMutation) {
                        mutatedEventInstanceGroup = eventManager.buildMutatedEventInstanceGroup(eventDef.id, eventDefMutation);
                        isAllowed = component.isEventInstanceGroupAllowed(mutatedEventInstanceGroup);
                    }
                    else {
                        isAllowed = false;
                    }
                }
                else {
                    isAllowed = false;
                }
                if (!isAllowed) {
                    eventDefMutation = null;
                    misc_1.disableCursor();
                }
                // if a valid drop location, have the subclass render a visual indication
                if (eventDefMutation &&
                    view.renderDrag(// truthy if rendered something
                    component.eventRangesToEventFootprints(mutatedEventInstanceGroup.sliceRenderRanges(component.dateProfile.renderUnzonedRange, calendar)), seg, dragListener.isTouch)) {
                    mouseFollower.hide(); // if the subclass is already using a mock event "helper", hide our own
                }
                else {
                    mouseFollower.show(); // otherwise, have the helper follow the mouse (no snapping)
                }
                if (isOrig) {
                    // needs to have moved hits to be a valid drop
                    eventDefMutation = null;
                }
            },
            hitOut: function () {
                view.unrenderDrag(seg); // unrender whatever was done in renderDrag
                mouseFollower.show(); // show in case we are moving out of all hits
                eventDefMutation = null;
            },
            hitDone: function () {
                misc_1.enableCursor();
            },
            interactionEnd: function (ev) {
                delete seg.component; // prevent side effects
                // do revert animation if hasn't changed. calls a callback when finished (whether animation or not)
                mouseFollower.stop(!eventDefMutation, function () {
                    if (isDragging) {
                        view.unrenderDrag(seg);
                        _this.segDragStop(seg, ev);
                    }
                    view.showEventsWithId(seg.footprint.eventDef.id);
                    if (eventDefMutation) {
                        // no need to re-show original, will rerender all anyways. esp important if eventRenderWait
                        view.reportEventDrop(eventInstance, eventDefMutation, el, ev);
                    }
                });
                _this.dragListener = null;
            }
        });
        return dragListener;
    };
    // Called before event segment dragging starts
    EventDragging.prototype.segDragStart = function (seg, ev) {
        this.isDragging = true;
        this.component.publiclyTrigger('eventDragStart', {
            context: seg.el,
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // Called after event segment dragging stops
    EventDragging.prototype.segDragStop = function (seg, ev) {
        this.isDragging = false;
        this.component.publiclyTrigger('eventDragStop', {
            context: seg.el,
            args: [
                seg.footprint.getEventLegacy(),
                ev,
                {},
                this.view
            ]
        });
    };
    // DOES NOT consider overlap/constraint
    EventDragging.prototype.computeEventDropMutation = function (startFootprint, endFootprint, eventDef) {
        var eventDefMutation = new EventDefMutation_1.default();
        eventDefMutation.setDateMutation(this.computeEventDateMutation(startFootprint, endFootprint));
        return eventDefMutation;
    };
    EventDragging.prototype.computeEventDateMutation = function (startFootprint, endFootprint) {
        var date0 = startFootprint.unzonedRange.getStart();
        var date1 = endFootprint.unzonedRange.getStart();
        var clearEnd = false;
        var forceTimed = false;
        var forceAllDay = false;
        var dateDelta;
        var dateMutation;
        if (startFootprint.isAllDay !== endFootprint.isAllDay) {
            clearEnd = true;
            if (endFootprint.isAllDay) {
                forceAllDay = true;
                date0.stripTime();
            }
            else {
                forceTimed = true;
            }
        }
        dateDelta = this.component.diffDates(date1, date0);
        dateMutation = new EventDefDateMutation_1.default();
        dateMutation.clearEnd = clearEnd;
        dateMutation.forceTimed = forceTimed;
        dateMutation.forceAllDay = forceAllDay;
        dateMutation.setDateDelta(dateDelta);
        return dateMutation;
    };
    return EventDragging;
}(Interaction_1.default));
exports.default = EventDragging;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var misc_1 = __webpack_require__(4);
var HitDragListener_1 = __webpack_require__(27);
var ComponentFootprint_1 = __webpack_require__(16);
var UnzonedRange_1 = __webpack_require__(7);
var Interaction_1 = __webpack_require__(19);
var DateSelecting = /** @class */ (function (_super) {
    tslib_1.__extends(DateSelecting, _super);
    /*
    component must implement:
      - bindDateHandlerToEl
      - getSafeHitFootprint
      - renderHighlight
      - unrenderHighlight
    */
    function DateSelecting(component) {
        var _this = _super.call(this, component) || this;
        _this.dragListener = _this.buildDragListener();
        return _this;
    }
    DateSelecting.prototype.end = function () {
        this.dragListener.endInteraction();
    };
    DateSelecting.prototype.getDelay = function () {
        var delay = this.opt('selectLongPressDelay');
        if (delay == null) {
            delay = this.opt('longPressDelay'); // fallback
        }
        return delay;
    };
    DateSelecting.prototype.bindToEl = function (el) {
        var _this = this;
        var component = this.component;
        var dragListener = this.dragListener;
        component.bindDateHandlerToEl(el, 'mousedown', function (ev) {
            if (_this.opt('selectable') && !component.shouldIgnoreMouse()) {
                dragListener.startInteraction(ev, {
                    distance: _this.opt('selectMinDistance')
                });
            }
        });
        component.bindDateHandlerToEl(el, 'touchstart', function (ev) {
            if (_this.opt('selectable') && !component.shouldIgnoreTouch()) {
                dragListener.startInteraction(ev, {
                    delay: _this.getDelay()
                });
            }
        });
        misc_1.preventSelection(el);
    };
    // Creates a listener that tracks the user's drag across day elements, for day selecting.
    DateSelecting.prototype.buildDragListener = function () {
        var _this = this;
        var component = this.component;
        var selectionFootprint; // null if invalid selection
        var dragListener = new HitDragListener_1.default(component, {
            scroll: this.opt('dragScroll'),
            interactionStart: function () {
                selectionFootprint = null;
            },
            dragStart: function (ev) {
                _this.view.unselect(ev); // since we could be rendering a new selection, we want to clear any old one
            },
            hitOver: function (hit, isOrig, origHit) {
                var origHitFootprint;
                var hitFootprint;
                if (origHit) { // click needs to have started on a hit
                    origHitFootprint = component.getSafeHitFootprint(origHit);
                    hitFootprint = component.getSafeHitFootprint(hit);
                    if (origHitFootprint && hitFootprint) {
                        selectionFootprint = _this.computeSelection(origHitFootprint, hitFootprint);
                    }
                    else {
                        selectionFootprint = null;
                    }
                    if (selectionFootprint) {
                        component.renderSelectionFootprint(selectionFootprint);
                    }
                    else if (selectionFootprint === false) {
                        misc_1.disableCursor();
                    }
                }
            },
            hitOut: function () {
                selectionFootprint = null;
                component.unrenderSelection();
            },
            hitDone: function () {
                misc_1.enableCursor();
            },
            interactionEnd: function (ev, isCancelled) {
                if (!isCancelled && selectionFootprint) {
                    // the selection will already have been rendered. just report it
                    _this.view.reportSelection(selectionFootprint, ev);
                }
            }
        });
        return dragListener;
    };
    // Given the first and last date-spans of a selection, returns another date-span object.
    // Subclasses can override and provide additional data in the span object. Will be passed to renderSelectionFootprint().
    // Will return false if the selection is invalid and this should be indicated to the user.
    // Will return null/undefined if a selection invalid but no error should be reported.
    DateSelecting.prototype.computeSelection = function (footprint0, footprint1) {
        var wholeFootprint = this.computeSelectionFootprint(footprint0, footprint1);
        if (wholeFootprint && !this.isSelectionFootprintAllowed(wholeFootprint)) {
            return false;
        }
        return wholeFootprint;
    };
    // Given two spans, must return the combination of the two.
    // TODO: do this separation of concerns (combining VS validation) for event dnd/resize too.
    // Assumes both footprints are non-open-ended.
    DateSelecting.prototype.computeSelectionFootprint = function (footprint0, footprint1) {
        var ms = [
            footprint0.unzonedRange.startMs,
            footprint0.unzonedRange.endMs,
            footprint1.unzonedRange.startMs,
            footprint1.unzonedRange.endMs
        ];
        ms.sort(misc_1.compareNumbers);
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(ms[0], ms[3]), footprint0.isAllDay);
    };
    DateSelecting.prototype.isSelectionFootprintAllowed = function (componentFootprint) {
        return this.component.dateProfile.validUnzonedRange.containsRange(componentFootprint.unzonedRange) &&
            this.view.calendar.constraints.isSelectionFootprintAllowed(componentFootprint);
    };
    return DateSelecting;
}(Interaction_1.default));
exports.default = DateSelecting;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var moment = __webpack_require__(0);
var html_1 = __webpack_require__(6);
var object_1 = __webpack_require__(5);
var dom_manip_1 = __webpack_require__(3);
var misc_1 = __webpack_require__(4);
var Scroller_1 = __webpack_require__(44);
var View_1 = __webpack_require__(46);
var TimeGrid_1 = __webpack_require__(234);
var DayGrid_1 = __webpack_require__(67);
var AGENDA_ALL_DAY_EVENT_LIMIT = 5;
var agendaTimeGridMethods;
var agendaDayGridMethods;
/* An abstract class for all agenda-related views. Displays one more columns with time slots running vertically.
----------------------------------------------------------------------------------------------------------------------*/
// Is a manager for the TimeGrid subcomponent and possibly the DayGrid subcomponent (if allDaySlot is on).
// Responsible for managing width/height.
var AgendaView = /** @class */ (function (_super) {
    tslib_1.__extends(AgendaView, _super);
    function AgendaView(calendar, viewSpec) {
        var _this = _super.call(this, calendar, viewSpec) || this;
        _this.usesMinMaxTime = true; // indicates that minTime/maxTime affects rendering
        _this.timeGrid = _this.instantiateTimeGrid();
        _this.addChild(_this.timeGrid);
        if (_this.opt('allDaySlot')) { // should we display the "all-day" area?
            _this.dayGrid = _this.instantiateDayGrid(); // the all-day subcomponent of this view
            _this.addChild(_this.dayGrid);
        }
        _this.scroller = new Scroller_1.default({
            overflowX: 'hidden',
            overflowY: 'auto'
        });
        return _this;
    }
    // Instantiates the TimeGrid object this view needs. Draws from this.timeGridClass
    AgendaView.prototype.instantiateTimeGrid = function () {
        var timeGrid = new this.timeGridClass(this);
        object_1.copyOwnProps(agendaTimeGridMethods, timeGrid);
        return timeGrid;
    };
    // Instantiates the DayGrid object this view might need. Draws from this.dayGridClass
    AgendaView.prototype.instantiateDayGrid = function () {
        var dayGrid = new this.dayGridClass(this);
        object_1.copyOwnProps(agendaDayGridMethods, dayGrid);
        return dayGrid;
    };
    /* Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    AgendaView.prototype.renderSkeleton = function () {
        var timeGridWrapEl;
        var timeGridEl;
        this.el.classList.add('fc-agenda-view');
        this.el.innerHTML = this.renderSkeletonHtml();
        this.scroller.render();
        timeGridWrapEl = this.scroller.el;
        timeGridWrapEl.classList.add('fc-time-grid-container');
        timeGridEl = dom_manip_1.createElement('div', { className: 'fc-time-grid' });
        timeGridWrapEl.appendChild(timeGridEl);
        this.el.querySelector('.fc-body > tr > td').appendChild(timeGridWrapEl);
        this.timeGrid.headContainerEl = this.el.querySelector('.fc-head-container');
        this.timeGrid.setElement(timeGridEl);
        if (this.dayGrid) {
            this.dayGrid.setElement(this.el.querySelector('.fc-day-grid'));
            // have the day-grid extend it's coordinate area over the <hr> dividing the two grids
            this.dayGrid.bottomCoordPadding = this.el.querySelector('.fc-divider').offsetHeight;
        }
    };
    AgendaView.prototype.unrenderSkeleton = function () {
        this.timeGrid.removeElement();
        if (this.dayGrid) {
            this.dayGrid.removeElement();
        }
        this.scroller.destroy();
    };
    // Builds the HTML skeleton for the view.
    // The day-grid and time-grid components will render inside containers defined by this HTML.
    AgendaView.prototype.renderSkeletonHtml = function () {
        var theme = this.calendar.theme;
        return '' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            (this.opt('columnHeader') ?
                '<thead class="fc-head">' +
                    '<tr>' +
                    '<td class="fc-head-container ' + theme.getClass('widgetHeader') + '">&nbsp;</td>' +
                    '</tr>' +
                    '</thead>' :
                '') +
            '<tbody class="fc-body">' +
            '<tr>' +
            '<td class="' + theme.getClass('widgetContent') + '">' +
            (this.dayGrid ?
                '<div class="fc-day-grid"></div>' +
                    '<hr class="fc-divider ' + theme.getClass('widgetHeader') + '" />' :
                '') +
            '</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>';
    };
    // Generates an HTML attribute string for setting the width of the axis, if it is known
    AgendaView.prototype.axisStyleAttr = function () {
        if (this.axisWidth != null) {
            return 'style="width:' + this.axisWidth + 'px"';
        }
        return '';
    };
    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    AgendaView.prototype.getNowIndicatorUnit = function () {
        return this.timeGrid.getNowIndicatorUnit();
    };
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/
    // Adjusts the vertical dimensions of the view to the specified values
    AgendaView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        var _this = this;
        var eventLimit;
        var scrollerHeight;
        var scrollbarWidths;
        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        // make all axis cells line up, and record the width so newly created axis cells will have it
        this.axisWidth = misc_1.matchCellWidths(dom_manip_1.findElements(this.el, '.fc-axis'));
        // hack to give the view some height prior to timeGrid's columns being rendered
        // TODO: separate setting height from scroller VS timeGrid.
        if (!this.timeGrid.colEls) {
            if (!isAuto) {
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            return;
        }
        // set of fake row elements that must compensate when scroller has scrollbars
        var noScrollRowEls = dom_manip_1.findElements(this.el, '.fc-row').filter(function (node) {
            return !_this.scroller.el.contains(node);
        });
        // reset all dimensions back to the original state
        this.timeGrid.bottomRuleEl.style.display = 'none'; // will be shown later if this <hr> is necessary
        this.scroller.clear(); // sets height to 'auto' and clears overflow
        noScrollRowEls.forEach(misc_1.uncompensateScroll);
        // limit number of events in the all-day area
        if (this.dayGrid) {
            this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
            eventLimit = this.opt('eventLimit');
            if (eventLimit && typeof eventLimit !== 'number') {
                eventLimit = AGENDA_ALL_DAY_EVENT_LIMIT; // make sure "auto" goes to a real number
            }
            if (eventLimit) {
                this.dayGrid.limitRows(eventLimit);
            }
        }
        if (!isAuto) { // should we force dimensions of the scroll container?
            scrollerHeight = this.computeScrollerHeight(totalHeight);
            this.scroller.setHeight(scrollerHeight);
            scrollbarWidths = this.scroller.getScrollbarWidths();
            if (scrollbarWidths.left || scrollbarWidths.right) { // using scrollbars?
                // make the all-day and header rows lines up
                noScrollRowEls.forEach(function (rowEl) {
                    misc_1.compensateScroll(rowEl, scrollbarWidths);
                });
                // the scrollbar compensation might have changed text flow, which might affect height, so recalculate
                // and reapply the desired height to the scroller.
                scrollerHeight = this.computeScrollerHeight(totalHeight);
                this.scroller.setHeight(scrollerHeight);
            }
            // guarantees the same scrollbar widths
            this.scroller.lockOverflow(scrollbarWidths);
            // if there's any space below the slats, show the horizontal rule.
            // this won't cause any new overflow, because lockOverflow already called.
            if (this.timeGrid.getTotalSlatHeight() < scrollerHeight) {
                this.timeGrid.bottomRuleEl.style.display = '';
            }
        }
    };
    // given a desired total height of the view, returns what the height of the scroller should be
    AgendaView.prototype.computeScrollerHeight = function (totalHeight) {
        return totalHeight -
            misc_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    };
    /* Scroll
    ------------------------------------------------------------------------------------------------------------------*/
    // Computes the initial pre-configured scroll state prior to allowing the user to change it
    AgendaView.prototype.computeInitialDateScroll = function () {
        var scrollTime = moment.duration(this.opt('scrollTime'));
        var top = this.timeGrid.computeTimeTop(scrollTime);
        // zoom can give weird floating-point values. rather scroll a little bit further
        top = Math.ceil(top);
        if (top) {
            top++; // to overcome top border that slots beyond the first have. looks better
        }
        return { top: top };
    };
    AgendaView.prototype.queryDateScroll = function () {
        return { top: this.scroller.getScrollTop() };
    };
    AgendaView.prototype.applyDateScroll = function (scroll) {
        if (scroll.top !== undefined) {
            this.scroller.setScrollTop(scroll.top);
        }
    };
    /* Hit Areas
    ------------------------------------------------------------------------------------------------------------------*/
    // forward all hit-related method calls to the grids (dayGrid might not be defined)
    AgendaView.prototype.getHitFootprint = function (hit) {
        // TODO: hit.component is set as a hack to identify where the hit came from
        return hit.component.getHitFootprint(hit);
    };
    AgendaView.prototype.getHitEl = function (hit) {
        // TODO: hit.component is set as a hack to identify where the hit came from
        return hit.component.getHitEl(hit);
    };
    /* Event Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    AgendaView.prototype.executeEventRender = function (eventsPayload) {
        var dayEventsPayload = {};
        var timedEventsPayload = {};
        var id;
        var eventInstanceGroup;
        // separate the events into all-day and timed
        for (id in eventsPayload) {
            eventInstanceGroup = eventsPayload[id];
            if (eventInstanceGroup.getEventDef().isAllDay()) {
                dayEventsPayload[id] = eventInstanceGroup;
            }
            else {
                timedEventsPayload[id] = eventInstanceGroup;
            }
        }
        this.timeGrid.executeEventRender(timedEventsPayload);
        if (this.dayGrid) {
            this.dayGrid.executeEventRender(dayEventsPayload);
        }
    };
    /* Dragging/Resizing Routing
    ------------------------------------------------------------------------------------------------------------------*/
    // A returned value of `true` signals that a mock "helper" event has been rendered.
    AgendaView.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        var groups = groupEventFootprintsByAllDay(eventFootprints);
        var renderedHelper = false;
        renderedHelper = this.timeGrid.renderDrag(groups.timed, seg, isTouch);
        if (this.dayGrid) {
            renderedHelper = this.dayGrid.renderDrag(groups.allDay, seg, isTouch) || renderedHelper;
        }
        return renderedHelper;
    };
    AgendaView.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        var groups = groupEventFootprintsByAllDay(eventFootprints);
        this.timeGrid.renderEventResize(groups.timed, seg, isTouch);
        if (this.dayGrid) {
            this.dayGrid.renderEventResize(groups.allDay, seg, isTouch);
        }
    };
    /* Selection
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of a selection
    AgendaView.prototype.renderSelectionFootprint = function (componentFootprint) {
        if (!componentFootprint.isAllDay) {
            this.timeGrid.renderSelectionFootprint(componentFootprint);
        }
        else if (this.dayGrid) {
            this.dayGrid.renderSelectionFootprint(componentFootprint);
        }
    };
    return AgendaView;
}(View_1.default));
exports.default = AgendaView;
AgendaView.prototype.timeGridClass = TimeGrid_1.default;
AgendaView.prototype.dayGridClass = DayGrid_1.default;
// Will customize the rendering behavior of the AgendaView's timeGrid
agendaTimeGridMethods = {
    // Generates the HTML that will go before the day-of week header cells
    renderHeadIntroHtml: function () {
        var view = this.view;
        var calendar = view.calendar;
        var weekStart = calendar.msToUtcMoment(this.dateProfile.renderUnzonedRange.startMs, true);
        var weekText;
        if (this.opt('weekNumbers')) {
            weekText = weekStart.format(this.opt('smallWeekFormat'));
            return '' +
                '<th class="fc-axis fc-week-number ' + calendar.theme.getClass('widgetHeader') + '" ' + view.axisStyleAttr() + '>' +
                view.buildGotoAnchorHtml(// aside from link, important for matchCellWidths
                { date: weekStart, type: 'week', forceOff: this.colCnt > 1 }, html_1.htmlEscape(weekText) // inner HTML
                ) +
                '</th>';
        }
        else {
            return '<th class="fc-axis ' + calendar.theme.getClass('widgetHeader') + '" ' + view.axisStyleAttr() + '></th>';
        }
    },
    // Generates the HTML that goes before the bg of the TimeGrid slot area. Long vertical column.
    renderBgIntroHtml: function () {
        var view = this.view;
        return '<td class="fc-axis ' + view.calendar.theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '></td>';
    },
    // Generates the HTML that goes before all other types of cells.
    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
    renderIntroHtml: function () {
        var view = this.view;
        return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
    }
};
// Will customize the rendering behavior of the AgendaView's dayGrid
agendaDayGridMethods = {
    // Generates the HTML that goes before the all-day cells
    renderBgIntroHtml: function () {
        var view = this.view;
        return '' +
            '<td class="fc-axis ' + view.calendar.theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '>' +
            '<span>' + // needed for matchCellWidths
            view.getAllDayHtml() +
            '</span>' +
            '</td>';
    },
    // Generates the HTML that goes before all other types of cells.
    // Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
    renderIntroHtml: function () {
        var view = this.view;
        return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
    }
};
function groupEventFootprintsByAllDay(eventFootprints) {
    var allDay = [];
    var timed = [];
    var i;
    for (i = 0; i < eventFootprints.length; i++) {
        if (eventFootprints[i].componentFootprint.isAllDay) {
            allDay.push(eventFootprints[i]);
        }
        else {
            timed.push(eventFootprints[i]);
        }
    }
    return { allDay: allDay, timed: timed };
}


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var moment = __webpack_require__(0);
var html_1 = __webpack_require__(6);
var date_1 = __webpack_require__(8);
var dom_manip_1 = __webpack_require__(3);
var misc_1 = __webpack_require__(4);
var InteractiveDateComponent_1 = __webpack_require__(45);
var BusinessHourRenderer_1 = __webpack_require__(62);
var StandardInteractionsMixin_1 = __webpack_require__(66);
var DayTableMixin_1 = __webpack_require__(61);
var CoordCache_1 = __webpack_require__(59);
var UnzonedRange_1 = __webpack_require__(7);
var ComponentFootprint_1 = __webpack_require__(16);
var TimeGridEventRenderer_1 = __webpack_require__(255);
var TimeGridHelperRenderer_1 = __webpack_require__(256);
var TimeGridFillRenderer_1 = __webpack_require__(257);
/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/
// We mixin DayTable, even though there is only a single row of days
// potential nice values for the slot-duration and interval-duration
// from largest to smallest
var AGENDA_STOCK_SUB_DURATIONS = [
    { hours: 1 },
    { minutes: 30 },
    { minutes: 15 },
    { seconds: 30 },
    { seconds: 15 }
];
var TimeGrid = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGrid, _super);
    function TimeGrid(view) {
        var _this = _super.call(this, view) || this;
        _this.processOptions();
        return _this;
    }
    // Slices up the given span (unzoned start/end with other misc data) into an array of segments
    TimeGrid.prototype.componentFootprintToSegs = function (componentFootprint) {
        var segs = this.sliceRangeByTimes(componentFootprint.unzonedRange);
        var i;
        for (i = 0; i < segs.length; i++) {
            if (this.isRTL) {
                segs[i].col = this.daysPerRow - 1 - segs[i].dayIndex;
            }
            else {
                segs[i].col = segs[i].dayIndex;
            }
        }
        return segs;
    };
    /* Date Handling
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.sliceRangeByTimes = function (unzonedRange) {
        var segs = [];
        var segRange;
        var dayIndex;
        for (dayIndex = 0; dayIndex < this.daysPerRow; dayIndex++) {
            segRange = unzonedRange.intersect(this.dayRanges[dayIndex]);
            if (segRange) {
                segs.push({
                    startMs: segRange.startMs,
                    endMs: segRange.endMs,
                    isStart: segRange.isStart,
                    isEnd: segRange.isEnd,
                    dayIndex: dayIndex
                });
            }
        }
        return segs;
    };
    /* Options
    ------------------------------------------------------------------------------------------------------------------*/
    // Parses various options into properties of this object
    TimeGrid.prototype.processOptions = function () {
        var slotDuration = this.opt('slotDuration');
        var snapDuration = this.opt('snapDuration');
        var input;
        slotDuration = moment.duration(slotDuration);
        snapDuration = snapDuration ? moment.duration(snapDuration) : slotDuration;
        this.slotDuration = slotDuration;
        this.snapDuration = snapDuration;
        this.snapsPerSlot = slotDuration / snapDuration; // TODO: ensure an integer multiple?
        // might be an array value (for TimelineView).
        // if so, getting the most granular entry (the last one probably).
        input = this.opt('slotLabelFormat');
        if (Array.isArray(input)) {
            input = input[input.length - 1];
        }
        this.labelFormat = input ||
            this.opt('smallTimeFormat'); // the computed default
        input = this.opt('slotLabelInterval');
        this.labelInterval = input ?
            moment.duration(input) :
            this.computeLabelInterval(slotDuration);
    };
    // Computes an automatic value for slotLabelInterval
    TimeGrid.prototype.computeLabelInterval = function (slotDuration) {
        var i;
        var labelInterval;
        var slotsPerLabel;
        // find the smallest stock label interval that results in more than one slots-per-label
        for (i = AGENDA_STOCK_SUB_DURATIONS.length - 1; i >= 0; i--) {
            labelInterval = moment.duration(AGENDA_STOCK_SUB_DURATIONS[i]);
            slotsPerLabel = date_1.divideDurationByDuration(labelInterval, slotDuration);
            if (misc_1.isInt(slotsPerLabel) && slotsPerLabel > 1) {
                return labelInterval;
            }
        }
        return moment.duration(slotDuration); // fall back. clone
    };
    /* Date Rendering
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.renderDates = function (dateProfile) {
        this.dateProfile = dateProfile;
        this.updateDayTable();
        this.renderSlats();
        this.renderColumns();
    };
    TimeGrid.prototype.unrenderDates = function () {
        // this.unrenderSlats(); // don't need this because repeated .html() calls clear
        this.unrenderColumns();
    };
    TimeGrid.prototype.renderSkeleton = function () {
        var theme = this.view.calendar.theme;
        this.el.innerHTML =
            '<div class="fc-bg"></div>' +
                '<div class="fc-slats"></div>' +
                '<hr class="fc-divider ' + theme.getClass('widgetHeader') + '" style="display:none" />';
        this.rootBgContainerEl = this.el.querySelector('.fc-bg');
        this.slatContainerEl = this.el.querySelector('.fc-slats');
        this.bottomRuleEl = this.el.querySelector('.fc-divider');
    };
    TimeGrid.prototype.renderSlats = function () {
        var theme = this.view.calendar.theme;
        this.slatContainerEl.innerHTML =
            '<table class="' + theme.getClass('tableGrid') + '">' +
                this.renderSlatRowHtml() +
                '</table>';
        this.slatEls = dom_manip_1.findElements(this.slatContainerEl, 'tr');
        this.slatCoordCache = new CoordCache_1.default({
            els: this.slatEls,
            isVertical: true
        });
    };
    // Generates the HTML for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
    TimeGrid.prototype.renderSlatRowHtml = function () {
        var view = this.view;
        var calendar = view.calendar;
        var theme = calendar.theme;
        var isRTL = this.isRTL;
        var dateProfile = this.dateProfile;
        var html = '';
        var slotTime = moment.duration(+dateProfile.minTime); // wish there was .clone() for durations
        var slotIterator = moment.duration(0);
        var slotDate; // will be on the view's first day, but we only care about its time
        var isLabeled;
        var axisHtml;
        // Calculate the time for each slot
        while (slotTime < dateProfile.maxTime) {
            slotDate = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs).time(slotTime);
            isLabeled = misc_1.isInt(date_1.divideDurationByDuration(slotIterator, this.labelInterval));
            axisHtml =
                '<td class="fc-axis fc-time ' + theme.getClass('widgetContent') + '" ' + view.axisStyleAttr() + '>' +
                    (isLabeled ?
                        '<span>' + // for matchCellWidths
                            html_1.htmlEscape(slotDate.format(this.labelFormat)) +
                            '</span>' :
                        '') +
                    '</td>';
            html +=
                '<tr data-time="' + slotDate.format('HH:mm:ss') + '"' +
                    (isLabeled ? '' : ' class="fc-minor"') +
                    '>' +
                    (!isRTL ? axisHtml : '') +
                    '<td class="' + theme.getClass('widgetContent') + '"></td>' +
                    (isRTL ? axisHtml : '') +
                    '</tr>';
            slotTime.add(this.slotDuration);
            slotIterator.add(this.slotDuration);
        }
        return html;
    };
    TimeGrid.prototype.renderColumns = function () {
        var dateProfile = this.dateProfile;
        var theme = this.view.calendar.theme;
        this.dayRanges = this.dayDates.map(function (dayDate) {
            return new UnzonedRange_1.default(dayDate.clone().add(dateProfile.minTime), dayDate.clone().add(dateProfile.maxTime));
        });
        if (this.headContainerEl) {
            this.headContainerEl.innerHTML = this.renderHeadHtml();
        }
        this.rootBgContainerEl.innerHTML =
            '<table class="' + theme.getClass('tableGrid') + '">' +
                this.renderBgTrHtml(0) + // row=0
                '</table>';
        this.colEls = dom_manip_1.findElements(this.el, '.fc-day, .fc-disabled-day');
        this.colCoordCache = new CoordCache_1.default({
            els: this.colEls,
            isHorizontal: true
        });
        this.renderContentSkeleton();
    };
    TimeGrid.prototype.unrenderColumns = function () {
        this.unrenderContentSkeleton();
    };
    /* Content Skeleton
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders the DOM that the view's content will live in
    TimeGrid.prototype.renderContentSkeleton = function () {
        var cellHtml = '';
        var i;
        var skeletonEl;
        for (i = 0; i < this.colCnt; i++) {
            cellHtml +=
                '<td>' +
                    '<div class="fc-content-col">' +
                    '<div class="fc-event-container fc-helper-container"></div>' +
                    '<div class="fc-event-container"></div>' +
                    '<div class="fc-highlight-container"></div>' +
                    '<div class="fc-bgevent-container"></div>' +
                    '<div class="fc-business-container"></div>' +
                    '</div>' +
                    '</td>';
        }
        skeletonEl = this.contentSkeletonEl = dom_manip_1.htmlToElement('<div class="fc-content-skeleton">' +
            '<table>' +
            '<tr>' + cellHtml + '</tr>' +
            '</table>' +
            '</div>');
        this.colContainerEls = dom_manip_1.findElements(skeletonEl, '.fc-content-col');
        this.helperContainerEls = dom_manip_1.findElements(skeletonEl, '.fc-helper-container');
        this.fgContainerEls = dom_manip_1.findElements(skeletonEl, '.fc-event-container:not(.fc-helper-container)');
        this.bgContainerEls = dom_manip_1.findElements(skeletonEl, '.fc-bgevent-container');
        this.highlightContainerEls = dom_manip_1.findElements(skeletonEl, '.fc-highlight-container');
        this.businessContainerEls = dom_manip_1.findElements(skeletonEl, '.fc-business-container');
        this.bookendCells(skeletonEl.querySelector('tr')); // TODO: do this on string level
        this.el.appendChild(skeletonEl);
    };
    TimeGrid.prototype.unrenderContentSkeleton = function () {
        if (this.contentSkeletonEl) { // defensive :(
            dom_manip_1.removeElement(this.contentSkeletonEl);
            this.contentSkeletonEl = null;
            this.colContainerEls = null;
            this.helperContainerEls = null;
            this.fgContainerEls = null;
            this.bgContainerEls = null;
            this.highlightContainerEls = null;
            this.businessContainerEls = null;
        }
    };
    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's col
    TimeGrid.prototype.groupSegsByCol = function (segs) {
        var segsByCol = [];
        var i;
        for (i = 0; i < this.colCnt; i++) {
            segsByCol.push([]);
        }
        for (i = 0; i < segs.length; i++) {
            segsByCol[segs[i].col].push(segs[i]);
        }
        return segsByCol;
    };
    // Given segments grouped by column, insert the segments' elements into a parallel array of container
    // elements, each living within a column.
    TimeGrid.prototype.attachSegsByCol = function (segsByCol, containerEls) {
        var col;
        var segs;
        var i;
        for (col = 0; col < this.colCnt; col++) { // iterate each column grouping
            segs = segsByCol[col];
            for (i = 0; i < segs.length; i++) {
                containerEls[col].appendChild(segs[i].el);
            }
        }
    };
    /* Now Indicator
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.getNowIndicatorUnit = function () {
        return 'minute'; // will refresh on the minute
    };
    TimeGrid.prototype.renderNowIndicator = function (date) {
        // HACK: if date columns not ready for some reason (scheduler)
        if (!this.colContainerEls) {
            return;
        }
        // seg system might be overkill, but it handles scenario where line needs to be rendered
        //  more than once because of columns with the same date (resources columns for example)
        var segs = this.componentFootprintToSegs(new ComponentFootprint_1.default(new UnzonedRange_1.default(date, date.valueOf() + 1), // protect against null range
        false // all-day
        ));
        var top = this.computeDateTop(date, date);
        var nodes = [];
        var i;
        // render lines within the columns
        for (i = 0; i < segs.length; i++) {
            var lineEl = dom_manip_1.createElement('div', { className: 'fc-now-indicator fc-now-indicator-line' });
            lineEl.style.top = top + 'px';
            this.colContainerEls[segs[i].col].appendChild(lineEl);
            nodes.push(lineEl);
        }
        // render an arrow over the axis
        if (segs.length > 0) { // is the current time in view?
            var arrowEl = dom_manip_1.createElement('div', { className: 'fc-now-indicator fc-now-indicator-arrow' });
            arrowEl.style.top = top + 'px';
            this.contentSkeletonEl.appendChild(arrowEl);
            nodes.push(arrowEl);
        }
        this.nowIndicatorEls = nodes;
    };
    TimeGrid.prototype.unrenderNowIndicator = function () {
        if (this.nowIndicatorEls) {
            this.nowIndicatorEls.forEach(dom_manip_1.removeElement);
            this.nowIndicatorEls = null;
        }
    };
    /* Coordinates
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        this.slatCoordCache.build();
        if (isResize) {
            this.updateSegVerticals([].concat(this.eventRenderer.getSegs(), this.businessSegs || []));
        }
    };
    TimeGrid.prototype.getTotalSlatHeight = function () {
        return this.slatContainerEl.offsetHeight;
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // `ms` can be a millisecond UTC time OR a UTC moment.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    TimeGrid.prototype.computeDateTop = function (ms, startOfDayDate) {
        return this.computeTimeTop(moment.duration(ms - startOfDayDate.clone().stripTime()));
    };
    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    TimeGrid.prototype.computeTimeTop = function (time) {
        var len = this.slatEls.length;
        var dateProfile = this.dateProfile;
        var slatCoverage = (time - dateProfile.minTime) / this.slotDuration; // floating-point value of # of slots covered
        var slatIndex;
        var slatRemainder;
        // compute a floating-point number for how many slats should be progressed through.
        // from 0 to number of slats (inclusive)
        // constrained because minTime/maxTime might be customized.
        slatCoverage = Math.max(0, slatCoverage);
        slatCoverage = Math.min(len, slatCoverage);
        // an integer index of the furthest whole slat
        // from 0 to number slats (*exclusive*, so len-1)
        slatIndex = Math.floor(slatCoverage);
        slatIndex = Math.min(slatIndex, len - 1);
        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
        // could be 1.0 if slatCoverage is covering *all* the slots
        slatRemainder = slatCoverage - slatIndex;
        return this.slatCoordCache.getTopPosition(slatIndex) +
            this.slatCoordCache.getHeight(slatIndex) * slatRemainder;
    };
    // Refreshes the CSS top/bottom coordinates for each segment element.
    // Works when called after initial render, after a window resize/zoom for example.
    TimeGrid.prototype.updateSegVerticals = function (segs) {
        this.computeSegVerticals(segs);
        this.assignSegVerticals(segs);
    };
    // For each segment in an array, computes and assigns its top and bottom properties
    TimeGrid.prototype.computeSegVerticals = function (segs) {
        var eventMinHeight = this.opt('agendaEventMinHeight');
        var i;
        var seg;
        var dayDate;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            dayDate = this.dayDates[seg.dayIndex];
            seg.top = this.computeDateTop(seg.startMs, dayDate);
            seg.bottom = Math.max(seg.top + eventMinHeight, this.computeDateTop(seg.endMs, dayDate));
        }
    };
    // Given segments that already have their top/bottom properties computed, applies those values to
    // the segments' elements.
    TimeGrid.prototype.assignSegVerticals = function (segs) {
        var i;
        var seg;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            dom_manip_1.applyStyle(seg.el, this.generateSegVerticalCss(seg));
        }
    };
    // Generates an object with CSS properties for the top/bottom coordinates of a segment element
    TimeGrid.prototype.generateSegVerticalCss = function (seg) {
        return {
            top: seg.top,
            bottom: -seg.bottom // flipped because needs to be space beyond bottom edge of event container
        };
    };
    /* Hit System
    ------------------------------------------------------------------------------------------------------------------*/
    TimeGrid.prototype.prepareHits = function () {
        this.colCoordCache.build();
        this.slatCoordCache.build();
    };
    TimeGrid.prototype.releaseHits = function () {
        this.colCoordCache.clear();
        // NOTE: don't clear slatCoordCache because we rely on it for computeTimeTop
    };
    TimeGrid.prototype.queryHit = function (leftOffset, topOffset) {
        var snapsPerSlot = this.snapsPerSlot;
        var colCoordCache = this.colCoordCache;
        var slatCoordCache = this.slatCoordCache;
        if (colCoordCache.isLeftInBounds(leftOffset) && slatCoordCache.isTopInBounds(topOffset)) {
            var colIndex = colCoordCache.getHorizontalIndex(leftOffset);
            var slatIndex = slatCoordCache.getVerticalIndex(topOffset);
            if (colIndex != null && slatIndex != null) {
                var slatTop = slatCoordCache.getTopOffset(slatIndex);
                var slatHeight = slatCoordCache.getHeight(slatIndex);
                var partial = (topOffset - slatTop) / slatHeight; // floating point number between 0 and 1
                var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
                var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
                var snapTop = slatTop + (localSnapIndex / snapsPerSlot) * slatHeight;
                var snapBottom = slatTop + ((localSnapIndex + 1) / snapsPerSlot) * slatHeight;
                return {
                    col: colIndex,
                    snap: snapIndex,
                    component: this,
                    left: colCoordCache.getLeftOffset(colIndex),
                    right: colCoordCache.getRightOffset(colIndex),
                    top: snapTop,
                    bottom: snapBottom
                };
            }
        }
    };
    TimeGrid.prototype.getHitFootprint = function (hit) {
        var start = this.getCellDate(0, hit.col); // row=0
        var time = this.computeSnapTime(hit.snap); // pass in the snap-index
        var end;
        start.time(time);
        end = start.clone().add(this.snapDuration);
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), false // all-day?
        );
    };
    // Given a row number of the grid, representing a "snap", returns a time (Duration) from its start-of-day
    TimeGrid.prototype.computeSnapTime = function (snapIndex) {
        return moment.duration(this.dateProfile.minTime + this.snapDuration * snapIndex);
    };
    TimeGrid.prototype.getHitEl = function (hit) {
        return this.colEls[hit.col];
    };
    /* Event Drag Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being dragged over the specified date(s).
    // A returned value of `true` signals that a mock "helper" event has been rendered.
    TimeGrid.prototype.renderDrag = function (eventFootprints, seg, isTouch) {
        var i;
        if (seg) { // if there is event information for this drag, render a helper event
            if (eventFootprints.length) {
                this.helperRenderer.renderEventDraggingFootprints(eventFootprints, seg, isTouch);
                // signal that a helper has been rendered
                return true;
            }
        }
        else { // otherwise, just render a highlight
            for (i = 0; i < eventFootprints.length; i++) {
                this.renderHighlight(eventFootprints[i].componentFootprint);
            }
        }
    };
    // Unrenders any visual indication of an event being dragged
    TimeGrid.prototype.unrenderDrag = function () {
        this.unrenderHighlight();
        this.helperRenderer.unrender();
    };
    /* Event Resize Visualization
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of an event being resized
    TimeGrid.prototype.renderEventResize = function (eventFootprints, seg, isTouch) {
        this.helperRenderer.renderEventResizingFootprints(eventFootprints, seg, isTouch);
    };
    // Unrenders any visual indication of an event being resized
    TimeGrid.prototype.unrenderEventResize = function () {
        this.helperRenderer.unrender();
    };
    /* Selection
    ------------------------------------------------------------------------------------------------------------------*/
    // Renders a visual indication of a selection. Overrides the default, which was to simply render a highlight.
    TimeGrid.prototype.renderSelectionFootprint = function (componentFootprint) {
        if (this.opt('selectHelper')) { // this setting signals that a mock helper event should be rendered
            this.helperRenderer.renderComponentFootprint(componentFootprint);
        }
        else {
            this.renderHighlight(componentFootprint);
        }
    };
    // Unrenders any visual indication of a selection
    TimeGrid.prototype.unrenderSelection = function () {
        this.helperRenderer.unrender();
        this.unrenderHighlight();
    };
    return TimeGrid;
}(InteractiveDateComponent_1.default));
exports.default = TimeGrid;
TimeGrid.prototype.eventRendererClass = TimeGridEventRenderer_1.default;
TimeGrid.prototype.businessHourRendererClass = BusinessHourRenderer_1.default;
TimeGrid.prototype.helperRendererClass = TimeGridHelperRenderer_1.default;
TimeGrid.prototype.fillRendererClass = TimeGridFillRenderer_1.default;
StandardInteractionsMixin_1.default.mixInto(TimeGrid);
DayTableMixin_1.default.mixInto(TimeGrid);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var UnzonedRange_1 = __webpack_require__(7);
var DateProfileGenerator_1 = __webpack_require__(228);
var BasicViewDateProfileGenerator = /** @class */ (function (_super) {
    tslib_1.__extends(BasicViewDateProfileGenerator, _super);
    function BasicViewDateProfileGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Computes the date range that will be rendered.
    BasicViewDateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
        var renderUnzonedRange = _super.prototype.buildRenderRange.call(this, currentUnzonedRange, currentRangeUnit, isRangeAllDay); // an UnzonedRange
        var start = this.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
        var end = this.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay);
        // year and month views should be aligned with weeks. this is already done for week
        if (/^(year|month)$/.test(currentRangeUnit)) {
            start.startOf('week');
            // make end-of-week if not already
            if (end.weekday()) {
                end.add(1, 'week').startOf('week'); // exclusively move backwards
            }
        }
        return new UnzonedRange_1.default(start, end);
    };
    return BasicViewDateProfileGenerator;
}(DateProfileGenerator_1.default));
exports.default = BasicViewDateProfileGenerator;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var moment = __webpack_require__(0);
var misc_1 = __webpack_require__(4);
var BasicView_1 = __webpack_require__(68);
var MonthViewDateProfileGenerator_1 = __webpack_require__(262);
/* A month view with day cells running in rows (one-per-week) and columns
----------------------------------------------------------------------------------------------------------------------*/
var MonthView = /** @class */ (function (_super) {
    tslib_1.__extends(MonthView, _super);
    function MonthView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Overrides the default BasicView behavior to have special multi-week auto-height logic
    MonthView.prototype.setGridHeight = function (height, isAuto) {
        // if auto, make the height of each row the height that it would be if there were 6 weeks
        if (isAuto) {
            height *= this.dayGrid.rowCnt / 6;
        }
        misc_1.distributeHeight(this.dayGrid.rowEls, height, !isAuto); // if auto, don't compensate for height-hogging rows
    };
    MonthView.prototype.isDateInOtherMonth = function (date, dateProfile) {
        return date.month() !== moment.utc(dateProfile.currentUnzonedRange.startMs).month(); // TODO: optimize
    };
    return MonthView;
}(BasicView_1.default));
exports.default = MonthView;
MonthView.prototype.dateProfileGeneratorClass = MonthViewDateProfileGenerator_1.default;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var dom_manip_1 = __webpack_require__(3);
var html_1 = __webpack_require__(6);
var misc_1 = __webpack_require__(4);
var UnzonedRange_1 = __webpack_require__(7);
var View_1 = __webpack_require__(46);
var Scroller_1 = __webpack_require__(44);
var ListEventRenderer_1 = __webpack_require__(263);
var ListEventPointing_1 = __webpack_require__(264);
/*
Responsible for the scroller, and forwarding event-related actions into the "grid".
*/
var ListView = /** @class */ (function (_super) {
    tslib_1.__extends(ListView, _super);
    function ListView(calendar, viewSpec) {
        var _this = _super.call(this, calendar, viewSpec) || this;
        _this.segSelector = '.fc-list-item'; // which elements accept event actions
        _this.scroller = new Scroller_1.default({
            overflowX: 'hidden',
            overflowY: 'auto'
        });
        return _this;
    }
    ListView.prototype.renderSkeleton = function () {
        this.el.classList.add('fc-list-view');
        var themeClass = this.calendar.theme.getClass('listView');
        if (themeClass) {
            this.el.classList.add(themeClass);
        }
        this.scroller.render();
        this.el.appendChild(this.scroller.el);
        this.contentEl = this.scroller.scrollEl; // shortcut
    };
    ListView.prototype.unrenderSkeleton = function () {
        this.scroller.destroy(); // will remove the Grid too
    };
    ListView.prototype.updateSize = function (totalHeight, isAuto, isResize) {
        _super.prototype.updateSize.call(this, totalHeight, isAuto, isResize);
        this.scroller.clear(); // sets height to 'auto' and clears overflow
        if (!isAuto) {
            this.scroller.setHeight(this.computeScrollerHeight(totalHeight));
        }
    };
    ListView.prototype.computeScrollerHeight = function (totalHeight) {
        return totalHeight -
            misc_1.subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
    };
    ListView.prototype.renderDates = function (dateProfile) {
        var calendar = this.calendar;
        var dayStart = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.startMs, true);
        var viewEnd = calendar.msToUtcMoment(dateProfile.renderUnzonedRange.endMs, true);
        var dayDates = [];
        var dayRanges = [];
        while (dayStart < viewEnd) {
            dayDates.push(dayStart.clone());
            dayRanges.push(new UnzonedRange_1.default(dayStart, dayStart.clone().add(1, 'day')));
            dayStart.add(1, 'day');
        }
        this.dayDates = dayDates;
        this.dayRanges = dayRanges;
        // all real rendering happens in EventRenderer
    };
    // slices by day
    ListView.prototype.componentFootprintToSegs = function (footprint) {
        var dayRanges = this.dayRanges;
        var dayIndex;
        var segRange;
        var seg;
        var segs = [];
        for (dayIndex = 0; dayIndex < dayRanges.length; dayIndex++) {
            segRange = footprint.unzonedRange.intersect(dayRanges[dayIndex]);
            if (segRange) {
                seg = {
                    startMs: segRange.startMs,
                    endMs: segRange.endMs,
                    isStart: segRange.isStart,
                    isEnd: segRange.isEnd,
                    dayIndex: dayIndex
                };
                segs.push(seg);
                // detect when footprint won't go fully into the next day,
                // and mutate the latest seg to the be the end.
                if (!seg.isEnd && !footprint.isAllDay &&
                    dayIndex + 1 < dayRanges.length &&
                    footprint.unzonedRange.endMs < dayRanges[dayIndex + 1].startMs + this.nextDayThreshold) {
                    seg.endMs = footprint.unzonedRange.endMs;
                    seg.isEnd = true;
                    break;
                }
            }
        }
        return segs;
    };
    ListView.prototype.renderEmptyMessage = function () {
        this.contentEl.innerHTML =
            '<div class="fc-list-empty-wrap2">' + // TODO: try less wraps
                '<div class="fc-list-empty-wrap1">' +
                '<div class="fc-list-empty">' +
                html_1.htmlEscape(this.opt('noEventsMessage')) +
                '</div>' +
                '</div>' +
                '</div>';
    };
    // render the event segments in the view
    ListView.prototype.renderSegList = function (allSegs) {
        var segsByDay = this.groupSegsByDay(allSegs); // sparse array
        var dayIndex;
        var daySegs;
        var i;
        var tableEl = dom_manip_1.htmlToElement('<table class="fc-list-table ' + this.calendar.theme.getClass('tableList') + '"><tbody></tbody></table>');
        var tbodyEl = tableEl.querySelector('tbody');
        for (dayIndex = 0; dayIndex < segsByDay.length; dayIndex++) {
            daySegs = segsByDay[dayIndex];
            if (daySegs) { // sparse array, so might be undefined
                // append a day header
                tbodyEl.appendChild(this.buildDayHeaderRow(this.dayDates[dayIndex]));
                this.eventRenderer.sortEventSegs(daySegs);
                for (i = 0; i < daySegs.length; i++) {
                    tbodyEl.appendChild(daySegs[i].el); // append event row
                }
            }
        }
        this.contentEl.innerHTML = '';
        this.contentEl.appendChild(tableEl);
    };
    // Returns a sparse array of arrays, segs grouped by their dayIndex
    ListView.prototype.groupSegsByDay = function (segs) {
        var segsByDay = []; // sparse array
        var i;
        var seg;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            (segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = []))
                .push(seg);
        }
        return segsByDay;
    };
    // generates the HTML for the day headers that live amongst the event rows
    ListView.prototype.buildDayHeaderRow = function (dayDate) {
        var mainFormat = this.opt('listDayFormat');
        var altFormat = this.opt('listDayAltFormat');
        return dom_manip_1.createElement('tr', {
            className: 'fc-list-heading',
            'data-date': dayDate.format('YYYY-MM-DD')
        }, '<td class="' + (this.calendar.theme.getClass('tableListHeading') ||
            this.calendar.theme.getClass('widgetHeader')) + '" colspan="3">' +
            (mainFormat ?
                this.buildGotoAnchorHtml(dayDate, { 'class': 'fc-list-heading-main' }, html_1.htmlEscape(dayDate.format(mainFormat)) // inner HTML
                ) :
                '') +
            (altFormat ?
                this.buildGotoAnchorHtml(dayDate, { 'class': 'fc-list-heading-alt' }, html_1.htmlEscape(dayDate.format(altFormat)) // inner HTML
                ) :
                '') +
            '</td>');
    };
    return ListView;
}(View_1.default));
exports.default = ListView;
ListView.prototype.eventRendererClass = ListEventRenderer_1.default;
ListView.prototype.eventPointingClass = ListEventPointing_1.default;


/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var exportHooks = __webpack_require__(35);
// for intentional side-effects
__webpack_require__(14);
__webpack_require__(52);
__webpack_require__(265);
__webpack_require__(266);
__webpack_require__(269);
__webpack_require__(270);
__webpack_require__(271);
module.exports = exportHooks;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
// given a function that resolves a result asynchronously.
// the function can either call passed-in success and failure callbacks,
// or it can return a promise.
// if you need to pass additional params to func, bind them first.
function unpromisify(func, success, failure) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    var isResolved = false;
    var wrappedSuccess = function () {
        if (!isResolved) {
            isResolved = true;
            success.apply(this, arguments);
        }
    };
    var wrappedFailure = function () {
        if (!isResolved) {
            isResolved = true;
            if (failure) {
                failure.apply(this, arguments);
            }
        }
    };
    var res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === 'function') {
        res.then(wrappedSuccess, wrappedFailure);
    }
}
exports.unpromisify = unpromisify;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var dom_manip_1 = __webpack_require__(3);
var Model_1 = __webpack_require__(53);
var Component = /** @class */ (function (_super) {
    tslib_1.__extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Component.prototype.setElement = function (el) {
        this.el = el;
        this.bindGlobalHandlers();
        this.renderSkeleton();
        this.set('isInDom', true);
    };
    Component.prototype.removeElement = function () {
        this.unset('isInDom');
        this.unrenderSkeleton();
        this.unbindGlobalHandlers();
        dom_manip_1.removeElement(this.el);
        // NOTE: don't null-out this.el in case the View was destroyed within an API callback.
        // We don't null-out the View's other element references upon destroy,
        //  so we shouldn't kill this.el either.
    };
    Component.prototype.bindGlobalHandlers = function () {
        // subclasses can override
    };
    Component.prototype.unbindGlobalHandlers = function () {
        // subclasses can override
    };
    /*
    NOTE: Can't have a `render` method. Read the deprecation notice in View::executeDateRender
    */
    // Renders the basic structure of the view before any content is rendered
    Component.prototype.renderSkeleton = function () {
        // subclasses should implement
    };
    // Unrenders the basic structure of the view
    Component.prototype.unrenderSkeleton = function () {
        // subclasses should implement
    };
    return Component;
}(Model_1.default));
exports.default = Component;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var dom_manip_1 = __webpack_require__(3);
var dom_geom_1 = __webpack_require__(13);
var dom_event_1 = __webpack_require__(10);
var misc_1 = __webpack_require__(4);
var options_1 = __webpack_require__(37);
var Iterator_1 = __webpack_require__(247);
var GlobalEmitter_1 = __webpack_require__(25);
var EmitterMixin_1 = __webpack_require__(15);
var ListenerMixin_1 = __webpack_require__(12);
var Toolbar_1 = __webpack_require__(248);
var OptionsManager_1 = __webpack_require__(249);
var ViewSpecManager_1 = __webpack_require__(250);
var Constraints_1 = __webpack_require__(215);
var locale_1 = __webpack_require__(36);
var moment_ext_1 = __webpack_require__(14);
var UnzonedRange_1 = __webpack_require__(7);
var ComponentFootprint_1 = __webpack_require__(16);
var EventDateProfile_1 = __webpack_require__(22);
var EventManager_1 = __webpack_require__(251);
var BusinessHourGenerator_1 = __webpack_require__(220);
var EventSourceParser_1 = __webpack_require__(43);
var EventDefParser_1 = __webpack_require__(54);
var SingleEventDef_1 = __webpack_require__(17);
var EventDefMutation_1 = __webpack_require__(42);
var EventSource_1 = __webpack_require__(9);
var ThemeRegistry_1 = __webpack_require__(56);
var Calendar = /** @class */ (function () {
    function Calendar(el, overrides) {
        this.loadingLevel = 0; // number of simultaneous loading tasks
        this.ignoreUpdateViewSize = 0;
        this.freezeContentHeightDepth = 0;
        // declare the current calendar instance relies on GlobalEmitter. needed for garbage collection.
        // unneeded() is called in destroy.
        GlobalEmitter_1.default.needed();
        this.el = el;
        this.viewsByType = {};
        this.optionsManager = new OptionsManager_1.default(this, overrides);
        this.viewSpecManager = new ViewSpecManager_1.default(this.optionsManager, this);
        this.initMomentInternals(); // needs to happen after options hash initialized
        this.initCurrentDate();
        this.initEventManager();
        this.constraints = new Constraints_1.default(this.eventManager, this);
        this.constructed();
    }
    Calendar.prototype.constructed = function () {
        // useful for monkeypatching. used?
    };
    Calendar.prototype.getView = function () {
        return this.view;
    };
    Calendar.prototype.publiclyTrigger = function (name, triggerInfo) {
        var optHandler = this.opt(name);
        var context;
        var args;
        if (Array.isArray(triggerInfo)) {
            args = triggerInfo;
        }
        else if (typeof triggerInfo === 'object' && triggerInfo) { // non-null object
            context = triggerInfo.context;
            args = triggerInfo.args;
        }
        if (context == null) {
            context = this.el; // fallback context
        }
        if (!args) {
            args = [];
        }
        this.triggerWith(name, context, args); // Emitter's method
        if (optHandler) {
            return optHandler.apply(context, args);
        }
    };
    Calendar.prototype.hasPublicHandlers = function (name) {
        return this.hasHandlers(name) ||
            this.opt(name); // handler specified in options
    };
    // Options Public API
    // -----------------------------------------------------------------------------------------------------------------
    // public getter/setter
    Calendar.prototype.option = function (name, value) {
        var newOptionHash;
        if (typeof name === 'string') {
            if (value === undefined) { // getter
                return this.optionsManager.get(name);
            }
            else { // setter for individual option
                newOptionHash = {};
                newOptionHash[name] = value;
                this.optionsManager.add(newOptionHash);
            }
        }
        else if (typeof name === 'object' && name) { // compound setter with object input (non-null)
            this.optionsManager.add(name);
        }
    };
    // private getter
    Calendar.prototype.opt = function (name) {
        return this.optionsManager.get(name);
    };
    // View
    // -----------------------------------------------------------------------------------------------------------------
    // Given a view name for a custom view or a standard view, creates a ready-to-go View object
    Calendar.prototype.instantiateView = function (viewType) {
        var spec = this.viewSpecManager.getViewSpec(viewType);
        if (!spec) {
            throw new Error("View type \"" + viewType + "\" is not valid");
        }
        return new spec['class'](this, spec);
    };
    // Returns a boolean about whether the view is okay to instantiate at some point
    Calendar.prototype.isValidViewType = function (viewType) {
        return Boolean(this.viewSpecManager.getViewSpec(viewType));
    };
    Calendar.prototype.changeView = function (viewName, dateOrRange) {
        if (dateOrRange) {
            if (dateOrRange.start && dateOrRange.end) { // a range
                this.optionsManager.recordOverrides({
                    visibleRange: dateOrRange
                });
            }
            else { // a date
                this.currentDate = this.moment(dateOrRange).stripZone(); // just like gotoDate
            }
        }
        this.renderView(viewName);
    };
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    Calendar.prototype.zoomTo = function (newDate, viewType) {
        var spec;
        viewType = viewType || 'day'; // day is default zoom
        spec = this.viewSpecManager.getViewSpec(viewType) ||
            this.viewSpecManager.getUnitViewSpec(viewType);
        this.currentDate = newDate.clone();
        this.renderView(spec ? spec.type : null);
    };
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initCurrentDate = function () {
        var defaultDateInput = this.opt('defaultDate');
        // compute the initial ambig-timezone date
        if (defaultDateInput != null) {
            this.currentDate = this.moment(defaultDateInput).stripZone();
        }
        else {
            this.currentDate = this.getNow(); // getNow already returns unzoned
        }
    };
    Calendar.prototype.prev = function () {
        var view = this.view;
        var prevInfo = view.dateProfileGenerator.buildPrev(view.get('dateProfile'));
        if (prevInfo.isValid) {
            this.currentDate = prevInfo.date;
            this.renderView();
        }
    };
    Calendar.prototype.next = function () {
        var view = this.view;
        var nextInfo = view.dateProfileGenerator.buildNext(view.get('dateProfile'));
        if (nextInfo.isValid) {
            this.currentDate = nextInfo.date;
            this.renderView();
        }
    };
    Calendar.prototype.prevYear = function () {
        this.currentDate.add(-1, 'years');
        this.renderView();
    };
    Calendar.prototype.nextYear = function () {
        this.currentDate.add(1, 'years');
        this.renderView();
    };
    Calendar.prototype.today = function () {
        this.currentDate = this.getNow(); // should deny like prev/next?
        this.renderView();
    };
    Calendar.prototype.gotoDate = function (zonedDateInput) {
        this.currentDate = this.moment(zonedDateInput).stripZone();
        this.renderView();
    };
    Calendar.prototype.incrementDate = function (delta) {
        this.currentDate.add(moment.duration(delta));
        this.renderView();
    };
    // for external API
    Calendar.prototype.getDate = function () {
        return this.applyTimezone(this.currentDate); // infuse the calendar's timezone
    };
    // Loading Triggering
    // -----------------------------------------------------------------------------------------------------------------
    // Should be called when any type of async data fetching begins
    Calendar.prototype.pushLoading = function () {
        if (!(this.loadingLevel++)) {
            this.publiclyTrigger('loading', [true, this.view]);
        }
    };
    // Should be called when any type of async data fetching completes
    Calendar.prototype.popLoading = function () {
        if (!(--this.loadingLevel)) {
            this.publiclyTrigger('loading', [false, this.view]);
        }
    };
    // High-level Rendering
    // -----------------------------------------------------------------------------------
    Calendar.prototype.render = function () {
        if (!this.contentEl) {
            this.initialRender();
        }
        else if (this.elementVisible()) {
            // mainly for the public API
            this.calcSize();
            this.updateViewSize();
        }
    };
    Calendar.prototype.initialRender = function () {
        var _this = this;
        var el = this.el;
        el.classList.add('fc');
        // event delegation for nav links
        this.removeNavLinkListener = dom_event_1.listenBySelector(el, 'click', 'a[data-goto]', function (ev, anchorEl) {
            var gotoOptions = anchorEl.getAttribute('data-goto');
            gotoOptions = gotoOptions ? JSON.parse(gotoOptions) : {};
            var date = _this.moment(gotoOptions.date);
            var viewType = gotoOptions.type;
            // property like "navLinkDayClick". might be a string or a function
            var customAction = _this.view.opt('navLink' + misc_1.capitaliseFirstLetter(viewType) + 'Click');
            if (typeof customAction === 'function') {
                customAction(date, ev);
            }
            else {
                if (typeof customAction === 'string') {
                    viewType = customAction;
                }
                _this.zoomTo(date, viewType);
            }
        });
        // called immediately, and upon option change
        this.optionsManager.watch('settingTheme', ['?theme', '?themeSystem'], function (opts) {
            var themeClass = ThemeRegistry_1.getThemeSystemClass(opts.themeSystem || opts.theme);
            var theme = new themeClass(_this.optionsManager);
            var widgetClass = theme.getClass('widget');
            _this.theme = theme;
            if (widgetClass) {
                el.classList.add(widgetClass);
            }
        }, function () {
            var widgetClass = _this.theme.getClass('widget');
            _this.theme = null;
            if (widgetClass) {
                el.classList.remove(widgetClass);
            }
        });
        this.optionsManager.watch('settingBusinessHourGenerator', ['?businessHours'], function (deps) {
            _this.businessHourGenerator = new BusinessHourGenerator_1.default(deps.businessHours, _this);
            if (_this.view) {
                _this.view.set('businessHourGenerator', _this.businessHourGenerator);
            }
        }, function () {
            _this.businessHourGenerator = null;
        });
        // called immediately, and upon option change.
        // HACK: locale often affects isRTL, so we explicitly listen to that too.
        this.optionsManager.watch('applyingDirClasses', ['?isRTL', '?locale'], function (opts) {
            dom_manip_1.forceClassName(el, 'fc-ltr', !opts.isRTL);
            dom_manip_1.forceClassName(el, 'fc-rtl', opts.isRTL);
        });
        dom_manip_1.prependToElement(el, this.contentEl = dom_manip_1.createElement('div', { className: 'fc-view-container' }));
        this.initToolbars();
        this.renderHeader();
        this.renderFooter();
        this.renderView(this.opt('defaultView'));
        if (this.opt('handleWindowResize')) {
            window.addEventListener('resize', this.windowResizeProxy = misc_1.debounce(// prevents rapid calls
            this.windowResize.bind(this), this.opt('windowResizeDelay')));
        }
        this.trigger('initialRender');
        Calendar.trigger('initialRender', this);
    };
    Calendar.prototype.destroy = function () {
        var wasRendered = Boolean(this.contentEl && this.contentEl.parentNode);
        if (this.view) {
            this.clearView();
        }
        this.toolbarsManager.proxyCall('removeElement');
        dom_manip_1.removeElement(this.contentEl);
        this.el.classList.remove('fc');
        this.el.classList.remove('fc-ltr');
        this.el.classList.remove('fc-rtl');
        // removes theme-related root className
        this.optionsManager.unwatch('settingTheme');
        this.optionsManager.unwatch('settingBusinessHourGenerator');
        if (this.removeNavLinkListener) {
            this.removeNavLinkListener();
            this.removeNavLinkListener = null;
        }
        if (this.windowResizeProxy) {
            window.removeEventListener('resize', this.windowResizeProxy);
            this.windowResizeProxy = null;
        }
        if (wasRendered) {
            GlobalEmitter_1.default.unneeded();
            this.trigger('destroy');
            Calendar.trigger('destroy', this);
        }
    };
    Calendar.prototype.elementVisible = function () {
        return Boolean(this.el.offsetWidth);
    };
    // Render Queue
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.bindViewHandlers = function (view) {
        var _this = this;
        view.watch('titleForCalendar', ['title'], function (deps) {
            if (view === _this.view) { // hack
                _this.setToolbarsTitle(deps.title);
            }
        });
        view.watch('dateProfileForCalendar', ['dateProfile'], function (deps) {
            if (view === _this.view) { // hack
                _this.currentDate = deps.dateProfile.date; // might have been constrained by view dates
                _this.updateToolbarButtons(deps.dateProfile);
            }
        });
    };
    Calendar.prototype.unbindViewHandlers = function (view) {
        view.unwatch('titleForCalendar');
        view.unwatch('dateProfileForCalendar');
    };
    // View Rendering
    // -----------------------------------------------------------------------------------
    // Renders a view because of a date change, view-type change, or for the first time.
    // If not given a viewType, keep the current view but render different dates.
    // Accepts an optional scroll state to restore to.
    Calendar.prototype.renderView = function (viewType) {
        var oldView = this.view;
        var newView;
        this.freezeContentHeight();
        if (oldView && viewType && oldView.type !== viewType) {
            this.clearView();
        }
        // if viewType changed, or the view was never created, create a fresh view
        if (!this.view && viewType) {
            newView = this.view =
                this.viewsByType[viewType] ||
                    (this.viewsByType[viewType] = this.instantiateView(viewType));
            this.bindViewHandlers(newView);
            newView.startBatchRender(); // so that setElement+setDate rendering are joined
            var viewEl = dom_manip_1.createElement('div', { className: 'fc-view fc-' + viewType + '-view' });
            this.contentEl.appendChild(viewEl);
            newView.setElement(viewEl);
            this.toolbarsManager.proxyCall('activateButton', viewType);
        }
        if (this.view) {
            // prevent unnecessary change firing
            if (this.view.get('businessHourGenerator') !== this.businessHourGenerator) {
                this.view.set('businessHourGenerator', this.businessHourGenerator);
            }
            this.view.setDate(this.currentDate);
            if (newView) {
                newView.stopBatchRender();
            }
        }
        this.thawContentHeight();
    };
    // Unrenders the current view and reflects this change in the Header.
    // Unregsiters the `view`, but does not remove from viewByType hash.
    Calendar.prototype.clearView = function () {
        var currentView = this.view;
        this.toolbarsManager.proxyCall('deactivateButton', currentView.type);
        this.unbindViewHandlers(currentView);
        currentView.removeElement();
        currentView.unsetDate(); // so bindViewHandlers doesn't fire with old values next time
        this.view = null;
    };
    // Destroys the view, including the view object. Then, re-instantiates it and renders it.
    // Maintains the same scroll state.
    // TODO: maintain any other user-manipulated state.
    Calendar.prototype.reinitView = function () {
        var oldView = this.view;
        var scroll = oldView.queryScroll(); // wouldn't be so complicated if Calendar owned the scroll
        this.freezeContentHeight();
        this.clearView();
        this.calcSize();
        this.renderView(oldView.type); // needs the type to freshly render
        this.view.applyScroll(scroll);
        this.thawContentHeight();
    };
    // Resizing
    // -----------------------------------------------------------------------------------
    Calendar.prototype.getSuggestedViewHeight = function () {
        if (this.suggestedViewHeight == null) {
            this.calcSize();
        }
        return this.suggestedViewHeight;
    };
    Calendar.prototype.isHeightAuto = function () {
        return this.opt('contentHeight') === 'auto' || this.opt('height') === 'auto';
    };
    Calendar.prototype.updateViewSize = function (isResize) {
        if (isResize === void 0) { isResize = false; }
        var view = this.view;
        var scroll;
        if (!this.ignoreUpdateViewSize && view) {
            if (isResize) {
                this.calcSize();
                scroll = view.queryScroll();
            }
            this.ignoreUpdateViewSize++;
            view.updateSize(this.getSuggestedViewHeight(), this.isHeightAuto(), isResize);
            this.ignoreUpdateViewSize--;
            if (isResize) {
                view.applyScroll(scroll);
            }
            return true; // signal success
        }
    };
    Calendar.prototype.calcSize = function () {
        if (this.elementVisible()) {
            this._calcSize();
        }
    };
    Calendar.prototype._calcSize = function () {
        var contentHeightInput = this.opt('contentHeight');
        var heightInput = this.opt('height');
        if (typeof contentHeightInput === 'number') { // exists and not 'auto'
            this.suggestedViewHeight = contentHeightInput;
        }
        else if (typeof contentHeightInput === 'function') { // exists and is a function
            this.suggestedViewHeight = contentHeightInput();
        }
        else if (typeof heightInput === 'number') { // exists and not 'auto'
            this.suggestedViewHeight = heightInput - this.queryToolbarsHeight();
        }
        else if (typeof heightInput === 'function') { // exists and is a function
            this.suggestedViewHeight = heightInput() - this.queryToolbarsHeight();
        }
        else if (heightInput === 'parent') { // set to height of parent element
            this.suggestedViewHeight = this.el.parentNode.offsetHeight - this.queryToolbarsHeight();
        }
        else {
            this.suggestedViewHeight = Math.round(this.contentEl.offsetWidth /
                Math.max(this.opt('aspectRatio'), .5));
        }
    };
    Calendar.prototype.windowResize = function (ev) {
        if (
        // the purpose: so we don't process jqui "resize" events that have bubbled up
        // cast to any because .target, which is Element, can't be compared to window for some reason.
        ev.target === window &&
            this.view &&
            this.view.isDatesRendered) {
            if (this.updateViewSize(true)) { // isResize=true, returns true on success
                this.publiclyTrigger('windowResize', [this.view]);
            }
        }
    };
    /* Height "Freezing"
    -----------------------------------------------------------------------------*/
    Calendar.prototype.freezeContentHeight = function () {
        if (!(this.freezeContentHeightDepth++)) {
            this.forceFreezeContentHeight();
        }
    };
    Calendar.prototype.forceFreezeContentHeight = function () {
        dom_manip_1.applyStyle(this.contentEl, {
            width: '100%',
            height: this.contentEl.offsetHeight,
            overflow: 'hidden'
        });
    };
    Calendar.prototype.thawContentHeight = function () {
        this.freezeContentHeightDepth--;
        // always bring back to natural height
        dom_manip_1.applyStyle(this.contentEl, {
            width: '',
            height: '',
            overflow: ''
        });
        // but if there are future thaws, re-freeze
        if (this.freezeContentHeightDepth) {
            this.forceFreezeContentHeight();
        }
    };
    // Toolbar
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initToolbars = function () {
        this.header = new Toolbar_1.default(this, this.computeHeaderOptions());
        this.footer = new Toolbar_1.default(this, this.computeFooterOptions());
        this.toolbarsManager = new Iterator_1.default([this.header, this.footer]);
    };
    Calendar.prototype.computeHeaderOptions = function () {
        return {
            extraClasses: 'fc-header-toolbar',
            layout: this.opt('header')
        };
    };
    Calendar.prototype.computeFooterOptions = function () {
        return {
            extraClasses: 'fc-footer-toolbar',
            layout: this.opt('footer')
        };
    };
    // can be called repeatedly and Header will rerender
    Calendar.prototype.renderHeader = function () {
        var header = this.header;
        header.setToolbarOptions(this.computeHeaderOptions());
        header.render();
        if (header.el) {
            dom_manip_1.prependToElement(this.el, header.el);
        }
    };
    // can be called repeatedly and Footer will rerender
    Calendar.prototype.renderFooter = function () {
        var footer = this.footer;
        footer.setToolbarOptions(this.computeFooterOptions());
        footer.render();
        if (footer.el) {
            this.el.appendChild(footer.el);
        }
    };
    Calendar.prototype.setToolbarsTitle = function (title) {
        this.toolbarsManager.proxyCall('updateTitle', title);
    };
    Calendar.prototype.updateToolbarButtons = function (dateProfile) {
        var now = this.getNow();
        var view = this.view;
        var todayInfo = view.dateProfileGenerator.build(now);
        var prevInfo = view.dateProfileGenerator.buildPrev(view.get('dateProfile'));
        var nextInfo = view.dateProfileGenerator.buildNext(view.get('dateProfile'));
        this.toolbarsManager.proxyCall((todayInfo.isValid && !dateProfile.currentUnzonedRange.containsDate(now)) ?
            'enableButton' :
            'disableButton', 'today');
        this.toolbarsManager.proxyCall(prevInfo.isValid ?
            'enableButton' :
            'disableButton', 'prev');
        this.toolbarsManager.proxyCall(nextInfo.isValid ?
            'enableButton' :
            'disableButton', 'next');
    };
    Calendar.prototype.queryToolbarsHeight = function () {
        return this.toolbarsManager.items.reduce(function (accumulator, toolbar) {
            var toolbarHeight = toolbar.el ?
                dom_geom_1.computeHeightAndMargins(toolbar.el) :
                0;
            return accumulator + toolbarHeight;
        }, 0);
    };
    // Selection
    // -----------------------------------------------------------------------------------------------------------------
    // this public method receives start/end dates in any format, with any timezone
    Calendar.prototype.select = function (zonedStartInput, zonedEndInput) {
        this.view.select(this.buildSelectFootprint.apply(this, arguments));
    };
    Calendar.prototype.unselect = function () {
        if (this.view) {
            this.view.unselect();
        }
    };
    // Given arguments to the select method in the API, returns a span (unzoned start/end and other info)
    Calendar.prototype.buildSelectFootprint = function (zonedStartInput, zonedEndInput) {
        var start = this.moment(zonedStartInput).stripZone();
        var end;
        if (zonedEndInput) {
            end = this.moment(zonedEndInput).stripZone();
        }
        else if (start.hasTime()) {
            end = start.clone().add(this.defaultTimedEventDuration);
        }
        else {
            end = start.clone().add(this.defaultAllDayEventDuration);
        }
        return new ComponentFootprint_1.default(new UnzonedRange_1.default(start, end), !start.hasTime());
    };
    // External Dragging
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.handlExternalDragStart = function (ev, el, skipBinding) {
        if (this.view) {
            this.view.handlExternalDragStart(ev, el, skipBinding);
        }
    };
    Calendar.prototype.handleExternalDragMove = function (ev) {
        if (this.view) {
            this.view.handleExternalDragMove(ev);
        }
    };
    Calendar.prototype.handleExternalDragStop = function (ev) {
        if (this.view) {
            this.view.handleExternalDragStop(ev);
        }
    };
    // Date Utils
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initMomentInternals = function () {
        var _this = this;
        this.defaultAllDayEventDuration = moment.duration(this.opt('defaultAllDayEventDuration'));
        this.defaultTimedEventDuration = moment.duration(this.opt('defaultTimedEventDuration'));
        // Called immediately, and when any of the options change.
        // Happens before any internal objects rebuild or rerender, because this is very core.
        this.optionsManager.watch('buildingMomentLocale', [
            '?locale', '?monthNames', '?monthNamesShort', '?dayNames', '?dayNamesShort',
            '?firstDay', '?weekNumberCalculation'
        ], function (opts) {
            var weekNumberCalculation = opts.weekNumberCalculation;
            var firstDay = opts.firstDay;
            var _week;
            // normalize
            if (weekNumberCalculation === 'iso') {
                weekNumberCalculation = 'ISO'; // normalize
            }
            var localeData = Object.create(// make a cheap copy
            locale_1.getMomentLocaleData(opts.locale) // will fall back to en
            );
            if (opts.monthNames) {
                localeData._months = opts.monthNames;
            }
            if (opts.monthNamesShort) {
                localeData._monthsShort = opts.monthNamesShort;
            }
            if (opts.dayNames) {
                localeData._weekdays = opts.dayNames;
            }
            if (opts.dayNamesShort) {
                localeData._weekdaysShort = opts.dayNamesShort;
            }
            if (firstDay == null && weekNumberCalculation === 'ISO') {
                firstDay = 1;
            }
            if (firstDay != null) {
                _week = Object.create(localeData._week); // _week: { dow: # }
                _week.dow = firstDay;
                localeData._week = _week;
            }
            if ( // whitelist certain kinds of input
            weekNumberCalculation === 'ISO' ||
                weekNumberCalculation === 'local' ||
                typeof weekNumberCalculation === 'function') {
                localeData._fullCalendar_weekCalc = weekNumberCalculation; // moment-ext will know what to do with it
            }
            _this.localeData = localeData;
            // If the internal current date object already exists, move to new locale.
            // We do NOT need to do this technique for event dates, because this happens when converting to "segments".
            if (_this.currentDate) {
                _this.localizeMoment(_this.currentDate); // sets to localeData
            }
        });
    };
    // Builds a moment using the settings of the current calendar: timezone and locale.
    // Accepts anything the vanilla moment() constructor accepts.
    Calendar.prototype.moment = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var mom;
        if (this.opt('timezone') === 'local') {
            mom = moment_ext_1.default.apply(null, args);
            // Force the moment to be local, because momentExt doesn't guarantee it.
            if (mom.hasTime()) { // don't give ambiguously-timed moments a local zone
                mom.local();
            }
        }
        else if (this.opt('timezone') === 'UTC') {
            mom = moment_ext_1.default.utc.apply(null, args); // process as UTC
        }
        else {
            mom = moment_ext_1.default.parseZone.apply(null, args); // let the input decide the zone
        }
        this.localizeMoment(mom); // TODO
        return mom;
    };
    Calendar.prototype.msToMoment = function (ms, forceAllDay) {
        var mom = moment_ext_1.default.utc(ms); // TODO: optimize by using Date.UTC
        if (forceAllDay) {
            mom.stripTime();
        }
        else {
            mom = this.applyTimezone(mom); // may or may not apply locale
        }
        this.localizeMoment(mom);
        return mom;
    };
    Calendar.prototype.msToUtcMoment = function (ms, forceAllDay) {
        var mom = moment_ext_1.default.utc(ms); // TODO: optimize by using Date.UTC
        if (forceAllDay) {
            mom.stripTime();
        }
        this.localizeMoment(mom);
        return mom;
    };
    // Updates the given moment's locale settings to the current calendar locale settings.
    Calendar.prototype.localizeMoment = function (mom) {
        mom._locale = this.localeData;
    };
    // Returns a boolean about whether or not the calendar knows how to calculate
    // the timezone offset of arbitrary dates in the current timezone.
    Calendar.prototype.getIsAmbigTimezone = function () {
        return this.opt('timezone') !== 'local' && this.opt('timezone') !== 'UTC';
    };
    // Returns a copy of the given date in the current timezone. Has no effect on dates without times.
    Calendar.prototype.applyTimezone = function (date) {
        if (!date.hasTime()) {
            return date.clone();
        }
        var zonedDate = this.moment(date.toArray());
        var timeAdjust = date.time().asMilliseconds() - zonedDate.time().asMilliseconds();
        var adjustedZonedDate;
        // Safari sometimes has problems with this coersion when near DST. Adjust if necessary. (bug #2396)
        if (timeAdjust) { // is the time result different than expected?
            adjustedZonedDate = zonedDate.clone().add(timeAdjust); // add milliseconds
            if (date.time().asMilliseconds() - adjustedZonedDate.time().asMilliseconds() === 0) { // does it match perfectly now?
                zonedDate = adjustedZonedDate;
            }
        }
        return zonedDate;
    };
    /*
    Assumes the footprint is non-open-ended.
    */
    Calendar.prototype.footprintToDateProfile = function (componentFootprint, ignoreEnd) {
        if (ignoreEnd === void 0) { ignoreEnd = false; }
        var start = moment_ext_1.default.utc(componentFootprint.unzonedRange.startMs);
        var end;
        if (!ignoreEnd) {
            end = moment_ext_1.default.utc(componentFootprint.unzonedRange.endMs);
        }
        if (componentFootprint.isAllDay) {
            start.stripTime();
            if (end) {
                end.stripTime();
            }
        }
        else {
            start = this.applyTimezone(start);
            if (end) {
                end = this.applyTimezone(end);
            }
        }
        return new EventDateProfile_1.default(start, end, this);
    };
    // Returns a moment for the current date, as defined by the client's computer or from the `now` option.
    // Will return an moment with an ambiguous timezone.
    Calendar.prototype.getNow = function () {
        var now = this.opt('now');
        if (typeof now === 'function') {
            now = now();
        }
        return this.moment(now).stripZone();
    };
    // Produces a human-readable string for the given duration.
    // Side-effect: changes the locale of the given duration.
    Calendar.prototype.humanizeDuration = function (duration) {
        return duration.locale(this.opt('locale')).humanize();
    };
    // will return `null` if invalid range
    Calendar.prototype.parseUnzonedRange = function (rangeInput) {
        var start = null;
        var end = null;
        if (rangeInput.start) {
            start = this.moment(rangeInput.start).stripZone();
        }
        if (rangeInput.end) {
            end = this.moment(rangeInput.end).stripZone();
        }
        if (!start && !end) {
            return null;
        }
        if (start && end && end.isBefore(start)) {
            return null;
        }
        return new UnzonedRange_1.default(start, end);
    };
    // Event-Date Utilities
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.initEventManager = function () {
        var _this = this;
        var eventManager = new EventManager_1.default(this);
        var rawSources = this.opt('eventSources') || [];
        var singleRawSource = this.opt('events');
        this.eventManager = eventManager;
        if (singleRawSource) {
            rawSources.unshift(singleRawSource);
        }
        eventManager.on('release', function (eventsPayload) {
            _this.trigger('eventsReset', eventsPayload);
        });
        eventManager.freeze();
        rawSources.forEach(function (rawSource) {
            var source = EventSourceParser_1.default.parse(rawSource, _this);
            if (source) {
                eventManager.addSource(source);
            }
        });
        eventManager.thaw();
    };
    Calendar.prototype.requestEvents = function (start, end, callback) {
        return this.eventManager.requestEvents(start, end, this.opt('timezone'), !this.opt('lazyFetching'), callback);
    };
    // Get an event's normalized end date. If not present, calculate it from the defaults.
    Calendar.prototype.getEventEnd = function (event) {
        if (event.end) {
            return event.end.clone();
        }
        else {
            return this.getDefaultEventEnd(event.allDay, event.start);
        }
    };
    // Given an event's allDay status and start date, return what its fallback end date should be.
    // TODO: rename to computeDefaultEventEnd
    Calendar.prototype.getDefaultEventEnd = function (allDay, zonedStart) {
        var end = zonedStart.clone();
        if (allDay) {
            end.stripTime().add(this.defaultAllDayEventDuration);
        }
        else {
            end.add(this.defaultTimedEventDuration);
        }
        if (this.getIsAmbigTimezone()) {
            end.stripZone(); // we don't know what the tzo should be
        }
        return end;
    };
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    Calendar.prototype.rerenderEvents = function () {
        this.view.flash('displayingEvents');
    };
    Calendar.prototype.refetchEvents = function () {
        this.eventManager.refetchAllSources();
    };
    Calendar.prototype.renderEvents = function (eventInputs, isSticky) {
        this.eventManager.freeze();
        for (var i = 0; i < eventInputs.length; i++) {
            this.renderEvent(eventInputs[i], isSticky);
        }
        this.eventManager.thaw();
    };
    Calendar.prototype.renderEvent = function (eventInput, isSticky) {
        if (isSticky === void 0) { isSticky = false; }
        var eventManager = this.eventManager;
        var eventDef = EventDefParser_1.default.parse(eventInput, eventInput.source || eventManager.stickySource);
        if (eventDef) {
            eventManager.addEventDef(eventDef, isSticky);
        }
    };
    // legacyQuery operates on legacy event instance objects
    Calendar.prototype.removeEvents = function (legacyQuery) {
        var eventManager = this.eventManager;
        var legacyInstances = [];
        var idMap = {};
        var eventDef;
        var i;
        if (legacyQuery == null) { // shortcut for removing all
            eventManager.removeAllEventDefs(); // persist=true
        }
        else {
            eventManager.getEventInstances().forEach(function (eventInstance) {
                legacyInstances.push(eventInstance.toLegacy());
            });
            legacyInstances = filterLegacyEventInstances(legacyInstances, legacyQuery);
            // compute unique IDs
            for (i = 0; i < legacyInstances.length; i++) {
                eventDef = this.eventManager.getEventDefByUid(legacyInstances[i]._id);
                idMap[eventDef.id] = true;
            }
            eventManager.freeze();
            for (i in idMap) { // reuse `i` as an "id"
                eventManager.removeEventDefsById(i); // persist=true
            }
            eventManager.thaw();
        }
    };
    // legacyQuery operates on legacy event instance objects
    Calendar.prototype.clientEvents = function (legacyQuery) {
        var legacyEventInstances = [];
        this.eventManager.getEventInstances().forEach(function (eventInstance) {
            legacyEventInstances.push(eventInstance.toLegacy());
        });
        return filterLegacyEventInstances(legacyEventInstances, legacyQuery);
    };
    Calendar.prototype.updateEvents = function (eventPropsArray) {
        this.eventManager.freeze();
        for (var i = 0; i < eventPropsArray.length; i++) {
            this.updateEvent(eventPropsArray[i]);
        }
        this.eventManager.thaw();
    };
    Calendar.prototype.updateEvent = function (eventProps) {
        var eventDef = this.eventManager.getEventDefByUid(eventProps._id);
        var eventInstance;
        var eventDefMutation;
        if (eventDef instanceof SingleEventDef_1.default) {
            eventInstance = eventDef.buildInstance();
            eventDefMutation = EventDefMutation_1.default.createFromRawProps(eventInstance, eventProps, // raw props
            null // largeUnit -- who uses it?
            );
            this.eventManager.mutateEventsWithId(eventDef.id, eventDefMutation); // will release
        }
    };
    // Public Event Sources API
    // ------------------------------------------------------------------------------------
    Calendar.prototype.getEventSources = function () {
        return this.eventManager.otherSources.slice(); // clone
    };
    Calendar.prototype.getEventSourceById = function (id) {
        return this.eventManager.getSourceById(EventSource_1.default.normalizeId(id));
    };
    Calendar.prototype.addEventSource = function (sourceInput) {
        var source = EventSourceParser_1.default.parse(sourceInput, this);
        if (source) {
            this.eventManager.addSource(source);
        }
    };
    Calendar.prototype.removeEventSources = function (sourceMultiQuery) {
        var eventManager = this.eventManager;
        var sources;
        var i;
        if (sourceMultiQuery == null) {
            this.eventManager.removeAllSources();
        }
        else {
            sources = eventManager.multiQuerySources(sourceMultiQuery);
            eventManager.freeze();
            for (i = 0; i < sources.length; i++) {
                eventManager.removeSource(sources[i]);
            }
            eventManager.thaw();
        }
    };
    Calendar.prototype.removeEventSource = function (sourceQuery) {
        var eventManager = this.eventManager;
        var sources = eventManager.querySources(sourceQuery);
        var i;
        eventManager.freeze();
        for (i = 0; i < sources.length; i++) {
            eventManager.removeSource(sources[i]);
        }
        eventManager.thaw();
    };
    Calendar.prototype.refetchEventSources = function (sourceMultiQuery) {
        var eventManager = this.eventManager;
        var sources = eventManager.multiQuerySources(sourceMultiQuery);
        var i;
        eventManager.freeze();
        for (i = 0; i < sources.length; i++) {
            eventManager.refetchSource(sources[i]);
        }
        eventManager.thaw();
    };
    // not for internal use. use options module directly instead.
    Calendar.defaults = options_1.globalDefaults;
    Calendar.englishDefaults = options_1.englishDefaults;
    Calendar.rtlDefaults = options_1.rtlDefaults;
    return Calendar;
}());
exports.default = Calendar;
EmitterMixin_1.default.mixIntoObj(Calendar); // for global registry
EmitterMixin_1.default.mixInto(Calendar);
ListenerMixin_1.default.mixInto(Calendar);
function filterLegacyEventInstances(legacyEventInstances, legacyQuery) {
    if (legacyQuery == null) {
        return legacyEventInstances;
    }
    else if (typeof legacyQuery === 'function') {
        return legacyEventInstances.filter(legacyQuery);
    }
    else { // an event ID
        legacyQuery += ''; // normalize to string
        return legacyEventInstances.filter(function (legacyEventInstance) {
            // soft comparison because id not be normalized to string
            // tslint:disable-next-line
            return legacyEventInstance.id == legacyQuery ||
                legacyEventInstance._id === legacyQuery; // can specify internal id, but must exactly match
        });
    }
}


/***/ }),
/* 247 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", { value: true });
var Iterator = /** @class */ (function () {
    function Iterator(items) {
        this.items = items || [];
    }
    /* Calls a method on every item passing the arguments through */
    Iterator.prototype.proxyCall = function (methodName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var results = [];
        this.items.forEach(function (item) {
            results.push(item[methodName].apply(item, args));
        });
        return results;
    };
    return Iterator;
}());
exports.default = Iterator;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(6);
var dom_manip_1 = __webpack_require__(3);
/* Toolbar with buttons and title
----------------------------------------------------------------------------------------------------------------------*/
var Toolbar = /** @class */ (function () {
    function Toolbar(calendar, toolbarOptions) {
        this.el = null; // mirrors local `el`
        this.viewsWithButtons = [];
        this.calendar = calendar;
        this.toolbarOptions = toolbarOptions;
    }
    // method to update toolbar-specific options, not calendar-wide options
    Toolbar.prototype.setToolbarOptions = function (newToolbarOptions) {
        this.toolbarOptions = newToolbarOptions;
    };
    // can be called repeatedly and will rerender
    Toolbar.prototype.render = function () {
        var sections = this.toolbarOptions.layout;
        var el = this.el;
        if (sections) {
            if (!el) {
                el = this.el = dom_manip_1.createElement('div', { className: 'fc-toolbar ' + this.toolbarOptions.extraClasses });
            }
            else {
                el.innerHTML = '';
            }
            dom_manip_1.appendToElement(el, this.renderSection('left'));
            dom_manip_1.appendToElement(el, this.renderSection('right'));
            dom_manip_1.appendToElement(el, this.renderSection('center'));
            dom_manip_1.appendToElement(el, '<div class="fc-clear"></div>');
        }
        else {
            this.removeElement();
        }
    };
    Toolbar.prototype.removeElement = function () {
        if (this.el) {
            dom_manip_1.removeElement(this.el);
            this.el = null;
        }
    };
    Toolbar.prototype.renderSection = function (position) {
        var _this = this;
        var calendar = this.calendar;
        var theme = calendar.theme;
        var optionsManager = calendar.optionsManager;
        var viewSpecManager = calendar.viewSpecManager;
        var sectionEl = dom_manip_1.createElement('div', { className: 'fc-' + position });
        var buttonStr = this.toolbarOptions.layout[position];
        var calendarCustomButtons = optionsManager.get('customButtons') || {};
        var calendarButtonTextOverrides = optionsManager.overrides.buttonText || {};
        var calendarButtonText = optionsManager.get('buttonText') || {};
        if (buttonStr) {
            buttonStr.split(' ').forEach(function (buttonGroupStr, i) {
                var groupChildren = [];
                var isOnlyButtons = true;
                var groupEl;
                buttonGroupStr.split(',').forEach(function (buttonName, j) {
                    var customButtonProps;
                    var viewSpec;
                    var buttonClick;
                    var buttonIcon; // only one of these will be set
                    var buttonText; // "
                    var buttonInnerHtml;
                    var buttonClasses;
                    var buttonEl;
                    var buttonAriaAttr;
                    if (buttonName === 'title') {
                        groupChildren.push(dom_manip_1.htmlToElement('<h2>&nbsp;</h2>')); // we always want it to take up height
                        isOnlyButtons = false;
                    }
                    else {
                        if ((customButtonProps = calendarCustomButtons[buttonName])) {
                            buttonClick = function (ev) {
                                if (customButtonProps.click) {
                                    customButtonProps.click.call(buttonEl, ev);
                                }
                            };
                            (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) ||
                                (buttonIcon = theme.getIconClass(buttonName)) ||
                                (buttonText = customButtonProps.text);
                        }
                        else if ((viewSpec = viewSpecManager.getViewSpec(buttonName))) {
                            _this.viewsWithButtons.push(buttonName);
                            buttonClick = function () {
                                calendar.changeView(buttonName);
                            };
                            (buttonText = viewSpec.buttonTextOverride) ||
                                (buttonIcon = theme.getIconClass(buttonName)) ||
                                (buttonText = viewSpec.buttonTextDefault);
                        }
                        else if (calendar[buttonName]) { // a calendar method
                            buttonClick = function () {
                                calendar[buttonName]();
                            };
                            (buttonText = calendarButtonTextOverrides[buttonName]) ||
                                (buttonIcon = theme.getIconClass(buttonName)) ||
                                (buttonText = calendarButtonText[buttonName]);
                            //            ^ everything else is considered default
                        }
                        if (buttonClick) {
                            buttonClasses = [
                                'fc-' + buttonName + '-button',
                                theme.getClass('button'),
                                theme.getClass('stateDefault')
                            ];
                            if (buttonText) {
                                buttonInnerHtml = html_1.htmlEscape(buttonText);
                                buttonAriaAttr = '';
                            }
                            else if (buttonIcon) {
                                buttonInnerHtml = "<span class='" + buttonIcon + "'></span>";
                                buttonAriaAttr = ' aria-label="' + buttonName + '"';
                            }
                            buttonEl = dom_manip_1.htmlToElement(// type="button" so that it doesn't submit a form
                            '<button type="button" class="' + buttonClasses.join(' ') + '"' +
                                buttonAriaAttr +
                                '>' + buttonInnerHtml + '</button>');
                            var allowInteraction_1 = function () {
                                var activeClassName = theme.getClass('stateActive');
                                var disabledClassName = theme.getClass('stateDisabled');
                                return (!activeClassName || !buttonEl.classList.contains(activeClassName)) &&
                                    (!disabledClassName || !buttonEl.classList.contains(disabledClassName));
                            };
                            buttonEl.addEventListener('click', function (ev) {
                                var disabledClassName = theme.getClass('stateDisabled');
                                var hoverClassName = theme.getClass('stateHover');
                                // don't process clicks for disabled buttons
                                if (!disabledClassName || !buttonEl.classList.contains(disabledClassName)) {
                                    buttonClick(ev);
                                    // after the click action, if the button becomes the "active" tab, or disabled,
                                    // it should never have a hover class, so remove it now.
                                    if (!allowInteraction_1() && hoverClassName) {
                                        buttonEl.classList.remove(hoverClassName);
                                    }
                                }
                            });
                            buttonEl.addEventListener('mousedown', function (ev) {
                                var downClassName = theme.getClass('stateDown');
                                // the *down* effect (mouse pressed in).
                                // only on buttons that are not the "active" tab, or disabled
                                if (allowInteraction_1() && downClassName) {
                                    buttonEl.classList.add(downClassName);
                                }
                            });
                            buttonEl.addEventListener('mouseup', function (ev) {
                                var downClassName = theme.getClass('stateDown');
                                // undo the *down* effect
                                if (downClassName) {
                                    buttonEl.classList.remove(downClassName);
                                }
                            });
                            buttonEl.addEventListener('mouseenter', function (ev) {
                                var hoverClassName = theme.getClass('stateHover');
                                // the *hover* effect.
                                // only on buttons that are not the "active" tab, or disabled
                                if (allowInteraction_1() && hoverClassName) {
                                    buttonEl.classList.add(hoverClassName);
                                }
                            });
                            buttonEl.addEventListener('mouseleave', function (ev) {
                                var hoverClassName = theme.getClass('stateHover');
                                var downClassName = theme.getClass('stateDown');
                                // undo the *hover* effect
                                if (hoverClassName) {
                                    buttonEl.classList.remove(hoverClassName);
                                }
                                if (downClassName) {
                                    buttonEl.classList.remove(downClassName); // if mouseleave happens before mouseup
                                }
                            });
                            groupChildren.push(buttonEl);
                        }
                    }
                });
                if (isOnlyButtons && groupChildren.length > 0) {
                    var cornerLeftClassName = theme.getClass('cornerLeft');
                    var cornerRightClassName = theme.getClass('cornerRight');
                    if (cornerLeftClassName) {
                        groupChildren[0].classList.add(cornerLeftClassName);
                    }
                    if (cornerRightClassName) {
                        groupChildren[groupChildren.length - 1].classList.add(cornerRightClassName);
                    }
                }
                if (groupChildren.length > 1) {
                    groupEl = document.createElement('div');
                    var buttonGroupClassName = theme.getClass('buttonGroup');
                    if (isOnlyButtons && buttonGroupClassName) {
                        groupEl.classList.add(buttonGroupClassName);
                    }
                    dom_manip_1.appendToElement(groupEl, groupChildren);
                    sectionEl.appendChild(groupEl);
                }
                else {
                    dom_manip_1.appendToElement(sectionEl, groupChildren); // 1 or 0 children
                }
            });
        }
        return sectionEl;
    };
    Toolbar.prototype.updateTitle = function (text) {
        if (this.el) {
            dom_manip_1.findElements(this.el, 'h2').forEach(function (titleEl) {
                titleEl.innerText = text;
            });
        }
    };
    Toolbar.prototype.activateButton = function (buttonName) {
        var _this = this;
        if (this.el) {
            dom_manip_1.findElements(this.el, '.fc-' + buttonName + '-button').forEach(function (buttonEl) {
                buttonEl.classList.add(_this.calendar.theme.getClass('stateActive'));
            });
        }
    };
    Toolbar.prototype.deactivateButton = function (buttonName) {
        var _this = this;
        if (this.el) {
            dom_manip_1.findElements(this.el, '.fc-' + buttonName + '-button').forEach(function (buttonEl) {
                buttonEl.classList.remove(_this.calendar.theme.getClass('stateActive'));
            });
        }
    };
    Toolbar.prototype.disableButton = function (buttonName) {
        var _this = this;
        if (this.el) {
            dom_manip_1.findElements(this.el, '.fc-' + buttonName + '-button').forEach(function (buttonEl) {
                buttonEl.disabled = true;
                buttonEl.classList.add(_this.calendar.theme.getClass('stateDisabled'));
            });
        }
    };
    Toolbar.prototype.enableButton = function (buttonName) {
        var _this = this;
        if (this.el) {
            dom_manip_1.findElements(this.el, '.fc-' + buttonName + '-button').forEach(function (buttonEl) {
                buttonEl.disabled = false;
                buttonEl.classList.remove(_this.calendar.theme.getClass('stateDisabled'));
            });
        }
    };
    Toolbar.prototype.getViewsWithButtons = function () {
        return this.viewsWithButtons;
    };
    return Toolbar;
}());
exports.default = Toolbar;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var object_1 = __webpack_require__(5);
var misc_1 = __webpack_require__(4);
var options_1 = __webpack_require__(37);
var locale_1 = __webpack_require__(36);
var Model_1 = __webpack_require__(53);
var OptionsManager = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsManager, _super);
    function OptionsManager(_calendar, overrides) {
        var _this = _super.call(this) || this;
        _this._calendar = _calendar;
        _this.overrides = object_1.assignTo({}, overrides); // make a copy
        _this.dynamicOverrides = {};
        _this.compute();
        return _this;
    }
    OptionsManager.prototype.add = function (newOptionHash) {
        var optionCnt = 0;
        var optionName;
        this.recordOverrides(newOptionHash); // will trigger this model's watchers
        for (optionName in newOptionHash) {
            optionCnt++;
        }
        // special-case handling of single option change.
        // if only one option change, `optionName` will be its name.
        if (optionCnt === 1) {
            if (optionName === 'height' || optionName === 'contentHeight' || optionName === 'aspectRatio') {
                this._calendar.updateViewSize(true); // isResize=true
                return;
            }
            else if (optionName === 'defaultDate') {
                return; // can't change date this way. use gotoDate instead
            }
            else if (optionName === 'businessHours') {
                return; // this model already reacts to this
            }
            else if (/^(event|select)(Overlap|Constraint|Allow)$/.test(optionName)) {
                return; // doesn't affect rendering. only interactions.
            }
            else if (optionName === 'timezone') {
                this._calendar.view.flash('initialEvents');
                return;
            }
        }
        // catch-all. rerender the header and footer and rebuild/rerender the current view
        this._calendar.renderHeader();
        this._calendar.renderFooter();
        // even non-current views will be affected by this option change. do before rerender
        // TODO: detangle
        this._calendar.viewsByType = {};
        this._calendar.reinitView();
    };
    // Computes the flattened options hash for the calendar and assigns to `this.options`.
    // Assumes this.overrides and this.dynamicOverrides have already been initialized.
    OptionsManager.prototype.compute = function () {
        var locale;
        var localeDefaults;
        var isRTL;
        var dirDefaults;
        var rawOptions;
        locale = misc_1.firstDefined(// explicit locale option given?
        this.dynamicOverrides.locale, this.overrides.locale);
        localeDefaults = locale_1.localeOptionHash[locale];
        if (!localeDefaults) { // explicit locale option not given or invalid?
            locale = options_1.globalDefaults.locale;
            localeDefaults = locale_1.localeOptionHash[locale] || {};
        }
        isRTL = misc_1.firstDefined(// based on options computed so far, is direction RTL?
        this.dynamicOverrides.isRTL, this.overrides.isRTL, localeDefaults.isRTL, options_1.globalDefaults.isRTL);
        dirDefaults = isRTL ? options_1.rtlDefaults : {};
        this.dirDefaults = dirDefaults;
        this.localeDefaults = localeDefaults;
        rawOptions = options_1.mergeOptions([
            options_1.globalDefaults,
            dirDefaults,
            localeDefaults,
            this.overrides,
            this.dynamicOverrides
        ]);
        locale_1.populateInstanceComputableOptions(rawOptions); // fill in gaps with computed options
        this.reset(rawOptions);
    };
    // stores the new options internally, but does not rerender anything.
    OptionsManager.prototype.recordOverrides = function (newOptionHash) {
        var optionName;
        for (optionName in newOptionHash) {
            this.dynamicOverrides[optionName] = newOptionHash[optionName];
        }
        this._calendar.viewSpecManager.clearCache(); // the dynamic override invalidates the options in this cache, so just clear it
        this.compute(); // this.options needs to be recomputed after the dynamic override
    };
    return OptionsManager;
}(Model_1.default));
exports.default = OptionsManager;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(0);
var ViewRegistry_1 = __webpack_require__(26);
var object_1 = __webpack_require__(5);
var date_1 = __webpack_require__(8);
var options_1 = __webpack_require__(37);
var locale_1 = __webpack_require__(36);
var ViewSpecManager = /** @class */ (function () {
    function ViewSpecManager(optionsManager, _calendar) {
        this.optionsManager = optionsManager;
        this._calendar = _calendar;
        this.clearCache();
    }
    ViewSpecManager.prototype.clearCache = function () {
        this.viewSpecCache = {};
    };
    // Gets information about how to create a view. Will use a cache.
    ViewSpecManager.prototype.getViewSpec = function (viewType) {
        var cache = this.viewSpecCache;
        return cache[viewType] || (cache[viewType] = this.buildViewSpec(viewType));
    };
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    ViewSpecManager.prototype.getUnitViewSpec = function (unit) {
        var viewTypes;
        var i;
        var spec;
        if (date_1.unitsDesc.indexOf(unit) !== -1) {
            // put views that have buttons first. there will be duplicates, but oh well
            viewTypes = this._calendar.header.getViewsWithButtons(); // TODO: include footer as well?
            for (var viewType in ViewRegistry_1.viewHash) {
                viewTypes.push(viewType);
            }
            for (i = 0; i < viewTypes.length; i++) {
                spec = this.getViewSpec(viewTypes[i]);
                if (spec) {
                    if (spec.singleUnit === unit) {
                        return spec;
                    }
                }
            }
        }
    };
    // Builds an object with information on how to create a given view
    ViewSpecManager.prototype.buildViewSpec = function (requestedViewType) {
        var viewOverrides = this.optionsManager.overrides.views || {};
        var specChain = []; // for the view. lowest to highest priority
        var defaultsChain = []; // for the view. lowest to highest priority
        var overridesChain = []; // for the view. lowest to highest priority
        var viewType = requestedViewType;
        var spec; // for the view
        var overrides; // for the view
        var durationInput;
        var duration;
        var unit;
        // iterate from the specific view definition to a more general one until we hit an actual View class
        while (viewType) {
            spec = ViewRegistry_1.viewHash[viewType];
            overrides = viewOverrides[viewType];
            viewType = null; // clear. might repopulate for another iteration
            if (typeof spec === 'function') { // TODO: deprecate
                spec = { 'class': spec };
            }
            if (spec) {
                specChain.unshift(spec);
                defaultsChain.unshift(spec.defaults || {});
                durationInput = durationInput || spec.duration;
                viewType = viewType || spec.type;
            }
            if (overrides) {
                overridesChain.unshift(overrides); // view-specific option hashes have options at zero-level
                durationInput = durationInput || overrides.duration;
                viewType = viewType || overrides.type;
            }
        }
        spec = object_1.mergeProps(specChain);
        spec.type = requestedViewType;
        if (!spec['class']) {
            return false;
        }
        // fall back to top-level `duration` option
        durationInput = durationInput ||
            this.optionsManager.dynamicOverrides.duration ||
            this.optionsManager.overrides.duration;
        if (durationInput) {
            duration = moment.duration(durationInput);
            if (duration.valueOf()) { // valid?
                unit = date_1.computeDurationGreatestUnit(duration, durationInput);
                spec.duration = duration;
                spec.durationUnit = unit;
                // view is a single-unit duration, like "week" or "day"
                // incorporate options for this. lowest priority
                if (duration.as(unit) === 1) {
                    spec.singleUnit = unit;
                    overridesChain.unshift(viewOverrides[unit] || {});
                }
            }
        }
        spec.defaults = options_1.mergeOptions(defaultsChain);
        spec.overrides = options_1.mergeOptions(overridesChain);
        this.buildViewSpecOptions(spec);
        this.buildViewSpecButtonText(spec, requestedViewType);
        return spec;
    };
    // Builds and assigns a view spec's options object from its already-assigned defaults and overrides
    ViewSpecManager.prototype.buildViewSpecOptions = function (spec) {
        var optionsManager = this.optionsManager;
        spec.options = options_1.mergeOptions([
            options_1.globalDefaults,
            spec.defaults,
            optionsManager.dirDefaults,
            optionsManager.localeDefaults,
            optionsManager.overrides,
            spec.overrides,
            optionsManager.dynamicOverrides // dynamically set via setter. highest precedence
        ]);
        locale_1.populateInstanceComputableOptions(spec.options);
    };
    // Computes and assigns a view spec's buttonText-related options
    ViewSpecManager.prototype.buildViewSpecButtonText = function (spec, requestedViewType) {
        var optionsManager = this.optionsManager;
        // given an options object with a possible `buttonText` hash, lookup the buttonText for the
        // requested view, falling back to a generic unit entry like "week" or "day"
        function queryButtonText(options) {
            var buttonText = options.buttonText || {};
            return buttonText[requestedViewType] ||
                // view can decide to look up a certain key
                (spec.buttonTextKey ? buttonText[spec.buttonTextKey] : null) ||
                // a key like "month"
                (spec.singleUnit ? buttonText[spec.singleUnit] : null);
        }
        // highest to lowest priority
        spec.buttonTextOverride =
            queryButtonText(optionsManager.dynamicOverrides) ||
                queryButtonText(optionsManager.overrides) || // constructor-specified buttonText lookup hash takes precedence
                spec.overrides.buttonText; // `buttonText` for view-specific options is a string
        // highest to lowest priority. mirrors buildViewSpecOptions
        spec.buttonTextDefault =
            queryButtonText(optionsManager.localeDefaults) ||
                queryButtonText(optionsManager.dirDefaults) ||
                spec.defaults.buttonText || // a single string. from ViewSubclass.defaults
                queryButtonText(options_1.globalDefaults) ||
                (spec.duration ? this._calendar.humanizeDuration(spec.duration) : null) || // like "3 days"
                requestedViewType; // fall back to given view name
    };
    return ViewSpecManager;
}());
exports.default = ViewSpecManager;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var array_1 = __webpack_require__(21);
var EventPeriod_1 = __webpack_require__(252);
var ArrayEventSource_1 = __webpack_require__(57);
var EventSource_1 = __webpack_require__(9);
var EventSourceParser_1 = __webpack_require__(43);
var SingleEventDef_1 = __webpack_require__(17);
var EventInstanceGroup_1 = __webpack_require__(23);
var EmitterMixin_1 = __webpack_require__(15);
var ListenerMixin_1 = __webpack_require__(12);
var EventManager = /** @class */ (function () {
    function EventManager(calendar) {
        this.calendar = calendar;
        this.stickySource = new ArrayEventSource_1.default(calendar);
        this.otherSources = [];
    }
    EventManager.prototype.requestEvents = function (start, end, timezone, force, callback) {
        if (force ||
            !this.currentPeriod ||
            !this.currentPeriod.isWithinRange(start, end) ||
            timezone !== this.currentPeriod.timezone) {
            this.setPeriod(// will change this.currentPeriod
            new EventPeriod_1.default(start, end, timezone));
        }
        this.currentPeriod.whenReleased(callback);
    };
    // Source Adding/Removing
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.addSource = function (eventSource) {
        this.otherSources.push(eventSource);
        if (this.currentPeriod) {
            this.currentPeriod.requestSource(eventSource); // might release
        }
    };
    EventManager.prototype.removeSource = function (doomedSource) {
        array_1.removeExact(this.otherSources, doomedSource);
        if (this.currentPeriod) {
            this.currentPeriod.purgeSource(doomedSource); // might release
        }
    };
    EventManager.prototype.removeAllSources = function () {
        this.otherSources = [];
        if (this.currentPeriod) {
            this.currentPeriod.purgeAllSources(); // might release
        }
    };
    // Source Refetching
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.refetchSource = function (eventSource) {
        var currentPeriod = this.currentPeriod;
        if (currentPeriod) {
            currentPeriod.freeze();
            currentPeriod.purgeSource(eventSource);
            currentPeriod.requestSource(eventSource);
            currentPeriod.thaw();
        }
    };
    EventManager.prototype.refetchAllSources = function () {
        var currentPeriod = this.currentPeriod;
        if (currentPeriod) {
            currentPeriod.freeze();
            currentPeriod.purgeAllSources();
            currentPeriod.requestSources(this.getSources());
            currentPeriod.thaw();
        }
    };
    // Source Querying
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.getSources = function () {
        return [this.stickySource].concat(this.otherSources);
    };
    // like querySources, but accepts multple match criteria (like multiple IDs)
    EventManager.prototype.multiQuerySources = function (matchInputs) {
        // coerce into an array
        if (!matchInputs) {
            matchInputs = [];
        }
        else if (!Array.isArray(matchInputs)) {
            matchInputs = [matchInputs];
        }
        var matchingSources = [];
        var i;
        // resolve raw inputs to real event source objects
        for (i = 0; i < matchInputs.length; i++) {
            matchingSources.push.apply(// append
            matchingSources, this.querySources(matchInputs[i]));
        }
        return matchingSources;
    };
    // matchInput can either by a real event source object, an ID, or the function/URL for the source.
    // returns an array of matching source objects.
    EventManager.prototype.querySources = function (matchInput) {
        var sources = this.otherSources;
        var i;
        var source;
        // given a proper event source object
        for (i = 0; i < sources.length; i++) {
            source = sources[i];
            if (source === matchInput) {
                return [source];
            }
        }
        // an ID match
        source = this.getSourceById(EventSource_1.default.normalizeId(matchInput));
        if (source) {
            return [source];
        }
        // parse as an event source
        matchInput = EventSourceParser_1.default.parse(matchInput, this.calendar);
        if (matchInput) {
            return sources.filter(function (source) {
                return isSourcesEquivalent(matchInput, source);
            });
        }
    };
    /*
    ID assumed to already be normalized
    */
    EventManager.prototype.getSourceById = function (id) {
        return this.otherSources.filter(function (source) {
            return source.id && source.id === id;
        })[0];
    };
    // Event-Period
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.setPeriod = function (eventPeriod) {
        if (this.currentPeriod) {
            this.unbindPeriod(this.currentPeriod);
            this.currentPeriod = null;
        }
        this.currentPeriod = eventPeriod;
        this.bindPeriod(eventPeriod);
        eventPeriod.requestSources(this.getSources());
    };
    EventManager.prototype.bindPeriod = function (eventPeriod) {
        this.listenTo(eventPeriod, 'release', function (eventsPayload) {
            this.trigger('release', eventsPayload);
        });
    };
    EventManager.prototype.unbindPeriod = function (eventPeriod) {
        this.stopListeningTo(eventPeriod);
    };
    // Event Getting/Adding/Removing
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.getEventDefByUid = function (uid) {
        if (this.currentPeriod) {
            return this.currentPeriod.getEventDefByUid(uid);
        }
    };
    EventManager.prototype.addEventDef = function (eventDef, isSticky) {
        if (isSticky) {
            this.stickySource.addEventDef(eventDef);
        }
        if (this.currentPeriod) {
            this.currentPeriod.addEventDef(eventDef); // might release
        }
    };
    EventManager.prototype.removeEventDefsById = function (eventId) {
        this.getSources().forEach(function (eventSource) {
            eventSource.removeEventDefsById(eventId);
        });
        if (this.currentPeriod) {
            this.currentPeriod.removeEventDefsById(eventId); // might release
        }
    };
    EventManager.prototype.removeAllEventDefs = function () {
        this.getSources().forEach(function (eventSource) {
            eventSource.removeAllEventDefs();
        });
        if (this.currentPeriod) {
            this.currentPeriod.removeAllEventDefs();
        }
    };
    // Event Mutating
    // -----------------------------------------------------------------------------------------------------------------
    /*
    Returns an undo function.
    */
    EventManager.prototype.mutateEventsWithId = function (eventDefId, eventDefMutation) {
        var currentPeriod = this.currentPeriod;
        var eventDefs;
        var undoFuncs = [];
        if (currentPeriod) {
            currentPeriod.freeze();
            eventDefs = currentPeriod.getEventDefsById(eventDefId);
            eventDefs.forEach(function (eventDef) {
                // add/remove esp because id might change
                currentPeriod.removeEventDef(eventDef);
                undoFuncs.push(eventDefMutation.mutateSingle(eventDef));
                currentPeriod.addEventDef(eventDef);
            });
            currentPeriod.thaw();
            return function () {
                currentPeriod.freeze();
                for (var i = 0; i < eventDefs.length; i++) {
                    currentPeriod.removeEventDef(eventDefs[i]);
                    undoFuncs[i]();
                    currentPeriod.addEventDef(eventDefs[i]);
                }
                currentPeriod.thaw();
            };
        }
        return function () { };
    };
    /*
    copies and then mutates
    */
    EventManager.prototype.buildMutatedEventInstanceGroup = function (eventDefId, eventDefMutation) {
        var eventDefs = this.getEventDefsById(eventDefId);
        var i;
        var defCopy;
        var allInstances = [];
        for (i = 0; i < eventDefs.length; i++) {
            defCopy = eventDefs[i].clone();
            if (defCopy instanceof SingleEventDef_1.default) {
                eventDefMutation.mutateSingle(defCopy);
                allInstances.push.apply(allInstances, // append
                defCopy.buildInstances());
            }
        }
        return new EventInstanceGroup_1.default(allInstances);
    };
    // Freezing
    // -----------------------------------------------------------------------------------------------------------------
    EventManager.prototype.freeze = function () {
        if (this.currentPeriod) {
            this.currentPeriod.freeze();
        }
    };
    EventManager.prototype.thaw = function () {
        if (this.currentPeriod) {
            this.currentPeriod.thaw();
        }
    };
    // methods that simply forward to EventPeriod
    EventManager.prototype.getEventDefsById = function (eventDefId) {
        return this.currentPeriod.getEventDefsById(eventDefId);
    };
    EventManager.prototype.getEventInstances = function () {
        return this.currentPeriod.getEventInstances();
    };
    EventManager.prototype.getEventInstancesWithId = function (eventDefId) {
        return this.currentPeriod.getEventInstancesWithId(eventDefId);
    };
    EventManager.prototype.getEventInstancesWithoutId = function (eventDefId) {
        return this.currentPeriod.getEventInstancesWithoutId(eventDefId);
    };
    return EventManager;
}());
exports.default = EventManager;
EmitterMixin_1.default.mixInto(EventManager);
ListenerMixin_1.default.mixInto(EventManager);
function isSourcesEquivalent(source0, source1) {
    return source0.getPrimitive() === source1.getPrimitive();
}


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var array_1 = __webpack_require__(21);
var object_1 = __webpack_require__(5);
var EmitterMixin_1 = __webpack_require__(15);
var UnzonedRange_1 = __webpack_require__(7);
var EventInstanceGroup_1 = __webpack_require__(23);
var EventPeriod = /** @class */ (function () {
    function EventPeriod(start, end, timezone) {
        this.pendingCnt = 0;
        this.freezeDepth = 0;
        this.stuntedReleaseCnt = 0;
        this.releaseCnt = 0;
        this.start = start;
        this.end = end;
        this.timezone = timezone;
        this.unzonedRange = new UnzonedRange_1.default(start.clone().stripZone(), end.clone().stripZone());
        this.requestsByUid = {};
        this.eventDefsByUid = {};
        this.eventDefsById = {};
        this.eventInstanceGroupsById = {};
    }
    EventPeriod.prototype.isWithinRange = function (start, end) {
        // TODO: use a range util function?
        return !start.isBefore(this.start) && !end.isAfter(this.end);
    };
    // Requesting and Purging
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.requestSources = function (sources) {
        this.freeze();
        for (var i = 0; i < sources.length; i++) {
            this.requestSource(sources[i]);
        }
        this.thaw();
    };
    EventPeriod.prototype.requestSource = function (source) {
        var _this = this;
        var request = { source: source, status: 'pending', eventDefs: null };
        this.requestsByUid[source.uid] = request;
        this.pendingCnt += 1;
        source.fetch(this.start, this.end, this.timezone, function (eventDefs) {
            if (request.status !== 'cancelled') {
                request.status = 'completed';
                request.eventDefs = eventDefs;
                _this.addEventDefs(eventDefs);
                _this.pendingCnt--;
                _this.tryRelease();
            }
        }, function () {
            if (request.status !== 'cancelled') {
                request.status = 'failed';
                _this.pendingCnt--;
                _this.tryRelease();
            }
        });
    };
    EventPeriod.prototype.purgeSource = function (source) {
        var request = this.requestsByUid[source.uid];
        if (request) {
            delete this.requestsByUid[source.uid];
            if (request.status === 'pending') {
                request.status = 'cancelled';
                this.pendingCnt--;
                this.tryRelease();
            }
            else if (request.status === 'completed') {
                request.eventDefs.forEach(this.removeEventDef.bind(this));
            }
        }
    };
    EventPeriod.prototype.purgeAllSources = function () {
        var requestsByUid = this.requestsByUid;
        var uid;
        var request;
        var completedCnt = 0;
        for (uid in requestsByUid) {
            request = requestsByUid[uid];
            if (request.status === 'pending') {
                request.status = 'cancelled';
            }
            else if (request.status === 'completed') {
                completedCnt++;
            }
        }
        this.requestsByUid = {};
        this.pendingCnt = 0;
        if (completedCnt) {
            this.removeAllEventDefs(); // might release
        }
    };
    // Event Definitions
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.getEventDefByUid = function (eventDefUid) {
        return this.eventDefsByUid[eventDefUid];
    };
    EventPeriod.prototype.getEventDefsById = function (eventDefId) {
        var a = this.eventDefsById[eventDefId];
        if (a) {
            return a.slice(); // clone
        }
        return [];
    };
    EventPeriod.prototype.addEventDefs = function (eventDefs) {
        for (var i = 0; i < eventDefs.length; i++) {
            this.addEventDef(eventDefs[i]);
        }
    };
    EventPeriod.prototype.addEventDef = function (eventDef) {
        var eventDefsById = this.eventDefsById;
        var eventDefId = eventDef.id;
        var eventDefs = eventDefsById[eventDefId] || (eventDefsById[eventDefId] = []);
        var eventInstances = eventDef.buildInstances(this.unzonedRange);
        var i;
        eventDefs.push(eventDef);
        this.eventDefsByUid[eventDef.uid] = eventDef;
        for (i = 0; i < eventInstances.length; i++) {
            this.addEventInstance(eventInstances[i], eventDefId);
        }
    };
    EventPeriod.prototype.removeEventDefsById = function (eventDefId) {
        var _this = this;
        this.getEventDefsById(eventDefId).forEach(function (eventDef) {
            _this.removeEventDef(eventDef);
        });
    };
    EventPeriod.prototype.removeAllEventDefs = function () {
        var hasEventDefs = !object_1.isEmptyObject(this.eventDefsByUid);
        this.eventDefsByUid = {};
        this.eventDefsById = {};
        this.eventInstanceGroupsById = {};
        if (hasEventDefs) {
            this.tryRelease();
        }
    };
    EventPeriod.prototype.removeEventDef = function (eventDef) {
        var eventDefsById = this.eventDefsById;
        var eventDefs = eventDefsById[eventDef.id];
        delete this.eventDefsByUid[eventDef.uid];
        if (eventDefs) {
            array_1.removeExact(eventDefs, eventDef);
            if (!eventDefs.length) {
                delete eventDefsById[eventDef.id];
            }
            this.removeEventInstancesForDef(eventDef);
        }
    };
    // Event Instances
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.getEventInstances = function () {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var eventInstances = [];
        var id;
        for (id in eventInstanceGroupsById) {
            eventInstances.push.apply(eventInstances, // append
            eventInstanceGroupsById[id].eventInstances);
        }
        return eventInstances;
    };
    EventPeriod.prototype.getEventInstancesWithId = function (eventDefId) {
        var eventInstanceGroup = this.eventInstanceGroupsById[eventDefId];
        if (eventInstanceGroup) {
            return eventInstanceGroup.eventInstances.slice(); // clone
        }
        return [];
    };
    EventPeriod.prototype.getEventInstancesWithoutId = function (eventDefId) {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var matchingInstances = [];
        var id;
        for (id in eventInstanceGroupsById) {
            if (id !== eventDefId) {
                matchingInstances.push.apply(matchingInstances, // append
                eventInstanceGroupsById[id].eventInstances);
            }
        }
        return matchingInstances;
    };
    EventPeriod.prototype.addEventInstance = function (eventInstance, eventDefId) {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var eventInstanceGroup = eventInstanceGroupsById[eventDefId] ||
            (eventInstanceGroupsById[eventDefId] = new EventInstanceGroup_1.default());
        eventInstanceGroup.eventInstances.push(eventInstance);
        this.tryRelease();
    };
    EventPeriod.prototype.removeEventInstancesForDef = function (eventDef) {
        var eventInstanceGroupsById = this.eventInstanceGroupsById;
        var eventInstanceGroup = eventInstanceGroupsById[eventDef.id];
        var removeCnt;
        if (eventInstanceGroup) {
            removeCnt = array_1.removeMatching(eventInstanceGroup.eventInstances, function (currentEventInstance) {
                return currentEventInstance.def === eventDef;
            });
            if (!eventInstanceGroup.eventInstances.length) {
                delete eventInstanceGroupsById[eventDef.id];
            }
            if (removeCnt) {
                this.tryRelease();
            }
        }
    };
    // Releasing and Freezing
    // -----------------------------------------------------------------------------------------------------------------
    EventPeriod.prototype.tryRelease = function () {
        if (!this.pendingCnt) {
            if (!this.freezeDepth) {
                this.release();
            }
            else {
                this.stuntedReleaseCnt++;
            }
        }
    };
    EventPeriod.prototype.release = function () {
        this.releaseCnt++;
        this.trigger('release', this.eventInstanceGroupsById);
    };
    EventPeriod.prototype.whenReleased = function (callback) {
        if (this.releaseCnt) {
            callback(this.eventInstanceGroupsById);
        }
        else {
            this.one('release', callback);
        }
    };
    EventPeriod.prototype.freeze = function () {
        if (!(this.freezeDepth++)) {
            this.stuntedReleaseCnt = 0;
        }
    };
    EventPeriod.prototype.thaw = function () {
        if (!(--this.freezeDepth) && this.stuntedReleaseCnt && !this.pendingCnt) {
            this.release();
        }
    };
    return EventPeriod;
}());
exports.default = EventPeriod;
EmitterMixin_1.default.mixInto(EventPeriod);


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var dom_event_1 = __webpack_require__(10);
var dom_manip_1 = __webpack_require__(3);
var ListenerMixin_1 = __webpack_require__(12);
/* Creates a clone of an element and lets it track the mouse as it moves
----------------------------------------------------------------------------------------------------------------------*/
var MouseFollower = /** @class */ (function () {
    function MouseFollower(sourceEl, options) {
        this.isFollowing = false;
        this.isHidden = false;
        this.isAnimating = false; // doing the revert animation?
        this.options = options = options || {};
        this.sourceEl = sourceEl;
        this.parentEl = options.parentEl || sourceEl.parentNode; // default to sourceEl's parent
    }
    // Causes the element to start following the mouse
    MouseFollower.prototype.start = function (ev) {
        if (!this.isFollowing) {
            this.isFollowing = true;
            this.y0 = dom_event_1.getEvY(ev);
            this.x0 = dom_event_1.getEvX(ev);
            this.topDelta = 0;
            this.leftDelta = 0;
            if (!this.isHidden) {
                this.updatePosition();
            }
            if (dom_event_1.getEvIsTouch(ev)) {
                this.listenTo(document, 'touchmove', this.handleMove);
            }
            else {
                this.listenTo(document, 'mousemove', this.handleMove);
            }
        }
    };
    // Causes the element to stop following the mouse. If shouldRevert is true, will animate back to original position.
    // `callback` gets invoked when the animation is complete. If no animation, it is invoked immediately.
    MouseFollower.prototype.stop = function (shouldRevert, callback) {
        var _this = this;
        var el = this.el;
        var revertDuration = this.options.revertDuration;
        var complete = function () {
            _this.isAnimating = false;
            _this.removeElement();
            _this.top0 = _this.left0 = null; // reset state for future updatePosition calls
            if (callback) {
                callback();
            }
        };
        if (this.isFollowing && !this.isAnimating) { // disallow more than one stop animation at a time
            this.isFollowing = false;
            this.stopListeningTo(document);
            if (shouldRevert && revertDuration && !this.isHidden) { // do a revert animation?
                this.isAnimating = true;
                // do before position change
                el.style.transition = 'top ' + revertDuration + 'ms, left ' + revertDuration + 'ms';
                dom_manip_1.applyStyle(el, {
                    top: this.top0,
                    left: this.left0
                });
                dom_event_1.whenTransitionDone(el, function () {
                    el.style.transition = '';
                    complete();
                });
            }
            else {
                complete();
            }
        }
    };
    // Gets the tracking element. Create it if necessary
    MouseFollower.prototype.getEl = function () {
        var el = this.el;
        if (!el) {
            el = this.el = this.sourceEl.cloneNode(true); // cloneChildren=true
            // we don't want long taps or any mouse interaction causing selection/menus.
            // would use preventSelection(), but that prevents selectstart, causing problems.
            el.classList.add('fc-unselectable');
            if (this.options.additionalClass) {
                el.classList.add(this.options.additionalClass);
            }
            dom_manip_1.applyStyle(el, {
                position: 'absolute',
                visibility: '',
                display: this.isHidden ? 'none' : '',
                margin: 0,
                right: 'auto',
                bottom: 'auto',
                width: this.sourceEl.offsetWidth,
                height: this.sourceEl.offsetHeight,
                opacity: this.options.opacity || '',
                zIndex: this.options.zIndex
            });
            this.parentEl.appendChild(el);
        }
        return el;
    };
    // Removes the tracking element if it has already been created
    MouseFollower.prototype.removeElement = function () {
        if (this.el) {
            dom_manip_1.removeElement(this.el);
            this.el = null;
        }
    };
    // Update the CSS position of the tracking element
    MouseFollower.prototype.updatePosition = function () {
        var sourceRect;
        var origin;
        var el = this.getEl(); // ensure this.el
        // make sure origin info was computed
        if (this.top0 == null) {
            sourceRect = this.sourceEl.getBoundingClientRect();
            origin = el.offsetParent.getBoundingClientRect();
            this.top0 = sourceRect.top - origin.top;
            this.left0 = sourceRect.left - origin.left;
        }
        dom_manip_1.applyStyle(el, {
            top: this.top0 + this.topDelta,
            left: this.left0 + this.leftDelta
        });
    };
    // Gets called when the user moves the mouse
    MouseFollower.prototype.handleMove = function (ev) {
        this.topDelta = dom_event_1.getEvY(ev) - this.y0;
        this.leftDelta = dom_event_1.getEvX(ev) - this.x0;
        if (!this.isHidden) {
            this.updatePosition();
        }
    };
    // Temporarily makes the tracking element invisible. Can be called before following starts
    MouseFollower.prototype.hide = function () {
        if (!this.isHidden) {
            this.isHidden = true;
            if (this.el) {
                this.el.style.display = 'none';
            }
        }
    };
    // Show the tracking element after it has been temporarily hidden
    MouseFollower.prototype.show = function () {
        if (this.isHidden) {
            this.isHidden = false;
            this.updatePosition();
            this.getEl().style.display = '';
        }
    };
    return MouseFollower;
}());
exports.default = MouseFollower;
ListenerMixin_1.default.mixInto(MouseFollower);


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var HitDragListener_1 = __webpack_require__(27);
var Interaction_1 = __webpack_require__(19);
var DateClicking = /** @class */ (function (_super) {
    tslib_1.__extends(DateClicking, _super);
    /*
    component must implement:
      - bindDateHandlerToEl
      - getSafeHitFootprint
      - getHitEl
    */
    function DateClicking(component) {
        var _this = _super.call(this, component) || this;
        _this.dragListener = _this.buildDragListener();
        return _this;
    }
    DateClicking.prototype.end = function () {
        this.dragListener.endInteraction();
    };
    DateClicking.prototype.bindToEl = function (el) {
        var component = this.component;
        var dragListener = this.dragListener;
        component.bindDateHandlerToEl(el, 'mousedown', function (ev) {
            if (!component.shouldIgnoreMouse()) {
                dragListener.startInteraction(ev);
            }
        });
        component.bindDateHandlerToEl(el, 'touchstart', function (ev) {
            if (!component.shouldIgnoreTouch()) {
                dragListener.startInteraction(ev);
            }
        });
    };
    // Creates a listener that tracks the user's drag across day elements, for day clicking.
    DateClicking.prototype.buildDragListener = function () {
        var _this = this;
        var component = this.component;
        var dayClickHit; // null if invalid dayClick
        var dragListener = new HitDragListener_1.default(component, {
            scroll: this.opt('dragScroll'),
            interactionStart: function () {
                dayClickHit = dragListener.origHit;
            },
            hitOver: function (hit, isOrig, origHit) {
                // if user dragged to another cell at any point, it can no longer be a dayClick
                if (!isOrig) {
                    dayClickHit = null;
                }
            },
            hitOut: function () {
                dayClickHit = null;
            },
            interactionEnd: function (ev, isCancelled) {
                var componentFootprint;
                if (!isCancelled && dayClickHit) {
                    componentFootprint = component.getSafeHitFootprint(dayClickHit);
                    if (componentFootprint) {
                        _this.view.triggerDayClick(componentFootprint, component.getHitEl(dayClickHit), ev);
                    }
                }
            }
        });
        // because dragListener won't be called with any time delay, "dragging" will begin immediately,
        // which will kill any touchmoving/scrolling. Prevent this.
        dragListener.shouldCancelTouchScroll = false;
        dragListener.scrollAlwaysKills = true;
        return dragListener;
    };
    return DateClicking;
}(Interaction_1.default));
exports.default = DateClicking;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var html_1 = __webpack_require__(6);
var dom_manip_1 = __webpack_require__(3);
var EventRenderer_1 = __webpack_require__(47);
/*
Only handles foreground segs.
Does not own rendering. Use for low-level util methods by TimeGrid.
*/
var TimeGridEventRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGridEventRenderer, _super);
    function TimeGridEventRenderer(timeGrid, fillRenderer) {
        var _this = _super.call(this, timeGrid, fillRenderer) || this;
        _this.timeGrid = timeGrid;
        return _this;
    }
    TimeGridEventRenderer.prototype.renderFgSegs = function (segs) {
        this.renderFgSegsIntoContainers(segs, this.timeGrid.fgContainerEls);
    };
    // Given an array of foreground segments, render a DOM element for each, computes position,
    // and attaches to the column inner-container elements.
    TimeGridEventRenderer.prototype.renderFgSegsIntoContainers = function (segs, containerEls) {
        var segsByCol;
        var col;
        segsByCol = this.timeGrid.groupSegsByCol(segs);
        for (col = 0; col < this.timeGrid.colCnt; col++) {
            this.updateFgSegCoords(segsByCol[col]);
        }
        this.timeGrid.attachSegsByCol(segsByCol, containerEls);
    };
    TimeGridEventRenderer.prototype.unrenderFgSegs = function () {
        if (this.fgSegs) { // hack
            this.fgSegs.forEach(function (seg) {
                dom_manip_1.removeElement(seg.el);
            });
        }
    };
    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
    TimeGridEventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('noMeridiemTimeFormat'); // like "6:30" (no AM/PM)
    };
    // Computes a default `displayEventEnd` value if one is not expliclty defined
    TimeGridEventRenderer.prototype.computeDisplayEventEnd = function () {
        return true;
    };
    // Renders the HTML for a single event segment's default rendering
    TimeGridEventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
        var view = this.view;
        var calendar = view.calendar;
        var componentFootprint = seg.footprint.componentFootprint;
        var isAllDay = componentFootprint.isAllDay;
        var eventDef = seg.footprint.eventDef;
        var isDraggable = view.isEventDefDraggable(eventDef);
        var isResizableFromStart = !disableResizing && seg.isStart && view.isEventDefResizableFromStart(eventDef);
        var isResizableFromEnd = !disableResizing && seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
        var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
        var skinCss = html_1.cssToStr(this.getSkinCss(eventDef));
        var timeText;
        var fullTimeText; // more verbose time text. for the print stylesheet
        var startTimeText; // just the start time text
        classes.unshift('fc-time-grid-event', 'fc-v-event');
        // if the event appears to span more than one day...
        if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
            // Don't display time text on segments that run entirely through a day.
            // That would appear as midnight-midnight and would look dumb.
            // Otherwise, display the time text for the *segment's* times (like 6pm-midnight or midnight-10am)
            if (seg.isStart || seg.isEnd) {
                var zonedStart = calendar.msToMoment(seg.startMs);
                var zonedEnd = calendar.msToMoment(seg.endMs);
                timeText = this._getTimeText(zonedStart, zonedEnd, isAllDay);
                fullTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, 'LT');
                startTimeText = this._getTimeText(zonedStart, zonedEnd, isAllDay, null, false); // displayEnd=false
            }
        }
        else {
            // Display the normal time text for the *event's* times
            timeText = this.getTimeText(seg.footprint);
            fullTimeText = this.getTimeText(seg.footprint, 'LT');
            startTimeText = this.getTimeText(seg.footprint, null, false); // displayEnd=false
        }
        return '<a class="' + classes.join(' ') + '"' +
            (eventDef.url ?
                ' href="' + html_1.htmlEscape(eventDef.url) + '"' :
                '') +
            (skinCss ?
                ' style="' + skinCss + '"' :
                '') +
            '>' +
            '<div class="fc-content">' +
            (timeText ?
                '<div class="fc-time"' +
                    ' data-start="' + html_1.htmlEscape(startTimeText) + '"' +
                    ' data-full="' + html_1.htmlEscape(fullTimeText) + '"' +
                    '>' +
                    '<span>' + html_1.htmlEscape(timeText) + '</span>' +
                    '</div>' :
                '') +
            (eventDef.title ?
                '<div class="fc-title">' +
                    html_1.htmlEscape(eventDef.title) +
                    '</div>' :
                '') +
            '</div>' +
            '<div class="fc-bg"></div>' +
            /* TODO: write CSS for this
            (isResizableFromStart ?
              '<div class="fc-resizer fc-start-resizer"></div>' :
              ''
              ) +
            */
            (isResizableFromEnd ?
                '<div class="fc-resizer fc-end-resizer"></div>' :
                '') +
            '</a>';
    };
    // Given segments that are assumed to all live in the *same column*,
    // compute their verical/horizontal coordinates and assign to their elements.
    TimeGridEventRenderer.prototype.updateFgSegCoords = function (segs) {
        this.timeGrid.computeSegVerticals(segs); // horizontals relies on this
        this.computeFgSegHorizontals(segs); // compute horizontal coordinates, z-index's, and reorder the array
        this.timeGrid.assignSegVerticals(segs);
        this.assignFgSegHorizontals(segs);
    };
    // Given an array of segments that are all in the same column, sets the backwardCoord and forwardCoord on each.
    // NOTE: Also reorders the given array by date!
    TimeGridEventRenderer.prototype.computeFgSegHorizontals = function (segs) {
        var levels;
        var level0;
        var i;
        this.sortEventSegs(segs); // order by certain criteria
        levels = buildSlotSegLevels(segs);
        computeForwardSlotSegs(levels);
        if ((level0 = levels[0])) {
            for (i = 0; i < level0.length; i++) {
                computeSlotSegPressures(level0[i]);
            }
            for (i = 0; i < level0.length; i++) {
                this.computeFgSegForwardBack(level0[i], 0, 0);
            }
        }
    };
    // Calculate seg.forwardCoord and seg.backwardCoord for the segment, where both values range
    // from 0 to 1. If the calendar is left-to-right, the seg.backwardCoord maps to "left" and
    // seg.forwardCoord maps to "right" (via percentage). Vice-versa if the calendar is right-to-left.
    //
    // The segment might be part of a "series", which means consecutive segments with the same pressure
    // who's width is unknown until an edge has been hit. `seriesBackwardPressure` is the number of
    // segments behind this one in the current series, and `seriesBackwardCoord` is the starting
    // coordinate of the first segment in the series.
    TimeGridEventRenderer.prototype.computeFgSegForwardBack = function (seg, seriesBackwardPressure, seriesBackwardCoord) {
        var forwardSegs = seg.forwardSegs;
        var i;
        if (seg.forwardCoord === undefined) { // not already computed
            if (!forwardSegs.length) {
                // if there are no forward segments, this segment should butt up against the edge
                seg.forwardCoord = 1;
            }
            else {
                // sort highest pressure first
                this.sortForwardSegs(forwardSegs);
                // this segment's forwardCoord will be calculated from the backwardCoord of the
                // highest-pressure forward segment.
                this.computeFgSegForwardBack(forwardSegs[0], seriesBackwardPressure + 1, seriesBackwardCoord);
                seg.forwardCoord = forwardSegs[0].backwardCoord;
            }
            // calculate the backwardCoord from the forwardCoord. consider the series
            seg.backwardCoord = seg.forwardCoord -
                (seg.forwardCoord - seriesBackwardCoord) / // available width for series
                    (seriesBackwardPressure + 1); // # of segments in the series
            // use this segment's coordinates to computed the coordinates of the less-pressurized
            // forward segments
            for (i = 0; i < forwardSegs.length; i++) {
                this.computeFgSegForwardBack(forwardSegs[i], 0, seg.forwardCoord);
            }
        }
    };
    TimeGridEventRenderer.prototype.sortForwardSegs = function (forwardSegs) {
        forwardSegs.sort(this.compareForwardSegs.bind(this));
    };
    // A cmp function for determining which forward segment to rely on more when computing coordinates.
    TimeGridEventRenderer.prototype.compareForwardSegs = function (seg1, seg2) {
        // put higher-pressure first
        return seg2.forwardPressure - seg1.forwardPressure ||
            // put segments that are closer to initial edge first (and favor ones with no coords yet)
            (seg1.backwardCoord || 0) - (seg2.backwardCoord || 0) ||
            // do normal sorting...
            this.compareEventSegs(seg1, seg2);
    };
    // Given foreground event segments that have already had their position coordinates computed,
    // assigns position-related CSS values to their elements.
    TimeGridEventRenderer.prototype.assignFgSegHorizontals = function (segs) {
        var i;
        var seg;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            dom_manip_1.applyStyle(seg.el, this.generateFgSegHorizontalCss(seg));
            // if the height is short, add a className for alternate styling
            if (seg.bottom - seg.top < 30) {
                seg.el.classList.add('fc-short');
            }
        }
    };
    // Generates an object with CSS properties/values that should be applied to an event segment element.
    // Contains important positioning-related properties that should be applied to any event element, customized or not.
    TimeGridEventRenderer.prototype.generateFgSegHorizontalCss = function (seg) {
        var shouldOverlap = this.opt('slotEventOverlap');
        var backwardCoord = seg.backwardCoord; // the left side if LTR. the right side if RTL. floating-point
        var forwardCoord = seg.forwardCoord; // the right side if LTR. the left side if RTL. floating-point
        var props = this.timeGrid.generateSegVerticalCss(seg); // get top/bottom first
        var isRTL = this.timeGrid.isRTL;
        var left; // amount of space from left edge, a fraction of the total width
        var right; // amount of space from right edge, a fraction of the total width
        if (shouldOverlap) {
            // double the width, but don't go beyond the maximum forward coordinate (1.0)
            forwardCoord = Math.min(1, backwardCoord + (forwardCoord - backwardCoord) * 2);
        }
        if (isRTL) {
            left = 1 - forwardCoord;
            right = backwardCoord;
        }
        else {
            left = backwardCoord;
            right = 1 - forwardCoord;
        }
        props.zIndex = seg.level + 1; // convert from 0-base to 1-based
        props.left = left * 100 + '%';
        props.right = right * 100 + '%';
        if (shouldOverlap && seg.forwardPressure) {
            // add padding to the edge so that forward stacked events don't cover the resizer's icon
            props[isRTL ? 'marginLeft' : 'marginRight'] = 10 * 2; // 10 is a guesstimate of the icon's width
        }
        return props;
    };
    return TimeGridEventRenderer;
}(EventRenderer_1.default));
exports.default = TimeGridEventRenderer;
// Builds an array of segments "levels". The first level will be the leftmost tier of segments if the calendar is
// left-to-right, or the rightmost if the calendar is right-to-left. Assumes the segments are already ordered by date.
function buildSlotSegLevels(segs) {
    var levels = [];
    var i;
    var seg;
    var j;
    for (i = 0; i < segs.length; i++) {
        seg = segs[i];
        // go through all the levels and stop on the first level where there are no collisions
        for (j = 0; j < levels.length; j++) {
            if (!computeSlotSegCollisions(seg, levels[j]).length) {
                break;
            }
        }
        seg.level = j;
        (levels[j] || (levels[j] = [])).push(seg);
    }
    return levels;
}
// For every segment, figure out the other segments that are in subsequent
// levels that also occupy the same vertical space. Accumulate in seg.forwardSegs
function computeForwardSlotSegs(levels) {
    var i;
    var level;
    var j;
    var seg;
    var k;
    for (i = 0; i < levels.length; i++) {
        level = levels[i];
        for (j = 0; j < level.length; j++) {
            seg = level[j];
            seg.forwardSegs = [];
            for (k = i + 1; k < levels.length; k++) {
                computeSlotSegCollisions(seg, levels[k], seg.forwardSegs);
            }
        }
    }
}
// Figure out which path forward (via seg.forwardSegs) results in the longest path until
// the furthest edge is reached. The number of segments in this path will be seg.forwardPressure
function computeSlotSegPressures(seg) {
    var forwardSegs = seg.forwardSegs;
    var forwardPressure = 0;
    var i;
    var forwardSeg;
    if (seg.forwardPressure === undefined) { // not already computed
        for (i = 0; i < forwardSegs.length; i++) {
            forwardSeg = forwardSegs[i];
            // figure out the child's maximum forward path
            computeSlotSegPressures(forwardSeg);
            // either use the existing maximum, or use the child's forward pressure
            // plus one (for the forwardSeg itself)
            forwardPressure = Math.max(forwardPressure, 1 + forwardSeg.forwardPressure);
        }
        seg.forwardPressure = forwardPressure;
    }
}
// Find all the segments in `otherSegs` that vertically collide with `seg`.
// Append into an optionally-supplied `results` array and return.
function computeSlotSegCollisions(seg, otherSegs, results) {
    if (results === void 0) { results = []; }
    for (var i = 0; i < otherSegs.length; i++) {
        if (isSlotSegCollision(seg, otherSegs[i])) {
            results.push(otherSegs[i]);
        }
    }
    return results;
}
// Do these segments occupy the same vertical space?
function isSlotSegCollision(seg1, seg2) {
    return seg1.bottom > seg2.top && seg1.top < seg2.bottom;
}


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var dom_manip_1 = __webpack_require__(3);
var HelperRenderer_1 = __webpack_require__(64);
var TimeGridHelperRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGridHelperRenderer, _super);
    function TimeGridHelperRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeGridHelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
        var helperNodes = [];
        var i;
        var seg;
        var sourceEl;
        var computedStyle;
        // TODO: not good to call eventRenderer this way
        this.eventRenderer.renderFgSegsIntoContainers(segs, this.component.helperContainerEls);
        // Try to make the segment that is in the same row as sourceSeg look the same
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            if (sourceSeg && sourceSeg.col === seg.col) {
                sourceEl = sourceSeg.el;
                computedStyle = window.getComputedStyle(sourceEl);
                dom_manip_1.applyStyle(seg.el, {
                    left: computedStyle.left,
                    right: computedStyle.right,
                    marginLeft: computedStyle.marginLeft,
                    marginRight: computedStyle.marginRight
                });
            }
            helperNodes.push(seg.el);
        }
        return helperNodes; // must return the elements rendered
    };
    return TimeGridHelperRenderer;
}(HelperRenderer_1.default));
exports.default = TimeGridHelperRenderer;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var FillRenderer_1 = __webpack_require__(63);
var TimeGridFillRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(TimeGridFillRenderer, _super);
    function TimeGridFillRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeGridFillRenderer.prototype.attachSegEls = function (type, segs) {
        var timeGrid = this.component;
        var containerEls;
        // TODO: more efficient lookup
        if (type === 'bgEvent') {
            containerEls = timeGrid.bgContainerEls;
        }
        else if (type === 'businessHours') {
            containerEls = timeGrid.businessContainerEls;
        }
        else if (type === 'highlight') {
            containerEls = timeGrid.highlightContainerEls;
        }
        timeGrid.updateSegVerticals(segs);
        timeGrid.attachSegsByCol(timeGrid.groupSegsByCol(segs), containerEls);
        return segs.map(function (seg) {
            return seg.el;
        });
    };
    return TimeGridFillRenderer;
}(FillRenderer_1.default));
exports.default = TimeGridFillRenderer;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

/* A rectangular panel that is absolutely positioned over other content
------------------------------------------------------------------------------------------------------------------------
Options:
  - className (string)
  - content (HTML string, element, or element array)
  - parentEl
  - top
  - left
  - right (the x coord of where the right edge should be. not a "CSS" right)
  - autoHide (boolean)
  - show (callback)
  - hide (callback)
*/
Object.defineProperty(exports, "__esModule", { value: true });
var dom_manip_1 = __webpack_require__(3);
var dom_event_1 = __webpack_require__(10);
var dom_geom_1 = __webpack_require__(13);
var ListenerMixin_1 = __webpack_require__(12);
var Popover = /** @class */ (function () {
    function Popover(options) {
        this.isHidden = true;
        this.margin = 10; // the space required between the popover and the edges of the scroll container
        this.options = options;
    }
    // Shows the popover on the specified position. Renders it if not already
    Popover.prototype.show = function () {
        if (this.isHidden) {
            if (!this.el) {
                this.render();
            }
            this.el.style.display = '';
            this.position();
            this.isHidden = false;
            this.trigger('show');
        }
    };
    // Hides the popover, through CSS, but does not remove it from the DOM
    Popover.prototype.hide = function () {
        if (!this.isHidden) {
            this.el.style.display = 'none';
            this.isHidden = true;
            this.trigger('hide');
        }
    };
    // Creates `this.el` and renders content inside of it
    Popover.prototype.render = function () {
        var _this = this;
        var options = this.options;
        var el = this.el = dom_manip_1.createElement('div', {
            className: 'fc-popover ' + (options.className || ''),
            style: {
                top: '0',
                left: '0'
            }
        }, options.content);
        options.parentEl.appendChild(el);
        // when a click happens on anything inside with a 'fc-close' className, hide the popover
        dom_event_1.listenBySelector(el, 'click', '.fc-close', function (ev) {
            _this.hide();
        });
        if (options.autoHide) {
            this.listenTo(document, 'mousedown', this.documentMousedown);
        }
    };
    // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
    Popover.prototype.documentMousedown = function (ev) {
        // only hide the popover if the click happened outside the popover
        if (this.el && !this.el.contains(ev.target)) {
            this.hide();
        }
    };
    // Hides and unregisters any handlers
    Popover.prototype.removeElement = function () {
        this.hide();
        if (this.el) {
            dom_manip_1.removeElement(this.el);
            this.el = null;
        }
        this.stopListeningTo(document, 'mousedown');
    };
    // Positions the popover optimally, using the top/left/right options
    Popover.prototype.position = function () {
        var options = this.options;
        var el = this.el;
        var rect = el.getBoundingClientRect();
        var scrollEl = dom_geom_1.getScrollParent(el);
        var viewportRect;
        var top; // the "position" (not "offset") values for the popover
        var left; //
        // compute top and left
        top = options.top || 0;
        if (options.left !== undefined) {
            left = options.left;
        }
        else if (options.right !== undefined) {
            left = options.right - rect.width; // derive the left value from the right value
        }
        else {
            left = 0;
        }
        if (scrollEl) {
            viewportRect = scrollEl.getBoundingClientRect();
        }
        else {
            viewportRect = {
                top: 0,
                left: 0,
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            };
        }
        // constrain to the view port. if constrained by two edges, give precedence to top/left
        if (options.viewportConstrain !== false) {
            top = Math.min(top, viewportRect.top + viewportRect.height - rect.height - this.margin);
            top = Math.max(top, viewportRect.top + this.margin);
            left = Math.min(left, viewportRect.left + viewportRect.width - rect.width - this.margin);
            left = Math.max(left, viewportRect.left + this.margin);
        }
        dom_manip_1.applyStyle(el, {
            top: top - rect.top,
            left: left - rect.left
        });
    };
    // Triggers a callback. Calls a function in the option hash of the same name.
    // Arguments beyond the first `name` are forwarded on.
    // TODO: better code reuse for this. Repeat code
    Popover.prototype.trigger = function (name) {
        if (this.options[name]) {
            this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
        }
    };
    return Popover;
}());
exports.default = Popover;
ListenerMixin_1.default.mixInto(Popover);


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var html_1 = __webpack_require__(6);
var dom_manip_1 = __webpack_require__(3);
var EventRenderer_1 = __webpack_require__(47);
/* Event-rendering methods for the DayGrid class
----------------------------------------------------------------------------------------------------------------------*/
var DayGridEventRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(DayGridEventRenderer, _super);
    function DayGridEventRenderer(dayGrid, fillRenderer) {
        var _this = _super.call(this, dayGrid, fillRenderer) || this;
        _this.dayGrid = dayGrid;
        return _this;
    }
    DayGridEventRenderer.prototype.renderBgRanges = function (eventRanges) {
        // don't render timed background events
        eventRanges = eventRanges.filter(function (eventRange) {
            return eventRange.eventDef.isAllDay();
        });
        _super.prototype.renderBgRanges.call(this, eventRanges);
    };
    // Renders the given foreground event segments onto the grid
    DayGridEventRenderer.prototype.renderFgSegs = function (segs) {
        var rowStructs = this.rowStructs = this.renderSegRows(segs);
        // append to each row's content skeleton
        this.dayGrid.rowEls.forEach(function (rowNode, i) {
            rowNode.querySelector('.fc-content-skeleton > table').appendChild(rowStructs[i].tbodyEl);
        });
    };
    // Unrenders all currently rendered foreground event segments
    DayGridEventRenderer.prototype.unrenderFgSegs = function () {
        var rowStructs = this.rowStructs || [];
        var rowStruct;
        while ((rowStruct = rowStructs.pop())) {
            dom_manip_1.removeElement(rowStruct.tbodyEl);
        }
        this.rowStructs = null;
    };
    // Uses the given events array to generate <tbody> elements that should be appended to each row's content skeleton.
    // Returns an array of rowStruct objects (see the bottom of `renderSegRow`).
    // PRECONDITION: each segment shoud already have a rendered and assigned `.el`
    DayGridEventRenderer.prototype.renderSegRows = function (segs) {
        var rowStructs = [];
        var segRows;
        var row;
        segRows = this.groupSegRows(segs); // group into nested arrays
        // iterate each row of segment groupings
        for (row = 0; row < segRows.length; row++) {
            rowStructs.push(this.renderSegRow(row, segRows[row]));
        }
        return rowStructs;
    };
    // Given a row # and an array of segments all in the same row, render a <tbody> element, a skeleton that contains
    // the segments. Returns object with a bunch of internal data about how the render was calculated.
    // NOTE: modifies rowSegs
    DayGridEventRenderer.prototype.renderSegRow = function (row, rowSegs) {
        var colCnt = this.dayGrid.colCnt;
        var segLevels = this.buildSegLevels(rowSegs); // group into sub-arrays of levels
        var levelCnt = Math.max(1, segLevels.length); // ensure at least one level
        var tbody = document.createElement('tbody');
        var segMatrix = []; // lookup for which segments are rendered into which level+col cells
        var cellMatrix = []; // lookup for all <td> elements of the level+col matrix
        var loneCellMatrix = []; // lookup for <td> elements that only take up a single column
        var i;
        var levelSegs;
        var col;
        var tr;
        var j;
        var seg;
        var td;
        // populates empty cells from the current column (`col`) to `endCol`
        function emptyCellsUntil(endCol) {
            while (col < endCol) {
                // try to grab a cell from the level above and extend its rowspan. otherwise, create a fresh cell
                td = (loneCellMatrix[i - 1] || [])[col];
                if (td) {
                    td.rowSpan = (td.rowSpan || 1) + 1;
                }
                else {
                    td = document.createElement('td');
                    tr.appendChild(td);
                }
                cellMatrix[i][col] = td;
                loneCellMatrix[i][col] = td;
                col++;
            }
        }
        for (i = 0; i < levelCnt; i++) { // iterate through all levels
            levelSegs = segLevels[i];
            col = 0;
            tr = document.createElement('tr');
            segMatrix.push([]);
            cellMatrix.push([]);
            loneCellMatrix.push([]);
            // levelCnt might be 1 even though there are no actual levels. protect against this.
            // this single empty row is useful for styling.
            if (levelSegs) {
                for (j = 0; j < levelSegs.length; j++) { // iterate through segments in level
                    seg = levelSegs[j];
                    emptyCellsUntil(seg.leftCol);
                    // create a container that occupies or more columns. append the event element.
                    td = dom_manip_1.createElement('td', { className: 'fc-event-container' }, seg.el);
                    if (seg.leftCol !== seg.rightCol) {
                        td.colSpan = seg.rightCol - seg.leftCol + 1;
                    }
                    else { // a single-column segment
                        loneCellMatrix[i][col] = td;
                    }
                    while (col <= seg.rightCol) {
                        cellMatrix[i][col] = td;
                        segMatrix[i][col] = seg;
                        col++;
                    }
                    tr.appendChild(td);
                }
            }
            emptyCellsUntil(colCnt); // finish off the row
            this.dayGrid.bookendCells(tr);
            tbody.appendChild(tr);
        }
        return {
            row: row,
            tbodyEl: tbody,
            cellMatrix: cellMatrix,
            segMatrix: segMatrix,
            segLevels: segLevels,
            segs: rowSegs
        };
    };
    // Stacks a flat array of segments, which are all assumed to be in the same row, into subarrays of vertical levels.
    // NOTE: modifies segs
    DayGridEventRenderer.prototype.buildSegLevels = function (segs) {
        var levels = [];
        var i;
        var seg;
        var j;
        // Give preference to elements with certain criteria, so they have
        // a chance to be closer to the top.
        this.sortEventSegs(segs);
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            // loop through levels, starting with the topmost, until the segment doesn't collide with other segments
            for (j = 0; j < levels.length; j++) {
                if (!isDaySegCollision(seg, levels[j])) {
                    break;
                }
            }
            // `j` now holds the desired subrow index
            seg.level = j;
            // create new level array if needed and append segment
            (levels[j] || (levels[j] = [])).push(seg);
        }
        // order segments left-to-right. very important if calendar is RTL
        for (j = 0; j < levels.length; j++) {
            levels[j].sort(compareDaySegCols);
        }
        return levels;
    };
    // Given a flat array of segments, return an array of sub-arrays, grouped by each segment's row
    DayGridEventRenderer.prototype.groupSegRows = function (segs) {
        var segRows = [];
        var i;
        for (i = 0; i < this.dayGrid.rowCnt; i++) {
            segRows.push([]);
        }
        for (i = 0; i < segs.length; i++) {
            segRows[segs[i].row].push(segs[i]);
        }
        return segRows;
    };
    // Computes a default event time formatting string if `timeFormat` is not explicitly defined
    DayGridEventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('extraSmallTimeFormat'); // like "6p" or "6:30p"
    };
    // Computes a default `displayEventEnd` value if one is not expliclty defined
    DayGridEventRenderer.prototype.computeDisplayEventEnd = function () {
        return this.dayGrid.colCnt === 1; // we'll likely have space if there's only one day
    };
    // Builds the HTML to be used for the default element for an individual segment
    DayGridEventRenderer.prototype.fgSegHtml = function (seg, disableResizing) {
        var view = this.view;
        var eventDef = seg.footprint.eventDef;
        var isAllDay = seg.footprint.componentFootprint.isAllDay;
        var isDraggable = view.isEventDefDraggable(eventDef);
        var isResizableFromStart = !disableResizing && isAllDay &&
            seg.isStart && view.isEventDefResizableFromStart(eventDef);
        var isResizableFromEnd = !disableResizing && isAllDay &&
            seg.isEnd && view.isEventDefResizableFromEnd(eventDef);
        var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
        var skinCss = html_1.cssToStr(this.getSkinCss(eventDef));
        var timeHtml = '';
        var timeText;
        var titleHtml;
        classes.unshift('fc-day-grid-event', 'fc-h-event');
        // Only display a timed events time if it is the starting segment
        if (seg.isStart) {
            timeText = this.getTimeText(seg.footprint);
            if (timeText) {
                timeHtml = '<span class="fc-time">' + html_1.htmlEscape(timeText) + '</span>';
            }
        }
        titleHtml =
            '<span class="fc-title">' +
                (html_1.htmlEscape(eventDef.title || '') || '&nbsp;') + // we always want one line of height
                '</span>';
        return '<a class="' + classes.join(' ') + '"' +
            (eventDef.url ?
                ' href="' + html_1.htmlEscape(eventDef.url) + '"' :
                '') +
            (skinCss ?
                ' style="' + skinCss + '"' :
                '') +
            '>' +
            '<div class="fc-content">' +
            (this.dayGrid.isRTL ?
                titleHtml + ' ' + timeHtml : // put a natural space in between
                timeHtml + ' ' + titleHtml //
            ) +
            '</div>' +
            (isResizableFromStart ?
                '<div class="fc-resizer fc-start-resizer"></div>' :
                '') +
            (isResizableFromEnd ?
                '<div class="fc-resizer fc-end-resizer"></div>' :
                '') +
            '</a>';
    };
    return DayGridEventRenderer;
}(EventRenderer_1.default));
exports.default = DayGridEventRenderer;
// Computes whether two segments' columns collide. They are assumed to be in the same row.
function isDaySegCollision(seg, otherSegs) {
    var i;
    var otherSeg;
    for (i = 0; i < otherSegs.length; i++) {
        otherSeg = otherSegs[i];
        if (otherSeg.leftCol <= seg.rightCol &&
            otherSeg.rightCol >= seg.leftCol) {
            return true;
        }
    }
    return false;
}
// A cmp function for determining the leftmost event
function compareDaySegCols(a, b) {
    return a.leftCol - b.leftCol;
}


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var dom_manip_1 = __webpack_require__(3);
var HelperRenderer_1 = __webpack_require__(64);
var DayGridHelperRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(DayGridHelperRenderer, _super);
    function DayGridHelperRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Renders a mock "helper" event. `sourceSeg` is the associated internal segment object. It can be null.
    DayGridHelperRenderer.prototype.renderSegs = function (segs, sourceSeg) {
        var helperNodes = [];
        var rowStructs;
        // TODO: not good to call eventRenderer this way
        rowStructs = this.eventRenderer.renderSegRows(segs);
        // inject each new event skeleton into each associated row
        this.component.rowEls.forEach(function (rowNode, row) {
            var skeletonEl = dom_manip_1.htmlToElement('<div class="fc-helper-skeleton"><table></table></div>'); // will be absolutely positioned
            var skeletonTopEl;
            var skeletonTop;
            // If there is an original segment, match the top position. Otherwise, put it at the row's top level
            if (sourceSeg && sourceSeg.row === row) {
                skeletonTopEl = sourceSeg.el;
            }
            else {
                skeletonTopEl = rowNode.querySelector('.fc-content-skeleton tbody');
                if (!skeletonTopEl) { // when no events
                    skeletonTopEl = rowNode.querySelector('.fc-content-skeleton table');
                }
            }
            skeletonTop = skeletonTopEl.getBoundingClientRect().top -
                rowNode.getBoundingClientRect().top; // the offsetParent origin
            skeletonEl.style.top = skeletonTop + 'px';
            skeletonEl.querySelector('table').appendChild(rowStructs[row].tbodyEl);
            rowNode.appendChild(skeletonEl);
            helperNodes.push(skeletonEl);
        });
        return helperNodes; // must return the elements rendered
    };
    return DayGridHelperRenderer;
}(HelperRenderer_1.default));
exports.default = DayGridHelperRenderer;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var dom_manip_1 = __webpack_require__(3);
var FillRenderer_1 = __webpack_require__(63);
var DayGridFillRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(DayGridFillRenderer, _super);
    function DayGridFillRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fillSegTag = 'td'; // override the default tag name
        return _this;
    }
    DayGridFillRenderer.prototype.attachSegEls = function (type, segs) {
        var els = [];
        var i;
        var seg;
        var skeletonEl;
        for (i = 0; i < segs.length; i++) {
            seg = segs[i];
            skeletonEl = this.renderFillRow(type, seg);
            this.component.rowEls[seg.row].appendChild(skeletonEl);
            els.push(skeletonEl);
        }
        return els;
    };
    // Generates the HTML needed for one row of a fill. Requires the seg's el to be rendered.
    DayGridFillRenderer.prototype.renderFillRow = function (type, seg) {
        var colCnt = this.component.colCnt;
        var startCol = seg.leftCol;
        var endCol = seg.rightCol + 1;
        var className;
        var skeletonEl;
        var trEl;
        if (type === 'businessHours') {
            className = 'bgevent';
        }
        else {
            className = type.toLowerCase();
        }
        skeletonEl = dom_manip_1.htmlToElement('<div class="fc-' + className + '-skeleton">' +
            '<table><tr></tr></table>' +
            '</div>');
        trEl = skeletonEl.getElementsByTagName('tr')[0];
        if (startCol > 0) {
            trEl.appendChild(dom_manip_1.createElement('td', { colSpan: startCol }));
        }
        seg.el.colSpan = endCol - startCol;
        trEl.appendChild(seg.el);
        if (endCol < colCnt) {
            trEl.appendChild(dom_manip_1.createElement('td', { colSpan: colCnt - endCol }));
        }
        this.component.bookendCells(trEl);
        return skeletonEl;
    };
    return DayGridFillRenderer;
}(FillRenderer_1.default));
exports.default = DayGridFillRenderer;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var BasicViewDateProfileGenerator_1 = __webpack_require__(235);
var UnzonedRange_1 = __webpack_require__(7);
var MonthViewDateProfileGenerator = /** @class */ (function (_super) {
    tslib_1.__extends(MonthViewDateProfileGenerator, _super);
    function MonthViewDateProfileGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Computes the date range that will be rendered.
    MonthViewDateProfileGenerator.prototype.buildRenderRange = function (currentUnzonedRange, currentRangeUnit, isRangeAllDay) {
        var renderUnzonedRange = _super.prototype.buildRenderRange.call(this, currentUnzonedRange, currentRangeUnit, isRangeAllDay);
        var start = this.msToUtcMoment(renderUnzonedRange.startMs, isRangeAllDay);
        var end = this.msToUtcMoment(renderUnzonedRange.endMs, isRangeAllDay);
        var rowCnt;
        // ensure 6 weeks
        if (this.opt('fixedWeekCount')) {
            rowCnt = Math.ceil(// could be partial weeks due to hiddenDays
            end.diff(start, 'weeks', true) // dontRound=true
            );
            end.add(6 - rowCnt, 'weeks');
        }
        return new UnzonedRange_1.default(start, end);
    };
    return MonthViewDateProfileGenerator;
}(BasicViewDateProfileGenerator_1.default));
exports.default = MonthViewDateProfileGenerator;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var html_1 = __webpack_require__(6);
var EventRenderer_1 = __webpack_require__(47);
var ListEventRenderer = /** @class */ (function (_super) {
    tslib_1.__extends(ListEventRenderer, _super);
    function ListEventRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListEventRenderer.prototype.renderFgSegs = function (segs) {
        if (!segs.length) {
            this.component.renderEmptyMessage();
        }
        else {
            this.component.renderSegList(segs);
        }
    };
    // generates the HTML for a single event row
    ListEventRenderer.prototype.fgSegHtml = function (seg) {
        var view = this.view;
        var calendar = view.calendar;
        var theme = calendar.theme;
        var eventFootprint = seg.footprint;
        var eventDef = eventFootprint.eventDef;
        var componentFootprint = eventFootprint.componentFootprint;
        var url = eventDef.url;
        var classes = ['fc-list-item'].concat(this.getClasses(eventDef));
        var bgColor = this.getBgColor(eventDef);
        var timeHtml;
        if (componentFootprint.isAllDay) {
            timeHtml = view.getAllDayHtml();
        }
        else if (view.isMultiDayRange(componentFootprint.unzonedRange)) {
            if (seg.isStart || seg.isEnd) { // outer segment that probably lasts part of the day
                timeHtml = html_1.htmlEscape(this._getTimeText(calendar.msToMoment(seg.startMs), calendar.msToMoment(seg.endMs), componentFootprint.isAllDay));
            }
            else { // inner segment that lasts the whole day
                timeHtml = view.getAllDayHtml();
            }
        }
        else {
            // Display the normal time text for the *event's* times
            timeHtml = html_1.htmlEscape(this.getTimeText(eventFootprint));
        }
        if (url) {
            classes.push('fc-has-url');
        }
        return '<tr class="' + classes.join(' ') + '">' +
            (this.displayEventTime ?
                '<td class="fc-list-item-time ' + theme.getClass('widgetContent') + '">' +
                    (timeHtml || '') +
                    '</td>' :
                '') +
            '<td class="fc-list-item-marker ' + theme.getClass('widgetContent') + '">' +
            '<span class="fc-event-dot"' +
            (bgColor ?
                ' style="background-color:' + bgColor + '"' :
                '') +
            '></span>' +
            '</td>' +
            '<td class="fc-list-item-title ' + theme.getClass('widgetContent') + '">' +
            '<a' + (url ? ' href="' + html_1.htmlEscape(url) + '"' : '') + '>' +
            html_1.htmlEscape(eventDef.title || '') +
            '</a>' +
            '</td>' +
            '</tr>';
    };
    // like "4:00am"
    ListEventRenderer.prototype.computeEventTimeFormat = function () {
        return this.opt('mediumTimeFormat');
    };
    return ListEventRenderer;
}(EventRenderer_1.default));
exports.default = ListEventRenderer;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var dom_manip_1 = __webpack_require__(3);
var EventPointing_1 = __webpack_require__(65);
var ListEventPointing = /** @class */ (function (_super) {
    tslib_1.__extends(ListEventPointing, _super);
    function ListEventPointing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // for events with a url, the whole <tr> should be clickable,
    // but it's impossible to wrap with an <a> tag. simulate this.
    ListEventPointing.prototype.handleClick = function (seg, ev) {
        var url;
        _super.prototype.handleClick.call(this, seg, ev); // might prevent the default action
        // not clicking on or within an <a> with an href
        if (!dom_manip_1.elementClosest(ev.target, 'a[href]')) {
            url = seg.footprint.eventDef.url;
            if (url && !ev.isDefaultPrevented()) { // jsEvent not cancelled in handler
                window.location.href = url; // simulate link click
            }
        }
    };
    return ListEventPointing;
}(EventPointing_1.default));
exports.default = ListEventPointing;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var EventSourceParser_1 = __webpack_require__(43);
var ArrayEventSource_1 = __webpack_require__(57);
var FuncEventSource_1 = __webpack_require__(223);
var JsonFeedEventSource_1 = __webpack_require__(224);
EventSourceParser_1.default.registerClass(ArrayEventSource_1.default);
EventSourceParser_1.default.registerClass(FuncEventSource_1.default);
EventSourceParser_1.default.registerClass(JsonFeedEventSource_1.default);


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ThemeRegistry_1 = __webpack_require__(56);
var StandardTheme_1 = __webpack_require__(221);
var JqueryUiTheme_1 = __webpack_require__(222);
var Bootstrap3Theme_1 = __webpack_require__(267);
var Bootstrap4Theme_1 = __webpack_require__(268);
ThemeRegistry_1.defineThemeSystem('standard', StandardTheme_1.default);
ThemeRegistry_1.defineThemeSystem('jquery-ui', JqueryUiTheme_1.default);
ThemeRegistry_1.defineThemeSystem('bootstrap3', Bootstrap3Theme_1.default);
ThemeRegistry_1.defineThemeSystem('bootstrap4', Bootstrap4Theme_1.default);


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Theme_1 = __webpack_require__(24);
var Bootstrap3Theme = /** @class */ (function (_super) {
    tslib_1.__extends(Bootstrap3Theme, _super);
    function Bootstrap3Theme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Bootstrap3Theme;
}(Theme_1.default));
exports.default = Bootstrap3Theme;
Bootstrap3Theme.prototype.classes = {
    widget: 'fc-bootstrap3',
    tableGrid: 'table-bordered',
    tableList: 'table',
    tableListHeading: 'active',
    buttonGroup: 'btn-group',
    button: 'btn btn-default',
    stateActive: 'active',
    stateDisabled: 'disabled',
    today: 'alert alert-info',
    popover: 'panel panel-default',
    popoverHeader: 'panel-heading',
    popoverContent: 'panel-body',
    // day grid
    // for left/right border color when border is inset from edges (all-day in agenda view)
    // avoid `panel` class b/c don't want margins/radius. only border color.
    headerRow: 'panel-default',
    dayRow: 'panel-default',
    // list view
    listView: 'panel panel-default'
};
Bootstrap3Theme.prototype.baseIconClass = 'glyphicon';
Bootstrap3Theme.prototype.iconClasses = {
    close: 'glyphicon-remove',
    prev: 'glyphicon-chevron-left',
    next: 'glyphicon-chevron-right',
    prevYear: 'glyphicon-backward',
    nextYear: 'glyphicon-forward'
};
Bootstrap3Theme.prototype.iconOverrideOption = 'bootstrapGlyphicons';
Bootstrap3Theme.prototype.iconOverrideCustomButtonOption = 'bootstrapGlyphicon';
Bootstrap3Theme.prototype.iconOverridePrefix = 'glyphicon-';


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(2);
var Theme_1 = __webpack_require__(24);
var Bootstrap4Theme = /** @class */ (function (_super) {
    tslib_1.__extends(Bootstrap4Theme, _super);
    function Bootstrap4Theme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Bootstrap4Theme;
}(Theme_1.default));
exports.default = Bootstrap4Theme;
Bootstrap4Theme.prototype.classes = {
    widget: 'fc-bootstrap4',
    tableGrid: 'table-bordered',
    tableList: 'table',
    tableListHeading: 'table-active',
    buttonGroup: 'btn-group',
    button: 'btn btn-primary',
    stateActive: 'active',
    stateDisabled: 'disabled',
    today: 'alert alert-info',
    popover: 'card card-primary',
    popoverHeader: 'card-header',
    popoverContent: 'card-body',
    // day grid
    // for left/right border color when border is inset from edges (all-day in agenda view)
    // avoid `table` class b/c don't want margins/padding/structure. only border color.
    headerRow: 'table-bordered',
    dayRow: 'table-bordered',
    // list view
    listView: 'card card-primary'
};
Bootstrap4Theme.prototype.baseIconClass = 'fa';
Bootstrap4Theme.prototype.iconClasses = {
    close: 'fa-times',
    prev: 'fa-chevron-left',
    next: 'fa-chevron-right',
    prevYear: 'fa-angle-double-left',
    nextYear: 'fa-angle-double-right'
};
Bootstrap4Theme.prototype.iconOverrideOption = 'bootstrapFontAwesome';
Bootstrap4Theme.prototype.iconOverrideCustomButtonOption = 'bootstrapFontAwesome';
Bootstrap4Theme.prototype.iconOverridePrefix = 'fa-';


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ViewRegistry_1 = __webpack_require__(26);
var BasicView_1 = __webpack_require__(68);
var MonthView_1 = __webpack_require__(236);
ViewRegistry_1.defineView('basic', {
    'class': BasicView_1.default
});
ViewRegistry_1.defineView('basicDay', {
    type: 'basic',
    duration: { days: 1 }
});
ViewRegistry_1.defineView('basicWeek', {
    type: 'basic',
    duration: { weeks: 1 }
});
ViewRegistry_1.defineView('month', {
    'class': MonthView_1.default,
    duration: { months: 1 },
    defaults: {
        fixedWeekCount: true
    }
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ViewRegistry_1 = __webpack_require__(26);
var AgendaView_1 = __webpack_require__(233);
ViewRegistry_1.defineView('agenda', {
    'class': AgendaView_1.default,
    defaults: {
        allDaySlot: true,
        slotDuration: '00:30:00',
        slotEventOverlap: true // a bad name. confused with overlap/constraint system
    }
});
ViewRegistry_1.defineView('agendaDay', {
    type: 'agenda',
    duration: { days: 1 }
});
ViewRegistry_1.defineView('agendaWeek', {
    type: 'agenda',
    duration: { weeks: 1 }
});


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var ViewRegistry_1 = __webpack_require__(26);
var ListView_1 = __webpack_require__(237);
ViewRegistry_1.defineView('list', {
    'class': ListView_1.default,
    buttonTextKey: 'list',
    defaults: {
        buttonText: 'list',
        listDayFormat: 'LL',
        noEventsMessage: 'No events to display'
    }
});
ViewRegistry_1.defineView('listDay', {
    type: 'list',
    duration: { days: 1 },
    defaults: {
        listDayFormat: 'dddd' // day-of-week is all we need. full date is probably in header
    }
});
ViewRegistry_1.defineView('listWeek', {
    type: 'list',
    duration: { weeks: 1 },
    defaults: {
        listDayFormat: 'dddd',
        listDayAltFormat: 'LL'
    }
});
ViewRegistry_1.defineView('listMonth', {
    type: 'list',
    duration: { month: 1 },
    defaults: {
        listDayAltFormat: 'dddd' // day-of-week is nice-to-have
    }
});
ViewRegistry_1.defineView('listYear', {
    type: 'list',
    duration: { year: 1 },
    defaults: {
        listDayAltFormat: 'dddd' // day-of-week is nice-to-have
    }
});


/***/ })
/******/ ]);
});

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(641);
var RequestBase = __webpack_require__(642);
var isObject = __webpack_require__(618);
var ResponseBase = __webpack_require__(643);
var Agent = __webpack_require__(645);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(618);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(644);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.created = 201 == status;
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
    this.unprocessableEntity = 422 == status;
};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};


/***/ }),
/* 645 */
/***/ (function(module, exports) {

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendar",attrs:{"id":"calendar"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(648);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("0f14cf62", content, true, {});

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, "/*!\n * FullCalendar v4.0.0-alpha\n * Docs & License: https://fullcalendar.io/\n * (c) 2018 Adam Shaw\n */.fc button,.fc table,body .fc{font-size:1em}.fc-bg,.fc-row .fc-bgevent-skeleton,.fc-row .fc-highlight-skeleton{bottom:0}.fc-icon,.fc-unselectable{-webkit-touch-callout:none;-khtml-user-select:none}.fc{direction:ltr;text-align:left}.fc-rtl{text-align:right}.fc-basic-view td.fc-week-number,.fc-icon,.fc-toolbar,.fc th{text-align:center}.fc-highlight{background:#bce8f1;opacity:.3}.fc-bgevent{background:#8fdf82;opacity:.3}.fc-nonbusiness{background:#d7d7d7}.fc button{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;height:2.1em;padding:0 .6em;white-space:nowrap;cursor:pointer}.fc button::-moz-focus-inner{margin:0;padding:0}.fc-state-default{border:1px solid;background-color:#f5f5f5;background-image:-moz-linear-gradient(top,#fff,#e6e6e6);background-image:-webkit-gradient(linear,0 0,0 100%,from(#fff),to(#e6e6e6));background-image:-webkit-linear-gradient(top,#fff,#e6e6e6);background-image:-o-linear-gradient(top,#fff,#e6e6e6);background-image:linear-gradient(180deg,#fff,#e6e6e6);background-repeat:repeat-x;border-color:#e6e6e6 #e6e6e6 #bfbfbf;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#333;text-shadow:0 1px 1px hsla(0,0%,100%,.75);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.2),0 1px 2px rgba(0,0,0,.05)}.fc-state-default.fc-corner-left{border-top-left-radius:4px;border-bottom-left-radius:4px}.fc-state-default.fc-corner-right{border-top-right-radius:4px;border-bottom-right-radius:4px}.fc button .fc-icon{position:relative;top:-.05em;margin:0 .2em;vertical-align:middle}.fc-state-active,.fc-state-disabled,.fc-state-down,.fc-state-hover{color:#333;background-color:#e6e6e6}.fc-state-hover{color:#333;text-decoration:none;background-position:0 -15px;-webkit-transition:background-position .1s linear;-moz-transition:background-position .1s linear;-o-transition:background-position .1s linear;transition:background-position .1s linear}.fc-state-active,.fc-state-down{background-color:#ccc;background-image:none;box-shadow:inset 0 2px 4px rgba(0,0,0,.15),0 1px 2px rgba(0,0,0,.05)}.fc-state-disabled{cursor:default;background-image:none;opacity:.65;box-shadow:none}.fc-event.fc-draggable,.fc-event[href],.fc-popover .fc-header .fc-close,a[data-goto]{cursor:pointer}.fc-button-group{display:inline-block}.fc .fc-button-group>*{float:left;margin:0 0 0 -1px}.fc .fc-button-group>:first-child{margin-left:0}.fc-popover{position:absolute;box-shadow:0 2px 6px rgba(0,0,0,.15)}.fc-popover .fc-header{padding:2px 4px}.fc-popover .fc-header .fc-title{margin:0 2px}.fc-ltr .fc-popover .fc-header .fc-title,.fc-rtl .fc-popover .fc-header .fc-close{float:left}.fc-ltr .fc-popover .fc-header .fc-close,.fc-rtl .fc-popover .fc-header .fc-title{float:right}.fc-divider{border-style:solid;border-width:1px}hr.fc-divider{height:0;margin:0;padding:0 0 2px;border-width:1px 0}.fc-bg table,.fc-row .fc-bgevent-skeleton table,.fc-row .fc-highlight-skeleton table{height:100%}.fc-clear{clear:both}.fc-bg,.fc-bgevent-skeleton,.fc-helper-skeleton,.fc-highlight-skeleton{position:absolute;top:0;left:0;right:0}.fc table{width:100%;box-sizing:border-box;table-layout:fixed;border-collapse:collapse;border-spacing:0}.fc td,.fc th{border-style:solid;border-width:1px;padding:0;vertical-align:top}.fc td.fc-today{border-style:double}a[data-goto]:hover{text-decoration:underline}.fc .fc-row{border-style:solid;border-width:0}.fc-row table{border-left:0 hidden transparent;border-right:0 hidden transparent;border-bottom:0 hidden transparent}.fc-row:first-child table{border-top:0 hidden transparent}.fc-row{position:relative}.fc-row .fc-bg{z-index:1}.fc-row .fc-bgevent-skeleton td,.fc-row .fc-highlight-skeleton td{border-color:transparent}.fc-row .fc-bgevent-skeleton{z-index:2}.fc-row .fc-highlight-skeleton{z-index:3}.fc-row .fc-content-skeleton{position:relative;z-index:4;padding-bottom:2px}.fc-row .fc-helper-skeleton{z-index:5}.fc .fc-row .fc-content-skeleton table,.fc .fc-row .fc-content-skeleton td,.fc .fc-row .fc-helper-skeleton td{background:0 0;border-color:transparent}.fc-row .fc-content-skeleton td,.fc-row .fc-helper-skeleton td{border-bottom:0}.fc-row .fc-content-skeleton tbody td,.fc-row .fc-helper-skeleton tbody td{border-top:0}.fc-scroller{-webkit-overflow-scrolling:touch}.fc-icon,.fc-row.fc-rigid,.fc-time-grid-event{overflow:hidden}.fc-scroller>.fc-day-grid,.fc-scroller>.fc-time-grid{position:relative;width:100%}.fc-event{position:relative;display:block;font-size:.85em;line-height:1.3;border-radius:3px;border:1px solid #3a87ad}.fc-event,.fc-event-dot{background-color:#3a87ad}.fc-event,.fc-event:hover{color:#fff;text-decoration:none}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc-event .fc-bg{z-index:1;background:#fff;opacity:.25}.fc-event .fc-content{position:relative;z-index:2}.fc-event .fc-resizer{position:absolute;z-index:4;display:none}.fc-event.fc-allow-mouse-resize .fc-resizer,.fc-event.fc-selected .fc-resizer{display:block}.fc-event.fc-selected .fc-resizer:before{content:\"\";position:absolute;z-index:9999;top:50%;left:50%;width:40px;height:40px;margin-left:-20px;margin-top:-20px}.fc-event.fc-selected{z-index:9999!important;box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event.fc-selected.fc-dragging{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-h-event.fc-selected:before{content:\"\";position:absolute;z-index:3;top:-10px;bottom:-10px;left:0;right:0}.fc-ltr .fc-h-event.fc-not-start,.fc-rtl .fc-h-event.fc-not-end{margin-left:0;border-left-width:0;padding-left:1px;border-top-left-radius:0;border-bottom-left-radius:0}.fc-ltr .fc-h-event.fc-not-end,.fc-rtl .fc-h-event.fc-not-start{margin-right:0;border-right-width:0;padding-right:1px;border-top-right-radius:0;border-bottom-right-radius:0}.fc-ltr .fc-h-event .fc-start-resizer,.fc-rtl .fc-h-event .fc-end-resizer{cursor:w-resize;left:-1px}.fc-ltr .fc-h-event .fc-end-resizer,.fc-rtl .fc-h-event .fc-start-resizer{cursor:e-resize;right:-1px}.fc-h-event.fc-allow-mouse-resize .fc-resizer{width:7px;top:-1px;bottom:-1px}.fc-h-event.fc-selected .fc-resizer{border-radius:4px;border-width:1px;width:6px;height:6px;border-style:solid;border-color:inherit;background:#fff;top:50%;margin-top:-4px}.fc-ltr .fc-h-event.fc-selected .fc-start-resizer,.fc-rtl .fc-h-event.fc-selected .fc-end-resizer{margin-left:-4px}.fc-ltr .fc-h-event.fc-selected .fc-end-resizer,.fc-rtl .fc-h-event.fc-selected .fc-start-resizer{margin-right:-4px}.fc-day-grid-event{margin:1px 2px 0;padding:0 1px}tr:first-child>td>.fc-day-grid-event{margin-top:2px}.fc-helper-skeleton tr:first-child>td>.fc-day-grid-event{margin-top:0}.fc-day-grid-event.fc-selected:after{content:\"\";position:absolute;z-index:1;top:-1px;right:-1px;bottom:-1px;left:-1px;background:#000;opacity:.25}.fc-day-grid-event .fc-content{white-space:nowrap;overflow:hidden}.fc-day-grid-event .fc-time{font-weight:700}.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer,.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer{margin-left:-2px}.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer,.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer{margin-right:-2px}a.fc-more{margin:1px 3px;font-size:.85em;cursor:pointer;text-decoration:none}a.fc-more:hover{text-decoration:underline}.fc.fc-bootstrap3 a,.ui-widget .fc-event{text-decoration:none}.fc-limited{display:none}.fc-icon,.fc-toolbar .fc-center{display:inline-block}.fc-day-grid .fc-row{z-index:1}.fc-more-popover{z-index:2;width:220px}.fc-more-popover .fc-event-container{padding:10px}.fc-bootstrap3 .fc-popover .panel-body,.fc-bootstrap4 .fc-popover .card-body{padding:0}.fc-now-indicator{position:absolute;border:0 solid red}.fc-bootstrap3 .fc-today.alert,.fc-bootstrap4 .fc-today.alert{border-radius:0}.fc-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fc-unthemed .fc-content,.fc-unthemed .fc-divider,.fc-unthemed .fc-list-heading td,.fc-unthemed .fc-list-view,.fc-unthemed .fc-popover,.fc-unthemed .fc-row,.fc-unthemed tbody,.fc-unthemed td,.fc-unthemed th,.fc-unthemed thead{border-color:#ddd}.fc-unthemed .fc-popover{background-color:#fff;border-width:1px;border-style:solid}.fc-unthemed .fc-divider,.fc-unthemed .fc-list-heading td,.fc-unthemed .fc-popover .fc-header{background:#eee}.fc-unthemed td.fc-today{background:#fcf8e3}.fc-unthemed .fc-disabled-day{background:#d7d7d7;opacity:.3}.fc-icon{height:1em;line-height:1em;font-size:1em;font-family:Courier New,Courier,monospace;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.fc-icon:after{position:relative}.fc-icon-left-single-arrow:after{content:\"\\2039\";font-weight:700;font-size:200%;top:-7%}.fc-icon-right-single-arrow:after{content:\"\\203A\";font-weight:700;font-size:200%;top:-7%}.fc-icon-left-double-arrow:after{content:\"\\AB\";font-size:160%;top:-7%}.fc-icon-right-double-arrow:after{content:\"\\BB\";font-size:160%;top:-7%}.fc-icon-left-triangle:after{content:\"\\25C4\";font-size:125%;top:3%}.fc-icon-right-triangle:after{content:\"\\25BA\";font-size:125%;top:3%}.fc-icon-down-triangle:after{content:\"\\25BC\";font-size:125%;top:2%}.fc-icon-x:after{content:\"\\D7\";font-size:200%;top:6%}.fc-unthemed .fc-popover .fc-header .fc-close{color:#666;font-size:.9em;margin-top:2px}.fc-unthemed .fc-list-item:hover td{background-color:#f5f5f5}.ui-widget .fc-disabled-day{background-image:none}.fc-bootstrap3 .fc-time-grid .fc-slats table,.fc-bootstrap4 .fc-time-grid .fc-slats table,.fc-time-grid .fc-slats .ui-widget-content{background:0 0}.fc-popover>.ui-widget-header+.ui-widget-content{border-top:0}.fc-bootstrap3 hr.fc-divider,.fc-bootstrap4 hr.fc-divider{border-color:inherit}.ui-widget .fc-event{color:#fff;font-weight:400}.ui-widget td.fc-axis{font-weight:400}.fc.fc-bootstrap3 a[data-goto]:hover{text-decoration:underline}.fc.fc-bootstrap4 a{text-decoration:none}.fc.fc-bootstrap4 a[data-goto]:hover{text-decoration:underline}.fc-bootstrap4 a.fc-event:not([href]):not([tabindex]){color:#fff}.fc-bootstrap4 .fc-popover.card{position:absolute}.fc-toolbar.fc-header-toolbar{margin-bottom:1em}.fc-toolbar.fc-footer-toolbar{margin-top:1em}.fc-toolbar .fc-left{float:left}.fc-toolbar .fc-right{float:right}.fc .fc-toolbar>*>*{float:left;margin-left:.75em}.fc .fc-toolbar>*>:first-child{margin-left:0}.fc-toolbar h2{margin:0}.fc-toolbar button{position:relative}.fc-toolbar .fc-state-hover,.fc-toolbar .ui-state-hover{z-index:2}.fc-toolbar .fc-state-down{z-index:3}.fc-toolbar .fc-state-active,.fc-toolbar .ui-state-active{z-index:4}.fc-toolbar button:focus{z-index:5}.fc-view-container *,.fc-view-container :after,.fc-view-container :before{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.fc-view,.fc-view>table{position:relative;z-index:1}.fc-basicDay-view .fc-content-skeleton,.fc-basicWeek-view .fc-content-skeleton{padding-bottom:1em}.fc-basic-view .fc-body .fc-row{min-height:4em}.fc-row.fc-rigid .fc-content-skeleton{position:absolute;top:0;left:0;right:0}.fc-day-top.fc-other-month{opacity:.3}.fc-basic-view .fc-day-number,.fc-basic-view .fc-week-number{padding:2px}.fc-basic-view th.fc-day-number,.fc-basic-view th.fc-week-number{padding:0 2px}.fc-ltr .fc-basic-view .fc-day-top .fc-day-number{float:right}.fc-rtl .fc-basic-view .fc-day-top .fc-day-number{float:left}.fc-ltr .fc-basic-view .fc-day-top .fc-week-number{float:left;border-radius:0 0 3px}.fc-rtl .fc-basic-view .fc-day-top .fc-week-number{float:right;border-radius:0 0 0 3px}.fc-basic-view .fc-day-top .fc-week-number{min-width:1.5em;text-align:center;background-color:#f2f2f2;color:grey}.fc-basic-view td.fc-week-number>*{display:inline-block;min-width:1.25em}.fc-agenda-view .fc-day-grid{position:relative;z-index:2}.fc-agenda-view .fc-day-grid .fc-row{min-height:3em}.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton{padding-bottom:1em}.fc .fc-axis{vertical-align:middle;padding:0 4px;white-space:nowrap}.fc-ltr .fc-axis{text-align:right}.fc-rtl .fc-axis{text-align:left}.fc-time-grid,.fc-time-grid-container{position:relative;z-index:1}.fc-time-grid{min-height:100%}.fc-time-grid table{border:0 hidden transparent}.fc-time-grid>.fc-bg{z-index:1}.fc-time-grid .fc-slats,.fc-time-grid>hr{position:relative;z-index:2}.fc-time-grid .fc-content-col{position:relative}.fc-time-grid .fc-content-skeleton{position:absolute;z-index:3;top:0;left:0;right:0}.fc-time-grid .fc-business-container{position:relative;z-index:1}.fc-time-grid .fc-bgevent-container{position:relative;z-index:2}.fc-time-grid .fc-highlight-container{z-index:3;position:relative}.fc-time-grid .fc-event-container{position:relative;z-index:4}.fc-time-grid .fc-now-indicator-line{z-index:5}.fc-time-grid .fc-helper-container{position:relative;z-index:6}.fc-time-grid .fc-slats td{height:1.5em;border-bottom:0}.fc-time-grid .fc-slats .fc-minor td{border-top-style:dotted}.fc-time-grid .fc-highlight{position:absolute;left:0;right:0}.fc-ltr .fc-time-grid .fc-event-container{margin:0 2.5% 0 2px}.fc-rtl .fc-time-grid .fc-event-container{margin:0 2px 0 2.5%}.fc-time-grid .fc-bgevent,.fc-time-grid .fc-event{position:absolute;z-index:1}.fc-time-grid .fc-bgevent{left:0;right:0}.fc-v-event.fc-not-start{border-top-width:0;padding-top:1px;border-top-left-radius:0;border-top-right-radius:0}.fc-v-event.fc-not-end{border-bottom-width:0;padding-bottom:1px;border-bottom-left-radius:0;border-bottom-right-radius:0}.fc-time-grid-event.fc-selected{overflow:visible}.fc-time-grid-event.fc-selected .fc-bg{display:none}.fc-time-grid-event .fc-content{overflow:hidden}.fc-time-grid-event .fc-time,.fc-time-grid-event .fc-title{padding:0 1px}.fc-time-grid-event .fc-time{font-size:.85em;white-space:nowrap}.fc-time-grid-event.fc-short .fc-content{white-space:nowrap}.fc-time-grid-event.fc-short .fc-time,.fc-time-grid-event.fc-short .fc-title{display:inline-block;vertical-align:top}.fc-time-grid-event.fc-short .fc-time span{display:none}.fc-time-grid-event.fc-short .fc-time:before{content:attr(data-start)}.fc-time-grid-event.fc-short .fc-time:after{content:\"\\A0-\\A0\"}.fc-time-grid-event.fc-short .fc-title{font-size:.85em;padding:0}.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer{left:0;right:0;bottom:0;height:8px;overflow:hidden;line-height:8px;font-size:11px;font-family:monospace;text-align:center;cursor:s-resize}.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer:after{content:\"=\"}.fc-time-grid-event.fc-selected .fc-resizer{border-radius:5px;border-width:1px;width:8px;height:8px;border-style:solid;border-color:inherit;background:#fff;left:50%;margin-left:-5px;bottom:-5px}.fc-time-grid .fc-now-indicator-line{border-top-width:1px;left:0;right:0}.fc-time-grid .fc-now-indicator-arrow{margin-top:-5px}.fc-ltr .fc-time-grid .fc-now-indicator-arrow{left:0;border-width:5px 0 5px 6px;border-top-color:transparent;border-bottom-color:transparent}.fc-rtl .fc-time-grid .fc-now-indicator-arrow{right:0;border-width:5px 6px 5px 0;border-top-color:transparent;border-bottom-color:transparent}.fc-event-dot{display:inline-block;width:10px;height:10px;border-radius:5px}.fc-rtl .fc-list-view{direction:rtl}.fc-list-view{border-width:1px;border-style:solid}.fc .fc-list-table{table-layout:auto}.fc-list-table td{border-width:1px 0 0;padding:8px 14px}.fc-list-table tr:first-child td{border-top-width:0}.fc-list-heading{border-bottom-width:1px}.fc-list-heading td{font-weight:700}.fc-ltr .fc-list-heading-main{float:left}.fc-ltr .fc-list-heading-alt,.fc-rtl .fc-list-heading-main{float:right}.fc-rtl .fc-list-heading-alt{float:left}.fc-list-item.fc-has-url{cursor:pointer}.fc-list-item-marker,.fc-list-item-time{white-space:nowrap;width:1px}.fc-ltr .fc-list-item-marker{padding-right:0}.fc-rtl .fc-list-item-marker{padding-left:0}.fc-list-item-title a{text-decoration:none;color:inherit}.fc-list-item-title a[href]:hover{text-decoration:underline}.fc-list-empty-wrap2{position:absolute;top:0;left:0;right:0;bottom:0}.fc-list-empty-wrap1{width:100%;height:100%;display:table}.fc-list-empty{display:table-cell;vertical-align:middle;text-align:center}.fc-unthemed .fc-list-empty{background-color:#eee}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/node_modules/fullcalendar/dist/fullcalendar.min.css"],"names":[],"mappings":"AAAA;;;;GAIG,8BAA8B,aAAa,CAAC,mEAAmE,QAAQ,CAAC,0BAA0B,2BAA2B,uBAAuB,CAAC,IAAI,cAAc,eAAe,CAAC,QAAQ,gBAAgB,CAAC,6DAA6D,iBAAiB,CAAC,cAAc,mBAAmB,UAAU,CAAC,YAAY,mBAAmB,UAAU,CAAC,gBAAgB,kBAAkB,CAAC,WAAW,2BAA2B,8BAA8B,sBAAsB,SAAS,aAAa,eAAe,mBAAmB,cAAc,CAAC,6BAA6B,SAAS,SAAS,CAAC,kBAAkB,iBAAiB,yBAAyB,wDAAwD,4EAA4E,2DAA2D,sDAAsD,sDAAyD,2BAA2B,qCAAqC,2DAA2D,WAAW,0CAA4C,qEAAuE,CAAC,iCAAiC,2BAA2B,6BAA6B,CAAC,kCAAkC,4BAA4B,8BAA8B,CAAC,oBAAoB,kBAAkB,WAAW,cAAc,qBAAqB,CAAC,mEAAmE,WAAW,wBAAwB,CAAC,gBAAgB,WAAW,qBAAqB,4BAA4B,kDAAkD,+CAA+C,6CAA6C,yCAAyC,CAAC,gCAAgC,sBAAsB,sBAAsB,oEAAoE,CAAC,mBAAmB,eAAe,sBAAsB,YAAY,eAAe,CAAC,qFAAqF,cAAc,CAAC,iBAAiB,oBAAoB,CAAC,uBAAuB,WAAW,iBAAiB,CAAC,kCAAkC,aAAa,CAAC,YAAY,kBAAkB,oCAAoC,CAAC,uBAAuB,eAAe,CAAC,iCAAiC,YAAY,CAAC,kFAAkF,UAAU,CAAC,kFAAkF,WAAW,CAAC,YAAY,mBAAmB,gBAAgB,CAAC,cAAc,SAAS,SAAS,gBAAgB,kBAAkB,CAAC,qFAAqF,WAAW,CAAC,UAAU,UAAU,CAAC,uEAAuE,kBAAkB,MAAM,OAAO,OAAO,CAAC,UAAU,WAAW,sBAAsB,mBAAmB,yBAAyB,gBAAgB,CAAC,cAAc,mBAAmB,iBAAiB,UAAU,kBAAkB,CAAC,gBAAgB,mBAAmB,CAAC,mBAAmB,yBAAyB,CAAC,YAAY,mBAAmB,cAAc,CAAC,cAAc,iCAAiC,kCAAkC,kCAAkC,CAAC,0BAA0B,+BAA+B,CAAC,QAAQ,iBAAiB,CAAC,eAAe,SAAS,CAAC,kEAAkE,wBAAwB,CAAC,6BAA6B,SAAS,CAAC,+BAA+B,SAAS,CAAC,6BAA6B,kBAAkB,UAAU,kBAAkB,CAAC,4BAA4B,SAAS,CAAC,8GAA8G,eAAe,wBAAwB,CAAC,+DAA+D,eAAe,CAAC,2EAA2E,YAAY,CAAC,aAAa,gCAAgC,CAAC,8CAA8C,eAAe,CAAC,qDAAqD,kBAAkB,UAAU,CAAC,UAAU,kBAAkB,cAAc,gBAAgB,gBAAgB,kBAAkB,wBAAwB,CAAC,wBAAwB,wBAAwB,CAAC,0BAA0B,WAAW,oBAAoB,CAAC,0CAA0C,kBAAkB,CAAC,iBAAiB,UAAU,gBAAgB,WAAW,CAAC,sBAAsB,kBAAkB,SAAS,CAAC,sBAAsB,kBAAkB,UAAU,YAAY,CAAC,8EAA8E,aAAa,CAAC,yCAAyC,WAAW,kBAAkB,aAAa,QAAQ,SAAS,WAAW,YAAY,kBAAkB,gBAAgB,CAAC,sBAAsB,uBAAuB,mCAAmC,CAAC,kCAAkC,mCAAmC,CAAC,+BAA+B,WAAW,kBAAkB,UAAU,UAAU,aAAa,OAAO,OAAO,CAAC,gEAAgE,cAAc,oBAAoB,iBAAiB,yBAAyB,2BAA2B,CAAC,gEAAgE,eAAe,qBAAqB,kBAAkB,0BAA0B,4BAA4B,CAAC,0EAA0E,gBAAgB,SAAS,CAAC,0EAA0E,gBAAgB,UAAU,CAAC,8CAA8C,UAAU,SAAS,WAAW,CAAC,oCAAoC,kBAAkB,iBAAiB,UAAU,WAAW,mBAAmB,qBAAqB,gBAAgB,QAAQ,eAAe,CAAC,kGAAkG,gBAAgB,CAAC,kGAAkG,iBAAiB,CAAC,mBAAmB,iBAAiB,aAAa,CAAC,qCAAqC,cAAc,CAAC,yDAAyD,YAAY,CAAC,qCAAqC,WAAW,kBAAkB,UAAU,SAAS,WAAW,YAAY,UAAU,gBAAgB,WAAW,CAAC,+BAA+B,mBAAmB,eAAe,CAAC,4BAA4B,eAAe,CAAC,oIAAoI,gBAAgB,CAAC,oIAAoI,iBAAiB,CAAC,UAAU,eAAe,gBAAgB,eAAe,oBAAoB,CAAC,gBAAgB,yBAAyB,CAAC,yCAAyC,oBAAoB,CAAC,YAAY,YAAY,CAAC,gCAAgC,oBAAoB,CAAC,qBAAqB,SAAS,CAAC,iBAAiB,UAAU,WAAW,CAAC,qCAAqC,YAAY,CAAC,6EAA6E,SAAS,CAAC,kBAAkB,kBAAkB,kBAAkB,CAAC,8DAA8D,eAAe,CAAC,iBAAiB,yBAAyB,sBAAsB,qBAAqB,iBAAiB,uCAAuC,CAAC,kOAAkO,iBAAiB,CAAC,yBAAyB,sBAAsB,iBAAiB,kBAAkB,CAAC,8FAA8F,eAAe,CAAC,yBAAyB,kBAAkB,CAAC,8BAA8B,mBAAmB,UAAU,CAAC,SAAS,WAAW,gBAAgB,cAAc,0CAA4C,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,eAAe,iBAAiB,CAAC,iCAAiC,gBAAgB,gBAAgB,eAAe,OAAO,CAAC,kCAAkC,gBAAgB,gBAAgB,eAAe,OAAO,CAAC,iCAAiC,cAAc,eAAe,OAAO,CAAC,kCAAkC,cAAc,eAAe,OAAO,CAAC,6BAA6B,gBAAgB,eAAe,MAAM,CAAC,8BAA8B,gBAAgB,eAAe,MAAM,CAAC,6BAA6B,gBAAgB,eAAe,MAAM,CAAC,iBAAiB,cAAc,eAAe,MAAM,CAAC,8CAA8C,WAAW,eAAe,cAAc,CAAC,oCAAoC,wBAAwB,CAAC,4BAA4B,qBAAqB,CAAC,qIAAqI,cAAc,CAAC,iDAAiD,YAAY,CAAC,0DAA0D,oBAAoB,CAAC,qBAAqB,WAAW,eAAe,CAAC,sBAAsB,eAAe,CAAC,qCAAqC,yBAAyB,CAAC,oBAAoB,oBAAoB,CAAC,qCAAqC,yBAAyB,CAAC,sDAAsD,UAAU,CAAC,gCAAgC,iBAAiB,CAAC,8BAA8B,iBAAiB,CAAC,8BAA8B,cAAc,CAAC,qBAAqB,UAAU,CAAC,sBAAsB,WAAW,CAAC,oBAAoB,WAAW,iBAAiB,CAAC,+BAA+B,aAAa,CAAC,eAAe,QAAQ,CAAC,mBAAmB,iBAAiB,CAAC,wDAAwD,SAAS,CAAC,2BAA2B,SAAS,CAAC,0DAA0D,SAAS,CAAC,yBAAyB,SAAS,CAAC,0EAA0E,+BAA+B,4BAA4B,sBAAsB,CAAC,wBAAwB,kBAAkB,SAAS,CAAC,+EAA+E,kBAAkB,CAAC,gCAAgC,cAAc,CAAC,sCAAsC,kBAAkB,MAAM,OAAO,OAAO,CAAC,2BAA2B,UAAU,CAAC,6DAA6D,WAAW,CAAC,iEAAiE,aAAa,CAAC,kDAAkD,WAAW,CAAC,kDAAkD,UAAU,CAAC,mDAAmD,WAAW,qBAAqB,CAAC,mDAAmD,YAAY,uBAAuB,CAAC,2CAA2C,gBAAgB,kBAAkB,yBAAyB,UAAU,CAAC,mCAAmC,qBAAqB,gBAAgB,CAAC,6BAA6B,kBAAkB,SAAS,CAAC,qCAAqC,cAAc,CAAC,0DAA0D,kBAAkB,CAAC,aAAa,sBAAsB,cAAc,kBAAkB,CAAC,iBAAiB,gBAAgB,CAAC,iBAAiB,eAAe,CAAC,sCAAsC,kBAAkB,SAAS,CAAC,cAAc,eAAe,CAAC,oBAAoB,2BAA2B,CAAC,qBAAqB,SAAS,CAAC,yCAAyC,kBAAkB,SAAS,CAAC,8BAA8B,iBAAiB,CAAC,mCAAmC,kBAAkB,UAAU,MAAM,OAAO,OAAO,CAAC,qCAAqC,kBAAkB,SAAS,CAAC,oCAAoC,kBAAkB,SAAS,CAAC,sCAAsC,UAAU,iBAAiB,CAAC,kCAAkC,kBAAkB,SAAS,CAAC,qCAAqC,SAAS,CAAC,mCAAmC,kBAAkB,SAAS,CAAC,2BAA2B,aAAa,eAAe,CAAC,qCAAqC,uBAAuB,CAAC,4BAA4B,kBAAkB,OAAO,OAAO,CAAC,0CAA0C,mBAAmB,CAAC,0CAA0C,mBAAmB,CAAC,kDAAkD,kBAAkB,SAAS,CAAC,0BAA0B,OAAO,OAAO,CAAC,yBAAyB,mBAAmB,gBAAgB,yBAAyB,yBAAyB,CAAC,uBAAuB,sBAAsB,mBAAmB,4BAA4B,4BAA4B,CAAC,gCAAgC,gBAAgB,CAAC,uCAAuC,YAAY,CAAC,gCAAgC,eAAe,CAAC,2DAA2D,aAAa,CAAC,6BAA6B,gBAAgB,kBAAkB,CAAC,yCAAyC,kBAAkB,CAAC,6EAA6E,qBAAqB,kBAAkB,CAAC,2CAA2C,YAAY,CAAC,6CAA6C,wBAAwB,CAAC,4CAA4C,iBAAiB,CAAC,uCAAuC,gBAAgB,SAAS,CAAC,sDAAsD,OAAO,QAAQ,SAAS,WAAW,gBAAgB,gBAAgB,eAAe,sBAAsB,kBAAkB,eAAe,CAAC,4DAA4D,WAAW,CAAC,4CAA4C,kBAAkB,iBAAiB,UAAU,WAAW,mBAAmB,qBAAqB,gBAAgB,SAAS,iBAAiB,WAAW,CAAC,qCAAqC,qBAAqB,OAAO,OAAO,CAAC,sCAAsC,eAAe,CAAC,8CAA8C,OAAO,2BAA2B,6BAA6B,+BAA+B,CAAC,8CAA8C,QAAQ,2BAA2B,6BAA6B,+BAA+B,CAAC,cAAc,qBAAqB,WAAW,YAAY,iBAAiB,CAAC,sBAAsB,aAAa,CAAC,cAAc,iBAAiB,kBAAkB,CAAC,mBAAmB,iBAAiB,CAAC,kBAAkB,qBAAqB,gBAAgB,CAAC,iCAAiC,kBAAkB,CAAC,iBAAiB,uBAAuB,CAAC,oBAAoB,eAAe,CAAC,8BAA8B,UAAU,CAAC,2DAA2D,WAAW,CAAC,6BAA6B,UAAU,CAAC,yBAAyB,cAAc,CAAC,wCAAwC,mBAAmB,SAAS,CAAC,6BAA6B,eAAe,CAAC,6BAA6B,cAAc,CAAC,sBAAsB,qBAAqB,aAAa,CAAC,kCAAkC,yBAAyB,CAAC,qBAAqB,kBAAkB,MAAM,OAAO,QAAQ,QAAQ,CAAC,qBAAqB,WAAW,YAAY,aAAa,CAAC,eAAe,mBAAmB,sBAAsB,iBAAiB,CAAC,4BAA4B,qBAAqB,CAAC","file":"fullcalendar.min.css","sourcesContent":["/*!\n * FullCalendar v4.0.0-alpha\n * Docs & License: https://fullcalendar.io/\n * (c) 2018 Adam Shaw\n */.fc button,.fc table,body .fc{font-size:1em}.fc-bg,.fc-row .fc-bgevent-skeleton,.fc-row .fc-highlight-skeleton{bottom:0}.fc-icon,.fc-unselectable{-webkit-touch-callout:none;-khtml-user-select:none}.fc{direction:ltr;text-align:left}.fc-rtl{text-align:right}.fc th,.fc-basic-view td.fc-week-number,.fc-icon,.fc-toolbar{text-align:center}.fc-highlight{background:#bce8f1;opacity:.3}.fc-bgevent{background:#8fdf82;opacity:.3}.fc-nonbusiness{background:#d7d7d7}.fc button{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;height:2.1em;padding:0 .6em;white-space:nowrap;cursor:pointer}.fc button::-moz-focus-inner{margin:0;padding:0}.fc-state-default{border:1px solid;background-color:#f5f5f5;background-image:-moz-linear-gradient(top,#fff,#e6e6e6);background-image:-webkit-gradient(linear,0 0,0 100%,from(#fff),to(#e6e6e6));background-image:-webkit-linear-gradient(top,#fff,#e6e6e6);background-image:-o-linear-gradient(top,#fff,#e6e6e6);background-image:linear-gradient(to bottom,#fff,#e6e6e6);background-repeat:repeat-x;border-color:#e6e6e6 #e6e6e6 #bfbfbf;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#333;text-shadow:0 1px 1px rgba(255,255,255,.75);box-shadow:inset 0 1px 0 rgba(255,255,255,.2),0 1px 2px rgba(0,0,0,.05)}.fc-state-default.fc-corner-left{border-top-left-radius:4px;border-bottom-left-radius:4px}.fc-state-default.fc-corner-right{border-top-right-radius:4px;border-bottom-right-radius:4px}.fc button .fc-icon{position:relative;top:-.05em;margin:0 .2em;vertical-align:middle}.fc-state-active,.fc-state-disabled,.fc-state-down,.fc-state-hover{color:#333;background-color:#e6e6e6}.fc-state-hover{color:#333;text-decoration:none;background-position:0 -15px;-webkit-transition:background-position .1s linear;-moz-transition:background-position .1s linear;-o-transition:background-position .1s linear;transition:background-position .1s linear}.fc-state-active,.fc-state-down{background-color:#ccc;background-image:none;box-shadow:inset 0 2px 4px rgba(0,0,0,.15),0 1px 2px rgba(0,0,0,.05)}.fc-state-disabled{cursor:default;background-image:none;opacity:.65;box-shadow:none}.fc-event.fc-draggable,.fc-event[href],.fc-popover .fc-header .fc-close,a[data-goto]{cursor:pointer}.fc-button-group{display:inline-block}.fc .fc-button-group>*{float:left;margin:0 0 0 -1px}.fc .fc-button-group>:first-child{margin-left:0}.fc-popover{position:absolute;box-shadow:0 2px 6px rgba(0,0,0,.15)}.fc-popover .fc-header{padding:2px 4px}.fc-popover .fc-header .fc-title{margin:0 2px}.fc-ltr .fc-popover .fc-header .fc-title,.fc-rtl .fc-popover .fc-header .fc-close{float:left}.fc-ltr .fc-popover .fc-header .fc-close,.fc-rtl .fc-popover .fc-header .fc-title{float:right}.fc-divider{border-style:solid;border-width:1px}hr.fc-divider{height:0;margin:0;padding:0 0 2px;border-width:1px 0}.fc-bg table,.fc-row .fc-bgevent-skeleton table,.fc-row .fc-highlight-skeleton table{height:100%}.fc-clear{clear:both}.fc-bg,.fc-bgevent-skeleton,.fc-helper-skeleton,.fc-highlight-skeleton{position:absolute;top:0;left:0;right:0}.fc table{width:100%;box-sizing:border-box;table-layout:fixed;border-collapse:collapse;border-spacing:0}.fc td,.fc th{border-style:solid;border-width:1px;padding:0;vertical-align:top}.fc td.fc-today{border-style:double}a[data-goto]:hover{text-decoration:underline}.fc .fc-row{border-style:solid;border-width:0}.fc-row table{border-left:0 hidden transparent;border-right:0 hidden transparent;border-bottom:0 hidden transparent}.fc-row:first-child table{border-top:0 hidden transparent}.fc-row{position:relative}.fc-row .fc-bg{z-index:1}.fc-row .fc-bgevent-skeleton td,.fc-row .fc-highlight-skeleton td{border-color:transparent}.fc-row .fc-bgevent-skeleton{z-index:2}.fc-row .fc-highlight-skeleton{z-index:3}.fc-row .fc-content-skeleton{position:relative;z-index:4;padding-bottom:2px}.fc-row .fc-helper-skeleton{z-index:5}.fc .fc-row .fc-content-skeleton table,.fc .fc-row .fc-content-skeleton td,.fc .fc-row .fc-helper-skeleton td{background:0 0;border-color:transparent}.fc-row .fc-content-skeleton td,.fc-row .fc-helper-skeleton td{border-bottom:0}.fc-row .fc-content-skeleton tbody td,.fc-row .fc-helper-skeleton tbody td{border-top:0}.fc-scroller{-webkit-overflow-scrolling:touch}.fc-icon,.fc-row.fc-rigid,.fc-time-grid-event{overflow:hidden}.fc-scroller>.fc-day-grid,.fc-scroller>.fc-time-grid{position:relative;width:100%}.fc-event{position:relative;display:block;font-size:.85em;line-height:1.3;border-radius:3px;border:1px solid #3a87ad}.fc-event,.fc-event-dot{background-color:#3a87ad}.fc-event,.fc-event:hover{color:#fff;text-decoration:none}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc-event .fc-bg{z-index:1;background:#fff;opacity:.25}.fc-event .fc-content{position:relative;z-index:2}.fc-event .fc-resizer{position:absolute;z-index:4;display:none}.fc-event.fc-allow-mouse-resize .fc-resizer,.fc-event.fc-selected .fc-resizer{display:block}.fc-event.fc-selected .fc-resizer:before{content:\"\";position:absolute;z-index:9999;top:50%;left:50%;width:40px;height:40px;margin-left:-20px;margin-top:-20px}.fc-event.fc-selected{z-index:9999!important;box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event.fc-selected.fc-dragging{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-h-event.fc-selected:before{content:\"\";position:absolute;z-index:3;top:-10px;bottom:-10px;left:0;right:0}.fc-ltr .fc-h-event.fc-not-start,.fc-rtl .fc-h-event.fc-not-end{margin-left:0;border-left-width:0;padding-left:1px;border-top-left-radius:0;border-bottom-left-radius:0}.fc-ltr .fc-h-event.fc-not-end,.fc-rtl .fc-h-event.fc-not-start{margin-right:0;border-right-width:0;padding-right:1px;border-top-right-radius:0;border-bottom-right-radius:0}.fc-ltr .fc-h-event .fc-start-resizer,.fc-rtl .fc-h-event .fc-end-resizer{cursor:w-resize;left:-1px}.fc-ltr .fc-h-event .fc-end-resizer,.fc-rtl .fc-h-event .fc-start-resizer{cursor:e-resize;right:-1px}.fc-h-event.fc-allow-mouse-resize .fc-resizer{width:7px;top:-1px;bottom:-1px}.fc-h-event.fc-selected .fc-resizer{border-radius:4px;border-width:1px;width:6px;height:6px;border-style:solid;border-color:inherit;background:#fff;top:50%;margin-top:-4px}.fc-ltr .fc-h-event.fc-selected .fc-start-resizer,.fc-rtl .fc-h-event.fc-selected .fc-end-resizer{margin-left:-4px}.fc-ltr .fc-h-event.fc-selected .fc-end-resizer,.fc-rtl .fc-h-event.fc-selected .fc-start-resizer{margin-right:-4px}.fc-day-grid-event{margin:1px 2px 0;padding:0 1px}tr:first-child>td>.fc-day-grid-event{margin-top:2px}.fc-helper-skeleton tr:first-child>td>.fc-day-grid-event{margin-top:0}.fc-day-grid-event.fc-selected:after{content:\"\";position:absolute;z-index:1;top:-1px;right:-1px;bottom:-1px;left:-1px;background:#000;opacity:.25}.fc-day-grid-event .fc-content{white-space:nowrap;overflow:hidden}.fc-day-grid-event .fc-time{font-weight:700}.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer,.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer{margin-left:-2px}.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer,.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer{margin-right:-2px}a.fc-more{margin:1px 3px;font-size:.85em;cursor:pointer;text-decoration:none}a.fc-more:hover{text-decoration:underline}.fc.fc-bootstrap3 a,.ui-widget .fc-event{text-decoration:none}.fc-limited{display:none}.fc-icon,.fc-toolbar .fc-center{display:inline-block}.fc-day-grid .fc-row{z-index:1}.fc-more-popover{z-index:2;width:220px}.fc-more-popover .fc-event-container{padding:10px}.fc-bootstrap3 .fc-popover .panel-body,.fc-bootstrap4 .fc-popover .card-body{padding:0}.fc-now-indicator{position:absolute;border:0 solid red}.fc-bootstrap3 .fc-today.alert,.fc-bootstrap4 .fc-today.alert{border-radius:0}.fc-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fc-unthemed .fc-content,.fc-unthemed .fc-divider,.fc-unthemed .fc-list-heading td,.fc-unthemed .fc-list-view,.fc-unthemed .fc-popover,.fc-unthemed .fc-row,.fc-unthemed tbody,.fc-unthemed td,.fc-unthemed th,.fc-unthemed thead{border-color:#ddd}.fc-unthemed .fc-popover{background-color:#fff;border-width:1px;border-style:solid}.fc-unthemed .fc-divider,.fc-unthemed .fc-list-heading td,.fc-unthemed .fc-popover .fc-header{background:#eee}.fc-unthemed td.fc-today{background:#fcf8e3}.fc-unthemed .fc-disabled-day{background:#d7d7d7;opacity:.3}.fc-icon{height:1em;line-height:1em;font-size:1em;font-family:\"Courier New\",Courier,monospace;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.fc-icon:after{position:relative}.fc-icon-left-single-arrow:after{content:\"\\2039\";font-weight:700;font-size:200%;top:-7%}.fc-icon-right-single-arrow:after{content:\"\\203A\";font-weight:700;font-size:200%;top:-7%}.fc-icon-left-double-arrow:after{content:\"\\AB\";font-size:160%;top:-7%}.fc-icon-right-double-arrow:after{content:\"\\BB\";font-size:160%;top:-7%}.fc-icon-left-triangle:after{content:\"\\25C4\";font-size:125%;top:3%}.fc-icon-right-triangle:after{content:\"\\25BA\";font-size:125%;top:3%}.fc-icon-down-triangle:after{content:\"\\25BC\";font-size:125%;top:2%}.fc-icon-x:after{content:\"\\D7\";font-size:200%;top:6%}.fc-unthemed .fc-popover .fc-header .fc-close{color:#666;font-size:.9em;margin-top:2px}.fc-unthemed .fc-list-item:hover td{background-color:#f5f5f5}.ui-widget .fc-disabled-day{background-image:none}.fc-bootstrap3 .fc-time-grid .fc-slats table,.fc-bootstrap4 .fc-time-grid .fc-slats table,.fc-time-grid .fc-slats .ui-widget-content{background:0 0}.fc-popover>.ui-widget-header+.ui-widget-content{border-top:0}.fc-bootstrap3 hr.fc-divider,.fc-bootstrap4 hr.fc-divider{border-color:inherit}.ui-widget .fc-event{color:#fff;font-weight:400}.ui-widget td.fc-axis{font-weight:400}.fc.fc-bootstrap3 a[data-goto]:hover{text-decoration:underline}.fc.fc-bootstrap4 a{text-decoration:none}.fc.fc-bootstrap4 a[data-goto]:hover{text-decoration:underline}.fc-bootstrap4 a.fc-event:not([href]):not([tabindex]){color:#fff}.fc-bootstrap4 .fc-popover.card{position:absolute}.fc-toolbar.fc-header-toolbar{margin-bottom:1em}.fc-toolbar.fc-footer-toolbar{margin-top:1em}.fc-toolbar .fc-left{float:left}.fc-toolbar .fc-right{float:right}.fc .fc-toolbar>*>*{float:left;margin-left:.75em}.fc .fc-toolbar>*>:first-child{margin-left:0}.fc-toolbar h2{margin:0}.fc-toolbar button{position:relative}.fc-toolbar .fc-state-hover,.fc-toolbar .ui-state-hover{z-index:2}.fc-toolbar .fc-state-down{z-index:3}.fc-toolbar .fc-state-active,.fc-toolbar .ui-state-active{z-index:4}.fc-toolbar button:focus{z-index:5}.fc-view-container *,.fc-view-container :after,.fc-view-container :before{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}.fc-view,.fc-view>table{position:relative;z-index:1}.fc-basicDay-view .fc-content-skeleton,.fc-basicWeek-view .fc-content-skeleton{padding-bottom:1em}.fc-basic-view .fc-body .fc-row{min-height:4em}.fc-row.fc-rigid .fc-content-skeleton{position:absolute;top:0;left:0;right:0}.fc-day-top.fc-other-month{opacity:.3}.fc-basic-view .fc-day-number,.fc-basic-view .fc-week-number{padding:2px}.fc-basic-view th.fc-day-number,.fc-basic-view th.fc-week-number{padding:0 2px}.fc-ltr .fc-basic-view .fc-day-top .fc-day-number{float:right}.fc-rtl .fc-basic-view .fc-day-top .fc-day-number{float:left}.fc-ltr .fc-basic-view .fc-day-top .fc-week-number{float:left;border-radius:0 0 3px}.fc-rtl .fc-basic-view .fc-day-top .fc-week-number{float:right;border-radius:0 0 0 3px}.fc-basic-view .fc-day-top .fc-week-number{min-width:1.5em;text-align:center;background-color:#f2f2f2;color:grey}.fc-basic-view td.fc-week-number>*{display:inline-block;min-width:1.25em}.fc-agenda-view .fc-day-grid{position:relative;z-index:2}.fc-agenda-view .fc-day-grid .fc-row{min-height:3em}.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton{padding-bottom:1em}.fc .fc-axis{vertical-align:middle;padding:0 4px;white-space:nowrap}.fc-ltr .fc-axis{text-align:right}.fc-rtl .fc-axis{text-align:left}.fc-time-grid,.fc-time-grid-container{position:relative;z-index:1}.fc-time-grid{min-height:100%}.fc-time-grid table{border:0 hidden transparent}.fc-time-grid>.fc-bg{z-index:1}.fc-time-grid .fc-slats,.fc-time-grid>hr{position:relative;z-index:2}.fc-time-grid .fc-content-col{position:relative}.fc-time-grid .fc-content-skeleton{position:absolute;z-index:3;top:0;left:0;right:0}.fc-time-grid .fc-business-container{position:relative;z-index:1}.fc-time-grid .fc-bgevent-container{position:relative;z-index:2}.fc-time-grid .fc-highlight-container{z-index:3;position:relative}.fc-time-grid .fc-event-container{position:relative;z-index:4}.fc-time-grid .fc-now-indicator-line{z-index:5}.fc-time-grid .fc-helper-container{position:relative;z-index:6}.fc-time-grid .fc-slats td{height:1.5em;border-bottom:0}.fc-time-grid .fc-slats .fc-minor td{border-top-style:dotted}.fc-time-grid .fc-highlight{position:absolute;left:0;right:0}.fc-ltr .fc-time-grid .fc-event-container{margin:0 2.5% 0 2px}.fc-rtl .fc-time-grid .fc-event-container{margin:0 2px 0 2.5%}.fc-time-grid .fc-bgevent,.fc-time-grid .fc-event{position:absolute;z-index:1}.fc-time-grid .fc-bgevent{left:0;right:0}.fc-v-event.fc-not-start{border-top-width:0;padding-top:1px;border-top-left-radius:0;border-top-right-radius:0}.fc-v-event.fc-not-end{border-bottom-width:0;padding-bottom:1px;border-bottom-left-radius:0;border-bottom-right-radius:0}.fc-time-grid-event.fc-selected{overflow:visible}.fc-time-grid-event.fc-selected .fc-bg{display:none}.fc-time-grid-event .fc-content{overflow:hidden}.fc-time-grid-event .fc-time,.fc-time-grid-event .fc-title{padding:0 1px}.fc-time-grid-event .fc-time{font-size:.85em;white-space:nowrap}.fc-time-grid-event.fc-short .fc-content{white-space:nowrap}.fc-time-grid-event.fc-short .fc-time,.fc-time-grid-event.fc-short .fc-title{display:inline-block;vertical-align:top}.fc-time-grid-event.fc-short .fc-time span{display:none}.fc-time-grid-event.fc-short .fc-time:before{content:attr(data-start)}.fc-time-grid-event.fc-short .fc-time:after{content:\"\\A0-\\A0\"}.fc-time-grid-event.fc-short .fc-title{font-size:.85em;padding:0}.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer{left:0;right:0;bottom:0;height:8px;overflow:hidden;line-height:8px;font-size:11px;font-family:monospace;text-align:center;cursor:s-resize}.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer:after{content:\"=\"}.fc-time-grid-event.fc-selected .fc-resizer{border-radius:5px;border-width:1px;width:8px;height:8px;border-style:solid;border-color:inherit;background:#fff;left:50%;margin-left:-5px;bottom:-5px}.fc-time-grid .fc-now-indicator-line{border-top-width:1px;left:0;right:0}.fc-time-grid .fc-now-indicator-arrow{margin-top:-5px}.fc-ltr .fc-time-grid .fc-now-indicator-arrow{left:0;border-width:5px 0 5px 6px;border-top-color:transparent;border-bottom-color:transparent}.fc-rtl .fc-time-grid .fc-now-indicator-arrow{right:0;border-width:5px 6px 5px 0;border-top-color:transparent;border-bottom-color:transparent}.fc-event-dot{display:inline-block;width:10px;height:10px;border-radius:5px}.fc-rtl .fc-list-view{direction:rtl}.fc-list-view{border-width:1px;border-style:solid}.fc .fc-list-table{table-layout:auto}.fc-list-table td{border-width:1px 0 0;padding:8px 14px}.fc-list-table tr:first-child td{border-top-width:0}.fc-list-heading{border-bottom-width:1px}.fc-list-heading td{font-weight:700}.fc-ltr .fc-list-heading-main{float:left}.fc-ltr .fc-list-heading-alt,.fc-rtl .fc-list-heading-main{float:right}.fc-rtl .fc-list-heading-alt{float:left}.fc-list-item.fc-has-url{cursor:pointer}.fc-list-item-marker,.fc-list-item-time{white-space:nowrap;width:1px}.fc-ltr .fc-list-item-marker{padding-right:0}.fc-rtl .fc-list-item-marker{padding-left:0}.fc-list-item-title a{text-decoration:none;color:inherit}.fc-list-item-title a[href]:hover{text-decoration:underline}.fc-list-empty-wrap2{position:absolute;top:0;left:0;right:0;bottom:0}.fc-list-empty-wrap1{width:100%;height:100%;display:table}.fc-list-empty{display:table-cell;vertical-align:middle;text-align:center}.fc-unthemed .fc-list-empty{background-color:#eee}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('full-calendar',{ref:"calendar",attrs:{"event-sources":_vm.eventSources,"config":_vm.calendarConfig,"events":_vm.calendarEvents}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_vuetify_aggregator_card__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vuetify_dialog_confirm__ = __webpack_require__(553);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyObservationAggregator',

  components: {
    VuetifyAggregatorCard: __WEBPACK_IMPORTED_MODULE_1__layouts_vuetify_aggregator_card__["a" /* default */],
    VuetifyDialogConfirm: __WEBPACK_IMPORTED_MODULE_2__components_vuetify_dialog_confirm__["a" /* default */]
  },

  props: {
    observations: {
      type: Array,
      default: null,
      required: true
    },
    addButton: {
      type: Boolean,
      default: true,
      required: false
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    },
    theTitleDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    canEdit: {
      type: Boolean,
      default: true,
      required: false
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    textFieldLabel: {
      type: String,
      default: 'Phone',
      required: false
    },
    textFieldRules: {
      type: Array,
      default: null,
      required: false
    },
    selectLabel: {
      type: String,
      default: 'Type',
      required: false
    },
    observationTypes: {
      type: Array,
      default: null,
      required: false
    },
    dialogConfirmHeadline: {
      type: String,
      default: 'Delete area',
      required: false
    },
    dialogConfirmText: {
      type: String,
      default: 'Estás a punto de eliminar un área de trabajo',
      required: false
    },
    cancelButton: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmButton: {
      type: String,
      default: 'Confirm',
      required: false
    },
    deleteIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    value: {
      type: Array,
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      titleDisabled: false,
      dialog: false,
      valid: false,
      title: '',
      date: '',
      message: '',
      type: '',
      user: '',
      preview: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: [{
        text: 'Phone'
      }, {
        text: 'Mobile'
      }, {
        text: 'Fax'
      }],
      theObservationType: '1',
      observationType: null,
      observationTitle: null,
      observationMsg: null,
      observationRef: null
    };
  },

  created: function created() {
    this.items = this.observations;
  },


  watch: {
    theTitleDisabled: {
      handler: function handler(newVal, oldVal) {
        this.titleDisabled = this.theTitleDisabled;
      },
      deep: true
    },
    observationTypes: {
      handler: function handler(newVal, oldVal) {
        this.types = newVal;
        this.observationType = this.types[0];
      },
      deep: true
    },

    observations: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal;
      },
      deep: true
    },

    items: {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:value', newVal);
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    askForConfirmation: function askForConfirmation(index) {
      this.currentIndex = index;
      this.showConfirmDialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    humanize: function humanize(date) {
      return 'Enviado por ' + this.user + ' el ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD-MM-YYYY') + ' a las ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('HH:mm') + 'h.';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.deleteObservation();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteObservation: function deleteObservation() {
      this.$emit('on-delete-observation', this.currentIndex, this.items[this.currentIndex]);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openMessage: function openMessage(index) {
      if (!this.showConfirmDialog) {
        this.message = this.items[index].booking_observation_message;
        this.user = this.items[index].booking_observation_user;
        this.title = this.items[index].booking_observation_title;
        this.date = this.humanize(this.items[index].booking_observation_created);
        this.type = this.items[index].booking_observation_type;
        this.preview = true;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    closeAggregator: function closeAggregator() {
      this.$refs.aggregator.dialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openAggregator: function openAggregator(type, title, message, ref, dialog, titleDisabled) {
      this.titleDisabled = titleDisabled || false;
      this.observationTitle = title || '';
      this.observationRef = ref || '';
      this.theObservationType = type || '1';
      this.observationMsg = message || '';
      this.$refs.aggregator.dialog = !(dialog === false);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addObservation: function addObservation() {
      this.closeAggregator();
      var item = {
        booking_id: 0,
        booking_observation_message: this.observationMsg,
        user_id: 0,
        booking_observation_id: 0,
        booking_observation_ref: this.observationRef,
        booking_observation_title: this.observationTitle,
        booking_observation_type: this.theObservationType
      };
      this.$refs.form.reset();
      this.$emit('on-add-observation', item);
      this.theObservationType = '1';
      this.observationTitle = '';
    }
  }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__ = __webpack_require__(553);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyDocumentAggregator',

  components: {
    VuetifyAggregatorCard: __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__["a" /* default */],
    VuetifyDialogConfirm: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__["a" /* default */]
  },

  props: {
    documents: {
      type: Array,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    textFieldLabel: {
      type: String,
      default: 'Phone',
      required: false
    },
    textFieldRules: {
      type: Array,
      default: null,
      required: false
    },
    selectLabel: {
      type: String,
      default: 'Type',
      required: false
    },
    documentTypes: {
      type: Array,
      default: null,
      required: false
    },
    dialogConfirmHeadline: {
      type: String,
      default: 'Delete area',
      required: false
    },
    dialogConfirmText: {
      type: String,
      default: 'Estás a punto de eliminar un área de trabajo',
      required: false
    },
    cancelButton: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmButton: {
      type: String,
      default: 'Confirm',
      required: false
    },
    deleteIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    value: {
      type: Array,
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      dialog: false,
      valid: false,
      title: '',
      url: '',
      filename: '',
      filetype: '',
      type: '',
      user: '',
      loader: null,
      loading: false,
      preview: false,
      disableTitle: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: [{
        text: 'Phone'
      }, {
        text: 'Mobile'
      }, {
        text: 'Fax'
      }],
      theDocumentType: '1',
      file: null,
      documentType: null,
      documentTitle: null,
      documentMsg: null,
      theDialogToolbarTitle: ''
    };
  },

  created: function created() {
    this.items = this.documents;
    this.theDialogToolbarTitle = this.dialogToolbarTitle;
  },


  watch: {
    documentTypes: {
      handler: function handler(newVal, oldVal) {
        this.types = newVal;
        this.documentType = this.types[0];
      },
      deep: true
    },

    documents: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal;
      },
      deep: true
    },

    items: {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:value', newVal);
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    askForConfirmation: function askForConfirmation(index) {
      this.currentIndex = index;
      this.showConfirmDialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    checkFile: function checkFile() {
      this.loading = true;
      var file = this.$refs.input.files[0];
      this.filename = this.filename || file.name || '';
      this.filetype = file.type || '';
      var reader = new FileReader();
      reader.readAsDataURL(file);
      var self = this;
      reader.addEventListener('load', function () {
        self.url = reader.result;
        self.loading = false;
      }, false);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    selectSignatureFile: function selectSignatureFile() {
      this.$refs.input.value = '';
      this.$refs.input.click();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.deleteDocument();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteDocument: function deleteDocument() {
      this.$emit('on-delete-document', this.currentIndex, this.items[this.currentIndex]);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openFile: function openFile(index) {
      console.error(this.items);
      if (!this.showConfirmDialog) {
        console.log('ddddddddd', this.items[index].booking_document_url);
        var win = window.open(this.items[index].booking_document_url.replace('public/documents/bookings', 'shared/documents/bookings') + '?isAuthorized', '_blank');
        win.focus();
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openDialog: function openDialog(dialogTitle, title, disableTitle, filename) {
      this.disableTitle = disableTitle;
      this.theDialogToolbarTitle = dialogTitle;
      this.documentTitle = title || this.documentTitle;
      this.theDialogToolbarTitle = dialogTitle;
      this.filename = filename || this.filename;
      this.$refs.aggregator.dialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    closeDialog: function closeDialog() {
      this.documentTitle = '';
      this.disableTitle = false;
      this.theDialogToolbarTitle = this.dialogToolbarTitle;
      this.$refs.aggregator.dialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addDocument: function addDocument() {
      var item = {
        booking_id: 0,
        booking_document_url: this.url,
        user_id: 0,
        booking_document_id: 0,
        booking_document_title: this.documentTitle,
        booking_document_filetype: this.filetype,
        booking_document_filename: this.filename
      };
      this.$refs.form.reset();
      this.url = '';
      this.filename = '';
      this.filetype = '';
      this.$emit('on-add-document', item);
      this.closeDialog();
    }
  }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_rule__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vuetify_form_creator_vuetify_form_creator__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_vuetify_aggregator_card__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vuetify_dialog_confirm__ = __webpack_require__(553);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VuetifyEquipmentAggregator',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_rule__["a" /* default */]],
  components: {
    VuetifyAggregatorCard: __WEBPACK_IMPORTED_MODULE_3__layouts_vuetify_aggregator_card__["a" /* default */],
    VuetifyDialogConfirm: __WEBPACK_IMPORTED_MODULE_4__components_vuetify_dialog_confirm__["a" /* default */],
    VuetifyFormCreator: __WEBPACK_IMPORTED_MODULE_2__components_vuetify_form_creator_vuetify_form_creator__["a" /* default */]
  },

  props: {
    equipments: {
      type: Array,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 600,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    rateId: {
      type: String,
      required: true
    },
    textFieldLabel: {
      type: String,
      default: 'Phone',
      required: false
    },
    textFieldRules: {
      type: Array,
      default: null,
      required: false
    },
    selectLabel: {
      type: String,
      default: 'Type',
      required: false
    },
    equipmentsList: {
      type: Object,
      default: null,
      required: false
    },
    dialogConfirmHeadline: {
      type: String,
      default: 'Delete area',
      required: false
    },
    dialogConfirmText: {
      type: String,
      default: 'Estás a punto de eliminar un área de trabajo',
      required: false
    },
    cancelButton: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmButton: {
      type: String,
      default: 'Confirm',
      required: false
    },
    deleteIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    canEdit: {
      type: Boolean,
      default: true,
      required: false
    },
    value: {
      type: Array,
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      dialog: false,
      valid: false,
      step: 1,
      title: '',
      message: '',
      user: '',
      preview: false,
      currentEquipment: null,
      showConfirmDialog: false,
      currentIndex: 0,
      form: [],
      questions: [{
        assign_to: 'details',
        type: 'radio-group',
        label: '¿Hay desinstalación? (EXTRA)',
        columns: 'xs12 sm12 md12 lg12',
        value: '',
        item_text: 'quantity_value',
        item_value: 'quantity_id',
        avatars: false,
        options: [{
          value: 'Sí',
          label: 'Sí',
          hint: 'ATENCIÓN: Si hay desinstalación, es un extra. Informar al cliente de ello.'
        }, {
          value: 'No',
          label: 'No'
        }],
        rules: [function (v) {
          return !!v || 'Requerido';
        }],
        required: true,
        autocomplete: true,
        disabled: false,
        chips: true
      }, {
        assign_to: 'details',
        type: 'radio-group',
        label: '¿Es posible que haya más de 4 metros de instalación?',
        columns: 'xs12 sm12 md12 lg12',
        value: 'No',
        item_text: 'quantity_value',
        item_value: 'quantity_id',
        avatars: false,
        options: [{
          value: 'Sí',
          label: 'Sí',
          hint: 'ATENCIÓN: posibles extras a pagar el día de la instalación. Informar al cliente de ello.'
        }, {
          value: 'No',
          label: 'No'
        }],
        rules: [function (v) {
          return !!v || 'Requerido';
        }],
        required: true,
        autocomplete: true,
        disabled: false,
        chips: true
      }, {
        assign_to: 'details',
        type: 'radio-group',
        label: '¿Hay preinstalación o tubos existentes empotrados?',
        columns: 'xs12 sm12 md12 lg12',
        value: 'No',
        item_text: 'quantity_value',
        item_value: 'quantity_id',
        avatars: false,
        options: [{
          value: 'Sí',
          label: 'Sí',
          hint: 'ATENCIÓN: informar al cliente que a veces es necesario realizar pruebas con nitrógeno, y es un extra. Esto se decidirá el mismo día de la instalación con el cliente, o se puede pedir primero un presupuesto.'
        }, {
          value: 'No',
          label: 'No'
        }],
        rules: [function (v) {
          return !!v || 'Requerido';
        }],
        required: true,
        autocomplete: true,
        disabled: false,
        chips: true
      }, {
        assign_to: 'details',
        type: 'radio-group',
        label: '¿Hay ascensor?',
        columns: 'xs12 sm12 md12 lg12',
        value: '',
        item_text: 'quantity_value',
        item_value: 'quantity_id',
        avatars: false,
        options: [{
          value: 'Sí',
          label: 'Sí'
        }, {
          value: 'No',
          label: 'No'
        }],
        rules: [],
        autocomplete: true,
        disabled: false,
        chips: true
      }, {
        assign_to: 'details',
        type: 'radio-group',
        label: '¿Se necesita escalera larga?',
        columns: 'xs12 sm12 md12 lg12',
        value: '',
        item_text: 'quantity_value',
        item_value: 'quantity_id',
        avatars: false,
        options: [{
          value: 'Sí',
          label: 'Sí',
          hint: 'ATENCIÓN: Si se necesita escalera larga, es un extra. Informar al cliente de ello.'
        }, {
          value: 'No',
          label: 'No'
        }, {
          value: 'No sabe',
          label: 'No sabe'
        }],
        rules: [function (v) {
          return !!v || 'Requerido';
        }],
        required: true,
        autocomplete: true,
        disabled: false,
        chips: true
      }],
      quantity: {
        type: 'select',
        ref: 'quantity',
        columns: 'xs12 sm12 md12 lg12',
        required: true,
        label: 'Cantidad',
        items: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
        value: '1',
        autocomplete: true
      },
      brand: {
        type: 'select',
        ref: 'brand',
        columns: 'xs12 sm6 md6 lg6',
        required: true,
        label: 'Marca',
        item_text: undefined,
        item_value: undefined,
        items: [],
        value: undefined
      },
      model: {
        type: 'select',
        ref: 'model',
        columns: 'xs12 sm6 md6 lg6',
        required: true,
        label: 'Modelo',
        item_text: 'seller_name',
        item_value: 'seller_id',
        items: [],
        value: undefined
      },
      installationType: {
        type: 'text-field',
        columns: 'xs12 sm6 md6 lg6',
        rules: ['required'],
        editable: true,
        required: true,
        label: 'Tipo de instalación',
        disabled: true,
        value: ''
      },
      installationPrice: {
        type: 'text-field',
        columns: 'xs12 sm6 md6 lg6',
        rules: ['required'],
        editable: true,
        required: true,
        label: 'Importe a cobrar',
        disabled: true,
        value: ''
      },
      indoorUnit1: {
        type: 'text-field',
        columns: 'xs12 sm6 md6 lg6',
        rules: ['required'],
        editable: true,
        required: true,
        label: 'Modelo unidad interior 1',
        disabled: true,
        value: ''
      },
      indoorUnit2: {
        type: 'text-field',
        columns: 'xs12 sm6 md6 lg6',
        rules: ['required'],
        editable: true,
        required: true,
        label: 'Modelo unidad interior 2',
        disabled: true,
        value: ''
      },
      duration: {
        type: 'hidden',
        columns: 'xs12 sm12 md12 lg12',
        rules: ['required'],
        editable: false,
        required: true,
        label: 'Duración de la instalación',
        disabled: true,
        value: ''
      },
      paymentMethod: {
        type: 'select',
        ref: 'paymentMethod',
        columns: 'xs12 sm6 md6 lg6',
        required: true,
        label: 'Forma de pago',
        items: ['Se pagará I.B. al instalador', 'Se ha pagado I.B. en tienda'],
        value: '',
        autocomplete: true
      },
      hasBeenPaid: {
        type: 'text-field',
        columns: 'xs12 sm6 md6 lg6',
        rules: ['required'],
        editable: true,
        required: true,
        label: 'Ha pagado',
        disabled: true,
        value: ''
      },
      formAggregator: [],
      equipmentType: null,
      equipmentTitle: null,
      equipmentMsg: null
    };
  },

  created: function created() {
    this.items = this.equipments;
    this.formAggregator = [];
    this.formAggregator.push(this.quantity);
    this.formAggregator.push(this.brand);
    this.formAggregator.push(this.model);
    this.installationType.rules = this.setRules(this.installationType.rules);
    this.formAggregator.push(this.installationType);
    this.installationPrice.rules = this.setRules(this.installationPrice.rules);
    this.formAggregator.push(this.installationPrice);
    this.indoorUnit1.rules = this.setRules(this.indoorUnit1.rules);
    this.formAggregator.push(this.indoorUnit1);
    this.indoorUnit2.rules = this.setRules(this.indoorUnit2.rules);
    this.formAggregator.push(this.indoorUnit2);
    this.formAggregator.push(this.paymentMethod);
    this.hasBeenPaid.rules = this.setRules(this.hasBeenPaid.rules);
    this.formAggregator.push(this.hasBeenPaid);
  },


  watch: {
    equipmentTypes: {
      handler: function handler(newVal, oldVal) {
        this.types = newVal;
        this.equipmentType = this.types[0];
      },
      deep: true
    },

    equipmentsList: {
      handler: function handler(newVal, oldVal) {
        this.brand.item_text = newVal.item_text_3 || undefined;
        this.brand.item_value = newVal.item_text_3 || undefined;
        this.brand.items = newVal.items || [];
        this.brand.value = undefined;
        this.model.item_text = newVal.item_text_4 || undefined;
        this.model.item_value = newVal.item_text_value || undefined;
      },
      deep: true
    },

    equipments: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal;
      },
      deep: true
    },

    items: {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:value', newVal);
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    askForConfirmation: function askForConfirmation(index) {
      this.currentIndex = index;
      this.showConfirmDialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange: function onChange(newVal, oldVal, item, isValid) {
      var _this = this;

      if (newVal && item.ref === 'brand') {
        this.model.items = [];
        this.installationType.value = '';
        this.indoorUnit1.value = '';
        this.indoorUnit2.value = '';
        this.duration.value = '';
        this.installationPrice.value = '';
        this.paymentMethod.value = '';
        this.hasBeenPaid.value = '';
        this.equipmentsList.items.forEach(function (item, index) {
          var brand = item[_this.equipmentsList.item_text_3];
          if (brand === newVal) {
            _this.model.items.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, _this.equipmentsList.item_text_4, item[_this.equipmentsList.item_text_4]));
            _this.currentEquipment = item;
          }
        });
      } else if (newVal && this.currentEquipment && item.ref === 'model') {
        newVal = newVal[this.equipmentsList.item_text_4];
        this.equipmentsList.items.forEach(function (item, index) {
          var model = item[_this.equipmentsList.item_text_4];
          if (model === newVal) {
            _this.currentEquipment = item;
          }
        });
        this.installationType.value = this.currentEquipment[this.equipmentsList.item_text_12];
        this.indoorUnit1.value = this.currentEquipment[this.equipmentsList.item_text_5];
        this.indoorUnit2.value = this.currentEquipment[this.equipmentsList.item_text_6];
        this.duration.value = this.currentEquipment[this.equipmentsList.item_text_17];
        if (this.rateId === '1') {
          this.installationPrice.value = this.currentEquipment[this.equipmentsList.item_text_14] + '€ (IVA no incluido)';
        } else if (this.rateId === '2') {
          this.installationPrice.value = this.currentEquipment[this.equipmentsList.item_text_15] + '€ (IVA no incluido)';
        } else if (this.rateId === '3') {
          this.installationPrice.value = this.currentEquipment[this.equipmentsList.item_text_16] + '€ (IVA no incluido)';
        }
      } else if (newVal && item.ref === 'paymentMethod') {
        this.paymentMethod.value = newVal;
        if (newVal === 'Se pagará I.B. al instalador') {
          this.hasBeenPaid.value = '¡No se ha pagado la I.B.!';
        } else {
          this.hasBeenPaid.value = 'I.B. ' + this.currentEquipment[this.equipmentsList.item_text_12];
        }
      } else if (newVal && item.ref === 'quantity') {
        this.quantity.value = newVal;
      } else if (newVal && (item.ref === 'serial_indoor_unit_1' || item.ref === 'serial_indoor_unit_2' || item.ref === 'serial_outdoor_unit_1')) {
        this.items[0][item.ref] = newVal;
        this.$emit('on-add-equipment', this.items[0]);
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    compare: function compare(a, b) {
      if (a.order < b.order) {
        return -1;
      }
      if (a.order > b.order) {
        return 1;
      }
      return 0;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeEquipment: function normalizeEquipment(equipmentIndex) {
      var i = 0;
      var form = [];
      var equipment = this.items[equipmentIndex];
      for (var key in equipment) {
        form[i] = {};
        form[i].label = key;
        form[i].columns = 'xs12 sm6 md6 lg6';
        form[i].editable = true;
        form[i].disabled = true;
        form[i].type = 'text-field';
        form[i].value = equipment[key];
        switch (key) {
          case 'id':
            form.splice(i, 1);
            break;
          case 'type':
            form[i].order = 2;
            form[i].label = 'Tipo de equipo';
            break;
          case 'brand':
            form[i].order = 3;
            form[i].label = 'Marca';
            break;
          case 'model':
            form[i].order = 4;
            form[i].label = 'Modelo';
            break;
          case 'indoor_unit_1':
            form[i].order = 5;
            form[i].label = 'Modelo U.I.1';
            break;
          case 'indoor_unit_2':
            form[i].order = 7;
            form[i].label = 'Modelo U.I.2';
            break;
          case 'outdoor_unit_1':
            form[i].order = 9;
            form[i].label = 'Modelo U.E.1';
            break;
          case 'serial_indoor_unit_1':
            form[i].order = 6;
            form[i].disabled = false;
            form[i].editable = false;
            form[i].type = this.canEdit ? 'text-field' : 'plain-text';
            form[i].ref = 'serial_indoor_unit_1';
            form[i].hint = 'Pulsa enter para agregar';
            form[i].tooltip = 'Pulsa para editar';
            form[i].label = 'Número de serie U.I.1';
            break;
          case 'serial_indoor_unit_2':
            form[i].order = 8;
            form[i].disabled = false;
            form[i].editable = false;
            form[i].type = this.canEdit ? 'text-field' : 'plain-text';
            form[i].ref = 'serial_indoor_unit_2';
            form[i].hint = 'Pulsa enter para agregar';
            form[i].tooltip = 'Pulsa para editar';
            form[i].label = 'Número de serie U.I.2';
            break;
          case 'serial_outdoor_unit_1':
            form[i].order = 10;
            form[i].disabled = false;
            form[i].editable = false;
            form[i].type = this.canEdit ? 'text-field' : 'plain-text';
            form[i].ref = 'serial_outdoor_unit_1';
            form[i].hint = 'Pulsa enter para agregar';
            form[i].tooltip = 'Pulsa para editar';
            form[i].label = 'Número de serie U.E.1';
            break;
          case 'refrigerant_type':
            form[i].order = 11;
            form[i].label = 'Tipo de refrigerante';
            break;
          case 'refrigerant_quantity':
            form[i].order = 12;
            form[i].label = 'Cantidad de refrigerante';
            break;
          case 'frigories':
            form[i].order = 13;
            form[i].label = 'Frigorías';
            break;
          case 'quantity':
            form[i].order = 1;
            form[i].label = 'Cantidad';
            break;
          case 'power_source':
            form[i].order = 14;
            form[i].label = 'Fuente de potencia';
            break;
          case 'installation_price':
            form[i].order = 18;
            form[i].label = 'Precio instalación (IVA NO INCLUIDO)';
            form[i].columns = 'xs12 sm12 md12 lg12';
            form[i].value = equipment[key] + '€';
            break;
          case 'payment_method':
            form[i].order = 15;
            form[i].label = 'Forma de pago';
            break;
          case 'has_been_paid':
            form[i].order = 16;
            form[i].label = 'Ha pagado';
            break;
          case 'installation_type':
            form[i].order = 17;
            form[i].label = 'Tipo de instalación';
            form[i].columns = 'xs12 sm12 md12 lg12';
            break;
          case 'duration':
            form[i].order = 19;
            form[i].label = 'Duración de la instalación';
            form[i].columns = 'xs12 sm12 md12 lg12';
            form[i].value = equipment[key] + 'h';
            break;
          case 'question_1':
            form[i].order = 20;
            form[i].label = '¿Hay desinstalación? ';
            form[i].columns = 'xs12 sm12 md12 lg12';
            break;
          case 'question_2':
            form[i].order = 22;
            form[i].label = '¿Es posible que haya más de 4 metros de instalación?';
            form[i].columns = 'xs12 sm12 md12 lg12';
            break;
          case 'question_3':
            form[i].order = 23;
            form[i].label = '¿Hay preinstalación o tubos existentes empotrados?';
            form[i].columns = 'xs12 sm12 md12 lg12';
            break;
          case 'question_4':
            form[i].order = 24;
            form[i].label = '¿Hay ascensor?';
            form[i].columns = 'xs12 sm12 md12 lg12';
            break;
          case 'question_5':
            form[i].order = 25;
            form[i].label = '¿Se necesita escalera larga?';
            form[i].columns = 'xs12 sm12 md12 lg12';
            break;
        }
        i++;
      }
      form.sort(this.compare);
      this.form = form;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.deleteEquipment();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteEquipment: function deleteEquipment() {
      this.items.splice(this.currentIndex, 1);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openMessage: function openMessage(index) {
      if (!this.showConfirmDialog) {
        this.normalizeEquipment(index);
        this.preview = true;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openDialog: function openDialog() {
      this.$refs.aggregator.dialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    closeDialog: function closeDialog() {
      this.$refs.aggregator.dialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addEquipment: function addEquipment() {
      if (this.$refs.equipment_details.validateForm()) {
        this.closeDialog();
        console.error(this.currentEquipment);
        console.error(this.currentEquipment[this.equipmentsList.item_text_9]);
        var item = {
          id: this.currentEquipment[this.equipmentsList.item_value],
          installation_type_id: this.currentEquipment[this.equipmentsList.item_text_18],
          type: this.currentEquipment[this.equipmentsList.item_text_2],
          brand: this.currentEquipment[this.equipmentsList.item_text_3],
          model: this.currentEquipment[this.equipmentsList.item_text_4],
          indoor_unit_1: this.currentEquipment[this.equipmentsList.item_text_5],
          indoor_unit_2: this.currentEquipment[this.equipmentsList.item_text_6],
          outdoor_unit_1: this.currentEquipment[this.equipmentsList.item_text_7],
          serial_indoor_unit_1: '',
          serial_indoor_unit_2: '',
          serial_outdoor_unit_1: '',
          refrigerant_type: this.currentEquipment[this.equipmentsList.item_text_9],
          refrigerant_quantity: this.currentEquipment[this.equipmentsList.item_text_10],
          frigories: this.currentEquipment[this.equipmentsList.item_text_11],
          quantity: this.quantity.value,
          power_source: this.currentEquipment[this.equipmentsList.item_text_8],
          installation_price: this.installationPrice.value,
          payment_method: this.paymentMethod.value,
          has_been_paid: this.hasBeenPaid.value,
          installation_type: this.currentEquipment[this.equipmentsList.item_text_12],
          question_1: this.questions[0].value,
          question_2: this.questions[1].value,
          question_3: this.questions[2].value,
          question_4: this.questions[3].value,
          question_5: this.questions[4].value,
          duration: this.currentEquipment[this.equipmentsList.item_text_17]
        };
        this.$refs.equipment_fields.reset();
        this.$refs.equipment_details.reset();
        this.currentEquipment = null;
        this.items.push(item);
        this.$emit('on-add-equipment', item);
        this.$emit('on-delete-equipment', this.currentIndex, this.items[this.currentIndex]);
      }
    }
  }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_form_creator_vuetify_form_creator__ = __webpack_require__(528);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    VuetifyFormCreator: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_form_creator_vuetify_form_creator__["a" /* default */]
  },

  name: 'VuetifyStepperDialog',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    reference: {
      type: String,
      default: 'dialog_confirm',
      required: false
    },
    value: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: 290,
      required: false
    },
    headline: {
      type: String,
      default: 'Delete element?',
      required: false
    },
    text: {
      type: String,
      default: 'Siguiente',
      required: false
    },
    cancel: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirm: {
      type: String,
      default: 'Confirm',
      required: false
    },
    dark: {
      type: Boolean,
      default: false,
      required: false
    },
    dialog: {
      type: Boolean,
      default: true,
      required: false
    },
    items: {
      type: Array,
      default: null,
      required: true
    }
  },

  data: function data() {
    return {
      progress: 50,
      step: 0,
      isValid: false,
      steps: [{
        fields: []
      }]
    };
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onNext: function onNext() {
      this.isValid = this.$refs.form_creator.validateForm();
      if (this.isValid) {
        this.nextStep();
      }
      this.$emit('on-next-step', this.steps[this.step], this.step, this.isValid);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onLast: function onLast() {
      this.lastStep();
      this.$emit('on-last-step', this.steps[this.step], this.step, this.isValid);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddItem: function onAddItem() {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['on-add-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params)));
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    nextStep: function nextStep() {
      if (this.steps[this.step + 1]) {
        this.step++;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    lastStep: function lastStep() {
      if (this.steps[this.step - 1]) {
        this.step--;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onClickButton: function onClickButton(item) {
      this.$emit('on-click-button', item, this.isValid);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange: function onChange() {
      var _console;

      for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }

      (_console = console).log.apply(_console, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params));
      this.$emit.apply(this, ['on-change'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params)));
    }
  },

  watch: {
    items: {
      handler: function handler(newVal) {
        this.steps = newVal;
      },
      deep: true
    }
  }
});

/***/ }),
/* 654 */,
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_phone_aggregator_vue__ = __webpack_require__(619);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f03cc47c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_phone_aggregator_vue__ = __webpack_require__(662);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_phone_aggregator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f03cc47c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_phone_aggregator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(657);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("aed2851c", content, true, {});

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vuetify-aggregator-card{margin-bottom:20px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/layouts/vuetify-aggregator-card.vue"],"names":[],"mappings":"AACA,yBACE,kBAAoB,CACrB","file":"vuetify-aggregator-card.vue","sourcesContent":["\n.vuetify-aggregator-card {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"vuetify-aggregator-card",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.toolbarTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{directives:[{name:"show",rawName:"v-show",value:(_vm.$slots['card-text'] && _vm.navigationMenu),expression:"$slots['card-text'] && navigationMenu"}],attrs:{"bottom":"","left":""}},[(_vm.canEdit)?_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1):_vm._e(),_vm._v(" "),_c('v-list',{staticClass:"scroll-y",staticStyle:{"max-height":"282px"}},[_c('v-list-tile',{on:{"click":function($event){_vm.dialog = !_vm.dialog}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.listTitle))])],1)],1)],1)],1),_vm._v(" "),(_vm.$slots['card-text'])?_vm._t("card-text"):_c('v-card-text',[_c('div',{staticClass:"add-area"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.addButton),expression:"addButton"}],attrs:{"slot":"activator","fab":"","dark":"","color":_vm.color},on:{"click":function($event){_vm.dialog = true}},slot:"activator"},[_c('v-icon',{attrs:{"dark":"","large":""}},[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.addButtonHoverText))])],1)],1)]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":_vm.dialogMaxWidth,"persistent":_vm.persistent},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._t("dialog"),_vm._v(" "),(!_vm.$slots['dialog'])?_c('v-card',{attrs:{"tile":""}},[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n              "+_vm._s(_vm.dialogToolbarTitle)+"\n            ")]),_vm._v(" "),_c('v-card-text',[_vm._t("dialog-card-text")],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_vm._t("dialog-card-actions")],2)],1):_vm._e()],2),_vm._v(" "),_vm._t("extras")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(660);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("4a8283a0", content, true, {});

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"vuetify-dialog-confirm.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{ref:_vm.reference,attrs:{"max-width":_vm.maxWidth},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('v-card',{attrs:{"dark":_vm.dark}},[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secundary","flat":"flat"},nativeOn:{"click":function($event){_vm.onClick('cancel')}}},[_vm._v(_vm._s(_vm.cancel))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":function($event){_vm.onClick('confirm')}}},[_vm._v(_vm._s(_vm.confirm))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-aggregator-card',{ref:"aggregator",attrs:{"color":_vm.color,"toolbar-title":_vm.toolbarTitle,"list-title":_vm.listTitle,"navigation-menu":_vm.navigationMenu,"add-button-hover-text":_vm.addButtonHoverText,"dialog-max-width":_vm.dialogMaxWidth,"dialog-toolbar-title":_vm.dialogToolbarTitle}},[(_vm.items.length > 0)?_c('v-list',{attrs:{"slot":"card-text","two-line":""},slot:"card-text"},[_c('transition-group',{attrs:{"name":"list","tag":"span"}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:(index + 2 * 100)},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.value))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.type))])],1),_vm._v(" "),(_vm.deleteButton)?_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":_vm.color},on:{"click":function($event){_vm.askForConfirmation(index)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.deleteIconHoverText))])],1)],1):_vm._e()],1),_vm._v(" "),(index + 1 !== _vm.items.length)?_c('v-divider',{key:(index + 1 * 100),attrs:{"inset":false}}):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"slot":"dialog-card-text","row":"","align-center":"","justify-center":""},slot:"dialog-card-text"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg6":""}},[_c('v-form',{ref:"form"},[_c('v-text-field',{attrs:{"label":_vm.textFieldLabel,"single-line":"","required":"","rules":_vm.textFieldRules || []},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg6":""}},[_c('v-select',{attrs:{"items":_vm.types,"label":_vm.selectLabel},model:{value:(_vm.phoneType),callback:function ($$v) {_vm.phoneType=$$v},expression:"phoneType"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"dialog-card-actions"},slot:"dialog-card-actions"},[_c('v-btn',{attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v("\n      "+_vm._s(_vm.cancelButton)+"\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.addPhone()}}},[_vm._v("\n      "+_vm._s(_vm.confirmButton)+"\n    ")])],1),_vm._v(" "),_c('vuetify-dialog-confirm',{attrs:{"slot":"extras","headline":_vm.dialogConfirmHeadline,"text":_vm.dialogConfirmText,"cancel":_vm.cancelButton,"confirm":_vm.confirmButton},on:{"on-cancel-dialog":_vm.onDiscardDeletion,"on-confirm-dialog":_vm.onConfirmDeletion},slot:"extras",model:{value:(_vm.showConfirmDialog),callback:function ($$v) {_vm.showConfirmDialog=$$v},expression:"showConfirmDialog"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_signature_aggregator_vue__ = __webpack_require__(623);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9064b8c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_signature_aggregator_vue__ = __webpack_require__(671);
function injectStyle (ssrContext) {
  __webpack_require__(664)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_signature_aggregator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9064b8c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_signature_aggregator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("7e215cb2", content, true, {});

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".signature-image>div{background-size:240px 120px!important}.signature-card{max-height:206px!important}.signature-actions{padding:18px}.fade-enter-active,.fade-leave-active,.fade-leave-to{-webkit-transition:.3s ease-out;transition:.3s ease-out;position:absolute;top:0;left:0}.fade-enter,.fade-leave,.fade-leave-to{opacity:0}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-signature-aggregator.vue"],"names":[],"mappings":"AACA,qBACE,qCAAwC,CACzC,AACD,gBACE,0BAA6B,CAC9B,AACD,mBACE,YAAc,CACf,AACD,qDACE,gCAAiC,AACjC,wBAAyB,AACzB,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACT,AACD,uCACE,SAAW,CACZ","file":"vuetify-signature-aggregator.vue","sourcesContent":["\n.signature-image > div {\n  background-size: 240px 120px !important;\n}\n.signature-card {\n  max-height: 206px !important;\n}\n.signature-actions {\n  padding: 18px;\n}\n.fade-enter-active, .fade-leave-active, .fade-leave-to {\n  -webkit-transition: .3s ease-out;\n  transition: .3s ease-out;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.fade-enter, .fade-leave, .fade-leave-to {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_signature_pad_vue__ = __webpack_require__(624);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9835709a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_signature_pad_vue__ = __webpack_require__(670);
function injectStyle (ssrContext) {
  __webpack_require__(667)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9835709a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_signature_pad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9835709a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_signature_pad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(668);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("32c9f3d1", content, true, {});

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, "#canvas[data-v-9835709a]{display:none}.wrapper[data-v-9835709a]{position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;margin:0 auto}img[data-v-9835709a]{position:absolute;left:0;top:0}.signature-pad[data-v-9835709a]{position:absolute;left:0;top:0;border:2px dashed #ccc}.input-file[data-v-9835709a]{display:none}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vue-signature-pad.vue"],"names":[],"mappings":"AACA,yBACE,YAAc,CACf,AACD,0BACE,kBAAmB,AACnB,sBAAuB,AACvB,yBAA0B,AAC1B,qBAAsB,AACtB,iBAAkB,AAClB,aAAe,CAChB,AACD,qBACE,kBAAmB,AACnB,OAAQ,AACR,KAAO,CACR,AACD,gCACE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,sBAAwB,CACzB,AACD,6BACE,YAAc,CACf","file":"vue-signature-pad.vue","sourcesContent":["\n#canvas[data-v-9835709a] {\n  display: none;\n}\n.wrapper[data-v-9835709a] {\n  position: relative;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: 0 auto;\n}\nimg[data-v-9835709a] {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.signature-pad[data-v-9835709a] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  border: 2px dashed #ccc;\n}\n.input-file[data-v-9835709a] {\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */

function Point(x, y, time) {
  this.x = x;
  this.y = y;
  this.time = time || new Date().getTime();
}

Point.prototype.velocityFrom = function (start) {
  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};

Point.prototype.distanceTo = function (start) {
  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};

Point.prototype.equals = function (other) {
  return this.x === other.x && this.y === other.y && this.time === other.time;
};

function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function () {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

/* eslint-disable no-multi-spaces, space-in-parens */
Bezier.prototype._point = function (t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

/* eslint-disable */

// http://stackoverflow.com/a/27078401/815507
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function SignaturePad(canvas, options) {
  var self = this;
  var opts = options || {};

  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
  this.minWidth = opts.minWidth || 0.5;
  this.maxWidth = opts.maxWidth || 2.5;
  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

  if (this.throttle) {
    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
  } else {
    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
  }

  this.dotSize = opts.dotSize || function () {
    return (this.minWidth + this.maxWidth) / 2;
  };
  this.penColor = opts.penColor || 'black';
  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
  this.onBegin = opts.onBegin;
  this.onEnd = opts.onEnd;

  this._canvas = canvas;
  this._ctx = canvas.getContext('2d');
  this.clear();

  // We need add these inline so they are available to unbind while still having
  // access to 'self' we could use _.bind but it's not worth adding a dependency.
  this._handleMouseDown = function (event) {
    if (event.which === 1) {
      self._mouseButtonDown = true;
      self._strokeBegin(event);
    }
  };

  this._handleMouseMove = function (event) {
    if (self._mouseButtonDown) {
      self._strokeMoveUpdate(event);
    }
  };

  this._handleMouseUp = function (event) {
    if (event.which === 1 && self._mouseButtonDown) {
      self._mouseButtonDown = false;
      self._strokeEnd(event);
    }
  };

  this._handleTouchStart = function (event) {
    if (event.targetTouches.length === 1) {
      var touch = event.changedTouches[0];
      self._strokeBegin(touch);
    }
  };

  this._handleTouchMove = function (event) {
    // Prevent scrolling.
    event.preventDefault();

    var touch = event.targetTouches[0];
    self._strokeMoveUpdate(touch);
  };

  this._handleTouchEnd = function (event) {
    var wasCanvasTouched = event.target === self._canvas;
    if (wasCanvasTouched) {
      event.preventDefault();
      self._strokeEnd(event);
    }
  };

  // Enable mouse and touch event handlers
  this.on();
}

// Public methods
SignaturePad.prototype.clear = function () {
  var ctx = this._ctx;
  var canvas = this._canvas;

  ctx.fillStyle = this.backgroundColor;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  this._data = [];
  this._reset();
  this._isEmpty = true;
};

SignaturePad.prototype.fromDataURL = function (dataUrl) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var image = new Image();
  var ratio = options.ratio || window.devicePixelRatio || 1;
  var width = options.width || this._canvas.width / ratio;
  var height = options.height || this._canvas.height / ratio;

  this._reset();
  image.src = dataUrl;
  image.onload = function () {
    _this._ctx.drawImage(image, 0, 0, width, height);
  };
  this._isEmpty = false;
};

SignaturePad.prototype.toDataURL = function (type) {
  var _canvas;

  switch (type) {
    case 'image/svg+xml':
      return this._toSVG();
    default:
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
  }
};

SignaturePad.prototype.on = function () {
  this._handleMouseEvents();
  this._handleTouchEvents();
};

SignaturePad.prototype.off = function () {
  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
  document.removeEventListener('mouseup', this._handleMouseUp);

  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype.isEmpty = function () {
  return this._isEmpty;
};

// Private methods
SignaturePad.prototype._strokeBegin = function (event) {
  this._data.push([]);
  this._reset();
  this._strokeUpdate(event);

  if (typeof this.onBegin === 'function') {
    this.onBegin(event);
  }
};

SignaturePad.prototype._strokeUpdate = function (event) {
  var x = event.clientX;
  var y = event.clientY;

  var point = this._createPoint(x, y);
  var lastPointGroup = this._data[this._data.length - 1];
  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;

  // Skip this point if it's too close to the previous one
  if (!(lastPoint && isLastPointTooClose)) {
    var _addPoint = this._addPoint(point),
        curve = _addPoint.curve,
        widths = _addPoint.widths;

    if (curve && widths) {
      this._drawCurve(curve, widths.start, widths.end);
    }

    this._data[this._data.length - 1].push({
      x: point.x,
      y: point.y,
      time: point.time,
      color: this.penColor
    });
  }
};

SignaturePad.prototype._strokeEnd = function (event) {
  var canDrawCurve = this.points.length > 2;
  var point = this.points[0]; // Point instance

  if (!canDrawCurve && point) {
    this._drawDot(point);
  }

  if (point) {
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object

    // When drawing a dot, there's only one point in a group, so without this check
    // such group would end up with exactly the same 2 points.
    if (!point.equals(lastPoint)) {
      lastPointGroup.push({
        x: point.x,
        y: point.y,
        time: point.time,
        color: this.penColor
      });
    }
  }

  if (typeof this.onEnd === 'function') {
    this.onEnd(event);
  }
};

SignaturePad.prototype._handleMouseEvents = function () {
  this._mouseButtonDown = false;

  this._canvas.addEventListener('mousedown', this._handleMouseDown);
  this._canvas.addEventListener('mousemove', this._handleMouseMove);
  document.addEventListener('mouseup', this._handleMouseUp);
};

SignaturePad.prototype._handleTouchEvents = function () {
  // Pass touch events to canvas element on mobile IE11 and Edge.
  this._canvas.style.msTouchAction = 'none';
  this._canvas.style.touchAction = 'none';

  this._canvas.addEventListener('touchstart', this._handleTouchStart, {passive: false}); // CUSTOM CHANGE
  this._canvas.addEventListener('touchmove', this._handleTouchMove, {passive: false}); // CUSTOM CHANGE
  this._canvas.addEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype._reset = function () {
  this.points = [];
  this._lastVelocity = 0;
  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
  this._ctx.fillStyle = this.penColor;
};

SignaturePad.prototype._createPoint = function (x, y, time) {
  var rect = this._canvas.getBoundingClientRect();

  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
};

SignaturePad.prototype._addPoint = function (point) {
  var points = this.points;
  var tmp = void 0;

  points.push(point);

  if (points.length > 2) {
    // To reduce the initial lag make it work with 3 points
    // by copying the first point to the beginning.
    if (points.length === 3) points.unshift(points[0]);

    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
    var c2 = tmp.c2;
    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
    var c3 = tmp.c1;
    var curve = new Bezier(points[1], c2, c3, points[2]);
    var widths = this._calculateCurveWidths(curve);

    // Remove the first element from the list,
    // so that we always have no more than 4 points in points array.
    points.shift();

    return { curve: curve, widths: widths };
  }

  return {};
};

SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
  var dx1 = s1.x - s2.x;
  var dy1 = s1.y - s2.y;
  var dx2 = s2.x - s3.x;
  var dy2 = s2.y - s3.y;

  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

  var dxm = m1.x - m2.x;
  var dym = m1.y - m2.y;

  var k = l2 / (l1 + l2);
  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

  var tx = s2.x - cm.x;
  var ty = s2.y - cm.y;

  return {
    c1: new Point(m1.x + tx, m1.y + ty),
    c2: new Point(m2.x + tx, m2.y + ty)
  };
};

SignaturePad.prototype._calculateCurveWidths = function (curve) {
  var startPoint = curve.startPoint;
  var endPoint = curve.endPoint;
  var widths = { start: null, end: null };

  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

  var newWidth = this._strokeWidth(velocity);

  widths.start = this._lastWidth;
  widths.end = newWidth;

  this._lastVelocity = velocity;
  this._lastWidth = newWidth;

  return widths;
};

SignaturePad.prototype._strokeWidth = function (velocity) {
  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};

SignaturePad.prototype._drawPoint = function (x, y, size) {
  var ctx = this._ctx;

  ctx.moveTo(x, y);
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  this._isEmpty = false;
};

SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
  var ctx = this._ctx;
  var widthDelta = endWidth - startWidth;
  var drawSteps = Math.floor(curve.length());

  ctx.beginPath();

  for (var i = 0; i < drawSteps; i += 1) {
    // Calculate the Bezier (x, y) coordinate for this step.
    var t = i / drawSteps;
    var tt = t * t;
    var ttt = tt * t;
    var u = 1 - t;
    var uu = u * u;
    var uuu = uu * u;

    var x = uuu * curve.startPoint.x;
    x += 3 * uu * t * curve.control1.x;
    x += 3 * u * tt * curve.control2.x;
    x += ttt * curve.endPoint.x;

    var y = uuu * curve.startPoint.y;
    y += 3 * uu * t * curve.control1.y;
    y += 3 * u * tt * curve.control2.y;
    y += ttt * curve.endPoint.y;

    var width = startWidth + ttt * widthDelta;
    this._drawPoint(x, y, width);
  }

  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._drawDot = function (point) {
  var ctx = this._ctx;
  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;

  ctx.beginPath();
  this._drawPoint(point.x, point.y, width);
  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
  for (var i = 0; i < pointGroups.length; i += 1) {
    var group = pointGroups[i];

    if (group.length > 1) {
      for (var j = 0; j < group.length; j += 1) {
        var rawPoint = group[j];
        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
        var color = rawPoint.color;

        if (j === 0) {
          // First point in a group. Nothing to draw yet.

          // All points in the group have the same color, so it's enough to set
          // penColor just at the beginning.
          this.penColor = color;
          this._reset();

          this._addPoint(point);
        } else if (j !== group.length - 1) {
          // Middle point in a group.
          var _addPoint2 = this._addPoint(point),
              curve = _addPoint2.curve,
              widths = _addPoint2.widths;

          if (curve && widths) {
            drawCurve(curve, widths, color);
          }
        } else {
          // Last point in a group. Do nothing.
        }
      }
    } else {
      this._reset();
      var _rawPoint = group[0];
      drawDot(_rawPoint);
    }
  }
};

SignaturePad.prototype._toSVG = function () {
  var _this2 = this;

  var pointGroups = this._data;
  var canvas = this._canvas;
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  var minX = 0;
  var minY = 0;
  var maxX = canvas.width / ratio;
  var maxY = canvas.height / ratio;
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttributeNS(null, 'width', canvas.width);
  svg.setAttributeNS(null, 'height', canvas.height);

  this._fromData(pointGroups, function (curve, widths, color) {
    var path = document.createElement('path');

    // Need to check curve for NaN values, these pop up when drawing
    // lines on the canvas that are not continuous. E.g. Sharp corners
    // or stopping mid-stroke and than continuing without lifting mouse.
    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));

      path.setAttribute('d', attr);
      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
      path.setAttribute('stroke', color);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke-linecap', 'round');

      svg.appendChild(path);
    }
  }, function (rawPoint) {
    var circle = document.createElement('circle');
    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
    circle.setAttribute('r', dotSize);
    circle.setAttribute('cx', rawPoint.x);
    circle.setAttribute('cy', rawPoint.y);
    circle.setAttribute('fill', rawPoint.color);

    svg.appendChild(circle);
  });

  var prefix = 'data:image/svg+xml;base64,';
  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
  var body = svg.innerHTML;

  // IE hack for missing innerHTML property on SVGElement
  if (body === undefined) {
    var dummy = document.createElement('dummy');
    var nodes = svg.childNodes;
    dummy.innerHTML = '';

    for (var i = 0; i < nodes.length; i += 1) {
      dummy.appendChild(nodes[i].cloneNode(true));
    }

    body = dummy.innerHTML;
  }

  var footer = '</svg>';
  var data = header + body + footer;

  return prefix + btoa(data);
};

SignaturePad.prototype.fromData = function (pointGroups) {
  var _this3 = this;

  this.clear();

  this._fromData(pointGroups, function (curve, widths) {
    return _this3._drawCurve(curve, widths.start, widths.end);
  }, function (rawPoint) {
    return _this3._drawDot(rawPoint);
  });

  this._data = pointGroups;
};

SignaturePad.prototype.toData = function () {
  return this._data;
};

/* harmony default export */ __webpack_exports__["a"] = (SignaturePad);


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper",style:({width: _vm.width + 'px', height: _vm.height + 'px'})},[_c('canvas',{ref:"signaturePad",staticClass:"signature-pad",style:('background: url(' + _vm.stamp + ') center center / cover no-repeat;'),attrs:{"width":_vm.width,"height":_vm.height}},[_vm._v("\n      Your browser does not support the canvas element.\n    ")]),_vm._v(" "),_c('canvas',{attrs:{"id":"canvas"}}),_vm._v(" "),_c('input',{ref:"input",staticClass:"input-file",attrs:{"type":"file","id":"signature","accept":"image/x-png"},on:{"change":function($event){_vm.checkFile()}}})]),_vm._v(" "),_c('div',[_vm._t("buttons")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-aggregator-card',{ref:"aggregator",attrs:{"color":_vm.color,"persistent":_vm.persistent,"toolbar-title":_vm.theToolbarTitle,"list-title":_vm.listTitle,"navigation-menu":_vm.navigationMenu,"add-button-hover-text":_vm.addButtonHoverText,"dialog-max-width":_vm.dialogMaxWidth,"dialog-toolbar-title":_vm.dialogToolbarTitle}},[(_vm.signature.value)?_c('div',{attrs:{"slot":"card-text"},slot:"card-text"},[_c('v-scale-transition',{attrs:{"origin":"center center"}},[(_vm.signature.value)?_c('div',[_c('v-card-media',{staticClass:"signature-image",attrs:{"src":_vm.signature.value || '',"height":"150px"}})],1):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('vue-signature-pad',{ref:"signature",attrs:{"slot":"dialog-card-text"},on:{"on-save-signature":_vm.onSaveSignature,"on-upload-error":_vm.onUploadError},slot:"dialog-card-text"},[_c('template',{slot:"buttons"},[_c('v-layout',{staticClass:"signature-actions",attrs:{"row":"","align-center":"","justify-center":""}},[(!_vm.disableUploadButton)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.selectSignatureFile()}},slot:"activator"},[_c('v-icon',[_vm._v("file_upload")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.uploadIconHoverText))])],1):_vm._e(),_vm._v(" "),(!_vm.disableClearButton)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":_vm.clearSignature},slot:"activator"},[_c('v-icon',[_vm._v("settings_backup_restore")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.clearIconHoverText))])],1):_vm._e(),_vm._v(" "),(!_vm.disableSaveButton)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.setSignature()}},slot:"activator"},[_c('v-icon',[_vm._v("check")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.saveIconHoverText))])],1):_vm._e(),_vm._v(" "),(!_vm.disableDeleteButton)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.askForConfirmation()}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.deleteIconHoverText))])],1):_vm._e(),_vm._v(" "),(!_vm.disableCancelButton)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.closeDialog()}},slot:"activator"},[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('span',[_vm._v("Salir")])],1):_vm._e(),_vm._v(" "),(_vm.disableSaveButton)?_c('v-btn',{attrs:{"outline":"","color":"primary"},on:{"click":function($event){_vm.setSignature()}}},[_vm._v(_vm._s(_vm.saveIconHoverText))]):_vm._e(),_vm._v(" "),(_vm.disableSaveButton)?_c('v-btn',{attrs:{"outline":"","color":"primary"},on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Cancelar")]):_vm._e()],1)],1)],2),_vm._v(" "),_c('vuetify-dialog-confirm',{attrs:{"slot":"extras","headline":_vm.dialogConfirmHeadline,"text":_vm.dialogConfirmText,"cancel":_vm.cancelButton,"confirm":_vm.confirmButton},on:{"on-cancel-dialog":_vm.onDiscardDeletion,"on-confirm-dialog":_vm.onConfirmDeletion},slot:"extras",model:{value:(_vm.showConfirmDialog),callback:function ($$v) {_vm.showConfirmDialog=$$v},expression:"showConfirmDialog"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_editable_address_card_vue__ = __webpack_require__(629);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fb5ae64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_editable_address_card_vue__ = __webpack_require__(675);
function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_editable_address_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fb5ae64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_editable_address_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(674);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("48faa726", content, true, {});

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".input-autocomplete{margin-bottom:32px}.vuetify-editable-address-card{margin-bottom:20px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-editable-address-card.vue"],"names":[],"mappings":"AACA,oBACE,kBAAoB,CACrB,AACD,+BACE,kBAAoB,CACrB","file":"vuetify-editable-address-card.vue","sourcesContent":["\n.input-autocomplete {\n  margin-bottom: 32px;\n}\n.vuetify-editable-address-card {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"vuetify-editable-address-card",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.toolbarTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.navigationMenu)?_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.openDialog()}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.listTitle))])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('vuetify-form-creator',{ref:"form_creator",attrs:{"columns":'xs12 sm12 md12 lg12',"items":_vm.items,"validate-on-changed":_vm.validateOnChanged},on:{"on-blur":_vm.onChange,"on-change":_vm.onChange},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n              "+_vm._s(_vm.dialogToolbarTitle)+"\n            ")]),_vm._v(" "),_c('v-layout',{staticClass:"address-autocomplete",attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"input-autocomplete input-group input-group--dirty input-group--solo input-group--text-field input-group--single-line primary--text"},[_c('div',{staticClass:"input-group__input"},[_c('vue-google-autocomplete',{ref:_vm.id,attrs:{"id":_vm.id,"classname":"form-control","placeholder":_vm.placeholder,"country":"es"},on:{"placechanged":_vm.getAddressData}})],1)])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_vue__ = __webpack_require__(634);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cb80ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_vue__ = __webpack_require__(679);
function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38cb80ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(678);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("70b4e290", content, true, {});

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".fc-sun{background:#eee}.vc-icon{height:24px;width:24px}.add{background-image:url(\"http://localhost:8088/app/public/add-icon.png\")}.subtract{background-image:url(\"http://localhost:8088/app/public/subtract-icon.png\")}.disable{background-image:url(\"http://localhost:8088/app/public/disable-icon.png\")}.installers-title{padding-top:24px;color:rgba(0,0,0,.54);font-size:17px}.actions-card{width:100%;text-align:right;top:0;right:0;position:absolute}.the-title{font-size:21px;padding-left:86px;margin-top:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:-webkit-fill-available}.multiline{white-space:unset!important;overflow:unset!important}.settings-btn{margin-bottom:48px}.close-btn{margin-top:4px;margin-right:-11px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/calendar.vue"],"names":[],"mappings":"AACA,QACE,eAAiB,CAClB,AACD,SACE,YAAa,AACb,UAAY,CACb,AACD,KACE,qEAAuE,CACxE,AACD,UACE,0EAA4E,CAC7E,AACD,SACE,yEAA2E,CAC5E,AACD,kBACE,iBAAkB,AAClB,sBAA2B,AAC3B,cAAgB,CACjB,AACD,cACE,WAAY,AACZ,iBAAkB,AAClB,MAAS,AACT,QAAW,AACX,iBAAmB,CACpB,AACD,WACE,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,mBAAoB,AACpB,gBAAiB,AACjB,uBAAwB,AACxB,4BAA8B,CAC/B,AACD,WACE,4BAA8B,AAC9B,wBAA2B,CAC5B,AACD,cACE,kBAAoB,CACrB,AACD,WACE,eAAgB,AAChB,kBAAoB,CACrB","file":"calendar.vue","sourcesContent":["\n.fc-sun {\n  background: #eee;\n}\n.vc-icon {\n  height: 24px;\n  width: 24px;\n}\n.add {\n  background-image: url(\"http://localhost:8088/app/public/add-icon.png\");\n}\n.subtract {\n  background-image: url(\"http://localhost:8088/app/public/subtract-icon.png\");\n}\n.disable {\n  background-image: url(\"http://localhost:8088/app/public/disable-icon.png\");\n}\n.installers-title {\n  padding-top: 24px;\n  color: rgba(0, 0, 0, 0.54);\n  font-size: 17px;\n}\n.actions-card {\n  width: 100%;\n  text-align: right;\n  top: 0px;\n  right: 0px;\n  position: absolute;\n}\n.the-title {\n  font-size: 21px;\n  padding-left: 86px;\n  margin-top: 15px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: -webkit-fill-available;\n}\n.multiline {\n  white-space: unset !important;\n  overflow: unset !important;\n}\n.settings-btn {\n  margin-bottom: 48px;\n}\n.close-btn {\n  margin-top: 4px;\n  margin-right: -11px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isInstaller())?_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.display),expression:"display"}],staticClass:"settings-btn",attrs:{"absolute":"","dark":"","fixed":"","fab":"","bottom":"","right":"","color":"primary"},on:{"click":function($event){_vm.sheet = true}}},[_c('v-icon',[_vm._v("settings")])],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"width":"450px"},model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}},[_c('v-card',{staticClass:"mx-auto"},[_c('v-btn',{staticClass:"close-btn",attrs:{"flat":"","icon":"","color":"#757575","absolute":"","right":""},on:{"click":function($event){_vm.sheet = !_vm.sheet}}},[_c('v-icon',{staticClass:"close-icon"},[_vm._v("close")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"installers-title",attrs:{"primary-title":""}},[_vm._v("\n        Seleccionar instaladores\n      ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"column":""}},_vm._l((_vm.installers),function(installer,i){return _c('v-checkbox',{key:i,style:({ color: installer.color }),attrs:{"label":installer.text},on:{"change":_vm.onChangeInstallers},model:{value:(installer.value),callback:function ($$v) {_vm.$set(installer, "value", $$v)},expression:"installer.value"}})}))],1)],1)],1),_vm._v(" "),((_vm.isSuperadmin() || _vm.isAdmin()) && !_vm.isNew())?_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-layout',{staticClass:"column avatar-info",attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{staticClass:"py-2",attrs:{"xs12":"","sm6":""}},[_c('v-btn-toggle',{attrs:{"mandatory":""},model:{value:(_vm.selectedTool),callback:function ($$v) {_vm.selectedTool=$$v},expression:"selectedTool"}},[_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',[_vm._v("block")])],1)],1)],1)],1),_vm._v(" "),_c('br')],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('vue-calendar',{ref:"calendar",attrs:{"config":_vm.config,"events":_vm.events},on:{"event-click":_vm.eventClick,"event-double-click":_vm.eventDoubleClick,"select":_vm.select}}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[(_vm.current)?_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{style:({ backgroundColor: _vm.current.color, color: 'white', height: '72px' }),attrs:{"light":""}},[_c('v-btn',{style:({ backgroundColor: 'white', color: _vm.current.color }),attrs:{"fab":"","small":"","light":"","bottom":"","left":"","absolute":""},on:{"click":function($event){_vm.openBooking(_vm.current.identificator)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),[_c('div',{staticClass:"the-title"},[_vm._v("\n              "+_vm._s(_vm.current. title)+"\n            ")])],_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{style:({ marginRight: '6px', marginTop: '-10px' }),attrs:{"flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],2),_vm._v(" "),_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.showPlainText()}}},[_c('v-list-tile-action',[_c('v-icon',{style:({ color: _vm.current.color })},[_vm._v("calendar_today")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.current.date))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.showPlainText()}}},[_c('v-list-tile-action',[_c('v-icon',{style:({ color: _vm.current.color })},[_vm._v("location_on")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"multiline"},[_vm._v(_vm._s(_vm.current.address))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.showPlainText()}}},[_c('v-list-tile-action',[_c('v-icon',{style:({ color: _vm.current.color })},[_vm._v("build")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"multiline"},[_vm._v(_vm._s(_vm.current.installer))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.showPlainText()}}},[_c('v-list-tile-action',[_c('v-icon',{style:({ color: _vm.current.color })},[_vm._v("face")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"multiline"},[_vm._v(_vm._s(_vm.current.customer))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.showPlainText()}}},[_c('v-list-tile-action',[_c('v-icon',{style:({ color: _vm.current.color })},[_vm._v("store")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"multiline"},[_vm._v(_vm._s(_vm.current.commerce))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.showPlainText()}}},[_c('v-list-tile-action',[_c('v-icon',{style:({ color: _vm.current.color })},[_vm._v("settings_input_component")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"multiline"},[_vm._v(_vm._s(_vm.current.model))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.showPlainText()}}},[_c('v-list-tile-action',[_c('v-icon',{style:({ color: _vm.current.color })},[_vm._v("attach_money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"multiline"},[_vm._v(_vm._s(_vm.current.payment_method))])],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.current)?_c('v-dialog',{attrs:{"max-width":"750"},model:{value:(_vm.flatDialog),callback:function ($$v) {_vm.flatDialog=$$v},expression:"flatDialog"}},[_c('v-card',{style:({ padding: '5px 38px' })},[_c('v-btn',{style:({ color: '#9e9e9e', float: 'right', marginRight: '-31px', marginTop: '0px' }),attrs:{"flat":"","icon":""},on:{"click":function($event){_vm.flatDialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-card-text',[_c('br'),_c('br'),_vm._v(" "),_c('div',{style:({ fontSize: '22px' })},[_c('b',[_vm._v(_vm._s(_vm.current.title))])]),_vm._v("\n          "+_vm._s(_vm.current.subtitle)),_c('br'),_vm._v("\n          "+_vm._s(_vm.current.anexo)),_c('br'),_c('br'),_vm._v("\n          -----------------------------------------------------------------------------------------------------------"),_c('br'),_c('br'),_vm._v("\n          "+_vm._s(_vm.current.phones)+" - "+_vm._s(_vm.current.customer)+" - "+_vm._s(_vm.current.dni)),_c('br'),_vm._v("\n          "+_vm._s(_vm.current.customer_email)),_c('br'),_vm._v("\n          "+_vm._s(_vm.current.address)),_c('br'),_vm._v("\n          "+_vm._s(_vm.current.invoiceInfo)),_c('br'),_c('br'),_vm._v("\n          -----------------------------------------------------------------------------------------------------------"),_c('br'),_c('br'),_vm._v("\n          "+_vm._s(_vm.current.equipment)),_c('br'),_c('br'),_vm._v("\n          -----------------------------------------------------------------------------------------------------------"),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("OBSERVACIONES")]),_vm._v(":"),_c('br'),_c('br'),_vm._v("\n          "+_vm._s(_vm.current.observations)),_c('br'),_c('br'),_vm._v("\n          "+_vm._s(_vm.current.booking_observations)),_c('br'),_c('br'),_vm._v("\n          -----------------------------------------------------------------------------------------------------------"),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("SE HA PAGADO")]),_vm._v(": "+_vm._s(_vm.current.wasPaid)),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("NO SE COBRA")]),_vm._v(": "+_vm._s(_vm.current.notPaid)),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("A COBRAR")]),_vm._v(": "+_vm._s(_vm.current.toPaid)),_c('br'),_c('br')])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 680 */,
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_observation_aggregator_vue__ = __webpack_require__(650);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643fc584_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_observation_aggregator_vue__ = __webpack_require__(684);
function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_observation_aggregator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643fc584_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_observation_aggregator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(683);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("5b046f6e", content, true, {});

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".types{margin:0 auto;text-align:center;display:table}.headlines{font-size:18px!important;font-weight:500;letter-spacing:normal!important;font-family:Roboto,sans-serif;padding:34px}.card-texts{padding:34px;margin-top:-38px;width:100%}.card-date{margin-top:-6px;width:100%;font-weight:100;padding-left:34px;font-size:13px;color:#49585f}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-observation-aggregator.vue"],"names":[],"mappings":"AACA,OACE,cAAe,AACf,kBAAmB,AACnB,aAAe,CAChB,AACD,WACE,yBAA2B,AAC3B,gBAAiB,AACjB,gCAAkC,AAClC,8BAAkC,AAClC,YAAc,CACf,AACD,YACE,aAAc,AACd,iBAAkB,AAClB,UAAY,CACb,AACD,WACE,gBAAiB,AACjB,WAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAChB","file":"vuetify-observation-aggregator.vue","sourcesContent":["\n.types {\n  margin: 0 auto;\n  text-align: center;\n  display: table;\n}\n.headlines {\n  font-size: 18px !important;\n  font-weight: 500;\n  letter-spacing: normal !important;\n  font-family: 'Roboto', sans-serif;\n  padding: 34px;\n}\n.card-texts {\n  padding: 34px;\n  margin-top: -38px;\n  width: 100%;\n}\n.card-date {\n  margin-top: -6px;\n  width: 100%;\n  font-weight: 100;\n  padding-left: 34px;\n  font-size: 13px;\n  color: #49585f;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-aggregator-card',{ref:"aggregator",attrs:{"color":_vm.color,"toolbar-title":_vm.toolbarTitle,"persistent":true,"can-edit":_vm.canEdit,"list-title":_vm.listTitle,"add-button":_vm.addButton,"add-button-hover-text":_vm.addButtonHoverText,"dialog-max-width":_vm.dialogMaxWidth,"dialog-toolbar-title":_vm.dialogToolbarTitle + (_vm.theObservationType === '1' ? 'observación' : (_vm.theObservationType === '2' ? 'incidencia' : 'Felicitación'))}},[(_vm.items.length > 0)?_c('v-list',{staticClass:"scroll-y",staticStyle:{"max-height":"282px"},attrs:{"slot":"card-text","three-line":""},slot:"card-text"},[_c('transition-group',{attrs:{"name":"list","tag":"span"}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:(index + 2 * 100),attrs:{"ripple":"","avatar":""},on:{"click":function($event){_vm.openMessage(index)}}},[_c('v-list-tile-action',[(parseInt(item.booking_observation_type) === 1)?_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("chat_bubble")]):(parseInt(item.booking_observation_type) === 2)?_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("notification_important")]):(parseInt(item.booking_observation_type) === 3)?_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("thumb_up_alt")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.booking_observation_title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s('<span class=\'text--primary\'>' + item.booking_observation_user + '</span> &mdash; ' + item.booking_observation_message)}})],1),_vm._v(" "),(_vm.deleteButton)?_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":_vm.color},on:{"click":function($event){_vm.askForConfirmation(index)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.deleteIconHoverText))])],1)],1):_vm._e()],1),_vm._v(" "),(index + 1 !== _vm.items.length)?_c('v-divider',{key:(index + 1 * 100),attrs:{"inset":false}}):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"slot":"dialog-card-text","row":"","align-center":"","justify-center":""},slot:"dialog-card-text"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-text-field',{attrs:{"label":_vm.textFieldLabel,"single-line":"","disabled":_vm.theTitleDisabled,"required":"","rules":_vm.textFieldRules || []},model:{value:(_vm.observationTitle),callback:function ($$v) {_vm.observationTitle=$$v},expression:"observationTitle"}}),_vm._v(" "),_c('v-text-field',{attrs:{"color":"primary","required":"","multi-line":"","rows":5},model:{value:(_vm.observationMsg),callback:function ($$v) {_vm.observationMsg=$$v},expression:"observationMsg"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n              Mensaje\n            ")])]),_vm._v(" "),_c('v-btn-toggle',{staticClass:"types",model:{value:(_vm.theObservationType),callback:function ($$v) {_vm.theObservationType=$$v},expression:"theObservationType"}},[_c('v-btn',{attrs:{"flat":"","value":"1"}},[_vm._v("\n                Observación\n              ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","value":"2"}},[_vm._v("\n                Incidencia\n              ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"dialog-card-actions"},slot:"dialog-card-actions"},[_c('v-btn',{attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.$refs.aggregator.dialog = false}}},[_vm._v("\n      "+_vm._s(_vm.cancelButton)+"\n    ")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.valid),expression:"valid"}],attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.addObservation()}}},[_vm._v("\n      "+_vm._s(_vm.confirmButton)+"\n    ")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"slot":"extras","max-width":"650"},slot:"extras",model:{value:(_vm.preview),callback:function ($$v) {_vm.preview=$$v},expression:"preview"}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":""}},[(parseInt(_vm.type) === 1)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("chat_bubble")]):(parseInt(_vm.type) === 2)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("notification_important")]):(parseInt(_vm.type) === 3)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("thumb_up_alt")]):_vm._e(),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(parseInt(_vm.type) === 1 ? 'OBSERVACÍÓN' : 'INCIDENCIA'))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"headlines"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-card-text',{staticClass:"card-texts"},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"card-date"},[_vm._v(_vm._s(_vm.date))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){_vm.preview = false}}},[_vm._v("Cerrar")])],1)],1)],1),_vm._v(" "),_c('vuetify-dialog-confirm',{attrs:{"slot":"extras","headline":_vm.dialogConfirmHeadline,"text":_vm.dialogConfirmText,"cancel":_vm.cancelButton,"confirm":_vm.confirmButton},on:{"on-cancel-dialog":_vm.onDiscardDeletion,"on-confirm-dialog":_vm.onConfirmDeletion},slot:"extras",model:{value:(_vm.showConfirmDialog),callback:function ($$v) {_vm.showConfirmDialog=$$v},expression:"showConfirmDialog"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_document_aggregator_vue__ = __webpack_require__(651);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d70f3c32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_document_aggregator_vue__ = __webpack_require__(688);
function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_document_aggregator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d70f3c32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_document_aggregator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(687);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("103052d4", content, true, {});

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".types{margin:0 auto;text-align:center;display:table}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-document-aggregator.vue"],"names":[],"mappings":"AACA,OACE,cAAe,AACf,kBAAmB,AACnB,aAAe,CAChB","file":"vuetify-document-aggregator.vue","sourcesContent":["\n.types {\n  margin: 0 auto;\n  text-align: center;\n  display: table;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-aggregator-card',{ref:"aggregator",attrs:{"color":_vm.color,"toolbar-title":_vm.toolbarTitle,"list-title":_vm.listTitle,"persistent":true,"navigation-menu":_vm.navigationMenu,"add-button-hover-text":_vm.addButtonHoverText,"dialog-max-width":_vm.dialogMaxWidth,"dialog-toolbar-title":_vm.theDialogToolbarTitle}},[(_vm.items.length > 0)?_c('v-list',{staticClass:"scroll-y",staticStyle:{"max-height":"282px"},attrs:{"slot":"card-text","three-line":""},slot:"card-text"},[_c('transition-group',{attrs:{"name":"list","tag":"span"}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:(index + 2 * 100),attrs:{"ripple":"","avatar":""},on:{"click":function($event){_vm.openFile(index)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("attach_file")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(item.booking_document_title)+"\n            ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(item.booking_document_user))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.booking_document_filename))])],1),_vm._v(" "),(_vm.deleteButton)?_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":_vm.color},on:{"click":function($event){_vm.askForConfirmation(index)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.deleteIconHoverText))])],1)],1):_vm._e()],1),_vm._v(" "),(index + 1 !== _vm.items.length)?_c('v-divider',{key:(index + 1 * 100),attrs:{"inset":false}}):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"slot":"dialog-card-text","row":"","align-center":"","justify-center":""},slot:"dialog-card-text"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg6":""}},[_c('v-text-field',{attrs:{"label":_vm.textFieldLabel,"single-line":"","disabled":_vm.disableTitle,"required":"","rules":_vm.textFieldRules || []},model:{value:(_vm.documentTitle),callback:function ($$v) {_vm.documentTitle=$$v},expression:"documentTitle"}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"loading":_vm.loading,"disabled":_vm.loading,"color":"primary"},on:{"click":function($event){_vm.selectSignatureFile()}},nativeOn:{"click":function($event){_vm.loader = 'loading'}}},[_vm._v("\n            "+_vm._s(_vm.filename || 'Subir')+"\n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"dialog-card-actions"},slot:"dialog-card-actions"},[_c('input',{ref:"input",staticClass:"input-file",attrs:{"type":"file","id":"file"},on:{"change":function($event){_vm.checkFile()}}}),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v("\n      "+_vm._s(_vm.cancelButton)+"\n    ")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.documentTitle && _vm.url),expression:"documentTitle && url"}],attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.addDocument()}}},[_vm._v("\n      "+_vm._s(_vm.confirmButton)+"\n    ")])],1),_vm._v(" "),_c('vuetify-dialog-confirm',{attrs:{"slot":"extras","headline":_vm.dialogConfirmHeadline,"text":_vm.dialogConfirmText,"cancel":_vm.cancelButton,"confirm":_vm.confirmButton},on:{"on-cancel-dialog":_vm.onDiscardDeletion,"on-confirm-dialog":_vm.onConfirmDeletion},slot:"extras",model:{value:(_vm.showConfirmDialog),callback:function ($$v) {_vm.showConfirmDialog=$$v},expression:"showConfirmDialog"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_equipment_aggregator_vue__ = __webpack_require__(652);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c734c47c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_equipment_aggregator_vue__ = __webpack_require__(692);
function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_equipment_aggregator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c734c47c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_equipment_aggregator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(691);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("3da4b3d2", content, true, {});

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"vuetify-equipment-aggregator.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-aggregator-card',{ref:"aggregator",attrs:{"color":_vm.color,"toolbar-title":_vm.toolbarTitle,"list-title":_vm.listTitle,"add-button-hover-text":_vm.addButtonHoverText,"dialog-max-width":650,"navigation-menu":_vm.navigationMenu,"dialog-toolbar-title":_vm.dialogToolbarTitle}},[(_vm.items.length > 0)?_c('v-list',{attrs:{"slot":"card-text","two-line":""},slot:"card-text"},[_c('transition-group',{attrs:{"name":"list","tag":"span"}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:(index + 2 * 100),attrs:{"ripple":"","avatar":""},on:{"click":function($event){_vm.openMessage(index)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("inbox")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(item.quantity)+" - "+_vm._s(item.brand + ' ' + item.model)+"\n            ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.installation_price))])],1),_vm._v(" "),(_vm.deleteButton)?_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":_vm.color},on:{"click":function($event){_vm.askForConfirmation(index)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.deleteIconHoverText))])],1)],1):_vm._e()],1),_vm._v(" "),(index + 1 !== _vm.items.length)?_c('v-divider',{key:(index + 1 * 100),attrs:{"inset":false}}):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"slot":"dialog-card-text","row":"","align-center":"","justify-center":""},slot:"dialog-card-text"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('vuetify-form-creator',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 1),expression:"step === 1"}],ref:"equipment_fields",attrs:{"columns":'xs12 sm12 md12 lg12',"items":_vm.formAggregator,"validate-on-changed":false},on:{"on-change":_vm.onChange},model:{value:(_vm.formAggregator),callback:function ($$v) {_vm.formAggregator=$$v},expression:"formAggregator"}}),_vm._v(" "),_c('vuetify-form-creator',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 2),expression:"step === 2"}],ref:"equipment_details",attrs:{"columns":'xs12 sm12 md12 lg12',"items":_vm.questions,"validate-on-changed":false},on:{"on-change":_vm.onChange},model:{value:(_vm.questions),callback:function ($$v) {_vm.questions=$$v},expression:"questions"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"dialog-card-actions"},slot:"dialog-card-actions"},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 2),expression:"step === 2"}],attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.step = 1}}},[_vm._v("\n      Volver\n    ")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 1),expression:"step === 1"}],attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.$refs.equipment_fields.validateForm() ? _vm.step = 2 : _vm.step = 1}}},[_vm._v("\n      Siguente\n    ")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.step === 2),expression:"step === 2"}],attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.addEquipment()}}},[_vm._v("\n      "+_vm._s(_vm.confirmButton)+"\n    ")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"slot":"extras","max-width":"600"},slot:"extras",model:{value:(_vm.preview),callback:function ($$v) {_vm.preview=$$v},expression:"preview"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("DETALLES DEL EQUIPO")]),_vm._v(" "),_c('v-card-text',[_c('vuetify-form-creator',{ref:"equipment_preview",attrs:{"columns":'xs12 sm12 md12 lg12',"items":_vm.form,"validate-on-changed":false},on:{"on-blur":_vm.onChange},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){_vm.preview = false}}},[_vm._v("Cerrar")])],1)],1)],1),_vm._v(" "),_c('vuetify-dialog-confirm',{attrs:{"slot":"extras","headline":_vm.dialogConfirmHeadline,"text":_vm.dialogConfirmText,"cancel":_vm.cancelButton,"confirm":_vm.confirmButton},on:{"on-cancel-dialog":_vm.onDiscardDeletion,"on-confirm-dialog":_vm.onConfirmDeletion},slot:"extras",model:{value:(_vm.showConfirmDialog),callback:function ($$v) {_vm.showConfirmDialog=$$v},expression:"showConfirmDialog"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_stepper_dialog_vue__ = __webpack_require__(653);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff3070f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_stepper_dialog_vue__ = __webpack_require__(696);
function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_stepper_dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ff3070f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_stepper_dialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(695);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("42bdb3de", content, true, {});

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vuetify-stepper-dialog{height:100%;max-height:80%}.overlay--active:before{opacity:.92}.app-icon{background:#3f51b5}.flex-button-right{display:inline-block}.button-right{float:right;right:-19px}.button-left{margin-left:-8px;margin-top:0}.button-left>div>i{font-size:28px}.stepper-title{margin-top:-9px!important}.progress-circular-test{margin-left:8px}.reservation{margin-left:21px}.reservation-span{margin-left:21px;display:block;font-size:17px}.close{z-index:9999999999!important;top:0;margin:30px 18px 0 26px}.close-icon{font-size:50px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-stepper-dialog.vue"],"names":[],"mappings":"AACA,wBACE,YAAa,AACb,cAAgB,CACjB,AACD,wBACE,WAAc,CACf,AACD,UACE,kBAAoB,CACrB,AACD,mBACE,oBAAsB,CACvB,AACD,cACE,YAAa,AACb,WAAa,CACd,AACD,aACE,iBAAkB,AAClB,YAAiB,CAClB,AACD,mBACE,cAAgB,CACjB,AACD,eACE,yBAA4B,CAC7B,AACD,wBACE,eAAiB,CAClB,AACD,aACE,gBAAkB,CACnB,AACD,kBACE,iBAAkB,AAClB,cAAe,AACf,cAAgB,CACjB,AACD,OACE,6BAA+B,AAC/B,MAAO,AACP,uBAAyB,CAC1B,AACD,YACE,cAAgB,CACjB","file":"vuetify-stepper-dialog.vue","sourcesContent":["\n.vuetify-stepper-dialog {\n  height: 100%;\n  max-height: 80%;\n}\n.overlay--active:before {\n  opacity: 0.92;\n}\n.app-icon {\n  background: #3F51B5;\n}\n.flex-button-right {\n  display: inline-block;\n}\n.button-right {\n  float: right;\n  right: -19px;\n}\n.button-left {\n  margin-left: -8px;\n  margin-top: -0px;\n}\n.button-left > div > i {\n  font-size: 28px;\n}\n.stepper-title {\n  margin-top: -9px !important;\n}\n.progress-circular-test {\n  margin-left: 8px;\n}\n.reservation {\n  margin-left: 21px;\n}\n.reservation-span {\n  margin-left: 21px;\n  display: block;\n  font-size: 17px;\n}\n.close {\n  z-index: 9999999999 !important;\n  top: 0;\n  margin: 30px 18px 0 26px;\n}\n.close-icon {\n  font-size: 50px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dialog)?_c('div',[_c('v-btn',{staticClass:"close",attrs:{"flat":"","icon":"","color":"white","absolute":"","right":""},on:{"click":function($event){_vm.$emit('on-close')}}},[_c('v-icon',{staticClass:"close-icon"},[_vm._v("close")])],1),_vm._v(" "),_c('v-dialog',{ref:_vm.reference,attrs:{"persistent":"","max-width":_vm.maxWidth},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.steps[_vm.step])?_c('v-card',{staticClass:"vuetify-stepper-dialog",attrs:{"height":"600","dark":_vm.dark}},[_c('v-card-title',{staticClass:"stepper-title"},[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs4":"","text-xs-center":"","layout":""}},[(_vm.step > 0)?_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.steps[_vm.step].icon_hidden),expression:"!steps[step].icon_hidden"}],staticClass:"button-left",attrs:{"color":"primary","flat":"","icon":"","round":""},on:{"click":function($event){_vm.onLast()}}},[_c('v-icon',[_vm._v("arrow_back")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{staticClass:"progress-circular-test",attrs:{"size":28,"width":3,"rotate":-90,"value":_vm.step / (_vm.steps.length - 1) * 100,"color":"primary"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"flex-button-right",attrs:{"xs4":"","text-xs-center":"","layout":""}},[((_vm.steps.length - _vm.step) > 1)?_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.steps[_vm.step].button_hidden),expression:"!steps[step].button_hidden"}],staticClass:"button-right",attrs:{"outline":"","round":"","color":"primary","dark":"","right":""},on:{"click":function($event){_vm.onNext()}}},[_vm._v(_vm._s(_vm.steps[_vm.step].text || _vm.text))]):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"headline reservation"},[_vm._v(_vm._s(_vm.steps[_vm.step].title || ''))]),_vm._v(" "),(_vm.steps[_vm.step].subtitle)?_c('span',{staticClass:"reservation-span section primary--text"},[_c('br'),_vm._v(_vm._s(_vm.steps[_vm.step].subtitle))]):_vm._e(),_vm._v(" "),_c('vuetify-form-creator',{ref:"form_creator",attrs:{"columns":'xs12 sm12 md12 lg12',"items":_vm.steps[_vm.step].fields,"validate-on-changed":false},on:{"on-click-button":_vm.onClickButton,"on-blur":_vm.onChange,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem},model:{value:(_vm.steps[_vm.step].fields),callback:function ($$v) {_vm.$set(_vm.steps[_vm.step], "fields", $$v)},expression:"steps[step].fields"}})],1)],1):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_rule__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vue_user_visible_for__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_calendar__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vuetify_editable_form_card__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_vuetify_form_creator_fields_vuetify_text_field__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_vuetify_form_creator_fields_vuetify_select__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_vuetify_phone_aggregator__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vuetify_avatar_card__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_vuetify_editable_address_card__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_vuetify_observation_aggregator__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_vuetify_document_aggregator__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_vuetify_equipment_aggregator__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_vuetify_signature_aggregator__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_vuetify_stepper_dialog__ = __webpack_require__(693);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_mixins_rule__["a" /* default */]],

  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_3__components_calendar__["a" /* default */],
    VisibleFor: __WEBPACK_IMPORTED_MODULE_2__components_vue_user_visible_for__["a" /* default */],
    VuetifyEditableAddressCard: __WEBPACK_IMPORTED_MODULE_9__components_vuetify_editable_address_card__["a" /* default */],
    VuetifyPhoneAggregator: __WEBPACK_IMPORTED_MODULE_7__components_vuetify_phone_aggregator__["a" /* default */],
    VuetifyEditableFormCard: __WEBPACK_IMPORTED_MODULE_4__components_vuetify_editable_form_card__["a" /* default */],
    VuetifyTextField: __WEBPACK_IMPORTED_MODULE_5__components_vuetify_form_creator_fields_vuetify_text_field__["a" /* default */],
    VuetifyAvatarCard: __WEBPACK_IMPORTED_MODULE_8__components_vuetify_avatar_card__["a" /* default */],
    VuetifySelect: __WEBPACK_IMPORTED_MODULE_6__components_vuetify_form_creator_fields_vuetify_select__["a" /* default */],
    VuetifyObservationAggregator: __WEBPACK_IMPORTED_MODULE_10__components_vuetify_observation_aggregator__["a" /* default */],
    VuetifyEquipmentAggregator: __WEBPACK_IMPORTED_MODULE_12__components_vuetify_equipment_aggregator__["a" /* default */],
    VuetifySignatureAggregator: __WEBPACK_IMPORTED_MODULE_13__components_vuetify_signature_aggregator__["a" /* default */],
    VuetifyDocumentAggregator: __WEBPACK_IMPORTED_MODULE_11__components_vuetify_document_aggregator__["a" /* default */],
    VuetifyStepperDialog: __WEBPACK_IMPORTED_MODULE_14__components_vuetify_stepper_dialog__["a" /* default */]
  },

  data: function data() {
    return {
      moment: __webpack_require__(0),
      route: {},
      canCreateReservation: true,
      routeExtras: {},
      postalCode: {},
      locality: {},
      province: {},
      newWindowContent: null,
      clickTimer: null,
      clickTimer2: null,
      addingSignature: false,
      sendEmailDoc1: false,
      sendEmailDoc2: false,
      sendEmailDoc3: false,
      hasSerials: true,
      placeID: {},
      assignTo: [],
      routeDelivery: {},
      routeExtrasDelivery: {},
      postalCodeDelivery: {},
      localityDelivery: {},
      provinceDelivery: {},
      placeIdDelivery: {},
      commerceAlias: {},
      commerceCif: {},
      commerceAddress: {},
      commerceAddress2: {},
      commercePostalCode: {},
      commerceLocality: {},
      commerceProvince: {},
      commercePhone: {},
      commerceEmail: {},
      installerEmail: {},
      adminEmail: {},
      sellerName: {},
      saleSoldDate: {},
      saleDeliveryDate: {},
      saleID: {},
      statusID: {},
      calendar_visibility: {},
      installationStartDate: {},
      installationEndDate: {},
      status: {},
      generation: false,
      showStateCauses: false,
      addingSerials: false,
      documentCreationdialog: false,
      dialogEmail: false,
      phone: {},
      sellerID: {},
      businessGroupType: '',
      businessGroupName: '',
      companyName: '',
      commerceType: '',
      commerceName: '',
      commerceAvatar: {},
      businessGroupId: {},
      step1: false,
      step2: false,
      step3: false,
      end1: false,
      end2: false,
      end3: false,
      checkboxDoc1: false,
      cloneDialog: false,
      cloneBooking: true,
      cloneDocuments: true,
      cloneObservations: true,
      checkboxDoc2: false,
      checkboxDoc3: false,
      checkboxDoc4: false,
      emailIsValid: false,
      download1: false,
      download2: false,
      download3: false,
      signatureSuccess1: false,
      uploadSuccess1: false,
      updateDocument1: false,
      checkbox1: false,
      checkbox2: false,
      hasAssignation: false,
      adviceSentToAdmin: false,
      adviceSentToCommerce: false,
      adviceSentToInstaller: false,
      noInstaller: false,
      noAssignation: false,
      installers: [],
      installerID: {},
      bookingEquipments: {},
      installerName: {},
      installerAlias: {},
      installerSurname: {},
      alias: {},
      rateID: {},
      commerceID: {},
      installerSignature: {},
      customerSignature: {},
      commerceSignature: {},
      signature: {
        toolbar_title: 'Agregar firma',
        value: null,
        booking_id: 0,
        user_id: 0,
        booking_document_url: '',
        booking_document_id: 0,
        booking_document_title: '',
        booking_document_filetype: '',
        booking_document_filename: ''
      },
      isSignature: false,
      customerID: {},
      addressCheckbox: {},
      sellers: [],
      documents: {
        type: 'select',
        assign_to: 'assignTo',
        editable: true,
        columns: 'xs12',
        label: 'Vendedor',
        item_text: 'seller_name',
        item_value: 'seller_id',
        dialog_toolbar_title: 'Agregar documento',
        items: [],
        rules: [],
        return_object: true,
        autocomplete: true
      },
      observation: {
        type: 'select',
        assign_to: 'assignTo',
        editable: true,
        columns: 'xs12',
        label: 'Vendedor',
        item_text: 'seller_name',
        item_value: 'seller_id',
        items: [],
        rules: [],
        return_object: true,
        autocomplete: true
      },
      sellersParams: {
        type: 'select',
        assign_to: 'fields',
        editable: true,
        ref: 'sellerID',
        columns: 'xs12',
        label: 'Vendedor',
        item_text: 'seller_name',
        item_value: 'seller_id',
        table: 'sellers',
        items: [],
        return_object: true,
        autocomplete: false
      },
      installationState: [{
        type: 'select',
        assign_to: 'assignTo',
        editable: true,
        columns: 'xs12',
        label: 'Vendedor',
        item_text: 'seller_name',
        item_value: 'seller_id',
        items: [],
        return_object: true,
        autocomplete: true
      }],
      newInstallation: [{
        type: 'select',
        assign_to: 'newInstallation',
        editable: false,
        columns: 'xs12',
        label: 'Acabo aquí en',
        item_text: 'item_text',
        item_value: 'item_value',
        items: [{
          item_text: 'He acabado',
          item_value: 'He acabado aquí.'
        }, {
          item_text: '15 minutos',
          item_value: 'Acabo aquí en 15 minutos.'
        }, {
          item_text: '30 minutos',
          item_value: 'Acabo aquí en 30 minutos.'
        }, {
          item_text: '45 minutos',
          item_value: 'Acabo aquí en 45 minutos.'
        }, {
          item_text: '1 hora',
          item_value: 'Acabo aquí en 1 hora.'
        }, {
          item_text: 'Hora y media',
          item_value: 'Acabo aquí en hora y media.'
        }],
        return_object: true,
        value: '',
        update: true,
        autocomplete: true
      }],
      invoice: [],
      invoiceForm: [{
        assign_to: 'invoice',
        type: 'button',
        columns: 'xs6',
        items: [{
          text_button: 'Subir factura',
          align: 'center',
          outline: true,
          ref: 'invoice-was-updated'
        }]
      }],
      requestImages: [{
        type: 'select',
        assign_to: 'requestImages',
        editable: false,
        columns: 'xs12',
        label: 'Solicitar',
        item_text: 'item_text',
        item_value: 'item_value',
        items: [{
          item_text: 'Fotografías de la instalación',
          item_value: 'Hacer fotografías a la instalación. En caso de no ser posible, agregar observación informando sobre el motivo.'
        }],
        return_object: true,
        value: '',
        update: true,
        autocomplete: true
      }],
      installationInfo: [],
      installationInfoForm: [{
        order: 0,
        type: 'date-picker',
        columns: 'xs12',
        rules: ['required'],
        required: true,
        ref: 'installationStartDate',
        assign_to: 'installationInfo',
        label: 'Fecha inicio instalación'
      }, {
        order: 0,
        type: 'date-picker',
        columns: 'xs12',
        rules: ['required'],
        required: true,
        ref: 'installationEndDate',
        assign_to: 'installationInfo',
        label: 'Fecha fin instalación'
      }, {
        order: 0,
        type: 'time-picker',
        columns: 'xs6',
        rules: ['required'],
        required: true,
        ref: 'installationStartDate',
        assign_to: 'installationInfo',
        label: 'Hora de inicio'
      }, {
        order: 0,
        type: 'time-picker',
        columns: 'xs6',
        rules: ['required'],
        required: true,
        ref: 'installationEndDate',
        assign_to: 'installationInfo',
        label: 'Hora de finalización'
      }],
      installationStateForm: [],
      installationStateCausesForm: [],
      eventsData: [],
      steppers: [],
      calendar: false,
      bookingWasSearch: false,
      fields: [],
      customer: [],
      avatar: {},
      avatars: [],
      commerce: {},
      userID: {},
      equipments: {},
      equipment: [],
      equipmentID: null,
      requestImagesOnNeww: false,
      currentStep: '',
      models: null,
      display: false,
      currentDocumentID: false
    };
  },
  created: function created() {
    var _this = this;

    this.getSale().then(function (response) {
      console.log(response);
      _this.normalizeAddress();
      _this.normalizeAndAssign(response.data);

      // console.log('........', this.avatar)
      var url = _this.avatar.default;
      _this.avatar.src = _this.avatar.value || _this.avatar.default + '0.png';
      for (var i = 0; i < 50; i++) {
        _this.avatars.push({ src: url + i + '.png' });
      }
      if (!(_this.isSuperadmin() || _this.isAdmin())) {
        _this.invoice[0].disabled = true;
      }
      _this.normalizeAndAssign(_this.installationInfoForm);
      _this.normalizeAndAssign(_this.invoiceForm);
      if (parseInt(_this.invoice[0].value) === 0) {
        _this.invoice[0].value = false;
      }
      var startDate = _this.installationStartDate.value;
      var endDate = _this.installationEndDate.value;
      if (_this.$route.params.booking_start && _this.$route.params.booking_end) {
        var start = _this.$route.params.booking_start.split('_');
        var dateStart = start[0] || _this.moment();
        var hourStart = start[1] || _this.moment();
        startDate = dateStart + ' ' + hourStart;
        var end = _this.$route.params.booking_end.split('_');
        var dateEnd = end[0] || _this.moment();
        var hourEnd = end[1] || _this.moment();
        endDate = dateEnd + ' ' + hourEnd;
      }

      if (startDate && endDate && startDate !== '0000-00-00 00:00:00' && endDate !== '0000-00-00 00:00:00') {
        _this.installationInfo[0].value = _this.moment(startDate).format('YYYY-MM-DD');
        _this.installationInfo[1].value = _this.moment(endDate).format('YYYY-MM-DD');
        _this.installationInfo[2].value = _this.moment(startDate).format('HH:mm');
        _this.installationInfo[3].value = _this.moment(endDate).format('HH:mm');
      } else {
        _this.installationInfo[0].value = false;
        _this.installationInfo[1].value = null;
        _this.installationInfo[2].value = null;
        _this.installationInfo[3].value = null;
      }

      if (_this.isNew()) {
        // this.installationStartDate.value = this.moment(startDate).format('YYYY-MM-DD HH:mm')
        // this.installationEndDate.value = this.moment(endDate).format('YYYY-MM-DD HH:mm')
        _this.installationStartDate.value = false;
        _this.installationEndDate.value = false;
        // this.updateItem(this.installationStartDate, this.installationStartDate.value)
        // this.updateItem(this.installationEndDate, this.installationEndDate.value)
        _this.fields[0].value = _this.moment(_this.saleSoldDate.value || _this.moment()).format('YYYY-MM-DD');
        _this.updateItem(_this.fields[0], _this.fields[0].value);
      } else {
        _this.fields[0].value = _this.moment(_this.saleSoldDate.value || _this.moment()).format('YYYY-MM-DD');
        _this.fields[1].value = _this.moment(_this.saleDeliveryDate.value || _this.moment()).format('YYYY-MM-DD');
        _this.updateItem(_this.fields[0], _this.fields[0].value);
        _this.updateItem(_this.fields[1], _this.fields[1].value);
      }

      _this.bookingEquipments.value = JSON.parse(_this.bookingEquipments.value);
      _this.phone.value = JSON.parse(_this.phone.value);

      var index = _this.installationStateForm[0].items.findIndex(function (item) {
        return parseInt(item.item_value) === parseInt(_this.installationStateForm[0].value);
      });
      _this.installationStateForm[0].value = _this.installationStateForm[0].items[index];
      if (_this.installationStateCausesForm[0].value && parseInt(_this.installationStateForm[0].value.item_value) === 8) {
        _this.showStateCauses = true;
        index = _this.installationStateCausesForm[0].items.findIndex(function (item) {
          return parseInt(item.item_value) === parseInt(_this.installationStateCausesForm[0].value);
        });

        _this.installationStateCausesForm[0].value = _this.installationStateCausesForm[0].items[index];
      }

      _this.getEquipments().then(function (response) {
        // console.log(response)
        if (!response.data.items || response.data.items.length === 0) {
          _this.canCreateReservation = false;
          _this.$awn.warning('Imposible crear reservas. No existen equipos disponibles en el sistema.');
          return false;
        }
        _this.equipments = response.data;

        _this.getMailingRegisters();

        _this.getDocuments().then(function (response) {
          console.log(response);
          _this.getObservations().then(function (response) {
            console.log(response);
            _this.getCommerceSellers().then(function (response) {
              // console.log(response)
              _this.getCommerces().then(function (response) {
                console.log(response);
                if (!response.data.items || response.data.items.length === 0) {
                  _this.canCreateReservation = false;
                  _this.$awn.warning('Imposible crear reservas. No existen comercios activos en el sistema.');
                  return false;
                }
                _this.getInstallers().then(function (response) {
                  if (!response.data.items || response.data.items.length === 0) {
                    _this.canCreateReservation = false;
                    _this.$awn.warning('Imposible crear reservas. No existen instaladores activos en el sistema.');
                    return false;
                  }
                  _this.hasSerials = false;
                  if (_this.bookingEquipments.value[0] && _this.bookingEquipments.value[0].serial_indoor_unit_1 && _this.bookingEquipments.value[0].serial_indoor_unit_1 !== '' && _this.bookingEquipments.value[0].serial_indoor_unit_2 && _this.bookingEquipments.value[0].serial_indoor_unit_2 !== '' && _this.bookingEquipments.value[0].serial_outdoor_unit_1 && _this.bookingEquipments.value[0].serial_outdoor_unit_1 !== '') {
                    _this.hasSerials = true;
                  }
                  // console.log('dddddddddd', this.hasSerials)
                  _this.setSteps();
                  if (_this.isSuperadmin() || _this.isAdmin()) {
                    // if (!this.installationInfo[4].value) {
                    //   this.noInstaller = true
                    // }
                    // this.setSteps()
                    // if (!this.isAssignated()) {
                    //   this.noAssignation = true
                    // }
                    // setTimeout(() => { this.display = true }, 100)
                    _this.display = true;
                  } else {
                    // console.log('[][][][][][][]', this.installationInfo[4].value)
                    if (_this.installationInfo[0].value) {
                      var value = _this.installationInfo[0].value.split('-');
                      _this.installationInfo[0].value = value[2] + '-' + value[1] + '-' + value[0];
                    }
                    _this.installationInfo[0].disabled = true;
                    _this.installationInfo[0].type = 'text-field';
                    if (_this.installationInfo[1].value) {
                      var _value = _this.installationInfo[1].value.split('-');
                      _this.installationInfo[1].value = _value[2] + '-' + _value[1] + '-' + _value[0];
                    }
                    _this.installationInfo[1].disabled = true;
                    _this.installationInfo[1].type = 'text-field';
                    _this.installationInfo[2].disabled = true;
                    _this.installationInfo[2].type = 'text-field';
                    _this.installationInfo[3].disabled = true;
                    _this.installationInfo[3].type = 'text-field';
                    _this.installationInfo[4].disabled = true;

                    if (_this.isInstaller()) {
                      _this.installationInfo[4].type = 'hidden';
                      _this.customer[0].disabled = true;
                      _this.customer[1].disabled = true;
                      _this.customer[2].disabled = true;
                      _this.fields[0].disabled = true;
                      _this.fields[0].type = 'text-field';
                      _this.fields[1].disabled = true;
                      _this.fields[1].type = 'text-field';
                      _this.fields[2].disabled = true;
                      _this.fields[2].type = 'text-field';
                      _this.fields[3].disabled = true;
                      _this.fields[3].type = 'text-field';
                      _this.fields[4].disabled = true;
                      _this.fields[4].type = 'text-field';
                      _this.fields[5].disabled = true;
                      _this.fields[5].type = 'text-field';
                      _this.fields[5].value = _this.fields[5].value.seller_name;
                    } else if (_this.isManager() || _this.isResponsible()) {
                      _this.installationInfo[4].type = 'hidden';
                      _this.customer[0].disabled = true;
                      _this.customer[1].disabled = true;
                      _this.customer[2].disabled = true;
                      _this.customer[3].disabled = true;
                      _this.installationStateForm[0].disabled = true;
                      _this.installationStateCausesForm[0].disabled = true;
                      _this.fields[0].disabled = true;
                      _this.fields[0].type = 'text-field';
                      _this.fields[1].disabled = true;
                      _this.fields[1].type = 'text-field';
                      _this.fields[2].disabled = true;
                      _this.fields[2].type = 'text-field';
                      _this.fields[3].disabled = true;
                      _this.fields[3].type = 'text-field';
                      _this.fields[4].disabled = true;
                      _this.fields[4].type = 'text-field';
                      _this.fields[5].disabled = true;
                      _this.fields[5].type = 'text-field';
                      _this.fields[5].value = _this.fields[5].value.seller_name;
                      _this.route.disabled = true;
                      _this.routeExtras.disabled = true;
                      _this.postalCode.disabled = true;
                      _this.locality.disabled = true;
                      _this.province.disabled = true;
                      _this.routeDelivery.disabled = true;
                      _this.routeExtrasDelivery.disabled = true;
                      _this.postalCodeDelivery.disabled = true;
                      _this.localityDelivery.disabled = true;
                      _this.provinceDelivery.disabled = true;
                    }
                    setTimeout(function () {
                      _this.display = true;
                    }, 100);
                  }
                  if (_this.$route.query.action === 'upload_invoice') {
                    if (!_this.invoice[0].value && _this.isCommerce()) {
                      _this.uploadInvoice();
                    } else if (_this.isAdmin || _this.isSuperadmin()) {
                      _this.uploadInvoice();
                    }
                  } else if (_this.$route.query.action === 'add_serial_numbers') {
                    _this.$refs.equipment_aggregator.openMessage(0);
                  } else if (_this.$route.query.action === 'signature_document_3') {
                    _this.generateDoc('signature', 3);
                  } else if (_this.$route.query.action === 'signature_document_2') {
                    _this.generateDoc('signature', 2);
                  }
                  if (!_this.isNew()) {
                    _this.addEventToGoogleCalendar();
                  }
                }).catch(function (error) {
                  console.log(error);
                });
              }).catch(function (error) {
                console.log(error);
              });
            }).catch(function (error) {
              console.log(error);
            });
          }).catch(function (error) {
            console.log(error);
          });
        });
      }).catch(function (error) {
        console.log(error);
      });
    }).catch(function (error) {
      console.log(error);
    });
  },


  methods: {

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isInstaller: function isInstaller() {
      return this.$store.getters['api/getUserRol'] === 'installer';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isCommerce: function isCommerce() {
      return this.$store.getters['api/getUserRol'] === 'commerce';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setAdminSteps: function setAdminSteps() {
      this.steppers = [{
        ref: 'advise',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'gray',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '4. AVISO DE INSTALACIÓN.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'help_outline',
          icon_color: 'primary',
          value: 'ATENCIÓN: Esta reserva no tiene fecha de instalación o instalador asignado. Pulsa en "Siguiente" para seleccionar un instalador y confirmar la fecha de la reserva.'
        }]),
        requestImagesOnNew: {},
        title: 'Generar documentos',
        text: 'Siguiente',
        icon_hidden: true
      }, {
        ref: 'installer',
        fields: [this.installationInfo[4]],
        title: 'Asignar al instalador'
      }, {
        ref: 'installationInfo',
        fields: [this.installationInfo[0], this.installationInfo[1], this.installationInfo[2], this.installationInfo[3]],
        title: 'Fecha y hora de la instalación'
      }, {
        ref: 'advise',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '4. AVISO DE INSTALACIÓN.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'help_outline',
          icon_color: 'primary',
          value: 'Los documentos se han generado correctamente. Puedes finalizar para ver los detalles de la reserva o enviar el aviso de instalación al comerciante. No es necesario enviar el aviso al instalador, el sistema lo enviará de forma automática 24 horas antes (48 horas si hay fiesta entre medio).'
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Finalizar',
            align: 'right',
            outline: true,
            ref: 'finish-assign-installer'
          }, {
            text_button: 'Enviar aviso a comerciante',
            align: 'right',
            outline: true,
            loading: false,
            disabled: false,
            ref: 'email-doc-4'
          }]
        }]),
        requestImagesOnNew: {},
        title: 'Generar documentos',
        text: 'Siguiente',
        button_hidden: true,
        icon_hidden: true
      }];
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setInstallerSteps: function setInstallerSteps() {
      this.steppers = [{
        ref: 'advise',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          type: !(this.isSuperadmin() || this.isAdmin()) ? 'hidden' : 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: !(this.isSuperadmin() || this.isAdmin()) ? 'hidden' : 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'gray',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'help_outline',
          icon_color: 'primary',
          value: 'ATENCIÓN: Antes de firmar o generar el parte B deben agregarse los números de serie.'
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Agregar números de serie',
            align: 'right',
            outline: true,
            ref: 'serial-numbers'
          }]
        }]),
        requestImagesOnNew: {},
        title: 'Generar documentos',
        text: 'Siguiente',
        icon_hidden: true
      }, {
        ref: 'customer_signature',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          type: !(this.isSuperadmin() || this.isAdmin()) ? 'hidden' : 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: !(this.isSuperadmin() || this.isAdmin()) ? 'hidden' : 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'gray',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Imprimir y firmar',
            align: 'right',
            outline: true,
            open_new_window: false,
            ref: 'upload-doc-3'
          }, {
            text_button: 'GENERAR y firmar en pantalla',
            align: 'right',
            outline: true,
            open_new_window: false,
            ref: 'signature-doc-3'
          }]
        }]),
        title: 'Generar documentos',
        button_hidden: this.hasSerials,
        icon_hidden: true
      }, {
        ref: 'customer-advise',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          type: !(this.isSuperadmin() || this.isAdmin()) ? 'hidden' : 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: !(this.isSuperadmin() || this.isAdmin()) ? 'hidden' : 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'check',
          icon_color: 'teal',
          value: 'El documento se ha actualizado correctamente.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'help_outline',
          icon_color: 'primary',
          value: 'Aconsejamos entregar al cliente una copia del parte B firmada.'
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Enviar por email',
            align: 'right',
            outline: true,
            ref: 'email-doc-3'
          }]
        }, {
          assign_to: 'unknown',
          type: 'checkbox',
          columns: 'xs12 sm12 md12 lg12',
          label: 'Se ha entregado/enviado una copia firmada.',
          value: this.checkboxDoc3,
          required: !this.checkboxDoc3,
          rules: !this.checkboxDoc3 ? ['is_true'] : []
        }]),
        requestImagesOnNew: {},
        title: 'Generar documentos',
        text: 'Siguiente',
        icon_hidden: true
      }, {
        ref: 'advise',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          type: !(this.isSuperadmin() || this.isAdmin()) ? 'hidden' : 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: !(this.isSuperadmin() || this.isAdmin()) ? 'hidden' : 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '4. AVISO DE INSTALACIÓN.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'help_outline',
          icon_color: 'primary',
          value: 'Los documentos se han generado correctamente.'
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Aceptar',
            align: 'right',
            outline: true,
            ref: 'finish-serials'
          }]
        }]),
        requestImagesOnNew: {},
        title: 'Generar documentos',
        text: 'Finalizar',
        icon_hidden: true
      }];
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setSteps: function setSteps() {
      if ((this.isSuperadmin() || this.isAdmin()) && !this.isNew() && (!this.installationInfo[0].value || !this.installationInfo[1].value || !this.installationInfo[2].value || !this.installationInfo[3].value || !this.installationInfo[4].value)) {
        return this.setAdminSteps();
      }
      var phoneExists1 = this.phone.value && this.phone.value[0] !== undefined;
      var phoneExists2 = this.phone.value && this.phone.value[1] !== undefined;
      var phoneExists3 = this.phone.value && this.phone.value[2] !== undefined;
      var equipmmentExists1 = this.equipmentExists();
      var observations = this.observation.value && this.observation.value[0] !== undefined;
      this.steppers = [{
        ref: 'commerce',
        fields: this.assignTo,
        title: 'Asignar al comercio'
      }, {
        ref: 'seller',
        fields: [this.sellersParams || {}],
        title: 'Asignar al vendedor',
        icon_hidden: !(this.isSuperadmin() || this.isAdmin())
      }, {
        ref: 'customer',
        fields: this.customer,
        title: 'Datos del cliente'
      }, {
        ref: 'phones',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          prepend_icon: 'phone',
          placeholder: 'Teléfono 1',
          editable: true,
          type: phoneExists1 ? 'text-field' : 'hidden',
          required: true,
          rules: ['required'],
          value: phoneExists1 ? this.phone.value[0].value : '',
          disabled: phoneExists1
        }, {
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          prepend_icon: 'phone',
          placeholder: 'Teléfono 2',
          editable: true,
          type: phoneExists2 ? 'text-field' : 'hidden',
          value: phoneExists2 ? this.phone.value[1].value : '',
          disabled: phoneExists2
        }, {
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          prepend_icon: 'phone',
          placeholder: 'Teléfono 3',
          editable: true,
          type: phoneExists3 ? 'text-field' : 'hidden',
          value: phoneExists3 ? this.phone.value[2].value : '',
          disabled: phoneExists3
        }, {
          assign_to: 'unknown',
          disabled: phoneExists1 && phoneExists2 && phoneExists3,
          ref: 'add-phone',
          type: 'button',
          align: 'center',
          columns: 'xs12 sm12 md12 lg12',
          text_button: 'Agregar teléfono'
        }]),
        title: 'Teléfonos de contacto'
      }, {
        ref: 'address',
        fields: [this.route, this.routeExtras, this.postalCode, this.locality, this.province, this.placeID],
        title: 'Dirección de cliente'
      }, {
        ref: 'installationAddress',
        fields: [this.addressCheckbox],
        title: ''
      }, {
        ref: 'address2',
        fields: [this.routeDelivery, this.routeExtrasDelivery, this.postalCodeDelivery, this.localityDelivery, this.provinceDelivery, this.placeIdDelivery],
        title: 'Dirección de instalación'
      }, {
        ref: 'equipments',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          prepend_icon: 'inbox',
          placeholder: 'Equipo',
          type: equipmmentExists1 ? 'text-field' : 'hidden',
          required: true,
          rules: ['required'],
          value: equipmmentExists1 ? this.bookingEquipments.value[0].brand + ' ' + this.bookingEquipments.value[0].model : '',
          disabled: equipmmentExists1
        }, {
          assign_to: 'unknown',
          disabled: equipmmentExists1,
          ref: 'add-equipment',
          type: 'button',
          align: 'center',
          columns: 'xs12 sm12 md12 lg12',
          text_button: 'Agregar equipo'
        }]),
        title: 'Equipo a instalar'
      }, {
        ref: 'preBooking',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          prepend_icon: 'inbox',
          placeholder: 'Equipo',
          type: 'hidden',
          required: true,
          rules: ['required'],
          value: this.bookingWasSearch ? 'true' : '',
          disabled: this.bookingWasSearch
        }, {
          assign_to: 'unknown',
          disabled: this.bookingWasSearch,
          ref: 'search-bookings',
          type: 'button',
          loading: false,
          align: 'center',
          columns: 'xs12 sm12 md12 lg12',
          text_button: 'Buscar'
        }]),
        title: 'Buscar reservas disponibles para la instalación',
        subtitle: this.bookingWasSearch && !this.hasAssignation ? 'No se han encontrado instaladores disponibles en la zona del cliente. Desde Instalaciones BEC nos encargaremos de asignar la instalación una vez finalizada la reserva.' : this.hasAssignation ? 'La reserva ha sido realizada.' : false
      }, {
        ref: 'installationInfo',
        fields: [this.installationInfo[0], this.installationInfo[1], this.installationInfo[2], this.installationInfo[3]],
        title: 'Fecha y hora de la instalación'
      }, {
        ref: 'installer',
        fields: [this.installationInfo[4]],
        title: 'Asignar al instalador'
      }, {
        ref: 'saleDeliveryDate',
        fields: [this.saleSoldDate, this.saleDeliveryDate],
        title: 'Fecha de venta y entrega'
      },
      // {
      //   ref: 'saleSoldDate',
      //   fields: [this.saleSoldDate],
      //   title: 'Fecha de venta'
      // },
      {
        ref: 'requestImagesOnNew',
        fields: this.normalizeAndAssign([{
          ref: 'requestImagesOnNew',
          type: 'radio-group',
          assign_to: 'requestImagesOnNew',
          label: '¿Solicitar fotografías de la instalación?',
          columns: 'xs12',
          value: 'No',
          options: [{
            value: 'yes',
            label: 'Sí'
          }, {
            value: 'No',
            label: 'No'
          }]
        }])
      }, {
        ref: 'saleDetails',
        fields: [this.fields[2], this.fields[3], this.fields[4]],
        title: 'Detalles de la venta'
      }, {
        ref: 'observations',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          prepend_icon: 'inbox',
          placeholder: 'Observaciones',
          multi_line: true,
          type: observations ? 'text-field' : 'hidden',
          required: true,
          value: this.observation.value !== undefined && this.observation.value.length ? this.observation.value[0].booking_observation_message : '',
          disabled: true
        }, {
          assign_to: 'unknown',
          disabled: observations,
          ref: 'add-observation',
          type: 'button',
          align: 'center',
          columns: 'xs12 sm12 md12 lg12',
          text_button: 'Agregar observaciones'
        }]),
        title: 'Agregar observaciones',
        text: 'Siguiente'
      }, {
        ref: 'document_1',
        fields: [{
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'help_outline',
          icon_color: 'primary',
          value: 'Antes de dar por terminada la reserva, se deben generar los siguientes documentos que deben ser firmados por el cliente:'
        }, {
          type: 'section-text',
          icon_color: 'gray',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: 'section-text',
          icon_color: 'gray',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
        }],
        title: 'Generar documentos'
      }, {
        ref: 'document_1_1',
        fields: [{
          type: 'section-text',
          append_icon: 'check_circle_outline',
          icon_color: 'gray',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE:'
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Imprimir y firmar',
            align: 'right',
            outline: true,
            open_new_window: false,
            ref: 'upload-doc-1'
          }, {
            text_button: 'GENERAR y firmar en pantalla',
            align: 'right',
            outline: true,
            open_new_window: false,
            ref: 'signature-doc-1'
          }]
        }],
        title: 'Generar documentos',
        button_hidden: true
      }, {
        ref: 'document_1_2',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          type: 'section-text',
          append_icon: 'check_circle_outline',
          icon_color: 'teal',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'check',
          icon_color: 'teal',
          value: 'El documento se ha actualizado correctamente.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'help_outline',
          icon_color: 'primary',
          value: 'Aconsejamos entregar al cliente una copia de la conformidad firmada.'
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Enviar por email',
            disabled: this.sendEmailDoc1 === true,
            align: 'right',
            outline: true,
            ref: 'email-doc-1'
          }]
        }, {
          assign_to: 'unknown',
          type: 'checkbox',
          columns: 'xs12 sm12 md12 lg12',
          label: 'Se ha entregado/enviado una copia firmada.',
          value: this.checkboxDoc1,
          required: !this.checkboxDoc1,
          rules: !this.checkboxDoc1 ? ['is_true'] : []
        }]),
        title: 'Generar documentos',
        icon_hidden: true
      }, {
        ref: 'document_2',
        fields: [{
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle_outline',
          icon_color: 'gray',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017:'
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Imprimir y firmar',
            align: 'right',
            outline: true,
            open_new_window: false,
            ref: 'upload-doc-2'
          }, {
            text_button: 'GENERAR y firmar en pantalla',
            align: 'right',
            outline: true,
            open_new_window: false,
            ref: 'signature-doc-2'
          }]
        }],
        title: 'Generar documentos',
        button_hidden: true,
        icon_hidden: true
      }, {
        ref: 'document_2_1',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'check',
          icon_color: 'teal',
          value: 'El documento se ha actualizado correctamente.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'help_outline',
          icon_color: 'primary',
          value: 'Aconsejamos entregar al cliente una copia del parte A firmada.'
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Enviar por email',
            align: 'right',
            outline: true,
            disabled: this.sendEmailDoc2 === true,
            ref: 'email-doc-2'
          }]
        }, {
          assign_to: 'unknown',
          type: 'checkbox',
          columns: 'xs12 sm12 md12 lg12',
          label: 'Se ha entregado/enviado una copia firmada.',
          value: this.checkboxDoc2,
          required: !this.checkboxDoc2,
          rules: !this.checkboxDoc2 ? ['is_true'] : []
        }]),
        title: 'Generar documentos',
        icon_hidden: true
      }, {
        ref: 'finish',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          value: parseInt(this.calendar_visibility.value) === 1 ? 'ENHORABUENA ' + (this.fields[5] ? this.fields[5].value.seller_name : '') + ': queda confirmado que la reserva de instalación del cliente ' + (this.customer[0] ? this.customer[0].value : '') + ' ' + (this.customer[0] ? this.customer[1].value : '') + ', para el equipo ' + (this.bookingEquipments.value[0] ? this.bookingEquipments.value[0].model : '') + ', del tipo ' + (this.bookingEquipments.value[0] ? this.bookingEquipments.value[0].type : '') + ' se ha realizado correctamente.' : 'GRACIAS ' + (this.fields[5] ? this.fields[5].value.seller_name : '') + ', desde Instalaciones BEC ¡nos pondremos en contacto con el cliente lo antes posible para darle fecha y hora de instalación!.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          value: parseInt(this.calendar_visibility.value) === 1 ? 'A partir de aquí, desde Instalaciones BEC nos encargaremos del resto. Muchas gracias por tu colaboración.' : ''
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Aceptar',
            align: 'right',
            outline: true,
            ref: 'finish-booking'
          }]
        }]),
        requestImagesOnNew: {},
        title: '¡RESERVA FINALIZADA!',
        text: 'Finalizar',
        icon_hidden: true,
        button_hidden: true
      }, {
        ref: 'advise',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '4. AVISO DE INSTALACIÓN.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          append_icon: 'help_outline',
          icon_color: 'primary',
          value: 'Los documentos se han generado correctamente. Puedes finalizar la reserva o enviar el aviso de instalación al comerciante. No es necesario enviar el aviso al instalador, el sistema lo enviará de forma automática 24 horas antes (48 horas si hay fiesta entre medio).'
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Finalizar',
            align: 'right',
            outline: true,
            ref: 'next-step'
          }, {
            text_button: 'Enviar aviso a comerciante',
            align: 'right',
            disabled: false,
            loading: false,
            outline: true,
            ref: 'email-doc-4'
          }]
        }]),
        requestImagesOnNew: {},
        title: 'Generar documentos',
        text: 'Siguiente',
        button_hidden: true,
        icon_hidden: true
      }, {
        ref: 'finish',
        fields: this.normalizeAndAssign([{
          assign_to: 'unknown',
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          columns: 'xs12 sm12 md12 lg12',
          value: '1. CONFORMIDAD DE CLIENTE.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '2. PARTE A – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '3. PARTE B – ANEXO VI – R.D. 115/2017.'
        }, {
          type: 'section-text',
          append_icon: 'check_circle',
          icon_color: 'teal',
          assign_to: 'unknown',
          columns: 'xs12 sm12 md12 lg12',
          value: '4. AVISO DE INSTALACIÓN.'
        }, {
          assign_to: 'unknown',
          type: 'section-text',
          columns: 'xs12 sm12 md12 lg12',
          value: '¡ENHORABUENA! Queda confirmado que la reserva de instalación del cliente ' + (this.customer[0] ? this.customer[0].value : '') + ' ' + (this.customer[0] ? this.customer[1].value : '') + ', para el equipo ' + (this.bookingEquipments.value[0] ? this.bookingEquipments.value[0].model : '') + ', del tipo ' + (this.bookingEquipments.value[0] ? this.bookingEquipments.value[0].type : '') + ' se ha realizado correctamente.'
        }, {
          assign_to: 'unknown',
          type: 'button',
          columns: 'xs12 sm12 md12 lg12',
          items: [{
            text_button: 'Aceptar',
            align: 'right',
            outline: true,
            ref: 'finish-booking'
          }]
        }]),
        requestImagesOnNew: {},
        title: '¡INSTALACIÓN RESERVADA!',
        text: 'Finalizar',
        icon_hidden: true
      }];
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onNextStep: function onNextStep(item, step, isValid) {
      console.log(item.ref);
      if (!isValid) {
        this.$awn.warning('Debes completar este paso antes de continuar');
      }
      // console.log('------>>>>', item.ref)
      // this.$refs.stepper.lastStep()
      // this.$refs.equipment_aggregator.openDialog()
      if (!(this.isSuperadmin() || this.isAdmin()) && item.ref === 'customer') {
        if (parseInt(this.sellerID.value) === 1) {
          this.$refs.stepper.lastStep();
        }
      } else if (item.ref === 'commerce') {
        if (!(this.isSuperadmin() || this.isAdmin())) {
          this.$refs.stepper.nextStep();
        }
      } else if (item.ref === 'address') {
        this.$refs.editable_address_card_1.openDialog();
      } else if (item.ref === 'address2') {
        if (this.addressCheckbox.value === 'yes') {
          this.$refs.stepper.nextStep();
        } else {
          this.$refs.editable_address_card_2.openDialog();
        }
      } else if (item.ref === 'phones') {
        if (this.phone.value.length === 0) {
          this.$refs.phone_aggregator.openDialog();
        }
      } else if (item.ref === 'equipments') {
        if (this.bookingEquipments.value.length === 0) {
          return this.$refs.equipment_aggregator.openDialog();
        }
        if (parseInt(this.calendar_visibility.value) === 0) {
          this.$refs.stepper.nextStep();
          this.$refs.stepper.nextStep();
        }
      } else if (item.ref === 'preBooking') {
        if (!(this.isSuperadmin() || this.isAdmin()) && parseInt(this.calendar_visibility.value) === 0) {
          this.$refs.stepper.nextStep();
          this.$refs.stepper.nextStep();
          this.$refs.stepper.nextStep();
        }
      } else if (item.ref === 'saleSoldDate') {
        this.onChange(this.fields[1].value, '8', this.fields[1], true);
        this.$refs.stepper.nextStep();
      } else if (item.ref === 'installationInfo') {
        if (!(this.isSuperadmin() || this.isAdmin()) && !this.hasAssignation) {
          this.$refs.stepper.nextStep();
          this.$refs.stepper.nextStep();
        }
      } else if (item.ref === 'installer') {
        if (!(this.isSuperadmin() || this.isAdmin()) && !this.hasAssignation) {
          this.$refs.stepper.nextStep();
        }
      } else if (item.ref === 'document_1') {
        if (this.isSuperadmin() || this.isAdmin()) {
          this.$refs.stepper.nextStep();
          this.$refs.stepper.nextStep();
          this.$refs.stepper.nextStep();
          this.$refs.stepper.nextStep();
          this.$refs.stepper.nextStep();
          this.$refs.stepper.nextStep();
        }
      } else if (item.ref === 'requestImagesOnNew') {
        if (!(this.isSuperadmin() || this.isAdmin())) {
          this.$refs.stepper.nextStep();
        }
      } else if (item.ref === 'customer_signature') {
        if (!this.bookingEquipments.value[0] || !this.bookingEquipments.value[0].serial_indoor_unit_1 || !this.bookingEquipments.value[0].serial_outdoor_unit_1) {
          this.$refs.stepper.lastStep();
          this.$awn.warning('Debes completar este paso antes de continuar');
        } else {
          this.hasSerials = true;
          this.$refs.stepper.nextStep();
          this.$refs.stepper.nextStep();
        }
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onLastStep: function onLastStep(item, step, isValid) {
      // this.$refs.stepper.lastStep()
      // this.$refs.equipment_aggregator.openDialog()
      // console.log('STEP', item.ref)
      this.currentStep = item.ref;
      if (item.ref === 'address') {
        this.$refs.editable_address_card_1.openDialog();
      } else if (item.ref === 'address2') {
        if (this.addressCheckbox.value === 'yes') {
          this.$refs.stepper.lastStep();
        } else {
          this.$refs.editable_address_card_2.openDialog();
        }
      } else if (item.ref === 'installationInfo') {
        if (!(this.isSuperadmin() || this.isAdmin()) && !this.hasAssignation) {
          this.$refs.stepper.lastStep();
        }
      } else if (item.ref === 'saleSoldDate') {
        this.$refs.stepper.lastStep();
      } else if (item.ref === 'installer') {
        if (!(this.isSuperadmin() || this.isAdmin()) && !this.hasAssignation) {
          this.$refs.stepper.lastStep();
          this.$refs.stepper.lastStep();
        }
        if (!(this.isSuperadmin() || this.isAdmin()) && !this.hasAssignation && parseInt(this.calendar_visibility.value) === 0) {
          this.$refs.stepper.lastStep();
        }
      } else if (item.ref === 'commerce') {
        if (!(this.isSuperadmin() || this.isAdmin())) {
          this.$refs.stepper.lastStep();
        }
      } else if (item.ref === 'requestImagesOnNew') {
        if (!(this.isSuperadmin() || this.isAdmin())) {
          this.$refs.stepper.lastStep();
        }
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getAvailableBookings: function getAvailableBookings() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'get/bookings/available/' + _this2.commerceID.value + '/',
          data: {
            postalCode: _this2.postalCodeDelivery.value,
            locality: _this2.localityDelivery.value,
            province: _this2.provinceDelivery.value,
            placeID: _this2.placeIdDelivery.value,
            duration: parseInt(_this2.bookingEquipments.value[0].duration),
            quantity: parseInt(_this2.bookingEquipments.value[0].quantity)
          }
        }).then(function (response) {
          // console.log(response)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this2.$store.dispatch('snackbar/show', 'Error al obtener reservas: ' + _this2.$store.getters['api/getMessage']);
          reject(error);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    duplicateBooking: function duplicateBooking() {
      var _this3 = this;

      this.duplicateBookingOnServer().then(function (saleId) {
        if (saleId) {
          _this3.$router.push({
            name: 'booking-id',
            params: {
              booking_id: saleId
            }
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this3.$store.dispatch('snackbar/show', 'Error al duplicar reserva: ' + _this3.$store.getters['api/getMessage']);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addEventToGoogleCalendar: function addEventToGoogleCalendar() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'sale/add-event-to-google-calendar/' + _this4.bookingID.value + '/'
        }).then(function (response) {
          console.log('GOOGLE_CALENDAR', response);
          resolve(true);
        }).catch(function (error) {
          console.log(error);
          _this4.$store.dispatch('snackbar/show', 'Error al agregar evento en Google Calendar: ' + _this4.$store.getters['api/getMessage']);
          reject(error);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    duplicateBookingOnServer: function duplicateBookingOnServer() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var cloneBooking = _this5.cloneBooking ? 1 : 0;
        var cloneDocuments = _this5.cloneDocuments ? 1 : 0;
        var cloneObservations = _this5.cloneObservations ? 1 : 0;
        _this5.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'sale/duplicate/' + _this5.saleID.value + '/' + cloneBooking + '/' + cloneDocuments + '/' + cloneObservations + '/'
        }).then(function (response) {
          resolve(response.data || null);
        }).catch(function (error) {
          console.log(error);
          _this5.$store.dispatch('snackbar/show', 'Error al obtener reservas: ' + _this5.$store.getters['api/getMessage']);
          reject(error);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAssignBooking: function onAssignBooking(installerID, start, end) {
      var _this6 = this;

      // console.log(installerID, start, end)
      this.hasAssignation = true;
      this.setSteps();
      this.installerID.value = parseInt(installerID);
      this.updateItem(this.installerID, this.installerID.value);
      var index = this.installationInfo[4].items.findIndex(function (item) {
        return parseInt(item[_this6.installationInfo[4].item_text_11]) === parseInt(installerID);
      });
      this.installationInfo[4].value = this.installationInfo[4].items[index];
      this.installationStartDate.value = this.moment(start).format('YYYY-MM-DD HH:mm');
      this.installationEndDate.value = this.moment(end).format('YYYY-MM-DD HH:mm');
      var startDate = this.installationStartDate.value;
      this.updateItem(this.installationStartDate, this.installationStartDate.value);
      var endDate = this.installationEndDate.value;
      this.updateItem(this.installationEndDate, this.installationEndDate.value);
      this.installationInfo[0].value = this.moment(startDate).format('YYYY-MM-DD');
      this.installationInfo[1].value = this.moment(endDate).format('YYYY-MM-DD');
      this.installationInfo[2].value = this.moment(startDate).format('HH:mm');
      this.installationInfo[3].value = this.moment(endDate).format('HH:mm');
      this.calendar = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isResponsible: function isResponsible() {
      return this.$store.getters['api/getUserRol'] === 'responsible';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isManager: function isManager() {
      return this.$store.getters['api/getUserRol'] === 'manager';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isSuperadmin: function isSuperadmin() {
      return this.$store.getters['api/getUserRol'] === 'superadmin';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isAdmin: function isAdmin() {
      return this.$store.getters['api/getUserRol'] === 'administrator';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isNew: function isNew() {
      return this.$route.params.booking_id === 'new';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isEdit: function isEdit() {
      return this.$route.name === 'booking-edit';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isView: function isView() {
      return this.$route.name !== 'booking-edit' && this.$route.name !== 'booking-new';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getTitle: function getTitle() {
      if (this.isView()) {
        return 'Detalles de la reserva';
      } else if (this.isEdit()) {
        return 'Editar reserva';
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDelete: function onDelete() {
      return this.$route.name === 'booking-edit';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setSignature: function setSignature(toolbarTitle, fileTitle, filetype, filename) {
      // console.log(toolbarTitle, fileTitle, filetype, filename)
      this.signature.toolbar_title = toolbarTitle;
      this.signature.booking_document_title = fileTitle;
      this.signature.booking_document_filetype = filetype;
      this.signature.booking_document_filename = filename;
      this.$refs.signature.openDialog();
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    uploadInvoice: function uploadInvoice() {
      this.$refs.document_aggregator.openDialog('Subir factura de compra', 'Factura de compra', true, 'factura-compra-reserva-' + this.saleID.value + '.pdf');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    generateDoc: function generateDoc(type, documentID) {
      this.currentDocumentID = documentID;
      if (type === 'signature') {
        if (documentID === 1) {
          this.isSignature = true;
          this.generateDocument(documentID, true);
          this.setSignature('Firmar documento: Conformidad Cliente', 'Firma documento: Conformidad Cliente', 'image/png', 'firma-documento-conformidad-cliente.png');
        } else if (documentID === 2) {
          this.isSignature = true;
          this.generateDocument(documentID, true);
          this.setSignature('Firmar documento: Parte A', 'Firma documento: Parte A', 'image/png', 'firma-documento-parte-a.png');
        } else if (documentID === 3) {
          this.isSignature = true;
          this.generateDocument(documentID, true);
          this.setSignature('Firmar documento: Parte B', 'Firma documento: Parte B', 'image/png', 'firma-documento-parte-b.png');
        }
      } else {
        if (documentID === 1) {
          this.isSignature = false;
          this.generateDocument(documentID, true);
          this.$refs.document_aggregator.openDialog('Adjuntar conformidad firmada por el cliente', 'Documento Conformidad Cliente', true, 'conformidad-cliente-adjunto.pdf');
        } else if (documentID === 2) {
          this.isSignature = false;
          this.generateDocument(documentID, true);
          this.$refs.document_aggregator.openDialog('Adjuntar parte A firmado por el cliente', 'Documento Parte A', true, 'real-decreto-115-2017-A-adjunto.pdf');
        } else if (documentID === 3) {
          this.isSignature = false;
          this.generateDocument(documentID, true);
          this.$refs.document_aggregator.openDialog('Adjuntar parte B firmado por el cliente', 'Documento Parte B', true, 'real-decreto-115-2017-B-adjunto.pdf');
        }
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    signatureExists: function signatureExists() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'bookings/signature/exists/' + _this7.bookingID.value + '/'
        }).then(function (response) {
          resolve(response.data);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    generateDocument: function generateDocument(documentID, openFile) {
      var _this8 = this;

      openFile && this.openNewWindow();
      if (documentID === 3) {
        if (!this.isCommerce() && !this.hasSerials) {
          this.newWindowContent.close();
          this.setInstallerSteps();
          this.noAssignation = true;
          return false;
        } else {
          this.signatureExists().then(function (response) {
            if (_this8.isInstaller() && !response) {
              _this8.setInstallerSteps();
              _this8.noAssignation = true;
              if (!_this8.addingSignature) {
                _this8.newWindowContent.close();
                _this8.$refs.stepper.nextStep();
              }
              _this8.addingSignature = true;
              return false;
            }
          });
        }
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this8.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'bookings/document/' + documentID + '/' + _this8.saleID.value + '/'
        }).then(function (response) {
          // console.log('$$$$$$$$$$$', response.data)
          console.log(response);
          if (openFile) {
            _this8.newWindowContent.location.href = response.data.replace('public/documents/bookings', 'shared/documents/bookings') + '?isAuthorized';
          }
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this8.$store.dispatch('snackbar/show', 'Error al generar el documento: ' + _this8.$store.getters['api/getMessage']);
          reject(error);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangeSignature: function onChangeSignature(item) {
      console.log('onChangeSignature');
      this.signature.booking_document_url = item.value;
      this.generateDocument(this.currentDocumentID, true);
      this.onAddDocument(this.signature);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getMailingRegisters: function getMailingRegisters() {
      var _this9 = this;

      this.$store.dispatch('api/authRequest', {
        method: 'get',
        url: 'mailing-registers/' + this.saleID.value + '/'
      }).then(function (response) {
        _this9.adviceSentToAdmin = response.data.findIndex(function (item) {
          return item.mailing_register_reference === 'advice_sent_to_admin';
        }) > -1;
        console.log('adviceSentToAdmin', _this9.adviceSentToAdmin);
        _this9.adviceSentToCommerce = response.data.findIndex(function (item) {
          return item.mailing_register_reference === 'advice_sent_to_commerce';
        }) > -1;
        _this9.adviceSentToInstaller = response.data.findIndex(function (item) {
          return item.mailing_register_reference === 'advice_sent_to_installer';
        }) > -1;
      }).catch(function (error) {
        _this9.$store.dispatch('snackbar/show', 'Error al obtener los registros de correos enviados: ' + _this9.$store.getters['api/getMessage']);
        console.log(error);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isAssignated: function isAssignated() {
      return this.installationInfo[0].value && this.installationInfo[1].value && this.installationInfo[2].value && this.installationInfo[4].value;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeAddress: function normalizeAddress() {
      this.normalizeAndAssign([{
        ref: 'installationAddress',
        type: 'radio-group',
        label: '¿La instalación se ha de realizar en la dirección indicada?',
        columns: 'xs12',
        assign_to: 'addressCheckbox',
        value: null,
        options: [{
          value: 'yes',
          label: 'Sí'
        }, {
          value: 'No',
          label: 'No'
        }],
        rules: ['required'],
        required: true
      }]);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onFinish: function onFinish() {
      var _this10 = this;

      var userID = parseInt(this.$store.getters['api/getUserId']);
      this.$store.dispatch('api/authRequest', {
        method: 'get',
        url: 'email-new-booking/' + userID + '/' + this.saleID.value + '/'
      }).then(function (response) {
        _this10.$router.push({
          name: 'booking-id',
          params: {
            booking_id: _this10.saleID.value
          }
        });
        // console.log(response)
      }).catch(function () {
        var message = _this10.$store.getters['api/getMessage'];
        _this10.$awn.alert('Error al enviar email informativo: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeAndAssign: function normalizeAndAssign(params) {
      var _this11 = this;

      var filter = function filter(param, def) {
        return typeof param !== 'undefined' ? param : def;
      };
      params.map(function (obj, index) {
        obj.editable = !_this11.isNew() ? filter(obj.editable, true) : false;
        obj.label = filter(obj.label, undefined);
        obj.hint = !_this11.isNew() ? filter(obj.hint, 'Pulsa enter para guardar') : '';
        obj.no_data_text = filter(obj.no_data_text, 'Pulsa enter para agregar:');
        obj.ref = filter(obj.ref, '');
        obj.order = filter(obj.order, '');
        obj.assign_to = filter(obj.assign_to, 'fields');
        obj.value_class = filter(obj.value_class, '');
        obj.tooltip = filter(obj.tooltip, 'Pulsa para editar');
        obj.focus_next_on_enter = filter(obj.focus_next_on_enter, true);
        obj.dark = filter(obj.dark, false);
        obj.color = filter(obj.color, 'primary');
        obj.columns = filter(obj.columns, 'xs12 sm6 md6 lg6');
        obj.counter = filter(obj.counter, false);
        obj.dialog = filter(obj.dialog, false);
        obj.required = filter(obj.required, false);
        obj.type = filter(obj.type, 'select');

        obj.disabled = filter(obj.disabled, false);
        obj.update = filter(obj.update, true);
        obj.add_on_enter = filter(obj.add_on_enter, false);
        obj.autocomplete = filter(obj.autocomplete, obj.ref);
        obj.rules = filter(obj.rules, []);
        obj.rules = _this11.setRules(obj.rules);
        var assignTo = Array.isArray(obj.assign_to) ? obj.assign_to : [obj.assign_to];

        assignTo.forEach(function (item) {
          if (Array.isArray(_this11[item])) {
            _this11[item].push(obj);
          } else {
            _this11[item] = obj;
          }
        });
      });
      return params;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    validateEmail: function validateEmail() {
      if (this.$refs.fields.$refs.form_creator.validateForm()) {
        this.dialogEmail = false;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getObservations: function getObservations() {
      var _this12 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var bookingID = _this12.$route.params.booking_id;
        _this12.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'booking/observations/' + bookingID + '/'
        }).then(function (response) {
          _this12.observation.items = response.data.reverse();
          // console.log(response)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this12.$store.dispatch('snackbar/show', 'Error al obtener observaciones: ' + _this12.$store.getters['api/getMessage']);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openNewWindow: function openNewWindow() {
      if (this.newWindowContent === null || this.newWindowContent && this.newWindowContent.closed) {
        this.newWindowContent = window.open('', '_blank');
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getDocuments: function getDocuments() {
      var _this13 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var bookingID = _this13.$route.params.booking_id;
        _this13.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'booking/documents/' + bookingID + '/'
        }).then(function (response) {
          // console.log(response)
          _this13.documents.items = response.data.reverse();
          // console.log(response)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this13.$store.dispatch('snackbar/show', 'Error al obtener el documento: ' + _this13.$store.getters['api/getMessage']);
          reject(error);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onCloseStepper: function onCloseStepper() {
      this.$router.go(-1);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getEquipments: function getEquipments() {
      var _this14 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this14.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'equipments/'
        }).then(function (response) {
          console.log(response.data);
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this14.$store.dispatch('snackbar/show', 'Error al obtener equipos: ' + _this14.$store.getters['api/getMessage']);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteObservation: function deleteObservation(index, item) {
      var _this15 = this;

      this.$store.dispatch('api/authRequest', {
        method: 'delete',
        url: 'booking/observations/' + item.booking_observation_id + '/'
      }).then(function (response) {
        // console.log(response)
        _this15.observation.items.splice(index, 1);
        if (!_this15.isNew()) {
          _this15.$awn.success('Observación eliminada');
        }
      }).catch(function () {
        var message = _this15.$store.getters['api/getMessage'];
        _this15.$awn.alert('Error al eliminar la observación: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    congratulations: function congratulations() {
      this.$refs.observation_aggregator.openAggregator('3', '¡Buen trabajo!', '¡Buen trabajo!', 'congratulations', false);
      this.$refs.observation_aggregator.addObservation();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    equipmentExists: function equipmentExists() {
      return this.bookingEquipments.value && this.bookingEquipments.value[0] !== undefined;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteDocument: function deleteDocument(index, item) {
      var _this16 = this;

      this.$store.dispatch('api/authRequest', {
        method: 'delete',
        url: 'booking/documents/' + item.booking_document_id + '/'
      }).then(function (response) {
        // console.log(response)
        _this16.documents.items.splice(index, 1);
        if (!_this16.isNew()) {
          _this16.$awn.success('Documento eliminado');
        }
      }).catch(function () {
        var message = _this16.$store.getters['api/getMessage'];
        _this16.$awn.alert('Error al eliminar la observación: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddObservation: function onAddObservation(item) {
      var _this17 = this;

      item.user_id = parseInt(this.$store.getters['api/getUserId']);
      item.booking_id = parseInt(this.bookingID.value);
      item.sale_id = parseInt(this.saleID.value);
      this.$store.dispatch('api/authRequest', {
        method: 'post',
        url: 'booking/observations/',
        data: item
      }).then(function (response) {
        // console.log(response.data)
        delete item.sale_id;
        item.booking_observation_id = response.data;
        item.booking_observation_user = 'Tú';
        _this17.observation.items.push(item);
        if (!_this17.isNew()) {
          _this17.$awn.success('Nota agregada');
        } else {
          if (!_this17.requestImagesOnNeww) {
            _this17.setSteps();
          }
        }
        _this17.getObservations();
        _this17.requestImagesOnNeww = false;
      }).catch(function (error) {
        console.log(error);
        var message = _this17.$store.getters['api/getMessage'];
        _this17.$awn.alert('Error al agregar la nota: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddDocument: function onAddDocument(item) {
      var _this18 = this;

      // console.log(item)
      if (this.isNew() || this.addingSignature) {
        this.$refs.stepper.nextStep();
      }
      item.user_id = parseInt(this.$store.getters['api/getUserId']);
      item.booking_id = parseInt(this.bookingID.value);
      this.$store.dispatch('api/authRequest', {
        method: 'post',
        url: 'booking/documents/',
        data: item
      }).then(function (response) {
        item.booking_document_id = response.data;
        item.booking_document_user = 'Tú';
        _this18.documents.items.push(item);
        if (item.booking_document_filename === 'factura-compra-reserva-' + _this18.saleID.value + '.pdf') {
          _this18.sendEmail('email-invoice-admin');
          _this18.invoice[0].value = true;
          _this18.updateItem(_this18.invoice[0], _this18.invoice[0].value);
        }
        if (!_this18.isNew()) {
          _this18.$awn.success('Documento agregado');
        }
        if ((_this18.isNew() || _this18.addingSerials) && _this18.isSignature) {
          _this18.generateDocument(_this18.currentDocumentID, true);
        }
        _this18.getDocuments();
      }).catch(function (error) {
        console.log(error);
        var message = _this18.$store.getters['api/getMessage'];
        _this18.$awn.alert('Error al agregar el documento: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddEquipment: function onAddEquipment(item) {
      if (this.isNew()) {
        this.setSteps();
      }
      this.onChange(this.bookingEquipments.value, null, this.bookingEquipments, true);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteEquipment: function deleteEquipment(index, item) {
      this.onChange(this.bookingEquipments.value, null, this.bookingEquipments, true);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCommerces: function getCommerces() {
      var _this19 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this19.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/active-commerces/'
        }).then(function (response) {
          var index = response.data.items.findIndex(function (item) {
            return parseInt(item[response.data.item_text]) === parseInt(_this19.commerceID.value);
          });
          response.data.value = response.data.items[index];
          response.data.item_text = response.data.item_text_3;
          response.data.item_value = response.data.item_value;
          _this19.normalizeAndAssign([response.data]);
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this19.$store.dispatch('snackbar/show', 'Error al obtener comercios: ' + _this19.$store.getters['api/getMessage']);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getInstallers: function getInstallers() {
      var _this20 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this20.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/active-installers/'
        }).then(function (response) {
          var index = response.data.items.findIndex(function (item) {
            return parseInt(item[response.data.item_text]) === parseInt(_this20.installerID.value);
          });

          response.data.items.map(function (obj, index) {
            // obj[response.data.item_text_2] = obj[response.data.item_text_11] + ' ' + obj[response.data.item_text_3]
            obj.theName = obj[response.data.item_text_2];
            obj[response.data.item_text_2] = obj[response.data.item_text_12];
            return obj;
          });
          response.data.value = response.data.items[index];
          response.data.item_text = response.data.item_text_2;
          response.data.item_value = response.data.item_value;
          _this20.normalizeAndAssign([response.data]);
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this20.$store.dispatch('snackbar/show', 'Error al obtener instaladores: ' + _this20.$store.getters['api/getMessage']);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCommerceSellers: function getCommerceSellers() {
      var _this21 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this21.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/commerce/sellers/' + _this21.commerceID.value + '/'
        }).then(function (response) {
          _this21.sellersParams.items = response.data;
          var index = _this21.sellersParams.items.findIndex(function (item) {
            return parseInt(item.seller_id) === parseInt(_this21.sellerID.value);
          });
          if (index > -1) {
            _this21.sellerID.value = _this21.sellersParams.items[index].seller_id;
            _this21.sellersParams.value = _this21.sellersParams.items[index];
          } else {
            _this21.sellerID.value = _this21.sellersParams.items[0].seller_id;
            _this21.sellersParams.value = _this21.sellersParams.items[0];
          }
          if (!_this21.fields[5]) {
            _this21.normalizeAndAssign([_this21.sellersParams]);
          }

          // console.log(response)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          var message = _this21.$store.getters['api/getMessage'];
          _this21.$awn.alert('Error al obtener vendedores: ' + message);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangeAvatar: function onChangeAvatar(item) {
      // this.onChange(item.value, null, item, true)
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onUploadError: function onUploadError(type, requiredValue) {
      var errors = {
        'format': 'ERROR: La imagen debe tener un formato: ' + requiredValue,
        'max-file-size': 'ERROR: La imagen no debe superar los ' + requiredValue / 1000 + 'kB',
        'width': 'ERROR: La imagen debe tener un ancho de ' + requiredValue + 'px',
        'height': 'ERROR: La imagen debe tener un alto de ' + requiredValue + 'px'
      };
      this.$awn.alert(errors[type]);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onEdit: function onEdit() {
      this.$router.push({
        name: 'booking-edit',
        params: {
          booking_id: this.saleID.value
        }
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addRates: function addRates() {
      var fields = [{
        assign_to: 'fields',
        type: 'text-field',
        columns: 'xs4',
        label: 'Precio instalación (1)',
        disabled: true,
        editable: true,
        static_field: true,
        appendText: '€',
        value: ''
      }, {
        assign_to: 'fields',
        type: 'text-field',
        columns: 'xs4',
        label: 'Precio instalación (2)',
        disabled: true,
        editable: true,
        static_field: true,
        appendText: '€',
        value: ''
      }, {
        assign_to: 'fields',
        type: 'text-field',
        columns: 'xs4',
        label: 'Precio instalación (3)',
        disabled: true,
        editable: true,
        static_field: true,
        appendText: '€',
        value: ''
      }];
      this.normalizeAndAssign(fields);
      this.setRatesValues();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setRatesValues: function setRatesValues() {
      if (this.fields[0].value) {
        this.fields[1].value = this.fields[0].value[this.fields[0].item_text_2];
        this.fields[2].value = this.fields[0].value[this.fields[0].item_text_3];
        this.fields[3].value = this.fields[0].value[this.fields[0].item_text_4];
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onClickButton: function onClickButton(item, isValid) {
      var _this22 = this;

      // console.log('NEW', item)
      if (item.newWindowContent) {
        this.newWindowContent = item.newWindowContent;
      }
      if (item.ref === 'add-phone') {
        this.$refs.phone_aggregator.openDialog();
      } else if (item.ref === 'add-equipment') {
        this.$refs.equipment_aggregator.openDialog();
      } else if (item.ref === 'add-observation') {
        this.$refs.observation_aggregator.openAggregator('1', 'Observaciones - Reserva', '', 'first-observation', true, true);
      } else if (item.ref === 'signature-doc-1') {
        this.generateDoc('signature', 1);
      } else if (item.ref === 'upload-doc-1') {
        this.generateDoc('upload', 1);
      } else if (item.ref === 'signature-doc-2') {
        this.generateDoc('signature', 2);
      } else if (item.ref === 'upload-doc-2') {
        this.generateDoc('upload', 2);
      } else if (item.ref === 'signature-doc-3') {
        this.generateDoc('signature', 3);
      } else if (item.ref === 'upload-doc-3') {
        this.generateDoc('upload', 3);
      } else if (item.ref === 'next-step') {
        this.$refs.stepper.onNext();
      } else if (item.ref === 'invoice-was-updated') {
        this.uploadInvoice();
      } else if (item.ref === 'finish-serials') {
        this.hasSerials = true;
        this.noAssignation = false;
        this.addingSerials = false;
        this.addingSignature = false;
        this.generateDocument(3, true);
        setTimeout(function () {
          location.reload();
        }, 500);
      } else if (item.ref === 'finish-assign-installer') {
        location.reload();
      } else if (item.ref === 'finish-booking') {
        this.generateDocument(4, false);
        // if (this.noAssignation) {
        //   location.reload()
        // }
        this.installationStateForm[0].value = this.installationStateCausesForm[0].items[0];
        this.updateItem(this.installationStateForm[0], '6');
        this.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'update-sale-status/' + this.bookingID.value + '/6/'
        }).then(function (response) {
          if (_this22.isCommerce()) {
            // this.sendEmail('email-doc-4')
          }
          _this22.installationStateForm[0].value = _this22.installationStateForm[0].items[0];
          _this22.onFinish();
        });
      } else if (item.ref === 'search-bookings') {
        setTimeout(function () {
          _this22.bookingWasSearch = true;
          _this22.getAvailableBookings().then(function (response) {
            if (response.data.items && response.data.items.length > 0) {
              _this22.$refs.calendar.renderShedules(response.data);
              _this22.calendar = true;
              return true;
            }

            _this22.setSteps();
          }).catch(function (error) {
            console.log(error);
          });
        }, 100);
      } else if (item.ref === 'email-doc-1') {
        this.sendEmailDoc1 = true;
        if (!this.customer[3].value) {
          this.dialogEmail = true;
        } else {
          this.setSteps();
          this.sendEmail('email-doc-1');
        }
      } else if (item.ref === 'email-doc-2') {
        this.sendEmailDoc2 = true;
        if (!this.customer[3].value) {
          this.dialogEmail = true;
        } else {
          this.setSteps();
          this.sendEmail('email-doc-2');
        }
      } else if (item.ref === 'email-doc-3') {
        this.sendEmailDoc3 = true;
        if (!this.customer[3].value) {
          this.dialogEmail = true;
        } else {
          // this.setSteps()
          this.sendEmail('email-doc-3');
        }
      } else if (item.ref === 'email-doc-4') {
        if (this.isNew()) {
          item.disabled = true;
          item.loading = true;
          this.setSteps();
        }
        this.generateDocument(4, false);
        setTimeout(function () {
          _this22.sendEmail(item.ref, item.user);
        }, 1000);
        setTimeout(function () {
          item.disabled = true;
          item.loading = false;
        }, 2000);
      } else if (item.ref === 'email-doc-8') {
        setTimeout(function () {
          _this22.sendEmail(item.ref, item.user);
        }, 1000);
      } else if (item.ref === 'email-doc-9') {
        setTimeout(function () {
          _this22.sendEmail(item.ref, item.user);
        }, 1000);
      } else if (item.ref === 'serial-numbers') {
        this.$refs.equipment_aggregator.openMessage(0);
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangePhone: function onChangePhone() {
      this.setSteps();
      this.onChange(this.phone.value, null, this.phone, true);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    sendEmail: function sendEmail(type, user) {
      var _this23 = this;

      if (type === 'email-doc-8' || type === 'email-doc-9') {
        if (type === 'email-doc-8' && !this.installationInfo[4].value) {
          return this.$awn.alert('No hay un instalador asignado para poder enviar este correo.');
        }
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this23.$store.dispatch('api/authRequest', {
          method: 'post',
          url: 'email/' + type + '/',
          data: {
            sale_id: _this23.saleID.value
          }
        }).then(function (response) {
          _this23.$awn.success('Email enviado');
          if (type === 'email-doc-1') {
            _this23.checkboxDoc1 = true;
          } else if (type === 'email-doc-2') {
            _this23.checkboxDoc2 = true;
          } else if (type === 'email-doc-3') {
            _this23.checkboxDoc3 = true;
          } else if (type === 'email-doc-4') {
            _this23.checkboxDoc4 = true;
          }
          _this23.setSteps();
          _this23.getMailingRegisters();
          console.log(response);
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this23.$awn.alert('Error al enviar el email: ' + _this23.$store.getters['api/getMessage']);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getSale: function getSale() {
      var _this24 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var bookingID = _this24.$route.params.booking_id;
        _this24.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'sale/' + bookingID + '/'
        }).then(function (response) {
          // console.log(response.data)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this24.$awn.alert('Error al obtener datos de la reserva: ' + _this24.$store.getters['api/getMessage']);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange: function onChange(newVal, oldVal, item, isValid) {
      console.log('sss');
      if (item.update) {
        if (this.display && isValid) {
          item.value = newVal;
          if (newVal && item.type === 'select') {
            if (item.ref === 'sellerID') {
              this.updateItem(this.sellerID, newVal[item.item_value]);
            } else if (item.assign_to === 'newInstallation') {
              this.$refs.observation_aggregator.openAggregator('1', 'Solicitar nueva instalación', newVal.item_value, 'get-new-installation', false);
              this.$refs.observation_aggregator.addObservation();
            } else if (item.assign_to === 'requestImages') {
              this.$refs.observation_aggregator.openAggregator('1', 'Hacer fotografías', newVal.item_value, 'take-pictures', false);
              this.$refs.observation_aggregator.addObservation();
            } else if (item.ref === 'installerID') {
              // console.log(newVal[item.item_text_11])
              this.updateItem(this.installerID, newVal[item.item_text_11]);
            } else if (item.ref === 'commerceID') {
              this.commerceName.value = newVal[item.item_text_3];
              this.companyName.value = newVal[item.item_text_4];
              this.commerceEmail.value = newVal[item.item_text_10];
              this.businessGroupName.value = newVal[item.item_text_5];
              this.businessGroupType.value = newVal[item.item_text_12];
              this.commerceType.value = newVal[item.item_text_13];
              this.commerceID.value = newVal[item.item_text_14];
              this.getCommerceSellers();
            } else {
              this.updateItem(item, newVal[item.item_value]);
            }
          } else if ((item.type === 'text-field' || item.type === 'hidden') && !item.static_field) {
            this.updateItem(item, item.value);
          } else if (item.type === 'checkbox' && item.assign_to === 'invoice') {
            this.updateItem(item, item.value ? 1 : 0);
          } else if (item.type === 'date-picker' || item.type === 'time-picker') {
            if (item.ref === 'installationStartDate') {
              var installationStartDate = this.installationInfo[0].value + ' ' + this.installationInfo[2].value;
              installationStartDate = this.moment(installationStartDate).format('YYYY-MM-DD HH:mm:ss');
              this.updateItem(this.installationStartDate, installationStartDate);
              /*
              let duration = parseInt(this.bookingEquipments.value[0].duration || 1)
              let installationEndDate = this.installationInfo[1].value + ' ' + this.installationInfo[3].value
               installationEndDate = this.moment(installationStartDate).add(duration, 'H').toISOString()
              this.installationInfo[1].value = this.moment(installationEndDate).format('YYYY-MM-DD')
              this.installationInfo[3].value = this.moment(installationEndDate).format('HH:mm')
              this.updateItem(this.installationEndDate, this.moment(installationEndDate).format('YYYY-MM-DD HH:mm:ss'))
              */
            } else if (item.ref === 'installationEndDate') {
              var installationEndDate = this.installationInfo[1].value + ' ' + this.installationInfo[3].value;
              installationEndDate = this.moment(installationEndDate).format('YYYY-MM-DD HH:mm:ss');
              this.updateItem(this.installationEndDate, installationEndDate);
            } else {
              var date = this.moment(item.value + ' 00:00:00').format('YYYY-MM-DD HH:mm:ss');
              item.assign_to = Array.isArray(item.assign_to) ? item.assign_to[1] : item.assign_to;
              this.updateItem(item, date);
            }
          } else if (item.type === 'image') {
            this.updateItem(item, item.value);
          }
        }
      }
      if (this.display && newVal && item.ref === 'installation_state') {
        if (this.installationStateCausesForm && parseInt(newVal.item_value) === 8) {
          this.showStateCauses = true;
        } else {
          this.showStateCauses = false;
          this.installationStateCausesForm[0].value = '';
          this.updateItem(this.installationStateCausesForm[0], this.installationStateCausesForm[0].value);
        }
        if (parseInt(newVal.item_value) === 11) {
          this.$refs.observation_aggregator.openAggregator('2', 'Terminada con incidencias');
        }
      }
      if (this.display && newVal && item.ref === 'installation_state_causes') {
        if (parseInt(newVal.item_value) === 5) {
          this.$refs.observation_aggregator.openAggregator('2', 'Instalación anulada', 'Motivo: ');
        }
      }
      if (item.type === 'radio-group' && this.isNew()) {
        if (item.ref === 'requestImagesOnNew') {
          if (!this.requestImagesWasAdded && this.requestImagesOnNew.value === 'yes') {
            this.requestImagesOnNeww = true;
            this.requestImagesWasAdded = true;
            this.$refs.observation_aggregator.openAggregator('1', 'Hacer fotografías', 'Hacer fotografías a la instalación. En caso de no ser posible, agregar observación informando sobre el motivo.', 'take-pictures', false);
            this.$refs.observation_aggregator.addObservation();
          }
        }
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    validateEquipment: function validateEquipment() {
      var equipment = this.$refs.equipment.$refs.form_creator.validateForm();
      var commerce = this.$refs.commerce.$refs.form_creator.validateForm();
      var fields = this.$refs.fields.$refs.form_creator.validateForm();
      if (equipment && commerce && fields) {
        this.onChange('1', null, this.status, true);
        this.$router.push({
          name: 'equipments'
        });
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    returnToEquipments: function returnToEquipments() {
      this.$router.push({
        name: 'equipments'
      });
      this.deleteEquipment(this.equipmentID);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeModels: function normalizeModels(item) {
      var _this25 = this;

      var currentBrandID = item.value[item.item_value];

      if (item.brands_relations[currentBrandID]) {
        if (!this.models) {
          this.models = this.equipment[2].items;
        }
        var brandModels = item.brands_relations[currentBrandID];

        var items = [];
        this.models.forEach(function (obj) {
          var modelID = obj[_this25.equipment[2].item_value];

          if (brandModels.indexOf(modelID) > -1) {
            items.push(obj);
          }
        });
        this.equipment[2].items = items;
        this.equipment[2].value = items ? items[0] : [];
      } else {
        this.equipment[2].items = [];
        this.equipment[2].value = '';
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddItem: function onAddItem(newVal, oldVal, item, isValid) {
      var _this26 = this;

      var equipmentID = this.equipmentID;
      this.$store.dispatch('api/authRequest', {
        method: 'post',
        url: 'equipment/' + equipmentID + '/',
        data: {
          controller: item.item_controller,
          value: newVal[item.item_text]
        }
      }).then(function (response) {
        newVal[item.item_value] = response.data;
        item.items.unshift(newVal);
        _this26.onChange(item.items[0], oldVal, item, isValid);
      }).catch(function (error) {
        console.log(error);
        _this26.$awn.alert('Al agregar nuevo elemento');
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    updateItem: function updateItem(item, value) {
      var url = '';
      // console.log(item.assign_to)
      switch (item.assign_to) {
        case 'bookingEquipments':
          url = 'sale/' + this.bookingID.value + '/';
          this.update(item, value, url);
          break;
        case 'customer':
        case 'routeDelivery':
        case 'routeExtrasDelivery':
        case 'postalCodeDelivery':
        case 'localityDelivery':
        case 'provinceDelivery':
        case 'placeIdDelivery':
        case 'route':
        case 'routeExtras':
        case 'postalCode':
        case 'locality':
        case 'province':
        case 'placeID':
        case 'phone':
          url = 'customer/' + this.customerID.value + '/';
          this.update(item, value, url);
          break;
        case 'invoice':
        case 'fields':
        case 'sellerID':
        case 'saleDeliveryDate':
        case 'saleSoldDate':
        case 'statusID':
          url = 'sale/' + this.saleID.value + '/';
          this.update(item, value, url);
          break;
        case 'installationStateForm':
        case 'installationStateCausesForm':
        case 'installerID':
        case 'installationStartDate':
        case 'installationEndDate':
          url = 'bookings/' + this.bookingID.value + '/';
          this.update(item, value, url);
          break;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    update: function update(item, value, url) {
      var _this27 = this;

      this.$store.dispatch('api/authRequest', {
        method: 'put',
        url: url,
        data: {
          table: item.table,
          column: item.column,
          data_type: item.data_type,
          value: value
        }
      }).then(function (response) {
        if (!_this27.isNew()) {
          clearTimeout(_this27.clickTimer);
          _this27.clickTimer = setTimeout(function () {
            _this27.addEventToGoogleCalendar();
          }, 2000);
        }
        if (!_this27.isNew() && !_this27.noAssignation) {
          clearTimeout(_this27.clickTimer2);
          _this27.clickTimer2 = setTimeout(function () {
            _this27.$awn.success('¡Hecho!');
          }, 1000);
        }
      }).catch(function (error) {
        console.log(error);
        _this27.$awn.alert('Al actualizar');
      });
    }
  },
  watch: {
    'addressCheckbox.value': {
      handler: function handler(newVal, oldVal) {
        if (this.isNew()) {
          if (newVal === 'yes') {
            this.routeDelivery.value = this.route.value;
            this.routeExtrasDelivery.value = this.routeExtras.value;
            this.postalCodeDelivery.value = this.postalCode.value;
            this.localityDelivery.value = this.locality.value;
            this.provinceDelivery.value = this.province.value;
            this.placeIdDelivery.value = this.placeID.value;
          } else {
            this.routeDelivery.value = '';
            this.routeExtrasDelivery.value = '';
            this.postalCodeDelivery.value = '';
            this.localityDelivery.value = '';
            this.provinceDelivery.value = '';
            this.placeIdDelivery.value = '';
          }
        }
      },
      deep: true
    },
    display: {
      handler: function handler(newVal, oldVal) {
        // console.log('------$------', this.commerceID)
        if (this.isCommerce()) {
          this.$refs.stepper.nextStep();
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(772);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("1bf5be7c", content, true, {});

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".application{background:rgba(63,81,181,.0705882)!important}a{text-decoration:none}.image{cursor:pointer}.flex{padding:5px 12px}.container.grid-list-xl :not(:only-child) .layout:first-child{margin-top:0}.jst-card{margin-bottom:20px}.installer{margin-top:-33px!important;font-weight:100;display:-webkit-box;width:100%}.input-file{display:none}.image-info{width:72%}.add-address{display:hidden}.address-autocomplete{max-width:435px;margin:0 auto;padding:32px 0}.list-item{display:inline-block;margin-right:10px}.list-enter-active,.list-leave-active{-webkit-transition:all 1s;transition:all 1s}.list-enter,.list-leave-to{opacity:0;-webkit-transform:translateY(30px);transform:translateY(30px)}html{overflow-y:visible!important}.profile-options{float:right;bottom:62px}.disable-area{opacity:.5;pointer-events:none;cursor:default;text-decoration:none;-webkit-transition:opacity 1s ease-in-out;transition:opacity 1s ease-in-out}.commerce{font-weight:100}.carousel-actions{padding:18px}.carousel{height:250px;width:250px;margin:0 auto;-webkit-box-shadow:none;box-shadow:none}.center-btn-booking{margin:auto;margin-top:16px;margin-bottom:16px;display:block}.document-advise{margin-top:8px;margin-bottom:8px;display:block}.vrg-title{color:rgba(0,0,0,.54);display:block!important}.alert>div{-ms-flex-item-align:center;align-self:center;-webkit-box-flex:1;-ms-flex:1 1;flex:1 1;text-align:left;font-size:16px}.alert{margin-bottom:18px}.list__tile__sub-title{max-height:40px!important}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/pages/booking.vue"],"names":[],"mappings":"AACA,aACE,6CAAoD,CACrD,AACD,EACE,oBAAsB,CACvB,AACD,OACE,cAAgB,CACjB,AACD,MACE,gBAAkB,CACnB,AACD,8DACE,YAAgB,CACjB,AACD,UACE,kBAAoB,CACrB,AACD,WACE,2BAA6B,AAC7B,gBAAiB,AACjB,oBAAqB,AACrB,UAAY,CACb,AAWD,YACE,YAAc,CACf,AACD,YACE,SAAW,CACZ,AACD,aACE,cAAgB,CACjB,AACD,sBACE,gBAAiB,AACjB,cAAe,AACf,cAAuB,CACxB,AACD,WACE,qBAAsB,AACtB,iBAAmB,CACpB,AACD,sCACE,0BAA2B,AAC3B,iBAAmB,CACpB,AACD,2BACE,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,KACE,4BAA+B,CAChC,AACD,iBACE,YAAa,AACb,WAAa,CACd,AACD,cACE,WAAa,AACb,oBAAqB,AACrB,eAAgB,AAChB,qBAAsB,AACtB,0CAA2C,AAC3C,iCAAmC,CACpC,AACD,UACE,eAAiB,CAClB,AACD,kBACE,YAAc,CACf,AACD,UACE,aAAc,AACd,YAAa,AACb,cAAe,AACf,wBAAyB,AACjB,eAAiB,CAC1B,AACD,oBACE,YAAa,AACb,gBAAiB,AACjB,mBAAoB,AACpB,aAAe,CAChB,AACD,iBACE,eAAgB,AAChB,kBAAmB,AACnB,aAAe,CAChB,AACD,WACE,sBAA2B,AAC3B,uBAA0B,CAC3B,AACD,WACE,2BAA4B,AACxB,kBAAmB,AACvB,mBAAoB,AAChB,aAAc,AACV,SAAU,AAClB,gBAAiB,AACjB,cAAgB,CACjB,AACD,OACE,kBAAoB,CACrB,AACD,uBACE,yBAA4B,CAC7B","file":"booking.vue","sourcesContent":["\n.application {\n  background: rgba(63, 81, 181, 0.0705882) !important;\n}\na {\n  text-decoration: none;\n}\n.image {\n  cursor: pointer;\n}\n.flex {\n  padding: 5px 12px;\n}\n.container.grid-list-xl *:not(:only-child) .layout:first-child {\n  margin-top: 0px;\n}\n.jst-card {\n  margin-bottom: 20px;\n}\n.installer {\n  margin-top: -33px !important;\n  font-weight: 100;\n  display: -webkit-box;\n  width: 100%;\n}\n.carousel-actions {\n  padding: 18px;\n}\n.carousel {\n  height: 250px;\n  width: 250px;\n  margin: 0 auto;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.input-file {\n  display: none;\n}\n.image-info {\n  width: 72%;\n}\n.add-address {\n  display: hidden;\n}\n.address-autocomplete {\n  max-width: 435px;\n  margin: 0 auto;\n  padding: 32px 0 32px 0;\n}\n.list-item {\n  display: inline-block;\n  margin-right: 10px;\n}\n.list-enter-active, .list-leave-active {\n  -webkit-transition: all 1s;\n  transition: all 1s;\n}\n.list-enter, .list-leave-to {\n  opacity: 0;\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n}\nhtml {\n  overflow-y: visible !important;\n}\n.profile-options {\n  float: right;\n  bottom: 62px;\n}\n.disable-area {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: default;\n  text-decoration: none;\n  -webkit-transition: opacity 1s ease-in-out;\n  transition: opacity 1s ease-in-out;\n}\n.commerce {\n  font-weight: 100;\n}\n.carousel-actions {\n  padding: 18px;\n}\n.carousel {\n  height: 250px;\n  width: 250px;\n  margin: 0 auto;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.center-btn-booking {\n  margin: auto;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  display: block;\n}\n.document-advise {\n  margin-top: 8px;\n  margin-bottom: 8px;\n  display: block;\n}\n.vrg-title {\n  color: rgba(0, 0, 0, 0.54);\n  display: block !important;\n}\n.alert > div {\n  -ms-flex-item-align: center;\n      align-self: center;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1;\n          flex: 1 1;\n  text-align: left;\n  font-size: 16px;\n}\n.alert {\n  margin-bottom: 18px;\n}\n.list__tile__sub-title {\n  max-height: 40px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-container',{directives:[{name:"show",rawName:"v-show",value:((!_vm.isNew() && !_vm.noAssignation) && _vm.display),expression:"(!isNew() && !noAssignation) && display"}],attrs:{"fluid":"","grid-list-xl":"","text-xs-center":""}},[_c('h1',{staticClass:"page-title display-1"},[_vm._v(_vm._s(_vm.getTitle()))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":"","lg5":"","xl5":""}},[(!_vm.isNew())?_c('vuetify-avatar-card',{attrs:{"color":'primary',"avatar":_vm.avatar || {},"avatars":_vm.avatars || []},on:{"on-upload-error":function($event){false && _vm.onUploadError},"on-change-avatar":function($event){false && _vm.onChangeAvatar}}},[_c('v-layout',{attrs:{"slot":"card-title","column":"","align-center":"","justify-center":""},slot:"card-title"},[_c('v-layout',{staticClass:"column avatar-info",attrs:{"align-center":"","justify-center":""}},[_c('div',{staticClass:"headline"},[_vm._v("\n                  "+_vm._s(_vm.commerceName.value)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"headline commerce"},[_vm._v("\n                  "+_vm._s(_vm.commerceType.value + ' ' + _vm.companyName.value)+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"section primary--text"},[_vm._v("\n                  "+_vm._s(_vm.businessGroupType.value + ' ' + _vm.businessGroupName.value)+"\n                ")])])],1),_vm._v(" "),_c('visible-for',{attrs:{"slot":"card-text","superadmin":"","administrator":""},slot:"card-text"},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){_vm.cloneDialog = true}},slot:"activator"},[_c('v-icon',[_vm._v("pages")])],1),_vm._v(" "),_c('span',[_vm._v("Duplicar reserva")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.isEdit() && (_vm.isSuperadmin() || _vm.isAdmin()))?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){_vm.onDelete()}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Eliminar reserva")])],1)],1)])],1):_vm._e(),_vm._v(" "),((_vm.isSuperadmin() || _vm.isAdmin()))?_c('vuetify-editable-form-card',{ref:"commerce",attrs:{"color":'primary',"toolbar-title":'Asignar a',"items":_vm.assignTo},on:{"on-click-button":_vm.onClickButton,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem}}):_vm._e(),_vm._v(" "),_c('vuetify-equipment-aggregator',{ref:"equipment_aggregator",attrs:{"color":'primary',"toolbar-title":'Equipo',"list-title":'Agregar equipo',"add-button-hover-text":'Pulsa para agregar un nuevo equipo',"dialog-max-width":450,"dialog-toolbar-title":'Agregar equipo a instalar',"text-field-label":'Título',"text-field-rules":_vm.equipment.rules,"select-label":'Tipo',"delete-button":!_vm.isInstaller() && !_vm.isManager() && !_vm.isResponsible(),"can-edit":!_vm.isManager() && !_vm.isResponsible(),"navigation-menu":false,"dialog-confirm-headline":'Eliminar equipo',"dialog-confirm-text":'¿Seguro que quieres eliminar este equipo?',"cancel-button":'Cancelar',"confirm-button":'Confirmar',"delete-icon-hover-text":'Pulsa para eliminar',"rate-id":_vm.rateID.value || '0',"equipments":_vm.bookingEquipments.value || [],"value":_vm.bookingEquipments.value,"equipments-list":_vm.equipments},on:{"update:value":function($event){_vm.$set(_vm.bookingEquipments, "value", $event)},"on-add-equipment":_vm.onAddEquipment,"on-delete-equipment":_vm.deleteEquipment}}),_vm._v(" "),_c('vuetify-phone-aggregator',{ref:"phone_aggregator",attrs:{"color":'primary',"toolbar-title":'Teléfonos de contacto',"list-title":'Agregar teléfono',"add-button-hover-text":'Pulsa para agregar un nuevo teléfono',"dialog-max-width":450,"dialog-toolbar-title":'Agregar teléfono cliente',"text-field-label":'Teléfono',"text-field-rules":_vm.phone.rules,"select-label":'Tipo',"dialog-confirm-headline":'Eliminar teléfono',"dialog-confirm-text":'¿Seguro que quieres eliminar este teléfono?',"delete-button":!_vm.isInstaller() && !_vm.isManager() && !_vm.isResponsible(),"navigation-menu":!_vm.isInstaller() && !_vm.isManager() && !_vm.isResponsible(),"cancel-button":'Cancelar',"confirm-button":'Confirmar',"delete-icon-hover-text":'Pulsa para eliminar',"phone-types":_vm.phone.types,"phones":_vm.phone.value || [],"value":_vm.phone.value},on:{"update:value":function($event){_vm.$set(_vm.phone, "value", $event)},"on-add-phone":_vm.onChangePhone,"on-delete-phone":_vm.onChangePhone}}),_vm._v(" "),_c('vuetify-signature-aggregator',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"signature",attrs:{"color":'primary',"toolbar-title":'Firma comercio',"list-title":'Agregar firma',"add-button-hover-text":'Pulsa para agregar una nueva firma',"dialog-max-width":670,"dialog-toolbar-title":_vm.signature.toolbar_title || '',"dialog-confirm-headline":'Eliminar firma',"dialog-confirm-text":'¿Seguro que quieres eliminar esta firma?',"cancel-button":'Cancelar',"confirm-button":'Confirmar',"upload-icon-hover-text":'Subir imagen de 400 x 200 píxeles en formato PNG',"clear-icon-hover-text":'Limpiar firma',"save-icon-hover-text":'Guardar firma',"delete-icon-hover-text":'Eliminar',"options":_vm.signature || {},"persistent":false,"value":_vm.signature.value,"disable-delete-button":true,"disable-clear-button":true,"disable-cancel-button":true,"disable-upload-button":true,"disable-save-button":true},on:{"update:value":function($event){_vm.$set(_vm.signature, "value", $event)},"on-upload-error":_vm.onUploadError,"on-add-signature":function($event){_vm.onChangeSignature(_vm.signature)}}}),_vm._v(" "),_c('vuetify-observation-aggregator',{ref:"observation_aggregator",attrs:{"color":'primary',"toolbar-title":'Notas',"list-title":'Agregar nota',"add-button-hover-text":'Pulsa para agregar una nueva nota',"dialog-max-width":450,"dialog-toolbar-title":'Agregar ',"delete-button":(_vm.isSuperadmin() || _vm.isAdmin()),"text-field-label":'Título',"text-field-rules":_vm.observation.rules,"select-label":'Tipo',"dialog-confirm-headline":'Eliminar nota',"dialog-confirm-text":'¿Seguro que quieres eliminar esta nota?',"cancel-button":'Cancelar',"confirm-button":'Confirmar',"delete-icon-hover-text":'Pulsa para eliminar',"observations":_vm.observation.items || [],"value":_vm.observation.value},on:{"update:value":function($event){_vm.$set(_vm.observation, "value", $event)},"on-add-observation":_vm.onAddObservation,"on-delete-observation":_vm.deleteObservation}}),_vm._v(" "),_c('vuetify-document-aggregator',{ref:"document_aggregator",attrs:{"color":'primary',"toolbar-title":'Documentos',"delete-button":(_vm.isSuperadmin() || _vm.isAdmin()),"list-title":'Agregar documento',"add-button-hover-text":'Pulsa para agregar un nuevo documento',"dialog-max-width":450,"dialog-toolbar-title":_vm.documents.dialog_toolbar_title,"text-field-label":'Título',"text-field-rules":_vm.documents.rules,"select-label":'Tipo',"dialog-confirm-headline":'Eliminar documento',"dialog-confirm-text":'¿Seguro que quieres eliminar este documento?',"cancel-button":'Cancelar',"confirm-button":'Confirmar',"delete-icon-hover-text":'Pulsa para eliminar',"documents":_vm.documents.items || [],"value":_vm.documents.value},on:{"update:value":function($event){_vm.$set(_vm.documents, "value", $event)},"on-add-document":_vm.onAddDocument,"on-delete-document":_vm.deleteDocument}}),_vm._v(" "),_c('vuetify-editable-form-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isInstaller() && !_vm.isManager() && !_vm.isResponsible()),expression:"!isInstaller() && !isManager() && !isResponsible()"}],attrs:{"color":'primary',"toolbar-title":'Factura de compra',"items":_vm.invoice},on:{"on-click-button":_vm.onClickButton,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem}}),_vm._v(" "),_c('vuetify-editable-form-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInstaller()),expression:"isInstaller()"}],attrs:{"color":'primary',"toolbar-title":'Solicitar nueva instalación',"items":_vm.newInstallation},on:{"on-click-button":_vm.onClickButton,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem}}),_vm._v(" "),_c('vuetify-editable-form-card',{directives:[{name:"show",rawName:"v-show",value:((_vm.isSuperadmin() || _vm.isAdmin())),expression:"(isSuperadmin() || isAdmin())"}],attrs:{"color":'primary',"toolbar-title":'Solicitar',"items":_vm.requestImages},on:{"on-click-button":_vm.onClickButton,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem}}),_vm._v(" "),((_vm.isSuperadmin() || _vm.isAdmin()))?_c('v-card',{staticClass:"vuetify-aggregator-card",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Aviso de instalación")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.onClickButton({ ref: 'email-doc-8', user: 'installer' })}},slot:"activator"},[_vm._v("\n                "+_vm._s(_vm.adviceSentToInstaller ? 'Volver a enviar a instalador' : 'Enviar a instalador')+"\n              ")]),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.onClickButton({ ref: 'email-doc-4', user: 'commerce' })}},slot:"activator"},[_vm._v("\n                "+_vm._s(_vm.adviceSentToCommerce ? 'Volver a enviar a comerciante' : 'Enviar a comerciante')+"\n              ")]),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.onClickButton({ ref: 'email-doc-9', user: 'admin' })}},slot:"activator"},[_vm._v("\n                "+_vm._s(_vm.adviceSentToAdmin ? 'Volver a enviar a administrador' : 'Enviar a administrador')+"\n              ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.isCommerce())?_c('v-card',{staticClass:"vuetify-aggregator-card",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Felicitar al instalador")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.congratulations()}},slot:"activator"},[_vm._v("\n                Felicitar\n              ")])],1)],1):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"vuetify-aggregator-card",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Generar documentos")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.generateDocument(1, true);}},slot:"activator"},[_vm._v("\n                Conformidad cliente\n              ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.isInstaller())?_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.generateDocument(2, true);}},slot:"activator"},[_vm._v("\n                PARTE A – ANEXO VI – R.D. 115/2017\n              ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.generateDocument(3, true);}},slot:"activator"},[_vm._v("\n                PARTE B – ANEXO VI – R.D. 115/2017\n              ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.isCommerce())?_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.generateDocument(4, true);}},slot:"activator"},[_vm._v("\n                AVISO DE INSTALACIÓN\n              ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),((_vm.isSuperadmin() || _vm.isAdmin()))?_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.generateDocument(5, true);}},slot:"activator"},[_vm._v("\n                FICHERO REGISTRO\n              ")]):_vm._e()],1)],1),_vm._v(" "),(!_vm.isManager() && !_vm.isResponsible())?_c('v-card',{staticClass:"vuetify-aggregator-card",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Firmar documentos")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.generateDoc('signature', 1);}},slot:"activator"},[_vm._v("\n                Conformidad cliente\n              ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.generateDoc('signature', 2);}},slot:"activator"},[_vm._v("\n                PARTE A – ANEXO VI – R.D. 115/2017\n              ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.isCommerce())?_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.generateDoc('signature', 3);}},slot:"activator"},[_vm._v("\n                PARTE B – ANEXO VI – R.D. 115/2017\n              ")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(!_vm.isManager() && !_vm.isResponsible())?_c('v-card',{staticClass:"vuetify-aggregator-card",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Subir documentos")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.generateDoc('upload', 1);}},slot:"activator"},[_vm._v("\n                Conformidad cliente\n              ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.generateDoc('upload', 2);}},slot:"activator"},[_vm._v("\n                PARTE A – ANEXO VI – R.D. 115/2017\n              ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.isCommerce())?_c('v-btn',{attrs:{"slot":"activator","dark":"","outline":"","color":"primary"},on:{"click":function($event){_vm.generateDoc('upload', 3);}},slot:"activator"},[_vm._v("\n                PARTE B – ANEXO VI – R.D. 115/2017\n              ")]):_vm._e()],1)],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md7":"","lg7":"","xl7":""}},[_c('vuetify-editable-form-card',{ref:"commerce",attrs:{"color":'primary',"toolbar-title":'Estado de la instalación',"items":_vm.installationStateForm},on:{"on-click-button":_vm.onClickButton,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem}}),_vm._v(" "),_c('vuetify-editable-form-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStateCauses),expression:"showStateCauses"}],ref:"commerce",attrs:{"color":'primary',"toolbar-title":'Causas de la anulación',"items":_vm.installationStateCausesForm},on:{"on-click-button":_vm.onClickButton,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem}}),_vm._v(" "),_c('vuetify-editable-form-card',{ref:"fields",attrs:{"color":'primary',"toolbar-title":'Detalles de la instalación',"items":_vm.installationInfo},on:{"on-click-button":_vm.onClickButton,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem}}),_vm._v(" "),_c('vuetify-editable-form-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isInstaller()),expression:"!isInstaller()"}],ref:"fields",attrs:{"color":'primary',"toolbar-title":'Detalles de la venta',"items":_vm.fields},on:{"on-click-button":_vm.onClickButton,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem}}),_vm._v(" "),_c('vuetify-editable-form-card',{ref:"fields",attrs:{"color":'primary',"toolbar-title":'Datos del cliente',"items":_vm.customer},on:{"on-click-button":_vm.onClickButton,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem}}),_vm._v(" "),_c('vuetify-editable-address-card',{ref:"editable_address_card_1",attrs:{"id":'address',"color":'primary',"navigation-menu":!_vm.isManager() && !_vm.isResponsible(),"toolbar-title":'Dirección del cliente',"dialog-toolbar-title":'Agregar dirección de cliente',"placeholder":'Escribe la dirección',"list-title":'Agregar dirección del cliente',"route":_vm.route,"route-extras":_vm.routeExtras,"postalCode":_vm.postalCode,"locality":_vm.locality,"province":_vm.province,"place-id":_vm.placeID},on:{"on-change":_vm.onChange}}),_vm._v(" "),_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('vuetify-editable-address-card',{ref:"editable_address_card_2",attrs:{"id":'address2',"color":'primary',"navigation-menu":!_vm.isManager() && !_vm.isResponsible(),"toolbar-title":'Dirección de instalación',"dialog-toolbar-title":'Agregar dirección',"placeholder":'Escribe tu dirección',"list-title":'Agregar dirección',"route":_vm.routeDelivery,"route-extras":_vm.routeExtrasDelivery,"postalCode":_vm.postalCodeDelivery,"locality":_vm.localityDelivery,"province":_vm.provinceDelivery,"place-id":_vm.placeIdDelivery},on:{"on-change":_vm.onChange}})],1)],1),_vm._v(" "),(false)?_c('v-btn',{attrs:{"dark":"","fab":"","fixed":"","bottom":"","left":"","color":"primary"},on:{"click":function($event){_vm.returnToEquipments()}}},[_c('v-icon',[_vm._v("arrow_back")])],1):_vm._e(),_vm._v(" "),(false)?_c('v-btn',{attrs:{"dark":"","fab":"","fixed":"","bottom":"","right":"","color":"teal"},on:{"click":function($event){_vm.validateEquipment()}}},[_c('v-icon',[_vm._v("check")])],1):_vm._e()],1),_vm._v(" "),(_vm.isNew() && this.bookingEquipments && this.bookingEquipments.value && this.bookingEquipments.value.length)?_c('v-btn',{attrs:{"dark":"","color":"primary"},on:{"click":function($event){_vm.documentCreationdialog = !_vm.documentCreationdialog}}},[_vm._v("\n              Finalizar\n            ")]):_vm._e()],1)],1),_vm._v(" "),(_vm.isNew())?_c('v-dialog',{attrs:{"persistent":"","max-width":"550"},model:{value:(_vm.dialogEmail),callback:function ($$v) {_vm.dialogEmail=$$v},expression:"dialogEmail"}},[_c('v-card',[_c('vuetify-editable-form-card',{ref:"fields",attrs:{"color":'primary',"toolbar-title":'Agregar email de cliente',"items":_vm.customer},on:{"on-click-button":_vm.onClickButton,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":function($event){_vm.dialogEmail = false}}},[_vm._v("\n              Cancelar\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":function($event){_vm.validateEmail()}}},[_vm._v("\n              Guardar\n            ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isNew())?_c('v-dialog',{attrs:{"slot":"extras","persistent":"","max-width":"800"},slot:"extras",model:{value:(_vm.calendar),callback:function ($$v) {_vm.calendar=$$v},expression:"calendar"}},[_c('v-card',{attrs:{"height":"600"}},[_c('calendar',{ref:"calendar",on:{"on-assign-booking":_vm.onAssignBooking}})],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"slot":"extras","persistent":"","max-width":"450"},slot:"extras",model:{value:(_vm.cloneDialog),callback:function ($$v) {_vm.cloneDialog=$$v},expression:"cloneDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("¿Duplicar reserva?")]),_vm._v(" "),_c('v-card-text',[_c('v-checkbox',{attrs:{"color":"indigo","label":"Incluir detalles de la instalación"},model:{value:(_vm.cloneBooking),callback:function ($$v) {_vm.cloneBooking=$$v},expression:"cloneBooking"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"indigo","label":"Incluir documentos"},model:{value:(_vm.cloneDocuments),callback:function ($$v) {_vm.cloneDocuments=$$v},expression:"cloneDocuments"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"color":"indigo","label":"Incluir observaciones"},model:{value:(_vm.cloneObservations),callback:function ($$v) {_vm.cloneObservations=$$v},expression:"cloneObservations"}}),_vm._v("\n        Se va a crear un duplicado de esta reserva: ¿desea continuar?")],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":function($event){_vm.cloneDialog = false}}},[_vm._v("\n            No\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":function($event){_vm.duplicateBooking()}}},[_vm._v("\n            Sí\n          ")])],1)],1)],1),_vm._v(" "),_c('div',[_c('vuetify-stepper-dialog',{ref:"stepper",attrs:{"items":_vm.steppers || [],"dialog":_vm.canCreateReservation && (_vm.isNew() || _vm.noAssignation) && _vm.display,"max-width":600},on:{"on-close":_vm.onCloseStepper,"on-last-step":_vm.onLastStep,"on-next-step":_vm.onNextStep,"on-click-button":_vm.onClickButton,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]));


// WEBPACK FOOTER //
// static/js/0.bf2551accd7610479e0b.js